(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("whatwg-fetch"), require("react"), require("react-dom"), require("d3-color"), require("lodash"), require("rdf-ext"), require("n3"), require("webcola"), require("file-saverjs"));
	else if(typeof define === 'function' && define.amd)
		define(["whatwg-fetch", "react", "react-dom", "d3-color", "lodash", "rdf-ext", "n3", "webcola", "file-saverjs"], factory);
	else if(typeof exports === 'object')
		exports["Ontodia"] = factory(require("whatwg-fetch"), require("react"), require("react-dom"), require("d3-color"), require("lodash"), require("rdf-ext"), require("n3"), require("webcola"), require("file-saverjs"));
	else
		root["Ontodia"] = factory(root["whatwg-fetch"], root["react"], root["react-dom"], root["d3-color"], root["lodash"], root["rdf-ext"], root["n3"], root["webcola"], root["file-saverjs"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__40__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__59__, __WEBPACK_EXTERNAL_MODULE__60__, __WEBPACK_EXTERNAL_MODULE__67__, __WEBPACK_EXTERNAL_MODULE__97__, __WEBPACK_EXTERNAL_MODULE__104__, __WEBPACK_EXTERNAL_MODULE__110__, __WEBPACK_EXTERNAL_MODULE__138__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InternalApi = void 0;
const tslib_1 = __webpack_require__(1);
__webpack_require__(2);
__webpack_require__(40);
__webpack_require__(41);
__webpack_require__(42);
tslib_1.__exportStar(__webpack_require__(43), exports);
tslib_1.__exportStar(__webpack_require__(44), exports);
tslib_1.__exportStar(__webpack_require__(48), exports);
tslib_1.__exportStar(__webpack_require__(91), exports);
tslib_1.__exportStar(__webpack_require__(92), exports);
tslib_1.__exportStar(__webpack_require__(93), exports);
tslib_1.__exportStar(__webpack_require__(94), exports);
tslib_1.__exportStar(__webpack_require__(95), exports);
tslib_1.__exportStar(__webpack_require__(100), exports);
tslib_1.__exportStar(__webpack_require__(105), exports);
tslib_1.__exportStar(__webpack_require__(102), exports);
tslib_1.__exportStar(__webpack_require__(107), exports);
tslib_1.__exportStar(__webpack_require__(111), exports);
var schema_1 = __webpack_require__(54);
Object.defineProperty(exports, "DIAGRAM_CONTEXT_URL_V1", ({ enumerable: true, get: function () { return schema_1.DIAGRAM_CONTEXT_URL_V1; } }));
var commands_1 = __webpack_require__(64);
Object.defineProperty(exports, "RestoreGeometry", ({ enumerable: true, get: function () { return commands_1.RestoreGeometry; } }));
var elementLayer_1 = __webpack_require__(58);
Object.defineProperty(exports, "ElementLayer", ({ enumerable: true, get: function () { return elementLayer_1.ElementLayer; } }));
var elements_1 = __webpack_require__(53);
Object.defineProperty(exports, "Element", ({ enumerable: true, get: function () { return elements_1.Element; } }));
Object.defineProperty(exports, "Link", ({ enumerable: true, get: function () { return elements_1.Link; } }));
Object.defineProperty(exports, "LinkVertex", ({ enumerable: true, get: function () { return elements_1.LinkVertex; } }));
Object.defineProperty(exports, "LinkDirection", ({ enumerable: true, get: function () { return elements_1.LinkDirection; } }));
var embeddedLayer_1 = __webpack_require__(51);
Object.defineProperty(exports, "EmbeddedLayer", ({ enumerable: true, get: function () { return embeddedLayer_1.EmbeddedLayer; } }));
tslib_1.__exportStar(__webpack_require__(57), exports);
tslib_1.__exportStar(__webpack_require__(65), exports);
var model_1 = __webpack_require__(112);
Object.defineProperty(exports, "DiagramModel", ({ enumerable: true, get: function () { return model_1.DiagramModel; } }));
tslib_1.__exportStar(__webpack_require__(66), exports);
var paperArea_1 = __webpack_require__(83);
Object.defineProperty(exports, "getContentFittingBox", ({ enumerable: true, get: function () { return paperArea_1.getContentFittingBox; } }));
tslib_1.__exportStar(__webpack_require__(114), exports);
var authoredEntity_1 = __webpack_require__(87);
Object.defineProperty(exports, "AuthoredEntity", ({ enumerable: true, get: function () { return authoredEntity_1.AuthoredEntity; } }));
tslib_1.__exportStar(__webpack_require__(89), exports);
var editorController_1 = __webpack_require__(116);
Object.defineProperty(exports, "EditorController", ({ enumerable: true, get: function () { return editorController_1.EditorController; } }));
var validation_1 = __webpack_require__(135);
Object.defineProperty(exports, "ValidationState", ({ enumerable: true, get: function () { return validation_1.ValidationState; } }));
var serializedDiagram_1 = __webpack_require__(108);
Object.defineProperty(exports, "convertToSerializedDiagram", ({ enumerable: true, get: function () { return serializedDiagram_1.convertToSerializedDiagram; } }));
Object.defineProperty(exports, "makeSerializedDiagram", ({ enumerable: true, get: function () { return serializedDiagram_1.makeSerializedDiagram; } }));
Object.defineProperty(exports, "makeLayoutData", ({ enumerable: true, get: function () { return serializedDiagram_1.makeLayoutData; } }));
var layout_1 = __webpack_require__(109);
Object.defineProperty(exports, "calculateLayout", ({ enumerable: true, get: function () { return layout_1.calculateLayout; } }));
Object.defineProperty(exports, "removeOverlaps", ({ enumerable: true, get: function () { return layout_1.removeOverlaps; } }));
Object.defineProperty(exports, "applyLayout", ({ enumerable: true, get: function () { return layout_1.applyLayout; } }));
Object.defineProperty(exports, "forceLayout", ({ enumerable: true, get: function () { return layout_1.forceLayout; } }));
var async_1 = __webpack_require__(61);
Object.defineProperty(exports, "Cancellation", ({ enumerable: true, get: function () { return async_1.Cancellation; } }));
tslib_1.__exportStar(__webpack_require__(55), exports);
var halo_1 = __webpack_require__(130);
Object.defineProperty(exports, "Halo", ({ enumerable: true, get: function () { return halo_1.Halo; } }));
var toolbar_1 = __webpack_require__(136);
Object.defineProperty(exports, "DefaultToolbar", ({ enumerable: true, get: function () { return toolbar_1.DefaultToolbar; } }));
var workspace_1 = __webpack_require__(137);
Object.defineProperty(exports, "Workspace", ({ enumerable: true, get: function () { return workspace_1.Workspace; } }));
Object.defineProperty(exports, "renderTo", ({ enumerable: true, get: function () { return workspace_1.renderTo; } }));
var workspaceContext_1 = __webpack_require__(88);
Object.defineProperty(exports, "WorkspaceEventKey", ({ enumerable: true, get: function () { return workspaceContext_1.WorkspaceEventKey; } }));
var draggableHandle_1 = __webpack_require__(118);
Object.defineProperty(exports, "DraggableHandle", ({ enumerable: true, get: function () { return draggableHandle_1.DraggableHandle; } }));
tslib_1.__exportStar(__webpack_require__(150), exports);
const InternalApi = tslib_1.__importStar(__webpack_require__(200));
exports.InternalApi = InternalApi;


/***/ }),
/* 1 */
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __addDisposableResource: () => (/* binding */ __addDisposableResource),
/* harmony export */   __assign: () => (/* binding */ __assign),
/* harmony export */   __asyncDelegator: () => (/* binding */ __asyncDelegator),
/* harmony export */   __asyncGenerator: () => (/* binding */ __asyncGenerator),
/* harmony export */   __asyncValues: () => (/* binding */ __asyncValues),
/* harmony export */   __await: () => (/* binding */ __await),
/* harmony export */   __awaiter: () => (/* binding */ __awaiter),
/* harmony export */   __classPrivateFieldGet: () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   __classPrivateFieldIn: () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   __classPrivateFieldSet: () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   __createBinding: () => (/* binding */ __createBinding),
/* harmony export */   __decorate: () => (/* binding */ __decorate),
/* harmony export */   __disposeResources: () => (/* binding */ __disposeResources),
/* harmony export */   __esDecorate: () => (/* binding */ __esDecorate),
/* harmony export */   __exportStar: () => (/* binding */ __exportStar),
/* harmony export */   __extends: () => (/* binding */ __extends),
/* harmony export */   __generator: () => (/* binding */ __generator),
/* harmony export */   __importDefault: () => (/* binding */ __importDefault),
/* harmony export */   __importStar: () => (/* binding */ __importStar),
/* harmony export */   __makeTemplateObject: () => (/* binding */ __makeTemplateObject),
/* harmony export */   __metadata: () => (/* binding */ __metadata),
/* harmony export */   __param: () => (/* binding */ __param),
/* harmony export */   __propKey: () => (/* binding */ __propKey),
/* harmony export */   __read: () => (/* binding */ __read),
/* harmony export */   __rest: () => (/* binding */ __rest),
/* harmony export */   __runInitializers: () => (/* binding */ __runInitializers),
/* harmony export */   __setFunctionName: () => (/* binding */ __setFunctionName),
/* harmony export */   __spread: () => (/* binding */ __spread),
/* harmony export */   __spreadArray: () => (/* binding */ __spreadArray),
/* harmony export */   __spreadArrays: () => (/* binding */ __spreadArrays),
/* harmony export */   __values: () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});


/***/ }),
/* 2 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_main_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_main_scss__WEBPACK_IMPORTED_MODULE_1__["default"], options);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_node_modules_sass_loader_dist_cjs_js_main_scss__WEBPACK_IMPORTED_MODULE_1__["default"].locals || {});

/***/ }),
/* 3 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : 0;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 4 */
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _images_font_awesome_exclamation_triangle_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
/* harmony import */ var _images_font_awesome_exclamation_triangle_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_exclamation_triangle_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_expand_link_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
/* harmony import */ var _images_expand_link_png__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_expand_link_png__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_add_to_filter_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10);
/* harmony import */ var _images_add_to_filter_png__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_add_to_filter_png__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _images_direction_in_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
/* harmony import */ var _images_direction_in_png__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_images_direction_in_png__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _images_direction_out_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12);
/* harmony import */ var _images_direction_out_png__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_images_direction_out_png__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _images_font_awesome_times_circle_regular_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13);
/* harmony import */ var _images_font_awesome_times_circle_regular_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_times_circle_regular_svg__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_connections_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14);
/* harmony import */ var _images_connections_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_images_connections_svg__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _images_close_connections_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15);
/* harmony import */ var _images_close_connections_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_images_close_connections_svg__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _images_link_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16);
/* harmony import */ var _images_link_svg__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_images_link_svg__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _images_delete_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17);
/* harmony import */ var _images_delete_svg__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_images_delete_svg__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _images_expand_properties_png__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18);
/* harmony import */ var _images_expand_properties_png__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_images_expand_properties_png__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _images_collapse_properties_png__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19);
/* harmony import */ var _images_collapse_properties_png__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_images_collapse_properties_png__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _images_font_awesome_undo_solid_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20);
/* harmony import */ var _images_font_awesome_undo_solid_svg__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_undo_solid_svg__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _images_font_awesome_plug_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21);
/* harmony import */ var _images_font_awesome_plug_svg__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_plug_svg__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _images_font_awesome_edit_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22);
/* harmony import */ var _images_font_awesome_edit_svg__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_edit_svg__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _images_font_awesome_trash_alt_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23);
/* harmony import */ var _images_font_awesome_trash_alt_svg__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_trash_alt_svg__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _images_font_awesome_pen_square_solid_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(24);
/* harmony import */ var _images_font_awesome_pen_square_solid_svg__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_pen_square_solid_svg__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _images_font_awesome_minus_square_regular_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25);
/* harmony import */ var _images_font_awesome_minus_square_regular_svg__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_minus_square_regular_svg__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _images_font_awesome_plus_square_regular_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26);
/* harmony import */ var _images_font_awesome_plus_square_regular_svg__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_images_font_awesome_plus_square_regular_svg__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _images_arrow_left_png__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27);
/* harmony import */ var _images_arrow_left_png__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_left_png__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _images_arrow_left1_png__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(28);
/* harmony import */ var _images_arrow_left1_png__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_left1_png__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _images_arrow_right_png__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29);
/* harmony import */ var _images_arrow_right_png__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_right_png__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _images_arrow_right1_png__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30);
/* harmony import */ var _images_arrow_right1_png__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_right1_png__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _images_resizable_column_handle_png__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(31);
/* harmony import */ var _images_resizable_column_handle_png__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_images_resizable_column_handle_png__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _images_arrow_top_png__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(32);
/* harmony import */ var _images_arrow_top_png__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_top_png__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _images_arrow_top1_png__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(33);
/* harmony import */ var _images_arrow_top1_png__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_top1_png__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _images_arrow_bottom_png__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(34);
/* harmony import */ var _images_arrow_bottom_png__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_bottom_png__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _images_arrow_bottom1_png__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(35);
/* harmony import */ var _images_arrow_bottom1_png__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_images_arrow_bottom1_png__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _images_left_panel_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(36);
/* harmony import */ var _images_left_panel_svg__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_images_left_panel_svg__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _images_right_panel_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(37);
/* harmony import */ var _images_right_panel_svg__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_images_right_panel_svg__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _images_left_panel_active_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(38);
/* harmony import */ var _images_left_panel_active_svg__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_images_left_panel_active_svg__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _images_right_panel_active_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(39);
/* harmony import */ var _images_right_panel_active_svg__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_images_right_panel_active_svg__WEBPACK_IMPORTED_MODULE_34__);
// Imports



































var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_cssWithMappingToString_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_exclamation_triangle_svg__WEBPACK_IMPORTED_MODULE_3___default()));
var ___CSS_LOADER_URL_REPLACEMENT_1___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_expand_link_png__WEBPACK_IMPORTED_MODULE_4___default()));
var ___CSS_LOADER_URL_REPLACEMENT_2___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_add_to_filter_png__WEBPACK_IMPORTED_MODULE_5___default()));
var ___CSS_LOADER_URL_REPLACEMENT_3___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_direction_in_png__WEBPACK_IMPORTED_MODULE_6___default()));
var ___CSS_LOADER_URL_REPLACEMENT_4___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_direction_out_png__WEBPACK_IMPORTED_MODULE_7___default()));
var ___CSS_LOADER_URL_REPLACEMENT_5___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_times_circle_regular_svg__WEBPACK_IMPORTED_MODULE_8___default()));
var ___CSS_LOADER_URL_REPLACEMENT_6___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_connections_svg__WEBPACK_IMPORTED_MODULE_9___default()));
var ___CSS_LOADER_URL_REPLACEMENT_7___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_close_connections_svg__WEBPACK_IMPORTED_MODULE_10___default()));
var ___CSS_LOADER_URL_REPLACEMENT_8___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_link_svg__WEBPACK_IMPORTED_MODULE_11___default()));
var ___CSS_LOADER_URL_REPLACEMENT_9___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_delete_svg__WEBPACK_IMPORTED_MODULE_12___default()));
var ___CSS_LOADER_URL_REPLACEMENT_10___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_expand_properties_png__WEBPACK_IMPORTED_MODULE_13___default()));
var ___CSS_LOADER_URL_REPLACEMENT_11___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_collapse_properties_png__WEBPACK_IMPORTED_MODULE_14___default()));
var ___CSS_LOADER_URL_REPLACEMENT_12___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_undo_solid_svg__WEBPACK_IMPORTED_MODULE_15___default()));
var ___CSS_LOADER_URL_REPLACEMENT_13___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_plug_svg__WEBPACK_IMPORTED_MODULE_16___default()));
var ___CSS_LOADER_URL_REPLACEMENT_14___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_edit_svg__WEBPACK_IMPORTED_MODULE_17___default()));
var ___CSS_LOADER_URL_REPLACEMENT_15___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_trash_alt_svg__WEBPACK_IMPORTED_MODULE_18___default()));
var ___CSS_LOADER_URL_REPLACEMENT_16___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_pen_square_solid_svg__WEBPACK_IMPORTED_MODULE_19___default()));
var ___CSS_LOADER_URL_REPLACEMENT_17___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_minus_square_regular_svg__WEBPACK_IMPORTED_MODULE_20___default()));
var ___CSS_LOADER_URL_REPLACEMENT_18___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_font_awesome_plus_square_regular_svg__WEBPACK_IMPORTED_MODULE_21___default()));
var ___CSS_LOADER_URL_REPLACEMENT_19___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_left_png__WEBPACK_IMPORTED_MODULE_22___default()));
var ___CSS_LOADER_URL_REPLACEMENT_20___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_left1_png__WEBPACK_IMPORTED_MODULE_23___default()));
var ___CSS_LOADER_URL_REPLACEMENT_21___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_right_png__WEBPACK_IMPORTED_MODULE_24___default()));
var ___CSS_LOADER_URL_REPLACEMENT_22___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_right1_png__WEBPACK_IMPORTED_MODULE_25___default()));
var ___CSS_LOADER_URL_REPLACEMENT_23___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_resizable_column_handle_png__WEBPACK_IMPORTED_MODULE_26___default()));
var ___CSS_LOADER_URL_REPLACEMENT_24___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_top_png__WEBPACK_IMPORTED_MODULE_27___default()));
var ___CSS_LOADER_URL_REPLACEMENT_25___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_top1_png__WEBPACK_IMPORTED_MODULE_28___default()));
var ___CSS_LOADER_URL_REPLACEMENT_26___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_bottom_png__WEBPACK_IMPORTED_MODULE_29___default()));
var ___CSS_LOADER_URL_REPLACEMENT_27___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_arrow_bottom1_png__WEBPACK_IMPORTED_MODULE_30___default()));
var ___CSS_LOADER_URL_REPLACEMENT_28___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_left_panel_svg__WEBPACK_IMPORTED_MODULE_31___default()));
var ___CSS_LOADER_URL_REPLACEMENT_29___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_right_panel_svg__WEBPACK_IMPORTED_MODULE_32___default()));
var ___CSS_LOADER_URL_REPLACEMENT_30___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_left_panel_active_svg__WEBPACK_IMPORTED_MODULE_33___default()));
var ___CSS_LOADER_URL_REPLACEMENT_31___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()((_images_right_panel_active_svg__WEBPACK_IMPORTED_MODULE_34___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ontodia-spinner__arrow {\n  animation-name: ontodia-spinner-rotation;\n  animation-duration: 1.5s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-iteration-count: infinite;\n}\n.ontodia-spinner[data-error=true] .ontodia-spinner__arrow {\n  animation-iteration-count: 1;\n}\n\n@keyframes ontodia-spinner-rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.clearfix:before, .clearfix:after {\n  display: table;\n  content: \"\";\n}\n.clearfix:after {\n  clear: both;\n}\n\n.ontodia-label {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.ontodia-btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  text-transform: none;\n  transition: background-color 0.3s;\n}\n.ontodia-btn[disabled] {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.ontodia-btn-default {\n  background-color: #fff;\n  border-color: #ccc;\n  color: #333;\n}\n.ontodia-btn-default:hover {\n  background-color: #e0e0e0;\n}\n.ontodia-btn-default.active {\n  background-color: #e0e0e0;\n  border-color: #dbdbdb;\n}\n.ontodia-btn-default.active:hover {\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.ontodia-btn-default[disabled], .ontodia-btn-default[disabled]:hover, .ontodia-btn-default[disabled].active, .ontodia-btn-default[disabled].active:hover {\n  background-color: #e0e0e0;\n}\n\n.ontodia-btn-primary {\n  color: rgb(255, 255, 255);\n  background-color: rgb(51, 122, 183);\n  border-color: #245580;\n}\n.ontodia-btn-primary:hover, .ontodia-btn-primary:focus, .ontodia-btn-primary:active {\n  background-color: #265a88;\n}\n.ontodia-btn-primary:hover, .ontodia-btn-primary:focus {\n  border-color: #204d74;\n}\n.ontodia-btn-primary.active {\n  border-color: #245580;\n}\n.ontodia-btn-primary[disabled], .ontodia-btn-primary[disabled]:hover, .ontodia-btn-primary[disabled]:focus, .ontodia-btn-primary[disabled]:active, .ontodia-btn-primary[disabled].active {\n  background-color: #265a88;\n}\n\n.ontodia-btn-success {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n  transition: 0.3s;\n}\n.ontodia-btn-success:hover {\n  background: #47a447;\n}\n\n.ontodia-btn-danger {\n  background-color: #c9302c;\n  border-color: #c9302c;\n  color: #fff;\n  transition: 0.3s;\n}\n.ontodia-btn-danger:hover {\n  background: #a82825;\n}\n\n.ontodia-btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ontodia-btn-group > .ontodia-btn, .ontodia-btn-group > .ontodia-btn-group {\n  position: relative;\n  float: left;\n}\n.ontodia-btn-group > .ontodia-btn:hover,\n.ontodia-btn-group > .ontodia-btn:focus,\n.ontodia-btn-group > .ontodia-btn.active,\n.ontodia-btn-group > .ontodia-btn.active:hover {\n  z-index: 2;\n}\n.ontodia-btn-group .ontodia-btn + .ontodia-btn,\n.ontodia-btn-group .ontodia-btn + .ontodia-btn-group,\n.ontodia-btn-group .ontodia-btn-group + .ontodia-btn,\n.ontodia-btn-group .ontodia-btn-group + .ontodia-btn-group {\n  margin-left: -1px;\n}\n.ontodia-btn-group > .ontodia-btn:first-child {\n  margin-left: 0;\n}\n.ontodia-btn-group-sm > .ontodia-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 5px 10px;\n}\n.ontodia-btn-group-xs > .ontodia-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 1px 5px;\n}\n\n.ontodia-form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  margin: 0;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background: #fff;\n  border: 1px solid #ccc;\n  transition: border-color ease-in-out 0.15s;\n}\n.ontodia-form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n}\n.ontodia-form-control:disabled {\n  background-color: #eee;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.ontodia-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.ontodia-input-group .ontodia-form-control {\n  display: table-cell;\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.ontodia-input-group .ontodia-form-control:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.ontodia-input-group-btn {\n  display: table-cell;\n  width: 1%;\n  vertical-align: middle;\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.ontodia-input-group-btn:last-child > .ontodia-btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  z-index: 2;\n  margin-left: -1px;\n}\n\n.ontodia-list-group {\n  margin: 0;\n  padding: 0;\n}\n\n.ontodia-list-group-item:last-child {\n  margin-bottom: 0;\n}\n\n.ontodia-list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.ontodia-badge {\n  display: inline-block;\n  min-width: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: rgb(119, 119, 119);\n  padding: 3px 7px;\n  border-radius: 10px;\n}\n\n.ontodia-overlayed-element {\n  cursor: move;\n  outline: none;\n}\n\n.ontodia-overlayed-element,\n.ontodia-exported-element {\n  box-sizing: border-box;\n  color: black;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n}\n.ontodia-overlayed-element img,\n.ontodia-exported-element img {\n  vertical-align: middle;\n}\n\n.ontodia-exported-element *, .ontodia-exported-element *:before, .ontodia-exported-element *:after {\n  box-sizing: inherit;\n}\n\n.ontodia-overlayed-element--blurred {\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n\n.ontodia-link__wrap {\n  stroke-width: 12px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke: transparent;\n  fill: none;\n}\n.ontodia-link:hover .ontodia-link__wrap {\n  stroke: rgba(140, 140, 140, 0.44);\n}\n.ontodia-link__vertex {\n  cursor: all-scroll;\n}\n.ontodia-link:not(:hover) .ontodia-link__vertex {\n  fill: transparent;\n}\n.ontodia-link__vertex-tools {\n  opacity: 0;\n  cursor: pointer;\n}\n.ontodia-link__vertex-tools > circle {\n  fill: gray;\n}\n.ontodia-link__vertex-tools > path {\n  stroke: white;\n}\n.ontodia-link__vertex-tools:hover > circle {\n  fill: black;\n}\n.ontodia-link:hover .ontodia-link__vertex-tools {\n  opacity: 0.8;\n}\n.ontodia-link--blurred {\n  opacity: 0.5;\n}\n\n.ontodia-paper-area {\n  flex: auto;\n  width: 0;\n  display: flex;\n  position: relative;\n  cursor: default;\n  background: #fff;\n}\n.ontodia-paper-area__area {\n  flex: auto;\n  overflow: hidden;\n}\n.ontodia-paper-area__widgets {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.ontodia-paper-area__watermark {\n  background-size: cover;\n  width: 8%;\n  max-width: 130px;\n  min-width: 50px;\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n.ontodia-paper-area__watermark:hover {\n  opacity: 0.5;\n}\n.ontodia-paper-area--hide-scrollbars {\n  overflow: hidden;\n}\n\n.ontodia-paper {\n  position: relative;\n}\n\n.ontodia-exported-watermark {\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n\n.ontodia-paper-area--animated .ontodia-overlayed-element {\n  transition: transform 0.5s ease-in-out;\n}\n.ontodia-paper-area--animated .ontodia-link-layer, .ontodia-paper-area--animated .ontodia-paper-area__widgets {\n  transition: none;\n  opacity: 0;\n}\n\n.ontodia-link-layer, .ontodia-paper-area__widgets {\n  transition: opacity 0.5s ease-in-out;\n}\n\n.ontodia-loading-widget {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n}\n\n.ontodia-authoring-state__item-error {\n  align-self: flex-end;\n  margin: 0px 5px;\n  display: flex;\n  align-items: center;\n  cursor: help;\n}\n.ontodia-authoring-state__item-error-icon {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  height: 15px;\n  width: 17px;\n}\n.ontodia-authoring-state__state-label {\n  font-weight: bold;\n  margin-right: 5px;\n}\n.ontodia-authoring-state__state-cancel {\n  color: #3f87a6;\n  cursor: pointer;\n}\n.ontodia-authoring-state__state-cancel:hover {\n  text-decoration: underline;\n}\n.ontodia-authoring-state__state-indicator {\n  position: absolute;\n}\n.ontodia-authoring-state__state-indicator-container {\n  position: relative;\n}\n.ontodia-authoring-state__state-indicator-body {\n  position: absolute;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 5px;\n}\n\n.ontodia-authoring-tools {\n  margin: 10px;\n}\n.ontodia-authoring-tools__create-entity {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  white-space: normal;\n}\n.ontodia-authoring-tools__type-label {\n  color: black;\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n\n.ontodia-class-tree {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-class-tree__filter {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.ontodia-class-tree__filter-group {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.ontodia-class-tree__only-creatable {\n  display: block;\n  margin-top: 5px;\n}\n.ontodia-class-tree__tree {\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.ontodia-class-tree__spinner {\n  align-self: center;\n  /* center vertically in flexbox */\n  margin: auto;\n}\n\n.ontodia-class-leaf {\n  margin: 1px 0;\n}\n.ontodia-class-leaf__row {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  user-select: none;\n}\n.ontodia-class-leaf__row > * {\n  flex-shrink: 0;\n}\n.ontodia-class-leaf__body {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-size: 15px;\n  padding: 1px;\n  border: 1px solid;\n  border-color: transparent;\n}\n.ontodia-class-leaf__body:hover {\n  background: rgba(220, 235, 255, 0.568627451);\n  border-color: #ccefff;\n  cursor: pointer;\n}\n.ontodia-class-leaf__body--selected {\n  background-color: #beebff;\n  border-color: #8edcff;\n}\n.ontodia-class-leaf__icon-container {\n  height: 20px;\n}\n.ontodia-class-leaf__icon {\n  display: block;\n  height: 100%;\n}\n.ontodia-class-leaf__label {\n  margin-left: 5px;\n  color: black;\n}\n.ontodia-class-leaf__highlighted-term {\n  font-weight: bold;\n}\n.ontodia-class-leaf__count {\n  margin-left: 5px;\n}\n.ontodia-class-leaf__children {\n  margin-left: 20px;\n}\n.ontodia-class-leaf__no-toggle {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n}\n.ontodia-class-leaf__toggle {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin: 5px;\n}\n.ontodia-class-leaf__toggle:hover:not(:empty) {\n  background: rgba(220, 235, 255, 0.568627451);\n  cursor: pointer;\n}\n.ontodia-class-leaf__toggle-icon {\n  display: block;\n  height: 100%;\n}\n.ontodia-class-leaf__create {\n  margin-left: 5px;\n}\n.ontodia-class-leaf__create > button {\n  cursor: move;\n}\n\n.ontodia-connections-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-connections-menu__sort-switch {\n  display: none;\n}\n.ontodia-connections-menu__sort-switch:checked + .ontodia-connections-menu__sort-switch-label {\n  color: #337ab7;\n  opacity: 1;\n}\n.ontodia-connections-menu__sort-switch-label {\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  opacity: 0.4;\n  text-align: center;\n}\n.ontodia-connections-menu__sort-switch-label:hover {\n  opacity: 1;\n}\n.ontodia-connections-menu__search-line-input {\n  flex: 1 1 100%;\n}\n\n.ontodia-connections-menu_bread-crumbs {\n  padding: 10px;\n  padding-bottom: 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 27px;\n  min-height: 27px;\n  flex-grow: 0;\n}\n\n.ontodia-connections-menu__title-label {\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n\n.ontodia-connections-menu_search-line {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.ontodia-connections-menu_search-line-sort-switches {\n  flex: 0 0 20px;\n  margin-left: 10px;\n}\n\n.ontodia-connections-menu_links-list {\n  padding: 5px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-top: 1px solid #dbdbdb;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.ocm_links-list-empty {\n  display: flex;\n  align-items: center;\n}\n\n.ontodia-connections-menu_links-list__empty {\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n  text-align: center;\n}\n\n.ontodia-connections-menu__loading,\n.ontodia-connections-menu__error {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n}\n\n.ontodia-connections-menu__loading-objects {\n  border: 1px solid gray;\n  flex-grow: 1;\n  box-shadow: inset 0px 0px 23px -8px gray;\n  background-color: whitesmoke;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.ontodia-connections-menu__move-to-filter {\n  display: flex;\n  padding: 5px 10px;\n  user-select: none;\n  cursor: pointer;\n}\n.ontodia-connections-menu__move-to-filter:hover {\n  background-color: #e6e6e6;\n}\n\n.link-in-popup-menu {\n  display: flex;\n  overflow: hidden;\n  padding: 0 5px 0 0;\n  align-items: center;\n  margin-bottom: 4px;\n  background: #f7f7f7;\n}\n.link-in-popup-menu__link-title {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 5px 0px 5px 5px;\n}\n.link-in-popup-menu__count {\n  flex-shrink: 0;\n  margin-left: 10px;\n}\n.link-in-popup-menu__navigate-button {\n  float: right;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");\n  width: 16px;\n  height: 16px;\n  opacity: 0.5;\n  margin-left: 10px;\n  min-width: 16px;\n  background-size: cover;\n}\n.link-in-popup-menu__navigate-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu__filter-button {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  opacity: 0.4;\n  margin-left: 10px;\n}\n.link-in-popup-menu__filter-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu:hover {\n  background-color: #e2e2e2;\n}\n\n.link-in-popup-menu_direction {\n  background: rgba(219, 219, 219, 0.35);\n  min-height: 30px;\n  padding: 5px 0px 5px 10px;\n  display: flex;\n  align-items: center;\n}\n\n.link-in-popup-menu_direction__in-direction {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 14px 0 0;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.link-in-popup-menu_direction__out-direction {\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 8px 0 6px;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.ontodia-connections-menu_links-list__loading {\n  text-align: center;\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n}\n\n.ontodia-connections-menu_links-list__hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.ontodia-connections-menu_objects-panel {\n  flex-grow: 1;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n\n.ontodia-connections-menu_objects-panel__select-all {\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n}\n.ontodia-connections-menu_objects-panel__select-all input {\n  margin-right: 5px;\n}\n.ontodia-connections-menu_objects-panel__select-all input:disabled {\n  opacity: 0.3;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel {\n  height: 25px;\n  white-space: nowrap;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel__count-label {\n  height: 25px;\n  float: left;\n  padding: 0px 5px;\n  font-size: larger;\n  display: flex;\n  align-items: center;\n  max-width: 60%;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel__extra-elements {\n  color: gray;\n  cursor: help;\n}\n\n.ontodia-btn.ontodia-connections-menu_objects-panel_bottom-panel__add-button {\n  height: 25px;\n  padding-top: 1px;\n  padding-bottom: 2px;\n}\n\n.ontodia-connections-menu_objects-panel_objects-list {\n  border: 1px solid gray;\n  height: 0;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.ontodia-connections-menu__link {\n  color: #337ab7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.ontodia-connections-menu__link:hover {\n  text-decoration: underline;\n}\n\n.ontodia-dialog {\n  background: #fff;\n  border: 1px solid #333;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  position: absolute;\n}\n.ontodia-dialog__caption {\n  font-weight: bold;\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n.ontodia-dialog__close-button {\n  background: transparent url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + ");\n  background-size: contain;\n  border: 0 none;\n  cursor: pointer;\n  display: block;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  top: -22px;\n  right: -22px;\n  height: 20px;\n  width: 20px;\n  opacity: 0.5;\n  transition: 0.3s;\n}\n.ontodia-dialog__close-button:hover {\n  opacity: 1;\n}\n\n.ontodia-dialog__bottom-right-handle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 10px 10px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n  cursor: nwse-resize;\n}\n.ontodia-dialog__bottom-right-handle::before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 5px 5px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n}\n.ontodia-dialog__bottom-right-handle:hover {\n  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n}\n\n.ontodia-dialog__bottom-handle, .ontodia-dialog__right-handle {\n  position: absolute;\n  opacity: 0;\n  background-color: black;\n}\n.ontodia-dialog__bottom-handle:hover, .ontodia-dialog__right-handle:hover {\n  opacity: 0.1;\n}\n\n.ontodia-dialog__bottom-handle {\n  bottom: 0;\n  width: 100%;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.ontodia-dialog__right-handle {\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.ontodia-edit-form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-edit-form__body {\n  overflow: auto;\n  padding: 10px;\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.ontodia-edit-form__controls {\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  text-align: right;\n  flex: 0 0 auto;\n}\n.ontodia-edit-form__apply-button {\n  margin-right: 5px;\n}\n.ontodia-edit-form__form-row {\n  display: block;\n  margin-bottom: 10px;\n}\n.ontodia-edit-form__element-selector {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-edit-form__search {\n  flex-shrink: 0;\n  position: relative;\n}\n.ontodia-edit-form__search-icon {\n  opacity: 0.6;\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  margin-top: -7px;\n}\n.ontodia-edit-form__search-input {\n  padding-left: 33px;\n}\n.ontodia-edit-form__existing-elements-list {\n  flex-grow: 1;\n  margin-top: 7px;\n  padding-right: 10px;\n  overflow-y: scroll;\n}\n.ontodia-edit-form__separator {\n  margin: 7px 0;\n  overflow: hidden;\n  text-align: center;\n}\n.ontodia-edit-form__separator-text {\n  color: #555;\n  display: inline-block;\n  font-size: 13px;\n  position: relative;\n}\n.ontodia-edit-form__separator-text:before, .ontodia-edit-form__separator-text:after {\n  content: \"\";\n  border-top: 1px solid;\n  position: absolute;\n  top: 50%;\n  margin: 0 10px;\n  width: 500px;\n}\n.ontodia-edit-form__separator-text:before {\n  left: 100%;\n}\n.ontodia-edit-form__separator-text:after {\n  right: 100%;\n}\n.ontodia-edit-form__progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.ontodia-edit-form__control-row {\n  position: relative;\n  padding-bottom: 18px;\n}\n.ontodia-edit-form__control-error {\n  color: red;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.ontodia-halo {\n  position: absolute;\n  pointer-events: none;\n  border: 1.5px dashed #d8956d;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 #d8956d inset;\n}\n.ontodia-halo__navigate {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  right: -22px;\n}\n.ontodia-halo__navigate:hover {\n  opacity: 1;\n}\n.ontodia-halo__navigate[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__navigate--open {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ");\n}\n.ontodia-halo__navigate--closed {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ");\n}\n.ontodia-halo__folow {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  left: -22px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + ");\n}\n.ontodia-halo__folow:hover {\n  opacity: 1;\n}\n.ontodia-halo__folow[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__remove {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  right: -22px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + ");\n}\n.ontodia-halo__remove:hover {\n  opacity: 1;\n}\n.ontodia-halo__remove[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__expand {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: 50%;\n  margin-left: -10px;\n}\n.ontodia-halo__expand:hover {\n  opacity: 1;\n}\n.ontodia-halo__expand[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__expand--open {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + ");\n}\n.ontodia-halo__expand--closed {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_11___ + ");\n}\n.ontodia-halo__add-to-filter {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  right: -22px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");\n}\n.ontodia-halo__add-to-filter:hover {\n  opacity: 1;\n}\n.ontodia-halo__add-to-filter[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__revert {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  left: 50%;\n  margin-left: -10px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_12___ + ");\n}\n.ontodia-halo__revert:hover {\n  opacity: 1;\n}\n.ontodia-halo__revert[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__establish-connection {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: -22px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_13___ + ");\n}\n.ontodia-halo__establish-connection:hover {\n  opacity: 1;\n}\n.ontodia-halo__establish-connection[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__establish-connection-spinner {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  bottom: -22px;\n  left: -22px;\n}\n\n.ontodia-halo-link__button {\n  background: transparent;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  opacity: 0.8;\n  outline: none;\n  transition: opacity 0.3s;\n}\n.ontodia-halo-link__button:hover {\n  opacity: 1;\n}\n.ontodia-halo-link__button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.ontodia-halo-link__edit {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_14___ + ");\n}\n.ontodia-halo-link__delete {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_15___ + ");\n}\n.ontodia-halo-link__spinner {\n  position: absolute;\n}\n.ontodia-halo-link__edit-label-button {\n  background: transparent url(" + ___CSS_LOADER_URL_REPLACEMENT_16___ + ") no-repeat;\n  background-size: cover;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  margin-left: 5px;\n  outline: none;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.ontodia-halo-link__edit-label-button:hover {\n  opacity: 1;\n}\n\n.ontodia-instances-search {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-instances-search__criteria {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.ontodia-instances-search__criterions {\n  padding-left: 15px;\n  margin-bottom: 10px;\n}\n.ontodia-instances-search__criterions:empty {\n  margin-bottom: 0;\n}\n.ontodia-instances-search__criterion {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ontodia-instances-search__criterion-class {\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__criterion-element {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__criterion-link-type {\n  border: black 1px dashed;\n  background: rgb(202, 255, 206);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__link-direction {\n  height: 1em;\n  opacity: 0.5;\n}\n.ontodia-instances-search__criterion-remove {\n  float: right;\n  margin: 0 10px 4px 4px;\n}\n.ontodia-instances-search__text-criteria {\n  margin: 0 10px;\n}\n.ontodia-instances-search__rest {\n  padding: 10px 10px 0 10px;\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.ontodia-instances-search__results {\n  padding-left: 0;\n  padding-top: 10px;\n  margin: 0 10px 0 10px;\n  outline: none;\n}\n.ontodia-instances-search[data-state=finished] .ontodia-instances-search__results:empty:before {\n  content: \"No items correspond to the specified criteria.\";\n  font-style: italic;\n}\n.ontodia-instances-search__rest-end {\n  margin: 5px 0 10px 0;\n}\n.ontodia-instances-search__load-more {\n  width: 100%;\n}\n\n.link-types-toolbox {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n.link-types-toolbox__heading {\n  padding: 10px;\n}\n.link-types-toolbox__searching-box {\n  display: flex;\n  align-items: center;\n}\n.link-types-toolbox__clearSearch {\n  margin-left: -25px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.link-types-toolbox__switch-all {\n  margin-top: 5px;\n}\n.link-types-toolbox__rest {\n  border-top: 1px solid #dddddd;\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.link-types-toolbox .panel-heading {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n}\n\n.link-types-toolbox ul {\n  margin-bottom: 0;\n}\n\n.link-types-toolbox .links-heading {\n  margin-left: 0.4em;\n}\n\n.link-types-toolbox .links-heading span {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n  line-height: 1.3;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls {\n  padding: 5px 15px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls > span {\n  padding-left: 0.3em;\n}\n\n.ontodia-list-group .linkInToolBox {\n  padding: 0 0 0 5px;\n  word-break: break-word;\n}\n\n.linkInToolBox > div {\n  display: inline;\n}\n.linkInToolBox__new-tag {\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n  border-radius: 2px;\n  padding: 0 5px;\n  background: orange;\n}\n.linkInToolBox .ontodia-badge {\n  display: none;\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n}\n.linkInToolBox .link-title {\n  font-size: 16px;\n  color: black;\n  display: inline;\n}\n.linkInToolBox .ontodia-btn-group {\n  float: left;\n  margin-top: 2px;\n  margin-right: 6px;\n  margin-bottom: 2px;\n}\n.linkInToolBox .ontodia-btn.ontodia-btn-default {\n  border-color: rgb(195, 195, 195);\n}\n.linkInToolBox__filter-button {\n  display: none;\n  float: right;\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  margin: 3px;\n  cursor: pointer;\n  opacity: 0.4;\n  transition: opacity 200ms 0ms;\n}\n.linkInToolBox:hover .linkInToolBox__filter-button {\n  opacity: 1;\n  transition: opacity 200ms 0ms;\n}\n\n.connected-links .linkInToolBox .ontodia-badge {\n  /* show connection count badge only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.connected-links .linkInToolBox__filter-button {\n  /* show filter button only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.ontodia-list-element-view {\n  position: relative;\n  display: block;\n  background: #808080;\n  padding: 1px 1px 1px 10px;\n  border-radius: 2px;\n  margin: 0 0 2px 0;\n  opacity: 1;\n  cursor: move;\n  user-select: none;\n}\n.ontodia-list-element-view--disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.ontodia-list-element-view__label {\n  background: white;\n  border-radius: 0 2px 2px 0;\n  font-family: \"Andale Mono\", sans-serif;\n  font-size: 15px;\n  min-height: 1.3em;\n  padding-left: 7px;\n  padding-right: 5px;\n  overflow-wrap: break-word;\n}\n\n.ontodia-text-highlight {\n  font-weight: bold;\n}\n\n.ontodia-navigator {\n  display: block;\n  position: absolute;\n  bottom: 25px;\n  right: 25px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  transition: width 0.3s, height 0.3s;\n}\n.ontodia .ontodia-navigator {\n  box-sizing: content-box;\n}\n.ontodia-navigator--collapsed {\n  width: 26px;\n  height: 26px;\n}\n.ontodia-navigator > canvas {\n  transition: opacity 0.3s;\n}\n.ontodia-navigator--expanded > canvas {\n  opacity: 1;\n}\n.ontodia-navigator--collapsed > canvas {\n  opacity: 0;\n}\n.ontodia-navigator__toggle {\n  position: absolute;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 4px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.ontodia-navigator__toggle:hover {\n  opacity: 1;\n}\n.ontodia-navigator--expanded .ontodia-navigator__toggle {\n  top: 5px;\n  left: 5px;\n}\n.ontodia-navigator--collapsed .ontodia-navigator__toggle {\n  top: 0px;\n  left: 0px;\n}\n.ontodia-navigator__toggle-icon {\n  width: 18px;\n  height: 18px;\n  background-size: 18px 18px;\n  background-repeat: no-repeat;\n}\n.ontodia-navigator--expanded .ontodia-navigator__toggle-icon {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_17___ + ");\n}\n.ontodia-navigator--collapsed .ontodia-navigator__toggle-icon {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_18___ + ");\n}\n\n@keyframes ontodia-progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.ontodia-progress-bar {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n  width: 100%;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);\n  background-repeat: repeat-x;\n  overflow: hidden;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.ontodia-progress-bar__bar {\n  float: left;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  transition: width 0.6s ease;\n  background-color: #337ab7;\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-repeat: repeat-x;\n  background-size: 40px 40px;\n  animation: ontodia-progress-bar-stripes 2s linear infinite;\n}\n.ontodia-progress-bar--loading, .ontodia-progress-bar--error {\n  /* property name | duration | delay */\n  transition: height 300ms 300ms;\n}\n.ontodia-progress-bar--error {\n  background-color: #E72F2F;\n}\n.ontodia-progress-bar--completed {\n  /* property name | duration | delay */\n  transition: height 200ms 0ms;\n}\n\n.ontodia-search-results {\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n\n.ontodia-accordion {\n  flex: auto;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.ontodia-accordion--scrollable {\n  overflow: auto;\n}\n.ontodia-accordion--vertical {\n  flex-direction: column;\n}\n.ontodia-accordion--vertical:not(.ontodia-accordion--resizing) > .ontodia-accordion-item {\n  transition: height 0.3s ease-in-out;\n}\n\n.ontodia-accordion-item {\n  display: flex;\n  position: relative;\n  flex: auto;\n}\n.ontodia-accordion-item--resizing > .ontodia-accordion-item__handle, .ontodia-accordion-item__handle:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.ontodia-accordion-item--vertical {\n  border-top: 1px solid lightgray;\n}\n.ontodia-accordion-item--vertical:first-child {\n  border-top-width: 0;\n}\n.ontodia-accordion-item--horizontal {\n  border-right: 1px solid lightgray;\n}\n.ontodia-accordion-item--horizontal:last-child {\n  border-right-width: 0;\n}\n.ontodia-accordion-item__handle {\n  position: absolute;\n  z-index: 2;\n}\n.ontodia-accordion-item__handle-vertical {\n  height: 5px;\n  bottom: -2.5px;\n  left: 0;\n  width: 100%;\n  cursor: ns-resize;\n}\n.ontodia-accordion-item__handle-horizontal {\n  height: 100%;\n  top: 0;\n  right: -2.5px;\n  width: 5px;\n  cursor: ew-resize;\n}\n.ontodia-accordion-item__handle-btn {\n  background: #fff;\n  border: 2px solid #17b;\n  box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  top: 50%;\n  margin-top: -10px;\n  width: 20px;\n  z-index: 20;\n  transition: 0.3s;\n}\n.ontodia-accordion-item__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 8px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -4px;\n  margin-left: -4px;\n  width: 8px;\n  transition: background 0.3s;\n}\n.ontodia-accordion-item__handle-btn:hover {\n  background: #17b;\n}\n.ontodia-accordion-item__handle-btn-left {\n  left: 100%;\n  margin-left: -10px;\n}\n.ontodia-accordion-item__handle-btn-left:before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_19___ + ");\n}\n.ontodia-accordion-item__handle-btn-left:hover:before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_20___ + ");\n}\n.ontodia-accordion-item__handle-btn-right {\n  right: 100%;\n  margin-right: -10px;\n}\n.ontodia-accordion-item__handle-btn-right:before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_21___ + ");\n}\n.ontodia-accordion-item__handle-btn-right:hover:before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_22___ + ");\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__handle-btn:before {\n  transform: rotate(180deg);\n}\n.ontodia-accordion-item__inner {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.ontodia-accordion-item__body {\n  flex: 1 1 0px;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-accordion-item__header {\n  padding-left: 14px;\n  position: relative;\n  flex-shrink: 0;\n  font-size: 16px;\n  background: #E4E4E4;\n  cursor: default;\n  /* unselectable */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ontodia-accordion-item__header:before {\n  border-top: 6px solid #555555;\n  border-left: 3.5px solid transparent;\n  border-right: 3.5px solid transparent;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 3px;\n  margin-top: -3px;\n  display: none;\n  -webkit-transition: 0.1s;\n  -moz-transition: 0.1s;\n  transition: 0.1s;\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__header:before {\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__body {\n  display: none;\n}\n\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle,\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle {\n  height: 8px;\n  width: 100%;\n  top: initial;\n  left: 0;\n  cursor: ns-resize;\n}\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn,\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn {\n  height: 100%;\n  width: 40px;\n  top: 0;\n  left: 50%;\n  margin-left: -20px;\n  margin-top: 0px;\n}\n\n.ontodia-drag-resizable-column {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.ontodia-drag-resizable-column__handle {\n  background: #fff url(" + ___CSS_LOADER_URL_REPLACEMENT_23___ + ") repeat;\n  width: 8px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: initial;\n  z-index: 2;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n  cursor: ew-resize;\n}\n.ontodia-drag-resizable-column__handle-btn {\n  background: #eee;\n  cursor: pointer;\n  height: 40px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  margin-top: -20px;\n  width: 100%;\n  z-index: 1;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.ontodia-drag-resizable-column__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 6px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -3px;\n  margin-left: -3px;\n  width: 6px;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.ontodia-drag-resizable-column__handle-btn:hover {\n  background: #b3b3b3;\n  transform: scale(1.2);\n}\n.ontodia-drag-resizable-column--closed .ontodia-drag-resizable-column__handle-btn::before {\n  transform: rotate(180deg);\n}\n.ontodia-drag-resizable-column--docked-left {\n  margin-right: 8px;\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle {\n  right: -8px;\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_19___ + ");\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_20___ + ");\n}\n.ontodia-drag-resizable-column--docked-right {\n  margin-left: 8px;\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle {\n  left: -8px;\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_21___ + ");\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_22___ + ");\n}\n.ontodia-drag-resizable-column--docked-top {\n  margin-bottom: 8px;\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle {\n  bottom: -8px;\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_24___ + ");\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_25___ + ");\n}\n.ontodia-drag-resizable-column--docked-bottom {\n  margin-top: 8px;\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle {\n  top: -8px;\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_26___ + ");\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_27___ + ");\n}\n\n.introjs-tooltiptext {\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n\n.ontodia-toolbar__language-selector {\n  padding: 5px;\n  margin-top: 4px;\n}\n.ontodia-toolbar__language-selector > label {\n  margin-right: 5px;\n}\n.ontodia-toolbar__language-selector > label > span {\n  vertical-align: middle;\n}\n.ontodia-toolbar__toggle {\n  line-height: 1;\n}\n.ontodia-toolbar__toggle:after {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  content: \"\";\n  display: block;\n  height: 12px;\n  margin: 3px 0;\n  width: 12px;\n}\n.ontodia-toolbar__toggle-left:after {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_28___ + ");\n}\n.ontodia-toolbar__toggle-right:after {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_29___ + ");\n}\n.ontodia-toolbar__toggle.active {\n  border-color: #c3c3c3;\n}\n.ontodia-toolbar__toggle-left.active:after {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_30___ + ");\n}\n.ontodia-toolbar__toggle-right.active:after {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_31___ + ");\n}\n\n.ontodia-toolbar__layout-group {\n  margin: 5px;\n  height: 30px;\n  float: left;\n}\n.ontodia-toolbar__layout-group > label {\n  margin-right: 5px;\n}\n.ontodia-toolbar__layout-group .btn-group, .ontodia-toolbar__layout-group button {\n  height: 100%;\n}\n\n.ontodia-toolbar {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.ontodia-toolbar > .ontodia-btn-group {\n  margin-left: 10px;\n}\n\n.ontodia-toolbar > .ontodia-btn-group > button {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.ontodia {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n  white-space: initial;\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n.ontodia *, .ontodia *:before, .ontodia *:after {\n  box-sizing: inherit;\n}\n.ontodia__header {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n}\n.ontodia__workspace {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  flex-direction: column;\n}\n.ontodia__main-panel {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  width: 0;\n}\n.ontodia--unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ontodia--horizontal-resizing * {\n  cursor: ew-resize !important;\n}\n.ontodia--vertical-resizing * {\n  cursor: ns-resize !important;\n}\n.ontodia h4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.ontodia select {\n  color: inherit;\n  margin: 0;\n  font: inherit;\n  line-height: inherit;\n  text-transform: none;\n}\n.ontodia hr {\n  border: 0;\n  border-top: 1px solid #eee;\n  height: 0;\n}\n\n.ontodia-scrollable {\n  flex: 1 1 0px;\n  overflow-y: scroll;\n}\n\n.ontodia-scrollable > * {\n  position: relative;\n}\n\n.jstree-icon.jstree-themeicon.jstree-themeicon-custom {\n  background-size: contain !important;\n}\n\n.ontodia-default-template, .ontodia-group-template__wrap {\n  max-width: 450px;\n  float: left;\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n}\n.ontodia-default-template__thumbnail {\n  text-align: center;\n}\n.ontodia-default-template__thumbnail > img {\n  max-width: 200px;\n}\n.ontodia-default-template[data-expanded=true] .ontodia-default-template__thumbnail > img, [data-expanded=true].ontodia-group-template__wrap .ontodia-default-template__thumbnail > img {\n  max-width: 350px;\n}\n\n.ontodia-default-template_type-line, .ontodia-group-template__type-line {\n  padding: 0px 7px;\n  color: white;\n  height: 18px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  display: flex;\n  align-items: baseline;\n  margin-top: -3px;\n}\n\ndiv.ontodia-default-template_type-line__icon, div.ontodia-group-template__type-line-icon {\n  position: inherit !important;\n  margin-right: 4px;\n}\n\n.ontodia-default-template_type-line_text-container, .ontodia-group-template__type-line-text-container {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 0;\n}\n\n.ontodia-default-template_type-line_text-container__text, .ontodia-group-template__type-line-text {\n  display: inline;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.ontodia-default-template_body, .ontodia-group-template__body {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  background: white;\n  padding: 7px 10px 8px 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.ontodia-default-template_body__label, .ontodia-group-template__label {\n  font-size: 19px;\n  font-weight: 100;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0;\n  white-space: nowrap;\n  word-wrap: break-word;\n}\n\n.ontodia-default-template_body_expander {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n\n.ontodia-default-template_body_expander__iri_label {\n  font-size: 12px;\n  font-weight: 100;\n  margin-right: 15px;\n  color: #b6b6b6;\n}\n\n.ontodia-default-template_body_expander_iri {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ontodia-default-template_body_expander_iri__link {\n  color: #b6b6b6;\n}\n\n.ontodia-default-template_body_expander__hr {\n  margin: 5px 0px 5px 0px;\n}\n\n.ontodia-default-template_body_expander_property-table {\n  font-size: 15px;\n  font-weight: 100;\n  margin-bottom: 5px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.ontodia-default-template_body_expander_property-table_row {\n  white-space: nowrap;\n}\n\n.ontodia-default-template_body_expander_property-table_row__key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key_values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key_values__value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n\n.ontodia-group-template {\n  overflow: hidden;\n}\n.ontodia-group-template__wrap {\n  max-width: none;\n}\n.ontodia-group-template__body {\n  overflow: visible;\n}\n.ontodia-group-template__embedded-layer {\n  margin-top: 7px;\n}\n.ontodia-group-template .ontodia-paper__canvas {\n  border-color: #fff;\n}\n\n.ontodia-standard-template {\n  min-width: 180px;\n  max-width: 400px;\n  float: left;\n}\n.ontodia-standard-template__main {\n  border-radius: 2px;\n  border: 1px solid;\n}\n.ontodia-standard-template__body {\n  margin-left: 8px;\n  border-radius: 0 2px 2px 0;\n  border-left: 1px solid;\n  padding: 3px 0;\n  background: #fafaf9;\n}\n.ontodia-standard-template__body-horizontal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.ontodia-standard-template__body-content {\n  flex-grow: 1;\n  min-width: 0;\n  margin-right: 12px;\n}\n.ontodia-standard-template__label {\n  font-size: 19px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__thumbnail {\n  font-size: 26px;\n  margin: 5px 10px;\n  flex-shrink: 0;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ontodia-standard-template__thumbnail-image {\n  max-height: 100%;\n  max-width: 100%;\n}\n.ontodia-standard-template__thumbnail-icon {\n  max-height: 26px;\n  max-width: 26px;\n}\n.ontodia-standard-template__photo {\n  border-bottom: 1px solid;\n}\n.ontodia-standard-template__photo-image {\n  width: 100%;\n  border-radius: 2px 2px 0 0;\n}\n.ontodia-standard-template__type {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 11px;\n  font-style: italic;\n  color: #999;\n  display: flex;\n}\n.ontodia-standard-template__type-value {\n  width: 0;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__iri {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n.ontodia-standard-template__iri-key {\n  font-size: 12px;\n  margin-right: 4px;\n  color: #b6b6b6;\n}\n.ontodia-standard-template__iri-value {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__iri-value a {\n  color: #b6b6b6;\n}\n.ontodia-standard-template__hr {\n  margin: 5px 0;\n}\n.ontodia-standard-template__properties {\n  font-size: 15px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.ontodia-standard-template__propertites-row {\n  white-space: nowrap;\n}\n.ontodia-standard-template__properties-key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n.ontodia-standard-template__properties-values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ontodia-standard-template__properties-value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n.ontodia-standard-template__pinned-props {\n  border-top: 1px solid;\n  margin: 0 5px;\n}\n.ontodia-standard-template__dropdown {\n  border-radius: 2px;\n  background-color: white;\n  margin-top: 5px;\n  border: 1px solid;\n}\n.ontodia-standard-template__dropdown-content {\n  width: 100%;\n  padding: 9px;\n}\n.ontodia-standard-template__actions {\n  display: flex;\n  justify-content: space-between;\n}\n.ontodia-standard-template__actions button {\n  padding: 5px;\n  min-width: 60px;\n}", "",{"version":3,"sources":["webpack://./styles/viewUtils/_spinner.scss","webpack://./styles/main.scss","webpack://./styles/viewUtils/_clearfix.scss","webpack://./styles/viewUtils/_label.scss","webpack://./styles/viewUtils/_btn.scss","webpack://./styles/viewUtils/_btn-group.scss","webpack://./styles/viewUtils/_form-control.scss","webpack://./styles/viewUtils/_input-group.scss","webpack://./styles/viewUtils/_list-group.scss","webpack://./styles/viewUtils/_badge.scss","webpack://./styles/diagram/_elementLayer.scss","webpack://./styles/diagram/_linkLayer.scss","webpack://./styles/diagram/_paperArea.scss","webpack://./styles/diagram/animation.scss","webpack://./styles/editor/_loadingWidget.scss","webpack://./styles/editor/_authoringState.scss","webpack://./styles/widgets/_authoringTools.scss","webpack://./styles/widgets/_classTree.scss","webpack://./styles/widgets/_connectionsMenu.scss","webpack://./styles/widgets/_dialog.scss","webpack://./styles/widgets/_editForm.scss","webpack://./styles/widgets/_halo.scss","webpack://./styles/widgets/_haloLink.scss","webpack://./styles/widgets/_instancesSearch.scss","webpack://./styles/widgets/_linksToolbox.scss","webpack://./styles/widgets/_listElementView.scss","webpack://./styles/widgets/_navigator.scss","webpack://./styles/widgets/_progressBar.scss","webpack://./styles/widgets/_searchResults.scss","webpack://./styles/workspace/_accordion.scss","webpack://./styles/workspace/_resizableSidebar.scss","webpack://./styles/workspace/_tutorial.scss","webpack://./styles/workspace/_toolbar.scss","webpack://./styles/workspace/_workspace.scss","webpack://./styles/templates/_icons.scss","webpack://./styles/templates/_defaultElement.scss","webpack://./styles/templates/_group.scss","webpack://./styles/templates/_standard.scss"],"names":[],"mappings":"AACE;EACE,wCAAA;EACA,wBAAA;EACA,+DAAA;EACA,mCAAA;ACAJ;ADGE;EACE,4BAAA;ACDJ;;ADKA;EACI;IAAK,uBAAA;ECDP;EDEE;IAAO,yBAAA;ECCT;AACF;ACfE;EACE,cAAA;EACA,WAAA;ADiBJ;ACdE;EACE,WAAA;ADgBJ;;AExBA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AF2BF;;AG/BA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;EACA,oBAAA;EACA,iCAAA;AHkCF;AGhCE;EACE,mBAAA;EACA,aAAA;AHkCJ;;AG7BA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;AHgCF;AG9BE;EACE,yBAAA;AHgCJ;AG7BE;EACE,yBAAA;EACA,qBAAA;AH+BJ;AG5BE;EACE,yBAAA;EACA,qBAAA;AH8BJ;AG3BE;EACE,yBAAA;AH6BJ;;AGzBA;EACE,yBAAA;EACA,mCAAA;EACA,qBAAA;AH4BF;AG1BE;EACE,yBAAA;AH4BJ;AGzBE;EACE,qBAAA;AH2BJ;AGxBE;EACE,qBAAA;AH0BJ;AGvBE;EACE,yBAAA;AHyBJ;;AGrBA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AHwBF;AGtBE;EACE,mBAAA;AHwBJ;;AGpBA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AHuBF;AGrBE;EACE,mBAAA;AHuBJ;;AIhHA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AJmHF;AIjHE;EACE,kBAAA;EACA,WAAA;AJmHJ;AIhHE;;;;EAIE,UAAA;AJkHJ;AI/GE;;;;EAIE,iBAAA;AJiHJ;AI9GE;EACE,cAAA;AJgHJ;AI7GE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AJ+GJ;AI5GE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AJ8GJ;;AKnJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,0CAAA;ALsJF;AKpJE;EACE,qBAAA;EACA,UAAA;ALsJJ;AKnJE;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ALqJJ;;AM1KA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;AN6KF;AM3KE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AN6KJ;AM1KE;EACE,0BAAA;EACA,6BAAA;AN4KJ;;AMxKA;EACE,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AN2KF;AMzKE;EACE,yBAAA;EACA,4BAAA;EACA,UAAA;EACA,iBAAA;AN2KJ;;AO3MA;EACE,SAAA;EACA,UAAA;AP8MF;;AO3MA;EACE,gBAAA;AP8MF;;AO3MA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AP8MF;;AQ7NA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;ARgOF;;AS5OA;EACE,YAAA;EACA,aAAA;AT+OF;;AS5OA;;EAGE,sBAAA;EACA,YAAA;EACA,2DAAA;EACA,eAAA;EACA,uBAAA;AT8OF;AS3OE;;EAAM,sBAAA;AT+OR;;AS3OE;EACE,mBAAA;AT8OJ;;AS1OA;EACE,uBAAA;EACA,YAAA;AT6OF;;AUtQE;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;AVyQJ;AUvQE;EACE,iCAAA;AVyQJ;AUtQE;EACE,kBAAA;AVwQJ;AUtQE;EACE,iBAAA;AVwQJ;AUrQE;EACE,UAAA;EACA,eAAA;AVuQJ;AUtQI;EAAW,UAAA;AVyQf;AUxQI;EAAS,aAAA;AV2Qb;AUzQM;EAAW,WAAA;AV4QjB;AUzQE;EACE,YAAA;AV2QJ;AUxQE;EACE,YAAA;AV0QJ;;AW3SA;EACE,UAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AX8SF;AW5SE;EACE,UAAA;EACA,gBAAA;AX8SJ;AW3SE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AX6SJ;AW1SE;EACE,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AX4SJ;AW1SI;EACE,YAAA;AX4SN;AWxSE;EACE,gBAAA;AX0SJ;;AWtSA;EACE,kBAAA;AXySF;;AWtSA;EACE,YAAA;EACA,wBAAA;AXySF;;AYvVI;EACI,sCAAA;AZ0VR;AYxVI;EACI,gBAAA;EACA,UAAA;AZ0VR;;AYtVA;EACI,oCAAA;AZyVJ;;AapWA;EACE,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,WAAA;AbuWF;;AcjXE;EACE,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AdoXJ;AcjXE;EACE,mDAAA;EACA,YAAA;EACA,WAAA;AdmXJ;AchXE;EACE,iBAAA;EACA,iBAAA;AdkXJ;Ac/WE;EACE,cAAA;EACA,eAAA;AdiXJ;AchXI;EACE,0BAAA;AdkXN;Ac9WE;EACE,kBAAA;AdgXJ;Ac9WE;EACE,kBAAA;AdgXJ;Ac9WE;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;AdgXJ;;AezZA;EACE,YAAA;Af4ZF;Ae1ZE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;Af4ZJ;AezZE;EACE,YAAA;EACA,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;Af2ZJ;;AgB5aA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AhB+aF;AgB7aE;EACE,cAAA;EACA,qBAAA;AhB+aJ;AgB5aE;EACE,iBAAA;EACA,kBAAA;AhB8aJ;AgB3aE;EACE,cAAA;EACA,eAAA;AhB6aJ;AgB1aE;EACE,wCAAA;AhB4aJ;AgBzaE;EACE,kBAAA;EACA,iCAAA;EACA,YAAA;AhB2aJ;;AgBvaA;EACE,aAAA;AhB0aF;AgBxaE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AhB0aJ;AgBzaI;EAAM,cAAA;AhB4aV;AgBzaE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AhB2aJ;AgB1aI;EACE,4CAAA;EACA,qBAAA;EACA,eAAA;AhB4aN;AgB1aI;EACE,yBAAA;EACA,qBAAA;AhB4aN;AgBxaE;EACE,YAAA;AhB0aJ;AgBvaE;EACE,cAAA;EACA,YAAA;AhByaJ;AgBtaE;EACE,gBAAA;EACA,YAAA;AhBwaJ;AgBraE;EACE,iBAAA;AhBuaJ;AgBpaE;EACE,gBAAA;AhBsaJ;AgBnaE;EACE,iBAAA;AhBqaJ;AgBlaE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AhBoaJ;AgBjaE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AhBmaJ;AgBlaI;EACE,4CAAA;EACA,eAAA;AhBoaN;AgBhaE;EACE,cAAA;EACA,YAAA;AhBkaJ;AgB/ZE;EACE,gBAAA;AhBiaJ;AgBhaI;EACE,YAAA;AhBkaN;;AiBlhBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AjBqhBF;AiBnhBE;EACE,aAAA;AjBqhBJ;AiBlhBE;EACE,cAAA;EACA,UAAA;AjBohBJ;AiBjhBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AjBmhBJ;AiBjhBI;EACE,UAAA;AjBmhBN;AiB/gBE;EACE,cAAA;AjBihBJ;;AiB7gBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AjBghBF;;AiB7gBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AjBghBF;;AiB7gBA;EACE,cAAA;EACA,iBAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,SAAA;AjBghBF;;AiB7gBA;EACE,aAAA;EACA,mBAAA;AjBghBF;;AiB7gBA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AjBghBF;;AiB9gBA;EACE,sBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AjBihBF;;AiB9gBA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AjBihBF;AiB/gBE;EACE,yBAAA;AjBihBJ;;AiB7gBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AjBghBF;AiB9gBE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AjBghBJ;AiB7gBE;EACE,cAAA;EACA,iBAAA;AjB+gBJ;AiB5gBE;EACE,YAAA;EACA,yDAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AjB8gBJ;AiB7gBI;EAAU,UAAA;AjBghBd;AiB7gBE;EACE,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AjB+gBJ;AiB9gBI;EAAU,UAAA;AjBihBd;AiB9gBE;EACE,yBAAA;AjBghBJ;;AiB5gBA;EACI,qCAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AjB+gBJ;;AiB5gBA;EACE,iEAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;AjB+gBF;;AiB5gBA;EACE,iEAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;AjB+gBF;;AiB5gBA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AjB+gBF;;AiB5gBA;EACE,gBAAA;EACA,mBAAA;AjB+gBF;;AiB5gBA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AjB+gBF;;AiB5gBA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;AjB+gBJ;AiB7gBI;EACE,iBAAA;AjB+gBN;AiB9gBM;EAAa,YAAA;AjBihBnB;;AiB7gBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AjBghBF;;AiB7gBA;EACE,WAAA;EACA,YAAA;AjBghBF;;AiB7gBA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AjBghBF;;AiB7gBA;EACE,sBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AjBghBF;;AiB7gBA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AjBghBF;AiB9gBE;EACE,0BAAA;AjBghBJ;;AkBlyBA;EACE,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AlBqyBF;AkBnyBE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlBqyBJ;AkBlyBE;EACE,+DAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,YAAA;EACA,gBAAA;AlBmyBJ;AkBjyBI;EACE,UAAA;AlBmyBN;;AkB9xBA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,qEAAA;EACA,mBAAA;AlBiyBF;AkB/xBE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,qEAAA;AlBiyBJ;AkB9xBE;EACE,oEAAA;AlBgyBJ;;AkB5xBA;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;AlB+xBF;AkB7xBE;EACE,YAAA;AlB+xBJ;;AkB3xBA;EACE,SAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AlB8xBF;;AkB3xBA;EACE,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AlB8xBF;;AmBx3BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AnB23BF;AmBz3BE;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AnB23BJ;AmBx3BE;EACE,0BAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AnB03BJ;AmBv3BE;EACE,iBAAA;AnBy3BJ;AmBt3BE;EACE,cAAA;EACA,mBAAA;AnBw3BJ;AmBr3BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AnBu3BJ;AmBp3BE;EACE,cAAA;EACA,kBAAA;AnBs3BJ;AmBn3BE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;AnBq3BJ;AmBl3BE;EACE,kBAAA;AnBo3BJ;AmBj3BE;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AnBm3BJ;AmBh3BE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AnBk3BJ;AmB/2BE;EACE,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AnBi3BJ;AmB/2BI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AnBi3BN;AmB92BI;EACE,UAAA;AnBg3BN;AmB72BI;EACE,WAAA;AnB+2BN;AmB32BE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AnB62BJ;AmB12BE;EACE,kBAAA;EACA,oBAAA;AnB42BJ;AmBz2BE;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AnB22BJ;;AoBr9BA;EACE,kBAAA;EACA,oBAAA;EAEA,4BAAA;EACA,kBAAA;EACA,mCAAA;ApBu9BF;AoBr4BE;EA3EE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAkCA,QAAA;EACA,iBAAA;EACA,YAAA;ApBi7BJ;AoBp9BI;EACE,UAAA;ApBs9BN;AoBn9BI;EACE,mBAAA;EACA,YAAA;ApBq9BN;AoB35BI;EACE,yDAAA;ApB65BN;AoB15BI;EACE,yDAAA;ApB45BN;AoBx5BE;EAxFE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAwCA,QAAA;EACA,iBAAA;EACA,WAAA;EAoCA,yDAAA;ApBw6BJ;AoBr/BI;EACE,UAAA;ApBu/BN;AoBp/BI;EACE,mBAAA;EACA,YAAA;ApBs/BN;AoB56BE;EA/FE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EA6BA,UAAA;EACA,YAAA;EAsDA,yDAAA;ApB47BJ;AoB/gCI;EACE,UAAA;ApBihCN;AoB9gCI;EACE,mBAAA;EACA,YAAA;ApBghCN;AoBh8BE;EArGE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EA8CA,aAAA;EACA,SAAA;EACA,kBAAA;ApB0/BJ;AoBziCI;EACE,UAAA;ApB2iCN;AoBxiCI;EACE,mBAAA;EACA,YAAA;ApB0iCN;AoBt9BI;EACE,0DAAA;ApBw9BN;AoBr9BI;EACE,0DAAA;ApBu9BN;AoBn9BE;EAlHE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAyDA,aAAA;EACA,YAAA;EA6CA,yDAAA;ApBm+BJ;AoBzkCI;EACE,UAAA;ApB2kCN;AoBxkCI;EACE,mBAAA;EACA,YAAA;ApB0kCN;AoBv+BE;EAxHE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAkBA,UAAA;EACA,SAAA;EACA,kBAAA;EAyFA,0DAAA;ApBw/BJ;AoBpmCI;EACE,UAAA;ApBsmCN;AoBnmCI;EACE,mBAAA;EACA,YAAA;ApBqmCN;AoB5/BE;EA9HE,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,WAfY;EAgBZ,YAfa;EAiBb,YAAA;EACA,wBAAA;EAoDA,aAAA;EACA,WAAA;EA8DA,0DAAA;ApB4gCJ;AoB9nCI;EACE,UAAA;ApBgoCN;AoB7nCI;EACE,mBAAA;EACA,YAAA;ApB+nCN;AoBhhCE;EA1GE,kBAAA;EACA,WAhCY;EAiCZ,YAhCa;EAsEb,aAAA;EACA,WAAA;ApBwlCJ;;AqBtqCE;EACE,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;ArByqCJ;AqBvqCI;EACE,UAAA;ArByqCN;AqBtqCI;EACE,mBAAA;EACA,YAAA;ArBwqCN;AqB1pCE;EATE,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EAKA,0DAAA;ArBkqCJ;AqB/pCE;EAdE,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EAUA,0DAAA;ArBuqCJ;AqBpqCE;EACE,kBAAA;ArBsqCJ;AqBnqCE;EACE,0EAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;ArBqqCJ;AqBnqCI;EACE,UAAA;ArBqqCN;;AsBhuCA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AtBmuCF;AsBjuCE;EACE,cAAA;EACA,qBAAA;AtBmuCJ;AsBhuCE;EACE,kBAAA;EACA,mBAAA;AtBkuCJ;AsBjuCI;EAAU,gBAAA;AtBouCd;AsBjuCE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AtBmuCJ;AsBhuCE;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;AtBkuCJ;AsB/tCE;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;AtBiuCJ;AsB9tCE;EACE,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,qBAAA;AtBguCJ;AsB7tCE;EACE,WAAA;EACA,YAAA;AtB+tCJ;AsB5tCE;EACE,YAAA;EACA,sBAAA;AtB8tCJ;AsB3tCE;EAAmB,cAAA;AtB8tCrB;AsB5tCE;EACE,yBAAA;EACA,wCAAA;AtB8tCJ;AsB3tCE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;AtB6tCJ;AsB1tCE;EACE,yDAAA;EACA,kBAAA;AtB4tCJ;AsBztCE;EAAc,oBAAA;AtB4tChB;AsB3tCE;EACE,WAAA;AtB6tCJ;;AuBvyCA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AvB0yCF;AuBxyCE;EACE,aAAA;AvB0yCJ;AuBvyCE;EACE,aAAA;EACA,mBAAA;AvByyCJ;AuBtyCE;EACE,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AvBwyCJ;AuBryCE;EACE,eAAA;AvBuyCJ;AuBpyCE;EACE,6BAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AvBsyCJ;;AuBlyCA;EACE,cAAA;EACA,sBAAA,EAAA,aAAA;AvBqyCF;;AuBlyCA;EACE,gBAAA;AvBqyCF;;AuBnyCA;EACE,kBAAA;AvBsyCF;;AuBpyCA;EACE,wBAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;AvBuyCF;;AuBpyCA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AvBuyCF;;AuBryCA;EACE,mBAAA;AvBwyCF;;AuBryCA;EACE,kBAAA;EACA,sBAAA;AvBwyCF;;AuBpyCE;EAAU,eAAA;AvBwyCZ;AuBtyCE;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AvBwyCJ;AuBryCE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AvBuyCJ;AuBpyCE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AvBsyCJ;AuBnyCE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AvBqyCJ;AuBlyCE;EACE,gCAAA;AvBoyCJ;AuBjyCE;EACE,aAAA;EACA,YAAA;EACA,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AvBmyCJ;AuBjyCE;EACE,UAAA;EACA,6BAAA;AvBmyCJ;;AuB/xCA;EACE,oEAAA;EACA,eAAA;AvBkyCF;;AuBhyCA;EACE,2DAAA;EACA,eAAA;AvBmyCF;;AwBp6CA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AxBu6CF;AwBr6CE;EACE,YAAA;EACA,eAAA;AxBu6CJ;AwBp6CE;EACE,iBAAA;EACA,0BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AxBs6CJ;;AwBl6CA;EACE,iBAAA;AxBq6CF;;AyBl8CA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EAQA,gBAAA;EACA,sBAAA;EACA,iDAAA;EAGA,mCAAA;AzB47CF;AyBr8CE;EACE,uBAAA;AzBu8CJ;AyB77CE;EACE,WAAA;EACA,YAAA;AzB+7CJ;AyB57CE;EACE,wBAAA;AzB87CJ;AyB57CE;EAAuB,UAAA;AzB+7CzB;AyB97CE;EAAwB,UAAA;AzBi8C1B;AyB/7CE;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EAEA,YAAA;EACA,wBAAA;AzBg8CJ;AyB97CI;EAEE,UAAA;AzB+7CN;AyB57CE;EACE,QAAA;EACA,SAAA;AzB87CJ;AyB57CE;EACE,QAAA;EACA,SAAA;AzB87CJ;AyB37CE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;AzB67CJ;AyB37CE;EACE,0DAAA;AzB67CJ;AyB37CE;EACE,0DAAA;AzB67CJ;;A0B9/CA;EACE;IACE,2BAAA;E1BigDF;E0B//CA;IACE,wBAAA;E1BigDF;AACF;A0B9/CA;EACE,cAAA;EACA,sBAAA,EAAA,aAAA;EACA,WAAA;EAEA,yBAAA;EACA,sEAAA;EACA,2BAAA;EACA,gBAAA;EACA,8CAAA;A1B+/CF;A0B7/CE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EAEA,yBAAA;EACA,qMAAA;EACA,2BAAA;EACA,0BAAA;EAEA,0DAAA;A1B6/CJ;A0B1/CE;EAEE,qCAAA;EACA,8BAAA;A1B2/CJ;A0Bx/CE;EACE,yBAAA;A1B0/CJ;A0Bv/CE;EACE,qCAAA;EACA,4BAAA;A1By/CJ;;A2B1iDA;EACE,SAAA;EACA,UAAA;EACA,aAAA;A3B6iDF;;A4BhjDA;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;A5BmjDF;A4BjjDE;EACE,cAAA;A5BmjDJ;A4BhjDE;EACE,sBAAA;A5BkjDJ;A4B/iDE;EACE,mCAAA;A5BijDJ;;A4B7iDA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;A5BgjDF;A4B9iDE;EACE,8BAAA;A5BgjDJ;A4B7iDE;EACE,+BAAA;A5B+iDJ;A4B7iDI;EACE,mBAAA;A5B+iDN;A4B3iDE;EACE,iCAAA;A5B6iDJ;A4B3iDI;EACE,qBAAA;A5B6iDN;A4BziDE;EACE,kBAAA;EACA,UAAA;A5B2iDJ;A4BxiDE;EACE,WAAA;EACA,cAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;A5B0iDJ;A4BviDE;EACE,YAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;A5ByiDJ;A4BtiDE;EACE,gBAAA;EACA,sBAAA;EACA,gFAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A5BwiDJ;A4BtiDI;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,2BAAA;A5BwiDN;A4BriDI;EACE,gBAAA;A5BuiDN;A4BniDE;EACE,UAAA;EACA,kBAAA;A5BqiDJ;A4BpiDI;EAAW,0DAAA;A5BuiDf;A4BtiDI;EAAiB,0DAAA;A5ByiDrB;A4BtiDE;EACE,WAAA;EACA,mBAAA;A5BwiDJ;A4BviDI;EAAW,0DAAA;A5B0iDf;A4BziDI;EAAiB,0DAAA;A5B4iDrB;A4BziDE;EACE,yBAAA;A5B2iDJ;A4BxiDE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;A5B0iDJ;A4BviDE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;A5ByiDJ;A4BtiDE;EACE,kBAAA;EACA,kBAAA;EAEA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;A5BuiDJ;A4BriDI;EACE,6BAAA;EACA,oCAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EAEA,wBAAA;EACA,qBAAA;EACA,gBAAA;A5BsiDN;A4BliDE;EACE,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;A5BoiDJ;A4BjiDE;EACE,aAAA;A5BmiDJ;;A6B3sDE;;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;A7B+sDJ;A6B5sDE;;EACE,YAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;A7B+sDJ;;A6B3sDA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;A7B8sDF;A6B5sDE;EACE,gEAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;A7B8sDJ;A6B3sDE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;A7B6sDJ;A6B3sDI;EACE,wBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;A7B6sDN;A6B1sDI;EACE,mBAAA;EACA,qBAAA;A7B4sDN;A6BvsDI;EAAY,yBAAA;A7B0sDhB;A6BvsDE;EAAiB,iBAAA;A7B0sDnB;A6BzsDE;EAA2B,WAAA;A7B4sD7B;A6B1sDI;EAAY,0DAAA;A7B6sDhB;A6B5sDI;EAAkB,0DAAA;A7B+sDtB;A6B5sDE;EAAkB,gBAAA;A7B+sDpB;A6B9sDE;EAA4B,UAAA;A7BitD9B;A6B/sDI;EAAY,0DAAA;A7BktDhB;A6BjtDI;EAAkB,0DAAA;A7BotDtB;A6BjtDE;EAAgB,kBAAA;A7BotDlB;A6BntDE;EAA0B,YAAA;A7BstD5B;A6BptDI;EAAY,0DAAA;A7ButDhB;A6BttDI;EAAkB,0DAAA;A7BytDtB;A6BttDE;EAAmB,eAAA;A7BytDrB;A6BxtDE;EAA6B,SAAA;A7B2tD/B;A6BztDI;EAAY,0DAAA;A7B4tDhB;A6B3tDI;EAAkB,0DAAA;A7B8tDtB;;A8Bv0DA;EACE,WAAA;EACA,+DAAA;EACA,eAAA;EACA,oBAAA;A9B00DF;;A+B70DE;EACE,YAAA;EACA,eAAA;A/Bg1DJ;A+B90DI;EACE,iBAAA;A/Bg1DN;A+B/0DM;EAAS,sBAAA;A/Bk1Df;A+B90DE;EACE,cAAA;A/Bg1DJ;A+B70DE;EACE,wBAAA;EACA,4BAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;A/B+0DJ;A+B50DE;EACE,0DAAA;A/B80DJ;A+B30DE;EACE,0DAAA;A/B60DJ;A+B10DE;EACE,qBAAA;A/B40DJ;A+Bz0DE;EACE,0DAAA;A/B20DJ;A+Bx0DE;EACE,0DAAA;A/B00DJ;;A+Br0DE;EACE,WAAA;EACA,YAAA;EACA,WAAA;A/Bw0DJ;A+Bt0DI;EACE,iBAAA;A/Bw0DN;A+Br0DI;EACE,YAAA;A/Bu0DN;;A+Bl0DA;EACE,+BAAA;A/Bq0DF;;A+Bl0DA;EACE,iBAAA;A/Bq0DF;;A+Bl0DA;EACE,eAAA;EACA,kBAAA;A/Bq0DF;;AgC74DA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,+DAAA;EACA,eAAA;EACA,oBAAA;AhC+4DF;AgC74DE;EACE,mBAAA;AhC+4DJ;AgC54DE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AhC84DJ;AgC34DE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AhC64DJ;AgC14DE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;AhC44DJ;AgCz4DE;EACE,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AhC24DJ;AgCx4DE;EAA2B,4BAAA;AhC24D7B;AgC14DE;EAAyB,4BAAA;AhC64D3B;AgC34DE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AhC64DJ;AgC14DE;EACE,cAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;AhC44DJ;AgCz4DE;EACE,SAAA;EACA,0BAAA;EACA,SAAA;AhC24DJ;;AgCv4DA;EACE,aAAA;EACA,kBAAA;AhC04DF;;AgCt4DA;EACE,kBAAA;AhCy4DF;;AiCt9DA;EACE,mCAAA;AjCy9DF;;AkC19DA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AlC69DF;AkC39DE;EACE,kBAAA;AlC69DJ;AkC59DI;EACE,gBAAA;AlC89DN;AkC19DE;EACE,gBAAA;AlC49DJ;;AkCx9DA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AlC29DF;;AkCx9DA;EACE,4BAAA;EACA,iBAAA;AlC29DF;;AkCx9DA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,QAAA;AlC29DF;;AkCz9DA;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AlC49DF;;AkCz9DA;EACE,+BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AlC49DF;;AkCz9DA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AlC49DF;;AkCz9DA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AlC49DF;;AkCz9DA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AlC49DF;;AkCz9DA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AlC49DF;;AkCz9DA;EACE,cAAA;AlC49DF;;AkCz9DA;EACE,uBAAA;AlC49DF;;AkCz9DA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlC49DF;;AkCz9DA;EACE,mBAAA;AlC49DF;;AkCz9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AlC49DF;;AkCz9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AlC49DF;;AkCz9DA;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AlC49DF;;AkCz9DA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AlC49DF;;AmCvmEA;EACE,gBAAA;AnC0mEF;AmCxmEE;EAEE,eAAA;AnCymEJ;AmCtlEE;EAEE,iBAAA;AnCulEJ;AmChlEE;EACE,eAAA;AnCklEJ;AmC/kEE;EACE,kBAAA;AnCilEJ;;AoCvnEA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;ApC0nEF;AoCxnEE;EACE,kBAAA;EACA,iBAAA;ApC0nEJ;AoCvnEE;EACE,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;ApCynEJ;AoCtnEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ApCwnEJ;AoCrnEE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;ApCunEJ;AoCpnEE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ApCsnEJ;AoCnnEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ApCqnEJ;AoClnEE;EACE,gBAAA;EACA,eAAA;ApConEJ;AoCjnEE;EACE,gBAAA;EACA,eAAA;ApCmnEJ;AoChnEE;EACE,wBAAA;ApCknEJ;AoC/mEE;EACE,WAAA;EACA,0BAAA;ApCinEJ;AoC9mEE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ApCgnEJ;AoC7mEE;EACE,QAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;ApC+mEJ;AoC5mEE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;ApC8mEJ;AoC3mEE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ApC6mEJ;AoC1mEE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ApC4mEJ;AoCzmEE;EACE,cAAA;ApC2mEJ;AoCxmEE;EACE,aAAA;ApC0mEJ;AoCvmEE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ApCymEJ;AoCtmEE;EACE,mBAAA;ApCwmEJ;AoCrmEE;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;ApCumEJ;AoCpmEE;EACE,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;ApCsmEJ;AoCnmEE;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;ApCqmEJ;AoClmEE;EACE,qBAAA;EACA,aAAA;ApComEJ;AoCjmEE;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;ApCmmEJ;AoChmEE;EACE,WAAA;EACA,YAAA;ApCkmEJ;AoC/lEE;EACE,aAAA;EACA,8BAAA;ApCimEJ;AoChmEI;EACE,YAAA;EACA,eAAA;ApCkmEN","sourcesContent":[".ontodia-spinner {\r\n  &__arrow {\r\n    animation-name: ontodia-spinner-rotation;\r\n    animation-duration: 1.5s;\r\n    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n    animation-iteration-count: infinite;\r\n  }\r\n\r\n  &[data-error='true'] &__arrow {\r\n    animation-iteration-count: 1;\r\n  }\r\n}\r\n\r\n@keyframes ontodia-spinner-rotation {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n",".ontodia-spinner__arrow {\n  animation-name: ontodia-spinner-rotation;\n  animation-duration: 1.5s;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-iteration-count: infinite;\n}\n.ontodia-spinner[data-error=true] .ontodia-spinner__arrow {\n  animation-iteration-count: 1;\n}\n\n@keyframes ontodia-spinner-rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.clearfix:before, .clearfix:after {\n  display: table;\n  content: \"\";\n}\n.clearfix:after {\n  clear: both;\n}\n\n.ontodia-label {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.ontodia-btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  text-transform: none;\n  transition: background-color 0.3s;\n}\n.ontodia-btn[disabled] {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.ontodia-btn-default {\n  background-color: #fff;\n  border-color: #ccc;\n  color: #333;\n}\n.ontodia-btn-default:hover {\n  background-color: #e0e0e0;\n}\n.ontodia-btn-default.active {\n  background-color: #e0e0e0;\n  border-color: #dbdbdb;\n}\n.ontodia-btn-default.active:hover {\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n.ontodia-btn-default[disabled], .ontodia-btn-default[disabled]:hover, .ontodia-btn-default[disabled].active, .ontodia-btn-default[disabled].active:hover {\n  background-color: #e0e0e0;\n}\n\n.ontodia-btn-primary {\n  color: rgb(255, 255, 255);\n  background-color: rgb(51, 122, 183);\n  border-color: #245580;\n}\n.ontodia-btn-primary:hover, .ontodia-btn-primary:focus, .ontodia-btn-primary:active {\n  background-color: #265a88;\n}\n.ontodia-btn-primary:hover, .ontodia-btn-primary:focus {\n  border-color: #204d74;\n}\n.ontodia-btn-primary.active {\n  border-color: #245580;\n}\n.ontodia-btn-primary[disabled], .ontodia-btn-primary[disabled]:hover, .ontodia-btn-primary[disabled]:focus, .ontodia-btn-primary[disabled]:active, .ontodia-btn-primary[disabled].active {\n  background-color: #265a88;\n}\n\n.ontodia-btn-success {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n  transition: 0.3s;\n}\n.ontodia-btn-success:hover {\n  background: #47a447;\n}\n\n.ontodia-btn-danger {\n  background-color: #c9302c;\n  border-color: #c9302c;\n  color: #fff;\n  transition: 0.3s;\n}\n.ontodia-btn-danger:hover {\n  background: #a82825;\n}\n\n.ontodia-btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ontodia-btn-group > .ontodia-btn, .ontodia-btn-group > .ontodia-btn-group {\n  position: relative;\n  float: left;\n}\n.ontodia-btn-group > .ontodia-btn:hover,\n.ontodia-btn-group > .ontodia-btn:focus,\n.ontodia-btn-group > .ontodia-btn.active,\n.ontodia-btn-group > .ontodia-btn.active:hover {\n  z-index: 2;\n}\n.ontodia-btn-group .ontodia-btn + .ontodia-btn,\n.ontodia-btn-group .ontodia-btn + .ontodia-btn-group,\n.ontodia-btn-group .ontodia-btn-group + .ontodia-btn,\n.ontodia-btn-group .ontodia-btn-group + .ontodia-btn-group {\n  margin-left: -1px;\n}\n.ontodia-btn-group > .ontodia-btn:first-child {\n  margin-left: 0;\n}\n.ontodia-btn-group-sm > .ontodia-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 5px 10px;\n}\n.ontodia-btn-group-xs > .ontodia-btn {\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 1px 5px;\n}\n\n.ontodia-form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  margin: 0;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background: #fff;\n  border: 1px solid #ccc;\n  transition: border-color ease-in-out 0.15s;\n}\n.ontodia-form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n}\n.ontodia-form-control:disabled {\n  background-color: #eee;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.ontodia-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.ontodia-input-group .ontodia-form-control {\n  display: table-cell;\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.ontodia-input-group .ontodia-form-control:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.ontodia-input-group-btn {\n  display: table-cell;\n  width: 1%;\n  vertical-align: middle;\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.ontodia-input-group-btn:last-child > .ontodia-btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  z-index: 2;\n  margin-left: -1px;\n}\n\n.ontodia-list-group {\n  margin: 0;\n  padding: 0;\n}\n\n.ontodia-list-group-item:last-child {\n  margin-bottom: 0;\n}\n\n.ontodia-list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.ontodia-badge {\n  display: inline-block;\n  min-width: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: rgb(119, 119, 119);\n  padding: 3px 7px;\n  border-radius: 10px;\n}\n\n.ontodia-overlayed-element {\n  cursor: move;\n  outline: none;\n}\n\n.ontodia-overlayed-element,\n.ontodia-exported-element {\n  box-sizing: border-box;\n  color: black;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n}\n.ontodia-overlayed-element img,\n.ontodia-exported-element img {\n  vertical-align: middle;\n}\n\n.ontodia-exported-element *, .ontodia-exported-element *:before, .ontodia-exported-element *:after {\n  box-sizing: inherit;\n}\n\n.ontodia-overlayed-element--blurred {\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n\n.ontodia-link__wrap {\n  stroke-width: 12px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke: transparent;\n  fill: none;\n}\n.ontodia-link:hover .ontodia-link__wrap {\n  stroke: rgba(140, 140, 140, 0.44);\n}\n.ontodia-link__vertex {\n  cursor: all-scroll;\n}\n.ontodia-link:not(:hover) .ontodia-link__vertex {\n  fill: transparent;\n}\n.ontodia-link__vertex-tools {\n  opacity: 0;\n  cursor: pointer;\n}\n.ontodia-link__vertex-tools > circle {\n  fill: gray;\n}\n.ontodia-link__vertex-tools > path {\n  stroke: white;\n}\n.ontodia-link__vertex-tools:hover > circle {\n  fill: black;\n}\n.ontodia-link:hover .ontodia-link__vertex-tools {\n  opacity: 0.8;\n}\n.ontodia-link--blurred {\n  opacity: 0.5;\n}\n\n.ontodia-paper-area {\n  flex: auto;\n  width: 0;\n  display: flex;\n  position: relative;\n  cursor: default;\n  background: #fff;\n}\n.ontodia-paper-area__area {\n  flex: auto;\n  overflow: hidden;\n}\n.ontodia-paper-area__widgets {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.ontodia-paper-area__watermark {\n  background-size: cover;\n  width: 8%;\n  max-width: 130px;\n  min-width: 50px;\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n.ontodia-paper-area__watermark:hover {\n  opacity: 0.5;\n}\n.ontodia-paper-area--hide-scrollbars {\n  overflow: hidden;\n}\n\n.ontodia-paper {\n  position: relative;\n}\n\n.ontodia-exported-watermark {\n  opacity: 0.3;\n  transition: opacity 0.3s;\n}\n\n.ontodia-paper-area--animated .ontodia-overlayed-element {\n  transition: transform 0.5s ease-in-out;\n}\n.ontodia-paper-area--animated .ontodia-link-layer, .ontodia-paper-area--animated .ontodia-paper-area__widgets {\n  transition: none;\n  opacity: 0;\n}\n\n.ontodia-link-layer, .ontodia-paper-area__widgets {\n  transition: opacity 0.5s ease-in-out;\n}\n\n.ontodia-loading-widget {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n}\n\n.ontodia-authoring-state__item-error {\n  align-self: flex-end;\n  margin: 0px 5px;\n  display: flex;\n  align-items: center;\n  cursor: help;\n}\n.ontodia-authoring-state__item-error-icon {\n  background: url(\"../images/font-awesome/exclamation-triangle.svg\");\n  height: 15px;\n  width: 17px;\n}\n.ontodia-authoring-state__state-label {\n  font-weight: bold;\n  margin-right: 5px;\n}\n.ontodia-authoring-state__state-cancel {\n  color: #3f87a6;\n  cursor: pointer;\n}\n.ontodia-authoring-state__state-cancel:hover {\n  text-decoration: underline;\n}\n.ontodia-authoring-state__state-indicator {\n  position: absolute;\n}\n.ontodia-authoring-state__state-indicator-container {\n  position: relative;\n}\n.ontodia-authoring-state__state-indicator-body {\n  position: absolute;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 5px;\n}\n\n.ontodia-authoring-tools {\n  margin: 10px;\n}\n.ontodia-authoring-tools__create-entity {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  white-space: normal;\n}\n.ontodia-authoring-tools__type-label {\n  color: black;\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n\n.ontodia-class-tree {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-class-tree__filter {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.ontodia-class-tree__filter-group {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.ontodia-class-tree__only-creatable {\n  display: block;\n  margin-top: 5px;\n}\n.ontodia-class-tree__tree {\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.ontodia-class-tree__spinner {\n  align-self: center;\n  /* center vertically in flexbox */\n  margin: auto;\n}\n\n.ontodia-class-leaf {\n  margin: 1px 0;\n}\n.ontodia-class-leaf__row {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  user-select: none;\n}\n.ontodia-class-leaf__row > * {\n  flex-shrink: 0;\n}\n.ontodia-class-leaf__body {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-size: 15px;\n  padding: 1px;\n  border: 1px solid;\n  border-color: transparent;\n}\n.ontodia-class-leaf__body:hover {\n  background: rgba(220, 235, 255, 0.568627451);\n  border-color: #ccefff;\n  cursor: pointer;\n}\n.ontodia-class-leaf__body--selected {\n  background-color: #beebff;\n  border-color: #8edcff;\n}\n.ontodia-class-leaf__icon-container {\n  height: 20px;\n}\n.ontodia-class-leaf__icon {\n  display: block;\n  height: 100%;\n}\n.ontodia-class-leaf__label {\n  margin-left: 5px;\n  color: black;\n}\n.ontodia-class-leaf__highlighted-term {\n  font-weight: bold;\n}\n.ontodia-class-leaf__count {\n  margin-left: 5px;\n}\n.ontodia-class-leaf__children {\n  margin-left: 20px;\n}\n.ontodia-class-leaf__no-toggle {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n}\n.ontodia-class-leaf__toggle {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin: 5px;\n}\n.ontodia-class-leaf__toggle:hover:not(:empty) {\n  background: rgba(220, 235, 255, 0.568627451);\n  cursor: pointer;\n}\n.ontodia-class-leaf__toggle-icon {\n  display: block;\n  height: 100%;\n}\n.ontodia-class-leaf__create {\n  margin-left: 5px;\n}\n.ontodia-class-leaf__create > button {\n  cursor: move;\n}\n\n.ontodia-connections-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-connections-menu__sort-switch {\n  display: none;\n}\n.ontodia-connections-menu__sort-switch:checked + .ontodia-connections-menu__sort-switch-label {\n  color: #337ab7;\n  opacity: 1;\n}\n.ontodia-connections-menu__sort-switch-label {\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  opacity: 0.4;\n  text-align: center;\n}\n.ontodia-connections-menu__sort-switch-label:hover {\n  opacity: 1;\n}\n.ontodia-connections-menu__search-line-input {\n  flex: 1 1 100%;\n}\n\n.ontodia-connections-menu_bread-crumbs {\n  padding: 10px;\n  padding-bottom: 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 27px;\n  min-height: 27px;\n  flex-grow: 0;\n}\n\n.ontodia-connections-menu__title-label {\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n\n.ontodia-connections-menu_search-line {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.ontodia-connections-menu_search-line-sort-switches {\n  flex: 0 0 20px;\n  margin-left: 10px;\n}\n\n.ontodia-connections-menu_links-list {\n  padding: 5px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-top: 1px solid #dbdbdb;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.ocm_links-list-empty {\n  display: flex;\n  align-items: center;\n}\n\n.ontodia-connections-menu_links-list__empty {\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n  text-align: center;\n}\n\n.ontodia-connections-menu__loading,\n.ontodia-connections-menu__error {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n}\n\n.ontodia-connections-menu__loading-objects {\n  border: 1px solid gray;\n  flex-grow: 1;\n  box-shadow: inset 0px 0px 23px -8px gray;\n  background-color: whitesmoke;\n  position: relative;\n  font-size: x-large;\n  display: flex;\n  color: #cbcbcb;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n\n.ontodia-connections-menu__move-to-filter {\n  display: flex;\n  padding: 5px 10px;\n  user-select: none;\n  cursor: pointer;\n}\n.ontodia-connections-menu__move-to-filter:hover {\n  background-color: #e6e6e6;\n}\n\n.link-in-popup-menu {\n  display: flex;\n  overflow: hidden;\n  padding: 0 5px 0 0;\n  align-items: center;\n  margin-bottom: 4px;\n  background: #f7f7f7;\n}\n.link-in-popup-menu__link-title {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 5px 0px 5px 5px;\n}\n.link-in-popup-menu__count {\n  flex-shrink: 0;\n  margin-left: 10px;\n}\n.link-in-popup-menu__navigate-button {\n  float: right;\n  background-image: url(\"../images/expand-link.png\");\n  width: 16px;\n  height: 16px;\n  opacity: 0.5;\n  margin-left: 10px;\n  min-width: 16px;\n  background-size: cover;\n}\n.link-in-popup-menu__navigate-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu__filter-button {\n  background-image: url(\"../images/add-to-filter.png\");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  opacity: 0.4;\n  margin-left: 10px;\n}\n.link-in-popup-menu__filter-button:hover {\n  opacity: 1;\n}\n.link-in-popup-menu:hover {\n  background-color: #e2e2e2;\n}\n\n.link-in-popup-menu_direction {\n  background: rgba(219, 219, 219, 0.35);\n  min-height: 30px;\n  padding: 5px 0px 5px 10px;\n  display: flex;\n  align-items: center;\n}\n\n.link-in-popup-menu_direction__in-direction {\n  background: url(\"../images/direction-in.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 14px 0 0;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.link-in-popup-menu_direction__out-direction {\n  background: url(\"../images/direction-out.png\") 0 0 no-repeat;\n  flex-shrink: 0;\n  width: 22px;\n  height: 15px;\n  margin: 0 8px 0 6px;\n  background-size: contain;\n  opacity: 0.5;\n}\n\n.ontodia-connections-menu_links-list__loading {\n  text-align: center;\n  width: 100%;\n  position: relative;\n  font-size: x-large;\n  color: #cbcbcb;\n}\n\n.ontodia-connections-menu_links-list__hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.ontodia-connections-menu_objects-panel {\n  flex-grow: 1;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n\n.ontodia-connections-menu_objects-panel__select-all {\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n}\n.ontodia-connections-menu_objects-panel__select-all input {\n  margin-right: 5px;\n}\n.ontodia-connections-menu_objects-panel__select-all input:disabled {\n  opacity: 0.3;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel {\n  height: 25px;\n  white-space: nowrap;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel__count-label {\n  height: 25px;\n  float: left;\n  padding: 0px 5px;\n  font-size: larger;\n  display: flex;\n  align-items: center;\n  max-width: 60%;\n}\n\n.ontodia-connections-menu_objects-panel_bottom-panel__extra-elements {\n  color: gray;\n  cursor: help;\n}\n\n.ontodia-btn.ontodia-connections-menu_objects-panel_bottom-panel__add-button {\n  height: 25px;\n  padding-top: 1px;\n  padding-bottom: 2px;\n}\n\n.ontodia-connections-menu_objects-panel_objects-list {\n  border: 1px solid gray;\n  height: 0;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding: 5px;\n  margin-bottom: 5px;\n}\n\n.ontodia-connections-menu__link {\n  color: #337ab7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.ontodia-connections-menu__link:hover {\n  text-decoration: underline;\n}\n\n.ontodia-dialog {\n  background: #fff;\n  border: 1px solid #333;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  position: absolute;\n}\n.ontodia-dialog__caption {\n  font-weight: bold;\n  position: absolute;\n  top: -11px;\n  left: 10px;\n  background: white;\n  padding-left: 3px;\n  padding-right: 3px;\n  border-radius: 6px;\n}\n.ontodia-dialog__close-button {\n  background: transparent url(\"../images/font-awesome/times-circle-regular.svg\");\n  background-size: contain;\n  border: 0 none;\n  cursor: pointer;\n  display: block;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  top: -22px;\n  right: -22px;\n  height: 20px;\n  width: 20px;\n  opacity: 0.5;\n  transition: 0.3s;\n}\n.ontodia-dialog__close-button:hover {\n  opacity: 1;\n}\n\n.ontodia-dialog__bottom-right-handle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 10px 10px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n  cursor: nwse-resize;\n}\n.ontodia-dialog__bottom-right-handle::before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 0 5px 5px;\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\n}\n.ontodia-dialog__bottom-right-handle:hover {\n  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n}\n\n.ontodia-dialog__bottom-handle, .ontodia-dialog__right-handle {\n  position: absolute;\n  opacity: 0;\n  background-color: black;\n}\n.ontodia-dialog__bottom-handle:hover, .ontodia-dialog__right-handle:hover {\n  opacity: 0.1;\n}\n\n.ontodia-dialog__bottom-handle {\n  bottom: 0;\n  width: 100%;\n  height: 5px;\n  cursor: ns-resize;\n}\n\n.ontodia-dialog__right-handle {\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.ontodia-edit-form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-edit-form__body {\n  overflow: auto;\n  padding: 10px;\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.ontodia-edit-form__controls {\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  text-align: right;\n  flex: 0 0 auto;\n}\n.ontodia-edit-form__apply-button {\n  margin-right: 5px;\n}\n.ontodia-edit-form__form-row {\n  display: block;\n  margin-bottom: 10px;\n}\n.ontodia-edit-form__element-selector {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-edit-form__search {\n  flex-shrink: 0;\n  position: relative;\n}\n.ontodia-edit-form__search-icon {\n  opacity: 0.6;\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  margin-top: -7px;\n}\n.ontodia-edit-form__search-input {\n  padding-left: 33px;\n}\n.ontodia-edit-form__existing-elements-list {\n  flex-grow: 1;\n  margin-top: 7px;\n  padding-right: 10px;\n  overflow-y: scroll;\n}\n.ontodia-edit-form__separator {\n  margin: 7px 0;\n  overflow: hidden;\n  text-align: center;\n}\n.ontodia-edit-form__separator-text {\n  color: #555;\n  display: inline-block;\n  font-size: 13px;\n  position: relative;\n}\n.ontodia-edit-form__separator-text:before, .ontodia-edit-form__separator-text:after {\n  content: \"\";\n  border-top: 1px solid;\n  position: absolute;\n  top: 50%;\n  margin: 0 10px;\n  width: 500px;\n}\n.ontodia-edit-form__separator-text:before {\n  left: 100%;\n}\n.ontodia-edit-form__separator-text:after {\n  right: 100%;\n}\n.ontodia-edit-form__progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.ontodia-edit-form__control-row {\n  position: relative;\n  padding-bottom: 18px;\n}\n.ontodia-edit-form__control-error {\n  color: red;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.ontodia-halo {\n  position: absolute;\n  pointer-events: none;\n  border: 1.5px dashed #d8956d;\n  border-radius: 2px;\n  box-shadow: 0 0 5px 0 #d8956d inset;\n}\n.ontodia-halo__navigate {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  right: -22px;\n}\n.ontodia-halo__navigate:hover {\n  opacity: 1;\n}\n.ontodia-halo__navigate[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__navigate--open {\n  background-image: url(\"../images/connections.svg\");\n}\n.ontodia-halo__navigate--closed {\n  background-image: url(\"../images/close-connections.svg\");\n}\n.ontodia-halo__folow {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: 50%;\n  margin-top: -10px;\n  left: -22px;\n  background-image: url(\"../images/link.svg\");\n}\n.ontodia-halo__folow:hover {\n  opacity: 1;\n}\n.ontodia-halo__folow[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__remove {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  right: -22px;\n  background-image: url(\"../images/delete.svg\");\n}\n.ontodia-halo__remove:hover {\n  opacity: 1;\n}\n.ontodia-halo__remove[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__expand {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: 50%;\n  margin-left: -10px;\n}\n.ontodia-halo__expand:hover {\n  opacity: 1;\n}\n.ontodia-halo__expand[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__expand--open {\n  background-image: url(\"../images/expand-properties.png\");\n}\n.ontodia-halo__expand--closed {\n  background-image: url(\"../images/collapse-properties.png\");\n}\n.ontodia-halo__add-to-filter {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  right: -22px;\n  background-image: url(\"../images/add-to-filter.png\");\n}\n.ontodia-halo__add-to-filter:hover {\n  opacity: 1;\n}\n.ontodia-halo__add-to-filter[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__revert {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  top: -22px;\n  left: 50%;\n  margin-left: -10px;\n  background-image: url(\"../images/font-awesome/undo-solid.svg\");\n}\n.ontodia-halo__revert:hover {\n  opacity: 1;\n}\n.ontodia-halo__revert[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__establish-connection {\n  position: absolute;\n  background-color: transparent;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 0 none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  pointer-events: auto;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n  bottom: -22px;\n  left: -22px;\n  background-image: url(\"../images/font-awesome/plug.svg\");\n}\n.ontodia-halo__establish-connection:hover {\n  opacity: 1;\n}\n.ontodia-halo__establish-connection[disabled] {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.ontodia-halo__establish-connection-spinner {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  bottom: -22px;\n  left: -22px;\n}\n\n.ontodia-halo-link__button {\n  background: transparent;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  opacity: 0.8;\n  outline: none;\n  transition: opacity 0.3s;\n}\n.ontodia-halo-link__button:hover {\n  opacity: 1;\n}\n.ontodia-halo-link__button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.ontodia-halo-link__edit {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(\"../images/font-awesome/edit.svg\");\n}\n.ontodia-halo-link__delete {\n  background-color: #ccc;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 60%;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  background-image: url(\"../images/font-awesome/trash-alt.svg\");\n}\n.ontodia-halo-link__spinner {\n  position: absolute;\n}\n.ontodia-halo-link__edit-label-button {\n  background: transparent url(\"../images/font-awesome/pen-square-solid.svg\") no-repeat;\n  background-size: cover;\n  border: 0 none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  margin-left: 5px;\n  outline: none;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.ontodia-halo-link__edit-label-button:hover {\n  opacity: 1;\n}\n\n.ontodia-instances-search {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-instances-search__criteria {\n  flex-shrink: 0;\n  margin: 10px 0 10px 0;\n}\n.ontodia-instances-search__criterions {\n  padding-left: 15px;\n  margin-bottom: 10px;\n}\n.ontodia-instances-search__criterions:empty {\n  margin-bottom: 0;\n}\n.ontodia-instances-search__criterion {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ontodia-instances-search__criterion-class {\n  border: black 1px dashed;\n  background: rgb(255, 210, 33);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__criterion-element {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__criterion-link-type {\n  border: black 1px dashed;\n  background: rgb(202, 255, 206);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n}\n.ontodia-instances-search__link-direction {\n  height: 1em;\n  opacity: 0.5;\n}\n.ontodia-instances-search__criterion-remove {\n  float: right;\n  margin: 0 10px 4px 4px;\n}\n.ontodia-instances-search__text-criteria {\n  margin: 0 10px;\n}\n.ontodia-instances-search__rest {\n  padding: 10px 10px 0 10px;\n  border-top: 1px solid rgb(221, 221, 221);\n}\n.ontodia-instances-search__results {\n  padding-left: 0;\n  padding-top: 10px;\n  margin: 0 10px 0 10px;\n  outline: none;\n}\n.ontodia-instances-search[data-state=finished] .ontodia-instances-search__results:empty:before {\n  content: \"No items correspond to the specified criteria.\";\n  font-style: italic;\n}\n.ontodia-instances-search__rest-end {\n  margin: 5px 0 10px 0;\n}\n.ontodia-instances-search__load-more {\n  width: 100%;\n}\n\n.link-types-toolbox {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n.link-types-toolbox__heading {\n  padding: 10px;\n}\n.link-types-toolbox__searching-box {\n  display: flex;\n  align-items: center;\n}\n.link-types-toolbox__clearSearch {\n  margin-left: -25px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n}\n.link-types-toolbox__switch-all {\n  margin-top: 5px;\n}\n.link-types-toolbox__rest {\n  border-top: 1px solid #dddddd;\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.link-types-toolbox .panel-heading {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n}\n\n.link-types-toolbox ul {\n  margin-bottom: 0;\n}\n\n.link-types-toolbox .links-heading {\n  margin-left: 0.4em;\n}\n\n.link-types-toolbox .links-heading span {\n  border: black 1px dashed;\n  background: rgb(255, 131, 92);\n  padding: 0 0.5em 0 0.5em;\n  word-wrap: break-word;\n  line-height: 1.3;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls {\n  padding: 5px 15px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.link-types-toolbox__heading .link-types-toolbox-controls > span {\n  padding-left: 0.3em;\n}\n\n.ontodia-list-group .linkInToolBox {\n  padding: 0 0 0 5px;\n  word-break: break-word;\n}\n\n.linkInToolBox > div {\n  display: inline;\n}\n.linkInToolBox__new-tag {\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n  border-radius: 2px;\n  padding: 0 5px;\n  background: orange;\n}\n.linkInToolBox .ontodia-badge {\n  display: none;\n  margin-left: 0.5em;\n  white-space: normal;\n  word-wrap: normal;\n}\n.linkInToolBox .link-title {\n  font-size: 16px;\n  color: black;\n  display: inline;\n}\n.linkInToolBox .ontodia-btn-group {\n  float: left;\n  margin-top: 2px;\n  margin-right: 6px;\n  margin-bottom: 2px;\n}\n.linkInToolBox .ontodia-btn.ontodia-btn-default {\n  border-color: rgb(195, 195, 195);\n}\n.linkInToolBox__filter-button {\n  display: none;\n  float: right;\n  background-image: url(\"../images/add-to-filter.png\");\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  margin: 3px;\n  cursor: pointer;\n  opacity: 0.4;\n  transition: opacity 200ms 0ms;\n}\n.linkInToolBox:hover .linkInToolBox__filter-button {\n  opacity: 1;\n  transition: opacity 200ms 0ms;\n}\n\n.connected-links .linkInToolBox .ontodia-badge {\n  /* show connection count badge only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.connected-links .linkInToolBox__filter-button {\n  /* show filter button only in \"Connected to Element\" list */\n  display: inline;\n}\n\n.ontodia-list-element-view {\n  position: relative;\n  display: block;\n  background: #808080;\n  padding: 1px 1px 1px 10px;\n  border-radius: 2px;\n  margin: 0 0 2px 0;\n  opacity: 1;\n  cursor: move;\n  user-select: none;\n}\n.ontodia-list-element-view--disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.ontodia-list-element-view__label {\n  background: white;\n  border-radius: 0 2px 2px 0;\n  font-family: \"Andale Mono\", sans-serif;\n  font-size: 15px;\n  min-height: 1.3em;\n  padding-left: 7px;\n  padding-right: 5px;\n  overflow-wrap: break-word;\n}\n\n.ontodia-text-highlight {\n  font-weight: bold;\n}\n\n.ontodia-navigator {\n  display: block;\n  position: absolute;\n  bottom: 25px;\n  right: 25px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\n  transition: width 0.3s, height 0.3s;\n}\n.ontodia .ontodia-navigator {\n  box-sizing: content-box;\n}\n.ontodia-navigator--collapsed {\n  width: 26px;\n  height: 26px;\n}\n.ontodia-navigator > canvas {\n  transition: opacity 0.3s;\n}\n.ontodia-navigator--expanded > canvas {\n  opacity: 1;\n}\n.ontodia-navigator--collapsed > canvas {\n  opacity: 0;\n}\n.ontodia-navigator__toggle {\n  position: absolute;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 4px;\n  opacity: 0.5;\n  transition: opacity 0.3s;\n}\n.ontodia-navigator__toggle:hover {\n  opacity: 1;\n}\n.ontodia-navigator--expanded .ontodia-navigator__toggle {\n  top: 5px;\n  left: 5px;\n}\n.ontodia-navigator--collapsed .ontodia-navigator__toggle {\n  top: 0px;\n  left: 0px;\n}\n.ontodia-navigator__toggle-icon {\n  width: 18px;\n  height: 18px;\n  background-size: 18px 18px;\n  background-repeat: no-repeat;\n}\n.ontodia-navigator--expanded .ontodia-navigator__toggle-icon {\n  background-image: url(\"../images/font-awesome/minus-square-regular.svg\");\n}\n.ontodia-navigator--collapsed .ontodia-navigator__toggle-icon {\n  background-image: url(\"../images/font-awesome/plus-square-regular.svg\");\n}\n\n@keyframes ontodia-progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.ontodia-progress-bar {\n  flex-shrink: 0;\n  -webkit-flex-shrink: 0; /* safari 8 */\n  width: 100%;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);\n  background-repeat: repeat-x;\n  overflow: hidden;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.ontodia-progress-bar__bar {\n  float: left;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  transition: width 0.6s ease;\n  background-color: #337ab7;\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-repeat: repeat-x;\n  background-size: 40px 40px;\n  animation: ontodia-progress-bar-stripes 2s linear infinite;\n}\n.ontodia-progress-bar--loading, .ontodia-progress-bar--error {\n  /* property name | duration | delay */\n  transition: height 300ms 300ms;\n}\n.ontodia-progress-bar--error {\n  background-color: #E72F2F;\n}\n.ontodia-progress-bar--completed {\n  /* property name | duration | delay */\n  transition: height 200ms 0ms;\n}\n\n.ontodia-search-results {\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n\n.ontodia-accordion {\n  flex: auto;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.ontodia-accordion--scrollable {\n  overflow: auto;\n}\n.ontodia-accordion--vertical {\n  flex-direction: column;\n}\n.ontodia-accordion--vertical:not(.ontodia-accordion--resizing) > .ontodia-accordion-item {\n  transition: height 0.3s ease-in-out;\n}\n\n.ontodia-accordion-item {\n  display: flex;\n  position: relative;\n  flex: auto;\n}\n.ontodia-accordion-item--resizing > .ontodia-accordion-item__handle, .ontodia-accordion-item__handle:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.ontodia-accordion-item--vertical {\n  border-top: 1px solid lightgray;\n}\n.ontodia-accordion-item--vertical:first-child {\n  border-top-width: 0;\n}\n.ontodia-accordion-item--horizontal {\n  border-right: 1px solid lightgray;\n}\n.ontodia-accordion-item--horizontal:last-child {\n  border-right-width: 0;\n}\n.ontodia-accordion-item__handle {\n  position: absolute;\n  z-index: 2;\n}\n.ontodia-accordion-item__handle-vertical {\n  height: 5px;\n  bottom: -2.5px;\n  left: 0;\n  width: 100%;\n  cursor: ns-resize;\n}\n.ontodia-accordion-item__handle-horizontal {\n  height: 100%;\n  top: 0;\n  right: -2.5px;\n  width: 5px;\n  cursor: ew-resize;\n}\n.ontodia-accordion-item__handle-btn {\n  background: #fff;\n  border: 2px solid #17b;\n  box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  top: 50%;\n  margin-top: -10px;\n  width: 20px;\n  z-index: 20;\n  transition: 0.3s;\n}\n.ontodia-accordion-item__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 8px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -4px;\n  margin-left: -4px;\n  width: 8px;\n  transition: background 0.3s;\n}\n.ontodia-accordion-item__handle-btn:hover {\n  background: #17b;\n}\n.ontodia-accordion-item__handle-btn-left {\n  left: 100%;\n  margin-left: -10px;\n}\n.ontodia-accordion-item__handle-btn-left:before {\n  background-image: url(\"../images/arrow-left.png\");\n}\n.ontodia-accordion-item__handle-btn-left:hover:before {\n  background-image: url(\"../images/arrow-left1.png\");\n}\n.ontodia-accordion-item__handle-btn-right {\n  right: 100%;\n  margin-right: -10px;\n}\n.ontodia-accordion-item__handle-btn-right:before {\n  background-image: url(\"../images/arrow-right.png\");\n}\n.ontodia-accordion-item__handle-btn-right:hover:before {\n  background-image: url(\"../images/arrow-right1.png\");\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__handle-btn:before {\n  transform: rotate(180deg);\n}\n.ontodia-accordion-item__inner {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.ontodia-accordion-item__body {\n  flex: 1 1 0px;\n  display: flex;\n  flex-direction: column;\n}\n.ontodia-accordion-item__header {\n  padding-left: 14px;\n  position: relative;\n  flex-shrink: 0;\n  font-size: 16px;\n  background: #E4E4E4;\n  cursor: default;\n  /* unselectable */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ontodia-accordion-item__header:before {\n  border-top: 6px solid #555555;\n  border-left: 3.5px solid transparent;\n  border-right: 3.5px solid transparent;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 3px;\n  margin-top: -3px;\n  display: none;\n  -webkit-transition: 0.1s;\n  -moz-transition: 0.1s;\n  transition: 0.1s;\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__header:before {\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n.ontodia-accordion-item--collapsed .ontodia-accordion-item__body {\n  display: none;\n}\n\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle,\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle {\n  height: 8px;\n  width: 100%;\n  top: initial;\n  left: 0;\n  cursor: ns-resize;\n}\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn,\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn {\n  height: 100%;\n  width: 40px;\n  top: 0;\n  left: 50%;\n  margin-left: -20px;\n  margin-top: 0px;\n}\n\n.ontodia-drag-resizable-column {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.ontodia-drag-resizable-column__handle {\n  background: #fff url(\"../images/resizable-column-handle.png\") repeat;\n  width: 8px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: initial;\n  z-index: 2;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n  cursor: ew-resize;\n}\n.ontodia-drag-resizable-column__handle-btn {\n  background: #eee;\n  cursor: pointer;\n  height: 40px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  margin-top: -20px;\n  width: 100%;\n  z-index: 1;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.ontodia-drag-resizable-column__handle-btn::before {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  background-size: cover;\n  content: \"\";\n  height: 6px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -3px;\n  margin-left: -3px;\n  width: 6px;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n.ontodia-drag-resizable-column__handle-btn:hover {\n  background: #b3b3b3;\n  transform: scale(1.2);\n}\n.ontodia-drag-resizable-column--closed .ontodia-drag-resizable-column__handle-btn::before {\n  transform: rotate(180deg);\n}\n.ontodia-drag-resizable-column--docked-left {\n  margin-right: 8px;\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle {\n  right: -8px;\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-left.png\");\n}\n.ontodia-drag-resizable-column--docked-left .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-left1.png\");\n}\n.ontodia-drag-resizable-column--docked-right {\n  margin-left: 8px;\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle {\n  left: -8px;\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-right.png\");\n}\n.ontodia-drag-resizable-column--docked-right .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-right1.png\");\n}\n.ontodia-drag-resizable-column--docked-top {\n  margin-bottom: 8px;\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle {\n  bottom: -8px;\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-top.png\");\n}\n.ontodia-drag-resizable-column--docked-top .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-top1.png\");\n}\n.ontodia-drag-resizable-column--docked-bottom {\n  margin-top: 8px;\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle {\n  top: -8px;\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn::before {\n  background-image: url(\"../images/arrow-bottom.png\");\n}\n.ontodia-drag-resizable-column--docked-bottom .ontodia-drag-resizable-column__handle-btn:hover::before {\n  background-image: url(\"../images/arrow-bottom1.png\");\n}\n\n.introjs-tooltiptext {\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n\n.ontodia-toolbar__language-selector {\n  padding: 5px;\n  margin-top: 4px;\n}\n.ontodia-toolbar__language-selector > label {\n  margin-right: 5px;\n}\n.ontodia-toolbar__language-selector > label > span {\n  vertical-align: middle;\n}\n.ontodia-toolbar__toggle {\n  line-height: 1;\n}\n.ontodia-toolbar__toggle:after {\n  background-position: 0 0;\n  background-repeat: no-repeat;\n  content: \"\";\n  display: block;\n  height: 12px;\n  margin: 3px 0;\n  width: 12px;\n}\n.ontodia-toolbar__toggle-left:after {\n  background-image: url(\"../images/left-panel.svg\");\n}\n.ontodia-toolbar__toggle-right:after {\n  background-image: url(\"../images/right-panel.svg\");\n}\n.ontodia-toolbar__toggle.active {\n  border-color: #c3c3c3;\n}\n.ontodia-toolbar__toggle-left.active:after {\n  background-image: url(\"../images/left-panel-active.svg\");\n}\n.ontodia-toolbar__toggle-right.active:after {\n  background-image: url(\"../images/right-panel-active.svg\");\n}\n\n.ontodia-toolbar__layout-group {\n  margin: 5px;\n  height: 30px;\n  float: left;\n}\n.ontodia-toolbar__layout-group > label {\n  margin-right: 5px;\n}\n.ontodia-toolbar__layout-group .btn-group, .ontodia-toolbar__layout-group button {\n  height: 100%;\n}\n\n.ontodia-toolbar {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.ontodia-toolbar > .ontodia-btn-group {\n  margin-left: 10px;\n}\n\n.ontodia-toolbar > .ontodia-btn-group > button {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.ontodia {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n  white-space: initial;\n  color: #333;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n}\n.ontodia *, .ontodia *:before, .ontodia *:after {\n  box-sizing: inherit;\n}\n.ontodia__header {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n}\n.ontodia__workspace {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  flex-direction: column;\n}\n.ontodia__main-panel {\n  display: flex;\n  flex: auto;\n  overflow: hidden;\n  width: 0;\n}\n.ontodia--unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ontodia--horizontal-resizing * {\n  cursor: ew-resize !important;\n}\n.ontodia--vertical-resizing * {\n  cursor: ns-resize !important;\n}\n.ontodia h4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.ontodia select {\n  color: inherit;\n  margin: 0;\n  font: inherit;\n  line-height: inherit;\n  text-transform: none;\n}\n.ontodia hr {\n  border: 0;\n  border-top: 1px solid #eee;\n  height: 0;\n}\n\n.ontodia-scrollable {\n  flex: 1 1 0px;\n  overflow-y: scroll;\n}\n\n.ontodia-scrollable > * {\n  position: relative;\n}\n\n.jstree-icon.jstree-themeicon.jstree-themeicon-custom {\n  background-size: contain !important;\n}\n\n.ontodia-default-template, .ontodia-group-template__wrap {\n  max-width: 450px;\n  float: left;\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n}\n.ontodia-default-template__thumbnail {\n  text-align: center;\n}\n.ontodia-default-template__thumbnail > img {\n  max-width: 200px;\n}\n.ontodia-default-template[data-expanded=true] .ontodia-default-template__thumbnail > img, [data-expanded=true].ontodia-group-template__wrap .ontodia-default-template__thumbnail > img {\n  max-width: 350px;\n}\n\n.ontodia-default-template_type-line, .ontodia-group-template__type-line {\n  padding: 0px 7px;\n  color: white;\n  height: 18px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  display: flex;\n  align-items: baseline;\n  margin-top: -3px;\n}\n\ndiv.ontodia-default-template_type-line__icon, div.ontodia-group-template__type-line-icon {\n  position: inherit !important;\n  margin-right: 4px;\n}\n\n.ontodia-default-template_type-line_text-container, .ontodia-group-template__type-line-text-container {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 0;\n}\n\n.ontodia-default-template_type-line_text-container__text, .ontodia-group-template__type-line-text {\n  display: inline;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.ontodia-default-template_body, .ontodia-group-template__body {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  background: white;\n  padding: 7px 10px 8px 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.ontodia-default-template_body__label, .ontodia-group-template__label {\n  font-size: 19px;\n  font-weight: 100;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0;\n  white-space: nowrap;\n  word-wrap: break-word;\n}\n\n.ontodia-default-template_body_expander {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n\n.ontodia-default-template_body_expander__iri_label {\n  font-size: 12px;\n  font-weight: 100;\n  margin-right: 15px;\n  color: #b6b6b6;\n}\n\n.ontodia-default-template_body_expander_iri {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ontodia-default-template_body_expander_iri__link {\n  color: #b6b6b6;\n}\n\n.ontodia-default-template_body_expander__hr {\n  margin: 5px 0px 5px 0px;\n}\n\n.ontodia-default-template_body_expander_property-table {\n  font-size: 15px;\n  font-weight: 100;\n  margin-bottom: 5px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.ontodia-default-template_body_expander_property-table_row {\n  white-space: nowrap;\n}\n\n.ontodia-default-template_body_expander_property-table_row__key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key_values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ontodia-default-template_body_expander_property-table_row_key_values__value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n\n.ontodia-group-template {\n  overflow: hidden;\n}\n.ontodia-group-template__wrap {\n  max-width: none;\n}\n.ontodia-group-template__body {\n  overflow: visible;\n}\n.ontodia-group-template__embedded-layer {\n  margin-top: 7px;\n}\n.ontodia-group-template .ontodia-paper__canvas {\n  border-color: #fff;\n}\n\n.ontodia-standard-template {\n  min-width: 180px;\n  max-width: 400px;\n  float: left;\n}\n.ontodia-standard-template__main {\n  border-radius: 2px;\n  border: 1px solid;\n}\n.ontodia-standard-template__body {\n  margin-left: 8px;\n  border-radius: 0 2px 2px 0;\n  border-left: 1px solid;\n  padding: 3px 0;\n  background: #fafaf9;\n}\n.ontodia-standard-template__body-horizontal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.ontodia-standard-template__body-content {\n  flex-grow: 1;\n  min-width: 0;\n  margin-right: 12px;\n}\n.ontodia-standard-template__label {\n  font-size: 19px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__thumbnail {\n  font-size: 26px;\n  margin: 5px 10px;\n  flex-shrink: 0;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ontodia-standard-template__thumbnail-image {\n  max-height: 100%;\n  max-width: 100%;\n}\n.ontodia-standard-template__thumbnail-icon {\n  max-height: 26px;\n  max-width: 26px;\n}\n.ontodia-standard-template__photo {\n  border-bottom: 1px solid;\n}\n.ontodia-standard-template__photo-image {\n  width: 100%;\n  border-radius: 2px 2px 0 0;\n}\n.ontodia-standard-template__type {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 11px;\n  font-style: italic;\n  color: #999;\n  display: flex;\n}\n.ontodia-standard-template__type-value {\n  width: 0;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__iri {\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n.ontodia-standard-template__iri-key {\n  font-size: 12px;\n  margin-right: 4px;\n  color: #b6b6b6;\n}\n.ontodia-standard-template__iri-value {\n  font-size: 12px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.ontodia-standard-template__iri-value a {\n  color: #b6b6b6;\n}\n.ontodia-standard-template__hr {\n  margin: 5px 0;\n}\n.ontodia-standard-template__properties {\n  font-size: 15px;\n  max-height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.ontodia-standard-template__propertites-row {\n  white-space: nowrap;\n}\n.ontodia-standard-template__properties-key {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: top;\n}\n.ontodia-standard-template__properties-values {\n  display: inline-block;\n  width: 50%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ontodia-standard-template__properties-value {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n  padding-right: 10px;\n}\n.ontodia-standard-template__pinned-props {\n  border-top: 1px solid;\n  margin: 0 5px;\n}\n.ontodia-standard-template__dropdown {\n  border-radius: 2px;\n  background-color: white;\n  margin-top: 5px;\n  border: 1px solid;\n}\n.ontodia-standard-template__dropdown-content {\n  width: 100%;\n  padding: 9px;\n}\n.ontodia-standard-template__actions {\n  display: flex;\n  justify-content: space-between;\n}\n.ontodia-standard-template__actions button {\n  padding: 5px;\n  min-width: 60px;\n}",".clearfix {\r\n\r\n  &:before, &:after {\r\n    display: table;\r\n    content: \"\";\r\n  }\r\n\r\n  &:after {\r\n    clear: both;\r\n  }\r\n}\r\n",".ontodia-label {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  margin-bottom: 5px;\r\n  font-weight: 700;\r\n}\r\n",".ontodia-btn {\r\n  display: inline-block;\r\n  padding: 6px 12px;\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.42857143;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  touch-action: manipulation;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  background-image: none;\r\n  border: 1px solid transparent;\r\n  text-transform: none;\r\n  transition: background-color 0.3s;\r\n\r\n  &[disabled] {\r\n    cursor: not-allowed;\r\n    opacity: .65;\r\n  }\r\n}\r\n\r\n\r\n.ontodia-btn-default {\r\n  background-color: #fff;\r\n  border-color: #ccc;\r\n  color: #333;\r\n\r\n  &:hover {\r\n    background-color: #e0e0e0;\r\n  }\r\n\r\n  &.active {\r\n    background-color: #e0e0e0;\r\n    border-color: #dbdbdb;\r\n  }\r\n\r\n  &.active:hover {\r\n    background-color: #d4d4d4;\r\n    border-color: #8c8c8c;\r\n  }\r\n\r\n  &[disabled], &[disabled]:hover, &[disabled].active, &[disabled].active:hover {\r\n    background-color: #e0e0e0;\r\n  }\r\n}\r\n\r\n.ontodia-btn-primary {\r\n  color: rgb(255, 255, 255);\r\n  background-color: rgb(51, 122, 183);\r\n  border-color: #245580;\r\n\r\n  &:hover, &:focus, &:active {\r\n    background-color: #265a88;\r\n  }\r\n\r\n  &:hover, &:focus {\r\n    border-color: #204d74;\r\n  }\r\n\r\n  &.active {\r\n    border-color: #245580;\r\n  }\r\n\r\n  &[disabled], &[disabled]:hover, &[disabled]:focus, &[disabled]:active, &[disabled].active {\r\n    background-color: #265a88;\r\n  }\r\n}\r\n\r\n.ontodia-btn-success {\r\n  background-color: #5cb85c;\r\n  border-color: #5cb85c;\r\n  color: #fff;\r\n  transition: 0.3s;\r\n\r\n  &:hover {\r\n    background: darken(#5cb85c, 8%);\r\n  }\r\n}\r\n\r\n.ontodia-btn-danger {\r\n  background-color: #c9302c;\r\n  border-color: #c9302c;\r\n  color: #fff;\r\n  transition: 0.3s;\r\n\r\n  &:hover {\r\n    background: darken(#c9302c, 8%);\r\n  }\r\n}\r\n",".ontodia-btn-group {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n\r\n  > .ontodia-btn, > .ontodia-btn-group {\r\n    position: relative;\r\n    float: left;\r\n  }\r\n\r\n  > .ontodia-btn:hover,\r\n  > .ontodia-btn:focus,\r\n  > .ontodia-btn.active,\r\n  > .ontodia-btn.active:hover {\r\n    z-index: 2;\r\n  }\r\n\r\n  .ontodia-btn + .ontodia-btn,\r\n  .ontodia-btn + .ontodia-btn-group,\r\n  .ontodia-btn-group + .ontodia-btn,\r\n  .ontodia-btn-group + .ontodia-btn-group {\r\n    margin-left: -1px;\r\n  }\r\n\r\n  > .ontodia-btn:first-child {\r\n    margin-left: 0;\r\n  }\r\n\r\n  &-sm > .ontodia-btn {\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    padding: 5px 10px;\r\n  }\r\n\r\n  &-xs > .ontodia-btn {\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    padding: 1px 5px;\r\n  }\r\n}\r\n",".ontodia-form-control {\r\n  display: block;\r\n  width: 100%;\r\n  height: 34px;\r\n  margin: 0;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  line-height: 1.42857143;\r\n  color: #555;\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  transition: border-color ease-in-out .15s;\r\n\r\n  &:focus {\r\n    border-color: #66afe9;\r\n    outline: 0;\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #eee;\r\n    cursor: not-allowed;\r\n    opacity: 0.6;\r\n  }\r\n}\r\n",".ontodia-input-group {\r\n  position: relative;\r\n  display: table;\r\n  border-collapse: separate;\r\n\r\n  .ontodia-form-control {\r\n    display: table-cell;\r\n    position: relative;\r\n    z-index: 2;\r\n    float: left;\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .ontodia-form-control:first-child {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n}\r\n\r\n.ontodia-input-group-btn {\r\n  display: table-cell;\r\n  width: 1%;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  font-size: 0;\r\n  white-space: nowrap;\r\n\r\n  &:last-child > .ontodia-btn {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    z-index: 2;\r\n    margin-left: -1px;\r\n  }\r\n}\r\n",".ontodia-list-group {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.ontodia-list-group-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ontodia-list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: 10px 15px;\r\n  margin-bottom: -1px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n}\r\n",".ontodia-badge {\r\n  display: inline-block;\r\n  min-width: 10px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: rgb(255, 255, 255);\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  background-color: rgb(119, 119, 119);\r\n  padding: 3px 7px;\r\n  border-radius: 10px;\r\n}\r\n",".ontodia-overlayed-element {\r\n  cursor: move;\r\n  outline: none;\r\n}\r\n\r\n.ontodia-overlayed-element,\r\n.ontodia-exported-element {\r\n  // set defaults for all inherited properties\r\n  box-sizing: border-box;\r\n  color: black;\r\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  font-size: 14px;\r\n  line-height: 1.42857143;\r\n\r\n  // http://stackoverflow.com/questions/6664460/line-height-affects-images\r\n  img { vertical-align: middle; }\r\n}\r\n\r\n.ontodia-exported-element {\r\n  *, *:before, *:after {\r\n    box-sizing: inherit;\r\n  }\r\n}\r\n\r\n.ontodia-overlayed-element--blurred {\r\n  filter: grayscale(100%);\r\n  opacity: 0.5;\r\n}\r\n",".ontodia-link {\r\n  &__wrap {\r\n    stroke-width: 12px;\r\n    stroke-linejoin: round;\r\n    stroke-linecap: round;\r\n    stroke: transparent;\r\n    fill: none;\r\n  }\r\n  &:hover &__wrap {\r\n    stroke: rgba(140, 140, 140, 0.44);\r\n  }\r\n\r\n  &__vertex {\r\n    cursor: all-scroll;\r\n  }\r\n  &:not(:hover) &__vertex {\r\n    fill: transparent;\r\n  }\r\n\r\n  &__vertex-tools {\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    > circle { fill: gray; }\r\n    > path { stroke: white; }\r\n    &:hover {\r\n      > circle { fill: black; }\r\n    }\r\n  }\r\n  &:hover &__vertex-tools {\r\n    opacity: 0.8;\r\n  }\r\n\r\n  &--blurred {\r\n    opacity: 0.5;\r\n  }\r\n}\r\n",".ontodia-paper-area {\r\n  flex: auto;\r\n  width: 0;\r\n  display: flex;\r\n  position: relative;\r\n  cursor: default;\r\n  background: #fff;\r\n\r\n  &__area {\r\n    flex: auto;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__widgets {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  &__watermark {\r\n    background-size: cover;\r\n    width: 8%;\r\n    max-width: 130px;\r\n    min-width: 50px;\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 25px;\r\n    cursor: pointer;\r\n    opacity: 0.3;\r\n    transition: opacity 0.3s;\r\n\r\n    &:hover {\r\n      opacity: 0.5;\r\n    }\r\n  }\r\n\r\n  &--hide-scrollbars {\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n.ontodia-paper {\r\n  position: relative;\r\n}\r\n\r\n.ontodia-exported-watermark {\r\n  opacity: 0.3;\r\n  transition: opacity 0.3s;\r\n}\r\n",".ontodia-paper-area--animated {\r\n    .ontodia-overlayed-element {\r\n        transition: transform 0.5s ease-in-out;\r\n    }\r\n    .ontodia-link-layer, .ontodia-paper-area__widgets {\r\n        transition: none;\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.ontodia-link-layer, .ontodia-paper-area__widgets {\r\n    transition: opacity 0.5s ease-in-out;\r\n}",".ontodia-loading-widget {\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  z-index: 10;\r\n}\r\n",".ontodia-authoring-state {\r\n  &__item-error {\r\n    align-self: flex-end;\r\n    margin: 0px 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: help;\r\n  }\r\n\r\n  &__item-error-icon {\r\n    background: url(\"../images/font-awesome/exclamation-triangle.svg\");\r\n    height: 15px;\r\n    width: 17px;\r\n  }\r\n\r\n  &__state-label {\r\n    font-weight: bold;\r\n    margin-right: 5px;\r\n  }\r\n\r\n  &__state-cancel {\r\n    color: #3f87a6;\r\n    cursor: pointer;\r\n    &:hover {\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n\r\n  &__state-indicator {\r\n    position: absolute;\r\n  }\r\n  &__state-indicator-container {\r\n    position: relative;\r\n  }\r\n  &__state-indicator-body {\r\n    position: absolute;\r\n    white-space: nowrap;\r\n    display: flex;\r\n    align-items: center;\r\n    bottom: 0;\r\n    background: rgba(255, 255, 255, 0.7);\r\n    border-radius: 5px;\r\n  }\r\n}\r\n",".ontodia-authoring-tools {\r\n  margin: 10px;\r\n\r\n  &__create-entity {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    white-space: normal;\r\n  }\r\n\r\n  &__type-label {\r\n    color: black;\r\n    border: black 1px dashed;\r\n    background: rgb(255, 210, 33);\r\n    padding: 0 .5em 0 .5em;\r\n    word-wrap: break-word;\r\n  }\r\n}\r\n",".ontodia-class-tree {\r\n  flex: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &__filter {\r\n    flex-shrink: 0;\r\n    margin: 10px 0 10px 0;\r\n  }\r\n\r\n  &__filter-group {\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  &__only-creatable {\r\n    display: block;\r\n    margin-top: 5px;\r\n  }\r\n\r\n  &__tree {\r\n    border-top: 1px solid rgb(221, 221, 221);\r\n  }\r\n\r\n  &__spinner {\r\n    align-self: center;\r\n    /* center vertically in flexbox */\r\n    margin: auto;\r\n  }\r\n}\r\n\r\n.ontodia-class-leaf {\r\n  margin: 1px 0;\r\n\r\n  &__row {\r\n    display: flex;\r\n    align-items: center;\r\n    white-space: nowrap;\r\n    user-select: none;\r\n    > * { flex-shrink: 0; }\r\n  }\r\n\r\n  &__body { \r\n    display: flex;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    padding: 1px;\r\n    border: 1px solid;\r\n    border-color: transparent;\r\n    &:hover {\r\n      background: #dcebff91;\r\n      border-color: #ccefff;\r\n      cursor: pointer;\r\n    }\r\n    &--selected {\r\n      background-color: #beebff;\r\n      border-color: #8edcff;\r\n    }\r\n  }\r\n\r\n  &__icon-container {\r\n    height: 20px;\r\n  }\r\n\r\n  &__icon {\r\n    display: block;\r\n    height: 100%;\r\n  }\r\n\r\n  &__label {\r\n    margin-left: 5px;\r\n    color: black;\r\n  }\r\n\r\n  &__highlighted-term {\r\n    font-weight: bold;\r\n  }\r\n\r\n  &__count {\r\n    margin-left: 5px;\r\n  }\r\n\r\n  &__children {\r\n    margin-left: 20px;\r\n  }\r\n\r\n  &__no-toggle {\r\n    display: inline-block;\r\n    width: 22px;\r\n    height: 22px;\r\n  }\r\n\r\n  &__toggle {\r\n    display: inline-block;\r\n    width: 12px;\r\n    height: 12px;\r\n    margin: 5px;\r\n    &:hover:not(:empty) {\r\n      background: #dcebff91;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  &__toggle-icon {\r\n    display: block;\r\n    height: 100%;\r\n  }\r\n\r\n  &__create {\r\n    margin-left: 5px;\r\n    > button {\r\n      cursor: move;\r\n    }\r\n  }\r\n}\r\n",".ontodia-connections-menu {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &__sort-switch {\r\n    display: none;\r\n  }\r\n\r\n  &__sort-switch:checked + &__sort-switch-label {\r\n    color: #337ab7;\r\n    opacity: 1;\r\n  }\r\n\r\n  &__sort-switch-label {\r\n    cursor: pointer;\r\n    display: block;\r\n    margin: 0;\r\n    opacity: 0.4;\r\n    text-align: center;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  &__search-line-input {\r\n    flex: 1 1 100%;\r\n  }\r\n}\r\n\r\n.ontodia-connections-menu_bread-crumbs {\r\n  padding: 10px;\r\n  padding-bottom: 0px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  height: 27px;\r\n  min-height: 27px;\r\n  flex-grow: 0;\r\n}\r\n\r\n.ontodia-connections-menu__title-label {\r\n  position: absolute;\r\n  top: -11px;\r\n  left: 10px;\r\n  background: white;\r\n  padding-left: 3px;\r\n  padding-right: 3px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.ontodia-connections-menu_search-line {\r\n  padding: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.ontodia-connections-menu_search-line-sort-switches {\r\n  flex: 0 0 20px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.ontodia-connections-menu_links-list {\r\n  padding: 5px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  border-top: 1px solid #dbdbdb;\r\n  flex-grow: 1;\r\n  margin: 0;\r\n}\r\n\r\n.ocm_links-list-empty {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ontodia-connections-menu_links-list__empty {\r\n  width: 100%;\r\n  position: relative;\r\n  font-size: x-large;\r\n  color: #cbcbcb;\r\n  text-align: center;\r\n}\r\n\r\n.ontodia-connections-menu__loading,\r\n.ontodia-connections-menu__error {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  font-size: x-large;\r\n  display: flex;\r\n  color: #cbcbcb;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.ontodia-connections-menu__loading-objects {\r\n  border: 1px solid gray;\r\n  flex-grow: 1;\r\n  box-shadow: inset 0px 0px 23px -8px gray;\r\n  background-color: whitesmoke;\r\n  position: relative;\r\n  font-size: x-large;\r\n  display: flex;\r\n  color: #cbcbcb;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.ontodia-connections-menu__move-to-filter {\r\n  display: flex;\r\n  padding: 5px 10px;\r\n  user-select: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background-color: #e6e6e6;\r\n  }\r\n}\r\n\r\n.link-in-popup-menu {\r\n  display: flex;\r\n  overflow: hidden;\r\n  padding: 0 5px 0 0;\r\n  align-items: center;\r\n  margin-bottom: 4px;\r\n  background: #f7f7f7;\r\n\r\n  &__link-title {\r\n    flex-grow: 1;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    margin: 5px 0px 5px 5px;\r\n  }\r\n\r\n  &__count {\r\n    flex-shrink: 0;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  &__navigate-button {\r\n    float: right;\r\n    background-image: url(\"../images/expand-link.png\");\r\n    width: 16px;\r\n    height: 16px;\r\n    opacity: 0.5;\r\n    margin-left: 10px;\r\n    min-width: 16px;\r\n    background-size: cover;\r\n    &:hover { opacity: 1; }\r\n  }\r\n\r\n  &__filter-button {\r\n    background-image: url(\"../images/add-to-filter.png\");\r\n    background-size: 20px 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    opacity: 0.4;\r\n    margin-left: 10px;\r\n    &:hover { opacity: 1; }\r\n  }\r\n\r\n  &:hover {\r\n    background-color: #e2e2e2;\r\n  }\r\n}\r\n\r\n.link-in-popup-menu_direction {\r\n    background: rgba(219, 219, 219, 0.35);\r\n    min-height: 30px;\r\n    padding: 5px 0px 5px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.link-in-popup-menu_direction__in-direction {\r\n  background: url(\"../images/direction-in.png\") 0 0 no-repeat;\r\n  flex-shrink: 0;\r\n  width: 22px;\r\n  height: 15px;\r\n  margin: 0 14px 0 0;\r\n  background-size: contain;\r\n  opacity: 0.5;\r\n}\r\n\r\n.link-in-popup-menu_direction__out-direction {\r\n  background: url(\"../images/direction-out.png\") 0 0 no-repeat;\r\n  flex-shrink: 0;\r\n  width: 22px;\r\n  height: 15px;\r\n  margin: 0 8px 0 6px;\r\n  background-size: contain;\r\n  opacity: 0.5;\r\n}\r\n\r\n.ontodia-connections-menu_links-list__loading {\r\n  text-align: center;\r\n  width: 100%;\r\n  position: relative;\r\n  font-size: x-large;\r\n  color: #cbcbcb;\r\n}\r\n\r\n.ontodia-connections-menu_links-list__hr {\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel {\r\n  flex-grow: 1;\r\n  padding: 10px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-top: 0px;\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel__select-all {\r\n    white-space: nowrap;\r\n    margin-bottom: 5px;\r\n    display: flex;\r\n\r\n    input {\r\n      margin-right: 5px;\r\n      &:disabled { opacity: 0.3 }\r\n    }\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel_bottom-panel {\r\n  height: 25px;\r\n  white-space: nowrap;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel_bottom-panel__count-label {\r\n  height: 25px;\r\n  float: left;\r\n  padding: 0px 5px;\r\n  font-size: larger;\r\n  display: flex;\r\n  align-items: center;\r\n  max-width: 60%;\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel_bottom-panel__extra-elements {\r\n  color: gray;\r\n  cursor: help;\r\n}\r\n\r\n.ontodia-btn.ontodia-connections-menu_objects-panel_bottom-panel__add-button {\r\n  height: 25px;\r\n  padding-top: 1px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.ontodia-connections-menu_objects-panel_objects-list {\r\n  border: 1px solid gray;\r\n  height: 0;\r\n  flex-grow: 1;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  padding: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.ontodia-connections-menu__link {\r\n  color: #337ab7;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n\r\n  &:hover {\r\n    text-decoration: underline;\r\n  }\r\n}\r\n",".ontodia-dialog {\r\n  background: #fff;\r\n  border: 1px solid #333;\r\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\r\n  position: absolute;\r\n\r\n  &__caption {\r\n    font-weight: bold;\r\n    position: absolute;\r\n    top: -11px;\r\n    left: 10px;\r\n    background: white;\r\n    padding-left: 3px;\r\n    padding-right: 3px;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  &__close-button {\r\n    background: transparent url(\"../images/font-awesome/times-circle-regular.svg\");\r\n    background-size: contain;\r\n    border: 0 none;\r\n    cursor: pointer;\r\n    display: block;\r\n    outline: none;\r\n    padding: 0;\r\n    position: absolute;\r\n    top: -22px;\r\n    right: -22px;\r\n    height: 20px;\r\n    width: 20px;\r\n\r\n    opacity: 0.5;\r\n    transition: 0.3s;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n\r\n.ontodia-dialog__bottom-right-handle {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 0 0 10px 10px;\r\n  border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\r\n  cursor: nwse-resize;\r\n\r\n  &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: -10px;\r\n    right: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-style: solid;\r\n    border-width: 0 0 5px 5px;\r\n    border-color: transparent transparent rgba(0, 0, 0, 0.38) transparent;\r\n  }\r\n\r\n  &:hover {\r\n    border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\r\n  }\r\n}\r\n\r\n.ontodia-dialog__bottom-handle, .ontodia-dialog__right-handle {\r\n  position: absolute;\r\n  opacity: 0;\r\n  background-color: black;\r\n\r\n  &:hover {\r\n    opacity: 0.1;\r\n  }\r\n}\r\n\r\n.ontodia-dialog__bottom-handle {\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 5px;\r\n  cursor: ns-resize;\r\n}\r\n\r\n.ontodia-dialog__right-handle {\r\n  top: 0;\r\n  right: 0;\r\n  width: 5px;\r\n  height: 100%;\r\n  cursor: ew-resize;\r\n}\r\n",".ontodia-edit-form {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &__body {\r\n    overflow: auto;\r\n    padding: 10px;\r\n    flex: 1 1 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n  }\r\n\r\n  &__controls {\r\n    border-top: 1px solid #ccc;\r\n    padding: 10px;\r\n    text-align: right;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  &__apply-button {\r\n    margin-right: 5px;\r\n  }\r\n\r\n  &__form-row {\r\n    display: block;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  &__element-selector {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  &__search {\r\n    flex-shrink: 0;\r\n    position: relative;\r\n  }\r\n\r\n  &__search-icon {\r\n    opacity: 0.6;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 10px;\r\n    margin-top: -7px;\r\n  }\r\n\r\n  &__search-input {\r\n    padding-left: 33px;\r\n  }\r\n\r\n  &__existing-elements-list {\r\n    flex-grow: 1;\r\n    margin-top: 7px;\r\n    padding-right: 10px;\r\n    overflow-y: scroll;\r\n  }\r\n\r\n  &__separator {\r\n    margin: 7px 0;\r\n    overflow: hidden;\r\n    text-align: center;\r\n  }\r\n\r\n  &__separator-text {\r\n    color: #555;\r\n    display: inline-block;\r\n    font-size: 13px;\r\n    position: relative;\r\n\r\n    &:before, &:after {\r\n      content: \"\";\r\n      border-top: 1px solid;\r\n      position: absolute;\r\n      top: 50%;\r\n      margin: 0 10px;\r\n      width: 500px;\r\n    }\r\n\r\n    &:before {\r\n      left: 100%;\r\n    }\r\n\r\n    &:after {\r\n      right: 100%;\r\n    }\r\n  }\r\n\r\n  &__progress {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n\r\n  &__control-row {\r\n    position: relative;\r\n    padding-bottom: 18px;\r\n  }\r\n\r\n  &__control-error {\r\n    color: red;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n  }\r\n}\r\n",".ontodia-halo {\r\n  position: absolute;\r\n  pointer-events: none;\r\n\r\n  border: 1.5px dashed #d8956d;\r\n  border-radius: 2px;\r\n  box-shadow: 0 0 5px 0 #d8956d inset;\r\n\r\n  $buttonWidth: 20px;\r\n  $buttonHeight: 20px;\r\n  $buttonMargin: 2px;\r\n\r\n  @mixin halo-button {\r\n    position: absolute;\r\n    background-color: transparent;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    border: 0 none;\r\n    cursor: pointer;\r\n    outline: none;\r\n    padding: 0;\r\n    pointer-events: auto;\r\n    width: $buttonWidth;\r\n    height: $buttonHeight;\r\n\r\n    opacity: 0.5;\r\n    transition: opacity 0.3s;\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[disabled] {\r\n      cursor: not-allowed;\r\n      opacity: 0.2;\r\n    }\r\n  }\r\n\r\n  @mixin spinner {\r\n    position: absolute;\r\n    width: $buttonWidth;\r\n    height: $buttonHeight;\r\n  }\r\n\r\n  @mixin n-docked {\r\n    top: -($buttonHeight + $buttonMargin);\r\n    left: 50%;\r\n    margin-left: -($buttonWidth / 2);\r\n  }\r\n\r\n  @mixin nw-docked {\r\n    top: -($buttonHeight + $buttonMargin);\r\n    left: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  @mixin ne-docked {\r\n    top: -($buttonHeight + $buttonMargin);\r\n    right: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  @mixin e-docked {\r\n    top: 50%;\r\n    margin-top: -($buttonHeight / 2);\r\n    right: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  @mixin w-docked {\r\n    top: 50%;\r\n    margin-top: -($buttonHeight / 2);\r\n    left: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  @mixin s-docked {\r\n    bottom: -($buttonHeight + $buttonMargin);\r\n    left: 50%;\r\n    margin-left: -($buttonWidth / 2);\r\n  }\r\n\r\n  @mixin sw-docked {\r\n    bottom: -($buttonHeight + $buttonMargin);\r\n    left: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  @mixin se-docked {\r\n    bottom: -($buttonHeight + $buttonMargin);\r\n    right: -($buttonWidth + $buttonMargin);\r\n  }\r\n\r\n  &__navigate {\r\n    @include halo-button;\r\n    @include e-docked;\r\n\r\n    &--open {\r\n      background-image: url(\"../images/connections.svg\");\r\n    }\r\n\r\n    &--closed {\r\n      background-image: url(\"../images/close-connections.svg\");\r\n    }\r\n  }\r\n\r\n  &__folow {\r\n    @include halo-button;\r\n    @include w-docked;\r\n\r\n    background-image: url(\"../images/link.svg\");\r\n  }\r\n\r\n  &__remove {\r\n    @include halo-button;\r\n    @include ne-docked;\r\n    background-image: url(\"../images/delete.svg\");\r\n  }\r\n\r\n  &__expand {\r\n    @include halo-button;\r\n    @include s-docked;\r\n\r\n    &--open {\r\n      background-image: url(\"../images/expand-properties.png\");\r\n    }\r\n\r\n    &--closed {\r\n      background-image: url(\"../images/collapse-properties.png\");\r\n    }\r\n  }\r\n\r\n  &__add-to-filter {\r\n    @include halo-button;\r\n    @include se-docked;\r\n    background-image: url(\"../images/add-to-filter.png\");\r\n  }\r\n\r\n  &__revert {\r\n    @include halo-button;\r\n    @include n-docked;\r\n    background-image: url(\"../images/font-awesome/undo-solid.svg\");\r\n  }\r\n\r\n  &__establish-connection {\r\n    @include halo-button;\r\n    @include sw-docked;\r\n    background-image: url(\"../images/font-awesome/plug.svg\");\r\n  }\r\n\r\n  &__establish-connection-spinner {\r\n    @include spinner;\r\n    @include sw-docked;\r\n  }\r\n}\r\n",".ontodia-halo-link {\r\n\r\n  &__button {\r\n    background: transparent;\r\n    border: 0 none;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    position: absolute;\r\n    opacity: 0.8;\r\n    outline: none;\r\n    transition: opacity 0.3s;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[disabled] {\r\n      cursor: not-allowed;\r\n      opacity: 0.5;\r\n    }\r\n  }\r\n\r\n  @mixin button {\r\n    background-color: #ccc;\r\n    background-position: 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 60%;\r\n    border-radius: 10px;\r\n    height: 20px;\r\n    width: 20px;\r\n  }\r\n\r\n  &__edit {\r\n    @include button;\r\n    background-image: url(\"../images/font-awesome/edit.svg\");\r\n  }\r\n\r\n  &__delete {\r\n    @include button;\r\n    background-image: url(\"../images/font-awesome/trash-alt.svg\");\r\n  }\r\n\r\n  &__spinner {\r\n    position: absolute;\r\n  }\r\n\r\n  &__edit-label-button {\r\n    background: transparent url(\"../images/font-awesome/pen-square-solid.svg\") no-repeat;\r\n    background-size: cover;\r\n    border: 0 none;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    position: absolute;\r\n    margin-left: 5px;\r\n    outline: none;\r\n    opacity: 0.5;\r\n    transition: opacity 0.3s;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n",".ontodia-instances-search {\r\n  flex: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &__criteria {\r\n    flex-shrink: 0;\r\n    margin: 10px 0 10px 0;\r\n  }\r\n\r\n  &__criterions {\r\n    padding-left: 15px;\r\n    margin-bottom: 10px;\r\n    &:empty { margin-bottom: 0; }\r\n  }\r\n\r\n  &__criterion {\r\n    display: block;\r\n    position: relative;\r\n    width: 100%;\r\n  }\r\n\r\n  &__criterion-class {\r\n    border: black 1px dashed;\r\n    background: rgb(255, 210, 33);\r\n    padding: 0 .5em 0 .5em;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n  &__criterion-element {\r\n    border: black 1px dashed;\r\n    background: rgb(255, 131, 92);\r\n    padding: 0 .5em 0 .5em;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n  &__criterion-link-type {\r\n    border: black 1px dashed;\r\n    background: rgb(202, 255, 206);\r\n    padding: 0 .5em 0 .5em;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n  &__link-direction {\r\n    height: 1em;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  &__criterion-remove {\r\n    float: right;\r\n    margin: 0 10px 4px 4px;\r\n  }\r\n\r\n  &__text-criteria { margin: 0 10px; }\r\n\r\n  &__rest {\r\n    padding: 10px 10px 0 10px;\r\n    border-top: 1px solid rgb(221, 221, 221);\r\n  }\r\n\r\n  &__results {\r\n    padding-left: 0;\r\n    padding-top: 10px;\r\n    margin: 0 10px 0 10px;\r\n    outline: none;\r\n  }\r\n\r\n  &[data-state='finished'] &__results:empty:before {\r\n    content: 'No items correspond to the specified criteria.';\r\n    font-style: italic;\r\n  }\r\n\r\n  &__rest-end { margin: 5px 0 10px 0; }\r\n  &__load-more {\r\n    width: 100%;\r\n  }\r\n}\r\n",".link-types-toolbox {\r\n  flex: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 0;\r\n\r\n  &__heading {\r\n    padding: 10px;\r\n  }\r\n\r\n  &__searching-box {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  &__clearSearch {\r\n    margin-left: -25px;\r\n    -webkit-appearance: none;\r\n    padding: 0;\r\n    cursor: pointer;\r\n    background: 0 0;\r\n    border: 0;\r\n  }\r\n\r\n  &__switch-all {\r\n    margin-top: 5px;\r\n  }\r\n\r\n  &__rest {\r\n    border-top: 1px solid #dddddd;\r\n    flex: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.link-types-toolbox .panel-heading {\r\n  flex-shrink: 0;\r\n  -webkit-flex-shrink: 0; /* safari 8 */\r\n}\r\n\r\n.link-types-toolbox ul {\r\n  margin-bottom: 0;\r\n}\r\n.link-types-toolbox .links-heading {\r\n  margin-left: .4em;\r\n}\r\n.link-types-toolbox .links-heading span {\r\n  border: black 1px dashed;\r\n  background: rgb(255, 131, 92);\r\n  padding: 0 .5em 0 .5em;\r\n  word-wrap: break-word;\r\n  line-height: 1.3;\r\n}\r\n\r\n.link-types-toolbox__heading .link-types-toolbox-controls {\r\n  padding: 5px 15px;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n.link-types-toolbox__heading .link-types-toolbox-controls > span {\r\n  padding-left: .3em;\r\n}\r\n\r\n.ontodia-list-group .linkInToolBox {\r\n  padding: 0 0 0 5px;\r\n  word-break: break-word;\r\n}\r\n\r\n.linkInToolBox {\r\n  & > div { display: inline; }\r\n\r\n  &__new-tag {\r\n    margin-left: .5em;\r\n    white-space: normal;\r\n    word-wrap: normal;\r\n    border-radius: 2px;\r\n    padding: 0 5px;\r\n    background: orange;\r\n  }\r\n\r\n  .ontodia-badge {\r\n    display: none;\r\n    margin-left: .5em;\r\n    white-space: normal;\r\n    word-wrap: normal;\r\n  }\r\n\r\n  .link-title {\r\n    font-size: 16px;\r\n    color: black;\r\n    display: inline;\r\n  }\r\n\r\n  .ontodia-btn-group {\r\n    float: left;\r\n    margin-top: 2px;\r\n    margin-right: 6px;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  .ontodia-btn.ontodia-btn-default {\r\n    border-color: rgb(195, 195, 195);\r\n  }\r\n\r\n  &__filter-button {\r\n    display: none;\r\n    float: right;\r\n    background-image: url(\"../images/add-to-filter.png\");\r\n    background-size: 20px 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin: 3px;\r\n    cursor: pointer;\r\n    opacity: 0.4;\r\n    transition: opacity 200ms 0ms;\r\n  }\r\n  &:hover &__filter-button {\r\n    opacity: 1.0;\r\n    transition: opacity 200ms 0ms;\r\n  }\r\n}\r\n\r\n.connected-links .linkInToolBox .ontodia-badge {\r\n  /* show connection count badge only in \"Connected to Element\" list */\r\n  display: inline;\r\n}\r\n.connected-links .linkInToolBox__filter-button {\r\n  /* show filter button only in \"Connected to Element\" list */\r\n  display: inline;\r\n}\r\n",".ontodia-list-element-view {\r\n  position: relative;\r\n  display: block;\r\n  background: #808080;\r\n  padding: 1px 1px 1px 10px;\r\n  border-radius: 2px;\r\n  margin: 0 0 2px 0;\r\n  opacity: 1.0;\r\n  cursor: move;\r\n  user-select: none;\r\n\r\n  &--disabled {\r\n    opacity: 0.4;\r\n    cursor: default;\r\n  }\r\n\r\n  &__label {\r\n    background: white;\r\n    border-radius: 0 2px 2px 0;\r\n    font-family: \"Andale Mono\", sans-serif;\r\n    font-size: 15px;\r\n    min-height: 1.3em;\r\n    padding-left: 7px;\r\n    padding-right: 5px;\r\n    overflow-wrap: break-word;\r\n  }\r\n}\r\n\r\n.ontodia-text-highlight {\r\n  font-weight: bold;\r\n}\r\n",".ontodia-navigator {\r\n  display: block;\r\n  position: absolute;\r\n  bottom: 25px;\r\n  right: 25px;\r\n  overflow: hidden;\r\n\r\n  // increase specificity to override default box-sizing,\r\n  // so border size won't be included into total size\r\n  .ontodia & {\r\n    box-sizing: content-box;\r\n  }\r\n\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  box-shadow: 0 4px 15px 7px rgba(51, 51, 51, 0.05);\r\n\r\n  $transition: 0.3s;\r\n  transition: width $transition, height $transition;\r\n\r\n  &--collapsed {\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n\r\n  > canvas {\r\n    transition: opacity $transition;\r\n  }\r\n  &--expanded > canvas { opacity: 1; }\r\n  &--collapsed > canvas { opacity: 0; }\r\n\r\n  &__toggle {\r\n    position: absolute;\r\n    background: transparent;\r\n    border: none;\r\n    outline: none;\r\n    padding: 4px;\r\n\r\n    opacity: 0.5;\r\n    transition: opacity 0.3s;\r\n\r\n    &:hover {\r\n      // background: lightgray;\r\n      opacity: 1;\r\n    }\r\n  }\r\n  &--expanded &__toggle {\r\n    top: 5px;\r\n    left: 5px;\r\n  }\r\n  &--collapsed &__toggle {\r\n    top: 0px;\r\n    left: 0px;\r\n  }\r\n\r\n  &__toggle-icon {\r\n    width: 18px;\r\n    height: 18px;\r\n    background-size: 18px 18px;\r\n    background-repeat: no-repeat;\r\n  }\r\n  &--expanded &__toggle-icon {\r\n    background-image: url('../images/font-awesome/minus-square-regular.svg');\r\n  }\r\n  &--collapsed &__toggle-icon {\r\n    background-image: url('../images/font-awesome/plus-square-regular.svg');\r\n  }\r\n}\r\n","@keyframes ontodia-progress-bar-stripes {\r\n  from {\r\n    background-position: 40px 0;\r\n  }\r\n  to {\r\n    background-position: 0 0;\r\n  }\r\n}\r\n\r\n.ontodia-progress-bar {\r\n  flex-shrink: 0;\r\n  -webkit-flex-shrink: 0; /* safari 8 */\r\n  width: 100%;\r\n\r\n  background-color: #f5f5f5;\r\n  background-image: linear-gradient(to bottom, #ebebeb 0%, #f5f5f5 100%);\r\n  background-repeat: repeat-x;\r\n  overflow: hidden;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\r\n\r\n  &__bar {\r\n    float: left;\r\n    height: 100%;\r\n    font-size: 12px;\r\n    line-height: 20px;\r\n    color: #fff;\r\n    text-align: center;\r\n    transition: width .6s ease;\r\n\r\n    background-color: #337ab7;\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-repeat: repeat-x;\r\n    background-size: 40px 40px;\r\n\r\n    animation: ontodia-progress-bar-stripes 2s linear infinite;\r\n  }\r\n\r\n  &--loading,\r\n  &--error {\r\n    /* property name | duration | delay */\r\n    transition: height 300ms 300ms;\r\n  }\r\n\r\n  &--error {\r\n    background-color: #E72F2F;\r\n  }\r\n\r\n  &--completed {\r\n    /* property name | duration | delay */\r\n    transition: height 200ms 0ms;\r\n  }\r\n}\r\n",".ontodia-search-results {\r\n  margin: 0;\r\n  padding: 0;\r\n  outline: none;\r\n}\r\n",".ontodia-accordion {\r\n  flex: auto;\r\n  display: flex;\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  &--scrollable {\r\n    overflow: auto;\r\n  }\r\n\r\n  &--vertical {\r\n    flex-direction: column;\r\n  }\r\n\r\n  &--vertical:not(&--resizing) > .ontodia-accordion-item {\r\n    transition: height 0.3s ease-in-out;\r\n  }\r\n}\r\n\r\n.ontodia-accordion-item {\r\n  display: flex;\r\n  position: relative;\r\n  flex: auto;\r\n\r\n  &--resizing > &__handle, &__handle:hover {\r\n    background: rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  &--vertical {\r\n    border-top: 1px solid lightgray;\r\n\r\n    &:first-child {\r\n      border-top-width: 0;\r\n    }\r\n  }\r\n\r\n  &--horizontal {\r\n    border-right: 1px solid lightgray;\r\n\r\n    &:last-child {\r\n      border-right-width: 0;\r\n    }\r\n  }\r\n\r\n  &__handle {\r\n    position: absolute;\r\n    z-index: 2;\r\n  }\r\n\r\n  &__handle-vertical {\r\n    height: 5px;\r\n    bottom: -2.5px;\r\n    left: 0;\r\n    width: 100%;\r\n    cursor: ns-resize;\r\n  }\r\n\r\n  &__handle-horizontal {\r\n    height: 100%;\r\n    top: 0;\r\n    right: -2.5px;\r\n    width: 5px;\r\n    cursor: ew-resize;\r\n  }\r\n\r\n  &__handle-btn {\r\n    background: #fff;\r\n    border: 2px solid #17b;\r\n    box-shadow: 0 0 0 1px rgba(9, 30, 66, 0.08), 0 2px 4px 1px rgba(9, 30, 66, 0.08);\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    height: 20px;\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -10px;\r\n    width: 20px;\r\n    z-index: 20;\r\n    transition: 0.3s;\r\n\r\n    &::before {\r\n      background-position: 0 0;\r\n      background-repeat: no-repeat;\r\n      background-size: cover;\r\n      content: \"\";\r\n      height: 8px;\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      margin-top: -4px;\r\n      margin-left: -4px;\r\n      width: 8px;\r\n      transition: background 0.3s;\r\n    }\r\n\r\n    &:hover {\r\n      background: #17b;\r\n    }\r\n  }\r\n\r\n  &__handle-btn-left {\r\n    left: 100%;\r\n    margin-left: -10px;\r\n    &:before { background-image: url(\"../images/arrow-left.png\"); }\r\n    &:hover:before { background-image: url(\"../images/arrow-left1.png\"); }\r\n  }\r\n\r\n  &__handle-btn-right {\r\n    right: 100%;\r\n    margin-right: -10px;\r\n    &:before { background-image: url(\"../images/arrow-right.png\"); }\r\n    &:hover:before { background-image: url(\"../images/arrow-right1.png\"); }\r\n  }\r\n\r\n  &--collapsed &__handle-btn:before {\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  &__inner {\r\n    flex: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__body {\r\n    flex: 1 1 0px; // IE 11 requires a unit to be added to the third argument\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  &__header {\r\n    padding-left: 14px;\r\n    position: relative;\r\n\r\n    flex-shrink: 0;\r\n    font-size: 16px;\r\n    background: #E4E4E4;\r\n    cursor: default;\r\n    /* unselectable */\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n\r\n    &:before {\r\n      border-top: 6px solid #555555;\r\n      border-left: 3.5px solid transparent;\r\n      border-right: 3.5px solid transparent;\r\n      content: \"\";\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 3px;\r\n      margin-top: -3px;\r\n      display: none;\r\n\r\n      -webkit-transition: 0.1s;\r\n      -moz-transition: 0.1s;\r\n      transition: 0.1s;\r\n    }\r\n  }\r\n\r\n  &--collapsed &__header:before {\r\n    -webkit-transform: rotate(-90deg);\r\n    -moz-transform: rotate(-90deg);\r\n    -ms-transform: rotate(-90deg);\r\n    transform: rotate(-90deg);\r\n  }\r\n\r\n  &--collapsed &__body {\r\n    display: none;\r\n  }\r\n}\r\n",".ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-bottom,\r\n.ontodia-drag-resizable-column.ontodia-drag-resizable-column--docked-top {\r\n  .ontodia-drag-resizable-column__handle {\r\n    height: 8px;\r\n    width: 100%;\r\n    top: initial;\r\n    left: 0;\r\n    cursor: ns-resize;\r\n  }\r\n\r\n  .ontodia-drag-resizable-column__handle-btn {\r\n    height: 100%;\r\n    width: 40px;\r\n    top: 0;\r\n    left: 50%;\r\n    margin-left: -20px;\r\n    margin-top: 0px;\r\n  }\r\n}\r\n\r\n.ontodia-drag-resizable-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n\r\n  &__handle {\r\n    background: #fff url(\"../images/resizable-column-handle.png\") repeat;\r\n    width: 8px;\r\n    height: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: initial;\r\n    z-index: 2;\r\n    -webkit-transition: 0.3s;\r\n    -moz-transition: 0.3s;\r\n    transition: 0.3s;\r\n    cursor: ew-resize;\r\n  }\r\n\r\n  &__handle-btn {\r\n    background: #eee;\r\n    cursor: pointer;\r\n    height: 40px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    margin-top: -20px;\r\n    width: 100%;\r\n    z-index: 1;\r\n    -webkit-transition: 0.3s;\r\n    -moz-transition: 0.3s;\r\n    transition: 0.3s;\r\n\r\n    &::before {\r\n      background-position: 0 0 ;\r\n      background-repeat: no-repeat;\r\n      background-size: cover;\r\n      content: \"\";\r\n      height: 6px;\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      margin-top: -3px;\r\n      margin-left: -3px;\r\n      width: 6px;\r\n      -webkit-transition: 0.3s;\r\n      -moz-transition: 0.3s;\r\n      transition: 0.3s;\r\n    }\r\n\r\n    &:hover {\r\n      background: #b3b3b3;\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n\r\n  &--closed &__handle-btn {\r\n    &::before { transform: rotate(180deg); }\r\n  }\r\n\r\n  &--docked-left { margin-right: 8px; }\r\n  &--docked-left &__handle { right: -8px; }\r\n  &--docked-left &__handle-btn {\r\n    &::before { background-image: url(\"../images/arrow-left.png\"); }\r\n    &:hover::before { background-image: url(\"../images/arrow-left1.png\"); }\r\n  }\r\n\r\n  &--docked-right { margin-left: 8px; }\r\n  &--docked-right &__handle { left: -8px; }\r\n  &--docked-right &__handle-btn {\r\n    &::before { background-image: url(\"../images/arrow-right.png\"); }\r\n    &:hover::before { background-image: url(\"../images/arrow-right1.png\"); }\r\n  }\r\n\r\n  &--docked-top { margin-bottom: 8px; }\r\n  &--docked-top &__handle { bottom: -8px; }\r\n  &--docked-top &__handle-btn {\r\n    &::before { background-image: url(\"../images/arrow-top.png\"); }\r\n    &:hover::before { background-image: url(\"../images/arrow-top1.png\"); }\r\n  }\r\n\r\n  &--docked-bottom { margin-top: 8px; }\r\n  &--docked-bottom &__handle { top: -8px; }\r\n  &--docked-bottom &__handle-btn {\r\n    &::before { background-image: url(\"../images/arrow-bottom.png\"); }\r\n    &:hover::before { background-image: url(\"../images/arrow-bottom1.png\"); }\r\n  }\r\n}\r\n",".introjs-tooltiptext {\r\n  color: #333;\r\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\r\n  font-size: 14px;\r\n  line-height: 1.42857;\r\n}\r\n",".ontodia-toolbar {\r\n  &__language-selector {\r\n    padding: 5px;\r\n    margin-top: 4px;\r\n\r\n    > label {\r\n      margin-right: 5px;\r\n      > span { vertical-align: middle; }\r\n    }\r\n  }\r\n\r\n  &__toggle {\r\n    line-height: 1;\r\n  }\r\n\r\n  &__toggle:after {\r\n    background-position: 0 0;\r\n    background-repeat: no-repeat;\r\n    content: '';\r\n    display: block;\r\n    height: 12px;\r\n    margin: 3px 0;\r\n    width: 12px;\r\n  }\r\n\r\n  &__toggle-left:after {\r\n    background-image: url('../images/left-panel.svg');\r\n  }\r\n\r\n  &__toggle-right:after {\r\n    background-image: url('../images/right-panel.svg');\r\n  }\r\n\r\n  &__toggle.active {\r\n    border-color: #c3c3c3;\r\n  }\r\n\r\n  &__toggle-left.active:after {\r\n    background-image: url('../images/left-panel-active.svg');\r\n  }\r\n\r\n  &__toggle-right.active:after {\r\n    background-image: url('../images/right-panel-active.svg');\r\n  }\r\n}\r\n\r\n.ontodia-toolbar {\r\n  &__layout-group {\r\n    margin: 5px;\r\n    height: 30px;\r\n    float: left;\r\n  \r\n    > label {\r\n      margin-right: 5px;\r\n    }\r\n  \r\n    .btn-group,button {\r\n      height: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.ontodia-toolbar {\r\n  background: rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.ontodia-toolbar > .ontodia-btn-group {\r\n  margin-left: 10px;\r\n}\r\n\r\n.ontodia-toolbar > .ontodia-btn-group > button {\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n// .ontodia-toolbar .ontodia-toolbar__undo,\r\n// .ontodia-toolbar .ontodia-toolbar__redo {\r\n//   display: none;\r\n// }\r\n\r\n",".ontodia {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  // defaults for inheritable properties\r\n  box-sizing: border-box;\r\n  white-space: initial;\r\n  color: #333;\r\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\r\n  font-size: 14px;\r\n  line-height: 1.42857;\r\n\r\n  *, *:before, *:after {\r\n    box-sizing: inherit;\r\n  }\r\n\r\n  &__header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  &__workspace {\r\n    display: flex;\r\n    flex: auto;\r\n    overflow: hidden;\r\n    flex-direction: column;\r\n  }\r\n\r\n  &__main-panel {\r\n    display: flex;\r\n    flex: auto;\r\n    overflow: hidden;\r\n    width: 0;\r\n  }\r\n\r\n  &--unselectable {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &--horizontal-resizing * { cursor: ew-resize !important; }\r\n  &--vertical-resizing * { cursor: ns-resize !important; }\r\n\r\n  h4 {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 1.1;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  select {\r\n    color: inherit;\r\n    margin: 0;\r\n    font: inherit;\r\n    line-height: inherit;\r\n    text-transform: none;\r\n  }\r\n\r\n  hr {\r\n    border: 0;\r\n    border-top: 1px solid #eee;\r\n    height: 0;\r\n  }\r\n}\r\n\r\n.ontodia-scrollable {\r\n  flex: 1 1 0px; // IE 11 requires a unit to be added to the third argument\r\n  overflow-y: scroll;\r\n}\r\n\r\n// fixes the bug in Chrome with redrawing children in scrollable elements\r\n.ontodia-scrollable > * {\r\n  position: relative;\r\n}\r\n",".jstree-icon.jstree-themeicon.jstree-themeicon-custom {\r\n  background-size: contain !important; // HACK: override background-size to fit in custom icons\r\n}\r\n",".ontodia-default-template {\r\n  max-width: 450px;\r\n  float: left;\r\n  border-radius: 12px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n\r\n  &__thumbnail {\r\n    text-align: center;\r\n    > img {\r\n      max-width: 200px;\r\n    }\r\n  } \r\n\r\n  &[data-expanded='true'] &__thumbnail > img {\r\n    max-width: 350px;\r\n  }\r\n}\r\n\r\n.ontodia-default-template_type-line {\r\n  padding: 0px 7px;\r\n  color: white;\r\n  height: 18px;\r\n  margin-bottom: 2px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: baseline;\r\n  margin-top: -3px;\r\n}\r\n\r\ndiv.ontodia-default-template_type-line__icon {\r\n  position: inherit !important;\r\n  margin-right: 4px;\r\n}\r\n\r\n.ontodia-default-template_type-line_text-container {\r\n  flex-grow: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 0;\r\n}\r\n.ontodia-default-template_type-line_text-container__text {\r\n  display: inline;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n}\r\n\r\n.ontodia-default-template_body {\r\n  border-bottom-left-radius: 12px;\r\n  border-bottom-right-radius: 12px;\r\n  border-top-style: solid;\r\n  border-top-width: 1px;\r\n  background: white;\r\n  padding: 7px 10px 8px 10px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.ontodia-default-template_body__label {\r\n  font-size: 19px;\r\n  font-weight: 100;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-bottom: 0;\r\n  white-space: nowrap;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.ontodia-default-template_body_expander {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  display: flex;\r\n}\r\n\r\n.ontodia-default-template_body_expander__iri_label {\r\n  font-size: 12px;\r\n  font-weight: 100;\r\n  margin-right: 15px;\r\n  color: #b6b6b6;\r\n}\r\n\r\n.ontodia-default-template_body_expander_iri {\r\n  font-size: 12px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.ontodia-default-template_body_expander_iri__link {\r\n  color: #b6b6b6;\r\n}\r\n\r\n.ontodia-default-template_body_expander__hr {\r\n  margin: 5px 0px 5px 0px;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table {\r\n  font-size: 15px;\r\n  font-weight: 100;\r\n  margin-bottom: 5px;\r\n  max-height: 200px;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table_row {\r\n  white-space: nowrap;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table_row__key {\r\n  display: inline-block;\r\n  width: 50%;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  vertical-align: top;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table_row_key {\r\n  display: inline-block;\r\n  width: 50%;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  vertical-align: top;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table_row_key_values {\r\n  display: inline-block;\r\n  width: 50%;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.ontodia-default-template_body_expander_property-table_row_key_values__value {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: initial;\r\n  padding-right: 10px;\r\n}\r\n",".ontodia-group-template {\r\n  overflow: hidden;\r\n\r\n  &__wrap {\r\n    @extend .ontodia-default-template;\r\n    max-width: none;\r\n  }\r\n\r\n  &__type-line {\r\n    @extend .ontodia-default-template_type-line;\r\n  }\r\n\r\n  &__type-line-icon {\r\n    @extend .ontodia-default-template_type-line__icon;\r\n  }\r\n\r\n  &__type-line-text-container {\r\n    @extend .ontodia-default-template_type-line_text-container;\r\n  }\r\n\r\n  &__type-line-text {\r\n    @extend .ontodia-default-template_type-line_text-container__text;\r\n  }\r\n\r\n  &__body {\r\n    @extend .ontodia-default-template_body;\r\n    overflow: visible;\r\n  }\r\n\r\n  &__label {\r\n    @extend .ontodia-default-template_body__label;\r\n  }\r\n\r\n  &__embedded-layer {\r\n    margin-top: 7px;\r\n  }\r\n\r\n  .ontodia-paper__canvas {\r\n    border-color: #fff;\r\n  }\r\n}\r\n",".ontodia-standard-template {\r\n  min-width: 180px;\r\n  max-width: 400px;\r\n  float: left;\r\n\r\n  &__main {\r\n    border-radius: 2px;\r\n    border: 1px solid;\r\n  }\r\n\r\n  &__body {\r\n    margin-left: 8px;\r\n    border-radius: 0 2px 2px 0;\r\n    border-left: 1px solid;\r\n    padding: 3px 0;\r\n    background: #fafaf9;\r\n  }\r\n\r\n  &__body-horizontal {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__body-content {\r\n    flex-grow: 1;\r\n    min-width: 0;\r\n    margin-right: 12px;\r\n  }\r\n\r\n  &__label {\r\n    font-size: 19px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__thumbnail {\r\n    font-size: 26px;\r\n    margin: 5px 10px;\r\n    flex-shrink: 0;\r\n    width: 50px;\r\n    height: 50px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  &__thumbnail-image {\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  &__thumbnail-icon {\r\n    max-height: 26px;\r\n    max-width: 26px;\r\n  }\r\n\r\n  &__photo {\r\n    border-bottom: 1px solid;\r\n  }\r\n\r\n  &__photo-image {\r\n    width: 100%;\r\n    border-radius: 2px 2px 0 0;\r\n  }\r\n\r\n  &__type {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 11px;\r\n    font-style: italic;\r\n    color: #999;\r\n    display: flex;\r\n  }\r\n\r\n  &__type-value {\r\n    width: 0;\r\n    flex-grow: 1;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__iri {\r\n    width: 100%;\r\n    overflow: hidden;\r\n    display: flex;\r\n  }\r\n\r\n  &__iri-key {\r\n    font-size: 12px;\r\n    margin-right: 4px;\r\n    color: #b6b6b6;\r\n  }\r\n\r\n  &__iri-value {\r\n    font-size: 12px;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__iri-value a {\r\n    color: #b6b6b6;\r\n  }\r\n\r\n  &__hr {\r\n    margin: 5px 0;\r\n  }\r\n\r\n  &__properties {\r\n    font-size: 15px;\r\n    max-height: 200px;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n  }\r\n\r\n  &__propertites-row {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  &__properties-key {\r\n    display: inline-block;\r\n    width: 50%;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    vertical-align: top;\r\n  }\r\n\r\n  &__properties-values {\r\n    display: inline-block;\r\n    width: 50%;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__properties-value {\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: initial;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  &__pinned-props {\r\n    border-top: 1px solid;\r\n    margin: 0 5px;\r\n  }\r\n\r\n  &__dropdown {\r\n    border-radius: 2px;\r\n    background-color: white;\r\n    margin-top: 5px;\r\n    border: 1px solid;\r\n  }\r\n\r\n  &__dropdown-content {\r\n    width: 100%;\r\n    padding: 9px;\r\n  }\r\n\r\n  &__actions {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    button {\r\n      padding: 5px;\r\n      min-width: 60px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),
/* 5 */
/***/ ((module) => {

"use strict";


function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

module.exports = function cssWithMappingToString(item) {
  var _item = _slicedToArray(item, 4),
      content = _item[1],
      cssMapping = _item[3];

  if (!cssMapping) {
    return content;
  }

  if (typeof btoa === "function") {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || "").concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join("\n");
  }

  return [content].join("\n");
};

/***/ }),
/* 6 */
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),
/* 7 */
/***/ ((module) => {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== "string") {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
  }

  return url;
};

/***/ }),
/* 8 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJmaWxsOiB3aGl0ZSIgdmlld0JveD0iMCAwIDU3NiA1MTIiPg0KICAgIDxyZWN0DQogICAgICAgIHN0eWxlPSJmaWxsOiB3aGl0ZSINCiAgICAgICAgd2lkdGg9IjE2MCINCiAgICAgICAgaGVpZ2h0PSIzNDAiDQogICAgICAgIHg9IjIwNy45OTk4Ig0KICAgICAgICB5PSIxMzYiDQogICAgICAgIHJ5PSIwIiAvPg0KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiByZWQiIGQ9Ik01NjkuNTE3IDQ0MC4wMTNDNTg3Ljk3NSA0NzIuMDA3IDU2NC44MDYgNTEyIDUyNy45NCA1MTJINDguMDU0Yy0zNi45MzcgMC01OS45OTktNDAuMDU1LTQxLjU3Ny03MS45ODdMMjQ2LjQyMyAyMy45ODVjMTguNDY3LTMyLjAwOSA2NC43Mi0zMS45NTEgODMuMTU0IDBsMjM5Ljk0IDQxNi4wMjh6TTI4OCAzNTRjLTI1LjQwNSAwLTQ2IDIwLjU5NS00NiA0NnMyMC41OTUgNDYgNDYgNDYgNDYtMjAuNTk1IDQ2LTQ2LTIwLjU5NS00Ni00Ni00NnptLTQzLjY3My0xNjUuMzQ2bDcuNDE4IDEzNmMuMzQ3IDYuMzY0IDUuNjA5IDExLjM0NiAxMS45ODIgMTEuMzQ2aDQ4LjU0NmM2LjM3MyAwIDExLjYzNS00Ljk4MiAxMS45ODItMTEuMzQ2bDcuNDE4LTEzNmMuMzc1LTYuODc0LTUuMDk4LTEyLjY1NC0xMS45ODItMTIuNjU0aC02My4zODNjLTYuODg0IDAtMTIuMzU2IDUuNzgtMTEuOTgxIDEyLjY1NHoiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 9 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGrSURBVHic7dYxSgNRGEXhGwOuRQyCi1AR3IHoUiwFW21cj5sRC3tFgrExzUBIMmPmP76cD145MxcODyYRyrTgm+dJDpO8F3xbHRdJPpK8JZkVb9l7yxiL32OUQt0YRim0KoZRCqyLYZQRbRrDKCOYZbsYy/Oa5Khgb/MmSZ6yfRBvyg4ZBcgoQEYBMgqQUYCMAmQUIKMAGQXIKEBGATIKkFGAjAJkFKChUY7Hn9w+owAZBcgoQEYBMgqQUYCMAjRJ8hijoBgFyChARgEyCpBRgIwCZBQgowANjXI6/uT2DYkyT3I5/uT2GQXIKEBGATIKkFGAsFEOdvViuEWSlyTfPZ6dJjn72zm6SvKZfjfkuWBv04wBYgwQY4AYA8QYIH1jzJPcFext2pAYtwV7m2YMEGOAGAPEGCDGADEGiDFAjAFiDBBjgBgDxBggxgAxBogxQIwBMiTGTcHephkDxBggxgAxBogxQIwBYgwQY4AYA8QYIMYAMQaIMUCMAWIMkJMkX+kX47pg7164jzcDZ9MoxhjRuijGKLAqijEKdaMYA2AZxRggD/HXVv/FDxh8HInEGLhOAAAAAElFTkSuQmCC"

/***/ }),
/* 10 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAuxJREFUeF7t3V1u4jAYhWFu+FkDIHHBGlgZILbBjtN8M/labEywYzs+js8rHYFUqGo/6twNXTHGWIVdLpduv993x+ORm3Fy53L3A8Nf8sX+gSuw4e7NCFJuBAEbQcBGELARBGxOkNPp9PZCbp4Nd2/2eDy67Xb79mIu7+TO5e775+/d7/dut9u9vYnLM7lrufP++eeIMs+8MDSi5F0QhkaUPJuEoREl7aIwNKKkWRIMjShxS4qhEWXasmBoRAlbVgyNKH6bBUMjyvhmxdCI4l4RDI0o5opiaET5PwgMrXUUKAytVRRIDK01FGgMrRWUKjC0paNUhaEtFaVKDG1pKFVjaEtBWQSGVjvKojC0WlEWiaHVhrJoDK0WlCYwNHSUpjA0VJQmMTQ0lKYxNBQUSIyu697mkXEwa16VRoHCcCHoPDMOZ827UihwvxkuCFlAxgGtBTU3ChyGFIkhGYe0FtxcKJAYUiSGZBzU2qRyo8BiSIggUi4UaAwJFURKjQKPISGDSKlQqsCQEEHsn+N2u3Xr9dr+3t6T98r36J/jVwOIJJ8r1T9M2vDeOqoFJOajP5wfXYGaHp4gIDlAfg9SYP8iyPBIEIAIAhZBwCIIWAQBiyBgKcQLSGjG4a1NiiAEwYkgYCGCuCKIf8bhrSWLIP4Zh7eWLIL4ZxzeWrKaBZmAYhzeWrKaBpEFZBzeWrKaB5F5ZhzeWrIIMswj4/DWkkWQl33JOLy1ZBHEsZIRZGQlIkjCpYgggfvU2NdCIojnvuXzGp8I8mW+hbx2LIIkXIqaAaklgoDVDIjrn5gciy0GxPl3AlFzXV6OxTYVZPTvBCLmurwci20KSDX/je011+XlWGyhIFViSK7Ly7HYQkCqxZBcl5djsfmCVI0huS4vx2LzAakeQ3JdXo7F9g1kERiS6/JyLLYxkMVg1NQnEGIUygVCjILZIMQo3CsIMQBSEGKAdDgcus1mQwyUzudzd71eiYHS8/kkBpu71eoHWjSksuGbaS0AAAAASUVORK5CYII="

/***/ }),
/* 11 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAYAAAAOEM1uAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAZEQAAGREBkIelaAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAG2SURBVFiFzde9axRRFMbhJ3Hjx0YRgkWElGIRGyVgaaG9XQpBrNIETJHKjxBSJCA2NiIWdhYKgoqCIELq/AU2tiJpAiliDMHEWEyKZfdO5szHrr4wzcx77vnNnXPnnktcK9jBwYCuLcwNBeHGsIGovyltDweNbYOHg9Eo4D9Tq0bsGj40BXKoO5isEjiht4ifHuE/qVpJvO/O049PvIxN/MBMH8ZP6pzeGVxK+C4kfAsl8vTMYBnI1x1Bv3E54bmWSHCAx2KfvBbgKGbxJAfOIcS7HMjnKCqpWoBRtfE5B/IVRsoAtnAGd3GlQchd/NE7Y7dwCtPYiw72xuD216KFk/zN3Ii+SYOajhqHZUU9aK1GjS3M4xumFK+yMuPexLHEsy9YbChPJR3HW+na+yjbBvNU+zdzHbcxfoTnUw7cS8XNSS3AFx1B6zif8FzKgXsmVj6VAduyFrwzcCUHcL/L9yiaJAUYXRRjON1172zC9xX3ZS+ziTk8KAFYWWX7wRGcqJAnudVV1RTu1YhP6WL3jWjXO4HvzbLE9N8fmqKAv/SpNyvQdmorSmlHVvhX1TsJltFPPPwL/+nTC6wUIf8AAAAASUVORK5CYII="

/***/ }),
/* 12 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAYAAAAOEM1uAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAZEQAAGREBkIelaAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGCSURBVFiFzdi9ShxRFAfwn+uiaAoRVBQbbfMEFqIoFja+QCoLLQQr8R0sbdIJgTQiSgT1AcTKzkdIQhpTaOlX0GyK2WJ2c8d1Pt0/XBjOnTnnP+eerxnYxj0aJa9nfEOvlLirgFx8zaQhV8Ng2jfKiVT2amWxKAr1gOwElwXpH8NWXiXtMbKZV2EMHwP6F2P7dR1O8T2PeBW/8EMHp5TpwWGtJewF06JEuWmzu4ueqgnC55juw6ZsHE8B218F8qJsgkS1b0Grh74EbDdwioGqCYbQj6MEkhcYIlxm3opZrGEyh47eJqH22JvDOZbJ5sEJ4Rgqeh1nLTMr6Mv4bBpMZSV4hj9FMknA96wxeC3qCOvyxWAd88L17wobdHkWV0VwxP+e3ksgd6LiOrgtyvhn7DRlo3gM2K68kwziNqb7QTSC9eN3m9136cWvjVuf8FOHaSZPJ8mLfRw0r/8m3RQiuIQPBZEY67CfSCyOsttV0hG/CV3/0VQTTbxVIrW9rv6z8A+8NRQ5z9bcwQAAAABJRU5ErkJggg=="

/***/ }),
/* 13 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhciIgZGF0YS1pY29uPSJ0aW1lcy1jaXJjbGUiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS10aW1lcy1jaXJjbGUgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yNTYgOEMxMTkgOCA4IDExOSA4IDI1NnMxMTEgMjQ4IDI0OCAyNDggMjQ4LTExMSAyNDgtMjQ4UzM5MyA4IDI1NiA4em0wIDQ0OGMtMTEwLjUgMC0yMDAtODkuNS0yMDAtMjAwUzE0NS41IDU2IDI1NiA1NnMyMDAgODkuNSAyMDAgMjAwLTg5LjUgMjAwLTIwMCAyMDB6bTEwMS44LTI2Mi4yTDI5NS42IDI1Nmw2Mi4yIDYyLjJjNC43IDQuNyA0LjcgMTIuMyAwIDE3bC0yMi42IDIyLjZjLTQuNyA0LjctMTIuMyA0LjctMTcgMEwyNTYgMjk1LjZsLTYyLjIgNjIuMmMtNC43IDQuNy0xMi4zIDQuNy0xNyAwbC0yMi42LTIyLjZjLTQuNy00LjctNC43LTEyLjMgMC0xN2w2Mi4yLTYyLjItNjIuMi02Mi4yYy00LjctNC43LTQuNy0xMi4zIDAtMTdsMjIuNi0yMi42YzQuNy00LjcgMTIuMy00LjcgMTcgMGw2Mi4yIDYyLjIgNjIuMi02Mi4yYzQuNy00LjcgMTIuMy00LjcgMTcgMGwyMi42IDIyLjZjNC43IDQuNyA0LjcgMTIuMyAwIDE3eiI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 14 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnDQogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgdmlld0JveD0iMCAwIDExMCAxMTAiDQogICB2ZXJzaW9uPSIxLjEiDQogICB3aWR0aD0iNTAwIg0KICAgaGVpZ2h0PSI1MDAiPg0KICA8cGF0aA0KICAgICBkPSJNIDU1LjEwNTk2NSw1NC42NDg4MjUgTSA4Mi4xODI0MjIsOC4wNTIxMTA3IEEgNTMuODkyMzc3LDUzLjg5MjM3NyAwIDEgMCAyOC4wMjk1MDgsMTAxLjI0NTU0IDUzLjg5MjM3Nyw1My44OTIzNzcgMCAxIDAgODIuMTgyNDIyLDguMDUyMTEwNyBaIE0gNTUuMTA1OTY1LDU0LjY0ODgyNSBNIDc2LjY5MjUzNiwxNy40OTk4MjQgQSA0Mi45NjU0MzIsNDIuOTY1NDMyIDAgMCAxIDMzLjUxOTM5Myw5MS43OTc4MjcgNDIuOTY1NDMyLDQyLjk2NTQzMiAwIDAgMSA3Ni42OTI1MzYsMTcuNDk5ODI0IFoiDQogICAgIHN0eWxlPSJzdHJva2Utd2lkdGg6MS4wNjgxMjc2MztmaWxsOiMwMDAwMDAiIC8+DQogIDxwYXRoDQogICAgIHN0eWxlPSJmaWxsOiMwMDAwMDA7c3Ryb2tlOm5vbmU7c3Ryb2tlLXdpZHRoOjAuMjU4OTMyNTlweDtzdHJva2UtbGluZWNhcDpidXR0O3N0cm9rZS1saW5lam9pbjptaXRlcjtzdHJva2Utb3BhY2l0eToxIg0KICAgICBkPSJNIDI1LjI5NDgxLDU2LjU1MjU5NyBDIDc4Ljg4Mjg2MywyOS44MzQ5MDUgNzkuMDM1NTM2LDI5LjgzNDkwNSA3OS4wMzU1MzYsMjkuODM0OTA1IEwgNTIuMTY1MTc0LDg0LjE4NjMyIDQ5LjU2OTc0LDU5LjMwMDcgWiIgLz4NCjwvc3ZnPg0K"

/***/ }),
/* 15 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnDQogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgdmlld0JveD0iMCAwIDExMCAxMTAiDQogICB2ZXJzaW9uPSIxLjEiDQogICB3aWR0aD0iNTAwIg0KICAgaGVpZ2h0PSI1MDAiPg0KICA8cGF0aA0KICAgICBkPSJNIDU1LjEwNTk2NSw1NC42NDg4MjUgTSA4Mi4xODI0MjIsOC4wNTIxMTA3IEEgNTMuODkyMzc3LDUzLjg5MjM3NyAwIDEgMCAyOC4wMjk1MDgsMTAxLjI0NTU0IDUzLjg5MjM3Nyw1My44OTIzNzcgMCAxIDAgODIuMTgyNDIyLDguMDUyMTEwNyBaIE0gNTUuMTA1OTY1LDU0LjY0ODgyNSBNIDc2LjY5MjUzNiwxNy40OTk4MjQgQSA0Mi45NjU0MzIsNDIuOTY1NDMyIDAgMCAxIDMzLjUxOTM5Myw5MS43OTc4MjcgNDIuOTY1NDMyLDQyLjk2NTQzMiAwIDAgMSA3Ni42OTI1MzYsMTcuNDk5ODI0IFoiDQogICAgIHN0eWxlPSJzdHJva2Utd2lkdGg6MS4wNjgxMjc2MyIgLz4NCiAgPHBhdGgNCiAgICAgZD0iTSA3MC43NDkzNjQsMzEuMjI0NjM1IDc4LjQyNjkzMywzOC45MTAxNDYgNjMuMDU0MjY1LDU0LjI2Njk3MyA3OC40MTEwNyw2OS42Mzk2NjIgNzAuNzI1NTcxLDc3LjMxNzI0MiA1NS4zNjg3NjYsNjEuOTQ0NTUzIDM5Ljk5NjA5OCw3Ny4zMDEzNzkgMzIuMzE4NTI5LDY5LjYxNTg2OSA0Ny42OTExOTcsNTQuMjU5MDQyIDMyLjMzNDM5MiwzOC44ODYzNTMgbCA3LjY4NTQ5OSwtNy42Nzc1OCAxNS4zNTY4MDUsMTUuMzcyNjg5IHoiDQogICAgIHN0eWxlPSJzdHJva2Utd2lkdGg6MS4xNzkxMzE4NyIgLz4NCjwvc3ZnPg0K"

/***/ }),
/* 16 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iIzAxMDEwMSIgZD0iTTQ1OS42NTQsMjMzLjM3M2wtOTAuNTMxLDkwLjVjLTQ5Ljk2OSw1MC0xMzEuMDMxLDUwLTE4MSwwYy03Ljg3NS03Ljg0NC0xNC4wMzEtMTYuNjg4LTE5LjQzOC0yNS44MTMNCglsNDIuMDYzLTQyLjA2M2MyLTIuMDE2LDQuNDY5LTMuMTcyLDYuODI4LTQuNTMxYzIuOTA2LDkuOTM4LDcuOTg0LDE5LjM0NCwxNS43OTcsMjcuMTU2YzI0Ljk1MywyNC45NjksNjUuNTYzLDI0LjkzOCw5MC41LDANCglsOTAuNS05MC41YzI0Ljk2OS0yNC45NjksMjQuOTY5LTY1LjU2MywwLTkwLjUxNmMtMjQuOTM4LTI0Ljk1My02NS41MzEtMjQuOTUzLTkwLjUsMGwtMzIuMTg4LDMyLjIxOQ0KCWMtMjYuMTA5LTEwLjE3Mi01NC4yNS0xMi45MDYtODEuNjQxLTguODkxbDY4LjU3OC02OC41NzhjNTAtNDkuOTg0LDEzMS4wMzEtNDkuOTg0LDE4MS4wMzEsMA0KCUM1MDkuNjIzLDEwMi4zNDIsNTA5LjYyMywxODMuMzg5LDQ1OS42NTQsMjMzLjM3M3ogTTIyMC4zMjYsMzgyLjE4NmwtMzIuMjAzLDMyLjIxOWMtMjQuOTUzLDI0LjkzOC02NS41NjMsMjQuOTM4LTkwLjUxNiwwDQoJYy0yNC45NTMtMjQuOTY5LTI0Ljk1My02NS41NjMsMC05MC41MzFsOTAuNTE2LTkwLjVjMjQuOTY5LTI0Ljk2OSw2NS41NDctMjQuOTY5LDkwLjUsMGM3Ljc5Nyw3Ljc5NywxMi44NzUsMTcuMjAzLDE1LjgxMywyNy4xMjUNCgljMi4zNzUtMS4zNzUsNC44MTMtMi41LDYuODEzLTQuNWw0Mi4wNjMtNDIuMDQ3Yy01LjM3NS05LjE1Ni0xMS41NjMtMTcuOTY5LTE5LjQzOC0yNS44MjhjLTQ5Ljk2OS00OS45ODQtMTMxLjAzMS00OS45ODQtMTgxLjAxNiwwDQoJbC05MC41LDkwLjVjLTQ5Ljk4NCw1MC00OS45ODQsMTMxLjAzMSwwLDE4MS4wMzFjNDkuOTg0LDQ5Ljk2OSwxMzEuMDMxLDQ5Ljk2OSwxODEuMDE2LDBsNjguNTk0LTY4LjU5NA0KCUMyNzQuNTYxLDM5NS4wOTIsMjQ2LjQyLDM5Mi4zNDIsMjIwLjMyNiwzODIuMTg2eiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 17 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnDQogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgdmlld0JveD0iMCAwIDExMCAxMTAiDQogICB2ZXJzaW9uPSIxLjEiDQogICB3aWR0aD0iNTAwIg0KICAgaGVpZ2h0PSI1MDAiPg0KICA8cGF0aA0KICAgICBkPSJNIDgyLjE4MjQyMiw4LjA1MjExMDcgQyA1Ni40NDc3NSwtNi45MDE4MTM3IDIzLjQ2MzE4NSwxLjgzNzcyNTggOC41MDkyNzA2LDI3LjU3MjM4IC02LjQ0NDY0MzQsNTMuMzA3MDM0IDIuMjk0ODM1Nyw4Ni4yOTE2MTYgMjguMDI5NTA4LDEwMS4yNDU1NCA1My43NjQxOCwxMTYuMTk5NDYgODYuNzQ4NzQ2LDEwNy40NTk5MyAxMDEuNzAyNjYsODEuNzI1MjcxIDExNi42NTY1Nyw1NS45OTA2MTYgMTA3LjkxNzA5LDIzLjAwNjAzNSA4Mi4xODI0MjIsOC4wNTIxMTA3IFogTSA3MS43NTYwMiwyOC41Nzg1NTMgODIuMjg2ODUsMzguODQ2OTg0IDY1LjQ1MzQ3OSw1Ni4zNzMyOTYgODMuMDY0NzM4LDczLjMxNDMwMSA3Mi43OTY5MzcsODMuODQ0NDg1IDU1LjE2OTczNiw2Ni42NTcwMzkgMzkuMDEwOTk4LDgzLjIyODcxMSAyOC40ODAxNjcsNzIuOTYwMjggNDQuNjM5Mzc4LDU2LjM4OTA2OSAyOC40MTUyMTEsNDAuNTY4NjMxIDM4LjY4MzAxMywzMC4wMzg0NDYgNTQuOTM4ODkzLDQ1Ljg1ODcxIFoiDQogICAgIHN0eWxlPSJmaWxsOiMwMDAwMDA7c3Ryb2tlLXdpZHRoOjEuMDY4MTI3NjMiIC8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 18 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIMDxQ3d8lonQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAEOSURBVEjH7dXNK0RhFAbwXxRyZyIlKwtlMbvZkUIW9rOThezEniIf/4E/UYgkGwskaTI2V51uF/NxZ6LuU+/ivec5z/Pe9+McSpQoUeK/YTgz38AEbgv2WcUkHvKCS2ilY7tA0/VU8w2NPMICHoP5TgGmy0HvBfXviNN4D+TdHkzn8BG05n9LmMJdSNjvwrSOZtjiWruJFdwE86MOTGshr4m1TlddxWsQOW5zwTFnsdtzquAyCJ39wJ3Fc+Cu9HozR3ERBE9zODOZF7FV1FtM8BSET0JsKC0MX7FG0VVuHFeZbR/Bffi22a8SO5Y58/inh/2u70lahVph7A2quVRxnZoeDLqzJTgvG3yJP4dPo59Rw97b1k8AAAAASUVORK5CYII="

/***/ }),
/* 19 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIMDx0nu7zDsAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAD+SURBVEjH7ZQxa8JQFIU/HFSqXQri1KHQwc2txaLi4N5NHMRNdFeoqPkH/YlFRRBxcVAREakuEQ7RiDWJWHgHAuHl3Pu9e/PuAyOjO1QM+L419BEYAjugdctKlzb08DSChkaBvgCn8v4VFPQBGAjIAsLARNbKQbR3LoCufAs5Kv/0CxoBfiRx74QnCczEU/EKjTv+qXXG+wwsxJvzMjIrSdS5cKMa835NpSNJ0P5DbEritkDh0sAnYCzBzSu6lbahO2Btb+asEsBGoHUP5+MF+JVcr27GN8fJrPkwEVnJt7Q7caSMmKo+3gFFabnrjJeAjwBuvbxbtUZGRkb/R3tcflA+OTpkkAAAAABJRU5ErkJggg=="

/***/ }),
/* 20 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ1bmRvIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtdW5kbyBmYS13LTE2IiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUxMiA1MTIiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTIxMi4zMzMgMjI0LjMzM0gxMmMtNi42MjcgMC0xMi01LjM3My0xMi0xMlYxMkMwIDUuMzczIDUuMzczIDAgMTIgMGg0OGM2LjYyNyAwIDEyIDUuMzczIDEyIDEydjc4LjExMkMxMTcuNzczIDM5LjI3OSAxODQuMjYgNy40NyAyNTguMTc1IDguMDA3YzEzNi45MDYuOTk0IDI0Ni40NDggMTExLjYyMyAyNDYuMTU3IDI0OC41MzJDNTA0LjA0MSAzOTMuMjU4IDM5My4xMiA1MDQgMjU2LjMzMyA1MDRjLTY0LjA4OSAwLTEyMi40OTYtMjQuMzEzLTE2Ni41MS02NC4yMTUtNS4wOTktNC42MjItNS4zMzQtMTIuNTU0LS40NjctMTcuNDJsMzMuOTY3LTMzLjk2N2M0LjQ3NC00LjQ3NCAxMS42NjItNC43MTcgMTYuNDAxLS41MjVDMTcwLjc2IDQxNS4zMzYgMjExLjU4IDQzMiAyNTYuMzMzIDQzMmM5Ny4yNjggMCAxNzYtNzguNzE2IDE3Ni0xNzYgMC05Ny4yNjctNzguNzE2LTE3Ni0xNzYtMTc2LTU4LjQ5NiAwLTExMC4yOCAyOC40NzYtMTQyLjI3NCA3Mi4zMzNoOTguMjc0YzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJ2NDhjMCA2LjYyNy01LjM3MyAxMi0xMiAxMnoiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 21 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzODQgNTEyIj48cGF0aCBkPSJNMjU2IDE0NFYzMmMwLTE3LjY3MyAxNC4zMjctMzIgMzItMzJzMzIgMTQuMzI3IDMyIDMydjExMmgtNjR6bTExMiAxNkgxNmMtOC44MzcgMC0xNiA3LjE2My0xNiAxNnYzMmMwIDguODM3IDcuMTYzIDE2IDE2IDE2aDE2djMyYzAgNzcuNDA2IDU0Ljk2OSAxNDEuOTcxIDEyOCAxNTYuNzk2VjUxMmg2NHYtOTkuMjA0YzczLjAzMS0xNC44MjUgMTI4LTc5LjM5IDEyOC0xNTYuNzk2di0zMmgxNmM4LjgzNyAwIDE2LTcuMTYzIDE2LTE2di0zMmMwLTguODM3LTcuMTYzLTE2LTE2LTE2em0tMjQwLTE2VjMyYzAtMTcuNjczLTE0LjMyNy0zMi0zMi0zMlM2NCAxNC4zMjcgNjQgMzJ2MTEyaDY0eiIvPjwvc3ZnPg=="

/***/ }),
/* 22 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NzYgNTEyIj48cGF0aCBkPSJNNDAyLjYgODMuMmw5MC4yIDkwLjJjMy44IDMuOCAzLjggMTAgMCAxMy44TDI3NC40IDQwNS42bC05Mi44IDEwLjNjLTEyLjQgMS40LTIyLjktOS4xLTIxLjUtMjEuNWwxMC4zLTkyLjhMMzg4LjggODMuMmMzLjgtMy44IDEwLTMuOCAxMy44IDB6bTE2Mi0yMi45bC00OC44LTQ4LjhjLTE1LjItMTUuMi0zOS45LTE1LjItNTUuMiAwbC0zNS40IDM1LjRjLTMuOCAzLjgtMy44IDEwIDAgMTMuOGw5MC4yIDkwLjJjMy44IDMuOCAxMCAzLjggMTMuOCAwbDM1LjQtMzUuNGMxNS4yLTE1LjMgMTUuMi00MCAwLTU1LjJ6TTM4NCAzNDYuMlY0NDhINjRWMTI4aDIyOS44YzMuMiAwIDYuMi0xLjMgOC41LTMuNWw0MC00MGM3LjYtNy42IDIuMi0yMC41LTguNS0yMC41SDQ4QzIxLjUgNjQgMCA4NS41IDAgMTEydjM1MmMwIDI2LjUgMjEuNSA0OCA0OCA0OGgzNTJjMjYuNSAwIDQ4LTIxLjUgNDgtNDhWMzA2LjJjMC0xMC43LTEyLjktMTYtMjAuNS04LjVsLTQwIDQwYy0yLjIgMi4zLTMuNSA1LjMtMy41IDguNXoiLz48L3N2Zz4="

/***/ }),
/* 23 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBkPSJNMCA4NFY1NmMwLTEzLjMgMTAuNy0yNCAyNC0yNGgxMTJsOS40LTE4LjdjNC04LjIgMTIuMy0xMy4zIDIxLjQtMTMuM2gxMTQuM2M5LjEgMCAxNy40IDUuMSAyMS41IDEzLjNMMzEyIDMyaDExMmMxMy4zIDAgMjQgMTAuNyAyNCAyNHYyOGMwIDYuNi01LjQgMTItMTIgMTJIMTJDNS40IDk2IDAgOTAuNiAwIDg0em00MTYgNTZ2MzI0YzAgMjYuNS0yMS41IDQ4LTQ4IDQ4SDgwYy0yNi41IDAtNDgtMjEuNS00OC00OFYxNDBjMC02LjYgNS40LTEyIDEyLTEyaDM2MGM2LjYgMCAxMiA1LjQgMTIgMTJ6bS0yNzIgNjhjMC04LjgtNy4yLTE2LTE2LTE2cy0xNiA3LjItMTYgMTZ2MjI0YzAgOC44IDcuMiAxNiAxNiAxNnMxNi03LjIgMTYtMTZWMjA4em05NiAwYzAtOC44LTcuMi0xNi0xNi0xNnMtMTYgNy4yLTE2IDE2djIyNGMwIDguOCA3LjIgMTYgMTYgMTZzMTYtNy4yIDE2LTE2VjIwOHptOTYgMGMwLTguOC03LjItMTYtMTYtMTZzLTE2IDcuMi0xNiAxNnYyMjRjMCA4LjggNy4yIDE2IDE2IDE2czE2LTcuMiAxNi0xNlYyMDh6Ii8+PC9zdmc+"

/***/ }),
/* 24 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJwZW4tc3F1YXJlIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtcGVuLXNxdWFyZSBmYS13LTE0IiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ0OCA1MTIiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTQwMCA0ODBINDhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4VjgwYzAtMjYuNSAyMS41LTQ4IDQ4LTQ4aDM1MmMyNi41IDAgNDggMjEuNSA0OCA0OHYzNTJjMCAyNi41LTIxLjUgNDgtNDggNDh6TTIzOC4xIDE3Ny45TDEwMi40IDMxMy42bC02LjMgNTcuMWMtLjggNy42IDUuNiAxNC4xIDEzLjMgMTMuM2w1Ny4xLTYuM0wzMDIuMiAyNDJjMi4zLTIuMyAyLjMtNi4xIDAtOC41TDI0Ni43IDE3OGMtMi41LTIuNC02LjMtMi40LTguNi0uMXpNMzQ1IDE2NS4xTDMxNC45IDEzNWMtOS40LTkuNC0yNC42LTkuNC0zMy45IDBsLTIzLjEgMjMuMWMtMi4zIDIuMy0yLjMgNi4xIDAgOC41bDU1LjUgNTUuNWMyLjMgMi4zIDYuMSAyLjMgOC41IDBMMzQ1IDE5OWM5LjMtOS4zIDkuMy0yNC41IDAtMzMuOXoiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 25 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhciIgZGF0YS1pY29uPSJtaW51cy1zcXVhcmUiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1taW51cy1zcXVhcmUgZmEtdy0xNCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xMDggMjg0Yy02LjYgMC0xMi01LjQtMTItMTJ2LTMyYzAtNi42IDUuNC0xMiAxMi0xMmgyMzJjNi42IDAgMTIgNS40IDEyIDEydjMyYzAgNi42LTUuNCAxMi0xMiAxMkgxMDh6TTQ0OCA4MHYzNTJjMCAyNi41LTIxLjUgNDgtNDggNDhINDhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4VjgwYzAtMjYuNSAyMS41LTQ4IDQ4LTQ4aDM1MmMyNi41IDAgNDggMjEuNSA0OCA0OHptLTQ4IDM0NlY4NmMwLTMuMy0yLjctNi02LTZINTRjLTMuMyAwLTYgMi43LTYgNnYzNDBjMCAzLjMgMi43IDYgNiA2aDM0MGMzLjMgMCA2LTIuNyA2LTZ6Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 26 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhciIgZGF0YS1pY29uPSJwbHVzLXNxdWFyZSIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLXBsdXMtc3F1YXJlIGZhLXctMTQiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDQ4IDUxMiI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMzUyIDI0MHYzMmMwIDYuNi01LjQgMTItMTIgMTJoLTg4djg4YzAgNi42LTUuNCAxMi0xMiAxMmgtMzJjLTYuNiAwLTEyLTUuNC0xMi0xMnYtODhoLTg4Yy02LjYgMC0xMi01LjQtMTItMTJ2LTMyYzAtNi42IDUuNC0xMiAxMi0xMmg4OHYtODhjMC02LjYgNS40LTEyIDEyLTEyaDMyYzYuNiAwIDEyIDUuNCAxMiAxMnY4OGg4OGM2LjYgMCAxMiA1LjQgMTIgMTJ6bTk2LTE2MHYzNTJjMCAyNi41LTIxLjUgNDgtNDggNDhINDhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4VjgwYzAtMjYuNSAyMS41LTQ4IDQ4LTQ4aDM1MmMyNi41IDAgNDggMjEuNSA0OCA0OHptLTQ4IDM0NlY4NmMwLTMuMy0yLjctNi02LTZINTRjLTMuMyAwLTYgMi43LTYgNnYzNDBjMCAzLjMgMi43IDYgNiA2aDM0MGMzLjMgMCA2LTIuNyA2LTZ6Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 27 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAACXSURBVHjaYvz//z8DIbBlyxYmIDUTiI/6+PgsQJZjJGQAVPMcIE4E4n9AnAA0ZDFRBqBphoELQGwKNOQPiMNEoubLQOwG04zTADyanYGaXyOrZaJEM4YBpGpGMYAczXgDkVgANwBoCyiOU4B4PpK8LhDvBbpOlCgXkGMIhhdINQRrGJBiCO2SMg6XgPh9yEmZkdLsDBBgAMUxZ3KEE1BeAAAAAElFTkSuQmCC"

/***/ }),
/* 28 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAACXSURBVHjaYvz//z8DIfD+/XsmIDUTiI8KCgouQJZjJGQAVPMcIE4E4n9AnAA0ZDFRBqBphoELQGwKNOQPiMNEoubLQOwG04zTADyanYGaXyOrZaJEM4YBpGpGMYAczXgDkVgANwBoCyiOU4B4PpK8LhDvBbpOlCgXkGMIhhdINQRrGJBiCO2SMg6XgPh9yEmZkdLsDBBgAKQBZhCkUF/8AAAAAElFTkSuQmCC"

/***/ }),
/* 29 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAACdSURBVHjaYvz//z8DMtiyZUsCkLIG4nQfH59/DAQAI7IBQM2xQGoBEDMB8XwgTiFkCNwAoGYWIHUaiA2Q5AkawgRjABX9AVJuQHwZST4RiOcADWciaADUkNdAypkUQzAESTUEq6mkGILTb8QawsRAIcBpANAWUSC1F4h18UUrEyWasRpAimYMA0jVTJOk3AfE/4jVjJEbycnOAAEGABIyZ3LVo9KqAAAAAElFTkSuQmCC"

/***/ }),
/* 30 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAACeSURBVHjaYvz//z8DMnj//n0CkLIG4nRBQcF/DAQAC5rmWCA1F4iZgJgZyE8hZAgjzAVAxSDDTgOxAZL8fCDGawgTjAFU9AdIuQHxZST5RCCeAzSciaABUENeAylnUgzBECTVEKymkmIITr8RawgTA4UApwFAW0SB1F4g1sUXrUyUaMZqACmaMQwgVTNNknIfEP8jVjOKC8jNzgABBgBosmVE6sxD1QAAAABJRU5ErkJggg=="

/***/ }),
/* 31 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAHElEQVQIW2PcvHnzf19fX0YGKIAzMARgKjFUAABdvQgFy9518AAAAABJRU5ErkJggg=="

/***/ }),
/* 32 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA30lEQVQ4T7WTzw2CMBSH37Ou4BiemICYeODABiYSmcAJOoELiPHgBiXhYGKYgBNjuIJQ80ghBfsaEmKPbb/v90v/ICwcuJAHr0BKuaIAKWXLBbECgoMgyAisqirlJE6BBScm+c5JfgQOuG/vlIwEHpiVDAIGrg25tQ5x1KQTcLAQYkfrTdO8AMApQR8cRdGbBEVRbDgJ5nl+BYDUqlhTcg/384wkQ6XUERFvAECPxgkzklZrferOQCl1QMSzEGI/TZ6+QNPkqbW+xHH8GG6hLMt1GIafOX/D3vvfzzSnzRcwRIO9lTALYQAAAABJRU5ErkJggg=="

/***/ }),
/* 33 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1ElEQVQ4T7WTQQrCMBBF88Usu2jBY3gKwVsIij2BB/ECVlx4C8FT9BhCZ9FlpV9SmlJrphSKWSZ57w+ZCczMhZm8GRWQXLgAALUWpAocXBRF5sAkSVJNEhR4GMDBCUjeNMmPYAj70jXJl0CDxySdQIHzFl5rkkagwdbajTuvquppjAlKMAZHUfRygrIsV6pERC4k016fc5fsYb8fkgDIICJ7kldjjBuaIKxIagDH5g1EZEfyZK3dDpOHE9hW8gBwjuP43u/CEsB7yt8g2d3972eaUs0Hvw2bpYUKd8YAAAAASUVORK5CYII="

/***/ }),
/* 34 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA60lEQVQ4T62TzQ2CQBBGv3FtwTI8UQEx8cCBDkw0UoEVbAU2IMaDHSwJBxNDBZwswxZc1ixhCbI/IUGOy7w3s7MzhJkfzeTRC6qqWsZx/JkiHMa2AiHEjohOjLFtkiTvkKQsy5WU8qGUOqdpeichxJ6IrgAWAF6MsY1P0sFPAGsAjVLqSEVRXABkg6xOyQg24TlxzhdRFOUADj6JB77VdZ21PQhJ9H8ppSnb5GhhznnTv4JP0hH6zhasD37mwCMZPkqf2RxagxSQWLBVgbE6JE7YKxg1FqZhrgEL7oKupJM1vun83zJNWSJXzBeWo4O9On9s3QAAAABJRU5ErkJggg=="

/***/ }),
/* 35 */
/***/ ((module) => {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA5klEQVQ4T62TQQrCMBBF5xez7KIFj+EpBG8hKPYEHsQLWHHhLQRP4TGEZtFlpF8S2hJtUgo1q5DMf/NnJoHMXJiplx5AcgHgPQXoxzqA1npL8qiU2qRp+hqD1HW9NMbcAZyyLLtBa70jeRGRRESeSql1DNKKHyKyEpEGwMECziQLL2sQ8iN24QBKkEyqqioB7GOQkJjkNc/zwvVgDGLvjTGdbZejFwONP4Wgk9aVrXkgdmX4HY846UP8zN3h4CHFICHxwIFn86ucmDgK8Btr967bQBN6YKN/wZbTzjsoHnUw5U/8BfABHFmbpQyQ0q0AAAAASUVORK5CYII="

/***/ }),
/* 36 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9JzEyJyBoZWlnaHQ9JzEyJyB2aWV3Qm94PScwIDAgNDY5LjMzMyA0NjkuMzMzJz4NCiAgICA8cGF0aCBmaWxsPScjMzMzJyBkPSdNNDQ4LDBIMjEuMzMzQzkuNTUyLDAsMCw5LjU1MiwwLDIxLjMzM1Y0NDhjMCwxMS43ODEsOS41NTIsMjEuMzMzLDIxLjMzMywyMS4zMzNINDQ4YzExLjc4MSwwLDIxLjMzMy05LjU1MiwyMS4zMzMtMjEuMzMzVjIxLjMzM0M0NjkuMzMzLDkuNTUyLDQ1OS43ODEsMCw0NDgsMHogTTEzOC42NjcsNDI2LjY2N2gtOTZ2LTM4NGg5NlY0MjYuNjY3ek00MjYuNjY3LDQyNi42NjdIMTgxLjMzM3YtMzg0aDI0NS4zMzNWNDI2LjY2N3onLz4NCjwvc3ZnPg0K"

/***/ }),
/* 37 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9JzEyJyBoZWlnaHQ9JzEyJyB2aWV3Qm94PScwIDAgNDY5LjMzMyA0NjkuMzMzJz4NCiAgICA8cGF0aCBmaWxsPScjMzMzJyBkPSdNNDQ4LDBIMjEuMzMzQzkuNTUyLDAsMCw5LjU1MiwwLDIxLjMzM1Y0NDhjMCwxMS43ODEsOS41NTIsMjEuMzMzLDIxLjMzMywyMS4zMzNINDQ4YzExLjc4MSwwLDIxLjMzMy05LjU1MiwyMS4zMzMtMjEuMzMzVjIxLjMzM0M0NjkuMzMzLDkuNTUyLDQ1OS43ODEsMCw0NDgsMHogTTI4OCw0MjYuNjY3SDQyLjY2N3YtMzg0SDI4OFY0MjYuNjY3ek00MjYuNjY3LDQyNi42NjdoLTk2di0zODRoOTZWNDI2LjY2N3onLz4NCjwvc3ZnPg0K"

/***/ }),
/* 38 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9JzEyJyBoZWlnaHQ9JzEyJyB2aWV3Qm94PScwIDAgNDY5LjMzMyA0NjkuMzMzJz4NCiAgICA8cGF0aCBmaWxsPScjMzMzJyBkPSdtIDMwLjUsMjM1LjY2MDg0IDAsLTIwNS4yMDgyNTkgNTkuNjgzNSwwIDU5LjY4MzUyLDAgMCwyMDUuMjA4MjU5IDAsMjA1LjIwODI4IC01OS42ODM1MiwwIC01OS42ODM1LDAgMCwtMjA1LjIwODI4IHonLz4NCiAgICA8cGF0aCBmaWxsPScjMzMzJyBkPSdNNDQ4LDBIMjEuMzMzQzkuNTUyLDAsMCw5LjU1MiwwLDIxLjMzM1Y0NDhjMCwxMS43ODEsOS41NTIsMjEuMzMzLDIxLjMzMywyMS4zMzNINDQ4YzExLjc4MSwwLDIxLjMzMy05LjU1MiwyMS4zMzMtMjEuMzMzVjIxLjMzM0M0NjkuMzMzLDkuNTUyLDQ1OS43ODEsMCw0NDgsMHogTTEzOC42NjcsNDI2LjY2N2gtOTZ2LTM4NGg5NlY0MjYuNjY3ek00MjYuNjY3LDQyNi42NjdIMTgxLjMzM3YtMzg0aDI0NS4zMzNWNDI2LjY2N3onLz4NCjwvc3ZnPg0K"

/***/ }),
/* 39 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9JzEyJyBoZWlnaHQ9JzEyJyB2aWV3Qm94PScwIDAgNDY5LjMzMyA0NjkuMzMzJz4NCiAgICA8cGF0aCBmaWxsPScjMzMzJyBkPSdtIDMxOC45MTQ5LDIzMy41MDgxNiAwLC0yMDUuMjA4MjYyIDU5LjY4MzUsMCA1OS42ODM1MSwwIDAsMjA1LjIwODI2MiAwLDIwNS4yMDgyOCAtNTkuNjgzNTEsMCAtNTkuNjgzNSwwIDAsLTIwNS4yMDgyOCB6Jy8+DQogICAgPHBhdGggZmlsbD0nIzMzMycgZD0nTTQ0OCwwSDIxLjMzM0M5LjU1MiwwLDAsOS41NTIsMCwyMS4zMzNWNDQ4YzAsMTEuNzgxLDkuNTUyLDIxLjMzMywyMS4zMzMsMjEuMzMzSDQ0OGMxMS43ODEsMCwyMS4zMzMtOS41NTIsMjEuMzMzLTIxLjMzM1YyMS4zMzNDNDY5LjMzMyw5LjU1Miw0NTkuNzgxLDAsNDQ4LDB6IE0yODgsNDI2LjY2N0g0Mi42Njd2LTM4NEgyODhWNDI2LjY2N3pNNDI2LjY2Nyw0MjYuNjY3aC05NnYtMzg0aDk2VjQyNi42Njd6Jy8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 40 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__40__;

/***/ }),
/* 41 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/** Empty module for conditional compilation. */
// tslint:disable-next-line:no-default-export
exports["default"] = undefined;


/***/ }),
/* 42 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isIE11 = void 0;
function isIE11() {
    return !(window.ActiveXObject) && 'ActiveXObject' in window;
}
exports.isIE11 = isIE11;
if (typeof Math.sign === 'undefined') {
    Math.sign = function (n) {
        if (n > 0) {
            return 1;
        }
        else if (n < 0) {
            return -1;
        }
        else {
            return 0;
        }
    };
}
if (typeof Number.isNaN === 'undefined') {
    Number.isNaN = function (value) {
        return typeof value === 'number' && isNaN(value);
    };
}
if (typeof Number.isFinite === 'undefined') {
    Number.isFinite = function (n) {
        return n !== Infinity && n !== -Infinity && !Number.isNaN(n);
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
// tslint:disable
if (!Array.prototype.find) {
    const arrayFind = function (predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;
        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];
        // 5. Let k be 0.
        var k = 0;
        // 6. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
            }
            // e. Increase k by 1.
            k++;
        }
        // 7. Return undefined.
        return undefined;
    };
    Object.defineProperty(Array.prototype, 'find', { value: arrayFind });
}
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}
// tslint:enable
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null) {
                    this.parentNode.removeChild(this);
                }
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


/***/ }),
/* 43 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),
/* 44 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultElementTemplateBundle = void 0;
const tslib_1 = __webpack_require__(1);
tslib_1.__exportStar(__webpack_require__(45), exports);
tslib_1.__exportStar(__webpack_require__(50), exports);
tslib_1.__exportStar(__webpack_require__(86), exports);
exports.DefaultElementTemplateBundle = types => undefined;


/***/ }),
/* 45 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultElementTemplate = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const utils_1 = __webpack_require__(47);
const CLASS_NAME = 'ontodia-default-template';
class DefaultElementTemplate extends React.Component {
    render() {
        const props = this.props;
        const image = props.imgUrl ? (React.createElement("div", { className: `${CLASS_NAME}__thumbnail` },
            React.createElement("img", { src: props.imgUrl }))) : undefined;
        const expander = props.isExpanded ? (React.createElement("div", null,
            React.createElement("div", { className: 'ontodia-default-template_body_expander' },
                React.createElement("div", { className: 'ontodia-default-template_body_expander__iri_label' }, "IRI:"),
                React.createElement("div", { className: 'ontodia-default-template_body_expander_iri' },
                    React.createElement("a", { className: 'ontodia-default-template_body_expander_iri__link', href: props.iri, title: props.iri }, props.iri))),
            React.createElement("hr", { className: 'ontodia-default-template_body_expander__hr' }),
            this.renderPropertyTable())) : null;
        return (React.createElement("div", { className: 'ontodia-default-template', style: {
                backgroundColor: props.color,
                borderColor: props.color,
            }, "data-expanded": this.props.isExpanded },
            React.createElement("div", { className: 'ontodia-default-template_type-line', title: props.label },
                React.createElement("div", { className: 'ontodia-default-template_type-line__icon', "aria-hidden": 'true' },
                    React.createElement("img", { src: props.iconUrl })),
                React.createElement("div", { title: props.types, className: 'ontodia-default-template_type-line_text-container' },
                    React.createElement("div", { className: 'ontodia-default-template_type-line_text-container__text' }, props.types))),
            image,
            React.createElement("div", { className: 'ontodia-default-template_body', style: { borderColor: props.color } },
                React.createElement("span", { className: 'ontodia-default-template_body__label', title: props.label }, props.label),
                expander)));
    }
    renderPropertyTable() {
        const { propsAsList } = this.props;
        if (propsAsList && propsAsList.length > 0) {
            return React.createElement("div", { className: 'ontodia-default-template_body_expander_property-table' }, propsAsList.map(prop => {
                const propertyValues = utils_1.getPropertyValues(prop.property);
                const values = propertyValues.map((text, index) => (React.createElement("div", { className: 'ontodia-default-template_body_expander_property-table_row_key_values__value', key: index, title: text }, text)));
                return (React.createElement("div", { key: prop.id, className: 'ontodia-default-template_body_expander_property-table_row' },
                    React.createElement("div", { title: prop.name + ' (' + prop.id + ')', className: 'ontodia-default-template_body_expander_property-table_row__key' }, prop.name),
                    React.createElement("div", { className: 'ontodia-default-template_body_expander_property-table_row_key_values' }, values)));
            }));
        }
        else {
            return React.createElement("div", null, "no properties");
        }
    }
}
exports.DefaultElementTemplate = DefaultElementTemplate;


/***/ }),
/* 46 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__46__;

/***/ }),
/* 47 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getPropertyValues = exports.getProperty = void 0;
const model_1 = __webpack_require__(48);
function getProperty(props, id) {
    if (props && props[id]) {
        return getPropertyValues(props[id]).join(', ');
    }
    else {
        return undefined;
    }
}
exports.getProperty = getProperty;
function getPropertyValues(property) {
    if (model_1.isIriProperty(property)) {
        return property.values.map(({ value }) => value);
    }
    else if (model_1.isLiteralProperty(property)) {
        return property.values.map(({ text }) => text);
    }
    return [];
}
exports.getPropertyValues = getPropertyValues;


/***/ }),
/* 48 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sameElement = exports.hashLink = exports.sameLink = exports.isLiteralProperty = exports.isIriProperty = void 0;
const utils_1 = __webpack_require__(49);
function isIriProperty(e) {
    return e && e.type === 'uri';
}
exports.isIriProperty = isIriProperty;
function isLiteralProperty(e) {
    return e && e.type === 'string';
}
exports.isLiteralProperty = isLiteralProperty;
function sameLink(left, right) {
    return (left.linkTypeId === right.linkTypeId &&
        left.sourceId === right.sourceId &&
        left.targetId === right.targetId);
}
exports.sameLink = sameLink;
function hashLink(link) {
    const { linkTypeId, sourceId, targetId } = link;
    let hash = utils_1.hashFnv32a(linkTypeId);
    hash = hash * 31 + utils_1.hashFnv32a(sourceId);
    hash = hash * 31 + utils_1.hashFnv32a(targetId);
    return hash;
}
exports.hashLink = hashLink;
function sameElement(left, right) {
    return (left.id === right.id &&
        isArraysEqual(left.types, right.types) &&
        isLocalizedStringsEqual(left.label.values, right.label.values) &&
        left.image === right.image &&
        isPropertiesEqual(left.properties, right.properties) &&
        ((!left.sources && !right.sources) ||
            (left.sources && right.sources && isArraysEqual(left.sources, right.sources))));
}
exports.sameElement = sameElement;
function isArraysEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (let i = 0; i < left.length; i++) {
        if (left[i] !== right[i]) {
            return false;
        }
    }
    return true;
}
function isLocalizedStringsEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (let i = 0; i < left.length; i++) {
        const leftValue = left[i];
        const rightValue = right[i];
        if (leftValue.text !== rightValue.text || leftValue.lang !== rightValue.lang) {
            return false;
        }
    }
    return true;
}
function isIriPropertiesEqual(left, right) {
    if (!isIriProperty(left) || !isIriProperty(right)) {
        return false;
    }
    if (left.values.length !== right.values.length) {
        return false;
    }
    for (let i = 0; i < left.values.length; i++) {
        const leftValue = left.values[i];
        const rightValue = right.values[i];
        if (leftValue.value !== rightValue.value) {
            return false;
        }
    }
    return true;
}
function isLiteralPropertiesEqual(left, right) {
    if (!isLiteralProperty(left) || !isLiteralProperty(right)) {
        return false;
    }
    return isLocalizedStringsEqual(left.values, right.values);
}
function isPropertiesEqual(left, right) {
    if (Object.keys(left).length !== Object.keys(right).length) {
        return false;
    }
    for (const key in left.properties) {
        if (left.properties.hasOwnProperty(key)) {
            const leftProperty = left[key];
            const rightProperty = right[key];
            if (!rightProperty) {
                return false;
            }
            if (!isIriPropertiesEqual(leftProperty, rightProperty) &&
                !isLiteralPropertiesEqual(leftProperty, rightProperty)) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 49 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getUriLocalName = exports.hashFnv32a = exports.generate128BitID = void 0;
/** Generates random 32-digit hexadecimal string. */
function generate128BitID() {
    function random32BitDigits() {
        return Math.floor((1 + Math.random()) * 0x100000000)
            .toString(16).substring(1);
    }
    // generate by half because of restricted numerical precision
    return random32BitDigits() + random32BitDigits() + random32BitDigits() + random32BitDigits();
}
exports.generate128BitID = generate128BitID;
/**
 * Calculate a 32 bit FNV-1a hash
 * Found here: https://gist.github.com/vaiorabbit/5657561
 * Ref.: http://isthe.com/chongo/tech/comp/fnv/
 *
 * @param {string} str the input value
 * @param {integer} [seed] optionally pass the hash of the previous chunk
 * @returns {integer}
 */
function hashFnv32a(str, seed = 0x811c9dc5) {
    /* tslint:disable:no-bitwise */
    let i, l, hval = seed & 0x7fffffff;
    for (i = 0, l = str.length; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return hval >>> 0;
    /* tslint:enable:no-bitwise */
}
exports.hashFnv32a = hashFnv32a;
/**
 * Extracts local name for URI the same way as it's done in RDF4J.
 */
function getUriLocalName(uri) {
    let index = uri.indexOf('#');
    if (index < 0) {
        index = uri.lastIndexOf('/');
    }
    if (index < 0) {
        index = uri.lastIndexOf(':');
    }
    if (index < 0) {
        return undefined;
    }
    return uri.substring(index + 1);
}
exports.getUriLocalName = getUriLocalName;


/***/ }),
/* 50 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GroupTemplate = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const embeddedLayer_1 = __webpack_require__(51);
const CLASS = 'ontodia-group-template';
class GroupTemplate extends React.Component {
    render() {
        const { label, iconUrl, types, color, isExpanded } = this.props;
        return (React.createElement("div", { className: CLASS },
            React.createElement("div", { className: `${CLASS}__wrap`, style: {
                    backgroundColor: color,
                    borderColor: color,
                } },
                React.createElement("div", { className: `${CLASS}__type-line`, title: label },
                    React.createElement("div", { className: `${CLASS}__type-line-icon` },
                        React.createElement("img", { src: iconUrl })),
                    React.createElement("div", { title: types, className: `${CLASS}__type-line-text-container` },
                        React.createElement("div", { className: `${CLASS}__type-line-text` }, types))),
                React.createElement("div", { className: `${CLASS}__body`, style: { borderColor: color } },
                    React.createElement("span", { className: `${CLASS}__label`, title: label }, label),
                    isExpanded ? (React.createElement("div", { className: `${CLASS}__embedded-layer` },
                        React.createElement(embeddedLayer_1.EmbeddedLayer, null))) : null))));
    }
}
exports.GroupTemplate = GroupTemplate;


/***/ }),
/* 51 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EmbeddedLayer = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const paper_1 = __webpack_require__(52);
const paperArea_1 = __webpack_require__(83);
const elements_1 = __webpack_require__(53);
const elementLayer_1 = __webpack_require__(58);
const events_1 = __webpack_require__(55);
const paperArea_2 = __webpack_require__(83);
class EmbeddedLayer extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.nestedElementListener = new events_1.EventObserver();
        this.layerOffsetLeft = 0;
        this.layerOffsetTop = 0;
        this.isApplyingParentMove = false;
        this.isNestedElementMoving = false;
        this.previousPositions = [];
        this.moveNestedElements = (offsetX, offsetY) => {
            this.isApplyingParentMove = true;
            try {
                for (const element of this.getNestedElements()) {
                    const { x, y } = element.position;
                    const newPosition = { x: x + offsetX, y: y + offsetY };
                    element.setPosition(newPosition);
                }
            }
            finally {
                this.isApplyingParentMove = false;
                this.recomputeSelfBounds();
            }
        };
        this.recomputeSelfBounds = () => {
            if (this.isApplyingParentMove) {
                return;
            }
            const { element } = this.context.ontodiaElement;
            const { x: offsetX, y: offsetY, width: paperWidth, height: paperHeight } = this.getContentFittingBox();
            if (this.isNestedElementMoving) {
                const position = {
                    x: offsetX - this.layerOffsetLeft,
                    y: offsetY - this.layerOffsetTop,
                };
                element.setPosition(position);
            }
            this.setState({ offsetX, offsetY, paperWidth, paperHeight }, () => element.redraw());
        };
        this.onPaperPointerDown = (e, cell) => {
            if (e.button !== 0 /* left mouse button */) {
                return;
            }
            if (cell && cell instanceof elements_1.Element) {
                e.preventDefault();
                this.isNestedElementMoving = true;
            }
        };
        this.onLayerInit = (layer) => {
            if (!layer) {
                return;
            }
            const { left, top } = this.calculateOffset(layer);
            this.layerOffsetLeft = left;
            this.layerOffsetTop = top;
        };
        this.state = { paperWidth: 0, paperHeight: 0, offsetX: 0, offsetY: 0 };
    }
    componentDidMount() {
        const { element } = this.context.ontodiaElement;
        const { paperArea, view } = this.context.ontodiaPaperArea;
        this.listener.listen(view.model.events, 'changeGroupContent', ({ group }) => {
            if (group === element.id) {
                this.listenNestedElements(this.getNestedElements());
                const { offsetX, offsetY } = this.getOffset();
                this.moveNestedElements(offsetX, offsetY);
            }
        });
        this.listener.listen(element.events, 'changePosition', () => {
            if (this.isNestedElementMoving) {
                return;
            }
            const { offsetX, offsetY } = this.getOffset();
            const { x, y } = this.getContentFittingBox();
            const diffX = offsetX - x;
            const diffY = offsetY - y;
            this.moveNestedElements(diffX, diffY);
            this.setState({ offsetX, offsetY });
        });
        this.listener.listen(paperArea.events, 'pointerUp', e => {
            this.isNestedElementMoving = false;
        });
        const nestedElements = this.getNestedElements();
        this.listenNestedElements(nestedElements);
        if (nestedElements.length > 0) {
            const { x: offsetX, y: offsetY, width: paperWidth, height: paperHeight, } = this.getContentFittingBox();
            this.setState({ offsetX, offsetY, paperWidth, paperHeight }, () => element.redraw());
        }
        else {
            element.requestGroupContent();
        }
    }
    listenNestedElements(nestedElements) {
        const listener = new events_1.EventObserver();
        for (const nestedElement of nestedElements) {
            listener.listen(nestedElement.events, 'changePosition', this.recomputeSelfBounds);
            listener.listen(nestedElement.events, 'changeSize', this.recomputeSelfBounds);
        }
        this.nestedElementListener.stopListening();
        this.nestedElementListener = listener;
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.nestedElementListener.stopListening();
        this.removeElements();
        this.setState({ paperWidth: 0, paperHeight: 0, offsetX: 0, offsetY: 0 });
    }
    getNestedElements() {
        const { element } = this.context.ontodiaElement;
        const { view } = this.context.ontodiaPaperArea;
        return view.model.elements.filter(el => el.group === element.id);
    }
    getContentFittingBox() {
        const nestedElements = this.getNestedElements();
        return paperArea_2.getContentFittingBox(nestedElements, []);
    }
    removeElements() {
        const { view } = this.context.ontodiaPaperArea;
        const batch = view.model.history.startBatch();
        for (const element of this.getNestedElements()) {
            view.model.removeElement(element.id);
        }
        batch.discard();
    }
    getOffset() {
        const { element } = this.context.ontodiaElement;
        const { x: elementX, y: elementY } = element.position;
        const offsetX = elementX + this.layerOffsetLeft;
        const offsetY = elementY + this.layerOffsetTop;
        return { offsetX, offsetY };
    }
    calculateOffset(layer) {
        const { paperArea } = this.context.ontodiaPaperArea;
        const scale = paperArea.getScale();
        const parent = findParentElement(layer);
        const { left, top } = layer.getBoundingClientRect();
        const { left: parentLeft, top: parentTop } = parent.getBoundingClientRect();
        return { left: (left - parentLeft) / scale, top: (top - parentTop) / scale };
    }
    render() {
        const { element } = this.context.ontodiaElement;
        const { view } = this.context.ontodiaPaperArea;
        const { paperWidth, paperHeight, offsetX, offsetY } = this.state;
        const paperTransform = {
            width: paperWidth,
            height: paperHeight,
            originX: -offsetX,
            originY: -offsetY,
            scale: 1,
            paddingX: 0,
            paddingY: 0,
        };
        return (React.createElement("div", { className: 'ontodia-embedded-layer', ref: this.onLayerInit },
            React.createElement(paper_1.Paper, { view: view, paperTransform: paperTransform, onPointerDown: this.onPaperPointerDown, group: element.id })));
    }
}
exports.EmbeddedLayer = EmbeddedLayer;
EmbeddedLayer.contextTypes = Object.assign(Object.assign({}, elementLayer_1.ElementContextTypes), paperArea_1.PaperAreaContextTypes);
function findParentElement(layer) {
    const parent = layer.parentElement;
    if (!parent) {
        throw new Error('Cannot find parent diagram element for EmbeddedLayer');
    }
    else if (parent.hasAttribute('data-element-id')) {
        return parent;
    }
    else {
        return findParentElement(parent);
    }
}


/***/ }),
/* 52 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paperFromPaneCoords = exports.paneFromPaperCoords = exports.paneTopLeft = exports.totalPaneSize = exports.TransformedSvgCanvas = exports.Paper = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const react_1 = __webpack_require__(46);
const elements_1 = __webpack_require__(53);
const elementLayer_1 = __webpack_require__(58);
const linkLayer_1 = __webpack_require__(82);
const CLASS_NAME = 'ontodia-paper';
class Paper extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onMouseDown = (e) => {
            const { view, onPointerDown } = this.props;
            const cell = e.target instanceof Element
                ? findCell(e.target, e.currentTarget, view.model) : undefined;
            if (onPointerDown) {
                onPointerDown(e, cell);
            }
        };
    }
    render() {
        const { view, group, paperTransform, linkLayerWidgets, elementLayerWidgets } = this.props;
        const { width, height, originX, originY, scale, paddingX, paddingY } = paperTransform;
        const scaledWidth = width * scale;
        const scaledHeight = height * scale;
        // using padding instead of margin in combination with setting width and height
        // on .paper element to avoid "over-constrained" margins, see an explanation here:
        // https://stackoverflow.com/questions/11695354
        const style = {
            width: scaledWidth + paddingX,
            height: scaledHeight + paddingY,
            marginLeft: paddingX,
            marginTop: paddingY,
            paddingRight: paddingX,
            paddingBottom: paddingY,
        };
        const htmlTransformStyle = {
            position: 'absolute', left: 0, top: 0,
            transform: `scale(${scale},${scale})translate(${originX}px,${originY}px)`,
        };
        return (React.createElement("div", { className: CLASS_NAME, style: style, onMouseDown: this.onMouseDown },
            React.createElement(TransformedSvgCanvas, { className: `${CLASS_NAME}__canvas`, style: { overflow: 'visible' }, paperTransform: paperTransform },
                React.createElement(linkLayer_1.LinkMarkers, { view: view }),
                React.createElement(linkLayer_1.LinkLayer, { view: view, links: view.model.links, group: group })),
            linkLayerWidgets,
            React.createElement(elementLayer_1.ElementLayer, { view: view, group: group, style: htmlTransformStyle }),
            elementLayerWidgets));
    }
}
exports.Paper = Paper;
function findCell(bottom, top, model) {
    let target = bottom;
    let vertexIndex;
    while (true) {
        if (target instanceof Element) {
            if (target.hasAttribute('data-element-id')) {
                return model.getElement(target.getAttribute('data-element-id'));
            }
            else if (target.hasAttribute('data-link-id')) {
                const link = model.getLinkById(target.getAttribute('data-link-id'));
                return typeof vertexIndex === 'number' ? new elements_1.LinkVertex(link, vertexIndex) : link;
            }
            else if (target.hasAttribute('data-vertex')) {
                vertexIndex = Number(target.getAttribute('data-vertex'));
            }
        }
        if (!target || target === top) {
            break;
        }
        target = target.parentNode;
    }
    return undefined;
}
class TransformedSvgCanvas extends react_1.Component {
    render() {
        const _a = this.props, { paperTransform, style, children } = _a, otherProps = tslib_1.__rest(_a, ["paperTransform", "style", "children"]);
        const { width, height, originX, originY, scale, paddingX, paddingY } = paperTransform;
        const scaledWidth = width * scale;
        const scaledHeight = height * scale;
        let svgStyle = TransformedSvgCanvas.SVG_STYLE;
        if (style) {
            svgStyle = Object.assign(Object.assign({}, svgStyle), style);
        }
        return (React.createElement("svg", Object.assign({ width: scaledWidth, height: scaledHeight, style: svgStyle }, otherProps),
            React.createElement("g", { transform: `scale(${scale},${scale})translate(${originX},${originY})` }, children)));
    }
}
exports.TransformedSvgCanvas = TransformedSvgCanvas;
TransformedSvgCanvas.SVG_STYLE = {
    position: 'absolute',
    top: 0,
    left: 0,
};
/**
 * @returns scrollable pane size in non-scaled pane coords.
 */
function totalPaneSize(pt) {
    return {
        x: pt.width * pt.scale + pt.paddingX * 2,
        y: pt.height * pt.scale + pt.paddingY * 2,
    };
}
exports.totalPaneSize = totalPaneSize;
/**
 * @returns scrollable pane top-left corner position in non-scaled pane coords.
 */
function paneTopLeft(pt) {
    return { x: -pt.paddingX, y: -pt.paddingY };
}
exports.paneTopLeft = paneTopLeft;
function paneFromPaperCoords(paper, pt) {
    return {
        x: (paper.x + pt.originX) * pt.scale,
        y: (paper.y + pt.originY) * pt.scale,
    };
}
exports.paneFromPaperCoords = paneFromPaperCoords;
function paperFromPaneCoords(pane, pt) {
    return {
        x: pane.x / pt.scale - pt.originX,
        y: pane.y / pt.scale - pt.originY,
    };
}
exports.paperFromPaneCoords = paperFromPaneCoords;


/***/ }),
/* 53 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkVertex = exports.FatLinkType = exports.linkMarkerKey = exports.Link = exports.RichProperty = exports.FatClassModel = exports.Element = exports.LinkDirection = void 0;
const schema_1 = __webpack_require__(54);
const events_1 = __webpack_require__(55);
const geometry_1 = __webpack_require__(57);
var LinkDirection;
(function (LinkDirection) {
    LinkDirection["in"] = "in";
    LinkDirection["out"] = "out";
})(LinkDirection = exports.LinkDirection || (exports.LinkDirection = {}));
class Element {
    constructor(props) {
        this.source = new events_1.EventSource();
        this.events = this.source;
        /** All in and out links of the element */
        this.links = [];
        const { id, data, position = { x: 0, y: 0 }, size = { width: 0, height: 0 }, expanded = false, group, elementState, temporary = false, } = props;
        this.id = id;
        this._data = data;
        this._position = position;
        this._size = size;
        this._expanded = expanded;
        this._group = group;
        this._elementState = elementState;
        this._temporary = temporary;
    }
    get iri() { return this._data.id; }
    get data() { return this._data; }
    setData(value) {
        const previous = this._data;
        if (previous === value) {
            return;
        }
        this._data = value;
        this.source.trigger('changeData', { source: this, previous });
    }
    get position() { return this._position; }
    setPosition(value) {
        const previous = this._position;
        const same = (previous.x === value.x &&
            previous.y === value.y);
        if (same) {
            return;
        }
        this._position = value;
        this.source.trigger('changePosition', { source: this, previous });
    }
    get size() { return this._size; }
    setSize(value) {
        const previous = this._size;
        const same = (previous.width === value.width &&
            previous.height === value.height);
        if (same) {
            return;
        }
        this._size = value;
        this.source.trigger('changeSize', { source: this, previous });
    }
    get isExpanded() { return this._expanded; }
    setExpanded(value) {
        const previous = this._expanded;
        if (previous === value) {
            return;
        }
        this._expanded = value;
        this.source.trigger('changeExpanded', { source: this, previous });
    }
    get group() { return this._group; }
    setGroup(value) {
        const previous = this._group;
        if (previous === value) {
            return;
        }
        this._group = value;
        this.source.trigger('changeGroup', { source: this, previous });
    }
    get elementState() { return this._elementState; }
    setElementState(value) {
        const previous = this._elementState;
        if (previous === value) {
            return;
        }
        this._elementState = value;
        this.source.trigger('changeElementState', { source: this, previous });
    }
    get temporary() { return this._temporary; }
    focus() {
        this.source.trigger('requestedFocus', { source: this });
    }
    requestGroupContent() {
        this.source.trigger('requestedGroupContent', { source: this });
    }
    addToFilter(linkType, direction) {
        this.source.trigger('requestedAddToFilter', {
            source: this, linkType, direction,
        });
    }
    redraw() {
        this.source.trigger('requestedRedraw', { source: this });
    }
}
exports.Element = Element;
class FatClassModel {
    constructor(props) {
        this.source = new events_1.EventSource();
        this.events = this.source;
        const { id, label = [], count } = props;
        this.id = id;
        this._label = label;
        this._count = count;
    }
    get label() { return this._label; }
    setLabel(value) {
        const previous = this._label;
        if (previous === value) {
            return;
        }
        this._label = value;
        this.source.trigger('changeLabel', { source: this, previous });
    }
    get count() { return this._count; }
    setCount(value) {
        const previous = this._count;
        if (previous === value) {
            return;
        }
        this._count = value;
        this.source.trigger('changeCount', { source: this, previous });
    }
}
exports.FatClassModel = FatClassModel;
class RichProperty {
    constructor(props) {
        this.source = new events_1.EventSource();
        this.events = this.source;
        const { id, label = [] } = props;
        this.id = id;
        this._label = label;
    }
    get label() { return this._label; }
    setLabel(value) {
        const previous = this._label;
        if (previous === value) {
            return;
        }
        this._label = value;
        this.source.trigger('changeLabel', { source: this, previous });
    }
}
exports.RichProperty = RichProperty;
class Link {
    constructor(props) {
        this.source = new events_1.EventSource();
        this.events = this.source;
        const { id = schema_1.GenerateID.forLink(), typeId, sourceId, targetId, data, vertices = [], linkState } = props;
        this.id = id;
        this._typeId = typeId;
        this._sourceId = sourceId;
        this._targetId = targetId;
        this._data = data;
        this._vertices = vertices;
        this._linkState = linkState;
    }
    get typeId() { return this._typeId; }
    get sourceId() { return this._sourceId; }
    get targetId() { return this._targetId; }
    get data() { return this._data; }
    setData(value) {
        const previous = this._data;
        if (previous === value) {
            return;
        }
        this._data = value;
        this._typeId = value.linkTypeId;
        this.source.trigger('changeData', { source: this, previous });
    }
    get labelBounds() { return this._labelBounds; }
    setLabelBounds(value) {
        const previous = this._labelBounds;
        if (previous === value) {
            return;
        }
        this._labelBounds = value;
        this.source.trigger('changeLabelBounds', { source: this, previous });
    }
    get layoutOnly() { return this._layoutOnly; }
    setLayoutOnly(value) {
        const previous = this._layoutOnly;
        if (previous === value) {
            return;
        }
        this._layoutOnly = value;
        this.source.trigger('changeLayoutOnly', { source: this, previous });
    }
    get vertices() { return this._vertices; }
    setVertices(value) {
        const previous = this._vertices;
        if (geometry_1.isPolylineEqual(this._vertices, value)) {
            return;
        }
        this._vertices = value;
        this.source.trigger('changeVertices', { source: this, previous });
    }
    get linkState() { return this._linkState; }
    setLinkState(value) {
        const previous = this._linkState;
        if (previous === value) {
            return;
        }
        this._linkState = value;
        this.source.trigger('changeLinkState', { source: this, previous });
    }
}
exports.Link = Link;
function linkMarkerKey(linkTypeIndex, startMarker) {
    return `ontodia-${startMarker ? 'mstart' : 'mend'}-${linkTypeIndex}`;
}
exports.linkMarkerKey = linkMarkerKey;
/**
 * Properties:
 *     visible: boolean
 *     showLabel: boolean
 *     isNew?: boolean
 *     label?: { values: LocalizedString[] }
 */
class FatLinkType {
    constructor(props) {
        this.source = new events_1.EventSource();
        this.events = this.source;
        this._isNew = false;
        this._visible = true;
        this._showLabel = true;
        const { id, index, label = [] } = props;
        this.id = id;
        this._index = index;
        this._label = label;
    }
    get index() { return this._index; }
    setIndex(value) {
        if (typeof this._index === 'number') {
            throw new Error('Cannot set index for link type more than once.');
        }
        this._index = value;
    }
    get label() { return this._label; }
    setLabel(value) {
        const previous = this._label;
        if (previous === value) {
            return;
        }
        this._label = value;
        this.source.trigger('changeLabel', { source: this, previous });
    }
    get visible() { return this._visible; }
    get showLabel() { return this._showLabel; }
    setVisibility(params) {
        const same = (this._visible === params.visible &&
            this._showLabel === params.showLabel);
        if (same) {
            return;
        }
        const preventLoading = Boolean(params.preventLoading) || this._visible === params.visible;
        this._visible = params.visible;
        this._showLabel = params.showLabel;
        this.source.trigger('changeVisibility', { source: this, preventLoading });
    }
    get isNew() { return this._isNew; }
    setIsNew(value) {
        const previous = this._isNew;
        if (previous === value) {
            return;
        }
        this._isNew = value;
        this.source.trigger('changeIsNew', { source: this, previous });
    }
}
exports.FatLinkType = FatLinkType;
class LinkVertex {
    constructor(link, vertexIndex) {
        this.link = link;
        this.vertexIndex = vertexIndex;
    }
    createAt(location) {
        const vertices = [...this.link.vertices];
        vertices.splice(this.vertexIndex, 0, location);
        this.link.setVertices(vertices);
    }
    moveTo(location) {
        const vertices = [...this.link.vertices];
        vertices.splice(this.vertexIndex, 1, location);
        this.link.setVertices(vertices);
    }
    remove() {
        const vertices = [...this.link.vertices];
        const [location] = vertices.splice(this.vertexIndex, 1);
        this.link.setVertices(vertices);
    }
}
exports.LinkVertex = LinkVertex;


/***/ }),
/* 54 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TemplateProperties = exports.GenerateID = exports.PLACEHOLDER_LINK_TYPE = exports.PLACEHOLDER_ELEMENT_TYPE = exports.DIAGRAM_CONTEXT_URL_V1 = void 0;
const utils_1 = __webpack_require__(49);
// context could be imported directly from NPM package, e.g.
//   import OntodiaContextV1 from 'ontodia/schema/context-v1.json';
exports.DIAGRAM_CONTEXT_URL_V1 = 'https://ontodia.org/context/v1.json';
exports.PLACEHOLDER_ELEMENT_TYPE = 'http://ontodia.org/NewEntity';
exports.PLACEHOLDER_LINK_TYPE = 'http://ontodia.org/NewLink';
const ONTODIA_ID_URL_PREFIX = 'http://ontodia.org/data/';
var GenerateID;
(function (GenerateID) {
    function forElement() { return `${ONTODIA_ID_URL_PREFIX}e_${utils_1.generate128BitID()}`; }
    GenerateID.forElement = forElement;
    function forLink() { return `${ONTODIA_ID_URL_PREFIX}l_${utils_1.generate128BitID()}`; }
    GenerateID.forLink = forLink;
})(GenerateID = exports.GenerateID || (exports.GenerateID = {}));
var TemplateProperties;
(function (TemplateProperties) {
    TemplateProperties.PinnedProperties = 'ontodia:pinnedProperties';
    TemplateProperties.CustomLabel = 'ontodia:customLabel';
})(TemplateProperties = exports.TemplateProperties || (exports.TemplateProperties = {}));


/***/ }),
/* 55 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EventObserver = exports.EventSource = void 0;
const collections_1 = __webpack_require__(56);
class EventSource {
    constructor() {
        this.listeners = collections_1.createStringMap();
    }
    on(eventKey, listener) {
        let listeners = this.listeners[eventKey];
        if (!listeners) {
            listeners = [];
            this.listeners[eventKey] = listeners;
        }
        listeners.push(listener);
    }
    onAny(listener) {
        let listeners = this.anyListeners;
        if (!listeners) {
            listeners = [];
            this.anyListeners = listeners;
        }
        listeners.push(listener);
    }
    off(eventKey, listener) {
        const listeners = this.listeners[eventKey];
        if (!listeners) {
            return;
        }
        const index = listeners.indexOf(listener);
        if (index >= 0) {
            listeners.splice(index, 1);
        }
    }
    offAny(listener) {
        const listeners = this.anyListeners;
        if (!listeners) {
            return;
        }
        const index = listeners.indexOf(listener);
        if (index >= 0) {
            listeners.splice(index, 1);
        }
    }
    trigger(eventKey, data) {
        const listeners = this.listeners[eventKey];
        if (listeners) {
            for (const listener of listeners) {
                listener(data, eventKey);
            }
        }
        if (this.anyListeners) {
            for (const anyListener of this.anyListeners) {
                anyListener({ [eventKey]: data }, eventKey);
            }
        }
    }
}
exports.EventSource = EventSource;
class EventObserver {
    constructor() {
        this.unsubscribeByKey = collections_1.createStringMap();
        this.onDispose = [];
    }
    listen(events, eventKey, listener) {
        events.on(eventKey, listener);
        this.onDispose.push(() => events.off(eventKey, listener));
    }
    listenAny(events, listener) {
        events.onAny(listener);
        this.onDispose.push(() => events.offAny(listener));
    }
    listenOnce(events, eventKey, listener) {
        let handled = false;
        const onceListener = (data, key) => {
            handled = true;
            events.off(eventKey, onceListener);
            listener(data, key);
        };
        events.on(eventKey, onceListener);
        this.onDispose.push(() => {
            if (handled) {
                return;
            }
            events.off(eventKey, onceListener);
        });
    }
    stopListening() {
        for (const unsubscribe of this.onDispose) {
            unsubscribe();
        }
        this.onDispose.length = 0;
        for (const key in this.unsubscribeByKey) {
            if (!collections_1.hasOwnProperty(this.unsubscribeByKey, key)) {
                continue;
            }
            const unsubscribers = this.unsubscribeByKey[key];
            for (const unsubscribe of unsubscribers) {
                unsubscribe();
            }
        }
        this.unsubscribeByKey = {};
    }
}
exports.EventObserver = EventObserver;


/***/ }),
/* 56 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeMoveComparator = exports.MoveDirection = exports.HashMap = exports.OrderedMap = exports.cloneSet = exports.cloneMap = exports.isEmptyMap = exports.hasOwnProperty = exports.createNumberMap = exports.createStringMap = void 0;
function createStringMap() {
    const map = Object.create(null);
    // tslint:disable-next-line:no-string-literal
    delete map['hint'];
    return map;
}
exports.createStringMap = createStringMap;
function createNumberMap() {
    return createStringMap();
}
exports.createNumberMap = createNumberMap;
function hasOwnProperty(collection, key) {
    return Object.prototype.hasOwnProperty.call(collection, key);
}
exports.hasOwnProperty = hasOwnProperty;
function isEmptyMap(map) {
    for (const key in map) {
        if (hasOwnProperty(map, key)) {
            return false;
        }
    }
    return true;
}
exports.isEmptyMap = isEmptyMap;
/**
 * Clones Map collection. Required due to IE11 not supporing `new Map(map)`.
 */
function cloneMap(map) {
    const clone = new Map();
    map.forEach((value, key) => clone.set(key, value));
    return clone;
}
exports.cloneMap = cloneMap;
/**
 * Clones Set collection. Required due to IE11 not supporing `new Set(set)`.
 */
function cloneSet(set) {
    const clone = new Set();
    set.forEach(item => clone.add(item));
    return clone;
}
exports.cloneSet = cloneSet;
class OrderedMap {
    constructor() {
        this.mapping = createStringMap();
        this.ordered = [];
    }
    reorder(compare) {
        this.ordered.sort(compare);
    }
    get items() {
        return this.ordered;
    }
    get(key) {
        return this.mapping[key];
    }
    push(key, value) {
        if (key in this.mapping) {
            const previous = this.mapping[key];
            if (previous === value) {
                return;
            }
            const index = this.ordered.indexOf(previous);
            this.ordered.splice(index, 1);
        }
        this.mapping[key] = value;
        this.ordered.push(value);
    }
    delete(key) {
        if (!(key in this.mapping)) {
            return undefined;
        }
        const previous = this.mapping[key];
        const index = this.ordered.indexOf(previous);
        this.ordered.splice(index, 1);
        delete this.mapping[key];
        return previous;
    }
}
exports.OrderedMap = OrderedMap;
class HashMap {
    constructor(hashCode, equals) {
        this.hashCode = hashCode;
        this.equals = equals;
        this.map = new Map();
        this._size = 0;
    }
    get size() {
        return this._size;
    }
    has(key) {
        const items = this.map.get(this.hashCode(key));
        if (!items) {
            return false;
        }
        return Boolean(items.find(p => this.equals(p.key, key)));
    }
    get(key) {
        const items = this.map.get(this.hashCode(key));
        if (!items) {
            return undefined;
        }
        const pair = items.find(p => this.equals(p.key, key));
        return pair ? pair.value : undefined;
    }
    set(key, value) {
        const hash = this.hashCode(key);
        let items = this.map.get(hash);
        if (items) {
            const index = items.findIndex(p => this.equals(p.key, key));
            if (index >= 0) {
                items.splice(index, 1);
            }
            else {
                this._size++;
            }
            items.push({ key, value });
        }
        else {
            items = [{ key, value }];
            this.map.set(hash, items);
            this._size++;
        }
        return this;
    }
    delete(key) {
        const items = this.map.get(this.hashCode(key));
        if (!items) {
            return false;
        }
        const index = items.findIndex(p => this.equals(p.key, key));
        if (index >= 0) {
            items.splice(index, 1);
            this._size--;
            return true;
        }
        else {
            return false;
        }
    }
    clear() {
        this.map.clear();
        this._size = 0;
    }
    forEach(callback) {
        this.map.forEach(items => {
            for (const { key, value } of items) {
                callback(value, key, this);
            }
        });
    }
    clone() {
        const clone = new HashMap(this.hashCode, this.equals);
        clone._size = this.size;
        this.map.forEach((value, key) => clone.map.set(key, [...value]));
        return clone;
    }
}
exports.HashMap = HashMap;
var MoveDirection;
(function (MoveDirection) {
    MoveDirection[MoveDirection["ToStart"] = -1] = "ToStart";
    MoveDirection[MoveDirection["ToEnd"] = 1] = "ToEnd";
})(MoveDirection = exports.MoveDirection || (exports.MoveDirection = {}));
function makeMoveComparator(items, selected, moveDirection) {
    const orderMap = new Map();
    const selectionIndexOffset = moveDirection * items.length;
    items.forEach((item, index) => {
        orderMap.set(item, index);
    });
    for (const selectedItem of selected) {
        orderMap.set(selectedItem, selectionIndexOffset + orderMap.get(selectedItem));
    }
    return (a, b) => {
        const orderA = orderMap.get(a);
        const orderB = orderMap.get(b);
        return (orderA > orderB ? 1 :
            orderA < orderB ? -1 :
                0);
    };
}
exports.makeMoveComparator = makeMoveComparator;


/***/ }),
/* 57 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.computeGrouping = exports.findNearestSegmentIndex = exports.getPointAlongPolyline = exports.computePolylineLength = exports.computePolyline = exports.isPolylineEqual = exports.boundsOf = exports.Rect = exports.Vector = void 0;
var Vector;
(function (Vector) {
    function equals(a, b) {
        return a.x === b.x && a.y === b.y;
    }
    Vector.equals = equals;
    function length({ x, y }) {
        return Math.sqrt(x * x + y * y);
    }
    Vector.length = length;
    function normalize({ x, y }) {
        if (x === 0 && y === 0) {
            return { x, y };
        }
        const inverseLength = 1 / Math.sqrt(x * x + y * y);
        return { x: x * inverseLength, y: y * inverseLength };
    }
    Vector.normalize = normalize;
    function dot({ x: x1, y: y1 }, { x: x2, y: y2 }) {
        return x1 * x2 + y1 * y2;
    }
    Vector.dot = dot;
    function cross2D({ x: x1, y: y1 }, { x: x2, y: y2 }) {
        return x1 * y2 - y1 * x2;
    }
    Vector.cross2D = cross2D;
})(Vector = exports.Vector || (exports.Vector = {}));
var Rect;
(function (Rect) {
    function center({ x, y, width, height }) {
        return { x: x + width / 2, y: y + height / 2 };
    }
    Rect.center = center;
})(Rect = exports.Rect || (exports.Rect = {}));
function boundsOf(element) {
    const { x, y } = element.position;
    const { width, height } = element.size;
    return { x, y, width, height };
}
exports.boundsOf = boundsOf;
function intersectRayFromRectangleCenter(sourceRect, rayTarget) {
    const isTargetInsideRect = sourceRect.width === 0 || sourceRect.height === 0 ||
        rayTarget.x > sourceRect.x && rayTarget.x < (sourceRect.x + sourceRect.width) &&
            rayTarget.y > sourceRect.y && rayTarget.y < (sourceRect.y + sourceRect.height);
    const halfWidth = sourceRect.width / 2;
    const halfHeight = sourceRect.height / 2;
    const center = {
        x: sourceRect.x + halfWidth,
        y: sourceRect.y + halfHeight,
    };
    if (isTargetInsideRect) {
        return center;
    }
    const direction = Vector.normalize({
        x: rayTarget.x - center.x,
        y: rayTarget.y - center.y,
    });
    const rightDirection = { x: Math.abs(direction.x), y: direction.y };
    const isHorizontal = Vector.cross2D({ x: halfWidth, y: -halfHeight }, rightDirection) > 0 &&
        Vector.cross2D({ x: halfWidth, y: halfHeight }, rightDirection) < 0;
    if (isHorizontal) {
        return {
            x: center.x + halfWidth * Math.sign(direction.x),
            y: center.y + halfWidth * direction.y / Math.abs(direction.x),
        };
    }
    else {
        return {
            x: center.x + halfHeight * direction.x / Math.abs(direction.y),
            y: center.y + halfHeight * Math.sign(direction.y),
        };
    }
}
function isPolylineEqual(left, right) {
    if (left === right) {
        return true;
    }
    if (left.length !== right.length) {
        return false;
    }
    for (let i = 0; i < left.length; i++) {
        const a = left[i];
        const b = right[i];
        if (!(a.x === b.x && a.y === b.y)) {
            return false;
        }
    }
    return true;
}
exports.isPolylineEqual = isPolylineEqual;
function computePolyline(source, target, vertices) {
    const sourceRect = boundsOf(source);
    const targetRect = boundsOf(target);
    const startPoint = intersectRayFromRectangleCenter(sourceRect, vertices.length > 0 ? vertices[0] : Rect.center(targetRect));
    const endPoint = intersectRayFromRectangleCenter(targetRect, vertices.length > 0 ? vertices[vertices.length - 1] : Rect.center(sourceRect));
    return [startPoint, ...vertices, endPoint];
}
exports.computePolyline = computePolyline;
function computePolylineLength(polyline) {
    let previous;
    return polyline.reduce((acc, point) => {
        const segmentLength = previous ? Vector.length({ x: point.x - previous.x, y: point.y - previous.y }) : 0;
        previous = point;
        return acc + segmentLength;
    }, 0);
}
exports.computePolylineLength = computePolylineLength;
function getPointAlongPolyline(polyline, offset) {
    if (polyline.length === 0) {
        throw new Error('Cannot compute a point for empty polyline');
    }
    if (offset < 0) {
        return polyline[0];
    }
    let currentOffset = 0;
    for (let i = 1; i < polyline.length; i++) {
        const previous = polyline[i - 1];
        const point = polyline[i];
        const segment = { x: point.x - previous.x, y: point.y - previous.y };
        const segmentLength = Vector.length(segment);
        const newOffset = currentOffset + segmentLength;
        if (offset < newOffset) {
            const leftover = (offset - currentOffset) / segmentLength;
            return {
                x: previous.x + leftover * segment.x,
                y: previous.y + leftover * segment.y,
            };
        }
        else {
            currentOffset = newOffset;
        }
    }
    return polyline[polyline.length - 1];
}
exports.getPointAlongPolyline = getPointAlongPolyline;
function findNearestSegmentIndex(polyline, location) {
    let minDistance = Infinity;
    let foundIndex = 0;
    for (let i = 0; i < polyline.length - 1; i++) {
        const pivot = polyline[i];
        const next = polyline[i + 1];
        const target = { x: location.x - pivot.x, y: location.y - pivot.y };
        const segment = { x: next.x - pivot.x, y: next.y - pivot.y };
        const segmentLength = Vector.length(segment);
        const projectionToSegment = Vector.dot(target, segment) / segmentLength;
        if (projectionToSegment < 0 || projectionToSegment > segmentLength) {
            continue;
        }
        const distanceToSegment = Math.abs(Vector.cross2D(target, segment)) / segmentLength;
        if (distanceToSegment < minDistance) {
            minDistance = distanceToSegment;
            foundIndex = i;
        }
    }
    return foundIndex;
}
exports.findNearestSegmentIndex = findNearestSegmentIndex;
function computeGrouping(elements) {
    const grouping = new Map();
    for (const element of elements) {
        const group = element.group;
        if (typeof group === 'string') {
            let children = grouping.get(group);
            if (!children) {
                children = [];
                grouping.set(group, children);
            }
            children.push(element);
        }
    }
    return grouping;
}
exports.computeGrouping = computeGrouping;


/***/ }),
/* 58 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ElementContextTypes = exports.ElementLayer = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const react_dom_1 = __webpack_require__(59);
const d3_color_1 = __webpack_require__(60);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const react_1 = __webpack_require__(62);
const keyedObserver_1 = __webpack_require__(63);
const commands_1 = __webpack_require__(64);
const view_1 = __webpack_require__(66);
// tslint:disable:no-bitwise
var RedrawFlags;
(function (RedrawFlags) {
    RedrawFlags[RedrawFlags["None"] = 0] = "None";
    RedrawFlags[RedrawFlags["Render"] = 1] = "Render";
    RedrawFlags[RedrawFlags["RecomputeTemplate"] = 3] = "RecomputeTemplate";
    RedrawFlags[RedrawFlags["RecomputeBlurred"] = 5] = "RecomputeBlurred";
})(RedrawFlags || (RedrawFlags = {}));
class ElementLayer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.listener = new events_1.EventObserver();
        this.redrawBatch = {
            requests: new Map(),
            forAll: RedrawFlags.None,
        };
        this.delatedRedraw = new async_1.Debouncer();
        this.sizeRequests = new Map();
        this.delayedUpdateSizes = new async_1.Debouncer();
        this.onMount = (layer) => {
            this.layer = layer;
        };
        this.requestRedraw = (element, request) => {
            // tslint:disable:no-bitwise
            const flagsWithForAll = this.redrawBatch.forAll | request;
            if (flagsWithForAll === this.redrawBatch.forAll) {
                // forAll flags already include the request
                return;
            }
            const existing = this.redrawBatch.requests.get(element.id);
            this.redrawBatch.requests.set(element.id, existing | request);
            this.delatedRedraw.call(this.redrawElements);
            // tslint:enable:no-bitwise
        };
        this.redrawElements = () => {
            const props = this.props;
            this.setState((state) => ({
                elementStates: applyRedrawRequests(props.view, props.group, this.redrawBatch, state.elementStates)
            }));
        };
        this.requestSizeUpdate = (element, node) => {
            this.sizeRequests.set(element.id, { element, node });
            this.delayedUpdateSizes.call(this.recomputeQueuedSizes);
        };
        this.recomputeQueuedSizes = () => {
            const batch = this.sizeRequests;
            this.sizeRequests = new Map();
            batch.forEach(({ element, node }) => {
                const { clientWidth, clientHeight } = node;
                element.setSize({ width: clientWidth, height: clientHeight });
            });
        };
        const { view, group } = this.props;
        this.state = {
            elementStates: applyRedrawRequests(view, group, this.redrawBatch, new Map())
        };
    }
    render() {
        const { view, style } = this.props;
        const { elementStates } = this.state;
        const elementsToRender = [];
        for (const { id } of view.model.elements) {
            const state = elementStates.get(id);
            if (state) {
                elementsToRender.push(state);
            }
        }
        return React.createElement("div", { className: 'ontodia-element-layer', ref: this.onMount, style: style }, elementsToRender.map(state => {
            const overlayElement = (React.createElement(OverlayedElement, { key: state.element.id, state: state, view: view, onInvalidate: this.requestRedraw, onResize: this.requestSizeUpdate }));
            // console.log(state.element.id)
            const elementDecorator = view._decorateElement(state.element);
            if (elementDecorator) {
                return (React.createElement("div", { key: state.element.id },
                    overlayElement,
                    elementDecorator));
            }
            return overlayElement;
        }));
    }
    componentDidMount() {
        const { view } = this.props;
        this.listener.listen(view.model.events, 'changeCells', () => {
            this.requestRedrawAll(RedrawFlags.None);
        });
        this.listener.listen(view.events, 'changeLanguage', () => {
            this.requestRedrawAll(RedrawFlags.RecomputeTemplate);
        });
        this.listener.listen(view.events, 'changeHighlight', () => {
            this.requestRedrawAll(RedrawFlags.RecomputeBlurred);
        });
        this.listener.listen(view.model.events, 'elementEvent', ({ data }) => {
            const invalidatesTemplate = data.changeData || data.changeExpanded || data.changeElementState;
            if (invalidatesTemplate) {
                this.requestRedraw(invalidatesTemplate.source, RedrawFlags.RecomputeTemplate);
            }
            const invalidatesRender = data.changePosition || data.requestedRedraw;
            if (invalidatesRender) {
                this.requestRedraw(invalidatesRender.source, RedrawFlags.Render);
            }
        });
        this.listener.listen(view.events, 'syncUpdate', ({ layer }) => {
            if (layer === view_1.RenderingLayer.Element) {
                this.delatedRedraw.runSynchronously();
            }
            else if (layer === view_1.RenderingLayer.ElementSize) {
                this.delayedUpdateSizes.runSynchronously();
            }
        });
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.group !== nextProps.group) {
            this.setState((state) => ({
                elementStates: applyRedrawRequests(nextProps.view, nextProps.group, this.redrawBatch, state.elementStates)
            }));
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.delatedRedraw.dispose();
        this.delayedUpdateSizes.dispose();
    }
    requestRedrawAll(request) {
        // tslint:disable-next-line:no-bitwise
        this.redrawBatch.forAll |= request;
        this.delatedRedraw.call(this.redrawElements);
    }
}
exports.ElementLayer = ElementLayer;
function applyRedrawRequests(view, targetGroup, batch, previous) {
    const computed = new Map();
    for (const element of view.model.elements) {
        if (element.group !== targetGroup) {
            continue;
        }
        const elementId = element.id;
        if (previous.has(elementId)) {
            let state = previous.get(elementId);
            // tslint:disable:no-bitwise
            const request = (batch.requests.get(elementId) || RedrawFlags.None) | batch.forAll;
            if (request & RedrawFlags.Render) {
                state = {
                    element: state.element,
                    templateProps: (request & RedrawFlags.RecomputeTemplate) === RedrawFlags.RecomputeTemplate
                        ? computeTemplateProps(state.element, view) : state.templateProps,
                    blurred: (request & RedrawFlags.RecomputeBlurred) === RedrawFlags.RecomputeBlurred
                        ? computeIsBlurred(state.element, view) : state.blurred,
                };
            }
            computed.set(elementId, state);
            batch.requests.delete(elementId);
            // tslint:enable:no-bitwise
        }
        else {
            computed.set(element.id, {
                element,
                templateProps: computeTemplateProps(element, view),
                blurred: computeIsBlurred(element, view),
            });
        }
    }
    batch.forAll = RedrawFlags.None;
    return computed;
}
exports.ElementContextTypes = {
    ontodiaElement: react_1.PropTypes.anything,
};
class OverlayedElement extends React.Component {
    constructor() {
        super(...arguments);
        this.listener = new events_1.EventObserver();
        this.disposed = false;
        this.rerenderTemplate = () => {
            if (this.disposed) {
                return;
            }
            this.props.onInvalidate(this.props.state.element, RedrawFlags.RecomputeTemplate);
        };
        this.onMount = (node) => {
            if (!node) {
                return;
            }
            const { state, onResize } = this.props;
            onResize(state.element, node);
        };
        this.onLoadOrErrorEvent = () => {
            const { state, onResize } = this.props;
            onResize(state.element, react_dom_1.findDOMNode(this));
        };
        this.onClick = (e) => {
            if (e.target instanceof HTMLElement && e.target.localName === 'a') {
                const anchor = e.target;
                const { view, state } = this.props;
                const clickIntent = e.target.getAttribute('data-iri-click-intent') === view_1.IriClickIntent.OpenEntityIri ?
                    view_1.IriClickIntent.OpenEntityIri : view_1.IriClickIntent.OpenOtherIri;
                view.onIriClick(decodeURI(anchor.href), state.element, clickIntent, e);
            }
        };
        this.onDoubleClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const { view, state: { element } } = this.props;
            view.model.history.execute(commands_1.setElementExpanded(element, !element.isExpanded));
        };
    }
    getChildContext() {
        const ontodiaElement = {
            element: this.props.state.element,
        };
        return { ontodiaElement };
    }
    render() {
        const { state: { element, blurred } } = this.props;
        if (element.temporary) {
            return React.createElement("div", null);
        }
        const { x = 0, y = 0 } = element.position;
        const transform = `translate(${x}px,${y}px)`;
        // const angle = model.get('angle') || 0;
        // if (angle) { transform += `rotate(${angle}deg)`; }
        const className = (`ontodia-overlayed-element ${blurred ? 'ontodia-overlayed-element--blurred' : ''}`);
        return React.createElement("div", { className: className, "data-element-id": element.id, style: { position: 'absolute', transform }, tabIndex: 0, ref: this.onMount, 
            // resize element when child image loaded
            onLoad: this.onLoadOrErrorEvent, onError: this.onLoadOrErrorEvent, onClick: this.onClick, onDoubleClick: this.onDoubleClick },
            React.createElement(TemplatedElement, Object.assign({}, this.props)));
    }
    componentDidMount() {
        const { state, view } = this.props;
        this.listener.listen(state.element.events, 'requestedFocus', () => {
            const element = react_dom_1.findDOMNode(this);
            if (element) {
                element.focus();
            }
        });
        this.typesObserver = keyedObserver_1.observeElementTypes(view.model, 'changeLabel', this.rerenderTemplate);
        this.propertiesObserver = keyedObserver_1.observeProperties(view.model, 'changeLabel', this.rerenderTemplate);
        this.observeTypes();
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.typesObserver.stopListening();
        this.propertiesObserver.stopListening();
        this.disposed = true;
    }
    shouldComponentUpdate(nextProps) {
        return this.props.state !== nextProps.state;
    }
    componentDidUpdate() {
        this.observeTypes();
        this.props.onResize(this.props.state.element, react_dom_1.findDOMNode(this));
    }
    observeTypes() {
        const { state: { element } } = this.props;
        this.typesObserver.observe(element.data.types);
        this.propertiesObserver.observe(Object.keys(element.data.properties));
    }
}
OverlayedElement.childContextTypes = exports.ElementContextTypes;
class TemplatedElement extends React.Component {
    render() {
        const { state, view } = this.props;
        const { element, templateProps } = state;
        const templateClass = view.getElementTemplate(element.data.types);
        this.cachedTemplateClass = templateClass;
        this.cachedTemplateProps = templateProps;
        return React.createElement(templateClass, templateProps);
    }
    shouldComponentUpdate(nextProps) {
        const templateClass = nextProps.view.getElementTemplate(nextProps.state.element.data.types);
        return !(this.cachedTemplateClass === templateClass &&
            this.cachedTemplateProps === nextProps.state.templateProps);
    }
}
function computeTemplateProps(model, view) {
    const types = model.data.types.length > 0
        ? view.getElementTypeString(model.data) : 'Thing';
    const label = view.formatLabel(model.data.label.values, model.iri);
    const { color, icon } = computeStyleFor(model, view);
    const propsAsList = computePropertyTable(model, view);
    // console.log('L URI dell entità selezionata è : ', model.iri);
    return {
        elementId: model.id,
        data: model.data,
        iri: model.iri,
        types,
        label,
        color,
        iconUrl: icon,
        imgUrl: model.data.image,
        isExpanded: model.isExpanded,
        props: model.data.properties,
        propsAsList,
    };
}
function computePropertyTable(model, view) {
    if (!model.data.properties) {
        return [];
    }
    const propertyIris = Object.keys(model.data.properties);
    const propTable = propertyIris.map(key => {
        const property = view.model.createProperty(key);
        const name = view.formatLabel(property.label, key);
        return {
            id: key,
            name: name,
            property: model.data.properties[key],
        };
    });
    propTable.sort((a, b) => {
        const aLabel = (a.name || a.id).toLowerCase();
        const bLabel = (b.name || b.id).toLowerCase();
        return aLabel.localeCompare(bLabel);
    });
    return propTable;
}
function computeStyleFor(model, view) {
    const { color: { h, c, l }, icon } = view.getTypeStyle(model.data.types);
    return {
        icon,
        color: d3_color_1.hcl(h, c, l).toString(),
    };
}
function computeIsBlurred(element, view) {
    return view.highlighter && !view.highlighter(element);
}


/***/ }),
/* 59 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__59__;

/***/ }),
/* 60 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__60__;

/***/ }),
/* 61 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.easeInOutBezier = exports.animateInterval = exports.delay = exports.CancelledError = exports.Cancellation = exports.Debouncer = exports.BufferingQueue = exports.BatchingScheduler = void 0;
const events_1 = __webpack_require__(55);
class BatchingScheduler {
    constructor(waitingTime = 0) {
        this.waitingTime = waitingTime;
        this.useAnimationFrame = waitingTime === 0;
        this.runSynchronously = this.runSynchronously.bind(this);
    }
    schedule() {
        if (typeof this.scheduled === 'undefined') {
            if (this.useAnimationFrame) {
                this.scheduled = requestAnimationFrame(this.runSynchronously);
            }
            else {
                this.scheduled = setTimeout(this.runSynchronously, this.waitingTime);
            }
        }
    }
    runSynchronously() {
        const wasScheduled = this.cancelScheduledTimeout();
        if (wasScheduled) {
            this.run();
        }
    }
    dispose() {
        this.cancelScheduledTimeout();
    }
    cancelScheduledTimeout() {
        if (typeof this.scheduled !== 'undefined') {
            if (this.useAnimationFrame) {
                cancelAnimationFrame(this.scheduled);
            }
            else {
                clearTimeout(this.scheduled);
            }
            this.scheduled = undefined;
            return true;
        }
        return false;
    }
}
exports.BatchingScheduler = BatchingScheduler;
class BufferingQueue extends BatchingScheduler {
    constructor(onFetch, waitingTime = 200) {
        super(waitingTime);
        this.onFetch = onFetch;
        this.fetchingQueue = Object.create(null);
    }
    push(key) {
        this.fetchingQueue[key] = true;
        this.schedule();
    }
    clear() {
        this.fetchingQueue = Object.create(null);
    }
    run() {
        const { fetchingQueue, onFetch } = this;
        this.fetchingQueue = Object.create(null);
        onFetch(Object.keys(fetchingQueue));
    }
}
exports.BufferingQueue = BufferingQueue;
class Debouncer extends BatchingScheduler {
    call(callback) {
        this.callback = callback;
        this.schedule();
    }
    run() {
        const callback = this.callback;
        callback && callback();
    }
}
exports.Debouncer = Debouncer;
class Cancellation {
    constructor() {
        this.source = new events_1.EventSource();
        this.aborted = false;
        this.signal = new (class {
            constructor(parent) {
                this.parent = parent;
            }
            get aborted() { return this.parent.aborted; }
            addEventListener(event, handler) {
                if (event !== 'abort') {
                    return;
                }
                if (this.parent.source) {
                    this.parent.source.on('abort', handler);
                }
                else {
                    handler();
                }
            }
            removeEventListener(event, handler) {
                if (event !== 'abort') {
                    return;
                }
                if (this.parent.source) {
                    this.parent.source.off('abort', handler);
                }
            }
        })(this);
    }
    abort() {
        if (this.aborted) {
            return;
        }
        this.aborted = true;
        this.source && this.source.trigger('abort', undefined);
        this.source = undefined;
    }
}
exports.Cancellation = Cancellation;
Cancellation.NEVER_SIGNAL = {
    aborted: false,
    addEventListener: () => { },
    removeEventListener: () => { },
};
class CancelledError extends Error {
    constructor(message) {
        super(message);
        this.name = CancelledError.name;
        Object.setPrototypeOf(this, CancelledError.prototype);
    }
}
exports.CancelledError = CancelledError;
function delay(timeout) {
    return new Promise(resolve => setTimeout(() => resolve(), timeout));
}
exports.delay = delay;
function animateInterval(duration, onProgress, cancellation) {
    return new Promise(resolve => {
        let animationFrameId;
        let start;
        const animate = (time) => {
            if (cancellation && cancellation.signal.aborted) {
                return;
            }
            start = start || time;
            let timePassed = time - start;
            if (timePassed > duration) {
                timePassed = duration;
            }
            onProgress(timePassed / duration);
            if (timePassed < duration) {
                animationFrameId = requestAnimationFrame(animate);
            }
            else {
                resolve();
            }
        };
        cancellation && cancellation.signal.addEventListener('abort', () => {
            cancelAnimationFrame(animationFrameId);
            resolve();
        });
        animationFrameId = requestAnimationFrame(animate);
    });
}
exports.animateInterval = animateInterval;
function easeInOutBezier(t) {
    if (t < 0) {
        return 0;
    }
    if (t > 1) {
        return 1;
    }
    return t * t * (3.0 - 2.0 * t);
}
exports.easeInOutBezier = easeInOutBezier;


/***/ }),
/* 62 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PropTypes = void 0;
var PropTypes;
(function (PropTypes) {
    PropTypes.anything = () => null;
})(PropTypes = exports.PropTypes || (exports.PropTypes = {}));


/***/ }),
/* 63 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.observeLinkTypes = exports.observeProperties = exports.observeElementTypes = exports.KeyedObserver = void 0;
class KeyedObserver {
    constructor(subscribe) {
        this.subscribe = subscribe;
        this.observedKeys = new Map();
    }
    observe(keys) {
        if (keys.length === 0 && this.observedKeys.size === 0) {
            return;
        }
        const newObservedKeys = new Map();
        for (const key of keys) {
            if (newObservedKeys.has(key)) {
                continue;
            }
            let unsubscribe = this.observedKeys.get(key);
            if (!unsubscribe) {
                unsubscribe = this.subscribe(key);
            }
            newObservedKeys.set(key, unsubscribe);
        }
        this.observedKeys.forEach((unsubscribe, key) => {
            if (!newObservedKeys.has(key)) {
                unsubscribe();
            }
        });
        this.observedKeys = newObservedKeys;
    }
    stopListening() {
        this.observe([]);
    }
}
exports.KeyedObserver = KeyedObserver;
function observeElementTypes(model, event, listener) {
    return new KeyedObserver(key => {
        const type = model.getClass(key);
        if (type) {
            type.events.on(event, listener);
            return () => type.events.off(event, listener);
        }
        return undefined;
    });
}
exports.observeElementTypes = observeElementTypes;
function observeProperties(model, event, listener) {
    return new KeyedObserver(key => {
        const property = model.getProperty(key);
        if (property) {
            property.events.on(event, listener);
            return () => property.events.off(event, listener);
        }
        return undefined;
    });
}
exports.observeProperties = observeProperties;
function observeLinkTypes(model, event, listener) {
    return new KeyedObserver(key => {
        const type = model.createLinkType(key);
        if (type) {
            type.events.on(event, listener);
            return () => type.events.off(event, listener);
        }
        return undefined;
    });
}
exports.observeLinkTypes = observeLinkTypes;


/***/ }),
/* 64 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setLinkData = exports.setElementData = exports.changeLinkTypeVisibility = exports.setElementExpanded = exports.restoreCapturedLinkGeometry = exports.RestoreGeometry = void 0;
const model_1 = __webpack_require__(48);
const geometry_1 = __webpack_require__(57);
const history_1 = __webpack_require__(65);
class RestoreGeometry {
    constructor(elementState, linkState) {
        this.elementState = elementState;
        this.linkState = linkState;
        this.title = 'Move elements and links';
    }
    static capture(model) {
        return RestoreGeometry.captureElementsAndLinks(model.elements, model.links);
    }
    static captureElementsAndLinks(elements, links) {
        return new RestoreGeometry(elements.map(element => ({ element, position: element.position })), links.map(link => ({ link, vertices: link.vertices })));
    }
    hasChanges() {
        return this.elementState.length > 0 || this.linkState.length > 0;
    }
    filterOutUnchanged() {
        return new RestoreGeometry(this.elementState.filter(({ element, position }) => !geometry_1.Vector.equals(element.position, position)), this.linkState.filter(({ link, vertices }) => !geometry_1.isPolylineEqual(link.vertices, vertices)));
    }
    invoke() {
        const previous = RestoreGeometry.captureElementsAndLinks(this.elementState.map(state => state.element), this.linkState.map(state => state.link));
        // restore in reverse order to workaround position changed event
        // handling in EmbeddedLayer inside nested elements
        // (child's position change causes group to resize or move itself)
        for (const { element, position } of [...this.elementState].reverse()) {
            element.setPosition(position);
        }
        for (const { link, vertices } of this.linkState) {
            link.setVertices(vertices);
        }
        return previous;
    }
}
exports.RestoreGeometry = RestoreGeometry;
function restoreCapturedLinkGeometry(link) {
    const vertices = link.vertices;
    return history_1.Command.create('Change link vertices', () => {
        const capturedInverse = restoreCapturedLinkGeometry(link);
        link.setVertices(vertices);
        return capturedInverse;
    });
}
exports.restoreCapturedLinkGeometry = restoreCapturedLinkGeometry;
function setElementExpanded(element, expanded) {
    const title = expanded ? 'Expand element' : 'Collapse element';
    return history_1.Command.create(title, () => {
        element.setExpanded(expanded);
        return setElementExpanded(element, !expanded);
    });
}
exports.setElementExpanded = setElementExpanded;
function changeLinkTypeVisibility(params) {
    const { linkType, visible, showLabel, preventLoading } = params;
    return history_1.Command.create('Change link type visibility', () => {
        const previousVisible = linkType.visible;
        const previousShowLabel = linkType.showLabel;
        linkType.setVisibility({ visible, showLabel, preventLoading });
        return changeLinkTypeVisibility({
            linkType,
            visible: previousVisible,
            showLabel: previousShowLabel,
            preventLoading,
        });
    });
}
exports.changeLinkTypeVisibility = changeLinkTypeVisibility;
function setElementData(model, target, data) {
    const elements = model.elements.filter(el => el.iri === target);
    const previous = elements.length > 0 ? elements[0].data : undefined;
    return history_1.Command.create('Set element data', () => {
        for (const element of model.elements.filter(el => el.iri === target)) {
            element.setData(data);
            updateLinksToReferByNewIri(element, previous.id, data.id);
        }
        return setElementData(model, target, previous);
    });
}
exports.setElementData = setElementData;
function updateLinksToReferByNewIri(element, oldIri, newIri) {
    if (oldIri === newIri) {
        return;
    }
    for (const link of element.links) {
        let data = link.data;
        if (data.sourceId === oldIri) {
            data = Object.assign(Object.assign({}, data), { sourceId: newIri });
        }
        if (data.targetId === oldIri) {
            data = Object.assign(Object.assign({}, data), { targetId: newIri });
        }
        link.setData(data);
    }
}
function setLinkData(model, oldData, newData) {
    if (!model_1.sameLink(oldData, newData)) {
        throw new Error('Cannot change typeId, sourceId or targetId when changing link data');
    }
    return history_1.Command.create('Set link data', () => {
        for (const link of model.links) {
            if (model_1.sameLink(link.data, oldData)) {
                link.setData(newData);
            }
        }
        return setLinkData(model, newData, oldData);
    });
}
exports.setLinkData = setLinkData;


/***/ }),
/* 65 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NonRememberingHistory = exports.Command = void 0;
const events_1 = __webpack_require__(55);
var Command;
(function (Command) {
    function create(title, action) {
        return { title, invoke: action };
    }
    Command.create = create;
    function effect(title, body) {
        const perform = {
            title,
            invoke: () => {
                body();
                return skip;
            }
        };
        const skip = {
            title: 'Skipped effect: ' + title,
            invoke: () => perform,
        };
        return perform;
    }
    Command.effect = effect;
})(Command = exports.Command || (exports.Command = {}));
class NonRememberingHistory {
    constructor() {
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.undoStack = [];
        this.redoStack = [];
        this.storeBatch = () => { };
        this.discardBatch = () => { };
    }
    reset() {
        this.source.trigger('historyChanged', { hasChanges: false });
    }
    undo() {
        throw new Error('Undo is unsupported');
    }
    redo() {
        throw new Error('Redo is unsupported');
    }
    execute(command) {
        command.invoke();
        this.source.trigger('historyChanged', { hasChanges: true });
    }
    registerToUndo(command) {
        this.source.trigger('historyChanged', { hasChanges: true });
    }
    startBatch(title) {
        return {
            history: this,
            store: this.storeBatch,
            discard: this.discardBatch,
        };
    }
}
exports.NonRememberingHistory = NonRememberingHistory;


/***/ }),
/* 66 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DiagramView = exports.WidgetAttachment = exports.RenderingLayer = exports.IriClickIntent = void 0;
const d3_color_1 = __webpack_require__(60);
const lodash_1 = __webpack_require__(67);
const defaultTypeStyles_1 = __webpack_require__(68);
const defaultLinkStyles_1 = __webpack_require__(78);
const templates_1 = __webpack_require__(44);
const blankNodes_1 = __webpack_require__(79);
const utils_1 = __webpack_require__(49);
const events_1 = __webpack_require__(55);
const geometry_1 = __webpack_require__(57);
const linkRouter_1 = __webpack_require__(81);
var IriClickIntent;
(function (IriClickIntent) {
    IriClickIntent["JumpToEntity"] = "jumpToEntity";
    IriClickIntent["OpenEntityIri"] = "openEntityIri";
    IriClickIntent["OpenOtherIri"] = "openOtherIri";
})(IriClickIntent = exports.IriClickIntent || (exports.IriClickIntent = {}));
var RenderingLayer;
(function (RenderingLayer) {
    RenderingLayer[RenderingLayer["Element"] = 1] = "Element";
    RenderingLayer[RenderingLayer["ElementSize"] = 2] = "ElementSize";
    RenderingLayer[RenderingLayer["PaperArea"] = 3] = "PaperArea";
    RenderingLayer[RenderingLayer["Link"] = 4] = "Link";
    RenderingLayer[RenderingLayer["Editor"] = 5] = "Editor";
    RenderingLayer[RenderingLayer["FirstToUpdate"] = 1] = "FirstToUpdate";
    RenderingLayer[RenderingLayer["LastToUpdate"] = 5] = "LastToUpdate";
})(RenderingLayer = exports.RenderingLayer || (exports.RenderingLayer = {}));
var WidgetAttachment;
(function (WidgetAttachment) {
    WidgetAttachment[WidgetAttachment["Viewport"] = 1] = "Viewport";
    WidgetAttachment[WidgetAttachment["OverElements"] = 2] = "OverElements";
    WidgetAttachment[WidgetAttachment["OverLinks"] = 3] = "OverLinks";
})(WidgetAttachment = exports.WidgetAttachment || (exports.WidgetAttachment = {}));
class DiagramView {
    constructor(model, options = {}) {
        this.model = model;
        this.options = options;
        this.listener = new events_1.EventObserver();
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.disposed = false;
        this.colorSeed = 0x0BADBEEF;
        this._language = 'en';
        this.linkTemplates = new Map();
        this.routings = new Map();
        this.resolveTypeStyle = options.typeStyleResolver || defaultTypeStyles_1.DefaultTypeStyleBundle;
        this.resolveLinkTemplate = options.linkTemplateResolver || defaultLinkStyles_1.DefaultLinkTemplateBundle;
        this.resolveElementTemplate = options.elementTemplateResolver || templates_1.DefaultElementTemplateBundle;
        this.initRouting();
    }
    initRouting() {
        this.router = this.options.linkRouter || new linkRouter_1.DefaultLinkRouter();
        this.updateRoutings();
        this.listener.listen(this.model.events, 'changeCells', () => this.updateRoutings());
        this.listener.listen(this.model.events, 'linkEvent', ({ key, data }) => {
            if (data.changeVertices) {
                this.updateRoutings();
            }
        });
        this.listener.listen(this.model.events, 'elementEvent', ({ key, data }) => {
            if (data.changePosition || data.changeSize) {
                this.updateRoutings();
            }
        });
    }
    updateRoutings() {
        const previousRoutes = this.routings;
        const computedRoutes = this.router.route(this.model);
        previousRoutes.forEach((previous, linkId) => {
            const computed = computedRoutes.get(linkId);
            if (computed && sameRoutedLink(previous, computed)) {
                // replace new route with the old one if they're equal
                // so other components can use a simple reference equality checks
                computedRoutes.set(linkId, previous);
            }
        });
        this.routings = computedRoutes;
        this.source.trigger('updateRoutings', { source: this, previous: previousRoutes });
    }
    getRoutings() {
        return this.routings;
    }
    getRouting(linkId) {
        return this.routings.get(linkId);
    }
    getLanguage() { return this._language; }
    setLanguage(value) {
        if (!value) {
            throw new Error('Cannot set empty language.');
        }
        const previous = this._language;
        if (previous === value) {
            return;
        }
        this._language = value;
        this.source.trigger('changeLanguage', { source: this, previous });
    }
    getLinkTemplates() {
        return this.linkTemplates;
    }
    performSyncUpdate() {
        for (let layer = RenderingLayer.FirstToUpdate; layer <= RenderingLayer.LastToUpdate; layer++) {
            this.source.trigger('syncUpdate', { layer });
        }
    }
    onIriClick(iri, element, clickIntent, event) {
        event.persist();
        event.preventDefault();
        const { onIriClick } = this.options;
        if (onIriClick) {
            onIriClick({ iri, element, clickIntent, originalEvent: event });
        }
    }
    setPaperWidget(widget) {
        const { key, widget: element, attachment } = widget;
        const widgets = { [key]: element ? { element, attachment } : undefined };
        this.source.trigger('updateWidgets', { widgets });
    }
    setHandlerForNextDropOnPaper(handler) {
        this.dropOnPaperHandler = handler;
    }
    _tryHandleDropOnPaper(e) {
        const { dropOnPaperHandler } = this;
        if (dropOnPaperHandler) {
            this.dropOnPaperHandler = undefined;
            dropOnPaperHandler(e);
            return true;
        }
        return false;
    }
    selectLabel(labels, language) {
        const targetLanguage = typeof language === 'undefined' ? this.getLanguage() : language;
        const { selectLabelLanguage = defaultSelectLabel } = this.options;
        return selectLabelLanguage(labels, targetLanguage);
    }
    formatLabel(labels, fallbackIri, language) {
        const label = this.selectLabel(labels, language);
        return resolveLabel(label, fallbackIri);
    }
    getElementTypeString(elementModel) {
        return elementModel.types.map(typeId => {
            const type = this.model.createClass(typeId);
            return this.formatLabel(type.label, type.id);
        }).sort().join(', ');
    }
    getTypeStyle(types) {
        types.sort();
        const customStyle = this.resolveTypeStyle(types);
        const icon = customStyle ? customStyle.icon : undefined;
        let color;
        if (customStyle && customStyle.color) {
            color = d3_color_1.hcl(customStyle.color);
        }
        else {
            const hue = getHueFromClasses(types, this.colorSeed);
            color = { h: hue, c: 40, l: 75 };
        }
        return { icon, color };
    }
    formatIri(iri) {
        if (blankNodes_1.isEncodedBlank(iri)) {
            return '(blank node)';
        }
        return `<${iri}>`;
    }
    getElementTemplate(types) {
        return this.resolveElementTemplate(types) || templates_1.StandardTemplate;
    }
    createLinkTemplate(linkType) {
        const existingTemplate = this.linkTemplates.get(linkType.id);
        if (existingTemplate) {
            return existingTemplate;
        }
        let template = {};
        const result = this.resolveLinkTemplate(linkType.id);
        if (result) {
            template = lodash_1.cloneDeep(result);
        }
        fillLinkTemplateDefaults(template);
        this.linkTemplates.set(linkType.id, template);
        this.source.trigger('changeLinkTemplates', {});
        return template;
    }
    dispose() {
        if (this.disposed) {
            return;
        }
        this.source.trigger('dispose', {});
        this.listener.stopListening();
        this.disposed = true;
    }
    get highlighter() { return this._highlighter; }
    setHighlighter(value) {
        const previous = this._highlighter;
        if (previous === value) {
            return;
        }
        this._highlighter = value;
        this.source.trigger('changeHighlight', { source: this, previous });
    }
    _setElementDecorator(decorator) {
        this._elementDecorator = decorator;
    }
    _decorateElement(element) {
        return this._elementDecorator(element);
    }
}
exports.DiagramView = DiagramView;
function sameRoutedLink(a, b) {
    return (a.linkId === b.linkId &&
        a.labelTextAnchor === b.labelTextAnchor &&
        geometry_1.isPolylineEqual(a.vertices, b.vertices));
}
function getHueFromClasses(classes, seed) {
    let hash = seed;
    for (const name of classes) {
        hash = utils_1.hashFnv32a(name, hash);
    }
    const MAX_INT32 = 0x7fffffff;
    return 360 * ((hash === undefined ? 0 : hash) / MAX_INT32);
}
function fillLinkTemplateDefaults(template) {
    const defaults = {
        markerTarget: { d: 'M0,0 L0,8 L9,4 z', width: 9, height: 8, fill: 'black' },
    };
    lodash_1.defaultsDeep(template, defaults);
    if (!template.renderLink) {
        template.renderLink = () => ({});
    }
}
function defaultSelectLabel(texts, language) {
    if (texts.length === 0) {
        return undefined;
    }
    let defaultValue;
    let englishValue;
    for (const text of texts) {
        if (text.lang === language) {
            return text;
        }
        else if (text.lang === '') {
            defaultValue = text;
        }
        else if (text.lang === 'en') {
            englishValue = text;
        }
    }
    return (defaultValue !== undefined ? defaultValue :
        englishValue !== undefined ? englishValue :
            texts[0]);
}
function resolveLabel(label, fallbackIri) {
    if (label) {
        return label.text;
    }
    return utils_1.getUriLocalName(fallbackIri) || fallbackIri;
}


/***/ }),
/* 67 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__67__;

/***/ }),
/* 68 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultTypeStyleBundle = void 0;
const classIcon = __webpack_require__(69);
const objectPropertyIcon = __webpack_require__(70);
const datatypePropertyIcon = __webpack_require__(71);
const personIcon = __webpack_require__(72);
const countryIcon = __webpack_require__(73);
const organizationIcon = __webpack_require__(74);
const locationIcon = __webpack_require__(75);
const eventIcon = __webpack_require__(76);
const objectIcon = __webpack_require__(77);
exports.DefaultTypeStyleBundle = types => {
    if (types.indexOf('http://www.w3.org/2002/07/owl#Class') !== -1 ||
        types.indexOf('http://www.w3.org/2000/01/rdf-schema#Class') !== -1) {
        return { color: '#eaac77', icon: classIcon };
    }
    else if (types.indexOf('http://www.w3.org/2002/07/owl#ObjectProperty') !== -1) {
        return { color: '#34c7f3', icon: objectPropertyIcon };
    }
    else if (types.indexOf('http://www.w3.org/2002/07/owl#DatatypeProperty') !== -1) {
        return { color: '#34c7f3', icon: datatypePropertyIcon };
    }
    else if (types.indexOf('http://xmlns.com/foaf/0.1/Person') !== -1 ||
        types.indexOf('http://www.wikidata.org/entity/Q5') !== -1) {
        return { color: '#eb7777', icon: personIcon };
    }
    else if (types.indexOf('http://www.wikidata.org/entity/Q6256') !== -1) {
        return { color: '#77ca98', icon: countryIcon };
    }
    else if (types.indexOf('http://schema.org/Organization') !== -1 ||
        types.indexOf('http://dbpedia.org/ontology/Organisation') !== -1 ||
        types.indexOf('http://xmlns.com/foaf/0.1/Organization') !== -1 ||
        types.indexOf('http://www.wikidata.org/entity/Q43229') !== -1) {
        return { color: '#77ca98', icon: organizationIcon };
    }
    else if (types.indexOf('http://www.wikidata.org/entity/Q618123') !== -1) {
        return { color: '#bebc71', icon: locationIcon };
    }
    else if (types.indexOf('http://www.wikidata.org/entity/Q1190554') !== -1) {
        return { color: '#b4b1fb', icon: eventIcon };
    }
    else if (types.indexOf('http://www.wikidata.org/entity/Q488383') !== -1) {
        return { color: '#53ccb2', icon: objectIcon };
    }
    else {
        return undefined;
    }
};


/***/ }),
/* 69 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNiAyNiI+DQogICAgPHRleHQgeD0iMyIgeT0iMjIiIGNsYXNzPSJ0ZXh0IiBmaWxsPSIjZWFhYzc3Ig0KICAgICAgICBzdHlsZT0iZm9udC1mYW1pbHk6ICdIZWx2ZXRpY2EgTmV1ZScsICdIZWx2ZXRpY2EnLCAnQXJpYWwnLCBzYW5zLXNlcmlmOyBmb250LXNpemU6IDI2cHg7IGZvbnQtd2VpZ2h0OiBib2xkOyI+DQogICAgICAgIEMNCiAgICA8L3RleHQ+DQo8L3N2Zz4NCg=="

/***/ }),
/* 70 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNiAyNiI+DQogICAgPHRleHQgeD0iMCIgeT0iMjAiIGNsYXNzPSJ0ZXh0IiBmaWxsPSIjMzRjN2YzIg0KICAgICAgICBzdHlsZT0iZm9udC1mYW1pbHk6ICdIZWx2ZXRpY2EgTmV1ZScsICdIZWx2ZXRpY2EnLCAnQXJpYWwnLCBzYW5zLXNlcmlmOyBmb250LXNpemU6IDE4cHg7IGZvbnQtd2VpZ2h0OiBib2xkOyI+DQogICAgICAgIE9QDQogICAgPC90ZXh0Pg0KPC9zdmc+DQo="

/***/ }),
/* 71 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNiAyNiI+DQogICAgPHRleHQgeD0iMCIgeT0iMjAiIGNsYXNzPSJ0ZXh0IiBmaWxsPSIjMzRjN2YzIg0KICAgICAgICBzdHlsZT0iZm9udC1mYW1pbHk6ICdIZWx2ZXRpY2EgTmV1ZScsICdIZWx2ZXRpY2EnLCAnQXJpYWwnLCBzYW5zLXNlcmlmOyBmb250LXNpemU6IDE4cHg7IGZvbnQtd2VpZ2h0OiBib2xkOyI+DQogICAgICAgIERQDQogICAgPC90ZXh0Pg0KPC9zdmc+DQo="

/***/ }),
/* 72 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAzNTAgMzUwIj4NCgk8cGF0aCBmaWxsPSIjZWI3Nzc3IiBkPSJNMTc1LDE3MS4xNzNjMzguOTE0LDAsNzAuNDYzLTM4LjMxOCw3MC40NjMtODUuNTg2QzI0NS40NjMsMzguMzE4LDIzNS4xMDUsMCwxNzUsMHMtNzAuNDY1LDM4LjMxOC03MC40NjUsODUuNTg3DQoJCUMxMDQuNTM1LDEzMi44NTUsMTM2LjA4NCwxNzEuMTczLDE3NSwxNzEuMTczeiIvPg0KCTxwYXRoIGZpbGw9IiNlYjc3NzciIGQ9Ik00MS45MDksMzAxLjg1M0M0MS44OTcsMjk4Ljk3MSw0MS44ODUsMzAxLjA0MSw0MS45MDksMzAxLjg1M0w0MS45MDksMzAxLjg1M3oiLz4NCgk8cGF0aCBmaWxsPSIjZWI3Nzc3IiBkPSJNMzA4LjA4NSwzMDQuMTA0QzMwOC4xMjMsMzAzLjMxNSwzMDguMDk4LDI5OC42MywzMDguMDg1LDMwNC4xMDRMMzA4LjA4NSwzMDQuMTA0eiIvPg0KCTxwYXRoIGZpbGw9IiNlYjc3NzciIGQ9Ik0zMDcuOTM1LDI5OC4zOTdjLTEuMzA1LTgyLjM0Mi0xMi4wNTktMTA1LjgwNS05NC4zNTItMTIwLjY1N2MwLDAtMTEuNTg0LDE0Ljc2MS0zOC41ODQsMTQuNzYxDQoJCXMtMzguNTg2LTE0Ljc2MS0zOC41ODYtMTQuNzYxYy04MS4zOTUsMTQuNjktOTIuODAzLDM3LjgwNS05NC4zMDMsMTE3Ljk4MmMtMC4xMjMsNi41NDctMC4xOCw2Ljg5MS0wLjIwMiw2LjEzMQ0KCQljMC4wMDUsMS40MjQsMC4wMTEsNC4wNTgsMC4wMTEsOC42NTFjMCwwLDE5LjU5MiwzOS40OTYsMTMzLjA4LDM5LjQ5NmMxMTMuNDg2LDAsMTMzLjA4LTM5LjQ5NiwxMzMuMDgtMzkuNDk2DQoJCWMwLTIuOTUxLDAuMDAyLTUuMDAzLDAuMDA1LTYuMzk5QzMwOC4wNjIsMzA0LjU3NSwzMDguMDE4LDMwMy42NjQsMzA3LjkzNSwyOTguMzk3eiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 73 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4NCiAgICA8cGF0aCBmaWxsPSIjNzdjYTk4IiBkPSJNNDcyLjkyOCwzNC43NTJjLTQuNDE2LTMuMDA4LTEwLjAxNi0zLjU1Mi0xNC45NDQtMS42Yy0xLjAyNCwwLjQxNi0xMDYuODgsNDIuMDQ4LTE5NS4xNjgsMC4zODQNCgkJCUMxODYuNzItMi40MzIsMTAyLjkxMiwxNC40LDY0LDI1Ljc2VjE2YzAtOC44MzItNy4xNjgtMTYtMTYtMTZjLTguODMyLDAtMTYsNy4xNjgtMTYsMTZ2MzJ2MjU2djE5MmMwLDguODMyLDcuMTY4LDE2LDE2LDE2DQoJCQljOC44MzIsMCwxNi03LjE2OCwxNi0xNlYzMTUuMzI4YzI4LjM4NC05LjE4NCwxMTIuNjA4LTMxLjEzNiwxODUuMTg0LDMuMTM2YzM0LjU5MiwxNi4zNTIsNzAuNzg0LDIxLjc5MiwxMDMuNjQ4LDIxLjc5Mg0KCQkJYzYzLjIsMCwxMTQuMDE2LTIwLjEyOCwxMTcuMTg0LTIxLjQwOGM2LjAxNi0yLjQ2NCw5Ljk4NC04LjMyLDkuOTg0LTE0Ljg0OFY0OEM0ODAsNDIuNjg4LDQ3Ny4zNDQsMzcuNzI4LDQ3Mi45MjgsMzQuNzUyeiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 74 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4NCiAgICA8cGF0aCBmaWxsPSIjNzdjYTk4IiBkPSJNMTU1LDBIMTVDNi43MTYsMCwwLDYuNzE2LDAsMTV2MzVoMTcwVjE1QzE3MCw2LjcxNiwxNjMuMjg0LDAsMTU1LDB6Ii8+DQogICAgPHBhdGggZmlsbD0iIzc3Y2E5OCIgZD0iTTUwNC40NjQsMTQyLjk4OWMtNC42NjItMi42NzQtMTAuMzk3LTIuNjUxLTE1LjAzNiwwLjA2M0wzNDEsMjI5Ljg1MlYxNTZjMC01LjM3NC0yLjg3NS0xMC4zMzctNy41MzYtMTMuMDExDQoJCQljLTQuNjYyLTIuNjc0LTEwLjM5Ny0yLjY1MS0xNS4wMzYsMC4wNjNMMTcwLDIyOS44NTJWODBIMHY0MTdjMCw4LjI4NCw2LjcxNiwxNSwxNSwxNWg0ODJjOC4yODQsMCwxNS02LjcxNiwxNS0xNVYxNTYNCgkJCUM1MTIsMTUwLjYyNiw1MDkuMTI1LDE0NS42NjMsNTA0LjQ2NCwxNDIuOTg5eiBNMjMwLDQwNi41YzAsOC4yODQtNi43MTYsMTUtMTUsMTVoLTYwYy04LjI4NCwwLTE1LTYuNzE2LTE1LTE1di02MA0KCQkJYzAtOC4yODQsNi43MTYtMTUsMTUtMTVoNjBjOC4yODQsMCwxNSw2LjcxNiwxNSwxNVY0MDYuNXogTTQwMSw0MDYuNWMwLDguMjg0LTYuNzE2LDE1LTE1LDE1aC02MGMtOC4yODQsMC0xNS02LjcxNi0xNS0xNXYtNjANCgkJCWMwLTguMjg0LDYuNzE2LTE1LDE1LTE1aDYwYzguMjg0LDAsMTUsNi43MTYsMTUsMTVWNDA2LjV6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 75 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI0Ny44MjVweCIgaGVpZ2h0PSI0Ny44MjVweCIgdmlld0JveD0iMCAwIDQ3LjgyNSA0Ny44MjUiPg0KICAgIDxwYXRoIGZpbGw9IiNiZWJjNzEiIGQ9Ik0zNi40MzksMTIuNjQ2YzAtNi45MTktNS42MDgtMTIuNTI3LTEyLjUyOC0xMi41MjdTMTEuMzg0LDUuNzI3LDExLjM4NCwxMi42NDZjMCw5LjkxMywxMi41MjcsMjQuNTgyLDEyLjUyNywyNC41ODINCgkJCQlTMzYuNDM5LDIyLjUwOCwzNi40MzksMTIuNjQ2eiBNMTcuNzMzLDExLjg5OGMwLTMuNDEzLDIuNzY3LTYuMTc5LDYuMTc5LTYuMTc5czYuMTc5LDIuNzY2LDYuMTc5LDYuMTc5DQoJCQkJYzAsMy40MTMtMi43NjcsNi4xNzktNi4xNzksNi4xNzlTMTcuNzMzLDE1LjMxMSwxNy43MzMsMTEuODk4eiIvPg0KICAgIDxjaXJjbGUgZmlsbD0iI2JlYmM3MSIgY3g9IjIzLjkxMSIgY3k9IjExLjg5OCIgcj0iMy4wMzgiLz4NCiAgICA8cGF0aCBmaWxsPSIjYmViYzcxIiBkPSJNMzAuOTk0LDMyLjg3Yy0xLjAyMSwxLjQ3Ni0xLjk3OSwyLjc2MS0yLjc3NywzLjc5M2M3LjkxNiwwLjQ3NiwxMy4xMDQsMi4xODUsMTUuMDM0LDMuNDU2DQoJCQkJYy0yLjI2MSwxLjQ5MS04Ljk3OSwzLjU4Ny0xOS4zMzgsMy41ODdjLTEwLjM1OCwwLTE3LjA3Ny0yLjA5Ny0xOS4zMzgtMy41ODdjMS45My0xLjI3MSw3LjExNC0yLjk3OSwxNS4wMjItMy40NTUNCgkJCQljLTAuOC0xLjAzMi0xLjc1OS0yLjMxNi0yLjc4MS0zLjc5MkM3LjA3NSwzMy44MzEsMCwzNi43MTMsMCw0MC4xMThjMCw0LjE5LDEwLjcwNyw3LjU4OCwyMy45MTMsNy41ODgNCgkJCQljMTMuMjA3LDAsMjMuOTEyLTMuMzk2LDIzLjkxMi03LjU4OEM0Ny44MjcsMzYuNzExLDQwLjc0NCwzMy44MjgsMzAuOTk0LDMyLjg3eiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 76 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI5Ny40NzNweCIgaGVpZ2h0PSI5Ny40NzNweCIgdmlld0JveD0iMCAwIDk3LjQ3MyA5Ny40NzMiPg0KCTxyZWN0IGZpbGw9IiNiNGIxZmIiIHg9IjQxLjU2OSIgeT0iNDcuNzUzIiB3aWR0aD0iMTQuMzMzIiBoZWlnaHQ9IjE0LjMzMyIvPg0KCTxyZWN0IGZpbGw9IiNiNGIxZmIiIHg9IjQxLjU2OSIgeT0iNjcuNzU0IiB3aWR0aD0iMTQuMzMzIiBoZWlnaHQ9IjE0LjMzMiIvPg0KCTxyZWN0IGZpbGw9IiNiNGIxZmIiIHg9IjE4LjU2OSIgeT0iNjcuNzU0IiB3aWR0aD0iMTQuMzMzIiBoZWlnaHQ9IjE0LjMzMiIvPg0KCTxyZWN0IGZpbGw9IiNiNGIxZmIiIHg9IjE4LjU2OSIgeT0iNDcuNzUzIiB3aWR0aD0iMTQuMzMzIiBoZWlnaHQ9IjE0LjMzMyIvPg0KCTxwYXRoIGZpbGw9IiNiNGIxZmIiIGQ9Ik05NS40NzIsMTQuNDY2SDg0LjQyN1YyLjcwMWMwLTEuMTA0LTAuODk2LTItMi0ySDY1LjgxMWMtMS4xMDQsMC0yLDAuODk2LTIsMnYxMS43NjVIMzMuNjYyVjIuNzAxYzAtMS4xMDQtMC44OTYtMi0yLTINCgkJCQlIMTUuMDQ1Yy0xLjEwNCwwLTIsMC44OTYtMiwydjExLjc2NUgyYy0xLjEwNCwwLTIsMC44OTYtMiwydjc4LjMwNWMwLDEuMTA0LDAuODk2LDIsMiwyaDkzLjQ3M2MxLjEwNCwwLDItMC44OTYsMi0yVjE2LjQ2Ng0KCQkJCUM5Ny40NzIsMTUuMzYyLDk2LjU3NiwxNC40NjYsOTUuNDcyLDE0LjQ2NnogTTY5LjY0NSw4LjAzN2MwLTAuODI4LDAuNjcyLTEuNSwxLjUtMS41aDUuOTQ3YzAuODI5LDAsMS41LDAuNjcyLDEuNSwxLjV2MjAuMzQNCgkJCQljMCwwLjgyOC0wLjY3MSwxLjUtMS41LDEuNWgtNS45NDdjLTAuODI4LDAtMS41LTAuNjcyLTEuNS0xLjVWOC4wMzd6IE0xOC44OCw4LjAzN2MwLTAuODI4LDAuNjcxLTEuNSwxLjUtMS41aDUuOTQ3DQoJCQkJYzAuODI5LDAsMS41LDAuNjcyLDEuNSwxLjV2MjAuMzRjMCwwLjgyOC0wLjY3MSwxLjUtMS41LDEuNUgyMC4zOGMtMC44MjksMC0xLjUtMC42NzItMS41LTEuNVY4LjAzN3ogTTg3LjA2OCw4NC45MDINCgkJCQljMCwwLjgyOC0wLjY3LDEuNS0xLjUsMS41SDExLjkwM2MtMC44MjksMC0xLjUtMC42NzItMS41LTEuNXYtNDBjMC0wLjgyOCwwLjY3MS0xLjUsMS41LTEuNWg3My42NjZjMC44MywwLDEuNSwwLjY3MiwxLjUsMS41DQoJCQkJVjg0LjkwMnoiLz4NCgk8cmVjdCBmaWxsPSIjYjRiMWZiIiB4PSI2NC41NjgiIHk9IjQ3Ljc1MyIgd2lkdGg9IjE0LjMzNCIgaGVpZ2h0PSIxNC4zMzMiLz4NCgk8cmVjdCBmaWxsPSIjYjRiMWZiIiB4PSI2NC41NjgiIHk9IjY3Ljc1NCIgd2lkdGg9IjE0LjMzNCIgaGVpZ2h0PSIxNC4zMzIiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 77 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IiBoZWlnaHQ9IjUwcHgiIHZpZXdCb3g9IjAgMCA1MCA1MCI+DQogICAgPHBhdGggZmlsbD0iIzUzY2NiMiIgZD0iTTI2LjEyLDE0LjQ4OGMwLjg3OS0xLjQ2OCwyLjI3LTMuNTY5LDQuMDI3LTUuNTg1aDAuMDAyYzEuNDg4LTEuNzExLDQuNDAyLTMuOTA3LDQuNDAyLTMuOTA3DQoJCQljMC40MzgtMC4zMzEsMC4zOTEtMC43OTItMC4xMDctMS4wMjRsLTMuNTIyLTEuNjQ2Yy0wLjQ5OC0wLjIzMy0xLjE3NS0wLjA2My0xLjUwNSwwLjM3NmMwLDAtMi42MDUsMy43MzctNS42NzEsMTEuNjkyDQoJCQljLTkuNDgtNC4yODgtMTguNDkxLDEuNzE4LTE4LjQ5MSwxMi4xNjJjMCwxMC45MDksOC4zOTMsMjcuNDgsMTkuNzQzLDIyLjQ3OGMxMS45NTQsNS4xNzMsMTkuNzQ5LTExLjU2OCwxOS43NDktMjIuNDc4DQoJCQlDNDQuNzQ3LDE2LjAyMiwzNi42NDcsOS44NDYsMjYuMTIsMTQuNDg4eiIvPg0KICAgIDxwYXRoIGZpbGw9IiM1M2NjYjIiIGQ9Ik0yMy45OTcsMTAuOTU1YzAuNTQ4LTAuMDQ2LDEuMDMyLTAuNTMxLDEuMDc2LTEuMDc4YzAsMCwwLjM1Mi00LjI2Ni0yLjYyMS03LjI0MmMtMi45ODItMi45NzctNy4yNC0yLjYyMi03LjI0LTIuNjIyDQoJCQljLTAuNTQ4LDAuMDQ2LTEuMDMyLDAuNTMxLTEuMDc3LDEuMDc4YzAsMC0wLjM1OCw0LjI2OCwyLjYxOSw3LjI0NUMxOS43MjksMTEuMzEsMjMuOTk3LDEwLjk1NSwyMy45OTcsMTAuOTU1eiIvPg0KPC9zdmc+DQo="

/***/ }),
/* 78 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultLinkTemplateBundle = exports.LINK_SHOW_IRI = void 0;
const schema_1 = __webpack_require__(54);
exports.LINK_SHOW_IRI = {
    renderLink: link => ({
        properties: [{
                position: 0.5,
                attrs: {
                    text: {
                        text: [{
                                text: link.typeId,
                                lang: '',
                            }],
                        fill: 'gray',
                        'font-size': 12,
                        'font-weight': 'lighter',
                    },
                },
            }],
    }),
};
const LINK_SUB_CLASS_OF = {
    markerTarget: {
        fill: '#f8a485',
        stroke: '#cf8e76',
    },
    renderLink: () => ({
        connection: {
            stroke: '#f8a485',
            'stroke-width': 2,
        },
    }),
};
const LINK_DOMAIN = {
    markerTarget: {
        fill: '#34c7f3',
        stroke: '#38b5db',
    },
    renderLink: () => ({
        connection: {
            stroke: '#34c7f3',
            'stroke-width': 2,
        },
    }),
};
const LINK_RANGE = {
    markerTarget: {
        fill: '#34c7f3',
        stroke: '#38b5db',
    },
    renderLink: () => ({
        connection: {
            stroke: '#34c7f3',
            'stroke-width': 2,
        },
    }),
};
const LINK_TYPE_OF = {
    markerTarget: {
        fill: '#8cd965',
        stroke: '#5b9a3b',
    },
    renderLink: () => ({
        connection: {
            stroke: '#8cd965',
            'stroke-width': 2,
        },
    }),
};
exports.DefaultLinkTemplateBundle = type => {
    if (type === 'http://www.w3.org/2000/01/rdf-schema#subClassOf') {
        return LINK_SUB_CLASS_OF;
    }
    else if (type === 'http://www.w3.org/2000/01/rdf-schema#domain') {
        return LINK_DOMAIN;
    }
    else if (type === 'http://www.w3.org/2000/01/rdf-schema#range') {
        return LINK_RANGE;
    }
    else if (type === 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type') {
        return LINK_TYPE_OF;
    }
    else if (type === schema_1.PLACEHOLDER_LINK_TYPE) {
        return { markerTarget: { fill: 'none' } };
    }
    else {
        return undefined;
    }
};


/***/ }),
/* 79 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.filter = exports.linkTypesOf = exports.linksInfo = exports.elementInfo = exports.createLabelForBlankBinding = exports.decodeId = exports.encodeId = exports.processBlankBindings = exports.updateFilterResults = exports.QueryExecutor = exports.isEncodedBlank = exports.BLANK_NODE_QUERY = exports.BLANK_NODE_QUERY_PARAMETERS = exports.ENCODED_PREFIX = exports.MAX_RECURSION_DEEP = void 0;
const tslib_1 = __webpack_require__(1);
const utils_1 = __webpack_require__(49);
const sparqlModels_1 = __webpack_require__(80);
exports.MAX_RECURSION_DEEP = 3;
exports.ENCODED_PREFIX = 'sparql-blank:';
exports.BLANK_NODE_QUERY_PARAMETERS = '?blankTrgProp ?blankTrg ?blankSrc ?blankSrcProp ?listHead';
exports.BLANK_NODE_QUERY = `
    OPTIONAL {
        FILTER (ISBLANK(?inst)).
        {
            ?inst ?blankTrgProp ?blankTrg.
            ?blankSrc ?blankSrcProp ?inst.
            FILTER NOT EXISTS { ?inst rdf:first _:smth1 }.
            BIND("blankNode" as ?blankType)
        } UNION {
            ?inst rdf:rest*/rdf:first ?blankTrg.
            ?blankSrc ?blankSrcProp ?inst.
            _:smth2 rdf:first ?blankTrg.
            BIND(?blankSrcProp as ?blankTrgProp)
            BIND("listHead" as ?blankType)
            FILTER NOT EXISTS { _:smth3 rdf:rest ?inst }.
        } UNION {
            ?listHead rdf:rest* ?inst.
            FILTER NOT EXISTS { _:smth4 rdf:rest ?listHead }.

            ?listHead rdf:rest*/rdf:first ?blankTrg.
            ?blankSrc ?blankSrcProp ?listHead.
            _:smth5 rdf:first ?blankTrg.
            BIND(?blankSrcProp as ?blankTrgProp)
            BIND("listHead" as ?blankType)
        }
    }
`;
function isEncodedBlank(id) {
    return id.startsWith(exports.ENCODED_PREFIX);
}
exports.isEncodedBlank = isEncodedBlank;
class QueryExecutor {
    constructor(queryFunction) {
        this.queryFunction = queryFunction;
        this.queryDictionary = {};
    }
    executeQuery(query) {
        const execution = this.queryDictionary[query];
        if (execution) {
            return execution;
        }
        else {
            this.queryDictionary[query] = this.queryFunction(query).then(response => {
                delete this.queryDictionary[query];
                return response;
            });
            return this.queryDictionary[query];
        }
    }
}
exports.QueryExecutor = QueryExecutor;
function updateFilterResults(result, queryFunction, settings) {
    const completeBindings = [];
    const blankBindings = [];
    for (const binding of result.results.bindings) {
        if (sparqlModels_1.isBlankBinding(binding)) {
            blankBindings.push(binding);
        }
        else {
            completeBindings.push(binding);
        }
    }
    return processBlankBindings(blankBindings, (callBackQuery) => {
        return queryFunction(callBackQuery);
    }, settings).then(processedBindings => {
        result.results.bindings = completeBindings.concat(processedBindings);
        return result;
    });
}
exports.updateFilterResults = updateFilterResults;
function processBlankBindings(blankBindings, queryFunction, settings) {
    const bindingGroupsById = {};
    for (const binding of blankBindings) {
        if (binding.newInst) {
            binding.inst = binding.newInst;
        }
        if (!bindingGroupsById[binding.inst.value]) {
            bindingGroupsById[binding.inst.value] = [];
        }
        bindingGroupsById[binding.inst.value].push(binding);
    }
    const relatedBlankBindnings = [];
    for (const b of blankBindings) {
        if (sparqlModels_1.isRdfBlank(b.blankTrg)) {
            relatedBlankBindnings.push([b]);
        }
    }
    const queryExecutor = new QueryExecutor(queryFunction);
    return loadRelatedBlankNodes(relatedBlankBindnings, queryExecutor, settings).then(loadedGroupsById => {
        const idsMap = getEncodedIdDictionary(loadedGroupsById);
        const groups = Object.keys(bindingGroupsById).map(key => bindingGroupsById[key]);
        for (const group of groups) {
            for (const blankBinding of group) {
                if (!blankBinding.label) {
                    blankBinding.label = createLabelForBlankBinding(blankBinding);
                }
                const encodedId4LoadedElement = idsMap[blankBinding.blankTrg.value];
                if (encodedId4LoadedElement) {
                    blankBinding.blankTrg.value = encodedId4LoadedElement;
                }
            }
            const encodedId = encodeId(group);
            updateGroupIds(group, encodedId);
        }
        return blankBindings;
    });
}
exports.processBlankBindings = processBlankBindings;
function getEncodedIdDictionary(blankBindingGroups) {
    const idDictionary = {};
    const keys = Object.keys(blankBindingGroups);
    for (const key of keys) {
        idDictionary[key] = encodeId(blankBindingGroups[key]);
        updateGroupIds(blankBindingGroups[key], idDictionary[key]);
    }
    return idDictionary;
}
function updateGroupIds(group, newId) {
    for (const loadedBlankBinding of group) {
        loadedBlankBinding.inst.value = newId;
    }
}
function encodeId(blankBindings) {
    const bindingSet = {};
    for (const binding of blankBindings) {
        // leave out instance unique ID
        const { inst } = binding, exceptInst = tslib_1.__rest(binding, ["inst"]);
        const encodedBinding = JSON.stringify(exceptInst);
        bindingSet[encodedBinding] = exceptInst;
    }
    const normalizedBindings = Object.keys(bindingSet).sort().map(key => bindingSet[key]);
    return exports.ENCODED_PREFIX + encodeURI(JSON.stringify(normalizedBindings));
}
exports.encodeId = encodeId;
function decodeId(id) {
    if (!isEncodedBlank(id)) {
        return undefined;
    }
    try {
        const clearId = id.substring(exports.ENCODED_PREFIX.length, id.length);
        const parsedBindings = JSON.parse(decodeURI(clearId));
        const bindings = parsedBindings.map(binding => {
            // restore instance unique ID
            binding.inst = { type: 'uri', value: id };
            return binding;
        });
        return bindings;
    }
    catch (error) {
        /* silent */
        return undefined;
    }
}
exports.decodeId = decodeId;
function createLabelForBlankBinding(bn) {
    if (bn.blankType.value === 'listHead') {
        return {
            type: 'literal',
            value: 'RDFList',
            'xml:lang': '',
        };
    }
    else {
        return {
            type: 'literal',
            value: bn.class ? (utils_1.getUriLocalName(bn.class.value) || bn.class.value) : 'anonymous',
            'xml:lang': '',
        };
    }
}
exports.createLabelForBlankBinding = createLabelForBlankBinding;
function loadRelatedBlankNodes(blankChains, queryExecutor, settings, recursionDeep) {
    recursionDeep = recursionDeep || 1;
    if (recursionDeep > exports.MAX_RECURSION_DEEP) {
        return Promise.resolve({});
    }
    const queryPairs = blankChains.map(chain => ({
        query: getQueryForChain(chain, settings),
        chain: chain,
    }));
    const promises = queryPairs.map(pair => queryExecutor.executeQuery(pair.query).then(response => ({
        response: response,
        chain: pair.chain,
    })));
    return Promise.all(promises)
        .then(results => {
        const recursionPromises = [];
        const loadedBlankBindings = {};
        for (const result of results) {
            const bindings = result.response.results.bindings;
            if (bindings.length > 0) {
                const relatedBlankBindings = [];
                for (const binding of bindings) {
                    if (sparqlModels_1.isRdfBlank(binding.blankTrg)) {
                        relatedBlankBindings.push(result.chain.concat([binding]));
                    }
                }
                recursionPromises.push(loadRelatedBlankNodes(relatedBlankBindings, queryExecutor, settings, (recursionDeep + 1))
                    .then(loadedGroupsById => {
                    const idsMap = getEncodedIdDictionary(loadedGroupsById);
                    const mergedResults = {};
                    for (const binding of bindings) {
                        binding.label = createLabelForBlankBinding(binding);
                        const encodedId = idsMap[binding.blankTrg.value];
                        if (encodedId) {
                            binding.blankTrg.value = encodedId;
                        }
                        if (!mergedResults[binding.inst.value]) {
                            mergedResults[binding.inst.value] = [];
                        }
                        mergedResults[binding.inst.value].push(binding);
                    }
                    Object.keys(mergedResults).forEach(key => {
                        const group = mergedResults[key];
                        const originalId = group[0].inst.value;
                        loadedBlankBindings[originalId] = group;
                    });
                    return true;
                }));
            }
        }
        return Promise.all(recursionPromises).then(() => {
            return loadedBlankBindings;
        });
    });
}
function getQueryForChain(blankNodes, sparqlDataProviderSettings) {
    function getQueryBlock(blankNode, index, maxIndex) {
        // if blankNode has type 'listHead' then his target and targetProperty is artificial,
        // and we can't include this id in chain
        const trustableTrgProp = (index === 0 || blankNode.blankType.value !== 'listHead');
        const sourceId = index > 0 ? '?inst' + (index - 1) : '<' + blankNode.blankSrc.value + '>';
        const sourcePropId = trustableTrgProp ?
            (index > 0 ? '?blankTrgProp' + (index - 1) : '<' + blankNode.blankSrcProp.value + '>') :
            '?anyType' + index;
        const instPostfix = index === maxIndex ? '' : index.toString();
        const targetPropId = trustableTrgProp ? '<' + blankNode.blankTrgProp.value + '>' : '?anyType0' + index;
        const firstRelation = index === 0 && blankNode.blankType.value === 'listHead' ?
            `
            ?blankSrc${index} rdf:rest*/rdf:first ?inst${instPostfix}.
            ` :
            `?blankSrc${index} ${targetPropId} ?inst${instPostfix}.`;
        return `
            # ======================
            ${sourceId} ${sourcePropId} ?blankSrc${index}.
            ${firstRelation}
            BIND (<${blankNode.blankTrgProp.value}> as ?blankSrcProp${index}).
            FILTER (ISBLANK(?inst${instPostfix})).
            {
                ?inst${instPostfix} ?blankTrgProp${instPostfix} ?blankTrg${instPostfix}.
                BIND("blankNode" as ?blankType${instPostfix}).
                FILTER NOT EXISTS { ?inst${instPostfix} rdf:first _:smth1${index} }.
            } UNION {
                ?inst${instPostfix} rdf:rest*/rdf:first ?blankTrg${instPostfix}.
                ?blankSrc${index} ?blankSrcProp${index} ?inst${instPostfix}.
                _:smth2${index} rdf:first ?blankTrg${instPostfix}.
                BIND(?blankSrcProp${index} as ?blankTrgProp${instPostfix})
                BIND("listHead" as ?blankType${instPostfix})
                FILTER NOT EXISTS { _:smth3${index} rdf:rest ?inst${instPostfix} }.
            }
            OPTIONAL {
                ?inst${instPostfix} rdf:type ?class${instPostfix}.
            }
        `;
    }
    const body = blankNodes.map((bn, index) => getQueryBlock(bn, index, blankNodes.length - 1)).join('\n');
    const query = `${sparqlDataProviderSettings.defaultPrefix}
    SELECT ?inst ?class ?label ?blankTrgProp ?blankTrg ?blankType
        WHERE {
           ${body}
        }
    `;
    return query;
}
function elementInfo(elementIds) {
    const ids = elementIds.filter(id => isEncodedBlank(id));
    return {
        head: undefined,
        results: { bindings: getElementBindings(ids) },
    };
}
exports.elementInfo = elementInfo;
function linksInfo(elementIds) {
    return {
        head: undefined,
        results: { bindings: getLinkBinding(elementIds) },
    };
}
exports.linksInfo = linksInfo;
function linkTypesOf(params) {
    return {
        head: undefined,
        results: { bindings: getLinkCountBinding(params.elementId) },
    };
}
exports.linkTypesOf = linkTypesOf;
function filter(params) {
    const filterResponse = {
        head: undefined,
        results: { bindings: [] },
    };
    if (params.limit === 0) {
        params.limit = 100;
    }
    if (params.elementTypeId) {
        filterResponse.results.bindings = [];
    }
    else if (params.refElementId && params.refElementLinkId) {
        filterResponse.results.bindings = getAllRelatedByLinkTypeElements(params.refElementId, params.refElementLinkId, params.linkDirection);
    }
    else if (params.refElementId) {
        filterResponse.results.bindings = getAllRelatedElements(params.refElementId);
    }
    if (params.text && filterResponse.results.bindings.length !== 0) {
        filterResponse.results.bindings =
            filterResponse.results.bindings.filter(be => be.inst.value.toLowerCase().indexOf(params.text) !== -1);
    }
    return filterResponse;
}
exports.filter = filter;
function getAllRelatedByLinkTypeElements(refElementId, refElementLinkId, linkDirection) {
    const blankElements = (decodeId(refElementId) || [])
        .concat(decodeId(refElementLinkId) || []);
    let bindings = [];
    if (blankElements.length > 0) {
        for (const be of blankElements) {
            if (linkDirection === 'in') {
                if (be.inst.value === refElementId &&
                    (sparqlModels_1.isRdfIri(be.blankSrc) || sparqlModels_1.isRdfBlank(be.blankSrc)) &&
                    refElementLinkId === be.blankSrcProp.value) {
                    if (sparqlModels_1.isRdfIri(be.blankSrc)) {
                        bindings.push({
                            inst: be.blankSrc,
                        });
                    }
                    else {
                        bindings = bindings.concat(decodeId(be.blankSrc.value) || [{ inst: be.blankSrc }]);
                    }
                }
                else if (be.blankTrg.value === refElementId &&
                    refElementLinkId === be.blankTrgProp.value) {
                    bindings.push(be);
                }
            }
            else {
                if (be.inst.value === refElementId &&
                    (sparqlModels_1.isRdfIri(be.blankTrg) || sparqlModels_1.isRdfBlank(be.blankTrg)) &&
                    refElementLinkId === be.blankTrgProp.value) {
                    if (sparqlModels_1.isRdfIri(be.blankTrg)) {
                        bindings.push({
                            inst: be.blankTrg,
                        });
                    }
                    else {
                        bindings = bindings.concat(decodeId(be.blankTrg.value) || [{ inst: be.blankTrg }]);
                    }
                }
                else if (be.blankSrc.value === refElementId &&
                    refElementLinkId === be.blankSrcProp.value) {
                    bindings.push(be);
                }
            }
        }
    }
    return bindings;
}
function getAllRelatedElements(id) {
    const blankElements = decodeId(id);
    let bindings = [];
    if (blankElements) {
        for (const be of blankElements) {
            if (be.inst.value === id || id === be.blankSrc.value || id === be.blankTrg.value) {
                bindings.push(be);
                if (sparqlModels_1.isRdfIri(be.blankSrc)) {
                    bindings.push({ inst: be.blankSrc });
                }
                else if (sparqlModels_1.isRdfBlank(be.blankSrc)) {
                    bindings = bindings.concat(decodeId(be.blankSrc.value) || [{ inst: be.blankSrc }]);
                }
                if (sparqlModels_1.isRdfIri(be.blankTrg)) {
                    bindings.push({ inst: be.blankTrg });
                }
                else if (sparqlModels_1.isRdfBlank(be.blankTrg)) {
                    bindings = bindings.concat(decodeId(be.blankTrg.value) || [{ inst: be.blankTrg }]);
                }
            }
        }
    }
    return bindings;
}
function getElementBindings(ids) {
    let blankElements = [];
    for (const id of ids) {
        const blankBindings = decodeId(id);
        if (blankBindings) {
            blankElements = blankElements.concat(decodeId(id));
        }
    }
    return blankElements.filter(be => {
        return ids.indexOf(be.inst.value) !== -1;
    });
}
function getLinkBinding(ids) {
    let blankElements = [];
    for (const id of ids) {
        const blankBindings = decodeId(id);
        if (blankBindings) {
            blankElements = blankElements.concat(decodeId(id));
        }
    }
    const bindings = [];
    for (const be of blankElements) {
        if (ids.indexOf(be.inst.value) !== -1) {
            if ((sparqlModels_1.isRdfIri(be.blankSrc) || sparqlModels_1.isRdfBlank(be.blankSrc)) &&
                sparqlModels_1.isRdfIri(be.blankSrcProp) &&
                ids.indexOf(be.blankSrc.value) !== -1) {
                bindings.push({
                    source: be.blankSrc,
                    type: be.blankSrcProp,
                    target: be.inst,
                });
            }
            if ((sparqlModels_1.isRdfIri(be.blankTrg) || sparqlModels_1.isRdfBlank(be.blankTrg)) &&
                sparqlModels_1.isRdfIri(be.blankTrgProp) &&
                ids.indexOf(be.blankTrg.value) !== -1) {
                bindings.push({
                    source: be.inst,
                    type: be.blankTrgProp,
                    target: be.blankTrg,
                });
            }
        }
    }
    return bindings;
}
function getLinkCountBinding(id) {
    const blankElements = decodeId(id);
    const bindings = [];
    const dictionary = {};
    for (const be of blankElements) {
        if (id === be.inst.value) {
            if ((sparqlModels_1.isRdfIri(be.blankTrg) || sparqlModels_1.isRdfBlank(be.blankTrg)) &&
                sparqlModels_1.isRdfIri(be.blankTrgProp)) {
                if ((sparqlModels_1.isRdfIri(be.blankSrc) || sparqlModels_1.isRdfBlank(be.blankSrc)) &&
                    sparqlModels_1.isRdfIri(be.blankSrcProp)) {
                    if (!dictionary[be.blankSrcProp.value]) {
                        dictionary[be.blankSrcProp.value] = {
                            link: be.blankSrcProp,
                            inCount: {
                                type: 'literal',
                                value: '1',
                                'xml:lang': '',
                            },
                            outCount: {
                                type: 'literal',
                                value: '0',
                                'xml:lang': '',
                            },
                        };
                    }
                }
                if (!dictionary[be.blankTrgProp.value]) {
                    dictionary[be.blankTrgProp.value] = {
                        link: be.blankTrgProp,
                        inCount: {
                            type: 'literal',
                            value: '0',
                            'xml:lang': '',
                        },
                        outCount: {
                            type: 'literal',
                            value: '1',
                            'xml:lang': '',
                        },
                    };
                }
                else {
                    dictionary[be.blankTrgProp.value].outCount.value =
                        (+dictionary[be.blankTrgProp.value].outCount.value + 1).toString();
                }
            }
        }
    }
    return Object.keys(dictionary).map(k => dictionary[k]);
}


/***/ }),
/* 80 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isBlankBinding = exports.isRdfLiteral = exports.isRdfIri = exports.isRdfBlank = void 0;
function isRdfBlank(e) {
    return e && e.type === 'bnode';
}
exports.isRdfBlank = isRdfBlank;
function isRdfIri(e) {
    return e && e.type === 'uri';
}
exports.isRdfIri = isRdfIri;
function isRdfLiteral(e) {
    return e && e.type === 'literal';
}
exports.isRdfLiteral = isRdfLiteral;
function isBlankBinding(binding) {
    const blank = binding;
    return blank.blankTrgProp !== undefined
        || blank.blankTrg !== undefined
        || blank.blankSrcProp !== undefined
        || blank.blankSrc !== undefined;
}
exports.isBlankBinding = isBlankBinding;


/***/ }),
/* 81 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultLinkRouter = void 0;
const geometry_1 = __webpack_require__(57);
class DefaultLinkRouter {
    constructor(gap = 20) {
        this.gap = gap;
    }
    route(model) {
        const routings = new Map();
        for (const link of model.links) {
            if (routings.has(link.id)) {
                continue;
            }
            // The cell is a link. Let's find its source and target models.
            const { sourceId, targetId } = link;
            if (!sourceId || !targetId) {
                continue;
            }
            else if (sourceId === targetId) {
                this.routeFeedbackSiblingLinks(model, sourceId, routings);
            }
            else {
                this.routeNormalSiblingLinks(model, sourceId, targetId, routings);
            }
        }
        return routings;
    }
    routeFeedbackSiblingLinks(model, elementId, routings) {
        const element = model.getElement(elementId);
        const { x, y } = element.position;
        const { width, height } = element.size;
        let index = 0;
        for (const sibling of element.links) {
            if (routings.has(sibling.id) || hasUserPlacedVertices(sibling)) {
                continue;
            }
            const { sourceId, targetId } = sibling;
            if (sourceId === targetId) {
                const offset = this.gap * (index + 1);
                const vertices = [
                    { x: x - offset, y: y + height / 2 },
                    { x: x - offset, y: y - offset },
                    { x: x + width / 2, y: y - offset },
                ];
                routings.set(sibling.id, { linkId: sibling.id, vertices });
                index++;
            }
        }
    }
    routeNormalSiblingLinks(model, sourceId, targetId, routings) {
        const source = model.getElement(sourceId);
        const target = model.getElement(targetId);
        const sourceCenter = centerOfElement(source);
        const targetCenter = centerOfElement(target);
        const midPoint = {
            x: (sourceCenter.x + targetCenter.x) / 2,
            y: (sourceCenter.y + targetCenter.y) / 2,
        };
        const direction = geometry_1.Vector.normalize({
            x: targetCenter.x - sourceCenter.x,
            y: targetCenter.y - sourceCenter.y,
        });
        const siblings = source.links.filter(link => (link.sourceId === targetId || link.targetId === targetId) &&
            !routings.has(link.id) &&
            !hasUserPlacedVertices(link));
        if (siblings.length <= 1) {
            return;
        }
        const indexModifier = siblings.length % 2 ? 0 : 1;
        siblings.forEach((sibling, siblingIndex) => {
            // For mor beautifull positioning
            const index = siblingIndex + indexModifier;
            // We want the offset values to be calculated as follows 0, 50, 50, 100, 100, 150, 150 ..
            const offset = this.gap * Math.ceil(index / 2) - (indexModifier ? this.gap / 2 : 0);
            // Now we need the vertices to be placed at points which are 'offset' pixels distant
            // from the first link and forms a perpendicular angle to it. And as index goes up
            // alternate left and right.
            //
            //  ^  odd indexes
            //  |
            //  |---->  index 0 line (straight line between a source center and a target center.
            //  |
            //  v  even indexes
            const offsetDirection = index % 2
                ? { x: -direction.y, y: direction.x } // rotate by 90 degrees counter-clockwise
                : { x: direction.y, y: -direction.x }; // rotate by 90 degrees clockwise
            // We found the vertex.
            const vertex = {
                x: midPoint.x + offsetDirection.x * offset,
                y: midPoint.y + offsetDirection.y * offset,
            };
            routings.set(sibling.id, {
                linkId: sibling.id,
                vertices: [vertex],
                labelTextAnchor: this.getLabelAlignment(direction, siblingIndex, siblings.length),
            });
        });
    }
    getLabelAlignment(connectionDirection, siblingIndex, siblingCount) {
        // offset direction angle in [0; 2 Pi] interval
        const angle = Math.atan2(connectionDirection.y, connectionDirection.x);
        const absoluteAngle = Math.abs(angle);
        const isHorizontal = absoluteAngle < Math.PI * 1 / 8 || absoluteAngle > Math.PI * 7 / 8;
        const isTop = angle < 0;
        const isBottom = angle > 0;
        const firstOuter = siblingCount - 2;
        const secondOuter = siblingCount - 1;
        if (!isHorizontal) {
            if (isTop && siblingIndex === secondOuter || isBottom && siblingIndex === firstOuter) {
                return 'end';
            }
            else if (isTop && siblingIndex === firstOuter || isBottom && siblingIndex === secondOuter) {
                return 'start';
            }
        }
        return 'middle';
    }
}
exports.DefaultLinkRouter = DefaultLinkRouter;
function hasUserPlacedVertices(link) {
    const vertices = link.vertices;
    return vertices && vertices.length > 0;
}
function centerOfElement(element) {
    const { x, y } = element.position;
    const { width, height } = element.size;
    return { x: x + width / 2, y: y + height / 2 };
}


/***/ }),
/* 82 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkMarkers = exports.LinkLayer = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const react_1 = __webpack_require__(46);
const async_1 = __webpack_require__(61);
const collections_1 = __webpack_require__(56);
const events_1 = __webpack_require__(55);
const commands_1 = __webpack_require__(64);
const elements_1 = __webpack_require__(53);
const geometry_1 = __webpack_require__(57);
const view_1 = __webpack_require__(66);
var UpdateRequest;
(function (UpdateRequest) {
    /** Some part of layer requested an update */
    UpdateRequest[UpdateRequest["Partial"] = 1] = "Partial";
    /** Full update requested */
    UpdateRequest[UpdateRequest["All"] = 2] = "All";
})(UpdateRequest || (UpdateRequest = {}));
const CLASS_NAME = 'ontodia-link-layer';
class LinkLayer extends react_1.Component {
    constructor(props, context) {
        super(props, context);
        this.listener = new events_1.EventObserver();
        this.delayedUpdate = new async_1.Debouncer();
        this.updateState = UpdateRequest.Partial;
        /** List of link IDs to update at the next flush event */
        this.scheduledToUpdate = collections_1.createStringMap();
        this.scheduleUpdateAll = () => {
            if (this.updateState !== UpdateRequest.All) {
                this.updateState = UpdateRequest.All;
                this.scheduledToUpdate = collections_1.createStringMap();
            }
            this.delayedUpdate.call(this.performUpdate);
        };
        this.performUpdate = () => {
            this.forceUpdate();
        };
        this.getLinks = () => {
            const { view, links, group } = this.props;
            if (!group) {
                return links;
            }
            const grouping = geometry_1.computeGrouping(view.model.elements);
            const nestedElements = computeDeepNestedElements(grouping, group);
            return links.filter(link => {
                const { sourceId, targetId } = link;
                const source = view.model.getElement(sourceId);
                const target = view.model.getElement(targetId);
                if (!source || !target) {
                    return false;
                }
                const sourceGroup = source.group;
                const targetGroup = target.group;
                return nestedElements[sourceGroup] || nestedElements[targetGroup];
            });
        };
    }
    componentDidMount() {
        const { view } = this.props;
        this.listener.listen(view.events, 'changeLanguage', this.scheduleUpdateAll);
        this.listener.listen(view.events, 'changeHighlight', this.scheduleUpdateAll);
        const updateChangedRoutes = (changed, previous) => {
            changed.forEach((routing, linkId) => {
                if (previous.get(linkId) !== routing) {
                    this.scheduleUpdateLink(linkId);
                }
            });
        };
        this.listener.listen(view.events, 'updateRoutings', ({ previous }) => {
            const newRoutes = view.getRoutings();
            updateChangedRoutes(newRoutes, previous);
            updateChangedRoutes(previous, newRoutes);
        });
        this.listener.listen(view.model.events, 'changeCells', this.scheduleUpdateAll);
        this.listener.listen(view.model.events, 'elementEvent', ({ data }) => {
            const elementEvent = data.changePosition || data.changeSize;
            if (!elementEvent) {
                return;
            }
            for (const link of elementEvent.source.links) {
                this.scheduleUpdateLink(link.id);
            }
        });
        this.listener.listen(view.model.events, 'linkEvent', ({ data }) => {
            const linkEvent = (data.changeData ||
                data.changeLayoutOnly ||
                data.changeVertices ||
                data.changeLinkState);
            if (linkEvent) {
                this.scheduleUpdateLink(linkEvent.source.id);
            }
        });
        this.listener.listen(view.model.events, 'linkTypeEvent', ({ data }) => {
            const linkTypeEvent = data.changeLabel || data.changeVisibility;
            if (!linkTypeEvent) {
                return;
            }
            const linkTypeId = linkTypeEvent.source.id;
            for (const link of view.model.linksOfType(linkTypeId)) {
                this.scheduleUpdateLink(link.id);
            }
        });
        this.listener.listen(view.events, 'syncUpdate', ({ layer }) => {
            if (layer !== view_1.RenderingLayer.Link) {
                return;
            }
            this.delayedUpdate.runSynchronously();
        });
    }
    shouldComponentUpdate() {
        return false;
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.delayedUpdate.dispose();
    }
    scheduleUpdateLink(linkId) {
        if (this.updateState === UpdateRequest.Partial) {
            this.scheduledToUpdate[linkId] = true;
        }
        this.delayedUpdate.call(this.performUpdate);
    }
    popShouldUpdatePredicate() {
        const { updateState, scheduledToUpdate } = this;
        this.scheduledToUpdate = collections_1.createStringMap();
        this.updateState = UpdateRequest.Partial;
        return updateState === UpdateRequest.All
            ? () => true
            : link => Boolean(scheduledToUpdate[link.id]);
    }
    render() {
        const { view } = this.props;
        const shouldUpdate = this.popShouldUpdatePredicate();
        return React.createElement("g", { className: CLASS_NAME }, this.getLinks().map(model => (React.createElement(LinkView, { key: model.id, view: view, model: model, shouldUpdate: shouldUpdate(model), route: view.getRouting(model.id) }))));
    }
}
exports.LinkLayer = LinkLayer;
function computeDeepNestedElements(grouping, groupId) {
    const deepChildren = {};
    function collectNestedItems(parentId) {
        deepChildren[parentId] = true;
        const children = grouping.get(parentId);
        if (!children) {
            return;
        }
        for (const element of children) {
            if (element.group !== parentId) {
                continue;
            }
            collectNestedItems(element.id);
        }
    }
    collectNestedItems(groupId);
    return deepChildren;
}
const LINK_CLASS = 'ontodia-link';
const LABEL_GROUPING_PRECISION = 100;
// temporary, cleared-before-render map to hold line numbers for labels
// grouped on the same link offset
const TEMPORARY_LABEL_LINES = new Map();
class LinkView extends react_1.Component {
    constructor(props, context) {
        super(props, context);
        this.onRemoveLinkVertex = (vertex) => {
            const model = this.props.view.model;
            model.history.registerToUndo(commands_1.restoreCapturedLinkGeometry(vertex.link));
            vertex.remove();
        };
        this.onBoundsUpdate = (newBounds) => {
            const { model } = this.props;
            model.setLabelBounds(newBounds);
        };
        this.grabLinkTemplate(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (this.linkType.id !== nextProps.model.typeId) {
            this.grabLinkTemplate(nextProps);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.shouldUpdate;
    }
    grabLinkTemplate(props) {
        this.linkType = props.view.model.getLinkType(props.model.typeId);
        this.template = props.view.createLinkTemplate(this.linkType);
    }
    render() {
        const { view, model, route } = this.props;
        const source = view.model.getElement(model.sourceId);
        const target = view.model.getElement(model.targetId);
        if (!(source && target)) {
            return null;
        }
        const verticesDefinedByUser = model.vertices || [];
        const vertices = route ? route.vertices : verticesDefinedByUser;
        const polyline = geometry_1.computePolyline(source, target, vertices);
        const path = 'M' + polyline.map(({ x, y }) => `${x},${y}`).join(' L');
        const { index: typeIndex, showLabel } = this.linkType;
        const style = this.template.renderLink(model);
        const pathAttributes = getPathAttributes(model, style);
        const isBlurred = view.highlighter && !view.highlighter(model);
        const className = `${LINK_CLASS} ${isBlurred ? `${LINK_CLASS}--blurred` : ''}`;
        return (React.createElement("g", { className: className, "data-link-id": model.id, "data-source-id": source.id, "data-target-id": target.id },
            React.createElement("path", Object.assign({ className: `${LINK_CLASS}__connection`, d: path }, pathAttributes, { markerStart: `url(#${elements_1.linkMarkerKey(typeIndex, true)})`, markerEnd: `url(#${elements_1.linkMarkerKey(typeIndex, false)})` })),
            React.createElement("path", { className: `${LINK_CLASS}__wrap`, d: path }),
            showLabel ? this.renderLabels(polyline, style) : undefined,
            this.renderVertices(verticesDefinedByUser, pathAttributes.stroke)));
    }
    renderVertices(vertices, fill) {
        const elements = [];
        const vertexClass = `${LINK_CLASS}__vertex`;
        const vertexRadius = 10;
        let index = 0;
        for (const { x, y } of vertices) {
            elements.push(React.createElement("circle", { key: index * 2, "data-vertex": index, className: vertexClass, cx: x, cy: y, r: vertexRadius, fill: fill }));
            elements.push(React.createElement(VertexTools, { key: index * 2 + 1, className: `${LINK_CLASS}__vertex-tools`, model: this.props.model, vertexIndex: index, vertexRadius: vertexRadius, x: x, y: y, onRemove: this.onRemoveLinkVertex }));
            index++;
        }
        return React.createElement("g", { className: `${LINK_CLASS}__vertices` }, elements);
    }
    renderLabels(polyline, style) {
        const { view, model, route } = this.props;
        const labels = computeLinkLabels(model, style, view);
        let textAnchor = 'middle';
        if (route && route.labelTextAnchor) {
            textAnchor = route.labelTextAnchor;
        }
        const polylineLength = geometry_1.computePolylineLength(polyline);
        TEMPORARY_LABEL_LINES.clear();
        return (React.createElement("g", { className: `${LINK_CLASS}__labels` }, labels.map((label, index) => {
            const { x, y } = geometry_1.getPointAlongPolyline(polyline, polylineLength * label.offset);
            const groupKey = Math.round(label.offset * LABEL_GROUPING_PRECISION) / LABEL_GROUPING_PRECISION;
            const line = TEMPORARY_LABEL_LINES.get(groupKey) || 0;
            TEMPORARY_LABEL_LINES.set(groupKey, line + 1);
            return (React.createElement(LinkLabel, { key: index, x: x, y: y, line: line, label: label, textAnchor: textAnchor, onBoundsUpdate: index === 0 ? this.onBoundsUpdate : undefined }));
        })));
    }
}
function computeLinkLabels(model, style, view) {
    const labels = [];
    const labelStyle = style.label || {};
    const labelTexts = labelStyle.attrs && labelStyle.attrs.text ? labelStyle.attrs.text.text : undefined;
    let text;
    if (labelTexts && labelTexts.length > 0) {
        text = view.selectLabel(labelTexts);
    }
    else {
        const type = view.model.getLinkType(model.typeId);
        text = view.selectLabel(type.label) || {
            text: view.formatLabel(type.label, type.id),
            lang: '',
        };
    }
    labels.push({
        offset: labelStyle.position || 0.5,
        text,
        attributes: {
            text: getLabelTextAttributes(labelStyle),
            rect: getLabelRectAttributes(labelStyle),
        },
    });
    if (style.properties) {
        for (const property of style.properties) {
            if (!(property.attrs && property.attrs.text && property.attrs.text.text)) {
                continue;
            }
            labels.push({
                offset: property.position || 0.5,
                text: view.selectLabel(property.attrs.text.text),
                attributes: {
                    text: getLabelTextAttributes(property),
                    rect: getLabelRectAttributes(property),
                },
            });
        }
    }
    return labels;
}
function getPathAttributes(model, style) {
    const connectionAttributes = style.connection || {};
    const defaultStrokeDasharray = model.layoutOnly ? '5,5' : undefined;
    const { fill = 'none', stroke = 'black', 'stroke-width': strokeWidth, 'stroke-dasharray': strokeDasharray = defaultStrokeDasharray, } = connectionAttributes;
    return { fill, stroke, strokeWidth, strokeDasharray };
}
function getLabelTextAttributes(label) {
    const { fill = 'black', stroke = 'none', 'stroke-width': strokeWidth = 0, 'font-family': fontFamily = '"Helvetica Neue", "Helvetica", "Arial", sans-serif', 'font-size': fontSize = 'inherit', 'font-weight': fontWeight = 'bold', } = label.attrs ? label.attrs.text : {};
    return {
        fill, stroke, strokeWidth, fontFamily, fontSize,
        fontWeight: fontWeight,
    };
}
function getLabelRectAttributes(label) {
    const { fill = 'white', stroke = 'none', 'stroke-width': strokeWidth = 0, } = label.attrs && label.attrs.rect ? label.attrs.rect : {};
    return { fill, stroke, strokeWidth };
}
const GROUPED_LABEL_MARGIN = 2;
class LinkLabel extends react_1.Component {
    constructor(props) {
        super(props);
        this.shouldUpdateBounds = true;
        this.onTextMount = (text) => {
            this.text = text;
        };
        this.state = { width: 0, height: 0 };
    }
    render() {
        const { x, y, label, line, textAnchor } = this.props;
        const { width, height } = this.state;
        const { x: rectX, y: rectY } = this.getLabelRectangle(width, height);
        const transform = line === 0 ? undefined :
            `translate(0, ${line * (height + GROUPED_LABEL_MARGIN)}px)`;
        // HACK: 'alignment-baseline' and 'dominant-baseline' are not supported in Edge and IE
        const dy = '0.6ex';
        return (React.createElement("g", { style: transform ? { transform } : undefined },
            React.createElement("rect", { x: rectX, y: rectY, width: width, height: height, style: label.attributes.rect }),
            React.createElement("text", { ref: this.onTextMount, x: x, y: y, dy: dy, textAnchor: textAnchor, style: label.attributes.text }, label.text.text)));
    }
    getLabelRectangle(width, height) {
        const { x, y, textAnchor } = this.props;
        let xOffset = 0;
        if (textAnchor === 'middle') {
            xOffset = -width / 2;
        }
        else if (textAnchor === 'end') {
            xOffset = -width;
        }
        return {
            x: x + xOffset,
            y: y - height / 2,
            width,
            height,
        };
    }
    componentDidMount() {
        this.recomputeBounds(this.props);
    }
    componentWillUnmount() {
        const { onBoundsUpdate } = this.props;
        onBoundsUpdate(undefined);
    }
    componentWillReceiveProps(nextProps) {
        this.shouldUpdateBounds = true;
    }
    componentDidUpdate(props) {
        this.recomputeBounds(this.props);
    }
    recomputeBounds(props) {
        if (this.shouldUpdateBounds) {
            const { onBoundsUpdate } = this.props;
            this.shouldUpdateBounds = false;
            const bounds = this.text.getBBox();
            if (onBoundsUpdate) {
                const labelBounds = this.getLabelRectangle(bounds.width, bounds.height);
                onBoundsUpdate(labelBounds);
            }
            this.setState({
                width: bounds.width,
                height: bounds.height,
            });
        }
    }
}
class VertexTools extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onRemoveVertex = (e) => {
            if (e.button !== 0 /* left button */) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const { onRemove, model, vertexIndex } = this.props;
            onRemove(new elements_1.LinkVertex(model, vertexIndex));
        };
    }
    render() {
        const { className, vertexIndex, vertexRadius, x, y } = this.props;
        const transform = `translate(${x + 2 * vertexRadius},${y - 2 * vertexRadius})scale(${vertexRadius})`;
        return (React.createElement("g", { className: className, transform: transform, onMouseDown: this.onRemoveVertex },
            React.createElement("title", null, "Remove vertex"),
            React.createElement("circle", { r: 1 }),
            React.createElement("path", { d: 'M-0.5,-0.5 L0.5,0.5 M0.5,-0.5 L-0.5,0.5', strokeWidth: 2 / vertexRadius })));
    }
}
class LinkMarkers extends react_1.Component {
    constructor() {
        super(...arguments);
        this.listener = new events_1.EventObserver();
        this.delayedUpdate = new async_1.Debouncer();
    }
    render() {
        const { view } = this.props;
        const markers = [];
        view.getLinkTemplates().forEach((template, linkTypeId) => {
            const type = view.model.getLinkType(linkTypeId);
            if (!type) {
                return;
            }
            const typeIndex = type.index;
            if (template.markerSource) {
                markers.push(React.createElement(LinkMarker, { key: typeIndex * 2, linkTypeIndex: typeIndex, style: template.markerSource, isStartMarker: true }));
            }
            if (template.markerTarget) {
                markers.push(React.createElement(LinkMarker, { key: typeIndex * 2 + 1, linkTypeIndex: typeIndex, style: template.markerTarget, isStartMarker: false }));
            }
        });
        return React.createElement("defs", null, markers);
    }
    componentDidMount() {
        const { view } = this.props;
        this.listener.listen(view.events, 'syncUpdate', ({ layer }) => {
            if (layer !== view_1.RenderingLayer.Link) {
                return;
            }
            this.delayedUpdate.runSynchronously();
        });
        this.listener.listen(view.events, 'changeLinkTemplates', () => {
            this.delayedUpdate.call(() => this.forceUpdate());
        });
    }
    shouldComponentUpdate() {
        return false;
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.delayedUpdate.dispose();
    }
}
exports.LinkMarkers = LinkMarkers;
const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
class LinkMarker extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onMarkerMount = (marker) => {
            if (!marker) {
                return;
            }
            const { linkTypeIndex, isStartMarker, style } = this.props;
            marker.setAttribute('id', elements_1.linkMarkerKey(linkTypeIndex, isStartMarker));
            marker.setAttribute('markerWidth', style.width.toString());
            marker.setAttribute('markerHeight', style.height.toString());
            marker.setAttribute('orient', 'auto');
            const xOffset = isStartMarker ? 0 : (style.width - 1);
            marker.setAttribute('refX', xOffset.toString());
            marker.setAttribute('refY', (style.height / 2).toString());
            marker.setAttribute('markerUnits', 'userSpaceOnUse');
            const path = document.createElementNS(SVG_NAMESPACE, 'path');
            path.setAttribute('d', style.d);
            if (style.fill !== undefined) {
                path.setAttribute('fill', style.fill);
            }
            if (style.stroke !== undefined) {
                path.setAttribute('stroke', style.stroke);
            }
            if (style.strokeWidth !== undefined) {
                path.setAttribute('stroke-width', style.strokeWidth);
            }
            marker.appendChild(path);
        };
    }
    render() {
        return React.createElement("marker", { ref: this.onMarkerMount });
    }
    shouldComponentUpdate() {
        return false;
    }
}


/***/ }),
/* 83 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getContentFittingBox = exports.PaperArea = exports.PaperAreaContextTypes = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const polyfills_1 = __webpack_require__(42);
const react_1 = __webpack_require__(62);
const toSvg_1 = __webpack_require__(84);
const commands_1 = __webpack_require__(64);
const elements_1 = __webpack_require__(53);
const geometry_1 = __webpack_require__(57);
const view_1 = __webpack_require__(66);
const paper_1 = __webpack_require__(52);
exports.PaperAreaContextTypes = {
    ontodiaPaperArea: react_1.PropTypes.anything,
};
const CLASS_NAME = 'ontodia-paper-area';
const DEFAULT_ANIMATION_DURATION = 500;
const LEFT_MOUSE_BUTTON = 0;
class PaperArea extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.listener = new events_1.EventObserver();
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.widgets = {};
        this.pageSize = { x: 1500, y: 800 };
        this.cssAnimations = 0;
        this.delayedPaperAdjust = new async_1.Debouncer();
        this.onOuterMount = (outer) => { this.outer = outer; };
        this.onAreaMount = (area) => { this.area = area; };
        this.onWidgetsMouseDown = (e) => {
            // prevent PaperArea from generating click on a blank area
            e.stopPropagation();
        };
        this.adjustPaper = (callback) => {
            const { clientWidth, clientHeight } = this.area;
            const adjusted = Object.assign(Object.assign({}, this.computeAdjustedBox()), { paddingX: Math.ceil(clientWidth), paddingY: Math.ceil(clientHeight) });
            const previous = this.state;
            const samePaperProps = (adjusted.paperWidth === previous.paperWidth &&
                adjusted.paperHeight === previous.paperHeight &&
                adjusted.originX === previous.originX &&
                adjusted.originY === previous.originY &&
                adjusted.paddingX === previous.paddingX &&
                adjusted.paddingY === previous.paddingY);
            if (!samePaperProps) {
                this.scrollBeforeUpdate = {
                    left: this.area.scrollLeft,
                    top: this.area.scrollTop,
                };
                this.setState(adjusted, callback);
            }
            else if (callback) {
                callback();
            }
        };
        this.onPaperPointerDown = (e, cell) => {
            if (this.movingState) {
                return;
            }
            const restore = commands_1.RestoreGeometry.capture(this.props.view.model);
            const batch = this.props.view.model.history.startBatch(restore.title);
            if (cell && e.button === LEFT_MOUSE_BUTTON) {
                if (cell instanceof elements_1.Element) {
                    e.preventDefault();
                    this.startMoving(e, cell);
                    this.listenToPointerMove(e, cell, batch, restore);
                }
                else {
                    e.preventDefault();
                    this.listenToPointerMove(e, cell, batch, restore);
                }
            }
            else {
                e.preventDefault();
                this.listenToPointerMove(e, undefined, batch, restore);
            }
        };
        this.onAreaPointerDown = (e) => {
            if (e.target === this.area) {
                this.onPaperPointerDown(e, undefined);
            }
        };
        this.onPointerMove = (e) => {
            if (!this.movingState || this.scrollBeforeUpdate) {
                return;
            }
            const { origin, target, panning } = this.movingState;
            const pageOffsetX = e.pageX - origin.pageX;
            const pageOffsetY = e.pageY - origin.pageY;
            if (Math.abs(pageOffsetX) >= 1 && Math.abs(pageOffsetY) >= 1) {
                this.movingState.pointerMoved = true;
            }
            if (typeof target === 'undefined') {
                if (panning) {
                    this.area.scrollLeft = this.panningScrollOrigin.scrollLeft - pageOffsetX;
                    this.area.scrollTop = this.panningScrollOrigin.scrollTop - pageOffsetY;
                }
                this.source.trigger('pointerMove', { source: this, sourceEvent: e, target, panning });
            }
            else if (target instanceof elements_1.Element) {
                const { x, y } = this.pageToPaperCoords(e.pageX, e.pageY);
                const { pointerX, pointerY, elementX, elementY } = this.movingElementOrigin;
                target.setPosition({
                    x: elementX + x - pointerX,
                    y: elementY + y - pointerY,
                });
                this.source.trigger('pointerMove', { source: this, sourceEvent: e, target, panning });
                this.props.view.performSyncUpdate();
            }
            else if (target instanceof elements_1.Link) {
                const location = this.pageToPaperCoords(e.pageX, e.pageY);
                const linkVertex = this.generateLinkVertex(target, location);
                linkVertex.createAt(location);
                this.movingState.target = linkVertex;
            }
            else if (target instanceof elements_1.LinkVertex) {
                const location = this.pageToPaperCoords(e.pageX, e.pageY);
                target.moveTo(location);
                this.source.trigger('pointerMove', { source: this, sourceEvent: e, target, panning });
                this.props.view.performSyncUpdate();
            }
        };
        this.stopListeningToPointerMove = (e) => {
            const movingState = this.movingState;
            this.movingState = undefined;
            if (movingState) {
                document.removeEventListener('mousemove', this.onPointerMove);
                document.removeEventListener('mouseup', this.stopListeningToPointerMove);
            }
            if (e && movingState) {
                const { pointerMoved, target, batch, restoreGeometry } = movingState;
                this.source.trigger('pointerUp', {
                    source: this,
                    sourceEvent: e,
                    target,
                    panning: movingState.panning,
                    triggerAsClick: !pointerMoved,
                });
                const restore = restoreGeometry.filterOutUnchanged();
                if (restore.hasChanges()) {
                    batch.history.registerToUndo(restore);
                }
                batch.store();
            }
        };
        this.onWheel = (e) => {
            if (this.shouldStartZooming(e)) {
                e.preventDefault();
                const delta = Math.max(-1, Math.min(1, e.deltaY || e.deltaX));
                const pivot = this.pageToPaperCoords(e.pageX, e.pageY);
                this.zoomBy(-delta * 0.1, { pivot });
            }
        };
        this.onDragOver = (e) => {
            // Necessary. Allows us to drop.
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.dataTransfer.dropEffect = 'move';
            const { x, y } = clientCoordsFor(this.area, e);
            return false;
        };
        this.onDragDrop = (e) => {
            if (this.props.onDragDrop) {
                const { x, y } = clientCoordsFor(this.area, e);
                const paperPosition = this.clientToPaperCoords(x, y);
                this.props.onDragDrop(e, paperPosition);
            }
        };
        this.onScroll = () => {
            this.source.trigger('scroll', { source: this });
        };
        this.applyViewportState = (targetState) => {
            const scale = targetState.scale.x;
            const paperCenter = targetState.center;
            this.setState({ scale }, () => {
                const { originX, originY, paddingX, paddingY } = this.state;
                const scrollCenterX = (paperCenter.x + originX) * scale;
                const scrollCenterY = (paperCenter.y + originY) * scale;
                const { clientWidth, clientHeight } = this.area;
                this.area.scrollLeft = scrollCenterX - clientWidth / 2 + paddingX;
                this.area.scrollTop = scrollCenterY - clientHeight / 2 + paddingY;
                if (this.props.onZoom) {
                    this.props.onZoom(scale, scale);
                }
            });
        };
        this.state = {
            paperWidth: this.pageSize.x,
            paperHeight: this.pageSize.y,
            originX: 0,
            originY: 0,
            scale: 1,
            paddingX: 0,
            paddingY: 0,
            renderedWidgets: [],
        };
    }
    get zoomOptions() {
        const { min = 0.2, max = 2, step = 0.1, maxFit = 1, fitPadding = 20, requireCtrl = true, } = this.props.zoomOptions || {};
        return { min, max, step, maxFit, fitPadding, requireCtrl };
    }
    getChildContext() {
        const { view } = this.props;
        const ontodiaPaperArea = { paperArea: this, view };
        return { ontodiaPaperArea };
    }
    render() {
        const { view, watermarkSvg, watermarkUrl } = this.props;
        const { paperWidth, paperHeight, originX, originY, scale, paddingX, paddingY, renderedWidgets } = this.state;
        const paperTransform = {
            width: paperWidth, height: paperHeight,
            originX, originY, scale, paddingX, paddingY,
        };
        const widgetProps = { paperArea: this, paperTransform };
        let areaClass = `${CLASS_NAME}__area`;
        if (this.props.hideScrollBars) {
            areaClass += ` ${CLASS_NAME}--hide-scrollbars`;
        }
        let componentClass = CLASS_NAME;
        if (this.isAnimatingGraph()) {
            componentClass += ` ${CLASS_NAME}--animated`;
        }
        return (React.createElement("div", { className: componentClass, ref: this.onOuterMount },
            React.createElement("div", { className: areaClass, ref: this.onAreaMount, onMouseDown: this.onAreaPointerDown },
                React.createElement(paper_1.Paper, { view: view, paperTransform: paperTransform, onPointerDown: this.onPaperPointerDown, linkLayerWidgets: React.createElement("div", { className: `${CLASS_NAME}__widgets`, onMouseDown: this.onWidgetsMouseDown }, renderedWidgets.filter(w => w.attachment === view_1.WidgetAttachment.OverLinks).map(widget => React.cloneElement(widget.element, widgetProps))), elementLayerWidgets: React.createElement("div", { className: `${CLASS_NAME}__widgets`, onMouseDown: this.onWidgetsMouseDown }, renderedWidgets.filter(w => w.attachment === view_1.WidgetAttachment.OverElements).map(widget => React.cloneElement(widget.element, widgetProps))) }),
                watermarkSvg ? (React.createElement("a", { href: watermarkUrl, target: '_blank', rel: 'noopener' },
                    React.createElement("img", { className: `${CLASS_NAME}__watermark`, src: watermarkSvg, draggable: false }))) : null),
            renderedWidgets.filter(w => w.attachment === view_1.WidgetAttachment.Viewport).map(widget => {
                return React.cloneElement(widget.element, widgetProps);
            })));
    }
    componentDidMount() {
        this.adjustPaper(() => this.centerTo());
        const { view } = this.props;
        const delayedAdjust = () => this.delayedPaperAdjust.call(this.adjustPaper);
        this.listener.listen(view.model.events, 'changeCells', delayedAdjust);
        this.listener.listen(view.model.events, 'elementEvent', ({ data }) => {
            if (data.changePosition || data.changeSize) {
                delayedAdjust();
            }
        });
        this.listener.listen(view.model.events, 'linkEvent', ({ data }) => {
            if (data.changeVertices) {
                delayedAdjust();
            }
        });
        this.listener.listen(view.events, 'syncUpdate', ({ layer }) => {
            if (layer !== view_1.RenderingLayer.PaperArea) {
                return;
            }
            this.delayedPaperAdjust.runSynchronously();
        });
        this.listener.listen(view.events, 'updateWidgets', ({ widgets }) => {
            this.updateWidgets(widgets);
        });
        this.area.addEventListener('dragover', this.onDragOver);
        this.area.addEventListener('drop', this.onDragDrop);
        this.area.addEventListener('scroll', this.onScroll);
        this.area.addEventListener('wheel', this.onWheel, polyfills_1.isIE11() ? false : { passive: false });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.scrollBeforeUpdate) {
            const { scale, originX, originY, paddingX, paddingY } = this.state;
            const scrollX = (originX - prevState.originX) * scale + (paddingX - prevState.paddingX);
            const scrollY = (originY - prevState.originY) * scale + (paddingY - prevState.paddingY);
            const scrollLeft = this.scrollBeforeUpdate.left + scrollX;
            const scrollTop = this.scrollBeforeUpdate.top + scrollY;
            this.area.scrollLeft = scrollLeft;
            this.area.scrollTop = scrollTop;
            this.scrollBeforeUpdate = undefined;
        }
    }
    componentWillUnmount() {
        this.stopListeningToPointerMove();
        this.listener.stopListening();
        this.area.removeEventListener('dragover', this.onDragOver);
        this.area.removeEventListener('drop', this.onDragDrop);
        this.area.removeEventListener('scroll', this.onScroll);
        this.area.removeEventListener('wheel', this.onWheel);
    }
    updateWidgets(update) {
        this.widgets = Object.assign(Object.assign({}, this.widgets), update);
        const renderedWidgets = Object.keys(this.widgets)
            .filter(key => this.widgets[key])
            .map(key => {
            const widget = this.widgets[key];
            const element = React.cloneElement(widget.element, { key });
            return Object.assign(Object.assign({}, widget), { element });
        });
        this.setState({ renderedWidgets });
    }
    pageToPaperCoords(pageX, pageY) {
        const { left, top } = this.area.getBoundingClientRect();
        return this.clientToPaperCoords(pageX - (left + window.pageXOffset), pageY - (top + window.pageYOffset));
    }
    clientToPaperCoords(areaClientX, areaClientY) {
        const { x: paneX, y: paneY } = this.clientToScrollablePaneCoords(areaClientX, areaClientY);
        return this.scrollablePaneToPaperCoords(paneX, paneY);
    }
    clientToScrollablePaneCoords(areaClientX, areaClientY) {
        const { paddingX, paddingY } = this.state;
        const paneX = areaClientX + this.area.scrollLeft - paddingX;
        const paneY = areaClientY + this.area.scrollTop - paddingY;
        return { x: paneX, y: paneY };
    }
    scrollablePaneToPaperCoords(paneX, paneY) {
        const { scale, paddingX, paddingY, originX, originY } = this.state;
        const paperX = paneX / scale - originX;
        const paperY = paneY / scale - originY;
        return { x: paperX, y: paperY };
    }
    paperToScrollablePaneCoords(paperX, paperY) {
        const { scale, paddingX, paddingY, originX, originY } = this.state;
        const paneX = (paperX + originX) * scale;
        const paneY = (paperY + originY) * scale;
        return { x: paneX, y: paneY };
    }
    /** Returns bounding box of paper content in paper coordinates. */
    getContentFittingBox() {
        const { elements, links } = this.props.view.model;
        return getContentFittingBox(elements, links);
    }
    /** Returns paper size in paper coordinates. */
    getPaperSize() {
        const { paperWidth: width, paperHeight: height, scale } = this.state;
        return { width: width / scale, height: height / scale };
    }
    getAreaMetrics() {
        const { clientWidth, clientHeight, offsetWidth, offsetHeight } = this.area;
        return { clientWidth, clientHeight, offsetWidth, offsetHeight };
    }
    computeAdjustedBox() {
        // bbox in paper coordinates
        const bbox = this.getContentFittingBox();
        const bboxLeft = bbox.x;
        const bboxTop = bbox.y;
        const bboxRight = bbox.x + bbox.width;
        const bboxBottom = bbox.y + bbox.height;
        const { x: gridWidth, y: gridHeight } = this.pageSize;
        // bbox in integer grid coordinates (open-closed intervals)
        const bboxGrid = {
            left: Math.floor(bboxLeft / gridWidth),
            top: Math.floor(bboxTop / gridHeight),
            right: Math.ceil(bboxRight / gridWidth),
            bottom: Math.ceil(bboxBottom / gridHeight),
        };
        // const oldOrigin = this.paper.options.origin;
        const originX = -bboxGrid.left * gridWidth;
        const originY = -bboxGrid.top * gridHeight;
        const paperWidth = Math.max(bboxGrid.right - bboxGrid.left, 1) * gridWidth;
        const paperHeight = Math.max(bboxGrid.bottom - bboxGrid.top, 1) * gridHeight;
        return { paperWidth, paperHeight, originX, originY };
    }
    shouldStartZooming(e) {
        return Boolean(e.ctrlKey) && Boolean(this.zoomOptions.requireCtrl) || !this.zoomOptions.requireCtrl;
    }
    shouldStartPanning(e) {
        const modifierPressed = e.ctrlKey || e.shiftKey || e.altKey;
        return e.button === LEFT_MOUSE_BUTTON && !modifierPressed;
    }
    startMoving(e, element) {
        const { x: pointerX, y: pointerY } = this.pageToPaperCoords(e.pageX, e.pageY);
        const { x: elementX, y: elementY } = element.position;
        this.movingElementOrigin = { pointerX, pointerY, elementX, elementY };
    }
    startPanning(event) {
        const { scrollLeft, scrollTop } = this.area;
        this.panningScrollOrigin = { scrollLeft, scrollTop };
        this.clearTextSelectionInArea();
    }
    /** Clears accidental text selection in the diagram area. */
    clearTextSelectionInArea() {
        if (document.getSelection) {
            const selection = document.getSelection();
            if (selection.removeAllRanges) {
                selection.removeAllRanges();
            }
        }
    }
    generateLinkVertex(link, location) {
        const previous = link.vertices;
        const vertices = previous ? [...previous] : [];
        const model = this.props.view.model;
        const polyline = geometry_1.computePolyline(model.getElement(link.sourceId), model.getElement(link.targetId), vertices);
        const segmentIndex = geometry_1.findNearestSegmentIndex(polyline, location);
        return new elements_1.LinkVertex(link, segmentIndex);
    }
    listenToPointerMove(event, cell, batch, restoreGeometry) {
        if (this.movingState) {
            return;
        }
        const panning = cell === undefined && this.shouldStartPanning(event);
        if (panning) {
            this.startPanning(event);
        }
        const { pageX, pageY } = event;
        this.movingState = {
            origin: { pageX, pageY },
            target: cell,
            panning,
            pointerMoved: false,
            batch,
            restoreGeometry,
        };
        document.addEventListener('mousemove', this.onPointerMove);
        document.addEventListener('mouseup', this.stopListeningToPointerMove);
        this.source.trigger('pointerDown', {
            source: this, sourceEvent: event, target: cell, panning,
        });
    }
    centerTo(paperPosition, options = {}) {
        const { paperWidth, paperHeight } = this.state;
        const paperCenter = paperPosition || { x: paperWidth / 2, y: paperHeight / 2 };
        const viewportState = {
            center: paperCenter,
        };
        return this.setViewportState(viewportState, options);
    }
    centerContent(options = {}) {
        const bbox = this.getContentFittingBox();
        return this.centerTo({
            x: bbox.x + bbox.width / 2,
            y: bbox.y + bbox.height / 2,
        }, options);
    }
    getScale() {
        return this.state.scale;
    }
    setScale(value, options) {
        let scale = value;
        const { min, max } = this.zoomOptions;
        scale = Math.max(scale, min);
        scale = Math.min(scale, max);
        let viewportState;
        if (options && options.pivot) {
            const { x, y } = options.pivot;
            const paperCenter = this.clientToPaperCoords(this.area.clientWidth / 2, this.area.clientHeight / 2);
            const previousScale = this.state.scale;
            const scaledBy = scale / previousScale;
            viewportState = {
                center: {
                    x: x - (x - paperCenter.x) / scaledBy,
                    y: y - (y - paperCenter.y) / scaledBy,
                },
                scale: { x: scale, y: scale },
            };
        }
        else {
            viewportState = {
                scale: { x: scale, y: scale },
            };
        }
        return this.setViewportState(viewportState, options);
    }
    zoomBy(value, options) {
        return this.setScale(this.getScale() + value, options);
    }
    zoomIn(scaleOptions) {
        return this.zoomBy(this.zoomOptions.step, scaleOptions);
    }
    zoomOut(scaleOptions) {
        return this.zoomBy(-this.zoomOptions.step, scaleOptions);
    }
    zoomToFit(options = {}) {
        if (options.elements && options.elements.size === 0) {
            return;
        }
        if (this.props.view.model.elements.length === 0) {
            return this.centerTo();
        }
        let bbox;
        let elements;
        if (options.elements) {
            const selectionElements = [];
            options.elements.forEach(el => selectionElements.push(el));
            elements = selectionElements;
        }
        else {
            elements = this.props.view.model.elements;
        }
        bbox = getContentFittingBox(elements, []);
        return this.zoomToFitRect(bbox, options);
    }
    zoomToFitRect(bbox, options = {}) {
        const { clientWidth, clientHeight } = this.area;
        if (bbox.width === 0) {
            return;
        }
        const { width } = toSvg_1.fitRectKeepingAspectRatio(bbox.width, bbox.height, clientWidth, clientHeight);
        let scale = width / bbox.width;
        const { min, maxFit } = this.zoomOptions;
        scale = Math.max(scale, min);
        scale = Math.min(scale, maxFit);
        const center = {
            x: bbox.x + bbox.width / 2,
            y: bbox.y + bbox.height / 2,
        };
        const viewPortState = {
            center,
            scale: { x: scale, y: scale },
        };
        return this.setViewportState(viewPortState, options);
    }
    makeToSVGOptions() {
        const svg = this.area.querySelector('.ontodia-paper__canvas');
        if (!svg) {
            throw new Error('Cannot find SVG canvas to export');
        }
        return {
            model: this.props.view.model,
            paper: svg,
            contentBox: this.getContentFittingBox(),
            getOverlayedElement: id => this.area.querySelector(`[data-element-id='${id}']`),
            preserveDimensions: true,
            convertImagesToDataUris: true,
            elementsToRemoveSelector: '.ontodia-link__vertex-tools',
            watermarkSvg: this.props.watermarkSvg,
        };
    }
    exportSVG() {
        return toSvg_1.toSVG(this.makeToSVGOptions());
    }
    exportPNG(options) {
        return toSvg_1.toDataURL(Object.assign(Object.assign({}, options), this.makeToSVGOptions()));
    }
    isAnimatingGraph() {
        return this.cssAnimations > 0;
    }
    /**
     * Starts animation for graph elements and links.
     *
     * @param setupChanges immediately called function to perform animatable changes on graph
     * @param duration animation duration in milliseconds (requires custom CSS to override)
     * @returns promise which resolves when this animation ends
     */
    animateGraph(setupChanges, duration) {
        this.changeGraphAnimationCount(+1);
        setupChanges();
        const timeout = typeof duration === 'number' ? duration : DEFAULT_ANIMATION_DURATION;
        return async_1.delay(timeout).then(() => this.onGraphAnimationEnd());
    }
    onGraphAnimationEnd() {
        this.changeGraphAnimationCount(-1);
    }
    changeGraphAnimationCount(change) {
        const newValue = this.cssAnimations + change;
        if (newValue < 0) {
            return;
        }
        const previous = this.isAnimatingGraph();
        this.cssAnimations = newValue;
        const current = this.isAnimatingGraph();
        if (previous !== current) {
            this.forceUpdate();
            this.source.trigger('changeAnimatingGraph', { source: this, previous });
        }
    }
    get viewportState() {
        const { clientWidth, clientHeight } = this.area;
        const { originX, originY, paddingX, paddingY, scale } = this.state;
        const scrollCenterX = this.area.scrollLeft + clientWidth / 2 - paddingX;
        const scrollCenterY = this.area.scrollTop + clientHeight / 2 - paddingY;
        const paperCenter = {
            x: scrollCenterX / scale - originX,
            y: scrollCenterY / scale - originY,
        };
        return {
            center: paperCenter,
            scale: {
                x: scale,
                y: scale,
            }
        };
    }
    setViewportState(state, options) {
        if (this.viewportAnimation) {
            this.viewportAnimation.cancellation.abort();
        }
        const from = this.viewportState;
        const to = Object.assign(Object.assign({}, from), state);
        const animate = options && (options.animate || options.duration > 0);
        if (animate) {
            const viewportAnimation = {
                from, to, cancellation: new async_1.Cancellation(),
            };
            const durationMs = typeof options.duration === 'number'
                ? options.duration : DEFAULT_ANIMATION_DURATION;
            const awaitPromise = async_1.animateInterval(durationMs, progress => {
                const t = async_1.easeInOutBezier(progress);
                const computed = {
                    center: {
                        x: from.center.x + (to.center.x - from.center.x) * t,
                        y: from.center.y + (to.center.y - from.center.y) * t,
                    },
                    scale: {
                        x: from.scale.x + (to.scale.x - from.scale.x) * t,
                        y: from.scale.y + (to.scale.y - from.scale.y) * t,
                    },
                };
                this.applyViewportState(computed);
            }, viewportAnimation.cancellation);
            this.viewportAnimation = viewportAnimation;
            return awaitPromise.then(() => {
                this.viewportAnimation = undefined;
            });
        }
        else {
            this.applyViewportState(to);
            return Promise.resolve();
        }
    }
}
exports.PaperArea = PaperArea;
PaperArea.childContextTypes = exports.PaperAreaContextTypes;
function clientCoordsFor(container, e) {
    const target = (e.target instanceof SVGElement && e.target.ownerSVGElement !== null)
        ? e.target.ownerSVGElement : e.target;
    const targetBox = target.getBoundingClientRect();
    const containerBox = container.getBoundingClientRect();
    return {
        x: e.offsetX + (targetBox.left - containerBox.left),
        y: e.offsetY + (targetBox.top - containerBox.top),
    };
}
function getContentFittingBox(elements, links) {
    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;
    for (const element of elements) {
        const { x, y } = element.position;
        const size = element.size;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x + size.width);
        maxY = Math.max(maxY, y + size.height);
    }
    for (const link of links) {
        const vertices = link.vertices || [];
        for (const { x, y } of vertices) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
        }
    }
    return {
        x: Number.isFinite(minX) ? minX : 0,
        y: Number.isFinite(minY) ? minY : 0,
        width: Number.isFinite(minX) && Number.isFinite(maxX) ? (maxX - minX) : 0,
        height: Number.isFinite(minY) && Number.isFinite(maxY) ? (maxY - minY) : 0,
    };
}
exports.getContentFittingBox = getContentFittingBox;


/***/ }),
/* 84 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.dataURLToBlob = exports.fitRectKeepingAspectRatio = exports.loadImage = exports.toDataURL = exports.toSVG = void 0;
const tslib_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(67);
const geometry_1 = __webpack_require__(57);
const polyfills_1 = __webpack_require__(42);
const htmlToSvg_1 = __webpack_require__(85);
const canvg = __webpack_require__(41);
const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
/**
 * Padding (in px) for <foreignObject> elements of exported SVG to
 * mitigate issues with elements body overflow caused by missing styles
 * in exported image.
 */
const FOREIGN_OBJECT_SIZE_PADDING = 2;
const BORDER_PADDING = 100;
function toSVG(options) {
    return exportSVG(options).then(svg => new XMLSerializer().serializeToString(svg));
}
exports.toSVG = toSVG;
function exportSVG(options) {
    const { contentBox: bbox, watermarkSvg } = options;
    const { svgClone, imageBounds } = clonePaperSvg(options, FOREIGN_OBJECT_SIZE_PADDING);
    if (polyfills_1.isIE11()) {
        clearAttributes(svgClone);
    }
    const paddedWidth = bbox.width + 2 * BORDER_PADDING;
    const paddedHeight = bbox.height + 2 * BORDER_PADDING;
    if (options.preserveDimensions) {
        svgClone.setAttribute('width', paddedWidth.toString());
        svgClone.setAttribute('height', paddedHeight.toString());
    }
    else {
        svgClone.setAttribute('width', '100%');
        svgClone.setAttribute('height', '100%');
    }
    const viewBox = {
        x: bbox.x - BORDER_PADDING,
        y: bbox.y - BORDER_PADDING,
        width: paddedWidth,
        height: paddedHeight,
    };
    svgClone.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`);
    addWatermark(svgClone, viewBox, watermarkSvg);
    const images = [];
    if (!polyfills_1.isIE11()) {
        const nodes = svgClone.querySelectorAll('img');
        foreachNode(nodes, node => images.push(node));
    }
    const convertingImages = Promise.all(images.map(img => {
        const exportKey = img.getAttribute('export-key');
        img.removeAttribute('export-key');
        if (exportKey) {
            const { width, height } = imageBounds[exportKey];
            img.setAttribute('width', width.toString());
            img.setAttribute('height', height.toString());
            if (!options.convertImagesToDataUris) {
                return Promise.resolve();
            }
            return exportAsDataUri(img).then(dataUri => {
                // check for empty svg data URI which happens when mockJointXHR catches an exception
                if (dataUri && dataUri !== 'data:image/svg+xml,') {
                    img.src = dataUri;
                }
            }).catch(err => {
                // tslint:disable-next-line:no-console
                console.warn('Failed to export image: ' + img.src, err);
            });
        }
        else {
            return Promise.resolve();
        }
    }));
    return convertingImages.then(() => {
        // workaround to include only ontodia-related stylesheets
        const exportedCssText = extractCSSFromDocument(svgClone);
        const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        defs.innerHTML = `<style>${exportedCssText}</style>`;
        svgClone.insertBefore(defs, svgClone.firstChild);
        if (options.elementsToRemoveSelector) {
            foreachNode(svgClone.querySelectorAll(options.elementsToRemoveSelector), node => node.remove());
        }
        return svgClone;
    });
}
function addWatermark(svg, viewBox, watermarkSvg) {
    const WATERMARK_CLASS = 'ontodia-exported-watermark';
    const WATERMARK_MAX_WIDTH = 120;
    const WATERMARK_PADDING = 20;
    const image = document.createElementNS(SVG_NAMESPACE, 'image');
    image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', watermarkSvg);
    image.setAttribute('class', WATERMARK_CLASS);
    const width = Math.min(viewBox.width * 0.2, WATERMARK_MAX_WIDTH);
    const x = viewBox.x + viewBox.width - width - WATERMARK_PADDING;
    const y = viewBox.y + WATERMARK_PADDING;
    image.setAttribute('x', x.toString());
    image.setAttribute('y', y.toString());
    image.setAttribute('width', width.toString());
    image.setAttribute('opacity', '0.3');
    svg.insertBefore(image, svg.firstChild);
}
function clearAttributes(svg) {
    const availableIds = {};
    const prohibitedIds = {};
    const defss = svg.querySelectorAll('defs');
    foreachNode(defss, defs => {
        foreachNode(defs.childNodes, def => {
            const id = def.getAttribute('id');
            if (id) {
                availableIds[id] = true;
                if (polyfills_1.isIE11() && def instanceof SVGFilterElement) {
                    availableIds[id] = false;
                }
            }
        });
    });
    const paths = svg.querySelectorAll('*');
    foreachNode(paths, path => {
        const markerStart = extractId(path.getAttribute('marker-start'));
        if (markerStart && !availableIds[markerStart]) {
            path.removeAttribute('marker-start');
        }
        const markerEnd = extractId(path.getAttribute('marker-end'));
        if (markerEnd && !availableIds[markerEnd]) {
            path.removeAttribute('marker-end');
        }
        const filterId = extractId(path.getAttribute('filter'));
        if (filterId && !availableIds[filterId]) {
            path.removeAttribute('filter');
        }
    });
    function extractId(attributeValue) {
        if (attributeValue) {
            if (polyfills_1.isIE11()) {
                return (attributeValue.match(/#(.*?)"/) || [])[1];
            }
            else {
                return (attributeValue.match(/#(.*?)\)/) || [])[1];
            }
        }
        else {
            return undefined;
        }
    }
}
function extractCSSFromDocument(targetSubtree) {
    const exportedRules = new Set();
    for (let i = 0; i < document.styleSheets.length; i++) {
        let rules;
        try {
            const cssSheet = document.styleSheets[i];
            rules = cssSheet.cssRules || cssSheet.rules;
            if (!rules) {
                continue;
            }
        }
        catch (e) {
            continue;
        }
        for (let j = 0; j < rules.length; j++) {
            const rule = rules[j];
            if (rule instanceof CSSStyleRule) {
                if (targetSubtree.querySelector(rule.selectorText)) {
                    exportedRules.add(rule);
                }
            }
        }
    }
    const exportedCssTexts = [];
    exportedRules.forEach(rule => exportedCssTexts.push(rule.cssText));
    return exportedCssTexts.join('\n');
}
function clonePaperSvg(options, elementSizePadding) {
    const { model, paper, getOverlayedElement } = options;
    const svgClone = paper.cloneNode(true);
    svgClone.removeAttribute('class');
    svgClone.removeAttribute('style');
    function findViewport() {
        let child = svgClone.firstChild;
        while (child) {
            if (child instanceof SVGGElement) {
                return child;
            }
            child = child.nextSibling;
        }
        return undefined;
    }
    const viewport = findViewport();
    viewport.removeAttribute('transform');
    const imageBounds = {};
    for (const element of model.elements) {
        const modelId = element.id;
        const overlayedView = getOverlayedElement(modelId);
        if (!overlayedView) {
            continue;
        }
        const elementRoot = document.createElementNS(SVG_NAMESPACE, 'g');
        const overlayedViewContent = overlayedView.firstChild.cloneNode(true);
        elementRoot.setAttribute('class', 'ontodia-exported-element');
        let newRoot;
        if (polyfills_1.isIE11()) {
            newRoot = htmlToSvg_1.htmlToSvg(overlayedView, [], options.mockImages);
        }
        else {
            newRoot = document.createElementNS(SVG_NAMESPACE, 'foreignObject');
            newRoot.appendChild(overlayedViewContent);
        }
        const { x, y, width, height } = geometry_1.boundsOf(element);
        newRoot.setAttribute('transform', `translate(${x},${y})`);
        newRoot.setAttribute('width', (width + elementSizePadding).toString());
        newRoot.setAttribute('height', (height + elementSizePadding).toString());
        elementRoot.appendChild(newRoot);
        viewport.appendChild(elementRoot);
        const originalNodes = overlayedView.firstChild.querySelectorAll('img');
        const clonedNodes = overlayedViewContent.querySelectorAll('img');
        foreachNode(overlayedView.querySelectorAll('img'), (img, index) => {
            const exportKey = lodash_1.uniqueId('export-key-');
            clonedNodes[index].setAttribute('export-key', exportKey);
            imageBounds[exportKey] = {
                width: img.clientWidth,
                height: img.clientHeight,
            };
        });
    }
    return { svgClone, imageBounds };
}
function exportAsDataUri(original) {
    const url = original.src;
    if (!url || url.startsWith('data:')) {
        return Promise.resolve(url);
    }
    return loadCrossOriginImage(original.src).then(image => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0);
        // match extensions like htttp://example.com/images/foo.JPG&w=200
        const extensionMatch = url.match(/\.([a-zA-Z0-9]+)[^\.a-zA-Z0-9]?[^\.]*$/);
        const extension = extensionMatch ? extensionMatch[1].toLowerCase() : 'png';
        try {
            const mimeType = 'image/' + (extension === 'jpg' ? 'jpeg' : extension);
            const dataUri = canvas.toDataURL(mimeType);
            return Promise.resolve(dataUri);
        }
        catch (e) {
            if (extension !== 'svg') {
                return Promise.reject('Failed to convert image to data URI');
            }
            return fetch(url)
                .then(response => response.text())
                .then(svg => svg.length > 0 ? ('data:image/svg+xml,' + encodeURIComponent(svg)) : '');
        }
    });
}
function loadCrossOriginImage(src) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    const promise = new Promise((resolve, reject) => {
        image.onload = () => resolve(image);
        image.onerror = ev => reject(ev);
    });
    image.src = src;
    return promise;
}
function foreachNode(nodeList, callback) {
    for (let i = 0; i < nodeList.length; i++) {
        callback(nodeList[i], i);
    }
}
const MAX_CANVAS_LENGTH = 4096;
function toDataURL(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { paper, mimeType = 'image/png' } = options;
        const svgOptions = Object.assign(Object.assign({}, options), { convertImagesToDataUris: true, mockImages: polyfills_1.isIE11(), preserveDimensions: true });
        const svg = yield exportSVG(svgOptions);
        const svgBox = {
            width: Number(svg.getAttribute('width')),
            height: Number(svg.getAttribute('height')),
        };
        const containerSize = (typeof options.width === 'number' || typeof options.height === 'number')
            ? { width: options.width, height: options.height }
            : fallbackContainerSize(svgBox);
        const { innerSize, outerSize, offset } = computeAutofit(svgBox, containerSize);
        svg.setAttribute('width', innerSize.width.toString());
        svg.setAttribute('height', innerSize.height.toString());
        const svgString = new XMLSerializer().serializeToString(svg);
        const { canvas, context } = createCanvas(outerSize.width, outerSize.height, options.backgroundColor);
        if (polyfills_1.isIE11()) {
            if (!canvg) {
                throw new Error('"canvg-fixed" dependency required to support exporting in the IE.');
            }
            canvg(canvas, svgString, {
                offsetX: offset.x,
                offsetY: offset.y,
                scaleWidth: innerSize.width,
                scaleHeight: innerSize.height,
                ignoreDimensions: true,
                ignoreClear: true,
            });
            return canvas.toDataURL(mimeType, options.quality);
        }
        else {
            const image = yield loadImage('data:image/svg+xml,' + encodeURIComponent(svgString));
            context.drawImage(image, offset.x, offset.y, innerSize.width, innerSize.height);
            return canvas.toDataURL(mimeType, options.quality);
        }
        function createCanvas(canvasWidth, canvasHeight, backgroundColor) {
            const cnv = document.createElement('canvas');
            cnv.width = canvasWidth;
            cnv.height = canvasHeight;
            const cnt = cnv.getContext('2d');
            if (backgroundColor) {
                cnt.fillStyle = backgroundColor;
                cnt.fillRect(0, 0, canvasWidth, canvasHeight);
            }
            return { canvas: cnv, context: cnt };
        }
    });
}
exports.toDataURL = toDataURL;
function loadImage(source) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = function () {
            resolve(image);
        };
        image.onerror = function (ev) {
            reject(ev);
        };
        image.src = source;
    });
}
exports.loadImage = loadImage;
function computeAutofit(itemSize, containerSize) {
    const fit = fitRectKeepingAspectRatio(itemSize.width, itemSize.height, containerSize.width, containerSize.height);
    const innerSize = {
        width: Math.floor(fit.width),
        height: Math.floor(fit.height),
    };
    const outerSize = {
        width: typeof containerSize.width === 'number' ? containerSize.width : innerSize.width,
        height: typeof containerSize.height === 'number' ? containerSize.height : innerSize.height,
    };
    const offset = {
        x: Math.round((outerSize.width - innerSize.width) / 2),
        y: Math.round((outerSize.height - innerSize.height) / 2),
    };
    return { innerSize, outerSize, offset };
}
function fallbackContainerSize(itemSize) {
    const maxResolutionScale = Math.min(MAX_CANVAS_LENGTH / itemSize.width, MAX_CANVAS_LENGTH / itemSize.height);
    const resolutionScale = Math.min(2.0, maxResolutionScale);
    const width = Math.floor(itemSize.width * resolutionScale);
    const height = Math.floor(itemSize.height * resolutionScale);
    return { width, height };
}
function fitRectKeepingAspectRatio(sourceWidth, sourceHeight, targetWidth, targetHeight) {
    if (!(typeof targetWidth === 'number' || typeof targetHeight === 'number')) {
        return { width: sourceWidth, height: sourceHeight };
    }
    const sourceAspectRatio = sourceWidth / sourceHeight;
    targetWidth = typeof targetWidth === 'number' ? targetWidth : targetHeight * sourceAspectRatio;
    targetHeight = typeof targetHeight === 'number' ? targetHeight : targetWidth / sourceAspectRatio;
    if (targetHeight * sourceAspectRatio <= targetWidth) {
        return { width: targetHeight * sourceAspectRatio, height: targetHeight };
    }
    else {
        return { width: targetWidth, height: targetWidth / sourceAspectRatio };
    }
}
exports.fitRectKeepingAspectRatio = fitRectKeepingAspectRatio;
/**
 * Creates and returns a blob from a data URL (either base64 encoded or not).
 *
 * @param {string} dataURL The data URL to convert.
 * @return {Blob} A blob representing the array buffer data.
 */
function dataURLToBlob(dataURL) {
    const BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        const parts = dataURL.split(',');
        const contentType = parts[0].split(':')[1];
        const raw = decodeURIComponent(parts[1]);
        return new Blob([raw], { type: contentType });
    }
    else {
        const parts = dataURL.split(BASE64_MARKER);
        const contentType = parts[0].split(':')[1];
        const raw = window.atob(parts[1]);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], { type: contentType });
    }
}
exports.dataURLToBlob = dataURLToBlob;


/***/ }),
/* 85 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.htmlToSvg = void 0;
const lodash_1 = __webpack_require__(67);
function htmlToSvg(htmlView, blackList, mockImages) {
    blackList = blackList || [];
    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    const primitives = breakIntoPrimitives(htmlView);
    for (const primitive of primitives) {
        const id = primitive.getAttribute('id');
        if (!id) {
            g.appendChild(primitive);
        }
        else {
            primitive.removeAttribute('id');
            const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
            clipPath.setAttribute('id', id);
            clipPath.appendChild(primitive);
            defs.appendChild(clipPath);
        }
    }
    g.appendChild(defs);
    return g;
    function breakIntoPrimitives(domElement) {
        if (domElement instanceof Element) {
            if (domElement instanceof HTMLImageElement) {
                return !mockImages ? processImage(domElement) : processElement(domElement);
            }
            else if (domElement instanceof HTMLElement) {
                return processElement(domElement);
            }
        }
        else if (domElement instanceof Text) {
            return processText(domElement);
        }
        return [];
    }
    function processImage(htmlElement) {
        const image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        // Process current node
        const style = window.getComputedStyle(htmlElement);
        const offsetTop = getOffsetTop(htmlElement);
        const offsetLeft = getOffsetLeft(htmlElement);
        const width = style.width;
        const height = style.height;
        // path.setAttribute('className', htmlElement.className);
        image.setAttribute('stroke', style.borderColor);
        image.setAttribute('stroke-width', style.borderWidth);
        image.setAttribute('x', `${offsetLeft}`);
        image.setAttribute('y', `${offsetTop}`);
        image.setAttribute('width', `${width}`);
        image.setAttribute('height', `${height}`);
        image.setAttribute('href', htmlElement.getAttribute('src'));
        htmlElement.removeAttribute('crossorigin');
        return [image];
    }
    function processElement(htmlElement) {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        let parts = [];
        // Process children
        const contentSize = { width: 0, height: 0 };
        forEachNode(htmlElement.childNodes, child => {
            const nestedParts = breakIntoPrimitives(child);
            if (nestedParts.length > 0) {
                for (const p of nestedParts) {
                    const bbox = getElementBoundingBox(p);
                    contentSize.width = Math.max(contentSize.width, bbox.x + bbox.width);
                    contentSize.height = Math.max(contentSize.height, bbox.y + bbox.height);
                }
                parts = parts.concat(nestedParts);
            }
        });
        // Process current node
        const style = window.getComputedStyle(htmlElement);
        const y = getOffsetTop(htmlElement);
        const x = getOffsetLeft(htmlElement);
        const { width, height } = htmlElement.getBoundingClientRect();
        // const width = !style.width.endsWith('px') ? contentSize.width + 'px' : style.width;
        // const height = !style.width.endsWith('px') ? contentSize.height + 'px' : style.height;
        const radius = getBorderRadius(style);
        const borderColor = getBorderColor(style);
        const borderWidth = getBorderWidth(style);
        // path.setAttribute('className', htmlElement.className);
        path.setAttribute('fill', style.backgroundColor);
        path.setAttribute('stroke', borderColor);
        path.setAttribute('stroke-width', `${borderWidth}px`);
        // path.setAttribute('transform', `translate(${x}, ${y})`);
        path.setAttribute('x', `${x}`);
        path.setAttribute('y', `${y}`);
        path.setAttribute('width', `${width}`);
        path.setAttribute('height', `${height}`);
        path.setAttribute('d', generatePathData(x, y, width, height, radius[0], radius[1], radius[2], radius[3]));
        // create mask if it's needed
        if (style.overflow === 'hidden' || style.overflow === 'auto') {
            const rect = createRect(x, y, width, height);
            const id = rect.getAttribute('id');
            parts.forEach(p => {
                if (!p.getAttribute('clip-path') && !p.getAttribute('id') && !(p instanceof SVGTextElement)) {
                    p.setAttribute('clip-path', `url(${'#' + id})`);
                }
            });
            parts.push(rect);
        }
        parts = [path].concat(parts);
        return parts;
    }
    function processText(textElement) {
        const parts = [];
        const textContent = textElement.textContent.trim();
        if (textContent.length === 0 || !(textElement.parentNode instanceof Element)) {
            return [];
        }
        const parent = textElement.parentNode;
        const style = window.getComputedStyle(parent);
        const x = getOffsetLeft(parent);
        const y = getOffsetTop(parent);
        const fill = style.color;
        const textSize = getTextSize(textContent, style.font);
        const prefferedWidth = stringToNumber(style.width);
        const lines = breakInLines(textContent, textSize, stringToNumber(style.width));
        lines.forEach((line, index) => {
            const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            text.setAttribute('transform', `translate(${x}, ${y + index * textSize.height})`);
            text.setAttribute('x', `${0}`);
            text.setAttribute('y', `${0}`);
            // text.setAttribute('x', `${x}`);
            // text.setAttribute('y', `${y + index * textSize.height}`);
            text.setAttribute('width', `${prefferedWidth || textSize.width}`);
            text.setAttribute('height', `${textSize.height}`);
            text.setAttribute('fill', fill);
            text.setAttribute('font', style.font);
            // It's not working for IE11 (our main goal)
            // text.setAttribute('alignment-baseline', 'hanging');
            text.setAttribute('dy', `${textSize.height}`);
            text.textContent = line;
            parts.push(text);
        });
        return parts;
    }
}
exports.htmlToSvg = htmlToSvg;
function getBorderRadius(style) {
    const radius = Math.round(stringToNumber(style.borderRadius.split(' ')[0])) || 0;
    return [
        Math.round(stringToNumber(style.borderTopLeftRadius)) || radius,
        Math.round(stringToNumber(style.borderTopRightRadius)) || radius,
        Math.round(stringToNumber(style.borderBottomRightRadius)) || radius,
        Math.round(stringToNumber(style.borderBottomLeftRadius)) || radius,
    ];
}
function getBorderColor(style) {
    const color = style.borderColor.split(' ')[0];
    return style.borderTopColor ||
        style.borderRightColor ||
        style.borderBottomColor ||
        style.borderLeftColor || color || null;
}
function getBorderWidth(style) {
    // const width = Math.round(stringToNumber(style.borderWidth.split(' ')[0]) || 0);
    const top = Math.round(stringToNumber(style.borderTopWidth) || 0);
    const right = Math.round(stringToNumber(style.borderRightWidth) || 0);
    const bottom = Math.round(stringToNumber(style.borderBottomWidth) || 0);
    const left = Math.round(stringToNumber(style.borderLeftWidth) || 0);
    return Math.min(top, right, bottom, left);
}
function createRect(x, y, width, height) {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('id', lodash_1.uniqueId('clip-rect-'));
    rect.setAttribute('x', `${x}`);
    rect.setAttribute('y', `${y}`);
    rect.setAttribute('width', `${width}px`);
    rect.setAttribute('height', `${height}px`);
    return rect;
}
function getOffsetTop(element) {
    if (element.className !== 'ontodia-overlayed-element') {
        return element.offsetTop +
            element.clientTop +
            (element.offsetParent && element.offsetParent instanceof HTMLElement ?
                getOffsetTop(element.offsetParent) : 0);
    }
    else {
        return 0;
    }
}
function getOffsetLeft(element) {
    if (element.className !== 'ontodia-overlayed-element') {
        return element.offsetLeft +
            element.clientLeft +
            (element.offsetParent && element.offsetParent instanceof HTMLElement ?
                getOffsetLeft(element.offsetParent) : 0);
    }
    else {
        return 0;
    }
}
function breakInLines(text, textSize, prefferedWidth, elipsis) {
    const { width, height } = textSize;
    const lines = [];
    // breakText
    if (!prefferedWidth || width <= prefferedWidth) {
        lines.push(text);
    }
    else {
        const oneCharLength = width / text.length;
        const charsInLine = Math.floor(prefferedWidth / oneCharLength);
        if (elipsis) {
            const ELIPSIS_LENGTH = 3;
            lines.push(text.substring(0, charsInLine - ELIPSIS_LENGTH) + '...');
        }
        else {
            let c = 0;
            let line = '';
            for (let i = 0; i < text.length; i++, c++) {
                if (c >= charsInLine) {
                    lines.push(line);
                    line = '';
                    c = 0;
                }
                line += text[i];
            }
        }
    }
    return lines;
}
function getElementBoundingBox(element) {
    return {
        x: stringToNumber(element.getAttribute('x')),
        y: stringToNumber(element.getAttribute('y')),
        width: stringToNumber(element.getAttribute('width')),
        height: stringToNumber(element.getAttribute('height')),
    };
}
/**
 * @param {string} text
 * @param {string} font
 */
function getTextSize(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    const fontSizeString = context.font.split(' ').filter(term => term.indexOf('px') !== -1)[0];
    const fontSize = +fontSizeString.substring(0, fontSizeString.length - 2);
    const metrics = context.measureText(text);
    return {
        width: metrics.width,
        height: fontSize,
    };
}
function forEachNode(nodeList, callback) {
    for (let i = 0; i < nodeList.length; i++) {
        callback(nodeList[i]);
    }
}
function stringToNumber(value) {
    const newValue = +cutExtension(value);
    return newValue;
}
const postfixes = ['px', 'vh', 'vw'];
function cutExtension(value) {
    const lowerCaseValue = value.toLowerCase();
    if (postfixes.filter(postfix => lowerCaseValue.indexOf(postfix) !== -1).length > 0) {
        return value.substring(0, value.length - 2);
    }
    else {
        return value;
    }
}
/*
 * Generate a path's data attribute
 *
 * @param {Number} width Width of the rectangular shape
 * @param {Number} height Height of the rectangular shape
 * @param {Number} tr Top border radius of the rectangular shape
 * @param {Number} br Bottom border radius of the rectangular shape
 * @return {String} a path's data attribute value
 */
function generatePathData(x, y, width, height, tl, tr, br, bl) {
    const data = [];
    // start point in top-middle of the rectangle
    data.push('M' + (width / 2 + x) + ',' + y);
    // next we go to the right
    data.push('H' + (x + width - tr));
    if (tr > 0) {
        // now we draw the arc in the top-right corner
        data.push('A' + arcParameter(tr, tr, 0, 0, 1, x + width, y + tr));
    }
    // next we go down
    data.push('V' + (y + height - br));
    if (br > 0) {
        // now we draw the arc in the lower-right corner
        data.push('A' + arcParameter(br, br, 0, 0, 1, x + width - br, y + height));
    }
    // now we go to the left
    data.push('H' + (x + bl));
    if (bl > 0) {
        // now we draw the arc in the lower-left corner
        data.push('A' + arcParameter(bl, bl, 0, 0, 1, x, y + height - bl));
    }
    // next we go up
    data.push('V' + (y + tl));
    if (tl > 0) {
        // now we draw the arc in the top-left corner
        data.push('A' + arcParameter(tl, tl, 0, 0, 1, x + tl, y));
    }
    // and we close the path
    data.push('Z');
    return data.join(' ');
}
function arcParameter(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
    return [
        rx, ',',
        ry, ' ',
        xAxisRotation, ' ',
        largeArcFlag, ',',
        sweepFlag, ' ',
        x, ',',
        y,
    ].join('');
}


/***/ }),
/* 86 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StandardTemplate = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const react_1 = __webpack_require__(46);
const blankNodes_1 = __webpack_require__(79);
const utils_1 = __webpack_require__(47);
const schema_1 = __webpack_require__(54);
const authoredEntity_1 = __webpack_require__(87);
const authoringState_1 = __webpack_require__(89);
const spinner_1 = __webpack_require__(90);
const FOAF_NAME = 'http://xmlns.com/foaf/0.1/name';
const CLASS_NAME = 'ontodia-standard-template';
class StandardTemplate extends react_1.Component {
    render() {
        return (React.createElement(authoredEntity_1.AuthoredEntity, { templateProps: this.props }, context => this.renderTemplate(context)));
    }
    renderTemplate(context) {
        const { color, types, isExpanded, iri, propsAsList } = this.props;
        const label = this.getLabel();
        const { editor } = context;
        const isNewElement = authoringState_1.AuthoringState.isNewElement(editor.authoringState, iri);
        const leftStripeColor = isNewElement ? 'white' : color;
        const pinnedProperties = this.findPinnedProperties(context);
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__main`, style: { backgroundColor: leftStripeColor, borderColor: color } },
                React.createElement("div", { className: `${CLASS_NAME}__body`, style: { borderLeftColor: color } },
                    React.createElement("div", { className: `${CLASS_NAME}__body-horizontal` },
                        this.renderThumbnail(),
                        React.createElement("div", { className: `${CLASS_NAME}__body-content` },
                            React.createElement("div", { title: types, className: `${CLASS_NAME}__type` },
                                React.createElement("div", { className: `${CLASS_NAME}__type-value` }, this.getTypesLabel())),
                            React.createElement("div", { className: `${CLASS_NAME}__label`, title: label }, label))),
                    pinnedProperties ? (React.createElement("div", { className: `${CLASS_NAME}__pinned-props`, style: { borderColor: color } }, this.renderProperties(pinnedProperties))) : null)),
            isExpanded ? (React.createElement("div", { className: `${CLASS_NAME}__dropdown`, style: { borderColor: color } },
                this.renderPhoto(),
                React.createElement("div", { className: `${CLASS_NAME}__dropdown-content` },
                    this.renderIri(),
                    this.renderProperties(propsAsList),
                    editor.inAuthoringMode ? React.createElement("hr", { className: `${CLASS_NAME}__hr` }) : null,
                    editor.inAuthoringMode ? this.renderActions(context) : null))) : null));
    }
    findPinnedProperties(context) {
        const { isExpanded, propsAsList, elementId } = this.props;
        if (isExpanded) {
            return undefined;
        }
        const templateState = context.view.model.getElement(elementId).elementState;
        if (!templateState) {
            return undefined;
        }
        const pinned = templateState[schema_1.TemplateProperties.PinnedProperties];
        if (!pinned) {
            return undefined;
        }
        const filtered = propsAsList.filter(prop => Boolean(pinned[prop.id]));
        return filtered.length === 0 ? undefined : filtered;
    }
    renderProperties(propsAsList) {
        if (!propsAsList.length) {
            return React.createElement("div", null, "no properties");
        }
        return (React.createElement("div", { className: `${CLASS_NAME}__properties` }, propsAsList.map(({ name, id, property }) => {
            const propertyValues = utils_1.getPropertyValues(property);
            return React.createElement("div", { key: id, className: `${CLASS_NAME}__properties-row` },
                React.createElement("div", { className: `${CLASS_NAME}__properties-key`, title: `${name} (${id})` }, name),
                React.createElement("div", { className: `${CLASS_NAME}__properties-values` }, propertyValues.map((text, index) => (React.createElement("div", { className: `${CLASS_NAME}__properties-value`, key: index, title: text }, text)))));
        })));
    }
    renderPhoto() {
        const { color, imgUrl } = this.props;
        if (!imgUrl) {
            return null;
        }
        return (React.createElement("div", { className: `${CLASS_NAME}__photo`, style: { borderColor: color } },
            React.createElement("img", { src: imgUrl, className: `${CLASS_NAME}__photo-image` })));
    }
    renderIri() {
        const { iri } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: `${CLASS_NAME}__iri` },
                React.createElement("div", { className: `${CLASS_NAME}__iri-key` }, "IRI:"),
                React.createElement("div", { className: `${CLASS_NAME}__iri-value` }, blankNodes_1.isEncodedBlank(iri)
                    ? React.createElement("span", null, "(blank node)")
                    : React.createElement("a", { href: iri, title: iri, "data-iri-click-intent": 'openEntityIri' }, iri))),
            React.createElement("hr", { className: `${CLASS_NAME}__hr` })));
    }
    renderThumbnail() {
        const { color, imgUrl, iconUrl } = this.props;
        if (imgUrl) {
            return (React.createElement("div", { className: `${CLASS_NAME}__thumbnail`, "aria-hidden": 'true' },
                React.createElement("img", { src: imgUrl, className: `${CLASS_NAME}__thumbnail-image` })));
        }
        else if (iconUrl) {
            return (React.createElement("div", { className: `${CLASS_NAME}__thumbnail`, "aria-hidden": 'true' },
                React.createElement("img", { src: iconUrl, className: `${CLASS_NAME}__thumbnail-icon` })));
        }
        const typeLabel = this.getTypesLabel();
        return (React.createElement("div", { className: `${CLASS_NAME}__thumbnail`, "aria-hidden": 'true', style: { color } }, typeLabel.length > 0 ? typeLabel.charAt(0).toUpperCase() : '✳'));
    }
    getTypesLabel() {
        return this.props.types;
    }
    getLabel() {
        const { label, props } = this.props;
        return utils_1.getProperty(props, FOAF_NAME) || label;
    }
    renderActions(context) {
        const { canEdit, canDelete, onEdit, onDelete } = context;
        const SPINNER_WIDTH = 15;
        const SPINNER_HEIGHT = 12;
        return (React.createElement("div", { className: `${CLASS_NAME}__actions` },
            React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: canDelete ? 'Delete entity' : 'Deletion is unavailable for the selected element', disabled: !canDelete, onClick: onDelete },
                React.createElement("span", { className: 'fa fa-trash' }),
                "\u00A0",
                canEdit === undefined
                    ? React.createElement(spinner_1.HtmlSpinner, { width: SPINNER_WIDTH, height: SPINNER_HEIGHT })
                    : 'Delete'),
            React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: canEdit ? 'Edit entity' : 'Editing is unavailable for the selected element', disabled: !canEdit, onClick: onEdit },
                React.createElement("span", { className: 'fa fa-edit' }),
                "\u00A0",
                canEdit === undefined
                    ? React.createElement(spinner_1.HtmlSpinner, { width: SPINNER_WIDTH, height: SPINNER_HEIGHT })
                    : 'Edit')));
    }
}
exports.StandardTemplate = StandardTemplate;


/***/ }),
/* 87 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AuthoredEntity = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const paperArea_1 = __webpack_require__(83);
const async_1 = __webpack_require__(61);
const workspaceContext_1 = __webpack_require__(88);
const authoringState_1 = __webpack_require__(89);
/**
 * Component to simplify tracking changes in validation messages (property and link type labels).
 */
class AuthoredEntity extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.queryCancellation = new async_1.Cancellation();
        this.onChangeAuthoringState = e => {
            const { source: editor, previous } = e;
            const iri = this.props.templateProps.data.id;
            const current = editor.authoringState;
            if (current.index.elements.get(iri) !== previous.index.elements.get(iri)) {
                this.queryAllowedActions();
            }
        };
        this.onEdit = () => {
            const { editor } = this.context.ontodiaWorkspace;
            const { elementId } = this.props.templateProps;
            const element = editor.model.getElement(elementId);
            editor.showEditEntityForm(element);
        };
        this.onDelete = () => {
            const { editor } = this.context.ontodiaWorkspace;
            const { data } = this.props.templateProps;
            editor.deleteEntity(data.id);
        };
        this.state = {};
    }
    componentDidMount() {
        const { editor } = this.context.ontodiaWorkspace;
        editor.events.on('changeAuthoringState', this.onChangeAuthoringState);
        this.queryAllowedActions();
    }
    componentDidUpdate(prevProps) {
        const shouldUpdateAllowedActions = !(this.props.templateProps.data === prevProps.templateProps.data &&
            this.props.templateProps.isExpanded === prevProps.templateProps.isExpanded);
        if (shouldUpdateAllowedActions) {
            this.queryAllowedActions();
        }
    }
    componentWillUnmount() {
        const { editor } = this.context.ontodiaWorkspace;
        editor.events.off('changeAuthoringState', this.onChangeAuthoringState);
        this.queryCancellation.abort();
    }
    queryAllowedActions() {
        const { isExpanded, data } = this.props.templateProps;
        // only fetch whether it's allowed to edit when expanded
        if (!isExpanded) {
            return;
        }
        this.queryCancellation.abort();
        this.queryCancellation = new async_1.Cancellation();
        const { editor } = this.context.ontodiaWorkspace;
        if (!editor.metadataApi || authoringState_1.AuthoringState.isDeletedElement(editor.authoringState, data.id)) {
            this.setState({ canEdit: false, canDelete: false });
        }
        else {
            this.queryCanEdit(data);
            this.queryCanDelete(data);
        }
    }
    queryCanEdit(data) {
        const { editor } = this.context.ontodiaWorkspace;
        const signal = this.queryCancellation.signal;
        this.setState({ canEdit: undefined });
        editor.metadataApi.canEditElement(data, signal).then(canEdit => {
            if (signal.aborted) {
                return;
            }
            this.setState({ canEdit });
        });
    }
    queryCanDelete(data) {
        const { editor } = this.context.ontodiaWorkspace;
        const signal = this.queryCancellation.signal;
        this.setState({ canDelete: undefined });
        editor.metadataApi.canDeleteElement(data, signal).then(canDelete => {
            if (signal.aborted) {
                return;
            }
            this.setState({ canDelete });
        });
    }
    render() {
        const { children: renderTemplate } = this.props;
        const { view } = this.context.ontodiaPaperArea;
        const { editor } = this.context.ontodiaWorkspace;
        const { canEdit, canDelete } = this.state;
        return renderTemplate({
            editor, view, canEdit, canDelete,
            onEdit: this.onEdit,
            onDelete: this.onDelete,
        });
    }
}
exports.AuthoredEntity = AuthoredEntity;
AuthoredEntity.contextTypes = Object.assign(Object.assign({}, paperArea_1.PaperAreaContextTypes), workspaceContext_1.WorkspaceContextTypes);


/***/ }),
/* 88 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkspaceContextTypes = exports.WorkspaceEventKey = void 0;
const react_1 = __webpack_require__(62);
var WorkspaceEventKey;
(function (WorkspaceEventKey) {
    WorkspaceEventKey["searchUpdateCriteria"] = "search:updateCriteria";
    WorkspaceEventKey["searchQueryItem"] = "search:queryItems";
    WorkspaceEventKey["connectionsLoadLinks"] = "connections:loadLinks";
    WorkspaceEventKey["connectionsExpandLink"] = "connections:expandLink";
    WorkspaceEventKey["connectionsLoadElements"] = "connections:loadElements";
    WorkspaceEventKey["editorChangeSelection"] = "editor:changeSelection";
    WorkspaceEventKey["editorToggleDialog"] = "editor:toggleDialog";
    WorkspaceEventKey["editorAddElements"] = "editor:addElements";
})(WorkspaceEventKey = exports.WorkspaceEventKey || (exports.WorkspaceEventKey = {}));
exports.WorkspaceContextTypes = {
    ontodiaWorkspace: react_1.PropTypes.anything,
};


/***/ }),
/* 89 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isLinkConnectedToElement = exports.TemporaryState = exports.AuthoringState = exports.AuthoringKind = void 0;
const model_1 = __webpack_require__(48);
const collections_1 = __webpack_require__(56);
var AuthoringKind;
(function (AuthoringKind) {
    AuthoringKind["ChangeElement"] = "changeElement";
    AuthoringKind["DeleteElement"] = "deleteElement";
    AuthoringKind["ChangeLink"] = "changeLink";
    AuthoringKind["DeleteLink"] = "deleteLink";
})(AuthoringKind = exports.AuthoringKind || (exports.AuthoringKind = {}));
var AuthoringState;
(function (AuthoringState) {
    AuthoringState.empty = {
        events: [],
        index: makeIndex([]),
    };
    function set(state, change) {
        const events = change.events || state.events;
        const index = makeIndex(events);
        return Object.assign(Object.assign({}, state), { events, index });
    }
    AuthoringState.set = set;
    function discard(state, discarded) {
        const index = state.events.indexOf(discarded);
        if (index < 0) {
            return state;
        }
        const newElementIri = discarded.type === AuthoringKind.ChangeElement && !discarded.before
            ? discarded.after.id : undefined;
        const events = state.events.filter(e => {
            if (e.type === AuthoringKind.ChangeLink) {
                if (newElementIri && isLinkConnectedToElement(e.after, newElementIri)) {
                    return false;
                }
            }
            return e !== discarded;
        });
        return set(state, { events });
    }
    AuthoringState.discard = discard;
    function addElement(state, item) {
        const event = { type: AuthoringKind.ChangeElement, after: item };
        return AuthoringState.set(state, { events: [...state.events, event] });
    }
    AuthoringState.addElement = addElement;
    function addLink(state, item) {
        const event = { type: AuthoringKind.ChangeLink, after: item };
        return AuthoringState.set(state, { events: [...state.events, event] });
    }
    AuthoringState.addLink = addLink;
    function changeElement(state, before, after) {
        const iriChanged = after.id !== before.id;
        if (iriChanged) {
            // disallow changing IRI for existing (non-new) entities
            const isNewEntity = state.events.find(e => e.type === AuthoringKind.ChangeElement &&
                e.after.id === before.id &&
                !e.before);
            if (!isNewEntity) {
                throw new Error('Cannot change IRI of already persisted entity');
            }
        }
        let previousBefore = before;
        const additional = [];
        const events = state.events.filter(e => {
            if (e.type === AuthoringKind.DeleteElement) {
                if (e.model.id === before.id) {
                    previousBefore = e.model;
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeElement) {
                if (e.after.id === before.id) {
                    previousBefore = e.before;
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                if (iriChanged && isLinkConnectedToElement(e.after, before.id)) {
                    additional.push({
                        type: AuthoringKind.ChangeLink,
                        before: e.before,
                        after: updateLinkToReferByNewIri(e.after, before.id, after.id),
                    });
                    return false;
                }
            }
            return true;
        });
        additional.unshift({
            type: AuthoringKind.ChangeElement,
            before: previousBefore,
            after: after,
        });
        return AuthoringState.set(state, { events: [...events, ...additional] });
    }
    AuthoringState.changeElement = changeElement;
    function changeLink(state, before, after) {
        if (!model_1.sameLink(before, after)) {
            throw new Error('Cannot move link to another element or change its type');
        }
        let previousBefore = before;
        const events = state.events.filter(e => {
            if (e.type === AuthoringKind.ChangeLink) {
                if (model_1.sameLink(e.after, before)) {
                    previousBefore = e.before;
                    return false;
                }
            }
            return true;
        });
        const event = {
            type: AuthoringKind.ChangeLink,
            before: previousBefore,
            after: after,
        };
        return AuthoringState.set(state, { events: [...events, event] });
    }
    AuthoringState.changeLink = changeLink;
    function deleteElement(state, model) {
        const events = state.events.filter(e => {
            if (e.type === AuthoringKind.ChangeElement) {
                if (e.after.id === model.id) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                if (isLinkConnectedToElement(e.after, model.id)) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                if (isLinkConnectedToElement(e.model, model.id)) {
                    return false;
                }
            }
            return true;
        });
        if (!isNewElement(state, model.id)) {
            events.push({ type: AuthoringKind.DeleteElement, model });
        }
        return AuthoringState.set(state, { events });
    }
    AuthoringState.deleteElement = deleteElement;
    function deleteLink(state, target) {
        const events = state.events.filter(e => {
            if (e.type === AuthoringKind.ChangeLink) {
                if (model_1.sameLink(e.after, target)) {
                    return false;
                }
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                if (model_1.sameLink(e.model, target)) {
                    return false;
                }
            }
            return true;
        });
        if (!isNewLink(state, target)) {
            events.push({
                type: AuthoringKind.DeleteLink,
                model: target,
            });
        }
        return AuthoringState.set(state, { events });
    }
    AuthoringState.deleteLink = deleteLink;
    function deleteNewLinksConnectedToElements(state, elementIris) {
        const events = state.events.filter(event => {
            if (event.type !== AuthoringKind.ChangeLink || event.before) {
                return true;
            }
            const linkModel = event.after;
            return !elementIris.has(linkModel.sourceId) &&
                !elementIris.has(linkModel.targetId);
        });
        return AuthoringState.set(state, { events });
    }
    AuthoringState.deleteNewLinksConnectedToElements = deleteNewLinksConnectedToElements;
    function makeIndex(events) {
        const elements = new Map();
        const links = new collections_1.HashMap(model_1.hashLink, model_1.sameLink);
        for (const e of events) {
            if (e.type === AuthoringKind.ChangeElement) {
                elements.set(e.after.id, e);
            }
            else if (e.type === AuthoringKind.DeleteElement) {
                elements.set(e.model.id, e);
            }
            else if (e.type === AuthoringKind.ChangeLink) {
                links.set(e.after, e);
            }
            else if (e.type === AuthoringKind.DeleteLink) {
                links.set(e.model, e);
            }
        }
        return { elements, links };
    }
    function isNewElement(state, target) {
        const event = state.index.elements.get(target);
        return event && event.type === AuthoringKind.ChangeElement && !event.before;
    }
    AuthoringState.isNewElement = isNewElement;
    function isDeletedElement(state, target) {
        const event = state.index.elements.get(target);
        return event && event.type === AuthoringKind.DeleteElement;
    }
    AuthoringState.isDeletedElement = isDeletedElement;
    function isNewLink(state, linkModel) {
        const event = state.index.links.get(linkModel);
        return event && event.type === AuthoringKind.ChangeLink && !event.before;
    }
    AuthoringState.isNewLink = isNewLink;
    function isDeletedLink(state, linkModel) {
        const event = state.index.links.get(linkModel);
        return event && event.type === AuthoringKind.DeleteLink ||
            isDeletedElement(state, linkModel.sourceId) ||
            isDeletedElement(state, linkModel.targetId);
    }
    AuthoringState.isDeletedLink = isDeletedLink;
})(AuthoringState = exports.AuthoringState || (exports.AuthoringState = {}));
var TemporaryState;
(function (TemporaryState) {
    TemporaryState.empty = {
        elements: new Map(),
        links: new collections_1.HashMap(model_1.hashLink, model_1.sameLink),
    };
    function addElement(state, element) {
        const elements = collections_1.cloneMap(state.elements);
        elements.set(element.id, element);
        return Object.assign(Object.assign({}, state), { elements });
    }
    TemporaryState.addElement = addElement;
    function deleteElement(state, element) {
        const elements = collections_1.cloneMap(state.elements);
        elements.delete(element.id);
        return Object.assign(Object.assign({}, state), { elements });
    }
    TemporaryState.deleteElement = deleteElement;
    function addLink(state, link) {
        const links = state.links.clone();
        links.set(link, link);
        return Object.assign(Object.assign({}, state), { links });
    }
    TemporaryState.addLink = addLink;
    function deleteLink(state, link) {
        const links = state.links.clone();
        links.delete(link);
        return Object.assign(Object.assign({}, state), { links });
    }
    TemporaryState.deleteLink = deleteLink;
})(TemporaryState = exports.TemporaryState || (exports.TemporaryState = {}));
function isLinkConnectedToElement(link, elementIri) {
    return link.sourceId === elementIri || link.targetId === elementIri;
}
exports.isLinkConnectedToElement = isLinkConnectedToElement;
function updateLinkToReferByNewIri(link, oldIri, newIri) {
    return Object.assign(Object.assign({}, link), { sourceId: link.sourceId === oldIri ? newIri : link.sourceId, targetId: link.targetId === oldIri ? newIri : link.targetId });
}


/***/ }),
/* 90 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HtmlSpinner = exports.Spinner = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const CLASS_NAME = 'ontodia-spinner';
class Spinner extends React.Component {
    render() {
        const { position = { x: 0, y: 0 }, size = 50, statusText, errorOccured } = this.props;
        const textLeftMargin = 5;
        const pathGeometry = 'm3.47,-19.7 a20,20 0 1,1 -6.95,0 m0,0 l-6,5 m6,-5 l-8,-0' +
            (errorOccured ? 'M-8,-8L8,8M-8,8L8,-8' : '');
        return React.createElement("g", { className: CLASS_NAME, "data-error": errorOccured, transform: `translate(${position.x},${position.y})` },
            React.createElement("g", { className: `${CLASS_NAME}__arrow` },
                React.createElement("path", { d: pathGeometry, transform: `scale(0.02)scale(${size})`, fill: 'none', stroke: errorOccured ? 'red' : 'black', strokeWidth: '3', strokeLinecap: 'round' })),
            React.createElement("text", { style: { dominantBaseline: 'middle' }, x: size / 2 + textLeftMargin }, statusText));
    }
}
exports.Spinner = Spinner;
class HtmlSpinner extends React.Component {
    render() {
        const { width, height } = this.props;
        const size = Math.min(width, height);
        return (React.createElement("svg", { width: width, height: height },
            React.createElement(Spinner, { size: size, position: { x: width / 2, y: height / 2 } })));
    }
}
exports.HtmlSpinner = HtmlSpinner;


/***/ }),
/* 91 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),
/* 92 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),
/* 93 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),
/* 94 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DemoDataProvider = void 0;
const lodash_1 = __webpack_require__(67);
class DemoDataProvider {
    constructor(allClasses, allLinkTypes, allElements, allLinks) {
        this.allClasses = allClasses;
        this.allLinkTypes = allLinkTypes;
        this.allElements = allElements;
        this.allLinks = allLinks;
    }
    simulateNetwork(result) {
        const MEAN_DELAY = 200;
        const cloned = lodash_1.cloneDeep(result);
        // simulate exponential distribution
        const delay = -Math.log(Math.random()) * MEAN_DELAY;
        return new Promise(resolve => {
            setTimeout(() => resolve(cloned), delay);
        });
    }
    classTree() {
        return this.simulateNetwork(this.allClasses);
    }
    classInfo(params) {
        const classIds = params.classIds || [];
        return this.simulateNetwork(this.allClasses.filter(cl => classIds.indexOf(cl.id)));
    }
    linkTypes() {
        return this.simulateNetwork(this.allLinkTypes);
    }
    linkTypesInfo(params) {
        const types = lodash_1.keyBy(params.linkTypeIds);
        const linkTypes = this.allLinkTypes.filter(type => types[type.id]);
        return this.simulateNetwork(linkTypes);
    }
    elementInfo(params) {
        const elements = params.elementIds
            .map(elementId => this.allElements[elementId])
            .filter(element => element !== undefined);
        return this.simulateNetwork(lodash_1.keyBy(elements, element => element.id));
    }
    linksInfo(params) {
        const nodes = lodash_1.keyBy(params.elementIds);
        const types = lodash_1.keyBy(params.linkTypeIds);
        const links = this.allLinks.filter(link => types[link.linkTypeId] && nodes[link.sourceId] && nodes[link.targetId]);
        return this.simulateNetwork(links);
    }
    linkTypesOf(params) {
        const counts = {};
        for (const link of this.allLinks) {
            if (link.sourceId === params.elementId ||
                link.targetId === params.elementId) {
                const linkCount = counts[link.linkTypeId];
                const isSource = link.sourceId === params.elementId;
                if (linkCount) {
                    isSource ? linkCount.outCount++ : linkCount.inCount++;
                }
                else {
                    counts[link.linkTypeId] = isSource
                        ? { id: link.linkTypeId, inCount: 0, outCount: 1 }
                        : { id: link.linkTypeId, inCount: 1, outCount: 0 };
                }
            }
        }
        return this.simulateNetwork(lodash_1.map(counts));
    }
    linkElements(params) {
        // for sparql we have rich filtering features and we just reuse filter.
        return this.filter({
            refElementId: params.elementId,
            refElementLinkId: params.linkId,
            linkDirection: params.direction,
            limit: params.limit,
            offset: params.offset,
            languageCode: '',
            inputText: '',
            quering: false,
            resultId: 0,
            error: undefined,
            items: [],
            items_filtred: [],
            sourceNames: [],
            selection: undefined,
            moreItemsAvailable: false
        });
    }
    filter(params) {
        if (params.limit === undefined) {
            params.limit = 100;
        }
        if (params.offset > 0) {
            return Promise.resolve({});
        }
        let filtered = {};
        if (params.elementTypeId) {
            lodash_1.each(this.allElements, element => {
                if (element.types.indexOf(params.elementTypeId) >= 0) {
                    filtered[element.id] = element;
                }
            });
        }
        else if (params.refElementId) {
            const filteredLinks = params.refElementLinkId
                ? this.allLinks.filter(link => link.linkTypeId === params.refElementLinkId)
                : this.allLinks;
            const nodeId = params.refElementId;
            for (const link of filteredLinks) {
                let linkedElementId;
                if (link.sourceId === nodeId && params.linkDirection !== 'in') {
                    linkedElementId = link.targetId;
                }
                else if (link.targetId === nodeId && params.linkDirection !== 'out') {
                    linkedElementId = link.sourceId;
                }
                if (linkedElementId !== undefined) {
                    const linkedElement = this.allElements[linkedElementId];
                    if (linkedElement) {
                        filtered[linkedElement.id] = linkedElement;
                    }
                }
            }
        }
        else if (params.text) {
            filtered = this.allElements; // filtering by text is done below
        }
        else {
            return Promise.reject(new Error('This type of filter is not implemented'));
        }
        if (params.text) {
            const filteredByText = {};
            const text = params.text.toLowerCase();
            lodash_1.each(filtered, element => {
                let found = false;
                if (element.id.toLowerCase().indexOf(text) >= 0) {
                    found = true;
                }
                else {
                    found = element.label.values.some(label => label.text.toLowerCase().indexOf(text) >= 0);
                }
                if (found) {
                    filteredByText[element.id] = element;
                }
            });
            return this.simulateNetwork(filteredByText);
        }
        else {
            return this.simulateNetwork(filtered);
        }
    }
}
exports.DemoDataProvider = DemoDataProvider;


/***/ }),
/* 95 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RDFDataProvider = void 0;
const tslib_1 = __webpack_require__(1);
const rdfCacheableStore_1 = __webpack_require__(96);
const rdfLoader_1 = __webpack_require__(98);
const rdfCompositeParser_1 = __webpack_require__(99);
const PREFIX_FACTORIES = {
    RDF: rdfCacheableStore_1.prefixFactory('http://www.w3.org/1999/02/22-rdf-syntax-ns#'),
    RDFS: rdfCacheableStore_1.prefixFactory('http://www.w3.org/2000/01/rdf-schema#'),
    FOAF: rdfCacheableStore_1.prefixFactory('http://xmlns.com/foaf/0.1/'),
    XSD: rdfCacheableStore_1.prefixFactory('http://www.w3.org/2001/XMLSchema#'),
    OWL: rdfCacheableStore_1.prefixFactory('http://www.w3.org/2002/07/owl#'),
};
class RDFDataProvider {
    constructor(options) {
        const parser = new rdfCompositeParser_1.RDFCompositeParser(options.parsers);
        this.rdfStorage = new rdfCacheableStore_1.RDFCacheableStore({
            parser,
            acceptBlankNodes: options.acceptBlankNodes,
        });
        this.rdfLoader = new rdfLoader_1.RDFLoader({
            parser: parser,
            proxy: options.proxy,
        });
        this.dataFetching = options.dataFetching;
        const parsePromises = (options.data || []).map(datum => {
            return parser.parse(datum.content, datum.type, datum.fileName)
                .then(rdfGraph => {
                this.rdfStorage.add(rdfGraph);
                return true;
            });
        });
        this.initStatement = Promise.all(parsePromises).catch((error) => {
            error.message = 'Initialization failed! Cause: ' + error.message;
            throw error;
        });
        this.options = options;
    }
    addGraph(graph) {
        this.rdfStorage.add(graph);
    }
    waitInitCompleted() {
        if (this.initStatement) {
            return this.initStatement.then(() => {
                delete this.initStatement;
            });
        }
        else {
            return Promise.resolve();
        }
    }
    classTree() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const rdfClassesQuery = this.rdfStorage.match(null, PREFIX_FACTORIES.RDF('type'), PREFIX_FACTORIES.RDFS('Class'), null);
            const owlClassesQuery = this.rdfStorage.match(null, PREFIX_FACTORIES.RDF('type'), PREFIX_FACTORIES.OWL('Class'));
            const fromRDFTypesQuery = this.rdfStorage.match(null, PREFIX_FACTORIES.RDF('type'), null);
            const subClassesQuery = this.rdfStorage.match(null, PREFIX_FACTORIES.RDFS('subClassOf'), null);
            const [rdfClassesGraph, owlClassesGraph, rdfTypesGraph, subClassesGraph,] = yield Promise.all([
                rdfClassesQuery,
                owlClassesQuery,
                fromRDFTypesQuery,
                subClassesQuery,
            ]);
            const rdfClasses = rdfClassesGraph.toArray().map(cl => cl.subject);
            const owlClasses = owlClassesGraph.toArray().map(cl => cl.subject);
            const rdfTypes = rdfTypesGraph.toArray().map(cl => cl.object);
            const subClasses = subClassesGraph.toArray();
            const classes = rdfClasses.concat(owlClasses).concat(rdfTypes);
            const classIris = classes
                .filter(clazz => clazz.interfaceName !== 'BlankNode')
                .map(clazz => clazz.nominalValue);
            const parents = {};
            for (const triple of subClasses) {
                const subClassIRI = triple.subject.nominalValue;
                const classIRI = triple.object.nominalValue;
                if (rdfCacheableStore_1.isNamedNode(triple.subject) && !parents[subClassIRI]) {
                    parents[subClassIRI] = [];
                }
                if (rdfCacheableStore_1.isNamedNode(triple.object) && parents[subClassIRI].indexOf(classIRI) === -1) {
                    parents[subClassIRI].push(classIRI);
                }
            }
            const dictionary = {};
            const firstLevel = {};
            const labelQueries = [];
            for (const classIri of classIris) {
                let classElement;
                if (!dictionary[classIri]) {
                    classElement = this.createEmptyClass(classIri);
                    dictionary[classIri] = classElement;
                    firstLevel[classIri] = classElement;
                    labelQueries.push(this.getLabels(classIri).then(labels => {
                        classElement.label = { values: labels };
                    }));
                }
                else {
                    classElement = dictionary[classIri];
                }
                if (parents[classIri]) {
                    for (const parentIri of parents[classIri]) {
                        if (!dictionary[parentIri]) {
                            const parentElement = this.createEmptyClass(parentIri);
                            dictionary[parentIri] = parentElement;
                            firstLevel[parentIri] = parentElement;
                            labelQueries.push(this.getLabels(parentIri).then(labels => {
                                parentElement.label = { values: labels };
                            }));
                        }
                        if (dictionary[parentIri].children.indexOf(classElement) === -1) {
                            dictionary[parentIri].children.push(classElement);
                            dictionary[parentIri].count += classElement.count;
                        }
                        delete firstLevel[classElement.id];
                    }
                }
            }
            yield Promise.all(labelQueries);
            const result = Object.keys(firstLevel).map(k => firstLevel[k]);
            return result;
        });
    }
    propertyInfo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const propertyInfoResult = {};
            const queries = params.propertyIds.map((propId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    const isExists = yield this.checkElement(propId);
                    yield this.fetchIfNecessary(propId, isExists);
                    const labels = yield this.getLabels(propId);
                    return {
                        id: propId,
                        label: { values: labels },
                    };
                }
                catch (error) {
                    // tslint:disable-next-line:no-console
                    console.warn(error);
                    return null;
                }
            }));
            const fetchedModels = yield Promise.all(queries);
            for (const model of fetchedModels) {
                if (model) {
                    propertyInfoResult[model.id] = model;
                }
            }
            return propertyInfoResult;
        });
    }
    classInfo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const queries = params.classIds.map((classId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    const isExists = yield this.checkElement(classId);
                    yield this.fetchIfNecessary(classId, isExists);
                    const labels = yield this.getLabels(classId);
                    return {
                        id: classId,
                        label: { values: labels },
                        count: this.rdfStorage.getTypeCount(classId),
                        children: [],
                    };
                }
                catch (error) {
                    // tslint:disable-next-line:no-console
                    console.warn(error);
                    return null;
                }
            }));
            const fetchedModels = yield Promise.all(queries);
            return fetchedModels.filter(cm => cm);
        });
    }
    linkTypesInfo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const queries = params.linkTypeIds.map((typeId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    const isExists = yield this.rdfStorage.checkElement(typeId);
                    yield this.fetchIfNecessary(typeId, isExists);
                    const labels = yield this.getLabels(typeId);
                    return {
                        id: typeId,
                        label: { values: labels },
                        count: this.rdfStorage.getTypeCount(typeId),
                    };
                }
                catch (error) {
                    // tslint:disable-next-line:no-console
                    console.warn(error);
                    return null;
                }
            }));
            const fetchedModels = yield Promise.all(queries);
            return fetchedModels.filter(lt => lt);
        });
    }
    linkTypes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const linkTypes = [];
            const rdfLinksQueries = this.rdfStorage.match(undefined, PREFIX_FACTORIES.RDF('type'), PREFIX_FACTORIES.RDF('Property'));
            const owlLinksQueries = this.rdfStorage.match(undefined, PREFIX_FACTORIES.RDF('type'), PREFIX_FACTORIES.OWL('ObjectProperty'));
            const [rdfLinks, owlLinks] = yield Promise.all([rdfLinksQueries, owlLinksQueries]);
            const linkTypeIds = new Set();
            const mapLinkTriple = (triple) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!linkTypeIds.has(triple.subject.nominalValue)) {
                    linkTypeIds.add(triple.subject.nominalValue);
                    const labels = yield this.getLabels(triple.subject.nominalValue);
                    linkTypes.push({
                        id: triple.subject.nominalValue,
                        label: { values: labels },
                        count: this.rdfStorage.getTypeCount(triple.subject.nominalValue),
                    });
                }
            });
            const linkTypePromises = [];
            for (const linkTriple of rdfLinks.toArray()) {
                linkTypePromises.push(mapLinkTriple(linkTriple));
            }
            for (const linkTriple of owlLinks.toArray()) {
                linkTypePromises.push(mapLinkTriple(linkTriple));
            }
            yield Promise.all(linkTypePromises);
            return linkTypes;
        });
    }
    elementInfo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const elementInfoResult = {};
            const queries = params.elementIds.map((elementId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    const isExists = yield this.rdfStorage.checkElement(elementId);
                    yield this.fetchIfNecessary(elementId, isExists);
                    return this.getElementInfo(elementId);
                }
                catch (error) {
                    // tslint:disable-next-line:no-console
                    console.warn(error);
                    return null;
                }
            }));
            const fetchedModels = yield Promise.all(queries);
            for (const model of fetchedModels) {
                if (model) {
                    elementInfoResult[model.id] = model;
                }
            }
            return elementInfoResult;
        });
    }
    linksInfo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const statementPromises = [];
            for (const source of params.elementIds) {
                for (const target of params.elementIds) {
                    statementPromises.push(Promise.all([
                        this.rdfStorage.checkElement(source)
                            .then(exists => this.fetchIfNecessary(source, exists)),
                        this.rdfStorage.checkElement(target)
                            .then(exists => this.fetchIfNecessary(target, exists)),
                    ]).then(() => ({ subject: source, object: target })).catch(error => {
                        // tslint:disable-next-line:no-console
                        console.warn(error);
                        return null;
                    }));
                }
            }
            const statements = yield Promise.all(statementPromises);
            const graph = yield this.rdfStorage.matchAll(statements.filter(statement => statement));
            let triples;
            if (this.options.acceptBlankNodes) {
                triples = graph.toArray();
            }
            else {
                triples = graph.toArray().filter(tripple => rdfCacheableStore_1.isNamedNode(tripple.subject) && rdfCacheableStore_1.isNamedNode(tripple.object));
            }
            const fetchedModels = triples.map((t) => ({
                linkTypeId: t.predicate.nominalValue,
                sourceId: t.subject.nominalValue,
                targetId: t.object.nominalValue,
            }));
            return fetchedModels;
        });
    }
    linkTypesOf(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            const links = [];
            const element = params.elementId;
            const linkMap = {};
            const incomingElementsTriples = yield this.rdfStorage.match(null, null, element);
            const incomingElements = incomingElementsTriples.toArray()
                .filter(t => rdfCacheableStore_1.isNamedNode(t.subject))
                .map(triple => triple.predicate);
            for (const el of incomingElements) {
                const linkTypeId = el.nominalValue;
                if (!linkMap[linkTypeId]) {
                    linkMap[linkTypeId] = {
                        id: linkTypeId,
                        inCount: 1,
                        outCount: 0,
                    };
                    links.push(linkMap[linkTypeId]);
                }
                else {
                    linkMap[linkTypeId].inCount++;
                }
            }
            const outgoingElementsTriples = yield this.rdfStorage.match(element, null, null);
            const outElements = outgoingElementsTriples.toArray()
                .filter(t => rdfCacheableStore_1.isNamedNode(t.object))
                .map(triple => triple.predicate);
            for (const el of outElements) {
                const linkTypeId = el.nominalValue;
                if (!linkMap[linkTypeId]) {
                    linkMap[linkTypeId] = {
                        id: linkTypeId,
                        inCount: 0,
                        outCount: 1,
                    };
                    links.push(linkMap[linkTypeId]);
                }
                else {
                    linkMap[linkTypeId].outCount++;
                }
            }
            return links;
        });
    }
    linkElements(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            return yield this.filter({
                refElementId: params.elementId,
                refElementLinkId: params.linkId,
                linkDirection: params.direction,
                limit: params.limit,
                offset: params.offset,
                languageCode: '',
                inputText: '',
                quering: false,
                resultId: 0,
                error: undefined,
                items: [],
                items_filtred: [],
                sourceNames: [],
                selection: undefined,
                moreItemsAvailable: false
            });
        });
    }
    filter(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.waitInitCompleted();
            if (params.limit === undefined) {
                params.limit = 100;
            }
            const limitCallback = (node, index) => {
                return (blankNodes || rdfCacheableStore_1.isNamedNode(node))
                    && offsetIndex <= index
                    && index < limitIndex;
            };
            const offsetIndex = params.offset;
            const limitIndex = params.offset + params.limit;
            const blankNodes = this.options.acceptBlankNodes;
            let elementsPromise;
            if (params.elementTypeId) {
                elementsPromise = this.filterByTypeId(params.elementTypeId, limitCallback);
            }
            else if (params.refElementId && params.refElementLinkId) {
                elementsPromise = this.filterByRefAndLink(params.refElementId, params.refElementLinkId, params.linkDirection, limitCallback);
            }
            else if (params.refElementId) {
                elementsPromise = this.filterByRef(params.refElementId, limitCallback);
            }
            else if (params.text) {
                const filteredElements = yield this.getAllElements(params.text, limitCallback);
                return this.filterByKey(undefined, filteredElements);
            }
            else {
                return {};
            }
            const elements = yield elementsPromise;
            return this.filterByKey(params.text, elements);
        });
    }
    filterByTypeId(elementTypeId, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const elementTriples = yield this.rdfStorage.match(undefined, PREFIX_FACTORIES.RDF('type'), elementTypeId);
            return Promise.all(elementTriples.toArray()
                .filter((t, index) => filter(t.subject, index))
                .map(el => this.getElementInfo(el.subject.nominalValue, true)));
        });
    }
    filterByRefAndLink(refEl, refLink, linkDirection, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (linkDirection === 'in') {
                const elementTriples = yield this.rdfStorage.match(null, refLink, refEl);
                return Promise.all(elementTriples.toArray().filter((t, index) => filter(t.subject, index))
                    .map(el => this.getElementInfo(el.subject.nominalValue, true)));
            }
            else {
                const elementTriples = yield this.rdfStorage.match(refEl, refLink, null);
                return Promise.all(elementTriples.toArray().filter((t, index) => filter(t.object, index))
                    .map(el => this.getElementInfo(el.object.nominalValue, true)));
            }
        });
    }
    filterByRef(refEl, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const incomingTriples = yield this.rdfStorage.match(null, null, refEl);
            const inRelations = yield Promise.all(incomingTriples.toArray().filter((t, index) => filter(t.subject, index))
                .map(el => this.getElementInfo(el.subject.nominalValue, true)));
            const outgoingTriples = yield this.rdfStorage.match(refEl, null, null);
            const outRelations = yield Promise.all(outgoingTriples.toArray().filter((t, index) => filter(t.object, index))
                .map(el => this.getElementInfo(el.object.nominalValue, true)));
            return inRelations.concat(outRelations);
        });
    }
    getAllElements(text, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const key = (text ? text.toLowerCase() : null);
            const elementTriples = yield this.rdfStorage.match(null, null, null);
            const promices = [];
            for (const triple of elementTriples.toArray()) {
                if (filter(triple.subject, promices.length)) {
                    const objectIsLiteral = triple.object.interfaceName === 'Literal';
                    const isLabel = rdfCacheableStore_1.isLabelType(triple.predicate.nominalValue);
                    const containsKey = isLabel &&
                        triple.object.nominalValue.toLowerCase().indexOf(key) !== -1 ||
                        !objectIsLiteral &&
                            triple.subject.nominalValue.toLowerCase().indexOf(key) !== -1;
                    if (containsKey) {
                        promices.push(this.getElementInfo(triple.subject.nominalValue, true));
                    }
                }
            }
            return Promise.all(promices);
        });
    }
    filterByKey(text, elements) {
        const result = {};
        const key = (text ? text.toLowerCase() : null);
        if (key) {
            for (const el of elements) {
                let acceptableKey = false;
                for (const label of el.label.values) {
                    acceptableKey = acceptableKey || label.text.toLowerCase().indexOf(key) !== -1;
                    if (acceptableKey) {
                        break;
                    }
                }
                acceptableKey = acceptableKey || el.id.toLowerCase().indexOf(key) !== -1;
                if (acceptableKey) {
                    result[el.id] = el;
                }
            }
        }
        else {
            for (const el of elements) {
                result[el.id] = el;
            }
        }
        return result;
    }
    checkElement(id) {
        return this.dataFetching ?
            this.rdfStorage.checkElement(id) :
            Promise.resolve(true);
    }
    fetchIfNecessary(id, exists) {
        if (exists || !this.dataFetching) {
            return Promise.resolve();
        }
        else {
            return this.rdfLoader.downloadElement(id).then(rdfGraph => {
                this.rdfStorage.add(rdfGraph);
                return;
            }).catch(error => {
                // tslint:disable-next-line:no-console
                console.warn(error);
                return;
            });
        }
    }
    getElementInfo(id, shortInfo) {
        return Promise.all([
            this.getTypes(id),
            (!shortInfo ? this.getProps(id) : Promise.resolve({})),
            this.getLabels(id),
        ]).then(([types, props, labels]) => {
            return {
                id: id,
                types: types,
                label: { values: labels },
                properties: props,
            };
        });
    }
    getLabels(id) {
        return this.rdfStorage.getLabels(id).then(labelTriples => {
            return labelTriples.toArray().map(l => ({
                text: l.object.nominalValue,
                lang: rdfCacheableStore_1.isLiteral(l.object) ? l.object.language || '' : '',
            }));
        });
    }
    getProps(el) {
        return this.rdfStorage.match(el, null, null).then(propsGraph => {
            const props = {};
            const propTriples = propsGraph.toArray();
            for (const statemet of propTriples) {
                if (rdfCacheableStore_1.isLiteral(statemet.object) &&
                    statemet.predicate.nominalValue !== PREFIX_FACTORIES.RDFS('label')) {
                    const property = props[statemet.predicate.nominalValue];
                    const value = {
                        text: statemet.object.nominalValue,
                        lang: statemet.object.language || '',
                    };
                    props[statemet.predicate.nominalValue] = {
                        type: 'string',
                        values: property ? [...property.values, value] : [value],
                    };
                }
            }
            return props;
        });
    }
    getTypes(el) {
        return this.rdfStorage.match(el, PREFIX_FACTORIES.RDF('type'), null)
            .then(typeTriples => {
            return typeTriples.toArray().map(t => t.object.nominalValue);
        });
    }
    createEmptyClass(classIri) {
        return {
            id: classIri,
            label: {
                values: [],
            },
            count: this.rdfStorage.getTypeCount(classIri),
            children: [],
        };
    }
}
exports.RDFDataProvider = RDFDataProvider;


/***/ }),
/* 96 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RDFCacheableStore = exports.isLabelType = exports.LABEL_POSTFIXES = exports.LABEL_URIS = exports.isNamedNode = exports.isLiteral = exports.prefixFactory = void 0;
const rdf_ext_1 = __webpack_require__(97);
const lodash_1 = __webpack_require__(67);
const DEFAULT_STORAGE_TYPE = 'text/turtle';
const DEFAULT_STORAGE_URI = 'http://ontodia.org/defaultGraph';
function prefixFactory(prefix) {
    const lastSymbol = prefix[prefix.length - 1];
    const _prefix = lastSymbol === '/' || lastSymbol === '#' ? prefix : prefix + '/';
    return (id) => {
        return _prefix + id;
    };
}
exports.prefixFactory = prefixFactory;
function isLiteral(el) {
    return el.interfaceName === 'Literal';
}
exports.isLiteral = isLiteral;
function isNamedNode(el) {
    return el.interfaceName === 'NamedNode';
}
exports.isNamedNode = isNamedNode;
exports.LABEL_URIS = [
    'http://www.w3.org/2004/02/skos/core#prefLabel',
    'http://www.w3.org/2004/02/skos/core#label',
    'http://www.w3.org/2004/02/skos/core#altLabel',
    'http://www.w3.org/2000/01/rdf-schema#prefLabel',
    'http://www.w3.org/2000/01/rdf-schema#label',
    'http://xmlns.com/foaf/0.1/name',
    'http://schema.org/name',
];
exports.LABEL_POSTFIXES = [
    'prefLabel',
    'prefName',
    'label',
    'name',
    'title',
];
function isLabelType(predicateIri) {
    const isLabelIri = exports.LABEL_URIS.indexOf(predicateIri) !== -1;
    const type = predicateIri.toLocaleLowerCase();
    const looksLikeLabel = Boolean(exports.LABEL_POSTFIXES.find((value, index, array) => {
        const postfix = value.toLocaleLowerCase();
        return type.indexOf(postfix) !== -1;
    }));
    return isLabelIri || looksLikeLabel;
}
exports.isLabelType = isLabelType;
class RDFCacheableStore {
    constructor(options) {
        this.checkingElementMap = {};
        this.labelsMap = {};
        this.countMap = {};
        this.elementTypes = {};
        this.parser = options.parser;
        this.acceptBlankNodes = Boolean(options.acceptBlankNodes);
        this.rdfStorage = rdf_ext_1.createStore();
        this.prefs = {
            RDF: prefixFactory('http://www.w3.org/1999/02/22-rdf-syntax-ns#'),
            RDFS: prefixFactory('http://www.w3.org/2000/01/rdf-schema#'),
            FOAF: prefixFactory('http://xmlns.com/foaf/0.1/'),
            XSD: prefixFactory('http://www.w3.org/2001/XMLSchema#'),
            OWL: prefixFactory('http://www.w3.org/2002/07/owl#'),
        };
    }
    add(rdfGraph, prefix) {
        this.rdfStorage.add(lodash_1.uniqueId(prefix) || (lodash_1.uniqueId(DEFAULT_STORAGE_URI)), rdfGraph);
        this.enrichMaps(rdfGraph);
    }
    match(subject, predicate, object, iri, callback, limit) {
        if (subject && (exports.LABEL_URIS.indexOf(predicate) !== -1) && !object) {
            return Promise.resolve(this._getLabels(subject));
        }
        else if (subject && predicate === this.prefs.RDF('type') && !object) {
            return Promise.resolve(this.getTypes(subject));
        }
        else {
            return this.rdfStorage.match(subject, predicate, object, iri, callback, limit);
        }
    }
    matchAll(statements) {
        const slowQueries = [];
        const queries = [];
        statements.forEach(statement => {
            if (statement.subject && (exports.LABEL_URIS.indexOf(statement.predicate) !== -1) && !statement.object) {
                queries.push(this._getLabels(statement.subject));
            }
            else if (statement.subject && statement.predicate === this.prefs.RDF('type') && !statement.object) {
                queries.push(this.getTypes(statement.subject));
            }
            else {
                slowQueries.push(statement);
            }
        });
        queries.push(this.multipleMatch(slowQueries));
        return Promise.resolve(this.combineGraphs(queries));
    }
    getLabels(id) {
        return Promise.resolve(rdf_ext_1.createGraph(this.labelsMap[id]));
    }
    // Checks whetger the element is in the storage.
    checkElement(id) {
        if (this.labelsMap[id]) { // if there is label for an id then the element is already fetched
            return Promise.resolve(true);
        }
        else {
            if (!this.checkingElementMap[id]) {
                this.checkingElementMap[id] = this.rdfStorage.match(id, null, null).then(result => {
                    const resultArray = result.toArray();
                    return resultArray.length !== 0;
                });
            }
            return this.checkingElementMap[id];
        }
    }
    getTypeCount(id) {
        return this.countMap[id] || 0;
    }
    enrichMaps(newGraph) {
        const triples = newGraph.toArray();
        // Deal with labels
        for (const triple of triples) {
            const element = triple.subject.nominalValue;
            const predicate = triple.predicate.nominalValue;
            if (isLabelType(predicate)) {
                if (!this.labelsMap[element]) {
                    this.labelsMap[element] = [];
                }
                if (isLiteral(triple.object)) {
                    this.labelsMap[element].push(triple);
                    this.labelsMap[element].sort((a, b) => {
                        const index1 = exports.LABEL_URIS.indexOf(a.predicate.nominalValue);
                        const index2 = exports.LABEL_URIS.indexOf(b.predicate.nominalValue);
                        if (index1 > index2) {
                            return 1;
                        }
                        else if (index1 < index2) {
                            return -1;
                        }
                        else {
                            return 0;
                        }
                    });
                }
            }
        }
        // Deal with counts
        const typeInstances = newGraph.match(null, this.prefs.RDF('type'), null).toArray();
        const typeInstMap = {};
        for (const instTriple of typeInstances) {
            const type = instTriple.object.nominalValue;
            const inst = instTriple.subject.nominalValue;
            if (!typeInstMap[type]) {
                typeInstMap[type] = [];
            }
            if (this.acceptBlankNodes || isNamedNode(instTriple.subject)) {
                if (!this.elementTypes[inst]) {
                    this.elementTypes[inst] = [];
                }
                if (typeInstMap[type].indexOf(inst) === -1) {
                    typeInstMap[type].push(inst);
                }
                this.elementTypes[inst].push(instTriple);
            }
        }
        Object.keys(typeInstMap).forEach(key => this.countMap[key] = typeInstMap[key].length);
        return true;
    }
    _getLabels(id) {
        return rdf_ext_1.createGraph(this.labelsMap[id]);
    }
    getTypes(id) {
        return rdf_ext_1.createGraph(this.elementTypes[id]);
    }
    combineGraphs(graphs) {
        const triples = [];
        for (const graph of graphs) {
            for (const triple of graph.toArray()) {
                triples.push(triple);
            }
        }
        return rdf_ext_1.createGraph(triples);
    }
    multipleMatch(statements) {
        const triples = [];
        const graphs = Object.keys(this.rdfStorage.graphs).map(id => this.rdfStorage.graphs[id]);
        for (const graph of graphs) {
            for (const triple of graph._graph) {
                for (const statement of statements) {
                    if (((!statement.object) || statement.object === triple.object.nominalValue) &&
                        ((!statement.predicate) || statement.predicate === triple.predicate.nominalValue) &&
                        ((!statement.subject) || statement.subject === triple.subject.nominalValue)) {
                        triples.push(triple);
                        continue;
                    }
                }
            }
        }
        return rdf_ext_1.createGraph(triples);
    }
}
exports.RDFCacheableStore = RDFCacheableStore;


/***/ }),
/* 97 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__97__;

/***/ }),
/* 98 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RDFLoader = exports.DEFAULT_PROXY = void 0;
exports.DEFAULT_PROXY = '/lod-proxy/';
class RDFLoader {
    constructor(parameters) {
        this.fetchingFileCatche = {};
        this.parser = parameters.parser;
        this.proxy = parameters.proxy || exports.DEFAULT_PROXY;
    }
    parseData(data, contentType, prefix) {
        let result;
        result = this.parser.parse(data, contentType);
        return result;
    }
    downloadElement(elementId) {
        const sharpIndex = elementId.indexOf('#');
        const fileUrl = sharpIndex !== -1 ? elementId.substr(0, sharpIndex) : elementId;
        let typePointer = 0;
        const mimeTypes = Object.keys(this.parser.parserMap);
        const recursivePart = () => {
            const acceptType = mimeTypes[typePointer++];
            if (acceptType && (elementId.startsWith('http') || elementId.startsWith('file'))) {
                return fetchFile({
                    url: elementId,
                    proxy: this.proxy,
                    headers: {
                        'Accept': acceptType,
                    },
                }).then((body) => {
                    return this.parseData(body, acceptType, elementId)
                        .catch(error => {
                        // tslint:disable-next-line:no-console
                        console.warn(error);
                        if (typePointer < mimeTypes.length) {
                            return recursivePart();
                        }
                        else {
                            throw new Error(`Unable to parse response. Response: ${body}`);
                        }
                    });
                });
            }
            else {
                throw new Error(`Unable to fetch data using this id (${elementId})`);
            }
        };
        if (!this.fetchingFileCatche[fileUrl]) {
            this.fetchingFileCatche[fileUrl] = recursivePart();
        }
        return this.fetchingFileCatche[fileUrl];
    }
}
exports.RDFLoader = RDFLoader;
function fetchFile(params) {
    return fetch(params.proxy + params.url, {
        method: 'GET',
        credentials: 'same-origin',
        mode: 'cors',
        cache: 'default',
        headers: params.headers || {
            'Accept': 'application/rdf+xml',
        },
    }).then(response => {
        if (response.ok) {
            return response.text();
        }
        else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}


/***/ }),
/* 99 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RDFCompositeParser = void 0;
function workaroundForRDFXmlParser(body) {
    // For some strange reason we've encountered xml parser errors
    // when parsing rdf/xml file with Collection tag.
    // As I remember, file came from x3c Ontology
    // and this workaround helps to get file through xml parsing.
    return body.replace(/parseType=["']Collection["']/ig, 'parseType="Collection1"');
}
const POSTFIX_TO_MIME = {
    'xml': 'application/rdf+xml',
    'rdf': 'application/rdf+xml',
    'owl': 'application/rdf+xml',
    'nttl': 'application/x-turtle',
    'jsonld': 'application/ld+json',
    'rj': 'application/ld+json',
    'ttl': 'text/turtle',
    'nt': 'text/turtle',
    'nq': 'text/turtle',
};
function getMimeTypeByFileName(fileName) {
    const postfix = (fileName.match(/\.([\S]*)$/i) || [])[1];
    return postfix ? POSTFIX_TO_MIME[postfix] : undefined;
}
class RDFCompositeParser {
    constructor(parserMap) {
        this.parserMap = parserMap;
    }
    parse(body, mimeType, fileName) {
        if (mimeType) {
            if (mimeType === 'application/rdf+xml') {
                body = workaroundForRDFXmlParser(body);
            }
            if (!this.parserMap[mimeType]) {
                throw Error('There is no parser for this MIME type');
            }
            return this.parserMap[mimeType].parse(body);
        }
        else {
            return this.tryToGuessMimeType(body, fileName);
        }
    }
    tryToGuessMimeType(body, fileName) {
        let mimeTypeIndex = 0;
        let mimeTypes = Object.keys(this.parserMap);
        if (fileName) {
            const mime = getMimeTypeByFileName(fileName);
            if (mime) {
                mimeTypes = [mime].concat(mimeTypes.filter(type => type !== mime));
            }
        }
        const errors = [];
        const recursion = () => {
            if (mimeTypeIndex < mimeTypes.length) {
                const mimeType = mimeTypes[mimeTypeIndex++];
                try {
                    const bodyToParse = mimeType === 'application/rdf+xml' ?
                        workaroundForRDFXmlParser(body) : body;
                    return this.parserMap[mimeType].parse(bodyToParse).catch((error) => {
                        errors.push({ mimeType, error });
                        return recursion();
                    });
                }
                catch (error) {
                    return recursion();
                }
            }
            else {
                throw new Error('Unknow mime type. Parse errors:\n' +
                    errors.map(e => `${e.mimeType}: ${e.error.message} ${e.error.stack};\n`).join('\n'));
            }
        };
        return recursion();
    }
}
exports.RDFCompositeParser = RDFCompositeParser;


/***/ }),
/* 100 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.executeSparqlConstruct = exports.executeSparqlQuery = exports.SparqlDataProvider = exports.SparqlQueryMethod = void 0;
const tslib_1 = __webpack_require__(1);
const responseHandler_1 = __webpack_require__(101);
const sparqlDataProviderSettings_1 = __webpack_require__(102);
const BlankNodes = tslib_1.__importStar(__webpack_require__(79));
const turtle_1 = __webpack_require__(103);
var SparqlQueryMethod;
(function (SparqlQueryMethod) {
    SparqlQueryMethod[SparqlQueryMethod["GET"] = 1] = "GET";
    SparqlQueryMethod[SparqlQueryMethod["POST"] = 2] = "POST";
})(SparqlQueryMethod = exports.SparqlQueryMethod || (exports.SparqlQueryMethod = {}));
class SparqlDataProvider {
    constructor(options, settings = sparqlDataProviderSettings_1.OWLStatsSettings) {
        const { queryFunction = queryInternal } = options;
        this.options = Object.assign(Object.assign({}, options), { queryFunction });
        this.settings = settings;
    }
    classTree() {
        const query = this.settings.defaultPrefix + this.settings.classTreeQuery;
        return this.executeSparqlQuery(query).then(responseHandler_1.getClassTree);
    }
    propertyInfo(params) {
        const ids = params.propertyIds.map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const query = this.settings.defaultPrefix + `
            SELECT ?prop ?label
            WHERE {
                VALUES (?prop) {${ids}}.
                OPTIONAL { ?prop ${this.settings.schemaLabelProperty} ?label. }
            }
        `;
        return this.executeSparqlQuery(query).then(responseHandler_1.getPropertyInfo);
    }
    classInfo(params) {
        const ids = params.classIds.map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const query = this.settings.defaultPrefix + `
            SELECT ?class ?label ?instcount
            WHERE {
                VALUES (?class) {${ids}}.
                OPTIONAL { ?class ${this.settings.schemaLabelProperty} ?label. }
                BIND("" as ?instcount)
            }
        `;
        return this.executeSparqlQuery(query).then(responseHandler_1.getClassInfo);
    }
    linkTypesInfo(params) {
        const ids = params.linkTypeIds.map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const query = this.settings.defaultPrefix + `
            SELECT ?link ?label ?instcount
            WHERE {
                VALUES (?link) {${ids}}.
                OPTIONAL { ?link ${this.settings.schemaLabelProperty} ?label. }
                BIND("" as ?instcount)
            }
        `;
        return this.executeSparqlQuery(query).then(responseHandler_1.getLinkTypes);
    }
    linkTypes() {
        const query = this.settings.defaultPrefix + `
            SELECT DISTINCT ?link ?instcount ?label
            WHERE {
                  ${this.settings.linkTypesPattern}
                  OPTIONAL { ?link ${this.settings.schemaLabelProperty} ?label. }
            }
        `;
        return this.executeSparqlQuery(query).then(responseHandler_1.getLinkTypes);
    }
    elementInfo(params) {
        const blankIds = [];
        const elementIds = params.elementIds.filter(id => !BlankNodes.isEncodedBlank(id));
        const blankNodeResponse = this.options.acceptBlankNodes
            ? BlankNodes.elementInfo(params.elementIds) : undefined;
        if (elementIds.length === 0 && this.options.acceptBlankNodes) {
            return Promise.resolve(responseHandler_1.getElementsInfo(blankNodeResponse, params.elementIds));
        }
        const ids = elementIds.map(escapeIri).map(id => ` (${id})`).join(' ');
        const { defaultPrefix, dataLabelProperty, elementInfoQuery, propertyConfigurations } = this.settings;
        const query = defaultPrefix + resolveTemplate(elementInfoQuery, { ids, dataLabelProperty, propertyConfigurations: this.formatPropertyInfo() });
        return this.executeSparqlConstruct(query)
            .then(responseHandler_1.triplesToElementBinding)
            .then(result => this.concatWithBlankNodeResponse(result, blankNodeResponse))
            .then(elementsInfo => responseHandler_1.getElementsInfo(elementsInfo, params.elementIds))
            .then(elementModels => {
            if (this.options.prepareImages) {
                return this.prepareElementsImage(elementModels);
            }
            else if (this.options.imagePropertyUris && this.options.imagePropertyUris.length) {
                return this.enrichedElementsInfo(elementModels, this.options.imagePropertyUris);
            }
            else {
                return elementModels;
            }
        });
    }
    enrichedElementsInfo(elementsInfo, types) {
        const ids = Object.keys(elementsInfo).filter(id => !BlankNodes.isEncodedBlank(id))
            .map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const typesString = types.map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const query = this.settings.defaultPrefix + `
            SELECT ?inst ?linkType ?image
            WHERE {{
                VALUES (?inst) {${ids}}
                VALUES (?linkType) {${typesString}}
                ${this.settings.imageQueryPattern}
            }}
        `;
        return this.executeSparqlQuery(query)
            .then(imageResponse => responseHandler_1.getEnrichedElementsInfo(imageResponse, elementsInfo))
            .catch(err => {
            // tslint:disable-next-line:no-console
            console.error(err);
            return elementsInfo;
        });
    }
    prepareElementsImage(elementsInfo) {
        return this.options.prepareImages(elementsInfo).then(images => {
            for (const key in images) {
                if (images.hasOwnProperty(key) && elementsInfo[key]) {
                    elementsInfo[key].image = images[key];
                }
            }
            return elementsInfo;
        });
    }
    linksInfo(params) {
        const elementIds = params.elementIds.filter(id => !BlankNodes.isEncodedBlank(id));
        const blankNodeResponse = this.options.acceptBlankNodes
            ? BlankNodes.linksInfo(params.elementIds) : undefined;
        if (elementIds.length === 0 && this.options.acceptBlankNodes) {
            return Promise.resolve(responseHandler_1.getLinksInfo(blankNodeResponse));
        }
        const ids = elementIds.map(escapeIri).map(id => ` ( ${id} )`).join(' ');
        const linksInfoQuery = resolveTemplate(this.settings.linksInfoQuery, { ids: ids, linkConfigurations: this.formatLinkLinks() });
        const query = this.settings.defaultPrefix + linksInfoQuery;
        return this.executeSparqlQuery(query)
            .then(result => this.concatWithBlankNodeResponse(result, blankNodeResponse))
            .then(responseHandler_1.getLinksInfo);
    }
    linkTypesOf(params) {
        if (this.options.acceptBlankNodes && BlankNodes.isEncodedBlank(params.elementId)) {
            return Promise.resolve(responseHandler_1.getLinksTypesOf(BlankNodes.linkTypesOf(params)));
        }
        const elementIri = escapeIri(params.elementId);
        // Ask for linkTypes
        const query = this.settings.defaultPrefix
            + resolveTemplate(this.settings.linkTypesOfQuery, { elementIri, linkConfigurations: this.formatLinkTypesOf(params.elementId) });
        return this.executeSparqlQuery(query)
            .then(linkTypeBinding => {
            const linkTypeIds = responseHandler_1.getLinksTypeIds(linkTypeBinding);
            const requests = [];
            const navigateElementFilterOut = this.options.acceptBlankNodes ?
                `FILTER (IsIri(?outObject) || IsBlank(?outObject))` : `FILTER IsIri(?outObject)`;
            const navigateElementFilterIn = this.options.acceptBlankNodes ?
                `FILTER (IsIri(?inObject) || IsBlank(?inObject))` : `FILTER IsIri(?inObject)`;
            for (const id of linkTypeIds) {
                const q = this.settings.defaultPrefix
                    + resolveTemplate(this.settings.linkTypesStatisticsQuery, {
                        linkId: escapeIri(id),
                        elementIri,
                        linkConfigurations: this.formatLinkTypesStatistics(params.elementId, id),
                        navigateElementFilterOut,
                        navigateElementFilterIn,
                    });
                requests.push(this.executeSparqlQuery(q).then(responseHandler_1.getLinkStatistics));
            }
            return Promise.all(requests);
        });
    }
    linkElements(params) {
        // for sparql we have rich filtering features and we just reuse filter.
        return this.filter({
            refElementId: params.elementId,
            refElementLinkId: params.linkId,
            linkDirection: params.direction,
            limit: params.limit,
            offset: params.offset,
            languageCode: '',
            inputText: '',
            quering: false,
            resultId: 0,
            error: undefined,
            items: [],
            items_filtred: [],
            sourceNames: [],
            selection: undefined,
            moreItemsAvailable: false
        });
    }
    filter(params) {
        if (params.limit === undefined) {
            params.limit = 100;
        }
        const blankFiltration = this.options.acceptBlankNodes
            ? BlankNodes.filter(params) : undefined;
        if (this.options.acceptBlankNodes && blankFiltration.results.bindings.length > 0) {
            return Promise.resolve(responseHandler_1.getFilteredData(blankFiltration));
        }
        if (!params.refElementId && params.refElementLinkId) {
            throw new Error(`Can't execute refElementLink filter without refElement`);
        }
        let refQueryPart = '';
        if (params.refElementId) {
            refQueryPart = this.createRefQueryPart({
                elementId: params.refElementId,
                linkId: params.refElementLinkId,
                direction: params.linkDirection,
            });
        }
        let elementTypePart = '';
        if (params.elementTypeId) {
            const elementTypeIri = escapeIri(params.elementTypeId);
            elementTypePart = resolveTemplate(this.settings.filterTypePattern, { elementTypeIri });
        }
        const { defaultPrefix, fullTextSearch, dataLabelProperty } = this.settings;
        let textSearchPart = '';
        if (params.text) {
            textSearchPart = resolveTemplate(fullTextSearch.queryPattern, { text: params.text, dataLabelProperty });
        }
        const blankNodes = this.options.acceptBlankNodes;
        const query = `${defaultPrefix}
            ${fullTextSearch.prefix}

        SELECT ?inst ?class ?label ?blankType ${blankNodes ? BlankNodes.BLANK_NODE_QUERY_PARAMETERS : ''}
        WHERE {
            {
                SELECT DISTINCT ?inst ${textSearchPart ? '?score' : ''} WHERE {
                    ${elementTypePart}
                    ${refQueryPart}
                    ${this.settings.fullTextSearch.extractLabel ? sparqlExtractLabel('?inst', '?extractedLabel') : ''}
                    ${textSearchPart}
                    ${this.settings.filterAdditionalRestriction}
                }
                ${textSearchPart ? 'ORDER BY DESC(?relevance)' : ''}
                LIMIT ${params.limit} OFFSET ${params.offset}
            }
            ${resolveTemplate(this.settings.filterElementInfoPattern, { dataLabelProperty })}
            ${blankNodes ? BlankNodes.BLANK_NODE_QUERY : ''}
        } ${textSearchPart ? 'ORDER BY DESC(?score)' : ''}
        `;
        return this.executeSparqlQuery(query)
            .then(result => {
            if (this.options.acceptBlankNodes) {
                return BlankNodes.updateFilterResults(result, blankQuery => this.executeSparqlQuery(blankQuery), this.settings);
            }
            return result;
        }).then(responseHandler_1.getFilteredData);
    }
    executeSparqlQuery(query) {
        const method = this.options.queryMethod ? this.options.queryMethod : SparqlQueryMethod.GET;
        return executeSparqlQuery(this.options.endpointUrl, query, method, this.options.queryFunction);
    }
    concatWithBlankNodeResponse(response, blankNodeResponse) {
        if (!this.options.acceptBlankNodes) {
            return response;
        }
        return {
            head: { vars: response.head.vars },
            results: {
                bindings: blankNodeResponse.results.bindings.concat(response.results.bindings)
            },
        };
    }
    executeSparqlConstruct(query) {
        const method = this.options.queryMethod ? this.options.queryMethod : SparqlQueryMethod.GET;
        return executeSparqlConstruct(this.options.endpointUrl, query, method, this.options.queryFunction);
    }
    createRefQueryPart(params) {
        const { elementId, linkId, direction } = params;
        const refElementIRI = escapeIri(params.elementId);
        // If no link configuration is passed, use rdf predicates as links
        if (this.settings.linkConfigurations.length === 0) {
            const linkPattern = linkId ? escapeIri(params.linkId) : '?link';
            const blankFilter = this.options.acceptBlankNodes
                ? 'FILTER(isIri(?inst) || isBlank(?inst))'
                : 'FILTER(isIri(?inst))';
            // link to element with specified link type
            // if direction is not specified, provide both patterns and union them
            // FILTER ISIRI is used to prevent blank nodes appearing in results
            let part = '';
            if (params.direction !== 'in') {
                part += `{ ${refElementIRI} ${linkPattern} ?inst . ${blankFilter} }`;
            }
            if (!params.direction) {
                part += ' UNION ';
            }
            if (params.direction !== 'out') {
                part += `{ ?inst ${linkPattern} ${refElementIRI} . ${blankFilter} }`;
            }
            if (this.settings.filterRefElementLinkPattern.length && !linkId) {
                part += `\n${this.settings.filterRefElementLinkPattern}`;
            }
            return part;
        }
        else {
            // use link configuration in filter. If you need more or somehow mix it with rdf predicates, override
            // this function and provide nessesary sparql for this.
            const linkConfigurations = this.formatLinkElements(params.elementId, params.linkId, params.direction);
            return linkConfigurations;
        }
    }
    formatLinkTypesOf(elementIri) {
        const elementIriConst = escapeIri(elementIri);
        return this.settings.linkConfigurations.map(linkConfig => {
            const links = [];
            links.push(`{ ${this.formatLinkPath(linkConfig.path, elementIriConst, '?outObject')}
                BIND(<${linkConfig.id}> as ?link )
            }`);
            links.push(`{ ${this.formatLinkPath(linkConfig.path, '?inObject', elementIriConst)}
                BIND(<${linkConfig.id}> as ?link )
            }`);
            if (linkConfig.inverseId) {
                links.push(`{ ${this.formatLinkPath(linkConfig.path, elementIriConst, '?inObject')}
                BIND(<${linkConfig.inverseId}> as ?link )
            }`);
                links.push(`{ ${this.formatLinkPath(linkConfig.path, '?outObject', elementIriConst)}
                BIND(<${linkConfig.inverseId}> as ?link )
            }`);
            }
            return links;
        }).map(links => links.join(`
            UNION
            `)).join(`
            UNION
            `);
    }
    formatLinkTypesStatistics(elementIri, linkIri) {
        const elementIriConst = escapeIri(elementIri);
        const links = [];
        this.settings.linkConfigurations.filter(link => link.id === linkIri).forEach(link => {
            links.push(`{ ${this.formatLinkPath(link.path, elementIriConst, '?outObject')}
                BIND(<${linkIri}> as ?link)
            }`);
            links.push(`{ ${this.formatLinkPath(link.path, '?inObject', elementIriConst)}
                BIND(<${linkIri}> as ?link)
            }`);
        });
        this.settings.linkConfigurations.filter(link => link.inverseId === linkIri).forEach(link => {
            links.push(`{ ${this.formatLinkPath(link.path, elementIriConst, '?inObject')}
                BIND(<${linkIri}> as ?link)
            }`);
            links.push(`{ ${this.formatLinkPath(link.path, '?outObject', elementIriConst)}
                BIND(<${linkIri}> as ?link)
            }`);
        });
        return links.join(` \n UNION \n `);
    }
    formatLinkElements(refElementIri, linkIri, direction) {
        const { linkConfigurations } = this.settings;
        const elementIriConst = `<${refElementIri}>`;
        let parts = [];
        if (!linkIri) {
            if (!direction || direction === 'out') {
                parts = parts.concat(linkConfigurations.map(link => `{ ${this.formatLinkPath(link.path, elementIriConst, '?inst')} }`));
            }
            if (!direction || direction === 'in') {
                parts = parts.concat(linkConfigurations.map(link => `{ ${this.formatLinkPath(link.path, '?inst', elementIriConst)} }`));
            }
        }
        else {
            const outLinks = linkConfigurations.filter(link => link.id === linkIri);
            const inLinks = linkConfigurations.filter(link => link.inverseId === linkIri);
            if (!direction || direction === 'out') {
                parts = parts.concat(outLinks.map(link => `{ ${this.formatLinkPath(link.path, elementIriConst, '?inst')} }`), inLinks.map(link => `{ ${this.formatLinkPath(link.path, '?inst', elementIriConst)} }`));
            }
            if (!direction || direction === 'in') {
                parts = parts.concat(inLinks.map(link => `{ ${this.formatLinkPath(link.path, elementIriConst, '?inst')} }`), outLinks.map(link => `{ ${this.formatLinkPath(link.path, '?inst', elementIriConst)} }`));
            }
        }
        return parts.join(` \n UNION \n `);
    }
    formatLinkLinks() {
        return this.settings.linkConfigurations.map(linkConfig => `{ ${this.formatLinkPath(linkConfig.path, '?source', '?target')}
                BIND(<${linkConfig.id}> as ?type )
               ${linkConfig.properties ? this.formatLinkPath(linkConfig.properties, '?source', '?target') : ''}
            }`).join(`
            UNION
            `);
    }
    formatLinkPath(path, source, target) {
        return path.replace(/\$source/g, source).replace(/\$target/g, target);
    }
    formatPropertyInfo() {
        return this.settings.propertyConfigurations.map(propConfig => `{ ${this.formatPropertyPath(propConfig.path, '?inst', '?propValue')}
                BIND(<${propConfig.id}> as ?propType )
            }`).join(`
            UNION
            `);
    }
    formatPropertyPath(path, subject, value) {
        return path.replace(/\$subject/g, subject).replace(/\$value/g, value);
    }
}
exports.SparqlDataProvider = SparqlDataProvider;
function resolveTemplate(template, values) {
    let result = template;
    for (const replaceKey in values) {
        if (!values.hasOwnProperty(replaceKey)) {
            continue;
        }
        const replaceValue = values[replaceKey];
        result = result.replace(new RegExp('\\${' + replaceKey + '}', 'g'), replaceValue);
    }
    return result;
}
function executeSparqlQuery(endpoint, query, method, queryFunction) {
    let internalQuery;
    if (method === SparqlQueryMethod.GET) {
        internalQuery = queryFunction({
            url: appendQueryParams(endpoint, { query }),
            headers: {
                'Accept': 'application/sparql-results+json',
            },
            method: 'GET',
        });
    }
    else {
        internalQuery = queryFunction({
            url: endpoint,
            body: query,
            headers: {
                'Accept': 'application/sparql-results+json',
                'Content-Type': 'application/sparql-query; charset=UTF-8',
            },
            method: 'POST',
        });
    }
    return internalQuery.then((response) => {
        if (response.ok) {
            return response.json();
        }
        else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}
exports.executeSparqlQuery = executeSparqlQuery;
function executeSparqlConstruct(endpoint, query, method, queryFunction) {
    let internalQuery;
    if (method === SparqlQueryMethod.GET) {
        internalQuery = queryFunction({
            url: appendQueryParams(endpoint, { query }),
            headers: {
                'Accept': 'text/turtle',
            },
            method: 'GET',
        });
    }
    else {
        internalQuery = queryFunction({
            url: endpoint,
            body: query,
            headers: {
                'Accept': 'text/turtle',
                'Content-Type': 'application/sparql-query; charset=UTF-8',
            },
            method: 'POST',
        });
    }
    return internalQuery.then(response => {
        if (response.ok) {
            return response.text();
        }
        else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }).then(turtle_1.parseTurtleText);
}
exports.executeSparqlConstruct = executeSparqlConstruct;
function appendQueryParams(endpoint, queryParams = {}) {
    const initialSeparator = endpoint.indexOf('?') < 0 ? '?' : '&';
    const additionalParams = initialSeparator + Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
    return endpoint + additionalParams;
}
function queryInternal(params) {
    return fetch(params.url, {
        method: params.method,
        body: params.body,
        credentials: 'same-origin',
        mode: 'cors',
        cache: 'default',
        headers: params.headers,
    });
}
function sparqlExtractLabel(subject, label) {
    return `
        BIND ( str( ${subject} ) as ?uriStr)
        BIND ( strafter(?uriStr, "#") as ?label3)
        BIND ( strafter(strafter(?uriStr, "//"), "/") as ?label6)
        BIND ( strafter(?label6, "/") as ?label5)
        BIND ( strafter(?label5, "/") as ?label4)
        BIND (if (?label3 != "", ?label3,
            if (?label4 != "", ?label4,
            if (?label5 != "", ?label5, ?label6))) as ${label})
    `;
}
function escapeIri(iri) {
    if (typeof iri !== 'string') {
        throw new Error(`Cannot escape IRI of type "${typeof iri}"`);
    }
    return `<${iri}>`;
}


/***/ }),
/* 101 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLinkTypeInfo = exports.getLinkInfo = exports.emptyElementInfo = exports.getLinkCount = exports.getPropertyModel = exports.getInstCount = exports.getLocalizedString = exports.enrichElement = exports.getFilteredData = exports.getLinkStatistics = exports.getLinksTypeIds = exports.getLinksTypesOf = exports.getLinksInfo = exports.getEnrichedElementsInfo = exports.getElementsInfo = exports.triplesToElementBinding = exports.getLinkTypes = exports.getPropertyInfo = exports.getClassInfo = exports.getClassTree = void 0;
const tslib_1 = __webpack_require__(1);
const sparqlModels_1 = __webpack_require__(80);
const model_1 = __webpack_require__(48);
const _ = tslib_1.__importStar(__webpack_require__(67));
const LABEL_URI = 'http://www.w3.org/2000/01/rdf-schema#label';
const RDF_TYPE_URI = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';
function getClassTree(response) {
    const treeNodes = createClassMap(response.results.bindings);
    const allNodes = [];
    // createClassMap ensures we get both elements and parents and we can use treeNodes[treeNode.parent] safely
    treeNodes.forEach(node => {
        allNodes.push(node);
        node.parents.forEach(parent => {
            treeNodes.get(parent).children.push(node);
        });
        node.parents = undefined;
    });
    const withoutCycles = breakCyclesAndCalculateCounts(allNodes);
    const leafs = new Set();
    for (const node of withoutCycles) {
        for (const child of node.children) {
            leafs.add(child.id);
        }
    }
    const tree = withoutCycles.filter(node => !leafs.has(node.id));
    return tree;
}
exports.getClassTree = getClassTree;
function createClassMap(bindings) {
    const treeNodes = new Map();
    for (const binding of bindings) {
        if (!sparqlModels_1.isRdfIri(binding.class)) {
            continue;
        }
        const classIri = binding.class.value;
        let node = treeNodes.get(classIri);
        if (!node) {
            node = createEmptyModel(classIri);
            treeNodes.set(classIri, node);
        }
        if (binding.label) {
            appendLabel(node.label, getLocalizedString(binding.label));
        }
        if (binding.parent) {
            const parentIri = binding.parent.value;
            node.parents.add(parentIri);
        }
        if (binding.instcount) {
            node.count = getInstCount(binding.instcount);
        }
    }
    // ensuring parent will always be there
    for (const binding of bindings) {
        if (binding.parent) {
            const parentIri = binding.parent.value;
            if (!treeNodes.has(parentIri)) {
                treeNodes.set(parentIri, createEmptyModel(parentIri));
            }
        }
    }
    function createEmptyModel(iri) {
        return {
            id: iri,
            children: [],
            label: { values: [] },
            count: undefined,
            parents: new Set(),
        };
    }
    return treeNodes;
}
function breakCyclesAndCalculateCounts(tree) {
    const visiting = new Set();
    function reduceChildren(acc, node) {
        if (visiting.has(node.id)) {
            // prevent unbounded recursion
            return acc;
        }
        // no more to count
        if (!node.children) {
            return;
        }
        // ensure all children have their counts completed;
        visiting.add(node.id);
        node.children = node.children.reduce(reduceChildren, []);
        visiting.delete(node.id);
        // we have to preserve no data here. If nor element nor childs have no count information,
        // we just pass undefined upwards.
        let childCount;
        node.children.forEach(({ count }) => {
            if (count === undefined) {
                return;
            }
            childCount = childCount === undefined ? count : childCount + count;
        });
        if (childCount !== undefined) {
            node.count = node.count === undefined ? childCount : node.count + childCount;
        }
        acc.push(node);
        return acc;
    }
    return tree.reduce(reduceChildren, []);
}
function getClassInfo(response) {
    const classes = {};
    for (const binding of response.results.bindings) {
        if (!binding.class) {
            continue;
        }
        const id = binding.class.value;
        const model = classes[id];
        if (model) {
            appendLabel(model.label, getLocalizedString(binding.label));
            const instanceCount = getInstCount(binding.instcount);
            if (instanceCount !== undefined) {
                model.count = Math.max(model.count, instanceCount);
            }
        }
        else {
            const label = getLocalizedString(binding.label);
            classes[id] = {
                id,
                children: [],
                label: { values: label ? [label] : [] },
                count: getInstCount(binding.instcount),
            };
        }
    }
    const classesList = [];
    for (const id in classes) {
        if (!classes.hasOwnProperty(id)) {
            continue;
        }
        const model = classes[id];
        classesList.push(model);
    }
    return classesList;
}
exports.getClassInfo = getClassInfo;
function getPropertyInfo(response) {
    const models = {};
    for (const sProperty of response.results.bindings) {
        const sPropertyTypeId = sProperty.prop.value;
        if (models[sPropertyTypeId]) {
            if (sProperty.label) {
                const label = models[sPropertyTypeId].label;
                if (label.values.length === 1 && !label.values[0].lang) {
                    label.values = [];
                }
                label.values.push(getLocalizedString(sProperty.label));
            }
        }
        else {
            models[sPropertyTypeId] = getPropertyModel(sProperty);
        }
    }
    return models;
}
exports.getPropertyInfo = getPropertyInfo;
function getLinkTypes(response) {
    const sInst = response.results.bindings;
    const linkTypes = [];
    const linkTypesMap = {};
    for (const sLink of sInst) {
        const sInstTypeId = sLink.link.value;
        if (linkTypesMap[sInstTypeId]) {
            if (sLink.label) {
                const label = linkTypesMap[sInstTypeId].label;
                if (label.values.length === 1 && !label.values[0].lang) {
                    label.values = [];
                }
                label.values.push(getLocalizedString(sLink.label));
            }
        }
        else {
            linkTypesMap[sInstTypeId] = getLinkTypeInfo(sLink);
            linkTypes.push(linkTypesMap[sInstTypeId]);
        }
    }
    return linkTypes;
}
exports.getLinkTypes = getLinkTypes;
function triplesToElementBinding(tripples) {
    const map = {};
    const convertedResponse = {
        head: {
            vars: ['inst', 'class', 'label', 'blankType', 'propType', 'propValue'],
        },
        results: {
            bindings: [],
        },
    };
    for (const tripple of tripples) {
        const trippleId = tripple.subject.value;
        if (!map[trippleId]) {
            map[trippleId] = createAndPushBinding(tripple);
        }
        if (tripple.predicate.value === LABEL_URI && sparqlModels_1.isRdfLiteral(tripple.object)) { // Label
            if (map[trippleId].label) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].label = tripple.object;
        }
        else if ( // Class
        tripple.predicate.value === RDF_TYPE_URI &&
            sparqlModels_1.isRdfIri(tripple.object) && sparqlModels_1.isRdfIri(tripple.predicate)) {
            if (map[trippleId].class) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].class = tripple.object;
        }
        else if (!sparqlModels_1.isRdfBlank(tripple.object) && sparqlModels_1.isRdfIri(tripple.predicate)) { // Property
            if (map[trippleId].propType) {
                map[trippleId] = createAndPushBinding(tripple);
            }
            map[trippleId].propType = tripple.predicate;
            map[trippleId].propValue = tripple.object;
        }
    }
    function createAndPushBinding(tripple) {
        const binding = {
            inst: tripple.subject,
        };
        convertedResponse.results.bindings.push(binding);
        return binding;
    }
    return convertedResponse;
}
exports.triplesToElementBinding = triplesToElementBinding;
function getElementsInfo(response, ids) {
    const sInstances = response.results.bindings;
    const instancesMap = {};
    for (const sInst of sInstances) {
        const sInstTypeId = sInst.inst.value;
        if (!instancesMap[sInstTypeId]) {
            instancesMap[sInstTypeId] = emptyElementInfo(sInstTypeId);
        }
        enrichElement(instancesMap[sInstTypeId], sInst);
    }
    return instancesMap;
}
exports.getElementsInfo = getElementsInfo;
function getEnrichedElementsInfo(response, elementsInfo) {
    const respElements = response.results.bindings;
    for (const respEl of respElements) {
        const elementInfo = elementsInfo[respEl.inst.value];
        if (elementInfo) {
            elementInfo.image = respEl.image.value;
        }
    }
    return elementsInfo;
}
exports.getEnrichedElementsInfo = getEnrichedElementsInfo;
function getLinksInfo(response) {
    const sparqlLinks = response.results.bindings;
    const linksMap = {};
    for (const sLink of sparqlLinks) {
        const linkKey = `${sLink.source.value} ${sLink.type.value} ${sLink.target.value}`;
        if (linksMap[linkKey]) {
            // this can only happen due to error in sparql or when merging properties
            if (sLink.propType) {
                mergeProperties(linksMap[linkKey].properties, sLink.propType, sLink.propValue);
            }
        }
        else {
            linksMap[linkKey] = getLinkInfo(sLink);
        }
    }
    return _.values(linksMap);
}
exports.getLinksInfo = getLinksInfo;
function getLinksTypesOf(response) {
    const sparqlLinkTypes = response.results.bindings.filter(b => !sparqlModels_1.isRdfBlank(b.link));
    return sparqlLinkTypes.map((sLink) => getLinkCount(sLink));
}
exports.getLinksTypesOf = getLinksTypesOf;
function getLinksTypeIds(response) {
    const sparqlLinkTypes = response.results.bindings.filter(b => !sparqlModels_1.isRdfBlank(b.link));
    return sparqlLinkTypes.map((sLink) => sLink.link.value);
}
exports.getLinksTypeIds = getLinksTypeIds;
function getLinkStatistics(response) {
    const sparqlLinkCount = response.results.bindings.filter(b => !sparqlModels_1.isRdfBlank(b.link))[0];
    return getLinkCount(sparqlLinkCount);
}
exports.getLinkStatistics = getLinkStatistics;
function getFilteredData(response) {
    const sInstances = response.results.bindings;
    const instancesMap = {};
    for (const sInst of sInstances) {
        if (!sparqlModels_1.isRdfIri(sInst.inst) && !sparqlModels_1.isRdfBlank(sInst.inst)) {
            continue;
        }
        const iri = sInst.inst.value;
        if (!instancesMap[iri]) {
            instancesMap[iri] = emptyElementInfo(iri);
        }
        enrichElement(instancesMap[iri], sInst);
    }
    return instancesMap;
}
exports.getFilteredData = getFilteredData;
/**
 * Modifies properties with merging with new values, couls be new peroperty or new value for existing properties.
 * @param properties
 * @param propType
 * @param propValue
 */
function mergeProperties(properties, propType, propValue) {
    let property = properties[propType.value];
    if (sparqlModels_1.isRdfIri(propValue)) {
        if (!property) {
            property = { type: 'uri', values: [] };
        }
        if (model_1.isIriProperty(property) && property.values.every(({ value }) => value !== propValue.value)) {
            property.values = [...property.values, propValue];
        }
    }
    else if (sparqlModels_1.isRdfLiteral(propValue)) {
        if (!property) {
            property = { type: 'string', values: [] };
        }
        const propertyValue = getLocalizedString(propValue);
        if (model_1.isLiteralProperty(property) && property.values.every(value => !isLocalizedEqual(value, propertyValue))) {
            property.values = [...property.values, propertyValue];
        }
    }
    properties[propType.value] = property;
}
function enrichElement(element, sInst) {
    if (!element) {
        return;
    }
    if (sInst.label) {
        const label = getLocalizedString(sInst.label);
        const currentLabels = element.label.values;
        if (element.label.values.every(value => !isLocalizedEqual(value, label))) {
            element.label.values.push(label);
        }
    }
    if (sInst.class && element.types.indexOf(sInst.class.value) < 0) {
        element.types.push(sInst.class.value);
    }
    if (sInst.propType && sInst.propType.value !== LABEL_URI) {
        mergeProperties(element.properties, sInst.propType, sInst.propValue);
    }
}
exports.enrichElement = enrichElement;
function appendLabel(container, newLabel) {
    if (!newLabel) {
        return;
    }
    for (const existing of container.values) {
        if (isLocalizedEqual(existing, newLabel)) {
            return;
        }
    }
    container.values.push(newLabel);
}
function isLocalizedEqual(left, right) {
    return left.lang === right.lang && left.text === right.text;
}
function getLocalizedString(label) {
    if (label) {
        return {
            text: label.value,
            lang: label['xml:lang'],
            datatype: label.datatype,
        };
    }
    else {
        return undefined;
    }
}
exports.getLocalizedString = getLocalizedString;
function getInstCount(instcount) {
    return (instcount ? +instcount.value : undefined);
}
exports.getInstCount = getInstCount;
function getPropertyModel(node) {
    const label = getLocalizedString(node.label);
    return {
        id: node.prop.value,
        label: { values: label ? [label] : [] },
    };
}
exports.getPropertyModel = getPropertyModel;
function getLinkCount(sLinkType) {
    return {
        id: sLinkType.link.value,
        inCount: getInstCount(sLinkType.inCount),
        outCount: getInstCount(sLinkType.outCount),
    };
}
exports.getLinkCount = getLinkCount;
function emptyElementInfo(id) {
    const elementInfo = {
        id: id,
        label: { values: [] },
        types: [],
        properties: {},
    };
    return elementInfo;
}
exports.emptyElementInfo = emptyElementInfo;
function getLinkInfo(sLinkInfo) {
    if (!sLinkInfo) {
        return undefined;
    }
    const linkModel = {
        linkTypeId: sLinkInfo.type.value,
        sourceId: sLinkInfo.source.value,
        targetId: sLinkInfo.target.value,
        properties: {},
    };
    if (sLinkInfo.propType && sLinkInfo.propValue) {
        linkModel.properties[sLinkInfo.propType.value] = {
            type: 'string',
            values: [getLocalizedString(sLinkInfo.propValue)],
        };
    }
    return linkModel;
}
exports.getLinkInfo = getLinkInfo;
function getLinkTypeInfo(sLinkInfo) {
    if (!sLinkInfo) {
        return undefined;
    }
    const label = getLocalizedString(sLinkInfo.label);
    return {
        id: sLinkInfo.link.value,
        label: { values: label ? [label] : [] },
        count: getInstCount(sLinkInfo.instcount),
    };
}
exports.getLinkTypeInfo = getLinkTypeInfo;


/***/ }),
/* 102 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DBPediaSettings = exports.OWLStatsSettings = exports.OWLRDFSSettings = exports.OWLRDFSSettingsOverride = exports.WikidataSettings = exports.RDFSettings = void 0;
exports.RDFSettings = {
    linkConfigurations: [],
    propertyConfigurations: [],
    linksInfoQuery: `SELECT ?source ?type ?target
            WHERE {
                ?source ?type ?target.
                VALUES (?source) {\${ids}}
                VALUES (?target) {\${ids}}
            }`,
    defaultPrefix: '',
    schemaLabelProperty: 'rdfs:label',
    dataLabelProperty: 'rdfs:label',
    fullTextSearch: {
        prefix: '',
        queryPattern: ``,
    },
    classTreeQuery: ``,
    linkTypesPattern: ``,
    elementInfoQuery: ``,
    imageQueryPattern: ``,
    linkTypesOfQuery: ``,
    linkTypesStatisticsQuery: ``,
    filterRefElementLinkPattern: '',
    filterTypePattern: ``,
    filterAdditionalRestriction: ``,
    filterElementInfoPattern: ``,
};
const WikidataSettingsOverride = {
    defaultPrefix: `PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
 PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
 PREFIX wdt: <http://www.wikidata.org/prop/direct/>
 PREFIX wd: <http://www.wikidata.org/entity/>
 PREFIX owl:  <http://www.w3.org/2002/07/owl#>

`,
    schemaLabelProperty: 'rdfs:label',
    dataLabelProperty: 'rdfs:label',
    fullTextSearch: {
        prefix: 'PREFIX bds: <http://www.bigdata.com/rdf/search#>' + '\n',
        queryPattern: `
              ?inst rdfs:label ?searchLabel.
              SERVICE bds:search {
                     ?searchLabel bds:search "\${text}*" ;
                                  bds:minRelevance '0.5' ;
                                  bds:matchAllTerms 'true' .
              }
              BIND(IF(STRLEN(?strInst) > 33,
                            0-<http://www.w3.org/2001/XMLSchema#integer>(SUBSTR(?strInst, 33)),
                            -10000) as ?score)
            `,
    },
    classTreeQuery: `
            SELECT distinct ?class ?label ?parent WHERE {
              ?class rdfs:label ?label.
              { ?class wdt:P279 wd:Q35120. }
                UNION
              { ?parent wdt:P279 wd:Q35120.
                ?class wdt:P279 ?parent. }
                UNION
              { ?parent wdt:P279/wdt:P279 wd:Q35120.
                ?class wdt:P279 ?parent. }
            }
        `,
    // todo: think more, maybe add a limit here?
    linkTypesPattern: `?link wdt:P279* wd:Q18616576.
    BIND(0 as ?instcount)
`,
    elementInfoQuery: `
        CONSTRUCT {
            ?inst rdf:type ?class .
            ?inst rdfs:label ?label .
            ?inst ?propType ?propValue.
        } WHERE {
            VALUES (?inst) {\${ids}}
            OPTIONAL {
                ?inst wdt:P31 ?class .
            }
            OPTIONAL {?inst rdfs:label ?label}
            OPTIONAL {
                ?inst ?propType ?propValue .
                FILTER (isLiteral(?propValue))
            }
        }
    `,
    imageQueryPattern: ` { ?inst ?linkType ?fullImage } union { ?inst wdt:P163/wdt:P18 ?fullImage }
                BIND(CONCAT("https://commons.wikimedia.org/w/thumb.php?f=",
                    STRAFTER(STR(?fullImage), "Special:FilePath/"), "&w=200") AS ?image)`,
    linkTypesOfQuery: `
        SELECT DISTINCT ?link
        WHERE {
            {
                \${elementIri} ?link ?outObject
            } UNION {
                ?inObject ?link \${elementIri}
            }
            ?claim <http://wikiba.se/ontology#directClaim> ?link .
        }
    `,
    linkTypesStatisticsQuery: `
        SELECT (\${linkId} as ?link) (COUNT(?outObject) AS ?outCount) (COUNT(?inObject) AS ?inCount)
        WHERE {
            {
                {
                    SELECT DISTINCT ?outObject WHERE {
                        \${elementIri} \${linkId} ?outObject.
                        FILTER(ISIRI(?outObject))
                        ?outObject ?someprop ?someobj.
                    }
                    LIMIT 101
                }
            } UNION {
                {
                    SELECT DISTINCT ?inObject WHERE {
                        ?inObject \${linkId} \${elementIri}.
                        FILTER(ISIRI(?inObject))
                        ?inObject ?someprop ?someobj.
                    }
                    LIMIT 101
                }
            }
        }
    `,
    filterRefElementLinkPattern: '?claim <http://wikiba.se/ontology#directClaim> ?link .',
    filterTypePattern: `?inst wdt:P31 ?instType. ?instType wdt:P279* \${elementTypeIri} . ${'\n'}`,
    filterAdditionalRestriction: `FILTER ISIRI(?inst)
                        BIND(STR(?inst) as ?strInst)
                        FILTER exists {?inst ?someprop ?someobj}
`,
    filterElementInfoPattern: `OPTIONAL {?inst wdt:P31 ?foundClass}
                BIND (coalesce(?foundClass, owl:Thing) as ?class)
                OPTIONAL {?inst rdfs:label ?label}
`,
};
exports.WikidataSettings = Object.assign(Object.assign({}, exports.RDFSettings), WikidataSettingsOverride);
exports.OWLRDFSSettingsOverride = {
    defaultPrefix: `PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
 PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
 PREFIX owl:  <http://www.w3.org/2002/07/owl#>
`,
    schemaLabelProperty: 'rdfs:label',
    dataLabelProperty: 'rdfs:label',
    fullTextSearch: {
        prefix: '',
        queryPattern: ` OPTIONAL {?inst \${dataLabelProperty} ?search1}
        FILTER regex(COALESCE(str(?search1), str(?extractedLabel)), "\${text}", "i")
        BIND(0 as ?score)
`,
        extractLabel: true,
    },
    classTreeQuery: `
            SELECT ?class ?label ?parent
            WHERE {
                {
                    ?class a rdfs:Class
                } UNION {
                    ?class a owl:Class
                }
                FILTER ISIRI(?class)
                OPTIONAL {?class rdfs:label ?label}
                OPTIONAL {?class rdfs:subClassOf ?parent. FILTER ISIRI(?parent)}
            }
        `,
    // todo: think more, maybe add a limit here?
    linkTypesPattern: `{	?link a rdf:Property
                    } UNION {
                    ?link a owl:ObjectProperty
                }
                BIND('' as ?instcount)
    `,
    elementInfoQuery: `
        CONSTRUCT {
            ?inst rdf:type ?class .
            ?inst rdfs:label ?label .
            ?inst ?propType ?propValue.
        } WHERE {
            VALUES (?inst) {\${ids}}
            OPTIONAL {?inst rdf:type ?class . }
            OPTIONAL {?inst \${dataLabelProperty} ?label}
            OPTIONAL {?inst ?propType ?propValue.
            FILTER (isLiteral(?propValue)) }
        }
    `,
    imageQueryPattern: `{ ?inst ?linkType ?image } UNION { [] ?linkType ?inst. BIND(?inst as ?image) }`,
    linkTypesOfQuery: `
        SELECT DISTINCT ?link
        WHERE {
            { \${elementIri} ?link ?outObject }
            UNION
            { ?inObject ?link \${elementIri} }
        }
    `,
    linkTypesStatisticsQuery: `
        SELECT ?link ?outCount ?inCount
        WHERE {
            {
                SELECT (\${linkId} as ?link) (count(?outObject) as ?outCount) WHERE {
                    \${elementIri} \${linkId} ?outObject.
                    \${navigateElementFilterOut}
                } LIMIT 101
            } {
                SELECT (\${linkId} as ?link) (count(?inObject) as ?inCount) WHERE {
                    ?inObject \${linkId} \${elementIri}.
                    \${navigateElementFilterIn}
                } LIMIT 101
            }
        }
    `,
    filterRefElementLinkPattern: '',
    filterTypePattern: `?inst rdf:type \${elementTypeIri} . ${'\n'}`,
    filterElementInfoPattern: `OPTIONAL {?inst rdf:type ?foundClass}
                BIND (coalesce(?foundClass, owl:Thing) as ?class)
                OPTIONAL {?inst \${dataLabelProperty} ?label}`,
    filterAdditionalRestriction: '',
};
exports.OWLRDFSSettings = Object.assign(Object.assign({}, exports.RDFSettings), exports.OWLRDFSSettingsOverride);
const OWLStatsOverride = {
    classTreeQuery: `
        SELECT ?class ?instcount ?label ?parent
        WHERE {
            {SELECT ?class (count(?inst) as ?instcount)
                WHERE {
                    ?inst rdf:type ?class.
                    FILTER ISIRI(?class)
                } GROUP BY ?class } UNION
            {
                ?class rdf:type rdfs:Class
            } UNION {
                ?class rdf:type owl:Class
            }
            OPTIONAL {?class rdfs:label ?label}
            OPTIONAL {?class rdfs:subClassOf ?parent. FILTER ISIRI(?parent)}
        }
    `,
};
exports.OWLStatsSettings = Object.assign(Object.assign({}, exports.OWLRDFSSettings), OWLStatsOverride);
const DBPediaOverride = {
    fullTextSearch: {
        prefix: 'PREFIX dbo: <http://dbpedia.org/ontology/>\n',
        queryPattern: `
              ?inst rdfs:label ?searchLabel.
              ?searchLabel bif:contains "\${text}".
              ?inst dbo:wikiPageID ?origScore .
              BIND(0-?origScore as ?score)
        `,
    },
    classTreeQuery: `
        SELECT distinct ?class ?label ?parent WHERE {
            ?class rdfs:label ?label.
            OPTIONAL {?class rdfs:subClassOf ?parent}
            ?root rdfs:subClassOf owl:Thing.
            ?class rdfs:subClassOf? | rdfs:subClassOf/rdfs:subClassOf ?root
        }
    `,
    elementInfoQuery: `
        CONSTRUCT {
            ?inst rdf:type ?class .
            ?inst rdfs:label ?label .
            ?inst ?propType ?propValue.
        } WHERE {
            VALUES (?inst) {\${ids}}
            ?inst rdf:type ?class .
            ?inst rdfs:label ?label .
            FILTER (!contains(str(?class), 'http://dbpedia.org/class/yago'))
            OPTIONAL {?inst ?propType ?propValue.
            FILTER (isLiteral(?propValue)) }
        }
    `,
    filterElementInfoPattern: `
        OPTIONAL {?inst rdf:type ?foundClass. FILTER (!contains(str(?foundClass), 'http://dbpedia.org/class/yago'))}
        BIND (coalesce(?foundClass, owl:Thing) as ?class)
        OPTIONAL {?inst \${dataLabelProperty} ?label}`,
    imageQueryPattern: ` { ?inst ?linkType ?fullImage } UNION { [] ?linkType ?inst. BIND(?inst as ?fullImage) }
            BIND(CONCAT("https://commons.wikimedia.org/w/thumb.php?f=",
            STRAFTER(STR(?fullImage), "Special:FilePath/"), "&w=200") AS ?image)
    `,
};
exports.DBPediaSettings = Object.assign(Object.assign({}, exports.OWLRDFSSettings), DBPediaOverride);


/***/ }),
/* 103 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.n3toRdfNode = exports.parseTurtleText = void 0;
const tslib_1 = __webpack_require__(1);
const N3 = tslib_1.__importStar(__webpack_require__(104));
function parseTurtleText(turtleText) {
    return new Promise((resolve, reject) => {
        const triples = [];
        N3.Parser().parse(turtleText, (error, triple, hash) => {
            if (error) {
                reject(error);
            }
            else if (triple) {
                triples.push({
                    subject: n3toRdfNode(triple.subject),
                    predicate: n3toRdfNode(triple.predicate),
                    object: n3toRdfNode(triple.object),
                });
            }
            else {
                resolve(triples);
            }
        });
    });
}
exports.parseTurtleText = parseTurtleText;
function n3toRdfNode(entity) {
    if (N3.Util.isLiteral(entity)) {
        return {
            type: 'literal',
            value: N3.Util.getLiteralValue(entity),
            datatype: N3.Util.getLiteralType(entity),
            'xml:lang': N3.Util.getLiteralLanguage(entity),
        };
    }
    else {
        return { type: 'uri', value: entity };
    }
}
exports.n3toRdfNode = n3toRdfNode;


/***/ }),
/* 104 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__104__;

/***/ }),
/* 105 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CompositeDataProvider = void 0;
const mergeUtils_1 = __webpack_require__(106);
function isDefinition(dp) {
    const definition = dp;
    return definition.name !== undefined && definition.dataProvider !== undefined;
}
class CompositeDataProvider {
    constructor(dataProviders, params) {
        this.mergeMode = 'fetchAll';
        let dpCounter = 1;
        this.dataProviders = dataProviders.map(dp => {
            if (isDefinition(dp)) {
                return dp;
            }
            else {
                return {
                    name: `DataProvider${dpCounter++}`,
                    dataProvider: dp,
                };
            }
        });
        if (params && params.mergeMode) {
            this.mergeMode = params.mergeMode;
        }
    }
    classTree() {
        return this.fetchSequentially('classTree', mergeUtils_1.mergeClassTree, undefined);
    }
    propertyInfo(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('propertyInfo', mergeUtils_1.mergePropertyInfo, params);
        }
        else {
            let propertyIds = params.propertyIds;
            return this.queueProcessResults((previousResult, dp) => {
                propertyIds = propertyIds.filter(id => !previousResult || !previousResult[id]);
                return propertyIds.length > 0 ? dp.dataProvider.propertyInfo({ propertyIds: propertyIds }) : undefined;
            }).then(mergeUtils_1.mergePropertyInfo);
        }
    }
    classInfo(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('classInfo', mergeUtils_1.mergeClassInfo, params);
        }
        else {
            let classIds = params.classIds;
            return this.queueProcessResults((previousResult, dp) => {
                classIds = classIds.filter(id => !previousResult || previousResult.map(cm => cm.id).indexOf(id) === -1);
                return classIds.length > 0 ? dp.dataProvider.classInfo({ classIds: classIds }) : undefined;
            }).then(mergeUtils_1.mergeClassInfo);
        }
    }
    linkTypesInfo(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('linkTypesInfo', mergeUtils_1.mergeLinkTypesInfo, params);
        }
        else {
            let linkTypeIds = params.linkTypeIds;
            return this.queueProcessResults((previousResult, dp) => {
                linkTypeIds = linkTypeIds.filter(id => !previousResult || previousResult.map(lt => lt.id).indexOf(id) === -1);
                return linkTypeIds.length > 0 ? dp.dataProvider.linkTypesInfo({ linkTypeIds: linkTypeIds }) : undefined;
            }).then(mergeUtils_1.mergeLinkTypesInfo);
        }
    }
    linkTypes() {
        return this.fetchSequentially('linkTypes', mergeUtils_1.mergeLinkTypes, undefined);
    }
    elementInfo(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('elementInfo', mergeUtils_1.mergeElementInfo, params);
        }
        else {
            let elementIds = params.elementIds;
            return this.queueProcessResults((previousResult, dp) => {
                elementIds = elementIds.filter(id => !previousResult || !previousResult[id]);
                return elementIds.length > 0 ? dp.dataProvider.elementInfo({ elementIds: elementIds }) : undefined;
            }).then(mergeUtils_1.mergeElementInfo);
        }
    }
    linksInfo(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('linksInfo', mergeUtils_1.mergeLinksInfo, params);
        }
        else {
            let elementIds = params.elementIds;
            return this.queueProcessResults((previousResult, dp) => {
                elementIds = elementIds.filter(id => {
                    if (previousResult) {
                        for (const linkModel of previousResult) {
                            if (linkModel.sourceId === id) {
                                return false;
                            }
                        }
                    }
                    return true;
                });
                return elementIds.length > 0 ?
                    dp.dataProvider.linksInfo({ elementIds: elementIds, linkTypeIds: params.linkTypeIds }) : undefined;
            }).then(mergeUtils_1.mergeLinksInfo);
        }
    }
    linkTypesOf(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('linkTypesOf', mergeUtils_1.mergeLinkTypesOf, params);
        }
        else {
            return this.queueProcessResults((previousResult, dp) => {
                if (!previousResult || previousResult && previousResult.length === 0) {
                    return dp.dataProvider.linkTypesOf(params);
                }
                else {
                    return undefined;
                }
            }).then(mergeUtils_1.mergeLinkTypesOf);
        }
    }
    linkElements(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('linkElements', mergeUtils_1.mergeLinkElements, params);
        }
        else {
            return this.queueProcessResults((previousResult, dp) => {
                if (!previousResult || previousResult && Object.keys(previousResult).length === 0) {
                    return dp.dataProvider.linkElements(params);
                }
                else {
                    return undefined;
                }
            }).then(mergeUtils_1.mergeLinkElements);
        }
    }
    filter(params) {
        if (this.mergeMode === 'fetchAll') {
            return this.fetchSequentially('filter', mergeUtils_1.mergeFilter, params);
        }
        else {
            return this.queueProcessResults((previousResult, dp) => {
                if (!previousResult || previousResult && Object.keys(previousResult).length === 0) {
                    return dp.dataProvider.filter(params);
                }
                else {
                    return undefined;
                }
            }).then(mergeUtils_1.mergeFilter);
        }
    }
    processResults(responsePromise, dpName, useProviderInStats) {
        return responsePromise
            .then(response => ({ dataSourceName: dpName, useInStats: useProviderInStats, response: response }))
            .catch(error => {
            // tslint:disable-next-line:no-console
            console.error(error);
            return { dataSourceName: dpName, useInStats: useProviderInStats, response: undefined };
        });
    }
    queueProcessResults(callBack) {
        let counter = 0;
        const responseList = [];
        const recursiveCall = (result) => {
            if (this.dataProviders.length > counter) {
                // console.log(this.dataProviders);
                const dp = this.dataProviders[counter++];
                const callBackResult = callBack(result, dp);
                if (!callBackResult) {
                    return Promise.resolve(responseList);
                }
                return callBackResult.then(newResult => {
                    responseList.push({
                        dataSourceName: dp.name,
                        response: newResult,
                    });
                    return recursiveCall(newResult);
                }).catch(error => {
                    // tslint:disable-next-line:no-console
                    console.error(error);
                    return recursiveCall(result);
                });
            }
            else {
                return Promise.resolve(responseList);
            }
        };
        return recursiveCall();
    }
    fetchSequentially(functionName, mergeFunction, params) {
        const resultPromises = this.dataProviders.map((dp) => {
            const providerMethod = dp.dataProvider[functionName];
            return this.processResults(providerMethod.call(dp.dataProvider, params), dp.name, dp.useInStats);
        });
        return Promise.all(resultPromises).then(mergeFunction);
    }
}
exports.CompositeDataProvider = CompositeDataProvider;


/***/ }),
/* 106 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeClassModel = exports.mergeCounts = exports.mergeLabels = exports.classTreeToArray = exports.mergeFilter = exports.mergeLinkElements = exports.mergeLinkTypesOf = exports.mergeLinksInfo = exports.mergeProperties = exports.mergeElementInfo = exports.mergeLinkTypes = exports.mergeLinkTypesInfo = exports.mergeClassInfo = exports.mergePropertyInfo = exports.mergeClassTree = void 0;
const DATA_PROVIDER_PROPERTY = 'http://ontodia.org/property/DataProvider';
function mergeClassTree(composite) {
    const lists = composite.filter(r => r.response).map(({ useInStats, response }) => ({ useInStats, classes: classTreeToArray(response) }));
    const dictionary = {};
    const topLevelModels = {};
    const childrenMap = {};
    for (const { useInStats, classes } of lists) {
        for (const model of classes) {
            const childrenIds = childrenMap[model.id] || [];
            model.children.map(ch => ch.id).forEach(id => {
                if (childrenIds.indexOf(id) === -1) {
                    childrenIds.push(id);
                }
            });
            model.children = [];
            if (!useInStats) {
                delete model.count;
            }
            if (!dictionary[model.id]) {
                topLevelModels[model.id] = model;
                dictionary[model.id] = model;
                childrenMap[model.id] = childrenIds;
            }
            else {
                topLevelModels[model.id] = mergeClassModel(dictionary[model.id], model);
                dictionary[model.id] = topLevelModels[model.id];
            }
        }
    }
    const models = Object.keys(dictionary).map(key => dictionary[key]);
    for (const m of models) {
        m.children = (childrenMap[m.id] || []).map(id => {
            delete topLevelModels[id];
            return dictionary[id];
        });
    }
    return Object.keys(topLevelModels).map(key => topLevelModels[key]);
}
exports.mergeClassTree = mergeClassTree;
function mergePropertyInfo(response) {
    const result = {};
    const props = response.filter(r => r.response).map(r => r.response);
    for (const model of props) {
        const keys = Object.keys(model);
        for (const key of keys) {
            const prop = model[key];
            if (!result[key]) {
                result[key] = prop;
            }
            else {
                result[key].label = mergeLabels(result[key].label, prop.label);
            }
        }
    }
    return result;
}
exports.mergePropertyInfo = mergePropertyInfo;
function mergeClassInfo(response) {
    const dictionaries = response.filter(r => r.response).map(r => r.response);
    const dictionary = {};
    for (const models of dictionaries) {
        for (const model of models) {
            if (!dictionary[model.id]) {
                dictionary[model.id] = model;
            }
            else {
                dictionary[model.id] = mergeClassModel(dictionary[model.id], model);
            }
        }
    }
    return Object.keys(dictionary).map(key => dictionary[key]);
}
exports.mergeClassInfo = mergeClassInfo;
function mergeLinkTypesInfo(response) {
    const lists = response.filter(r => r.response).map(r => r.response);
    const mergeLinkType = (a, b) => {
        return {
            id: a.id,
            label: mergeLabels(a.label, b.label),
            count: a.count + b.count,
        };
    };
    const dictionary = {};
    for (const linkTypes of lists) {
        for (const linkType of linkTypes) {
            if (!dictionary[linkType.id]) {
                dictionary[linkType.id] = linkType;
            }
            else {
                dictionary[linkType.id] = mergeLinkType(dictionary[linkType.id], linkType);
            }
        }
    }
    return Object.keys(dictionary).map(key => dictionary[key]);
}
exports.mergeLinkTypesInfo = mergeLinkTypesInfo;
function mergeLinkTypes(response) {
    return mergeLinkTypesInfo(response);
}
exports.mergeLinkTypes = mergeLinkTypes;
function mergeElementInfo(response) {
    const mergeElementModels = (a, b) => {
        const types = a.types;
        for (const t of b.types) {
            if (types.indexOf(t) === -1) {
                types.push(t);
            }
        }
        const sources = [];
        for (const s of a.sources) {
            if (sources.indexOf(s) === -1) {
                sources.push(s);
            }
        }
        for (const s of b.sources) {
            if (sources.indexOf(s) === -1) {
                sources.push(s);
            }
        }
        return {
            id: a.id,
            label: mergeLabels(a.label, b.label),
            types: types,
            image: a.image || b.image,
            properties: mergeProperties(a.properties, b.properties),
            sources: sources,
        };
    };
    const dictionaries = response.filter(r => r.response).map(r => r.response);
    const dictionary = {};
    for (const resp of response) {
        if (!resp.response) {
            continue;
        }
        const list = Object.keys(resp.response).map(k => resp.response[k]);
        for (const em of list) {
            em.sources = [resp.dataSourceName];
            em.properties[DATA_PROVIDER_PROPERTY] = {
                type: 'string', values: [{ text: resp.dataSourceName, lang: '' }],
            };
            if (!dictionary[em.id]) {
                dictionary[em.id] = em;
            }
            else {
                dictionary[em.id] = mergeElementModels(dictionary[em.id], em);
            }
        }
    }
    return dictionary;
}
exports.mergeElementInfo = mergeElementInfo;
function mergeProperties(a, b) {
    const aLists = Object.keys(a);
    const bLists = Object.keys(b);
    const result = {};
    function createIdForProperty(baseId) {
        let counter = 1;
        while (result[baseId + '_' + counter]) {
            counter++;
        }
        return baseId + '_' + counter;
    }
    for (const pKey of aLists) {
        const prop = a[pKey];
        if (!result[pKey]) {
            result[pKey] = prop;
        }
        else {
            result[createIdForProperty(pKey)] = prop;
        }
    }
    for (const pKey of bLists) {
        const prop = b[pKey];
        if (!result[pKey]) {
            result[pKey] = prop;
        }
        else {
            result[createIdForProperty(pKey)] = prop;
        }
    }
    return result;
}
exports.mergeProperties = mergeProperties;
function mergeLinksInfo(response) {
    const lists = response.filter(r => r.response).map(r => r.response);
    const resultInfo = [];
    function compareLinksInfo(a, b) {
        return a.sourceId === b.sourceId &&
            a.targetId === b.targetId &&
            a.linkTypeId === b.linkTypeId;
    }
    for (const linkInfo of lists) {
        for (const linkModel of linkInfo) {
            if (!resultInfo.some(l => compareLinksInfo(l, linkModel))) {
                resultInfo.push(linkModel);
            }
        }
    }
    return resultInfo;
}
exports.mergeLinksInfo = mergeLinksInfo;
function mergeLinkTypesOf(response) {
    const lists = response.filter(r => r.response).map(r => r.response);
    const dictionary = {};
    const merge = (a, b) => {
        return {
            id: a.id,
            inCount: a.inCount + b.inCount,
            outCount: a.outCount + b.outCount,
        };
    };
    for (const linkCount of lists) {
        for (const lCount of linkCount) {
            if (!dictionary[lCount.id]) {
                dictionary[lCount.id] = lCount;
            }
            else {
                dictionary[lCount.id] = merge(lCount, dictionary[lCount.id]);
            }
        }
    }
    return Object.keys(dictionary).map(key => dictionary[key]);
}
exports.mergeLinkTypesOf = mergeLinkTypesOf;
function mergeLinkElements(response) {
    return mergeElementInfo(response);
}
exports.mergeLinkElements = mergeLinkElements;
function mergeFilter(response) {
    return mergeElementInfo(response);
}
exports.mergeFilter = mergeFilter;
function classTreeToArray(models) {
    let resultArray = models;
    function getDescendants(model) {
        let descendants = model.children || [];
        for (const descendant of descendants) {
            const nextGeneration = getDescendants(descendant);
            descendants = descendants.concat(nextGeneration);
        }
        return descendants;
    }
    for (const model of models) {
        const descendants = getDescendants(model);
        resultArray = resultArray.concat(descendants);
    }
    return resultArray;
}
exports.classTreeToArray = classTreeToArray;
function mergeLabels(a, b) {
    function compareLabels(l1, l2) {
        return l1.lang === l2.lang && l1.text === l2.text;
    }
    const mergedValuesList = a.values;
    for (const locStr of b.values) {
        if (!mergedValuesList.some(l => compareLabels(l, locStr))) {
            mergedValuesList.push(locStr);
        }
    }
    return {
        values: mergedValuesList,
    };
}
exports.mergeLabels = mergeLabels;
function mergeCounts(a, b) {
    if (a === undefined && b === undefined) {
        return undefined;
    }
    return (a || 0) + (b || 0);
}
exports.mergeCounts = mergeCounts;
function mergeClassModel(a, b) {
    const childrenDictionary = {};
    for (const child of a.children.concat(b.children)) {
        if (!childrenDictionary[child.id]) {
            childrenDictionary[child.id] = child;
        }
    }
    return {
        id: a.id,
        label: mergeLabels(a.label, b.label),
        count: mergeCounts(a.count, b.count),
        children: Object.keys(childrenDictionary).map(key => childrenDictionary[key]),
    };
}
exports.mergeClassModel = mergeClassModel;


/***/ }),
/* 107 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeLayout = exports.makeGraphItems = exports.GraphBuilder = void 0;
const lodash_1 = __webpack_require__(67);
const schema_1 = __webpack_require__(54);
const serializedDiagram_1 = __webpack_require__(108);
const layout_1 = __webpack_require__(109);
const turtle_1 = __webpack_require__(103);
const GREED_STEP = 150;
class GraphBuilder {
    constructor(dataProvider) {
        this.dataProvider = dataProvider;
    }
    createGraph(graph) {
        return this.dataProvider.elementInfo({ elementIds: graph.elementIds }).then(elementsInfo => ({
            preloadedElements: elementsInfo,
            diagram: makeLayout(graph.elementIds, graph.links),
        }));
    }
    getGraphFromRDFGraph(graph) {
        const { elementIds, links } = makeGraphItems(graph);
        return this.createGraph({ elementIds, links });
    }
    getGraphFromTurtleGraph(graph) {
        return turtle_1.parseTurtleText(graph).then(triples => this.getGraphFromRDFGraph(triples));
    }
}
exports.GraphBuilder = GraphBuilder;
function makeGraphItems(response) {
    const elements = {};
    const links = [];
    for (const { subject, predicate, object } of response) {
        if (subject.type === 'uri' && !elements[subject.value]) {
            elements[subject.value] = true;
        }
        if (object.type === 'uri' && !elements[object.value]) {
            elements[object.value] = true;
        }
        if (subject.type === 'uri' && object.type === 'uri') {
            links.push({
                linkTypeId: predicate.value,
                sourceId: subject.value,
                targetId: object.value,
            });
        }
    }
    return { elementIds: Object.keys(elements), links };
}
exports.makeGraphItems = makeGraphItems;
function makeLayout(elementsIds, linksInfo) {
    const rows = Math.ceil(Math.sqrt(elementsIds.length));
    const grid = layout_1.uniformGrid({ rows, cellSize: { x: GREED_STEP, y: GREED_STEP } });
    const elements = elementsIds.map((id, index) => {
        const { x, y } = grid(index);
        return { '@type': 'Element', '@id': schema_1.GenerateID.forElement(), iri: id, position: { x, y } };
    });
    const layoutElementsMap = lodash_1.keyBy(elements, 'iri');
    const links = [];
    linksInfo.forEach((link, index) => {
        const source = layoutElementsMap[link.sourceId];
        const target = layoutElementsMap[link.targetId];
        if (!source || !target) {
            return;
        }
        links.push({
            '@type': 'Link',
            '@id': schema_1.GenerateID.forLink(),
            property: link.linkTypeId,
            source: { '@id': source['@id'] },
            target: { '@id': target['@id'] },
        });
    });
    return serializedDiagram_1.makeSerializedDiagram({ layoutData: { '@type': 'Layout', elements, links }, linkTypeOptions: [] });
}
exports.makeLayout = makeLayout;


/***/ }),
/* 108 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeLayoutData = exports.makeSerializedDiagram = exports.convertToSerializedDiagram = exports.emptyLayoutData = exports.emptyDiagram = void 0;
const lodash_1 = __webpack_require__(67);
const schema_1 = __webpack_require__(54);
const serializedCellProperties = [
    // common properties
    'id', 'type',
    // element properties
    'size', 'angle', 'isExpanded', 'position', 'iri', 'group',
    // link properties
    'typeId', 'source', 'target', 'vertices',
];
function emptyDiagram() {
    return {
        '@context': schema_1.DIAGRAM_CONTEXT_URL_V1,
        '@type': 'Diagram',
        layoutData: emptyLayoutData(),
        linkTypeOptions: [],
    };
}
exports.emptyDiagram = emptyDiagram;
function emptyLayoutData() {
    return { '@type': 'Layout', elements: [], links: [] };
}
exports.emptyLayoutData = emptyLayoutData;
function convertToSerializedDiagram(params) {
    const elements = [];
    const links = [];
    for (const cell of params.layoutData.cells) {
        // get rid of unused properties
        const newCell = lodash_1.pick(cell, serializedCellProperties);
        // normalize type
        if (newCell.type === 'Ontodia.Element' || newCell.type === 'element') {
            newCell.type = 'Element';
        }
        // normalize type
        if (newCell.type === 'link') {
            newCell.type = 'Link';
        }
        if (!newCell.iri) {
            newCell.iri = newCell.id;
        }
        // rename to @id and @type to match JSON-LD
        newCell['@id'] = newCell.id;
        delete newCell.id;
        newCell['@type'] = newCell.type;
        delete newCell.type;
        // make two separate lists
        switch (newCell['@type']) {
            case 'Element':
                elements.push(newCell);
                break;
            case 'Link':
                // rename internal IDs
                newCell.source['@id'] = newCell.source.id;
                delete newCell.source.id;
                newCell.target['@id'] = newCell.target.id;
                delete newCell.target.id;
                // rename typeID to property
                newCell.property = newCell.typeId;
                delete newCell.typeId;
                links.push(newCell);
                break;
        }
    }
    return Object.assign(Object.assign({}, emptyDiagram()), { layoutData: { '@type': 'Layout', elements, links }, linkTypeOptions: params.linkTypeOptions });
}
exports.convertToSerializedDiagram = convertToSerializedDiagram;
function makeSerializedDiagram(params) {
    const diagram = Object.assign(Object.assign({}, emptyDiagram()), { linkTypeOptions: params.linkTypeOptions });
    // layout data is a complex structure we want to persist
    if (params.layoutData) {
        diagram.layoutData = params.layoutData;
    }
    return diagram;
}
exports.makeSerializedDiagram = makeSerializedDiagram;
function makeLayoutData(modelElements, modelLinks) {
    const elements = modelElements.map((element) => ({
        '@type': 'Element',
        '@id': element.id,
        iri: element.iri,
        position: element.position,
        size: element.size,
        isExpanded: element.isExpanded,
        group: element.group,
        elementState: element.elementState,
    }));
    const links = modelLinks.map((link) => ({
        '@type': 'Link',
        '@id': link.id,
        property: link.typeId,
        source: { '@id': link.sourceId },
        target: { '@id': link.targetId },
        vertices: [...link.vertices],
        linkState: link.linkState,
    }));
    return { '@type': 'Layout', elements, links };
}
exports.makeLayoutData = makeLayoutData;


/***/ }),
/* 109 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getContentFittingBoxForLayout = exports.forceLayout = exports.removeOverlaps = exports.placeElementsAround = exports.calculateAveragePosition = exports.applyLayout = exports.calculateLayout = exports.biasFreePadded = exports.padded = exports.uniformGrid = exports.translateToPositiveQuadrant = exports.groupRemoveOverlaps = exports.groupForceLayout = void 0;
const tslib_1 = __webpack_require__(1);
const cola = tslib_1.__importStar(__webpack_require__(110));
const geometry_1 = __webpack_require__(57);
const events_1 = __webpack_require__(55);
const paperArea_1 = __webpack_require__(83);
function groupForceLayout(params) {
    const layout = new cola.Layout()
        .nodes(params.nodes)
        .links(params.links)
        .avoidOverlaps(params.avoidOvelaps)
        .convergenceThreshold(1e-9)
        .jaccardLinkLengths(params.preferredLinkLength)
        .handleDisconnected(true);
    layout.start(30, 0, 10, undefined, false);
}
exports.groupForceLayout = groupForceLayout;
function groupRemoveOverlaps(nodes) {
    const nodeRectangles = [];
    for (const node of nodes) {
        nodeRectangles.push(new cola.Rectangle(node.x, node.x + node.width, node.y, node.y + node.height));
    }
    cola.removeOverlaps(nodeRectangles);
    for (let i = 0; i < nodeRectangles.length; i++) {
        const node = nodes[i];
        const rectangle = nodeRectangles[i];
        node.x = rectangle.x;
        node.y = rectangle.y;
    }
}
exports.groupRemoveOverlaps = groupRemoveOverlaps;
function translateToPositiveQuadrant(positions, offset) {
    let minX = Infinity, minY = Infinity;
    positions.forEach(position => {
        minX = Math.min(minX, position.x);
        minY = Math.min(minY, position.y);
    });
    const { x, y } = offset;
    positions.forEach((position, key) => {
        positions.set(key, {
            x: position.x - minX + x,
            y: position.y - minY + y,
        });
    });
}
exports.translateToPositiveQuadrant = translateToPositiveQuadrant;
function uniformGrid(params) {
    return cellIndex => {
        const row = Math.floor(cellIndex / params.rows);
        const column = cellIndex - row * params.rows;
        return {
            x: column * params.cellSize.x,
            y: row * params.cellSize.y,
            width: params.cellSize.x,
            height: params.cellSize.y,
        };
    };
}
exports.uniformGrid = uniformGrid;
function padded(nodes, padding, transform) {
    if (padding) {
        for (const node of nodes) {
            node.x -= padding.x;
            node.y -= padding.y;
            node.width += 2 * padding.x;
            node.height += 2 * padding.y;
        }
    }
    transform();
    if (padding) {
        for (const node of nodes) {
            node.x += padding.x;
            node.y += padding.y;
            node.width -= 2 * padding.x;
            node.height -= 2 * padding.y;
        }
    }
}
exports.padded = padded;
function biasFreePadded(nodes, padding, transform) {
    const nodeSizeMap = new Map();
    const possibleCompression = { x: Infinity, y: Infinity };
    for (const node of nodes) {
        nodeSizeMap.set(node.id, { width: node.width, height: node.height });
        const maxSide = Math.max(node.width, node.height);
        const compressionX = node.width ? (maxSide / node.width) : 1;
        const compressionY = node.height ? (maxSide / node.height) : 1;
        possibleCompression.x = Math.min(1 + (compressionX - 1), possibleCompression.x);
        possibleCompression.y = Math.min(1 + (compressionY - 1), possibleCompression.y);
        node.height = maxSide;
        node.width = maxSide;
    }
    padded(nodes, padding, () => transform());
    const fittingBox = getContentFittingBoxForLayout(nodes);
    for (const node of nodes) {
        const size = nodeSizeMap.get(node.id);
        node.x = (node.x - fittingBox.x) / possibleCompression.x + fittingBox.x;
        node.y = (node.y - fittingBox.y) / possibleCompression.y + fittingBox.y;
        node.height = size.height;
        node.width = size.width;
    }
}
exports.biasFreePadded = biasFreePadded;
function calculateLayout(params) {
    const grouping = geometry_1.computeGrouping(params.model.elements);
    const { layoutFunction, model, fixedElements, selectedElements } = params;
    if (selectedElements && selectedElements.size <= 1) {
        return {
            positions: new Map(),
            nestedLayouts: [],
            keepAveragePosition: false,
        };
    }
    return internalRecursion(params.group);
    function internalRecursion(group) {
        const elementsToProcess = group
            ? grouping.get(group)
            : model.elements.filter(el => el.group === undefined);
        const elements = selectedElements
            ? elementsToProcess.filter(el => selectedElements.has(el))
            : elementsToProcess;
        const nestedLayouts = [];
        for (const element of elements) {
            if (grouping.has(element.id)) {
                nestedLayouts.push(internalRecursion(element.id));
            }
        }
        const nodes = [];
        const nodeById = {};
        for (const element of elements) {
            const { x, y, width, height } = geometry_1.boundsOf(element);
            const node = {
                id: element.id,
                x, y, width, height,
                fixed: fixedElements && fixedElements.has(element) ? 1 : 0,
            };
            nodeById[element.id] = node;
            nodes.push(node);
        }
        const links = [];
        for (const link of model.links) {
            if (!model.isSourceAndTargetVisible(link)) {
                continue;
            }
            const source = model.sourceOf(link);
            const target = model.targetOf(link);
            const sourceNode = nodeById[source.id];
            const targetNode = nodeById[target.id];
            if (sourceNode && targetNode) {
                links.push({ source: sourceNode, target: targetNode });
            }
        }
        layoutFunction(nodes, links, group);
        const positions = new Map();
        for (const node of nodes) {
            positions.set(node.id, { x: node.x, y: node.y });
        }
        return {
            positions,
            group,
            nestedLayouts,
            keepAveragePosition: Boolean(selectedElements)
        };
    }
}
exports.calculateLayout = calculateLayout;
function applyLayout(model, layout) {
    const { positions, group, nestedLayouts, keepAveragePosition } = layout;
    const elements = model.elements.filter(({ id }) => positions.has(id));
    for (const nestedLayout of nestedLayouts) {
        applyLayout(model, nestedLayout);
    }
    if (group) {
        const offset = paperArea_1.getContentFittingBox(elements, []);
        translateToPositiveQuadrant(positions, offset);
    }
    const averagePosition = keepAveragePosition ? calculateAveragePosition(elements) : undefined;
    for (const element of elements) {
        element.setPosition(positions.get(element.id));
    }
    if (keepAveragePosition) {
        const newAveragePosition = calculateAveragePosition(elements);
        const averageDiff = {
            x: averagePosition.x - newAveragePosition.x,
            y: averagePosition.y - newAveragePosition.y,
        };
        positions.forEach((position, elementId) => {
            const element = model.getElement(elementId);
            element.setPosition({
                x: position.x + averageDiff.x,
                y: position.y + averageDiff.y,
            });
        });
    }
}
exports.applyLayout = applyLayout;
function calculateAveragePosition(position) {
    let xSum = 0;
    let ySum = 0;
    for (const element of position) {
        xSum += element.position.x + element.size.width / 2;
        ySum += element.position.y + element.size.height / 2;
    }
    return {
        x: xSum / position.length,
        y: ySum / position.length,
    };
}
exports.calculateAveragePosition = calculateAveragePosition;
function placeElementsAround(params) {
    const { model, elements, targetElement, prefferedLinksLength } = params;
    const targetElementBounds = geometry_1.boundsOf(targetElement);
    const targetPosition = {
        x: targetElementBounds.x + targetElementBounds.width / 2,
        y: targetElementBounds.y + targetElementBounds.height / 2,
    };
    let outgoingAngle = 0;
    if (targetElement.links.length > 0) {
        const averageSourcePosition = calculateAveragePosition(targetElement.links.map(link => {
            const linkSource = model.sourceOf(link);
            return linkSource !== targetElement ? linkSource : model.targetOf(link);
        }));
        const vectorDiff = {
            x: targetPosition.x - averageSourcePosition.x, y: targetPosition.y - averageSourcePosition.y,
        };
        if (vectorDiff.x !== 0 || vectorDiff.y !== 0) {
            outgoingAngle = Math.atan2(vectorDiff.y, vectorDiff.x);
        }
    }
    const step = Math.min(Math.PI / elements.length, Math.PI / 6);
    const elementsSteck = [].concat(elements);
    const placeElementFromSteck = (curAngle, element) => {
        if (element) {
            const size = element.size;
            element.setPosition({
                x: targetPosition.x + prefferedLinksLength * Math.cos(curAngle) - size.width / 2,
                y: targetPosition.y + prefferedLinksLength * Math.sin(curAngle) - size.height / 2,
            });
        }
    };
    const isOddLength = elementsSteck.length % 2 === 0;
    if (isOddLength) {
        for (let angle = step / 2; elementsSteck.length > 0; angle += step) {
            placeElementFromSteck(outgoingAngle - angle, elementsSteck.pop());
            placeElementFromSteck(outgoingAngle + angle, elementsSteck.pop());
        }
    }
    else {
        placeElementFromSteck(outgoingAngle, elementsSteck.pop());
        for (let angle = step; elementsSteck.length > 0; angle += step) {
            placeElementFromSteck(outgoingAngle - angle, elementsSteck.pop());
            placeElementFromSteck(outgoingAngle + angle, elementsSteck.pop());
        }
    }
    return new Promise(resolve => {
        const listener = new events_1.EventObserver();
        listener.listen(model.events, 'changeCells', () => {
            listener.stopListening();
            removeOverlaps({
                model,
                padding: { x: 15, y: 15 },
            });
            resolve();
        });
    });
}
exports.placeElementsAround = placeElementsAround;
function removeOverlaps(params) {
    const { padding, model, group, fixedElements, selectedElements } = params;
    return calculateLayout({
        model,
        group,
        fixedElements,
        selectedElements,
        layoutFunction: (nodes) => {
            padded(nodes, padding, () => groupRemoveOverlaps(nodes));
        },
    });
}
exports.removeOverlaps = removeOverlaps;
function forceLayout(params) {
    const { model, group, fixedElements, selectedElements } = params;
    return calculateLayout({
        model,
        group,
        fixedElements,
        selectedElements,
        layoutFunction: (nodes, links) => {
            if (fixedElements && fixedElements.size > 0) {
                biasFreePadded(nodes, { x: 50, y: 50 }, () => groupForceLayout({
                    nodes, links, preferredLinkLength: 200,
                    avoidOvelaps: true,
                }));
            }
            else {
                groupForceLayout({ nodes, links, preferredLinkLength: 200 });
                biasFreePadded(nodes, { x: 50, y: 50 }, () => groupRemoveOverlaps(nodes));
            }
        },
    });
}
exports.forceLayout = forceLayout;
function getContentFittingBoxForLayout(nodes) {
    let minX = Infinity, minY = Infinity;
    let maxX = -Infinity, maxY = -Infinity;
    for (const node of nodes) {
        const { x, y, width, height } = node;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x + width);
        maxY = Math.max(maxY, y + height);
    }
    return {
        x: Number.isFinite(minX) ? minX : 0,
        y: Number.isFinite(minY) ? minY : 0,
        width: Number.isFinite(minX) && Number.isFinite(maxX) ? (maxX - minX) : 0,
        height: Number.isFinite(minY) && Number.isFinite(maxY) ? (maxY - minY) : 0,
    };
}
exports.getContentFittingBoxForLayout = getContentFittingBoxForLayout;


/***/ }),
/* 110 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__110__;

/***/ }),
/* 111 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SparqlGraphBuilder = void 0;
const graphBuilder_1 = __webpack_require__(107);
const DEFAULT_PREFIX = `PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
 PREFIX rdf:  <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
 PREFIX owl:  <http://www.w3.org/2002/07/owl#>` + '\n\n';
class SparqlGraphBuilder {
    constructor(dataProvider) {
        this.dataProvider = dataProvider;
        this.graphBuilder = new graphBuilder_1.GraphBuilder(dataProvider);
    }
    getGraphFromConstruct(constructQuery) {
        const query = DEFAULT_PREFIX + constructQuery;
        return this.dataProvider.executeSparqlConstruct(query)
            .then(graph => this.graphBuilder.getGraphFromRDFGraph(graph));
    }
}
exports.SparqlGraphBuilder = SparqlGraphBuilder;


/***/ }),
/* 112 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.placeholderDataFromIri = exports.DiagramModel = void 0;
const schema_1 = __webpack_require__(54);
const events_1 = __webpack_require__(55);
const elements_1 = __webpack_require__(53);
const graph_1 = __webpack_require__(113);
const history_1 = __webpack_require__(65);
/**
 * Model of diagram.
 */
class DiagramModel {
    constructor(history) {
        this.history = history;
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.graph = new graph_1.Graph();
        this.graphListener = new events_1.EventObserver();
    }
    get elements() { return this.graph.getElements(); }
    get links() { return this.graph.getLinks(); }
    getElement(elementId) {
        return this.graph.getElement(elementId);
    }
    getLinkById(linkId) {
        return this.graph.getLink(linkId);
    }
    linksOfType(linkTypeId) {
        return this.graph.getLinks().filter(link => link.typeId === linkTypeId);
    }
    findLink(linkTypeId, sourceId, targetId) {
        return this.graph.findLink(linkTypeId, sourceId, targetId);
    }
    sourceOf(link) { return this.getElement(link.sourceId); }
    targetOf(link) { return this.getElement(link.targetId); }
    isSourceAndTargetVisible(link) {
        return Boolean(this.sourceOf(link) && this.targetOf(link));
    }
    resetGraph() {
        if (this.graphListener) {
            this.graphListener.stopListening();
            this.graphListener = new events_1.EventObserver();
        }
        this.graph = new graph_1.Graph();
    }
    subscribeGraph() {
        this.graphListener.listen(this.graph.events, 'changeCells', () => {
            this.source.trigger('changeCells', {});
        });
        this.graphListener.listen(this.graph.events, 'elementEvent', e => {
            this.source.trigger('elementEvent', e);
        });
        this.graphListener.listen(this.graph.events, 'linkEvent', e => {
            this.source.trigger('linkEvent', e);
        });
        this.graphListener.listen(this.graph.events, 'linkTypeEvent', e => {
            this.source.trigger('linkTypeEvent', e);
        });
        this.graphListener.listen(this.graph.events, 'classEvent', e => {
            this.source.trigger('classEvent', e);
        });
        this.source.trigger('changeCells', { source: this });
    }
    reorderElements(compare) {
        this.graph.reorderElements(compare);
    }
    createElement(elementIriOrModel, group) {
        const elementIri = typeof elementIriOrModel === 'string'
            ? elementIriOrModel : elementIriOrModel.id;
        const elements = this.elements.filter(el => el.iri === elementIri && el.group === group);
        if (elements.length > 0) {
            // usually there should be only one element
            return elements[0];
        }
        let data = typeof elementIriOrModel === 'string'
            ? placeholderDataFromIri(elementIri)
            : elementIriOrModel;
        data = Object.assign(Object.assign({}, data), { id: data.id });
        const element = new elements_1.Element({ id: schema_1.GenerateID.forElement(), data, group });
        this.history.execute(addElement(this.graph, element, []));
        return element;
    }
    removeElement(elementId) {
        const element = this.getElement(elementId);
        if (element) {
            this.history.execute(removeElement(this.graph, element));
        }
    }
    addLink(link) {
        const { typeId, sourceId, targetId, data } = link;
        if (data && data.linkTypeId !== typeId) {
            throw new Error('linkTypeId must match linkType.id');
        }
        const existingLink = this.findLink(typeId, sourceId, targetId);
        if (existingLink) {
            if (link.data) {
                existingLink.setLayoutOnly(false);
                existingLink.setData(data);
            }
            return existingLink;
        }
        const linkType = this.createLinkType(link.typeId);
        const source = this.getElement(sourceId);
        const target = this.getElement(targetId);
        const shouldBeVisible = linkType.visible && source && target;
        if (!shouldBeVisible) {
            return undefined;
        }
        if (!link.data) {
            link.setData({ linkTypeId: typeId, sourceId: source.iri, targetId: target.iri });
        }
        this.graph.addLink(link);
        return link;
    }
    removeLink(linkId) {
        this.graph.removeLink(linkId);
    }
    getClass(classIri) {
        return this.graph.getClass(classIri);
    }
    createClass(classIri) {
        const existing = this.graph.getClass(classIri);
        if (existing) {
            return existing;
        }
        const classModel = new elements_1.FatClassModel({ id: classIri });
        this.addClass(classModel);
        return classModel;
    }
    addClass(model) {
        this.graph.addClass(model);
    }
    getLinkType(linkTypeIri) {
        return this.graph.getLinkType(linkTypeIri);
    }
    createLinkType(linkTypeIri) {
        const existing = this.graph.getLinkType(linkTypeIri);
        if (existing) {
            return existing;
        }
        const linkType = new elements_1.FatLinkType({ id: linkTypeIri });
        this.graph.addLinkType(linkType);
        return linkType;
    }
    getProperty(propertyTypeIri) {
        return this.graph.getProperty(propertyTypeIri);
    }
    createProperty(propertyIri) {
        const existing = this.graph.getProperty(propertyIri);
        if (existing) {
            return existing;
        }
        const property = new elements_1.RichProperty({ id: propertyIri });
        this.graph.addProperty(property);
        return property;
    }
    triggerChangeGroupContent(group) {
        this.source.trigger('changeGroupContent', { group });
    }
    createTemporaryElement() {
        const target = new elements_1.Element({
            id: schema_1.GenerateID.forElement(),
            data: placeholderDataFromIri(''),
            temporary: true,
        });
        this.graph.addElement(target);
        return target;
    }
}
exports.DiagramModel = DiagramModel;
function placeholderDataFromIri(iri) {
    return {
        id: iri,
        types: [],
        label: { values: [] },
        properties: {},
    };
}
exports.placeholderDataFromIri = placeholderDataFromIri;
function addElement(graph, element, connectedLinks) {
    return history_1.Command.create('Add element', () => {
        graph.addElement(element);
        for (const link of connectedLinks) {
            const existing = graph.getLink(link.id) || graph.findLink(link.typeId, link.sourceId, link.targetId);
            if (!existing) {
                graph.addLink(link);
            }
        }
        return removeElement(graph, element);
    });
}
function removeElement(graph, element) {
    return history_1.Command.create('Remove element', () => {
        const connectedLinks = [...element.links];
        graph.removeElement(element.id);
        return addElement(graph, element, connectedLinks);
    });
}


/***/ }),
/* 113 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Graph = void 0;
const collections_1 = __webpack_require__(56);
const events_1 = __webpack_require__(55);
class Graph {
    constructor() {
        this.source = new events_1.EventSource();
        this.events = this.source;
        this.elements = new collections_1.OrderedMap();
        this.links = new collections_1.OrderedMap();
        this.classesById = new Map();
        this.propertiesById = new Map();
        this.linkTypes = new Map();
        this.onElementEvent = (data, key) => {
            this.source.trigger('elementEvent', { key, data });
        };
        this.onLinkEvent = (data, key) => {
            this.source.trigger('linkEvent', { key, data });
        };
        this.onLinkTypeEvent = (data, key) => {
            this.source.trigger('linkTypeEvent', { key, data });
        };
        this.onClassEvent = (data, key) => {
            this.source.trigger('classEvent', { key, data });
        };
    }
    getElements() { return this.elements.items; }
    getLinks() { return this.links.items; }
    getLink(linkId) {
        return this.links.get(linkId);
    }
    findLink(linkTypeId, sourceId, targetId) {
        const source = this.getElement(sourceId);
        if (!source) {
            return undefined;
        }
        const index = findLinkIndex(source.links, linkTypeId, sourceId, targetId);
        return index >= 0 ? source.links[index] : undefined;
    }
    sourceOf(link) {
        return this.getElement(link.sourceId);
    }
    targetOf(link) {
        return this.getElement(link.targetId);
    }
    reorderElements(compare) {
        this.elements.reorder(compare);
    }
    getElement(elementId) {
        return this.elements.get(elementId);
    }
    addElement(element) {
        if (this.getElement(element.id)) {
            throw new Error(`Link type '${element.id}' already exists.`);
        }
        element.events.onAny(this.onElementEvent);
        this.elements.push(element.id, element);
        this.source.trigger('changeCells', {});
    }
    removeElement(elementId) {
        const element = this.elements.get(elementId);
        if (element) {
            const options = { silent: true };
            // clone links to prevent modifications during iteration
            for (const link of [...element.links]) {
                this.removeLink(link.id, options);
            }
            this.elements.delete(elementId);
            element.events.offAny(this.onElementEvent);
            this.source.trigger('changeCells', {});
        }
    }
    addLink(link) {
        if (this.getLink(link.id)) {
            throw new Error(`Link '${link.id}' already exists.`);
        }
        const linkType = this.getLinkType(link.typeId);
        if (!linkType) {
            throw new Error(`Link type '${link.typeId}' not found.`);
        }
        this.registerLink(link);
    }
    registerLink(link) {
        const { typeId } = link;
        this.sourceOf(link).links.push(link);
        if (link.sourceId !== link.targetId) {
            this.targetOf(link).links.push(link);
        }
        link.events.onAny(this.onLinkEvent);
        this.links.push(link.id, link);
        this.source.trigger('changeCells', {});
    }
    removeLink(linkId, options) {
        const link = this.links.delete(linkId);
        if (link) {
            const { typeId, sourceId, targetId } = link;
            link.events.offAny(this.onLinkEvent);
            this.removeLinkReferences(typeId, sourceId, targetId);
            if (!(options && options.silent)) {
                this.source.trigger('changeCells', {});
            }
        }
    }
    removeLinkReferences(linkTypeId, sourceId, targetId) {
        const source = this.getElement(sourceId);
        if (source) {
            removeLinkFrom(source.links, linkTypeId, sourceId, targetId);
        }
        const target = this.getElement(targetId);
        if (target) {
            removeLinkFrom(target.links, linkTypeId, sourceId, targetId);
        }
    }
    getLinkTypes() {
        const result = [];
        this.linkTypes.forEach(type => result.push(type));
        return result;
    }
    getLinkType(linkTypeId) {
        return this.linkTypes.get(linkTypeId);
    }
    addLinkType(linkType) {
        if (this.getLinkType(linkType.id)) {
            throw new Error(`Link type '${linkType.id}' already exists.`);
        }
        linkType.setIndex(Graph.nextLinkTypeIndex++);
        linkType.events.onAny(this.onLinkTypeEvent);
        this.linkTypes.set(linkType.id, linkType);
    }
    getProperty(propertyId) {
        return this.propertiesById.get(propertyId);
    }
    addProperty(property) {
        if (this.getProperty(property.id)) {
            throw new Error(`Property '${property.id}' already exists.`);
        }
        this.propertiesById.set(property.id, property);
    }
    getClass(classId) {
        return this.classesById.get(classId);
    }
    getClasses() {
        const classes = [];
        this.classesById.forEach(richClass => classes.push(richClass));
        return classes;
    }
    addClass(classModel) {
        if (this.getClass(classModel.id)) {
            throw new Error(`Class '${classModel.id}' already exists.`);
        }
        classModel.events.onAny(this.onClassEvent);
        this.classesById.set(classModel.id, classModel);
    }
}
exports.Graph = Graph;
Graph.nextLinkTypeIndex = 0;
function removeLinkFrom(links, linkTypeId, sourceId, targetId) {
    if (!links) {
        return;
    }
    while (true) {
        const index = findLinkIndex(links, linkTypeId, sourceId, targetId);
        if (index < 0) {
            break;
        }
        links.splice(index, 1);
    }
}
function findLinkIndex(haystack, linkTypeId, sourceId, targetId) {
    for (let i = 0; i < haystack.length; i++) {
        const link = haystack[i];
        if (link.sourceId === sourceId &&
            link.targetId === targetId &&
            link.typeId === linkTypeId) {
            return i;
        }
    }
    return -1;
}


/***/ }),
/* 114 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.restoreLinksBetweenElements = exports.requestElementData = exports.AsyncModel = void 0;
const schema_1 = __webpack_require__(54);
const elements_1 = __webpack_require__(53);
const history_1 = __webpack_require__(65);
const model_1 = __webpack_require__(112);
const dataFetcher_1 = __webpack_require__(115);
const serializedDiagram_1 = __webpack_require__(108);
class AsyncModel extends model_1.DiagramModel {
    constructor(history, groupByProperties) {
        super(history);
        this.groupByProperties = groupByProperties;
        this.linkSettings = {};
        this.onLinkTypeVisibilityChanged = e => {
            if (e.source.visible) {
                if (!e.preventLoading) {
                    this.requestLinksOfType([e.source.id]);
                }
            }
            else {
                for (const link of this.linksOfType(e.source.id)) {
                    this.graph.removeLink(link.id);
                }
            }
        };
    }
    get asyncSource() {
        return this.source;
    }
    get dataProvider() { return this._dataProvider; }
    subscribeGraph() {
        super.subscribeGraph();
        this.graphListener.listen(this.graph.events, 'linkTypeEvent', e => {
            if (e.key === 'changeVisibility') {
                this.onLinkTypeVisibilityChanged(e.data[e.key], e.key);
            }
        });
    }
    setDataProvider(dataProvider) {
        this._dataProvider = dataProvider;
        this.fetcher = new dataFetcher_1.DataFetcher(this.graph, dataProvider);
    }
    createNewDiagram(dataProvider) {
        this.resetGraph();
        this.setDataProvider(dataProvider);
        this.asyncSource.trigger('loadingStart', { source: this });
        return this.dataProvider.linkTypes().then((linkTypes) => {
            const allLinkTypes = this.initLinkTypes(linkTypes);
            return this.loadAndRenderLayout({
                allLinkTypes,
                markLinksAsLayoutOnly: false,
            });
        }).catch(error => {
            // tslint:disable-next-line:no-console
            console.error(error);
            this.asyncSource.trigger('loadingError', { source: this, error });
            return Promise.reject(error);
        });
    }
    importLayout(params) {
        this.resetGraph();
        this.setDataProvider(params.dataProvider);
        this.asyncSource.trigger('loadingStart', { source: this });
        return this.dataProvider.linkTypes().then(linkTypes => {
            const allLinkTypes = this.initLinkTypes(linkTypes);
            const diagram = params.diagram ? params.diagram : serializedDiagram_1.emptyDiagram();
            this.setLinkSettings(diagram.linkTypeOptions);
            const loadingModels = this.loadAndRenderLayout({
                layoutData: diagram.layoutData,
                preloadedElements: params.preloadedElements || {},
                markLinksAsLayoutOnly: params.validateLinks || false,
                allLinkTypes,
                hideUnusedLinkTypes: params.hideUnusedLinkTypes,
            });
            const requestingLinks = params.validateLinks
                ? this.requestLinksOfType() : Promise.resolve();
            return Promise.all([loadingModels, requestingLinks]);
        }).then(() => {
            this.asyncSource.trigger('loadingSuccess', { source: this });
        }).catch(error => {
            // tslint:disable-next-line:no-console
            console.error(error);
            this.asyncSource.trigger('loadingError', { source: this, error });
            return Promise.reject(error);
        });
    }
    exportLayout() {
        const layoutData = serializedDiagram_1.makeLayoutData(this.graph.getElements(), this.graph.getLinks());
        const linkTypeOptions = this.graph.getLinkTypes()
            // do not serialize default link type options
            .filter(linkType => (!linkType.visible || !linkType.showLabel) && linkType.id !== schema_1.PLACEHOLDER_LINK_TYPE)
            .map(({ id, visible, showLabel }) => ({ '@type': 'LinkTypeOptions', property: id, visible, showLabel }));
        return serializedDiagram_1.makeSerializedDiagram({ layoutData, linkTypeOptions });
    }
    initLinkTypes(linkTypes) {
        const types = [];
        for (const { id, label } of linkTypes) {
            const linkType = new elements_1.FatLinkType({ id, label: label.values });
            this.graph.addLinkType(linkType);
            types.push(linkType);
        }
        return types;
    }
    setLinkSettings(settings) {
        if (!settings) {
            return;
        }
        for (const setting of settings) {
            const { visible = true, showLabel = true } = setting;
            const linkTypeId = setting.property;
            this.linkSettings[linkTypeId] = { '@type': 'LinkTypeOptions', property: linkTypeId, visible, showLabel };
            const linkType = this.getLinkType(linkTypeId);
            if (linkType) {
                linkType.setVisibility({ visible, showLabel });
            }
        }
    }
    loadAndRenderLayout(params) {
        const { layoutData = serializedDiagram_1.emptyLayoutData(), preloadedElements = {}, markLinksAsLayoutOnly, hideUnusedLinkTypes, } = params;
        const elementIrisToRequestData = [];
        const usedLinkTypes = {};
        for (const layoutElement of layoutData.elements) {
            const { '@id': id, iri, position, size, isExpanded, group, elementState } = layoutElement;
            const template = preloadedElements[iri];
            const data = template || model_1.placeholderDataFromIri(iri);
            const element = new elements_1.Element({ id, data, position, size, expanded: isExpanded, group, elementState });
            this.graph.addElement(element);
            if (!template) {
                elementIrisToRequestData.push(element.iri);
            }
        }
        for (const layoutLink of layoutData.links) {
            const { '@id': id, property, source, target, vertices, linkState } = layoutLink;
            const linkType = this.createLinkType(property);
            usedLinkTypes[linkType.id] = linkType;
            const link = this.addLink(new elements_1.Link({
                id,
                typeId: linkType.id,
                sourceId: source['@id'],
                targetId: target['@id'],
                vertices,
                linkState,
            }));
            if (link) {
                link.setLayoutOnly(markLinksAsLayoutOnly);
            }
        }
        this.subscribeGraph();
        const requestingModels = this.requestElementData(elementIrisToRequestData);
        if (hideUnusedLinkTypes && params.allLinkTypes) {
            this.hideUnusedLinkTypes(params.allLinkTypes, usedLinkTypes);
        }
        return requestingModels;
    }
    hideUnusedLinkTypes(allTypes, usedTypes) {
        for (const linkType of allTypes) {
            if (!usedTypes[linkType.id]) {
                linkType.setVisibility({
                    visible: false,
                    showLabel: linkType.showLabel,
                });
            }
        }
    }
    requestElementData(elementIris) {
        return this.fetcher.fetchElementData(elementIris);
    }
    requestLinksOfType(linkTypeIds) {
        const linkTypes = linkTypeIds || this.graph.getLinkTypes()
            .filter(type => type.visible)
            .map(type => type.id);
        return this.dataProvider.linksInfo({
            elementIds: this.graph.getElements().map(element => element.iri),
            linkTypeIds: linkTypes,
        }).then(links => this.onLinkInfoLoaded(links));
    }
    createClass(classId) {
        if (this.graph.getClass(classId)) {
            return super.getClass(classId);
        }
        const classModel = super.createClass(classId);
        this.fetcher.fetchClass(classModel);
        return classModel;
    }
    createLinkType(linkTypeId) {
        if (this.graph.getLinkType(linkTypeId)) {
            return super.createLinkType(linkTypeId);
        }
        const linkType = super.createLinkType(linkTypeId);
        const setting = this.linkSettings[linkType.id];
        if (setting) {
            const { visible, showLabel } = setting;
            linkType.setVisibility({ visible, showLabel, preventLoading: true });
        }
        this.fetcher.fetchLinkType(linkType);
        return linkType;
    }
    createProperty(propertyIri) {
        if (this.graph.getProperty(propertyIri)) {
            return super.createProperty(propertyIri);
        }
        const property = super.createProperty(propertyIri);
        this.fetcher.fetchPropertyType(property);
        return property;
    }
    onLinkInfoLoaded(links) {
        let allowToCreate;
        const cancel = () => { allowToCreate = false; };
        for (const linkModel of links) {
            this.createLinkType(linkModel.linkTypeId);
            allowToCreate = true;
            this.asyncSource.trigger('createLoadedLink', { source: this, model: linkModel, cancel });
            if (allowToCreate) {
                this.createLinks(linkModel);
            }
        }
    }
    createLinks(data) {
        const sources = this.graph.getElements().filter(el => el.iri === data.sourceId);
        const targets = this.graph.getElements().filter(el => el.iri === data.targetId);
        const typeId = data.linkTypeId;
        for (const source of sources) {
            for (const target of targets) {
                this.addLink(new elements_1.Link({ typeId, sourceId: source.id, targetId: target.id, data }));
            }
        }
    }
    loadEmbeddedElements(elementIri) {
        const elements = this.groupByProperties.map(groupBy => this.dataProvider.linkElements({
            elementId: elementIri,
            linkId: groupBy.linkType,
            offset: 0,
            direction: groupBy.linkDirection,
        }));
        return Promise.all(elements).then(res => res.reduce((memo, current) => Object.assign(memo, current), {}));
    }
}
exports.AsyncModel = AsyncModel;
function requestElementData(model, elementIris) {
    return history_1.Command.effect('Fetch element data', () => {
        model.requestElementData(elementIris);
    });
}
exports.requestElementData = requestElementData;
function restoreLinksBetweenElements(model) {
    return history_1.Command.effect('Restore links between elements', () => {
        model.requestLinksOfType();
    });
}
exports.restoreLinksBetweenElements = restoreLinksBetweenElements;


/***/ }),
/* 115 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataFetcher = void 0;
const async_1 = __webpack_require__(61);
const collections_1 = __webpack_require__(56);
class DataFetcher {
    constructor(graph, dataProvider) {
        this.graph = graph;
        this.dataProvider = dataProvider;
        this.classQueue = new async_1.BufferingQueue(classIds => {
            this.dataProvider.classInfo({ classIds }).then(this.onClassesLoaded);
        });
        this.linkTypeQueue = new async_1.BufferingQueue(linkTypeIds => {
            this.dataProvider.linkTypesInfo({ linkTypeIds }).then(this.onLinkTypesLoaded);
        });
        this.propertyTypeQueue = new async_1.BufferingQueue(propertyIds => {
            this.dataProvider.propertyInfo({ propertyIds }).then(this.onPropertyTypesLoaded);
        });
        this.onElementInfoLoaded = (elements) => {
            for (const element of this.graph.getElements()) {
                const loadedModel = elements[element.iri];
                if (loadedModel) {
                    element.setData(loadedModel);
                }
            }
        };
        this.onClassesLoaded = (classInfos) => {
            for (const { id, label, count } of classInfos) {
                const model = this.graph.getClass(id);
                if (!model) {
                    continue;
                }
                model.setLabel(label.values);
                if (typeof count === 'number') {
                    model.setCount(count);
                }
            }
        };
        this.onLinkTypesLoaded = (linkTypesInfo) => {
            for (const { id, label } of linkTypesInfo) {
                const model = this.graph.getLinkType(id);
                if (!model) {
                    continue;
                }
                model.setLabel(label.values);
            }
        };
        this.onPropertyTypesLoaded = (propertyModels) => {
            for (const propId in propertyModels) {
                if (!collections_1.hasOwnProperty(propertyModels, propId)) {
                    continue;
                }
                const { id, label } = propertyModels[propId];
                const targetProperty = this.graph.getProperty(id);
                if (targetProperty) {
                    targetProperty.setLabel(label.values);
                }
            }
        };
    }
    fetchElementData(elementIris) {
        if (elementIris.length === 0) {
            return Promise.resolve();
        }
        return this.dataProvider.elementInfo({ elementIds: [...elementIris] })
            .then(this.onElementInfoLoaded);
    }
    fetchClass(model) {
        this.classQueue.push(model.id);
    }
    fetchLinkType(linkType) {
        this.linkTypeQueue.push(linkType.id);
    }
    fetchPropertyType(propertyType) {
        if (!this.dataProvider.propertyInfo) {
            return;
        }
        this.propertyTypeQueue.push(propertyType.id);
    }
}
exports.DataFetcher = DataFetcher;


/***/ }),
/* 116 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createLinkAndChangeDirection = exports.EditorController = exports.DialogTypes = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const model_1 = __webpack_require__(48);
const commands_1 = __webpack_require__(64);
const elements_1 = __webpack_require__(53);
const geometry_1 = __webpack_require__(57);
const history_1 = __webpack_require__(65);
const view_1 = __webpack_require__(66);
const events_1 = __webpack_require__(55);
const dialog_1 = __webpack_require__(117);
const connectionsMenu_1 = __webpack_require__(119);
const editEntityForm_1 = __webpack_require__(123);
const editElementTypeForm_1 = __webpack_require__(124);
const editLinkForm_1 = __webpack_require__(128);
const editLinkLabelForm_1 = __webpack_require__(129);
const halo_1 = __webpack_require__(130);
const haloLink_1 = __webpack_require__(131);
const linkStateWidget_1 = __webpack_require__(132);
const elementDecorator_1 = __webpack_require__(133);
const layout_1 = __webpack_require__(109);
const spinner_1 = __webpack_require__(90);
const asyncModel_1 = __webpack_require__(114);
const authoringState_1 = __webpack_require__(89);
const editLayer_1 = __webpack_require__(134);
const validation_1 = __webpack_require__(135);
const async_1 = __webpack_require__(61);
const collections_1 = __webpack_require__(56);
var DialogTypes;
(function (DialogTypes) {
    DialogTypes[DialogTypes["ConnectionsMenu"] = 0] = "ConnectionsMenu";
    DialogTypes[DialogTypes["EditEntityForm"] = 1] = "EditEntityForm";
    DialogTypes[DialogTypes["EditLinkForm"] = 2] = "EditLinkForm";
    DialogTypes[DialogTypes["EditEntityTypeForm"] = 3] = "EditEntityTypeForm";
    DialogTypes[DialogTypes["EditLinkLabelForm"] = 4] = "EditLinkLabelForm";
})(DialogTypes = exports.DialogTypes || (exports.DialogTypes = {}));
class EditorController {
    constructor(props) {
        this.listener = new events_1.EventObserver();
        this.source = new events_1.EventSource();
        this.events = this.source;
        this._authoringState = authoringState_1.AuthoringState.empty;
        this._validationState = validation_1.ValidationState.empty;
        this._temporaryState = authoringState_1.TemporaryState.empty;
        this._selection = [];
        this.cancellation = new async_1.Cancellation();
        this.onKeyUp = (e) => {
            const DELETE_KEY_CODE = 46;
            if (e.keyCode === DELETE_KEY_CODE &&
                document.activeElement.localName !== 'input') {
                this.removeSelectedElements();
            }
        };
        const { model, view } = props, options = tslib_1.__rest(props, ["model", "view"]);
        this.model = model;
        this.view = view;
        this.options = options;
        this.listener.listen(this.events, 'changeValidationState', e => {
            for (const element of this.model.elements) {
                const previous = e.previous.elements.get(element.iri);
                const current = this.validationState.elements.get(element.iri);
                if (current !== previous) {
                    element.redraw();
                }
            }
        });
        this.listener.listen(this.events, 'changeAuthoringState', e => {
            if (this.options.validationApi) {
                const changedElements = validation_1.changedElementsToValidate(e.previous, this);
                validation_1.validateElements(changedElements, this.options.validationApi, this, this.cancellation.signal);
            }
        });
        this.view._setElementDecorator((element) => React.createElement(elementDecorator_1.ElementDecorator, { model: element, view: this.view, editor: this, position: element.position }));
    }
    _initializePaperComponents(paperArea) {
        this.listener.listen(paperArea.events, 'pointerUp', e => this.onPaperPointerUp(e));
        this.listener.listen(this.model.events, 'changeCells', () => this.onCellsChanged());
        this.listener.listen(this.model.events, 'elementEvent', e => {
            if (e.key === 'requestedGroupContent') {
                this.loadGroupContent(e.data.requestedGroupContent.source);
            }
        });
        this.listener.listen(this.model.events, 'loadingStart', () => this.setSpinner({}));
        this.listener.listen(this.model.events, 'loadingSuccess', () => {
            this.setSpinner(undefined);
            const widget = React.createElement(linkStateWidget_1.LinkStateWidget, { view: this.view, editor: this });
            this.view.setPaperWidget({ key: 'states', widget, attachment: view_1.WidgetAttachment.OverLinks });
        });
        this.listener.listen(this.model.events, 'loadingError', ({ error }) => {
            const statusText = error ? error.message : undefined;
            this.setSpinner({ statusText, errorOccured: true });
        });
        if (!this.options.disableHalo) {
            this.configureHalo();
            document.addEventListener('keyup', this.onKeyUp);
            this.listener.listen(this.view.events, 'dispose', () => {
                document.removeEventListener('keyup', this.onKeyUp);
            });
        }
    }
    get inAuthoringMode() {
        return Boolean(this._metadataApi);
    }
    get metadataApi() { return this._metadataApi; }
    setMetadataApi(value) {
        const previous = this._metadataApi;
        if (value === previous) {
            return;
        }
        this._metadataApi = value;
        if (Boolean(value) !== Boolean(previous)) {
            // authoring mode changed
            this.source.trigger('changeMode', { source: this });
        }
    }
    get authoringState() { return this._authoringState; }
    setAuthoringState(value) {
        const previous = this._authoringState;
        if (previous === value) {
            return;
        }
        this.model.history.execute(this.updateAuthoringState(value));
    }
    updateAuthoringState(state) {
        const previous = this._authoringState;
        return history_1.Command.create('Create or delete entities and links', () => {
            this._authoringState = state;
            this.source.trigger('changeAuthoringState', { source: this, previous });
            return this.updateAuthoringState(previous);
        });
    }
    get validationState() { return this._validationState; }
    setValidationState(value) {
        const previous = this._validationState;
        if (value === previous) {
            return;
        }
        this._validationState = value;
        this.source.trigger('changeValidationState', { source: this, previous });
    }
    get temporaryState() { return this._temporaryState; }
    setTemporaryState(value) {
        const previous = this._temporaryState;
        if (value === previous) {
            return;
        }
        this._temporaryState = value;
        this.source.trigger('changeTemporaryState', { source: this, previous });
    }
    get selection() { return this._selection; }
    setSelection(value) {
        const previous = this._selection;
        if (previous === value) {
            return;
        }
        this._selection = value;
        this.source.trigger('changeSelection', { source: this, previous });
    }
    cancelSelection() {
        this.setSelection([]);
    }
    removeSelectedElements() {
        const itemsToRemove = this.selection;
        if (itemsToRemove.length === 0) {
            return;
        }
        this.cancelSelection();
        this.removeItems(itemsToRemove);
    }
    removeItems(items) {
        const batch = this.model.history.startBatch();
        const deletedElementIris = new Set();
        for (const item of items) {
            if (item instanceof elements_1.Element) {
                const event = this.authoringState.index.elements.get(item.iri);
                this.discardChange(event);
                this.model.removeElement(item.id);
                deletedElementIris.add(item.iri);
            }
            else if (item instanceof elements_1.Link) {
                if (authoringState_1.AuthoringState.isNewLink(this.authoringState, item.data)) {
                    this.deleteLink(item.data);
                }
            }
        }
        if (deletedElementIris.size > 0) {
            const newState = authoringState_1.AuthoringState.deleteNewLinksConnectedToElements(this.authoringState, deletedElementIris);
            this.setAuthoringState(newState);
        }
        batch.store();
    }
    onPaperPointerUp(event) {
        if (this.options.disableHalo) {
            return;
        }
        const { sourceEvent, target, triggerAsClick } = event;
        if (sourceEvent.ctrlKey || sourceEvent.shiftKey || sourceEvent.metaKey) {
            return;
        }
        if (this.dialogTarget && this.dialogType === DialogTypes.EditEntityForm) {
            return;
        }
        if (target instanceof elements_1.Element) {
            this.setSelection([target]);
            target.focus();
        }
        else if (target instanceof elements_1.Link) {
            this.setSelection([target]);
        }
        else if (target instanceof elements_1.LinkVertex) {
            this.setSelection([target.link]);
        }
        else if (!target && triggerAsClick) {
            this.setSelection([]);
            this.hideDialog();
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }
    }
    onCellsChanged() {
        if (this.selection.length === 0) {
            return;
        }
        const newSelection = this.selection.filter(el => this.model.getElement(el.id));
        if (newSelection.length < this.selection.length) {
            this.setSelection(newSelection);
        }
    }
    setSpinner(props) {
        const widget = props ? React.createElement(LoadingWidget, { spinnerProps: props }) : undefined;
        this.view.setPaperWidget({ key: LoadingWidget.Key, widget, attachment: view_1.WidgetAttachment.Viewport });
    }
    configureHalo() {
        if (this.options.disableHalo) {
            return;
        }
        this.listener.listen(this.events, 'changeSelection', () => {
            const selected = this.selection.length === 1 ? this.selection[0] : undefined;
            if (this.dialogTarget && selected !== this.dialogTarget) {
                this.hideDialog();
            }
            this.bringSelectedElementsToFront();
            this.renderDefaultHalo();
        });
        this.listener.listen(this.events, 'toggleDialog', ({ isOpened }) => {
            this.renderDefaultHalo();
        });
        this.renderDefaultHalo();
    }
    bringSelectedElementsToFront() {
        if (this.selection.length === 0) {
            return;
        }
        this.model.reorderElements(collections_1.makeMoveComparator(this.model.elements, this.selection.filter(item => item instanceof elements_1.Element), collections_1.MoveDirection.ToEnd));
        this.view.performSyncUpdate();
    }
    renderDefaultHalo() {
        const selected = this.selection.length === 1 ? this.selection[0] : undefined;
        let halo;
        if (selected instanceof elements_1.Element) {
            halo = (React.createElement(halo_1.Halo, { editor: this, metadataApi: this.metadataApi, target: selected, onRemove: () => this.removeSelectedElements(), onExpand: () => {
                    this.model.history.execute(commands_1.setElementExpanded(selected, !selected.isExpanded));
                }, navigationMenuOpened: this.dialogType === DialogTypes.ConnectionsMenu, onToggleNavigationMenu: () => {
                    if (this.dialogTarget && this.dialogType === DialogTypes.ConnectionsMenu) {
                        this.hideDialog();
                    }
                    else {
                        this.showConnectionsMenu(selected);
                    }
                    this.renderDefaultHalo();
                }, onAddToFilter: () => selected.addToFilter(), onEstablishNewLink: (point) => this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.establishLink, point }), onFollowLink: (element, e) => this.view.onIriClick(element.iri, element, view_1.IriClickIntent.JumpToEntity, e) }));
        }
        else if (selected instanceof elements_1.Link) {
            halo = (React.createElement(haloLink_1.HaloLink, { view: this.view, editor: this, metadataApi: this.metadataApi, target: selected, onEdit: () => this.showEditLinkForm(selected), onDelete: () => this.deleteLink(selected.data), onRevert: () => {
                    const deletion = this.authoringState.index.links.get(selected.data);
                    if (deletion && deletion.type === authoringState_1.AuthoringKind.DeleteLink) {
                        this.discardChange(deletion);
                    }
                }, onSourceMove: (point) => this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.moveLinkSource, point }), onTargetMove: (point) => this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.moveLinkTarget, point }), onEditLabel: () => this.showEditLinkLabelForm(selected) }));
        }
        this.view.setPaperWidget({ key: 'halo', widget: halo, attachment: view_1.WidgetAttachment.OverElements });
    }
    showConnectionsMenu(target) {
        const dialogType = DialogTypes.ConnectionsMenu;
        const onClose = () => this.hideDialog();
        const content = (React.createElement(connectionsMenu_1.ConnectionsMenu, { view: this.view, editor: this, target: target, onAddElements: (iris, linkType) => this.onAddElementsInConnectionMenu(iris, target, linkType), onClose: onClose, suggestProperties: this.options.suggestProperties }));
        this.showDialog({ target, dialogType, content, onClose });
    }
    showEditEntityForm(target) {
        const { propertyEditor } = this.options;
        const dialogType = DialogTypes.EditEntityForm;
        const onSubmit = (newData) => {
            this.hideDialog();
            this.changeEntityData(target.data.id, newData);
        };
        const onCancel = () => this.hideDialog();
        const content = propertyEditor ? propertyEditor({ elementData: target.data, onSubmit, onCancel }) : (React.createElement(editEntityForm_1.EditEntityForm, { view: this.view, entity: target.data, onApply: onSubmit, onCancel: onCancel }));
        this.showDialog({ target, dialogType, content, onClose: onCancel });
    }
    showEditElementTypeForm({ link, source, target }) {
        const dialogType = DialogTypes.EditEntityTypeForm;
        const onCancel = () => {
            this.removeTemporaryElement(target);
            this.removeTemporaryLink(link);
            this.hideDialog();
        };
        const content = (React.createElement(editElementTypeForm_1.EditElementTypeForm, { editor: this, view: this.view, metadataApi: this.metadataApi, link: link.data, source: source.data, target: target.data, onChangeElement: (data) => {
                this.setTemporaryState(authoringState_1.TemporaryState.deleteElement(this.temporaryState, target.data));
                target.setData(data);
                this.setTemporaryState(authoringState_1.TemporaryState.addElement(this.temporaryState, target.data));
            }, onChangeLink: (data) => {
                this.removeTemporaryLink(link);
                const newLink = createLinkAndChangeDirection({
                    data,
                    originalData: link.data,
                    sourceId: link.sourceId,
                    targetId: link.targetId,
                });
                link = this.createNewLink({ link: newLink, temporary: true });
            }, onApply: (elementData, linkData) => {
                const isNewElement = target.iri === elementData.id;
                const position = target.position;
                this.removeTemporaryElement(target);
                this.removeTemporaryLink(link);
                const batch = this.model.history.startBatch();
                const newTarget = this.model.createElement(elementData);
                newTarget.setPosition(position);
                if (isNewElement) {
                    newTarget.setExpanded(true);
                    this.addNewEntity(newTarget.data);
                }
                else {
                    this.model.requestLinksOfType();
                }
                const newLink = createLinkAndChangeDirection({
                    data: linkData,
                    originalData: link.data,
                    sourceId: source.id,
                    targetId: newTarget.id,
                });
                this.createNewLink({ link: newLink });
                batch.store();
                this.hideDialog();
                if (isNewElement) {
                    this.showEditEntityForm(newTarget);
                }
            }, onCancel: onCancel }));
        this.showDialog({ target, dialogType, content, caption: 'Establish New Connection', onClose: onCancel });
    }
    showEditLinkForm(link) {
        const dialogType = DialogTypes.EditLinkForm;
        const source = this.model.getElement(link.sourceId).data;
        const target = this.model.getElement(link.targetId).data;
        const onCancel = () => {
            if (this.temporaryState.links.has(link.data)) {
                this.removeTemporaryLink(link);
            }
            this.hideDialog();
        };
        const content = (React.createElement(editLinkForm_1.EditLinkForm, { editor: this, view: this.view, metadataApi: this.metadataApi, link: link.data, source: source, target: target, onChange: (data) => {
                if (this.temporaryState.links.has(link.data)) {
                    this.removeTemporaryLink(link);
                    const newLink = createLinkAndChangeDirection({
                        data,
                        originalData: link.data,
                        sourceId: link.sourceId,
                        targetId: link.targetId,
                    });
                    this.showEditLinkForm(this.createNewLink({ link: newLink, temporary: true }));
                }
            }, onApply: (data) => {
                if (this.temporaryState.links.has(link.data)) {
                    this.removeTemporaryLink(link);
                    const newLink = createLinkAndChangeDirection({
                        data,
                        originalData: link.data,
                        sourceId: link.sourceId,
                        targetId: link.targetId,
                    });
                    this.createNewLink({ link: newLink });
                }
                else {
                    this.changeLink(link.data, data);
                }
                this.hideDialog();
            }, onCancel: onCancel }));
        const caption = this.temporaryState.links.has(link.data) ? 'Establish New Connection' : 'Edit Connection';
        this.showDialog({
            target: link,
            dialogType,
            content,
            size: { width: 300, height: 160 },
            caption,
            onClose: onCancel,
        });
    }
    // Link editing implementation could be rethought in the future.
    showEditLinkLabelForm(link) {
        const linkType = this.view.model.getLinkType(link.typeId);
        const template = this.view.createLinkTemplate(linkType);
        const size = { width: 300, height: 145 };
        const onCancel = () => this.hideDialog();
        this.showDialog({
            target: link,
            dialogType: DialogTypes.EditLinkLabelForm,
            content: (React.createElement(editLinkLabelForm_1.EditLinkLabelForm, { view: this.view, link: link, onApply: (label) => {
                    template.setLinkLabel(link, label);
                    this.hideDialog();
                }, onCancel: onCancel })),
            size,
            caption: 'Edit Link Label',
            offset: { x: 25, y: -size.height / 2 },
            calculatePosition: () => {
                const { x, y, width, height } = link.labelBounds;
                return { x: x + width, y: y + height / 2 };
            },
            onClose: onCancel,
        });
    }
    showDialog(params) {
        const { target, dialogType, content, size, caption, offset, calculatePosition, onClose } = params;
        this.dialogTarget = target;
        this.dialogType = dialogType;
        const dialog = (React.createElement(dialog_1.Dialog, { view: this.view, target: target, size: size, caption: caption, offset: offset, calculatePosition: calculatePosition, onClose: onClose }, content));
        this.view.setPaperWidget({ key: 'dialog', widget: dialog, attachment: view_1.WidgetAttachment.OverElements });
        this.source.trigger('toggleDialog', { isOpened: false });
    }
    hideDialog() {
        if (this.dialogTarget) {
            const isTemporaryElement = this.dialogTarget instanceof elements_1.Element && this.temporaryState.elements.has(this.dialogTarget.iri);
            const isTemporaryLink = this.dialogTarget instanceof elements_1.Link && this.temporaryState.links.has(this.dialogTarget.data);
            if (isTemporaryElement || isTemporaryLink) {
                this.resetTemporaryState();
            }
            this.dialogType = undefined;
            this.dialogTarget = undefined;
            this.view.setPaperWidget({ key: 'dialog', widget: undefined, attachment: view_1.WidgetAttachment.OverElements });
            this.source.trigger('toggleDialog', { isOpened: false });
        }
    }
    onDragDrop(dragged, paperPosition) {
        const batch = this.model.history.startBatch('Drag and drop onto diagram');
        const placedElements = placeElements(this.view, dragged, paperPosition);
        const irisToLoad = placedElements.map(elem => elem.iri);
        batch.history.execute(asyncModel_1.requestElementData(this.model, irisToLoad));
        batch.history.execute(asyncModel_1.restoreLinksBetweenElements(this.model));
        batch.store();
        if (placedElements.length > 0) {
            placedElements[placedElements.length - 1].focus();
        }
        this.setSelection(placedElements);
        this.source.trigger('addElements', { elements: placedElements });
    }
    onAddElementsInConnectionMenu(elementIris, targetElement, linkType) {
        const batch = this.view.model.history.startBatch();
        const elements = elementIris.map(iri => this.model.createElement(iri));
        this.view.performSyncUpdate();
        layout_1.placeElementsAround({
            model: this.model,
            elements,
            targetElement,
            prefferedLinksLength: 300,
        }).then(() => {
            this.source.trigger('addElements', { elements });
        });
        if (linkType && !linkType.visible) {
            batch.history.execute(commands_1.changeLinkTypeVisibility({
                linkType,
                visible: true,
                showLabel: true,
                preventLoading: true,
            }));
        }
        batch.history.execute(asyncModel_1.requestElementData(this.model, elementIris));
        batch.history.execute(asyncModel_1.restoreLinksBetweenElements(this.model));
        batch.store();
    }
    loadGroupContent(element) {
        return this.model.loadEmbeddedElements(element.iri).then(models => {
            const batch = this.model.history.startBatch();
            const elementIris = Object.keys(models);
            const elements = elementIris.map(key => this.model.createElement(models[key], element.id));
            batch.discard();
            return Promise.all([
                this.model.requestElementData(elementIris),
                this.model.requestLinksOfType(),
            ]).then(() => {
                this.view.performSyncUpdate();
                layout_1.applyLayout(this.model, layout_1.forceLayout({
                    model: this.model,
                    group: element.id,
                }));
                this.model.triggerChangeGroupContent(element.id);
            });
        });
    }
    createNewEntity({ elementModel, temporary }) {
        const batch = this.model.history.startBatch('Create new entity');
        const element = this.model.createElement(elementModel);
        element.setExpanded(true);
        if (temporary) {
            this.setTemporaryState(authoringState_1.TemporaryState.addElement(this.temporaryState, element.data));
            batch.discard();
        }
        else {
            this.setAuthoringState(authoringState_1.AuthoringState.addElement(this._authoringState, element.data));
            batch.store();
        }
        return element;
    }
    changeEntityData(targetIri, newData) {
        const elements = this.model.elements.filter(el => el.iri === targetIri);
        if (elements.length === 0) {
            return;
        }
        const oldData = elements[0].data;
        const batch = this.model.history.startBatch('Edit entity');
        this.model.history.execute(commands_1.setElementData(this.model, targetIri, newData));
        this.setAuthoringState(authoringState_1.AuthoringState.changeElement(this._authoringState, oldData, newData));
        batch.store();
    }
    deleteEntity(elementIri) {
        const state = this.authoringState;
        const elements = this.model.elements.filter(el => el.iri === elementIri);
        if (elements.length === 0) {
            return;
        }
        const batch = this.model.history.startBatch('Delete entity');
        const model = elements[0].data;
        const event = state.index.elements.get(elementIri);
        // remove new connected links
        const linksToRemove = new Set();
        for (const element of elements) {
            for (const link of element.links) {
                if (link.data && authoringState_1.AuthoringState.isNewLink(state, link.data)) {
                    linksToRemove.add(link.id);
                }
            }
        }
        linksToRemove.forEach(linkId => this.model.removeLink(linkId));
        if (event) {
            this.discardChange(event);
        }
        this.setAuthoringState(authoringState_1.AuthoringState.deleteElement(state, model));
        batch.store();
    }
    createNewLink({ link: base, temporary }) {
        const existingLink = this.model.findLink(base.typeId, base.sourceId, base.targetId);
        if (existingLink) {
            throw Error('The link already exists');
        }
        const batch = this.model.history.startBatch('Create new link');
        this.model.createLinks(base.data);
        const links = this.model.links.filter(link => model_1.sameLink(link.data, base.data));
        if (links.length > 0) {
            if (temporary) {
                this.setTemporaryState(authoringState_1.TemporaryState.addLink(this.temporaryState, base.data));
                batch.discard();
            }
            else {
                this.setAuthoringState(authoringState_1.AuthoringState.addLink(this._authoringState, base.data));
                batch.store();
            }
        }
        else {
            batch.discard();
        }
        return links.find(({ sourceId, targetId }) => sourceId === base.sourceId && targetId === base.targetId);
    }
    changeLink(oldData, newData) {
        const batch = this.model.history.startBatch('Change link');
        if (model_1.sameLink(oldData, newData)) {
            this.model.history.execute(commands_1.setLinkData(this.model, oldData, newData));
            this.setAuthoringState(authoringState_1.AuthoringState.changeLink(this._authoringState, oldData, newData));
        }
        else {
            let newState = this._authoringState;
            newState = authoringState_1.AuthoringState.deleteLink(newState, oldData);
            newState = authoringState_1.AuthoringState.addLink(newState, newData);
            if (authoringState_1.AuthoringState.isNewLink(this._authoringState, oldData)) {
                this.model.links
                    .filter(link => model_1.sameLink(link.data, oldData))
                    .forEach(link => this.model.removeLink(link.id));
            }
            this.model.createLinks(newData);
            this.setAuthoringState(newState);
        }
        batch.store();
    }
    moveLinkSource(params) {
        const { link, newSource } = params;
        const batch = this.model.history.startBatch('Move link to another element');
        this.changeLink(link.data, Object.assign(Object.assign({}, link.data), { sourceId: newSource.iri }));
        const newLink = this.model.findLink(link.typeId, newSource.id, link.targetId);
        newLink.setVertices(link.vertices);
        batch.store();
        return newLink;
    }
    moveLinkTarget(params) {
        const { link, newTarget } = params;
        const batch = this.model.history.startBatch('Move link to another element');
        this.changeLink(link.data, Object.assign(Object.assign({}, link.data), { targetId: newTarget.iri }));
        const newLink = this.model.findLink(link.typeId, link.sourceId, newTarget.id);
        newLink.setVertices(link.vertices);
        batch.store();
        return newLink;
    }
    deleteLink(model) {
        const state = this.authoringState;
        const event = state.index.links.get(model);
        if (event && event.type === authoringState_1.AuthoringKind.DeleteLink) {
            return;
        }
        const batch = this.model.history.startBatch('Delete link');
        const newState = authoringState_1.AuthoringState.deleteLink(state, model);
        if (authoringState_1.AuthoringState.isNewLink(state, model)) {
            this.model.links
                .filter(({ data }) => model_1.sameLink(data, model))
                .forEach(link => this.model.removeLink(link.id));
        }
        this.setAuthoringState(newState);
        batch.store();
    }
    startEditing(params) {
        const { target, mode, point } = params;
        const editLayer = (React.createElement(editLayer_1.EditLayer, { view: this.view, editor: this, metadataApi: this.metadataApi, mode: mode, target: target, point: point }));
        this.view.setPaperWidget({ key: 'editLayer', widget: editLayer, attachment: view_1.WidgetAttachment.OverElements });
    }
    finishEditing() {
        this.view.setPaperWidget({ key: 'editLayer', widget: undefined, attachment: view_1.WidgetAttachment.OverElements });
    }
    addNewEntity(element) {
        const batch = this.model.history.startBatch('Create new entity');
        this.setAuthoringState(authoringState_1.AuthoringState.addElement(this._authoringState, element));
        batch.store();
    }
    resetTemporaryState() {
        if (this.temporaryState.elements.size) {
            this.model.elements.forEach(element => {
                if (this.temporaryState.elements.has(element.iri)) {
                    this.removeTemporaryElement(element);
                }
            });
        }
        if (this.temporaryState.links.size) {
            this.model.links.forEach(link => {
                if (this.temporaryState.links.get(link.data)) {
                    this.removeTemporaryLink(link);
                }
            });
        }
    }
    removeTemporaryElement(element) {
        const batch = this.model.history.startBatch();
        this.model.removeElement(element.id);
        batch.discard();
        this.setTemporaryState(authoringState_1.TemporaryState.deleteElement(this.temporaryState, element.data));
    }
    removeTemporaryLink(link) {
        this.model.removeLink(link.id);
        this.setTemporaryState(authoringState_1.TemporaryState.deleteLink(this.temporaryState, link.data));
    }
    discardChange(event) {
        const newState = authoringState_1.AuthoringState.discard(this._authoringState, event);
        if (newState === this._authoringState) {
            return;
        }
        const batch = this.model.history.startBatch('Discard change');
        if (event.type === authoringState_1.AuthoringKind.ChangeElement) {
            if (event.before) {
                this.model.history.execute(commands_1.setElementData(this.model, event.after.id, event.before));
            }
            else {
                this.model.elements
                    .filter(el => el.iri === event.after.id)
                    .forEach(el => this.model.removeElement(el.id));
            }
        }
        else if (event.type === authoringState_1.AuthoringKind.ChangeLink) {
            if (event.before) {
                this.model.history.execute(commands_1.setLinkData(this.model, event.after, event.before));
            }
            else {
                this.model.links
                    .filter(({ data }) => model_1.sameLink(data, event.after))
                    .forEach(link => this.model.removeLink(link.id));
            }
        }
        this.setAuthoringState(newState);
        batch.store();
    }
}
exports.EditorController = EditorController;
class LoadingWidget extends React.Component {
    render() {
        const { spinnerProps, paperArea } = this.props;
        const areaMetrics = paperArea.getAreaMetrics();
        const paneWidth = areaMetrics.clientWidth;
        const paneHeight = areaMetrics.clientHeight;
        const x = spinnerProps.statusText ? paneWidth / 3 : paneWidth / 2;
        const position = { x, y: paneHeight / 2 };
        return (React.createElement("div", { className: 'ontodia-loading-widget' },
            React.createElement("svg", { width: paneWidth, height: paneHeight },
                React.createElement(spinner_1.Spinner, Object.assign({ position: position }, spinnerProps)))));
    }
}
LoadingWidget.Key = 'loadingWidget';
function placeElements(view, dragged, position) {
    const elements = dragged.map(item => view.model.createElement(item));
    view.performSyncUpdate();
    let { x, y } = position;
    let isFirst = true;
    for (const element of elements) {
        let { width, height } = geometry_1.boundsOf(element);
        if (width === 0) {
            width = 100;
        }
        if (height === 0) {
            height = 50;
        }
        if (isFirst) {
            isFirst = false;
            x -= width / 2;
            y -= height / 2;
        }
        element.setPosition({ x, y });
        y += height + 20;
    }
    return elements;
}
function createLinkAndChangeDirection({ data, originalData, sourceId, targetId }) {
    // some of the ids can be totally different because of generating IRI so we use "OR" instead of "AND"
    const directionHasChanged = originalData.sourceId === data.targetId || originalData.targetId === data.sourceId;
    if (directionHasChanged) {
        [sourceId, targetId] = [targetId, sourceId];
    }
    return new elements_1.Link({ typeId: data.linkTypeId, sourceId, targetId, data });
}
exports.createLinkAndChangeDirection = createLinkAndChangeDirection;


/***/ }),
/* 117 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dialog = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const elements_1 = __webpack_require__(53);
const events_1 = __webpack_require__(55);
const geometry_1 = __webpack_require__(57);
const draggableHandle_1 = __webpack_require__(118);
const DEFAULT_WIDTH = 300;
const DEFAULT_HEIGHT = 300;
const MIN_WIDTH = 250;
const MIN_HEIGHT = 250;
const MAX_WIDTH = 800;
const MAX_HEIGHT = 800;
const ELEMENT_OFFSET = 40;
const LINK_OFFSET = 20;
const FOCUS_OFFSET = 20;
const CLASS_NAME = 'ontodia-dialog';
class Dialog extends React.Component {
    constructor(props) {
        super(props);
        this.unsubscribeFromTarget = undefined;
        this.handler = new events_1.EventObserver();
        this.updateAll = () => this.forceUpdate();
        this.onStartDragging = (e) => {
            this.preventSelection();
            const { size } = this.props;
            this.startSize = { x: this.state.width || size.width, y: this.state.height || size.height };
        };
        this.onDragHandleBottom = (e, dx, dy) => {
            const height = this.calculateHeight(this.startSize.y + dy);
            this.setState({ height });
        };
        this.onDragHandleRight = (e, dx) => {
            const width = this.calculateWidth(this.startSize.x + dx);
            this.setState({ width });
        };
        this.onDragHandleBottomRight = (e, dx, dy) => {
            const width = this.calculateWidth(this.startSize.x + dx);
            const height = this.calculateHeight(this.startSize.y + dy);
            this.setState({ width, height });
        };
        this.preventSelection = () => {
            const onMouseUp = () => {
                document.body.classList.remove('ontodia--unselectable');
                document.removeEventListener('mouseup', onMouseUp);
            };
            document.addEventListener('mouseup', onMouseUp);
            document.body.classList.add('ontodia--unselectable');
        };
        this.state = {};
    }
    componentDidMount() {
        this.listenToTarget(this.props.target);
        this.focusOn();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.target !== this.props.target) {
            this.listenToTarget(nextProps.target);
        }
    }
    componentWillUnmount() {
        this.listenToTarget(undefined);
    }
    listenToTarget(target) {
        if (this.unsubscribeFromTarget) {
            this.unsubscribeFromTarget();
            this.unsubscribeFromTarget = undefined;
        }
        if (target) {
            const { view } = this.props;
            if (target instanceof elements_1.Element) {
                this.listenToElement(target);
            }
            else if (target instanceof elements_1.Link) {
                this.listenToLink(target);
            }
            this.handler.listen(view.events, 'changeLanguage', this.updateAll);
            this.unsubscribeFromTarget = () => { this.handler.stopListening(); };
        }
    }
    listenToElement(element) {
        this.handler.listen(element.events, 'changePosition', this.updateAll);
        this.handler.listen(element.events, 'changeSize', this.updateAll);
    }
    listenToLink(link) {
        const { view } = this.props;
        const source = view.model.getElement(link.sourceId);
        const target = view.model.getElement(link.targetId);
        this.listenToElement(source);
        this.listenToElement(target);
        this.handler.listen(link.events, 'changeVertices', this.updateAll);
        this.handler.listen(link.events, 'changeLabelBounds', this.updateAll);
    }
    calculatePositionForElement(element) {
        const { paperArea, size } = this.props;
        const bbox = geometry_1.boundsOf(element);
        const { y: y0 } = paperArea.paperToScrollablePaneCoords(bbox.x, bbox.y);
        const { x: x1, y: y1 } = paperArea.paperToScrollablePaneCoords(bbox.x + bbox.width, bbox.y + bbox.height);
        return {
            x: x1 + ELEMENT_OFFSET,
            y: (y0 + y1) / 2 - (size.height / 2),
        };
    }
    calculatePositionForLink(link) {
        const { view, paperArea } = this.props;
        const source = view.model.getElement(link.sourceId);
        const target = view.model.getElement(link.targetId);
        if (!source || !target) {
            throw new Error('Source and target are not specified');
        }
        const route = view.getRouting(link.id);
        const verticesDefinedByUser = link.vertices || [];
        const vertices = route ? route.vertices : verticesDefinedByUser;
        const polyline = geometry_1.computePolyline(source, target, vertices);
        const polylineLength = geometry_1.computePolylineLength(polyline);
        const targetPoint = geometry_1.getPointAlongPolyline(polyline, polylineLength / 2);
        const { x, y } = paperArea.paperToScrollablePaneCoords(targetPoint.x, targetPoint.y);
        return { y: y + LINK_OFFSET, x: x + LINK_OFFSET };
    }
    calculatePosition() {
        const { target, paperArea, offset = { x: 0, y: 0 }, calculatePosition } = this.props;
        if (calculatePosition) {
            const pos = calculatePosition();
            const { x, y } = paperArea.paperToScrollablePaneCoords(pos.x, pos.y);
            return { x: x + offset.x, y: y + offset.y };
        }
        if (target instanceof elements_1.Element) {
            return this.calculatePositionForElement(target);
        }
        else if (target instanceof elements_1.Link) {
            return this.calculatePositionForLink(target);
        }
        throw new Error('Unknown target type');
    }
    getViewPortScrollablePoints() {
        const { paperArea } = this.props;
        const paperAreaMetrix = paperArea.getAreaMetrics();
        const min = paperArea.clientToScrollablePaneCoords(0, 0);
        const max = paperArea.clientToScrollablePaneCoords(paperAreaMetrix.clientWidth, paperAreaMetrix.clientHeight);
        return { min, max };
    }
    getDialogScrollablePoints() {
        const { size } = this.props;
        const { x, y } = this.calculatePosition();
        const min = {
            x: x - FOCUS_OFFSET,
            y: y - FOCUS_OFFSET,
        };
        const max = {
            x: min.x + size.width + FOCUS_OFFSET * 2,
            y: min.y + size.height + FOCUS_OFFSET * 2,
        };
        return { min, max };
    }
    focusOn() {
        const { paperArea } = this.props;
        const { min: viewPortMin, max: viewPortMax } = this.getViewPortScrollablePoints();
        const { min, max } = this.getDialogScrollablePoints();
        let xOffset = 0;
        if (min.x < viewPortMin.x) {
            xOffset = min.x - viewPortMin.x;
        }
        else if (max.x > viewPortMax.x) {
            xOffset = max.x - viewPortMax.x;
        }
        let yOffset = 0;
        if (min.y < viewPortMin.y) {
            yOffset = min.y - viewPortMin.y;
        }
        else if (max.y > viewPortMax.y) {
            yOffset = max.y - viewPortMax.y;
        }
        const curScrollableCenter = {
            x: viewPortMin.x + (viewPortMax.x - viewPortMin.x) / 2,
            y: viewPortMin.y + (viewPortMax.y - viewPortMin.y) / 2,
        };
        const newScrollabalCenter = {
            x: curScrollableCenter.x + xOffset,
            y: curScrollableCenter.y + yOffset,
        };
        const paperCenter = paperArea.scrollablePaneToPaperCoords(newScrollabalCenter.x, newScrollabalCenter.y);
        paperArea.centerTo(paperCenter);
    }
    calculateHeight(height) {
        const { size } = this.props;
        const minHeight = Math.min(size.height, MIN_HEIGHT);
        const maxHeight = Math.max(size.height, MAX_HEIGHT);
        return Math.max(minHeight, Math.min(maxHeight, height));
    }
    calculateWidth(width) {
        const { size } = this.props;
        const minWidth = Math.min(size.width, MIN_WIDTH);
        const maxWidth = Math.max(size.width, MAX_WIDTH);
        return Math.max(minWidth, Math.min(maxWidth, width));
    }
    render() {
        const { size, caption } = this.props;
        const { x, y } = this.calculatePosition();
        const width = this.state.width || size.width;
        const height = this.state.height || size.height;
        const style = {
            top: y,
            left: x,
            width,
            height,
        };
        return (React.createElement("div", { className: CLASS_NAME, style: style },
            React.createElement("button", { className: `${CLASS_NAME}__close-button`, onClick: () => this.props.onClose() }),
            caption ? React.createElement("div", { className: 'ontodia-dialog__caption' }, caption) : null,
            this.props.children,
            React.createElement(draggableHandle_1.DraggableHandle, { className: `${CLASS_NAME}__bottom-handle`, onBeginDragHandle: this.onStartDragging, onDragHandle: this.onDragHandleBottom }),
            React.createElement(draggableHandle_1.DraggableHandle, { className: `${CLASS_NAME}__right-handle`, onBeginDragHandle: this.onStartDragging, onDragHandle: this.onDragHandleRight }),
            React.createElement(draggableHandle_1.DraggableHandle, { className: `${CLASS_NAME}__bottom-right-handle`, onBeginDragHandle: this.onStartDragging, onDragHandle: this.onDragHandleBottomRight })));
    }
}
exports.Dialog = Dialog;
Dialog.defaultProps = {
    size: { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT },
};


/***/ }),
/* 118 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DraggableHandle = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
class DraggableHandle extends React.Component {
    constructor() {
        super(...arguments);
        this.isHoldingMouse = false;
        this.onHandleMouseDown = (e) => {
            if (e.target !== e.currentTarget) {
                return;
            }
            if (this.isHoldingMouse) {
                return;
            }
            const LEFT_BUTTON = 0;
            if (e.button !== LEFT_BUTTON) {
                return;
            }
            this.isHoldingMouse = true;
            this.originPageX = e.pageX;
            this.originPageY = e.pageY;
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
            this.props.onBeginDragHandle(e);
        };
        this.onMouseMove = (e) => {
            if (!this.isHoldingMouse) {
                return;
            }
            e.preventDefault();
            this.props.onDragHandle(e, e.pageX - this.originPageX, e.pageY - this.originPageY);
        };
        this.onMouseUp = (e) => {
            this.removeListeners();
            if (this.props.onEndDragHandle) {
                this.props.onEndDragHandle(e);
            }
        };
    }
    render() {
        // remove custom handlers from `div` props
        // tslint:disable-next-line:no-unused-variable
        const _a = this.props, { onBeginDragHandle, onDragHandle, onEndDragHandle } = _a, props = tslib_1.__rest(_a, ["onBeginDragHandle", "onDragHandle", "onEndDragHandle"]);
        return React.createElement("div", Object.assign({}, props, { onMouseDown: this.onHandleMouseDown }), this.props.children);
    }
    componentWillUnmount() {
        this.removeListeners();
    }
    removeListeners() {
        if (this.isHoldingMouse) {
            this.isHoldingMouse = false;
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);
        }
    }
}
exports.DraggableHandle = DraggableHandle;


/***/ }),
/* 119 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConnectionsMenu = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const elements_1 = __webpack_require__(53);
const events_1 = __webpack_require__(55);
const progressBar_1 = __webpack_require__(120);
const listElementView_1 = __webpack_require__(121);
const searchResults_1 = __webpack_require__(122);
const workspaceContext_1 = __webpack_require__(88);
const MAX_LINK_COUNT = 100;
const ALL_RELATED_ELEMENTS_LINK = new elements_1.FatLinkType({
    id: 'allRelatedElements',
    label: [{ lang: '', text: 'All' }],
});
class ConnectionsMenu extends React.Component {
    constructor() {
        super(...arguments);
        this.handler = new events_1.EventObserver();
        this.linkTypesListener = new events_1.EventObserver();
        this.loadingState = progressBar_1.ProgressState.none;
        this.updateAll = () => this.forceUpdate();
        this.addSelectedElements = (selectedObjects) => {
            const { onClose, onAddElements } = this.props;
            const addedElementsIris = selectedObjects.map(item => item.model.id);
            const linkType = this.linkDataChunk ? this.linkDataChunk.link : undefined;
            const hasChosenLinkType = this.linkDataChunk && linkType !== ALL_RELATED_ELEMENTS_LINK;
            onAddElements(addedElementsIris, hasChosenLinkType ? linkType : undefined);
            onClose();
        };
        this.onExpandLink = (linkDataChunk) => {
            const alreadyLoaded = (this.objects &&
                this.linkDataChunk &&
                this.linkDataChunk.link === linkDataChunk.link &&
                this.linkDataChunk.direction === linkDataChunk.direction);
            if (!alreadyLoaded) {
                this.loadObjects(linkDataChunk);
            }
            this.updateAll();
            this.context.ontodiaWorkspace.triggerWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.connectionsExpandLink);
        };
        this.onMoveToFilter = (linkDataChunk) => {
            const { view, target } = this.props;
            const { link, direction } = linkDataChunk;
            if (link === ALL_RELATED_ELEMENTS_LINK) {
                target.addToFilter();
            }
            else {
                const selectedElement = view.model.getElement(target.id);
                selectedElement.addToFilter(link, direction);
            }
        };
    }
    componentDidMount() {
        const { view } = this.props;
        this.handler.listen(view.events, 'changeLanguage', this.updateAll);
        this.loadLinks();
    }
    componentWillUnmount() {
        this.handler.stopListening();
        this.linkTypesListener.stopListening();
    }
    resubscribeOnLinkTypeEvents(linkTypesOfElement) {
        this.linkTypesListener.stopListening();
        for (const linkType of linkTypesOfElement) {
            this.linkTypesListener.listen(linkType.events, 'changeLabel', this.updateAll);
            this.linkTypesListener.listen(linkType.events, 'changeVisibility', this.updateAll);
        }
    }
    loadLinks() {
        const { view, editor, target } = this.props;
        this.loadingState = progressBar_1.ProgressState.loading;
        this.links = [];
        this.countMap = {};
        editor.model.dataProvider.linkTypesOf({ elementId: target.iri })
            .then(linkTypes => {
            this.loadingState = progressBar_1.ProgressState.completed;
            const countMap = {};
            const links = [];
            for (const { id: linkTypeId, inCount, outCount } of linkTypes) {
                countMap[linkTypeId] = { inCount, outCount };
                links.push(view.model.createLinkType(linkTypeId));
            }
            countMap[ALL_RELATED_ELEMENTS_LINK.id] = Object.keys(countMap)
                .map(key => countMap[key])
                .reduce((a, b) => {
                return { inCount: a.inCount + b.inCount, outCount: a.outCount + b.outCount };
            }, { inCount: 0, outCount: 0 });
            this.countMap = countMap;
            this.links = links;
            this.resubscribeOnLinkTypeEvents(this.links);
            this.updateAll();
            this.context.ontodiaWorkspace.triggerWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.connectionsLoadLinks);
        })
            .catch(err => {
            // tslint:disable-next-line:no-console
            console.error(err);
            this.loadingState = progressBar_1.ProgressState.error;
            this.updateAll();
        });
        this.updateAll();
    }
    loadObjects(linkDataChunk) {
        const { view, editor, target } = this.props;
        const { link, direction } = linkDataChunk;
        const offset = (linkDataChunk.offset || 0);
        this.loadingState = progressBar_1.ProgressState.loading;
        this.linkDataChunk = linkDataChunk;
        this.objects = [];
        editor.model.dataProvider.linkElements({
            elementId: target.iri,
            linkId: (link === ALL_RELATED_ELEMENTS_LINK ? undefined : link.id),
            limit: offset + MAX_LINK_COUNT,
            offset: offset,
            direction,
        }).then(elements => {
            this.loadingState = progressBar_1.ProgressState.completed;
            this.objects = Object.keys(elements).map(iri => ({
                model: elements[iri],
                presentOnDiagram: view.model.elements.findIndex(element => element.iri === iri && element.group === undefined) >= 0,
            }));
            this.updateAll();
            this.context.ontodiaWorkspace.triggerWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.connectionsLoadElements);
        }).catch(err => {
            // tslint:disable-next-line:no-console
            console.error(err);
            this.loadingState = progressBar_1.ProgressState.error;
            this.updateAll();
        });
    }
    render() {
        const connectionsData = {
            links: this.links || [],
            countMap: this.countMap || {},
        };
        let objectsData = null;
        if (this.linkDataChunk && this.objects) {
            objectsData = {
                linkDataChunk: this.linkDataChunk,
                objects: this.objects,
            };
        }
        const { view, target, suggestProperties } = this.props;
        return (React.createElement(ConnectionsMenuMarkup, { target: target, connectionsData: connectionsData, objectsData: objectsData, state: this.loadingState, view: view, onExpandLink: this.onExpandLink, onPressAddSelected: this.addSelectedElements, onMoveToFilter: this.onMoveToFilter, propertySuggestionCall: suggestProperties }));
    }
}
exports.ConnectionsMenu = ConnectionsMenu;
ConnectionsMenu.contextTypes = workspaceContext_1.WorkspaceContextTypes;
class ConnectionsMenuMarkup extends React.Component {
    constructor(props) {
        super(props);
        this.onChangeFilter = (e) => {
            const filterKey = e.currentTarget.value;
            this.setState({ filterKey });
        };
        this.getTitle = () => {
            if (this.props.objectsData && this.state.panel === 'objects') {
                return 'Objects';
            }
            else if (this.props.connectionsData && this.state.panel === 'connections') {
                return 'Connections';
            }
            return 'Error';
        };
        this.onExpandLink = (linkDataChunk) => {
            this.setState({ filterKey: '', panel: 'objects' });
            this.props.onExpandLink(linkDataChunk);
        };
        this.onCollapseLink = () => {
            this.setState({ filterKey: '', panel: 'connections' });
        };
        this.getBreadCrumbs = () => {
            if (this.props.objectsData && this.state.panel === 'objects') {
                const { link, direction } = this.props.objectsData.linkDataChunk;
                const localizedText = this.props.view.formatLabel(link.label, link.id);
                return React.createElement("span", { className: 'ontodia-connections-menu_bread-crumbs' },
                    React.createElement("a", { className: 'ontodia-connections-menu__link', onClick: this.onCollapseLink }, "Connections"),
                    '\u00A0' + '/' + '\u00A0',
                    localizedText,
                    " ",
                    direction ? `(${direction})` : null);
            }
            else {
                return null;
            }
        };
        this.getBody = () => {
            if (this.props.state === 'error') {
                return React.createElement("label", { className: 'ontodia-label ontodia-connections-menu__error' }, "Error");
            }
            else if (this.props.objectsData && this.state.panel === 'objects') {
                return React.createElement(ObjectsPanel, { data: this.props.objectsData, onMoveToFilter: this.props.onMoveToFilter, view: this.props.view, filterKey: this.state.filterKey, loading: this.props.state === progressBar_1.ProgressState.loading, onPressAddSelected: this.props.onPressAddSelected });
            }
            else if (this.props.connectionsData && this.state.panel === 'connections') {
                if (this.props.state === progressBar_1.ProgressState.loading) {
                    return React.createElement("label", { className: 'ontodia-label ontodia-connections-menu__loading' }, "Loading...");
                }
                return React.createElement(ConnectionsList, { id: this.props.target.id, data: this.props.connectionsData, view: this.props.view, filterKey: this.state.filterKey, onExpandLink: this.onExpandLink, onMoveToFilter: this.props.onMoveToFilter, propertySuggestionCall: this.props.propertySuggestionCall, sortMode: this.state.sortMode });
            }
            else {
                return React.createElement("div", null);
            }
        };
        this.onSortChange = (e) => {
            const value = e.target.value;
            if (this.state.sortMode === value) {
                return;
            }
            this.setState({ sortMode: value });
        };
        this.renderSortSwitch = (id, icon, title) => {
            return (React.createElement("div", null,
                React.createElement("input", { type: 'radio', name: 'sort', id: id, value: id, className: 'ontodia-connections-menu__sort-switch', onChange: this.onSortChange, checked: this.state.sortMode === id }),
                React.createElement("label", { htmlFor: id, className: 'ontodia-connections-menu__sort-switch-label', title: title },
                    React.createElement("i", { className: `fa ${icon}` }))));
        };
        this.renderSortSwitches = () => {
            if (this.state.panel !== 'connections' || !this.props.propertySuggestionCall) {
                return null;
            }
            return (React.createElement("div", { className: 'ontodia-connections-menu_search-line-sort-switches' },
                this.renderSortSwitch('alphabet', 'fa-sort-alpha-asc', 'Sort alphabetically'),
                this.renderSortSwitch('smart', 'fa-lightbulb-o', 'Smart sort')));
        };
        this.state = {
            filterKey: '',
            panel: 'connections',
            sortMode: 'alphabet',
        };
    }
    render() {
        return (React.createElement("div", { className: 'ontodia-connections-menu' },
            React.createElement("label", { className: 'ontodia-label ontodia-connections-menu__title-label' }, this.getTitle()),
            this.getBreadCrumbs(),
            React.createElement("div", { className: 'ontodia-connections-menu_search-line' },
                React.createElement("input", { type: 'text', className: 'search-input ontodia-form-control ontodia-connections-menu__search-line-input', value: this.state.filterKey, onChange: this.onChangeFilter, placeholder: 'Search for...' }),
                this.renderSortSwitches()),
            React.createElement(progressBar_1.ProgressBar, { state: this.props.state, height: 10 }),
            this.getBody()));
    }
}
class ConnectionsList extends React.Component {
    constructor(props) {
        super(props);
        this.updateScores = (props) => {
            if (props.propertySuggestionCall && (props.filterKey || props.sortMode === 'smart')) {
                const { id, data, view, filterKey } = props;
                const lang = view.getLanguage();
                const token = filterKey.trim();
                const properties = data.links.map(l => l.id);
                props.propertySuggestionCall({ elementId: id, token, properties, lang }).then(scores => this.setState({ scores }));
            }
        };
        this.compareLinks = (a, b) => {
            const { view } = this.props;
            const aText = view.formatLabel(a.label, a.id);
            const bText = view.formatLabel(b.label, b.id);
            return aText.localeCompare(bText);
        };
        this.compareLinksByWeight = (a, b) => {
            const { view } = this.props;
            const aText = view.formatLabel(a.label, a.id);
            const bText = view.formatLabel(b.label, b.id);
            const aWeight = this.state.scores[a.id] ? this.state.scores[a.id].score : 0;
            const bWeight = this.state.scores[b.id] ? this.state.scores[b.id].score : 0;
            return (aWeight > bWeight ? -1 :
                aWeight < bWeight ? 1 :
                    aText.localeCompare(bText));
        };
        this.getLinks = () => {
            const { view, data, filterKey } = this.props;
            return (data.links || []).filter(link => {
                const text = view.formatLabel(link.label, link.id).toLowerCase();
                return !filterKey || text.indexOf(filterKey.toLowerCase()) >= 0;
            })
                .sort(this.compareLinks);
        };
        this.getProbableLinks = () => {
            const isSmartMode = this.isSmartMode();
            return (this.props.data.links || []).filter(link => {
                return this.state.scores[link.id] && (this.state.scores[link.id].score > 0 || isSmartMode);
            }).sort(this.compareLinksByWeight);
        };
        this.getViews = (links, notSure) => {
            const { view } = this.props;
            const countMap = this.props.data.countMap || {};
            const views = [];
            const addView = (link, direction) => {
                const count = direction === 'in'
                    ? countMap[link.id].inCount
                    : countMap[link.id].outCount;
                if (count === 0) {
                    return;
                }
                const postfix = notSure ? '-probable' : '';
                views.push(React.createElement(LinkInPopupMenu, { key: `${direction}-${link.id}-${postfix}`, link: link, onExpandLink: this.props.onExpandLink, view: view, count: count, direction: direction, filterKey: notSure ? '' : this.props.filterKey, onMoveToFilter: this.props.onMoveToFilter, probability: (this.state.scores[link.id] && notSure ? this.state.scores[link.id].score : 0) }));
            };
            for (const link of links) {
                addView(link, 'in');
                addView(link, 'out');
            }
            return views;
        };
        this.state = { scores: {} };
        this.updateScores(props);
    }
    componentWillReceiveProps(newProps) {
        this.updateScores(newProps);
    }
    isSmartMode() {
        return this.props.sortMode === 'smart' && !this.props.filterKey;
    }
    render() {
        const { view } = this.props;
        const isSmartMode = this.isSmartMode();
        const links = isSmartMode ? [] : this.getLinks();
        const probableLinks = this.getProbableLinks().filter(link => links.indexOf(link) === -1);
        const views = this.getViews(links);
        const probableViews = this.getViews(probableLinks, true);
        let viewList;
        if (views.length === 0 && probableViews.length === 0) {
            viewList = React.createElement("label", { className: 'ontodia-label ontodia-connections-menu_links-list__empty' }, "List empty");
        }
        else {
            viewList = views;
            if (views.length > 1 || (isSmartMode && probableViews.length > 1)) {
                const countMap = this.props.data.countMap || {};
                const allRelatedElements = countMap[ALL_RELATED_ELEMENTS_LINK.id];
                viewList = [
                    React.createElement(LinkInPopupMenu, { key: ALL_RELATED_ELEMENTS_LINK.id, link: ALL_RELATED_ELEMENTS_LINK, onExpandLink: this.props.onExpandLink, view: view, count: allRelatedElements.inCount + allRelatedElements.outCount, onMoveToFilter: this.props.onMoveToFilter }),
                    React.createElement("hr", { key: 'ontodia-hr-line', className: 'ontodia-connections-menu_links-list__hr' }),
                ].concat(viewList);
            }
        }
        let probablePart = null;
        if (probableViews.length !== 0) {
            probablePart = [
                isSmartMode ? null : (React.createElement("li", { key: 'probable-links' },
                    React.createElement("span", { className: 'ontodia-label' }, "Probably, you're looking for.."))),
                probableViews,
            ];
        }
        return React.createElement("ul", { className: 'ontodia-connections-menu_links-list '
                + (views.length === 0 && probableViews.length === 0 ? 'ocm_links-list-empty' : '') },
            viewList,
            probablePart);
    }
}
class LinkInPopupMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onExpandLink = (expectedCount, direction) => {
            this.props.onExpandLink({
                link: this.props.link,
                direction,
                expectedCount,
            });
        };
        this.onMoveToFilter = (evt) => {
            evt.stopPropagation();
            this.props.onMoveToFilter({
                link: this.props.link,
                direction: this.props.direction,
                expectedCount: this.props.count,
            });
        };
    }
    render() {
        const { view, link } = this.props;
        const fullText = view.formatLabel(link.label, link.id);
        const probability = Math.round(this.props.probability * 100);
        const textLine = listElementView_1.highlightSubstring(fullText + (probability > 0 ? ' (' + probability + '%)' : ''), this.props.filterKey);
        const directionName = this.props.direction === 'in' ? 'source' :
            this.props.direction === 'out' ? 'target' :
                'all connected';
        return (React.createElement("li", { "data-linkTypeId": this.props.link.id, className: 'link-in-popup-menu', title: `${directionName} of "${fullText}" ${view.formatIri(link.id)}`, onClick: () => this.onExpandLink(this.props.count, this.props.direction) },
            this.props.direction === 'in' || this.props.direction === 'out' ?
                React.createElement("div", { className: 'link-in-popup-menu_direction' },
                    this.props.direction === 'in' && React.createElement("div", { className: 'link-in-popup-menu_direction__in-direction' }),
                    this.props.direction === 'out' && React.createElement("div", { className: 'link-in-popup-menu_direction__out-direction' }))
                : null,
            React.createElement("div", { className: 'link-in-popup-menu__link-title' }, textLine),
            React.createElement("span", { className: 'ontodia-badge link-in-popup-menu__count' }, this.props.count <= MAX_LINK_COUNT ? this.props.count : '100+'),
            React.createElement("div", { className: 'link-in-popup-menu__filter-button', onClick: this.onMoveToFilter, title: 'Set as filter in the Instances panel' }),
            React.createElement("div", { className: 'link-in-popup-menu__navigate-button', title: `Navigate to ${directionName} "${fullText}" elements` })));
    }
}
class ObjectsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.onSelectAll = () => {
            const objects = this.props.data.objects;
            if (objects.length === 0) {
                return;
            }
            const allSelected = allNonPresentedAreSelected(objects, this.state.selection);
            const newSelection = allSelected ? new Set() : selectNonPresented(this.props.data.objects);
            this.updateSelection(newSelection);
        };
        this.updateSelection = (newSelection) => {
            this.setState({ selection: newSelection });
        };
        this.counter = (activeObjCount) => {
            const countString = `${activeObjCount}\u00A0of\u00A0${this.props.data.objects.length}`;
            const wrongNodes = Math.min(MAX_LINK_COUNT, this.props.data.linkDataChunk.expectedCount) - this.props.data.objects.length;
            const wrongNodesString = Math.abs(wrongNodes) > MAX_LINK_COUNT ?
                `${MAX_LINK_COUNT}+` : Math.abs(wrongNodes).toString();
            const wrongNodesCount = wrongNodes === 0 ? '' : (wrongNodes < 0 ?
                `\u00A0(${wrongNodesString})` : `\u00A0(${wrongNodesString})`);
            const wrongNodesTitle = wrongNodes === 0 ? '' : (wrongNodes > 0 ? 'Unavailable nodes' : 'Extra nodes');
            return React.createElement("div", { className: 'ontodia-label ontodia-connections-menu_objects-panel_bottom-panel__count-label' },
                React.createElement("span", null, countString),
                React.createElement("span", { className: 'ontodia-connections-menu_objects-panel_bottom-panel__extra-elements', title: wrongNodesTitle }, wrongNodesCount));
        };
        this.state = { selection: new Set() };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.data.objects.length < nextProps.data.objects.length) {
            this.setState({ selection: new Set() });
        }
    }
    getFilteredObjects() {
        if (!this.props.filterKey) {
            return this.props.data.objects;
        }
        const filterKey = this.props.filterKey.toLowerCase();
        return this.props.data.objects.filter(element => {
            const text = this.props.view.formatLabel(element.model.label.values, element.model.id).toLowerCase();
            return text && text.indexOf(filterKey) >= 0;
        });
    }
    getItems(list) {
        const added = {};
        const result = [];
        for (const obj of list) {
            if (added[obj.model.id]) {
                continue;
            }
            added[obj.model.id] = true;
            result.push(obj.model);
        }
        return result;
    }
    render() {
        const { onPressAddSelected, filterKey } = this.props;
        const { selection } = this.state;
        const objects = this.getFilteredObjects();
        const isAllSelected = allNonPresentedAreSelected(objects, selection);
        const nonPresented = objects.filter(el => !el.presentOnDiagram);
        const active = nonPresented.filter(el => selection.has(el.model.id));
        return React.createElement("div", { className: 'ontodia-connections-menu_objects-panel' },
            React.createElement("div", { className: 'ontodia-connections-menu_objects-panel__select-all' },
                React.createElement("label", null,
                    React.createElement("input", { type: 'checkbox', checked: isAllSelected && nonPresented.length > 0, onChange: this.onSelectAll, disabled: nonPresented.length === 0 }),
                    "Select All")),
            (this.props.loading ?
                React.createElement("label", { className: 'ontodia-label ontodia-connections-menu__loading-objects' }, "Loading...") :
                objects.length === 0 ?
                    React.createElement("label", { className: 'ontodia-label ontodia-connections-menu__loading-objects' }, "No available nodes") :
                    React.createElement("div", { className: 'ontodia-connections-menu_objects-panel_objects-list' },
                        React.createElement(searchResults_1.SearchResults, { view: this.props.view, items: this.getItems(objects), selection: this.state.selection, onSelectionChanged: this.updateSelection, highlightText: filterKey }),
                        this.props.data.linkDataChunk.expectedCount > MAX_LINK_COUNT ? (React.createElement("div", { className: 'ontodia-connections-menu__move-to-filter', onClick: () => this.props.onMoveToFilter(this.props.data.linkDataChunk) }, "The list was truncated, for more data click here to use the filter panel")) : null)),
            React.createElement("div", { className: 'ontodia-connections-menu_objects-panel_bottom-panel' },
                this.counter(active.length),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-primary pull-right ' +
                        'ontodia-connections-menu_objects-panel_bottom-panel__add-button', disabled: this.props.loading || nonPresented.length === 0, onClick: () => onPressAddSelected(active.length > 0 ? active : nonPresented) }, active.length > 0 ? 'Add selected' : 'Add all')));
    }
}
function selectNonPresented(objects) {
    const selection = new Set();
    for (const object of objects) {
        if (object.presentOnDiagram) {
            continue;
        }
        selection.add(object.model.id);
    }
    return selection;
}
function allNonPresentedAreSelected(objects, selection) {
    let allSelected = true;
    for (const object of objects) {
        if (object.presentOnDiagram) {
            continue;
        }
        allSelected = allSelected && selection.has(object.model.id);
    }
    return allSelected;
}


/***/ }),
/* 120 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProgressBar = exports.ProgressState = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
var ProgressState;
(function (ProgressState) {
    ProgressState["none"] = "none";
    ProgressState["loading"] = "loading";
    ProgressState["error"] = "error";
    ProgressState["completed"] = "completed";
})(ProgressState = exports.ProgressState || (exports.ProgressState = {}));
const CLASS_NAME = 'ontodia-progress-bar';
class ProgressBar extends React.Component {
    render() {
        const { state, percent = 100, height = 20 } = this.props;
        const className = `${CLASS_NAME} ${CLASS_NAME}--${state}`;
        const showBar = state === ProgressState.loading || state === ProgressState.error;
        return (React.createElement("div", { className: className, style: { height: showBar ? height : 0 } },
            React.createElement("div", { className: `${CLASS_NAME}__bar`, role: 'progressbar', style: { width: `${percent}%` }, "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": percent })));
    }
}
exports.ProgressBar = ProgressBar;


/***/ }),
/* 121 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.highlightSubstring = exports.startDragElements = exports.ListElementView = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const d3_color_1 = __webpack_require__(60);
const CLASS_NAME = 'ontodia-list-element-view';
class ListElementView extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = (event) => {
            const { disabled, model, onClick } = this.props;
            if (!disabled && onClick) {
                event.persist();
                onClick(event, model);
            }
        };
    }
    render() {
        const { className, view, model, highlightText, disabled, selected, onDragStart } = this.props;
        const { h, c, l } = view.getTypeStyle(model.types).color;
        const frontColor = (selected && !disabled) ? d3_color_1.hcl(h, c, l * 1.2) : d3_color_1.hcl('white');
        let classNames = `${CLASS_NAME}`;
        classNames += disabled ? ` ${CLASS_NAME}--disabled` : '';
        classNames += className ? ` ${className}` : '';
        const localizedText = view.formatLabel(model.label.values, model.id);
        const classesString = model.types.length > 0 ? `\nClasses: ${view.getElementTypeString(model)}` : '';
        return React.createElement("li", { className: classNames, draggable: !disabled && Boolean(onDragStart), title: `${localizedText} ${view.formatIri(model.id)}${classesString}`, style: { background: d3_color_1.hcl(h, c, l) }, onClick: this.onClick, onDragStart: onDragStart },
            React.createElement("div", { className: `${CLASS_NAME}__label`, style: { background: frontColor } }, highlightSubstring(localizedText, highlightText)));
    }
}
exports.ListElementView = ListElementView;
function startDragElements(e, iris) {
    try {
        e.dataTransfer.setData('application/x-ontodia-elements', JSON.stringify(iris));
    }
    catch (ex) { // IE fix
        e.dataTransfer.setData('text', JSON.stringify(iris));
    }
    return false;
}
exports.startDragElements = startDragElements;
const DEFAULT_HIGHLIGHT_PROPS = {
    className: `ontodia-text-highlight`
};
function highlightSubstring(text, substring, highlightProps = DEFAULT_HIGHLIGHT_PROPS) {
    if (!substring) {
        return React.createElement("span", null, text);
    }
    const start = text.toLowerCase().indexOf(substring.toLowerCase());
    if (start < 0) {
        return React.createElement("span", null, text);
    }
    const end = start + substring.length;
    const before = text.substring(0, start);
    const highlighted = text.substring(start, end);
    const after = text.substring(end);
    return React.createElement("span", null,
        before,
        React.createElement("span", Object.assign({}, highlightProps), highlighted),
        after);
}
exports.highlightSubstring = highlightSubstring;


/***/ }),
/* 122 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchResults = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const collections_1 = __webpack_require__(56);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const listElementView_1 = __webpack_require__(121);
const CLASS_NAME = 'ontodia-search-results';
class SearchResults extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.delayedChangeCells = new async_1.Debouncer();
        this.startSelection = 0;
        this.endSelection = 0;
        this.onRootMount = (root) => {
            this.root = root;
        };
        this.renderResultItem = (model) => {
            const alreadyOnDiagram = this.isOnDiagram(model);
            return (React.createElement(listElementView_1.ListElementView, { key: model.id, model: model, view: this.props.view, highlightText: this.props.highlightText, disabled: alreadyOnDiagram, selected: this.props.selection.has(model.id), onClick: alreadyOnDiagram ? undefined : this.onItemClick, onDragStart: e => {
                    const { selection } = this.props;
                    const iris = [];
                    selection.forEach(iri => iris.push(iri));
                    if (!selection.has(model.id)) {
                        iris.push(model.id);
                    }
                    return listElementView_1.startDragElements(e, iris);
                } }));
        };
        this.onChangeCells = () => {
            const { items, selection } = this.props;
            if (selection.size === 0) {
                if (items && items.length > 0) {
                    // redraw "already on diagram" state
                    this.forceUpdate();
                }
            }
            else {
                const newSelection = collections_1.cloneSet(selection);
                for (const element of this.props.view.model.elements) {
                    if (element.group === undefined && selection.has(element.iri)) {
                        newSelection.delete(element.iri);
                    }
                }
                this.updateSelection(newSelection);
            }
        };
        this.addKeyListener = () => {
            document.addEventListener('keydown', this.onKeyUp);
        };
        this.removeKeyListener = () => {
            document.removeEventListener('keydown', this.onKeyUp);
        };
        this.onKeyUp = (event) => {
            const { items } = this.props;
            const isPressedUp = event.keyCode === 38 || event.which === 38;
            const isPressDown = event.keyCode === 40 || event.which === 40;
            if (isPressedUp || isPressDown) {
                if (event.shiftKey) { // select range
                    if (isPressedUp) {
                        this.endSelection = this.getNextIndex(this.endSelection, 0 /* Up */);
                    }
                    else if (isPressDown) {
                        this.endSelection = this.getNextIndex(this.endSelection, 1 /* Down */);
                    }
                    const startIndex = Math.min(this.startSelection, this.endSelection);
                    const finishIndex = Math.max(this.startSelection, this.endSelection);
                    const selection = this.selectRange(startIndex, finishIndex);
                    this.updateSelection(selection);
                    this.focusOn(this.endSelection);
                }
                else { // change focus
                    const startIndex = Math.min(this.startSelection, this.endSelection);
                    const finishIndex = Math.max(this.startSelection, this.endSelection);
                    if (isPressedUp) {
                        this.startSelection = this.getNextIndex(startIndex, 0 /* Up */);
                    }
                    else if (isPressDown) {
                        this.startSelection = this.getNextIndex(finishIndex, 1 /* Down */);
                    }
                    this.endSelection = this.startSelection;
                    const focusElement = items[this.startSelection];
                    const newSelection = new Set();
                    newSelection.add(focusElement.id);
                    this.updateSelection(newSelection);
                    this.focusOn(this.startSelection);
                }
            }
            event.preventDefault();
        };
        this.onItemClick = (event, model) => {
            event.preventDefault();
            const { items, selection, onSelectionChanged } = this.props;
            const previouslySelected = selection.has(model.id);
            const modelIndex = items.indexOf(model);
            let newSelection;
            if (event.shiftKey && this.startSelection !== -1) { // select range
                const start = Math.min(this.startSelection, modelIndex);
                const end = Math.max(this.startSelection, modelIndex);
                newSelection = this.selectRange(start, end);
            }
            else {
                this.endSelection = this.startSelection = modelIndex;
                const ctrlKey = event.ctrlKey || event.metaKey;
                if (ctrlKey) { // select/deselect
                    newSelection = collections_1.cloneSet(selection);
                    if (selection.has(model.id)) {
                        newSelection.delete(model.id);
                    }
                    else {
                        newSelection.add(model.id);
                    }
                }
                else { // single click
                    newSelection = new Set();
                    newSelection.add(model.id);
                }
            }
            onSelectionChanged(newSelection);
        };
        this.state = {
            selection: props.selection || {},
        };
    }
    render() {
        const items = this.props.items || [];
        return React.createElement("ul", { className: CLASS_NAME, ref: this.onRootMount, tabIndex: -1, onFocus: this.addKeyListener, onBlur: this.removeKeyListener }, items.map(this.renderResultItem));
    }
    componentDidMount() {
        this.listener.listen(this.props.view.model.events, 'changeCells', () => {
            this.delayedChangeCells.call(this.onChangeCells);
        });
    }
    componentWillReceiveProps(props) {
        this.setState({ selection: props.selection || {} });
    }
    componentWillUnmount() {
        this.removeKeyListener();
        this.listener.stopListening();
        this.delayedChangeCells.dispose();
    }
    updateSelection(selection) {
        const { onSelectionChanged } = this.props;
        onSelectionChanged(selection);
    }
    selectRange(start, end) {
        const { items } = this.props;
        const selection = new Set();
        for (let i = start; i <= end; i++) {
            const selectedModel = items[i];
            if (!this.isOnDiagram(selectedModel)) {
                selection.add(selectedModel.id);
            }
        }
        return selection;
    }
    getNextIndex(curIndex, direction) {
        const items = this.props.items;
        const step = direction === 0 /* Up */ ? -1 : 1;
        for (let i = curIndex + step; i !== curIndex; i += step) {
            if (i < 0) {
                i = items.length - 1;
            }
            if (i >= items.length) {
                i = 0;
            }
            if (!this.isOnDiagram(items[i])) {
                return i;
            }
        }
        return 0;
    }
    isOnDiagram(model) {
        return this.props.view.model.elements.findIndex(element => element.iri === model.id && element.group === undefined) >= 0;
    }
    focusOn(index) {
        const container = this.root.parentElement;
        const item = this.root.children.item(index);
        const rootOffset = container.clientTop + container.offsetTop;
        const minPosition = container.scrollTop + rootOffset;
        const itemTopOffset = item.offsetTop;
        if (itemTopOffset < minPosition) {
            container.scrollTop = itemTopOffset - rootOffset;
        }
        const maxPosition = minPosition + container.clientHeight;
        const itemBottomOffset = item.offsetTop + item.clientHeight;
        if (itemBottomOffset > maxPosition) {
            container.scrollTop = itemBottomOffset - container.clientHeight - rootOffset;
        }
        item.focus();
    }
}
exports.SearchResults = SearchResults;


/***/ }),
/* 123 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EditEntityForm = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const model_1 = __webpack_require__(48);
const CLASS_NAME = 'ontodia-edit-form';
class EditEntityForm extends React.Component {
    constructor(props) {
        super(props);
        this.renderProperty = (key, property) => {
            const { view } = this.props;
            const richProperty = view.model.getProperty(key);
            const label = view.formatLabel(richProperty.label, key);
            let values = [];
            if (model_1.isIriProperty(property)) {
                values = property.values.map(({ value }) => value);
            }
            else if (model_1.isLiteralProperty(property)) {
                values = property.values.map(({ text }) => text);
            }
            return (React.createElement("div", { key: key, className: `${CLASS_NAME}__form-row` },
                React.createElement("label", null,
                    label,
                    values.map((value, index) => (React.createElement("input", { key: index, className: 'ontodia-form-control', defaultValue: value }))))));
        };
        this.onChangeLabel = (e) => {
            const target = e.target;
            const labels = target.value.length > 0 ? [{ text: target.value, lang: '' }] : [];
            this.setState({ elementModel: Object.assign(Object.assign({}, this.state.elementModel), { label: { values: labels } }) });
        };
        this.state = { elementModel: props.entity };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.entity !== nextProps.entity) {
            this.setState({ elementModel: nextProps.entity });
        }
    }
    renderProperties() {
        const { properties } = this.props.entity;
        const propertyIris = Object.keys(properties);
        return (React.createElement("div", null, propertyIris.map(iri => {
            return this.renderProperty(iri, properties[iri]);
        })));
    }
    renderType() {
        const { view } = this.props;
        const { elementModel } = this.state;
        const label = view.getElementTypeString(elementModel);
        return (React.createElement("label", null,
            "Type",
            React.createElement("input", { className: 'ontodia-form-control', value: label, disabled: true })));
    }
    renderLabel() {
        const { view } = this.props;
        const label = view.selectLabel(this.state.elementModel.label.values);
        const text = label ? label.text : '';
        return (React.createElement("label", null,
            "Label",
            React.createElement("input", { className: 'ontodia-form-control', value: text, onChange: this.onChangeLabel })));
    }
    render() {
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__body` },
                React.createElement("div", { className: `${CLASS_NAME}__form-row` }, this.renderType()),
                React.createElement("div", { className: `${CLASS_NAME}__form-row` }, this.renderLabel()),
                this.renderProperties()),
            React.createElement("div", { className: `${CLASS_NAME}__controls` },
                React.createElement("button", { className: `ontodia-btn ontodia-btn-success ${CLASS_NAME}__apply-button`, onClick: () => this.props.onApply(this.state.elementModel) }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    }
}
exports.EditEntityForm = EditEntityForm;


/***/ }),
/* 124 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EditElementTypeForm = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const model_1 = __webpack_require__(48);
const elements_1 = __webpack_require__(53);
const async_1 = __webpack_require__(61);
const progressBar_1 = __webpack_require__(120);
const elementTypeSelector_1 = __webpack_require__(125);
const linkTypeSelector_1 = __webpack_require__(127);
const CLASS_NAME = 'ontodia-edit-form';
class EditElementTypeForm extends React.Component {
    constructor(props) {
        super(props);
        this.validationCancellation = new async_1.Cancellation();
        this.state = {
            elementValue: { value: props.target, validated: true },
            linkValue: { value: { link: props.link, direction: elements_1.LinkDirection.out }, validated: true },
            isValid: true,
        };
    }
    componentDidMount() {
        this.validate();
    }
    componentDidUpdate(prevProps, prevState) {
        const { elementValue, linkValue } = this.state;
        const elementChanged = !model_1.sameElement(elementValue.value, prevState.elementValue.value);
        const linkChanged = !model_1.sameLink(linkValue.value.link, prevState.linkValue.value.link);
        if (elementChanged || linkChanged) {
            if (elementChanged) {
                this.resetLinkValue();
            }
            this.validate();
        }
        if (elementValue !== prevState.elementValue && elementValue.validated && !elementValue.error) {
            this.props.onChangeElement(elementValue.value);
        }
        if (linkValue !== prevState.linkValue && linkValue.validated && !linkValue.error) {
            this.props.onChangeLink(linkValue.value.link);
        }
    }
    componentWillUnmount() {
        this.validationCancellation.abort();
    }
    resetLinkValue() {
        const { link: originalLink } = this.props;
        this.setState(({ elementValue: { value: element } }) => {
            const link = Object.assign(Object.assign({}, originalLink), { targetId: element.id });
            return { linkValue: { value: { link, direction: elements_1.LinkDirection.out }, error: undefined, validated: false } };
        });
    }
    validate() {
        const { editor, link: originalLink } = this.props;
        const { elementValue: { value: element }, linkValue: { value } } = this.state;
        this.setState({ isValidating: true });
        this.validationCancellation.abort();
        this.validationCancellation = new async_1.Cancellation();
        const signal = this.validationCancellation.signal;
        const validateElement = elementTypeSelector_1.validateElementType(element);
        const validateLink = linkTypeSelector_1.validateLinkType(editor, value.link, originalLink);
        Promise.all([validateElement, validateLink]).then(([elementError, linkError]) => {
            if (signal.aborted) {
                return;
            }
            this.setState(({ elementValue, linkValue }) => ({
                elementValue: Object.assign(Object.assign({}, elementValue), { error: elementError, validated: true }),
                linkValue: Object.assign(Object.assign({}, linkValue), { error: linkError, validated: true }),
                isValid: !(elementError || linkError),
                isValidating: false,
            }));
        });
    }
    render() {
        const { editor, view, metadataApi, source } = this.props;
        const { elementValue, linkValue, isValid, isValidating } = this.state;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__body` },
                React.createElement(elementTypeSelector_1.ElementTypeSelector, { editor: editor, view: view, metadataApi: metadataApi, source: source, elementValue: elementValue, onChange: value => this.setState({ elementValue: { value, error: undefined, validated: false } }) }),
                React.createElement(linkTypeSelector_1.LinkTypeSelector, { editor: editor, view: view, metadataApi: metadataApi, linkValue: linkValue, source: source, target: elementValue.value, onChange: value => this.setState({ linkValue: { value, error: undefined, validated: false } }), disabled: elementValue.error !== undefined }),
                isValidating ? (React.createElement("div", { className: `${CLASS_NAME}__progress` },
                    React.createElement(progressBar_1.ProgressBar, { state: progressBar_1.ProgressState.loading, height: 10 }))) : null),
            React.createElement("div", { className: `${CLASS_NAME}__controls` },
                React.createElement("button", { className: `ontodia-btn ontodia-btn-success ${CLASS_NAME}__apply-button`, onClick: () => this.props.onApply(elementValue.value, linkValue.value.link), disabled: !isValid || isValidating }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    }
}
exports.EditElementTypeForm = EditElementTypeForm;


/***/ }),
/* 125 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateElementType = exports.ElementTypeSelector = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const schema_1 = __webpack_require__(54);
const instancesSearch_1 = __webpack_require__(126);
const listElementView_1 = __webpack_require__(121);
const async_1 = __webpack_require__(61);
const spinner_1 = __webpack_require__(90);
const CLASS_NAME = 'ontodia-edit-form';
class ElementTypeSelector extends React.Component {
    constructor(props) {
        super(props);
        this.cancellation = new async_1.Cancellation();
        this.filterCancellation = new async_1.Cancellation();
        this.newIriCancellation = new async_1.Cancellation();
        this.onElementTypeChange = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoading: true });
            this.newIriCancellation.abort();
            this.newIriCancellation = new async_1.Cancellation();
            const signal = this.newIriCancellation.signal;
            const { elementValue, onChange, metadataApi } = this.props;
            const classId = e.target.value;
            const type = this.props.editor.model.createClass(classId);
            const typeName = this.props.view.formatLabel(type.label, type.id);
            const types = [classId];
            const newId = yield metadataApi.generateNewElementIri(types, signal);
            if (signal.aborted) {
                return;
            }
            this.setState({ isLoading: false });
            onChange(Object.assign(Object.assign({}, elementValue.value), { id: newId, types: types, label: { values: [{ text: `New ${typeName}`, lang: '' }] } }));
        });
        this.renderPossibleElementType = (elementType) => {
            const { view } = this.props;
            const type = view.model.createClass(elementType);
            const label = view.formatLabel(type.label, type.id);
            return React.createElement("option", { key: elementType, value: elementType }, label);
        };
        this.state = { searchString: '', existingElements: [] };
    }
    componentDidMount() {
        this.fetchPossibleElementTypes();
    }
    componentDidUpdate(prevProps, prevState) {
        const { searchString } = this.state;
        if (searchString !== prevState.searchString) {
            this.searchExistingElements();
        }
    }
    componentWillUnmount() {
        this.cancellation.abort();
        this.filterCancellation.abort();
        this.newIriCancellation.abort();
    }
    fetchPossibleElementTypes() {
        const { view, metadataApi, source } = this.props;
        if (!metadataApi) {
            return;
        }
        metadataApi.typesOfElementsDraggedFrom(source, this.cancellation.signal).then(elementTypes => {
            if (this.cancellation.signal.aborted) {
                return;
            }
            elementTypes.sort(makeElementTypeComparatorByLabel(view));
            this.setState({ elementTypes });
        });
    }
    searchExistingElements() {
        const { editor, view } = this.props;
        const { searchString } = this.state;
        this.setState({ existingElements: [] });
        if (searchString.length > 0) {
            this.setState({ isLoading: true });
            this.filterCancellation.abort();
            this.filterCancellation = new async_1.Cancellation();
            const signal = this.filterCancellation.signal;
            const request = instancesSearch_1.createRequest({ text: searchString }, view.getLanguage(), {
                inputText: '',
                quering: false,
                resultId: 0,
                error: undefined,
                items: [],
                items_filtred: [],
                sourceNames: [],
                selection: undefined,
                moreItemsAvailable: false
            });
            editor.model.dataProvider.filter(request).then(elements => {
                if (signal.aborted) {
                    return;
                }
                const existingElements = Object.keys(elements).map(key => elements[key]);
                this.setState({ existingElements, isLoading: false });
            });
        }
    }
    renderElementTypeSelector() {
        const { elementValue } = this.props;
        const { elementTypes, isLoading } = this.state;
        const value = elementValue.value.types.length ? elementValue.value.types[0] : '';
        if (isLoading) {
            return React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 });
        }
        return (React.createElement("div", { className: `${CLASS_NAME}__control-row` },
            React.createElement("label", null, "Entity Type"),
            elementTypes ? (React.createElement("select", { className: 'ontodia-form-control', value: value, onChange: this.onElementTypeChange },
                React.createElement("option", { value: schema_1.PLACEHOLDER_ELEMENT_TYPE, disabled: true }, "Select entity type"),
                elementTypes.map(this.renderPossibleElementType))) : React.createElement("div", null,
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 })),
            elementValue.error ? React.createElement("span", { className: `${CLASS_NAME}__control-error` }, elementValue.error) : ''));
    }
    renderExistingElementsList() {
        const { view, elementValue, onChange } = this.props;
        const { elementTypes, isLoading, existingElements } = this.state;
        if (isLoading) {
            return React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 });
        }
        if (existingElements.length > 0) {
            return existingElements.map(element => {
                const isAlreadyOnDiagram = Boolean(view.model.elements.find(({ iri, group }) => iri === element.id && group === undefined));
                const hasAppropriateType = Boolean(elementTypes.find(type => element.types.indexOf(type) >= 0));
                return (React.createElement(listElementView_1.ListElementView, { key: element.id, view: view, model: element, disabled: isAlreadyOnDiagram || !hasAppropriateType, selected: element.id === elementValue.value.id, onClick: (e, model) => onChange(model) }));
            });
        }
        return React.createElement("span", null, "No results");
    }
    render() {
        const { searchString } = this.state;
        return (React.createElement("div", { className: `${CLASS_NAME}__form-row ${CLASS_NAME}__element-selector` },
            React.createElement("div", { className: `${CLASS_NAME}__search` },
                React.createElement("i", { className: `fa fa-search ${CLASS_NAME}__search-icon` }),
                React.createElement("input", { value: searchString, onChange: e => this.setState({ searchString: e.target.value }), className: `ontodia-form-control ${CLASS_NAME}__search-input`, placeholder: 'Search for...', autoFocus: true })),
            searchString.length > 0 ? (React.createElement("div", { className: `${CLASS_NAME}__existing-elements-list` }, this.renderExistingElementsList())) : (React.createElement("div", null,
                React.createElement("div", { className: `${CLASS_NAME}__separator` },
                    React.createElement("i", { className: `${CLASS_NAME}__separator-text` }, "or create new entity")),
                this.renderElementTypeSelector()))));
    }
}
exports.ElementTypeSelector = ElementTypeSelector;
function makeElementTypeComparatorByLabel(view) {
    return (a, b) => {
        const typeA = view.model.createClass(a);
        const typeB = view.model.createClass(b);
        const labelA = view.formatLabel(typeA.label, typeA.id);
        const labelB = view.formatLabel(typeB.label, typeB.id);
        return labelA.localeCompare(labelB);
    };
}
function validateElementType(element) {
    const isElementTypeSelected = element.types.indexOf(schema_1.PLACEHOLDER_ELEMENT_TYPE) < 0;
    const error = !isElementTypeSelected ? 'Required!' : undefined;
    return Promise.resolve(error);
}
exports.validateElementType = validateElementType;


/***/ }),
/* 126 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createRequest = exports.InstancesSearch = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const events_1 = __webpack_require__(55);
const progressBar_1 = __webpack_require__(120);
const searchResults_1 = __webpack_require__(122);
const workspaceContext_1 = __webpack_require__(88);
const DirectionInImage = __webpack_require__(11);
const DirectionOutImage = __webpack_require__(12);
const CLASS_NAME = 'ontodia-instances-search';
class InstancesSearch extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.listener = new events_1.EventObserver();
        this.onSelectionChanged = (newSelection) => {
            this.setState({ selection: newSelection }, () => {
                // Questo verrà chiamato dopo che lo stato è stato effettivamente aggiornato
                this.updateSearchResultsInRedux();
            });
        };
        this.state = {
            resultId: 0,
            selection: new Set(),
            items_filtred: [],
            sourceNames: [],
            selectedSource: '',
        };
    }
    extractSourceNames() {
        const sourceNames = [];
        const providers = this.props.model.dataProvider;
        if (providers && providers.dataProviders) {
            providers.dataProviders.forEach(provider => {
                if (provider.dataProvider && provider.dataProvider.options) {
                    const optionsName = provider.dataProvider.options.name;
                    const providerName = provider.name;
                    if (optionsName && providerName) {
                        sourceNames.push([optionsName, providerName]);
                    }
                }
            });
        }
        this.setState({ sourceNames: sourceNames });
    }
    updateSearchResultsInRedux() {
        // Creiamo un nuovo oggetto searchResults da inviare a Redux
        const newSearchResults = {
            items: this.state.items,
            inputText: this.state.inputText,
            quering: this.state.quering,
            moreItemsAvailable: this.state.moreItemsAvailable,
            items_filtred: this.state.items_filtred,
            sourceNames: this.state.sourceNames,
            selection: this.state.selection,
        };
        // Invia l'azione Redux per aggiornare i risultati di ricerca
        // console.log(this.props)
        try {
            this.props.onResultsChanged(newSearchResults);
        }
        catch (error) {
            console.log("Error in updateSearchResultsInRedux: " + error);
            // assicurati che onResultsChanged sia una funzione
        }
    }
    filterResultsBySource(source) {
        console.log(source);
        const strSource = source.toString();
        this.setState({ selectedSource: strSource });
        // console.log(strSource);
        const filteredItems = this.state.items.filter(item => {
            return item.sources.some(s => s === strSource);
        });
        this.setState({ items_filtred: filteredItems }, () => {
            // Questo verrà chiamato dopo che lo stato è stato effettivamente aggiornato
            this.updateSearchResultsInRedux();
        });
    }
    deleteFilter() {
        this.setState({ items_filtred: [], selectedSource: 'all' });
        this.setState({ selectedSource: 'all' });
    }
    render() {
        const ENTER_KEY_CODE = 13;
        const className = `${CLASS_NAME} ${this.props.className || ''}`;
        const progressState = (this.state.quering ? progressBar_1.ProgressState.loading :
            this.state.error ? progressBar_1.ProgressState.error :
                this.state.items ? progressBar_1.ProgressState.completed :
                    progressBar_1.ProgressState.none);
        const searchTerm = this.state.inputText === undefined
            ? this.props.criteria.text : this.state.inputText;
        return React.createElement("div", { className: className },
            React.createElement(progressBar_1.ProgressBar, { state: progressState }),
            React.createElement("div", { className: `${CLASS_NAME}__criteria` },
                this.renderCriteria(),
                React.createElement("div", { className: `${CLASS_NAME}__text-criteria ontodia-input-group` },
                    React.createElement("input", { type: 'text', className: 'ontodia-form-control', placeholder: 'Search for...', value: searchTerm || '', onChange: e => this.setState({ inputText: e.currentTarget.value }), onKeyUp: e => {
                            if (e.keyCode === ENTER_KEY_CODE) {
                                this.submitCriteriaUpdate();
                            }
                        } }),
                    React.createElement("span", { className: 'ontodia-input-group-btn' },
                        React.createElement("button", { className: 'ontodia-btn ontodia-btn-default', type: 'button', title: 'Search', onClick: () => this.submitCriteriaUpdate() },
                            React.createElement("span", { className: 'fa fa-search', "aria-hidden": 'true' }))))),
            this.state.items && this.state.sourceNames ?
                React.createElement("div", { className: `${CLASS_NAME}__filter-buttons` },
                    this.state.sourceNames.map(source => (React.createElement("button", { key: source[1], type: 'button', className: `ontodia-btn ontodia-btn-default ${this.state.selectedSource === source[1] ? 'selected' : ''}`, onClick: () => this.filterResultsBySource(source[1]) }, source[0]))),
                    React.createElement("button", { type: 'button', className: `ontodia-btn ontodia-btn-default ${this.state.selectedSource === 'all' ? 'selected' : ''}`, onClick: () => this.deleteFilter() }, "See all"))
                : null,
            React.createElement("div", { className: `${CLASS_NAME}__rest ontodia-scrollable`, key: this.state.resultId },
                React.createElement(searchResults_1.SearchResults, { view: this.props.view, items: this.state.items_filtred && this.state.items_filtred.length != 0 ? this.state.items_filtred : this.state.items, highlightText: this.props.criteria.text, selection: this.state.selection, onSelectionChanged: this.onSelectionChanged }),
                React.createElement("div", { className: `${CLASS_NAME}__rest-end` },
                    React.createElement("button", { type: 'button', className: `${CLASS_NAME}__load-more ontodia-btn ontodia-btn-primary`, disabled: this.state.quering, style: { display: this.state.moreItemsAvailable ? undefined : 'none' }, onClick: () => this.queryItems(true) },
                        React.createElement("span", { className: 'fa fa-chevron-down', "aria-hidden": 'true' }),
                        "\u00A0Show more"))));
    }
    renderCriteria() {
        const { criteria = {}, view } = this.props;
        const criterions = [];
        if (criteria.elementType) {
            const classInfo = criteria.elementType;
            const classLabel = view.formatLabel(classInfo.label, classInfo.id);
            criterions.push(React.createElement("div", { key: 'hasType', className: `${CLASS_NAME}__criterion` },
                this.renderRemoveCriterionButtons(() => this.props.onCriteriaChanged(Object.assign(Object.assign({}, this.props.criteria), { elementType: undefined }))),
                "Has type ",
                React.createElement("span", { className: `${CLASS_NAME}__criterion-class`, title: classInfo.id }, classLabel)));
        }
        else if (criteria.refElement) {
            const element = criteria.refElement;
            const elementLabel = view.formatLabel(element.data.label.values, element.iri);
            const linkType = criteria.refElementLink;
            const linkTypeLabel = linkType ? view.formatLabel(linkType.label, linkType.id) : undefined;
            criterions.push(React.createElement("div", { key: 'hasLinkedElement', className: `${CLASS_NAME}__criterion` },
                this.renderRemoveCriterionButtons(() => this.props.onCriteriaChanged(Object.assign(Object.assign({}, this.props.criteria), { refElement: undefined, refElementLink: undefined }))),
                "Connected to ",
                React.createElement("span", { className: `${CLASS_NAME}__criterion-element`, title: element ? element.iri : undefined }, elementLabel),
                linkType && React.createElement("span", null,
                    ' through ',
                    React.createElement("span", { className: `${CLASS_NAME}__criterion-link-type`, title: linkType ? linkType.id : undefined }, linkTypeLabel),
                    criteria.linkDirection === 'in' && React.createElement("span", null,
                        ' as ',
                        React.createElement("img", { className: `${CLASS_NAME}__link-direction`, src: DirectionInImage }),
                        "\u00A0source"),
                    criteria.linkDirection === 'out' && React.createElement("span", null,
                        ' as ',
                        React.createElement("img", { className: `${CLASS_NAME}__link-direction`, src: DirectionOutImage }),
                        "\u00A0target"))));
        }
        return React.createElement("div", { className: `${CLASS_NAME}__criterions` }, criterions);
    }
    renderRemoveCriterionButtons(onClick) {
        return React.createElement("div", { className: `${CLASS_NAME}__criterion-remove ontoidia-btn-group ontodia-btn-group-xs` },
            React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Remove criteria', onClick: onClick },
                React.createElement("span", { className: 'fa fa-times', "aria-hidden": 'true' })));
    }
    submitCriteriaUpdate() {
        let text = this.state.inputText === undefined ? this.props.criteria.text : this.state.inputText;
        text = text === '' ? undefined : text;
        this.props.onCriteriaChanged(Object.assign(Object.assign({}, this.props.criteria), { text }));
    }
    componentDidMount() {
        this.listener.listen(this.props.view.events, 'changeLanguage', () => this.forceUpdate());
        this.queryItems(false);
    }
    componentDidUpdate(prevProps, prevState) {
        // Controlla se gli items sono stati aggiornati
        if (prevState.items !== this.state.items) {
            this.updateSearchResultsInRedux();
        }
    }
    componentWillReceiveProps(nextProps) {
        const languageChanged = this.currentRequest
            ? this.currentRequest.languageCode !== nextProps.view.getLanguage() : false;
        if (this.props.criteria !== nextProps.criteria || languageChanged) {
            this.setState({ inputText: undefined }, () => this.queryItems(false));
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.currentRequest = undefined;
    }
    queryItems(loadMoreItems) {
        let request;
        if (loadMoreItems) {
            if (!this.currentRequest) {
                throw new Error('Cannot request more items without initial request.');
            }
            const { offset, limit } = this.currentRequest;
            request = Object.assign(Object.assign({}, this.currentRequest), { offset: offset + limit });
        }
        else {
            request = createRequest(this.props.criteria, this.props.view.getLanguage(), this.props.searchResults);
        }
        if (!(request.text || request.elementTypeId || request.refElementId || request.refElementLinkId)) {
            this.setState({
                quering: false,
                error: undefined,
                items: undefined,
                selection: new Set(),
                moreItemsAvailable: false,
            });
            return;
        }
        this.currentRequest = request;
        this.setState({
            quering: true,
            error: undefined,
            moreItemsAvailable: false,
        });
        this.props.model.dataProvider.filter(request).then(elements => {
            if (this.currentRequest !== request) {
                return;
            }
            this.processFilterData(elements);
            this.context.ontodiaWorkspace.triggerWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.searchQueryItem);
            this.extractSourceNames();
            this.updateSearchResultsInRedux();
        }).catch(error => {
            if (this.currentRequest !== request) {
                return;
            }
            // tslint:disable-next-line:no-console
            console.error(error);
            this.setState({ quering: false, error });
        });
    }
    processFilterData(elements) {
        const requestedAdditionalItems = this.currentRequest.offset > 0;
        const existingIris = {};
        if (requestedAdditionalItems) {
            this.state.items.forEach(item => existingIris[item.id] = true);
        }
        const items = requestedAdditionalItems ? [...this.state.items] : [];
        for (const iri in elements) {
            if (!elements.hasOwnProperty(iri)) {
                continue;
            }
            if (existingIris[iri]) {
                continue;
            }
            items.push(elements[iri]);
        }
        const moreItemsAvailable = Object.keys(elements).length >= this.currentRequest.limit;
        if (requestedAdditionalItems) {
            this.setState({ quering: false, items, error: undefined, moreItemsAvailable });
        }
        else {
            this.setState({
                quering: false,
                resultId: this.state.resultId + 1,
                items,
                selection: new Set(),
                error: undefined,
                moreItemsAvailable,
            });
        }
    }
}
exports.InstancesSearch = InstancesSearch;
InstancesSearch.contextTypes = workspaceContext_1.WorkspaceContextTypes;
function createRequest(criteria, language, searchResults) {
    const { text, elementType, refElement, refElementLink, linkDirection } = criteria;
    const { moreItemsAvailable, inputText, items, quering, items_filtred, sourceNames, selection } = searchResults;
    return {
        inputText: inputText,
        items: items,
        sourceNames: sourceNames,
        selection: selection,
        quering: quering,
        items_filtred: items_filtred,
        moreItemsAvailable: moreItemsAvailable,
        text,
        elementTypeId: elementType ? elementType.id : undefined,
        refElementId: refElement ? refElement.iri : undefined,
        refElementLinkId: refElementLink ? refElementLink.id : undefined,
        linkDirection,
        offset: 0,
        limit: 100,
        languageCode: language || 'en',
    };
}
exports.createRequest = createRequest;


/***/ }),
/* 127 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateLinkType = exports.LinkTypeSelector = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const model_1 = __webpack_require__(48);
const schema_1 = __webpack_require__(54);
const elements_1 = __webpack_require__(53);
const events_1 = __webpack_require__(55);
const async_1 = __webpack_require__(61);
const spinner_1 = __webpack_require__(90);
const CLASS_NAME = 'ontodia-edit-form';
class LinkTypeSelector extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.cancellation = new async_1.Cancellation();
        this.updateAll = () => this.forceUpdate();
        this.onChangeType = (e) => {
            const { link: originalLink, direction: originalDirection } = this.props.linkValue.value;
            const index = parseInt(e.currentTarget.value, 10);
            const { fatLinkType, direction } = this.state.fatLinkTypes[index];
            const link = Object.assign(Object.assign({}, originalLink), { linkTypeId: fatLinkType.id });
            // switches source and target if the direction has changed
            if (originalDirection !== direction) {
                link.sourceId = originalLink.targetId;
                link.targetId = originalLink.sourceId;
            }
            this.props.onChange({ link, direction });
            console.log('onChangeType', { link, direction, fatLinkType, index });
        };
        this.renderPossibleLinkType = ({ fatLinkType, direction }, index) => {
            const { view, linkValue, source, target } = this.props;
            const label = view.formatLabel(fatLinkType.label, fatLinkType.id);
            let [sourceLabel, targetLabel] = [source, target].map(element => view.formatLabel(element.label.values, element.id));
            if (direction !== linkValue.value.direction) {
                [sourceLabel, targetLabel] = [targetLabel, sourceLabel];
            }
            return React.createElement("option", { key: index, value: index },
                label,
                " [",
                sourceLabel,
                " \u2192 ",
                targetLabel,
                "]");
        };
        this.state = {
            fatLinkTypes: [],
        };
    }
    componentDidMount() {
        this.fetchPossibleLinkTypes();
    }
    componentDidUpdate(prevProps) {
        const { source, target } = this.props;
        if (prevProps.source !== source || prevProps.target !== target) {
            this.setState({ fatLinkTypes: undefined });
            this.fetchPossibleLinkTypes();
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.cancellation.abort();
    }
    fetchPossibleLinkTypes() {
        const { view, metadataApi, source, target } = this.props;
        if (!metadataApi) {
            return;
        }
        metadataApi.possibleLinkTypes(source, target, this.cancellation.signal).then(linkTypes => {
            if (this.cancellation.signal.aborted) {
                return;
            }
            const fatLinkTypes = [];
            linkTypes.forEach(({ linkTypeIri, direction }) => {
                const fatLinkType = view.model.createLinkType(linkTypeIri);
                fatLinkTypes.push({ fatLinkType, direction });
            });
            fatLinkTypes.sort(makeLinkTypeComparatorByLabelAndDirection(view));
            this.setState({ fatLinkTypes });
            this.listenToLinkLabels(fatLinkTypes);
            console.log('possibleLinkTypes', fatLinkTypes);
        });
    }
    listenToLinkLabels(fatLinkTypes) {
        fatLinkTypes.forEach(({ fatLinkType }) => this.listener.listen(fatLinkType.events, 'changeLabel', this.updateAll));
        console.log('listenToLinkLabels', fatLinkTypes);
    }
    render() {
        const { linkValue, disabled } = this.props;
        const { fatLinkTypes } = this.state;
        const value = (fatLinkTypes || []).findIndex(({ fatLinkType, direction }) => fatLinkType.id === linkValue.value.link.linkTypeId && direction === linkValue.value.direction);
        return (React.createElement("div", { className: `${CLASS_NAME}__control-row` },
            React.createElement("label", null, "Link Type"),
            fatLinkTypes ? (React.createElement("select", { className: 'ontodia-form-control', value: value, onChange: this.onChangeType, disabled: disabled },
                React.createElement("option", { value: -1, disabled: true }, "Select link type"),
                fatLinkTypes.map(this.renderPossibleLinkType))) : React.createElement("div", null,
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 })),
            linkValue.error ? React.createElement("span", { className: `${CLASS_NAME}__control-error` }, linkValue.error) : ''));
    }
}
exports.LinkTypeSelector = LinkTypeSelector;
function makeLinkTypeComparatorByLabelAndDirection(view) {
    return (a, b) => {
        const labelA = view.formatLabel(a.fatLinkType.label, a.fatLinkType.id);
        const labelB = view.formatLabel(b.fatLinkType.label, b.fatLinkType.id);
        const labelCompareResult = labelA.localeCompare(labelB);
        if (labelCompareResult !== 0) {
            return labelCompareResult;
        }
        if (a.direction === elements_1.LinkDirection.out && b.direction === elements_1.LinkDirection.in) {
            return -1;
        }
        if (a.direction === elements_1.LinkDirection.in && b.direction === elements_1.LinkDirection.out) {
            return 1;
        }
        return 0;
    };
}
function validateLinkType(editor, currentLink, originalLink) {
    if (currentLink.linkTypeId === schema_1.PLACEHOLDER_LINK_TYPE) {
        return Promise.resolve('Required!');
    }
    if (model_1.sameLink(currentLink, originalLink)) {
        return Promise.resolve(undefined);
    }
    const alreadyOnDiagram = editor.model.links.find(({ data: { linkTypeId, sourceId, targetId } }) => linkTypeId === currentLink.linkTypeId &&
        sourceId === currentLink.sourceId &&
        targetId === currentLink.targetId &&
        !editor.temporaryState.links.has(currentLink));
    if (alreadyOnDiagram) {
        return Promise.resolve('The link already exists!');
    }
    return editor.model.dataProvider.linksInfo({
        elementIds: [currentLink.sourceId, currentLink.targetId],
        linkTypeIds: [currentLink.linkTypeId],
    }).then(links => {
        const alreadyExists = links.some(link => model_1.sameLink(link, currentLink));
        return alreadyExists ? 'The link already exists!' : undefined;
    });
}
exports.validateLinkType = validateLinkType;


/***/ }),
/* 128 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EditLinkForm = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const model_1 = __webpack_require__(48);
const elements_1 = __webpack_require__(53);
const async_1 = __webpack_require__(61);
const progressBar_1 = __webpack_require__(120);
const linkTypeSelector_1 = __webpack_require__(127);
const CLASS_NAME = 'ontodia-edit-form';
class EditLinkForm extends React.Component {
    constructor(props) {
        super(props);
        this.validationCancellation = new async_1.Cancellation();
        this.state = {
            linkValue: {
                value: { link: props.link, direction: elements_1.LinkDirection.out },
                validated: true,
            },
            isValid: true,
        };
    }
    componentDidMount() {
        this.validate();
    }
    componentDidUpdate(prevProps, prevState) {
        const { linkValue } = this.state;
        if (!model_1.sameLink(linkValue.value.link, prevState.linkValue.value.link)) {
            this.validate();
        }
        if (linkValue !== prevState.linkValue && linkValue.validated && !linkValue.error) {
            this.props.onChange(linkValue.value.link);
        }
    }
    componentWillUnmount() {
        this.validationCancellation.abort();
    }
    validate() {
        const { editor, link: originalLink } = this.props;
        const { linkValue: { value } } = this.state;
        this.setState({ isValidating: true });
        this.validationCancellation.abort();
        this.validationCancellation = new async_1.Cancellation();
        const signal = this.validationCancellation.signal;
        linkTypeSelector_1.validateLinkType(editor, value.link, originalLink).then(error => {
            if (signal.aborted) {
                return;
            }
            this.setState(({ linkValue }) => ({
                linkValue: Object.assign(Object.assign({}, linkValue), { error, validated: true }),
                isValid: !error,
                isValidating: false,
            }));
        });
    }
    render() {
        const { editor, view, metadataApi, source, target } = this.props;
        const { linkValue, isValid, isValidating } = this.state;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__body` },
                React.createElement(linkTypeSelector_1.LinkTypeSelector, { editor: editor, view: view, metadataApi: metadataApi, linkValue: linkValue, source: source, target: target, onChange: value => this.setState({ linkValue: { value, error: undefined, validated: false } }) }),
                isValidating ? (React.createElement("div", { className: `${CLASS_NAME}__progress` },
                    React.createElement(progressBar_1.ProgressBar, { state: progressBar_1.ProgressState.loading, height: 10 }))) : null),
            React.createElement("div", { className: `${CLASS_NAME}__controls` },
                React.createElement("button", { className: `ontodia-btn ontodia-btn-success ${CLASS_NAME}__apply-button`, onClick: () => this.props.onApply(linkValue.value.link), disabled: !isValid || isValidating }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    }
}
exports.EditLinkForm = EditLinkForm;


/***/ }),
/* 129 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EditLinkLabelForm = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const CLASS_NAME = 'ontodia-edit-form';
class EditLinkLabelForm extends React.Component {
    constructor(props) {
        super(props);
        const label = this.computeLabel();
        this.state = { label };
    }
    componentDidUpdate(prevProps) {
        if (this.props.link.typeId !== prevProps.link.typeId) {
            const label = this.computeLabel();
            this.setState({ label });
        }
    }
    computeLabel() {
        const { view, link } = this.props;
        const linkType = view.model.getLinkType(link.typeId);
        const template = view.createLinkTemplate(linkType);
        const { label = {} } = template.renderLink(link);
        const labelTexts = label.attrs && label.attrs.text ? label.attrs.text.text : undefined;
        return (labelTexts && labelTexts.length > 0)
            ? view.selectLabel(labelTexts).text
            : view.formatLabel(linkType.label, linkType.id);
    }
    render() {
        const { onApply, onCancel } = this.props;
        const { label } = this.state;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__body` },
                React.createElement("div", { className: `${CLASS_NAME}__form-row` },
                    React.createElement("label", null, "Link Label"),
                    React.createElement("input", { className: 'ontodia-form-control', value: label, onChange: e => this.setState({ label: e.target.value }) }))),
            React.createElement("div", { className: `${CLASS_NAME}__controls` },
                React.createElement("button", { className: `ontodia-btn ontodia-btn-success ${CLASS_NAME}__apply-button`, onClick: () => onApply(label) }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: () => onCancel() }, "Cancel"))));
    }
}
exports.EditLinkLabelForm = EditLinkLabelForm;


/***/ }),
/* 130 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Halo = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const geometry_1 = __webpack_require__(57);
const authoringState_1 = __webpack_require__(89);
const events_1 = __webpack_require__(55);
const async_1 = __webpack_require__(61);
const spinner_1 = __webpack_require__(90);
const CLASS_NAME = 'ontodia-halo';
class Halo extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.targetListener = new events_1.EventObserver();
        this.queryDebouncer = new async_1.Debouncer();
        this.queryCancellation = new async_1.Cancellation();
        this.onElementEvent = data => {
            if (data.changePosition || data.changeSize || data.changeExpanded) {
                this.forceUpdate();
            }
            if (data.changeData) {
                this.queryAllowedActions();
            }
        };
        this.onEstablishNewLink = (e) => {
            const point = this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
            this.props.onEstablishNewLink(point);
        };
        this.state = {};
    }
    componentDidMount() {
        const { editor, target } = this.props;
        this.listener.listen(editor.events, 'changeAuthoringState', () => {
            this.queryAllowedActions();
        });
        this.listenToElement(target);
        this.queryAllowedActions();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.target !== this.props.target) {
            this.listenToElement(this.props.target);
            this.queryAllowedActions();
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.listenToElement(undefined);
        this.queryDebouncer.dispose();
        this.queryCancellation.abort();
    }
    listenToElement(element) {
        this.targetListener.stopListening();
        if (element) {
            this.targetListener.listenAny(element.events, this.onElementEvent);
        }
    }
    queryAllowedActions() {
        this.queryDebouncer.call(() => {
            this.queryCancellation.abort();
            this.queryCancellation = new async_1.Cancellation();
            this.canLink(this.props.target);
        });
    }
    canLink(target) {
        const { metadataApi, editor } = this.props;
        if (!metadataApi) {
            this.setState({ canLink: false });
            return;
        }
        const event = editor.authoringState.index.elements.get(target.iri);
        if (event && event.type === authoringState_1.AuthoringKind.DeleteElement) {
            this.setState({ canLink: false });
        }
        else {
            this.setState({ canLink: undefined });
            const signal = this.queryCancellation.signal;
            metadataApi.canLinkElement(target.data, signal).then(canLink => {
                if (signal.aborted) {
                    return;
                }
                if (this.props.target.iri === target.iri) {
                    this.setState({ canLink });
                }
            });
        }
    }
    render() {
        const { paperArea, editor, target, navigationMenuOpened, onToggleNavigationMenu, onAddToFilter, onExpand, onFollowLink, } = this.props;
        if (!target) {
            return React.createElement("div", { className: CLASS_NAME, style: { display: 'none' } });
        }
        const bbox = geometry_1.boundsOf(target);
        const { x: x0, y: y0 } = paperArea.paperToScrollablePaneCoords(bbox.x, bbox.y);
        const { x: x1, y: y1 } = paperArea.paperToScrollablePaneCoords(bbox.x + bbox.width, bbox.y + bbox.height);
        const MARGIN = 5;
        const style = { left: x0 - MARGIN, top: y0 - MARGIN,
            width: ((x1 - x0) + MARGIN * 2), height: ((y1 - y0) + MARGIN * 2) };
        // console.log("halo selection:", target.iri)
        return (React.createElement("div", { className: CLASS_NAME, style: style },
            this.renderRemoveOrDeleteButton(),
            onToggleNavigationMenu && React.createElement("div", { className: `${CLASS_NAME}__navigate ` +
                    `${CLASS_NAME}__navigate--${navigationMenuOpened ? 'closed' : 'open'}`, role: 'button', title: 'Open a dialog to navigate to connected elements', onClick: onToggleNavigationMenu }),
            onFollowLink && React.createElement("a", { className: `${CLASS_NAME}__folow`, href: target.iri, role: 'button', title: 'Jump to resource', onClick: e => onFollowLink(target, e) }),
            onAddToFilter && React.createElement("div", { className: `${CLASS_NAME}__add-to-filter`, role: 'button', title: 'Search for connected elements', onClick: onAddToFilter }),
            onExpand && React.createElement("div", { className: `${CLASS_NAME}__expand ` +
                    `${CLASS_NAME}__expand--${target.isExpanded ? 'closed' : 'open'}`, role: 'button', title: `Expand an element to reveal additional properties`, onClick: onExpand }),
            editor.inAuthoringMode ? this.renderEstablishNewLinkButton() : null));
    }
    renderRemoveOrDeleteButton() {
        const { editor, target, onRemove } = this.props;
        if (!onRemove) {
            return null;
        }
        const isNewElement = authoringState_1.AuthoringState.isNewElement(editor.authoringState, target.iri);
        return (React.createElement("div", { className: isNewElement ? `${CLASS_NAME}__delete` : `${CLASS_NAME}__remove`, role: 'button', title: isNewElement ? 'Delete new element' : 'Remove an element from the diagram', onClick: onRemove }));
    }
    renderEstablishNewLinkButton() {
        const { onEstablishNewLink } = this.props;
        const { canLink } = this.state;
        if (!onEstablishNewLink) {
            return null;
        }
        if (canLink === undefined) {
            return (React.createElement("div", { className: `${CLASS_NAME}__establish-connection-spinner` },
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 })));
        }
        const title = canLink
            ? 'Establish connection'
            : 'Establishing connection is unavailable for the selected element';
        return (React.createElement("button", { className: `${CLASS_NAME}__establish-connection`, title: title, onMouseDown: this.onEstablishNewLink, disabled: !canLink }));
    }
}
exports.Halo = Halo;


/***/ }),
/* 131 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HaloLink = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const geometry_1 = __webpack_require__(57);
const authoringState_1 = __webpack_require__(89);
const events_1 = __webpack_require__(55);
const async_1 = __webpack_require__(61);
const spinner_1 = __webpack_require__(90);
const CLASS_NAME = 'ontodia-halo-link';
const BUTTON_SIZE = 20;
const BUTTON_MARGIN = 5;
class HaloLink extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.targetListener = new events_1.EventObserver();
        this.queryDebouncer = new async_1.Debouncer();
        this.queryCancellation = new async_1.Cancellation();
        this.updateAll = () => this.forceUpdate();
        this.onSourceMove = (e) => {
            const point = this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
            this.props.onSourceMove(point);
        };
        this.onTargetMove = (e) => {
            const point = this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
            this.props.onTargetMove(point);
        };
        this.state = {};
    }
    componentDidMount() {
        const { target, editor } = this.props;
        this.listener.listen(editor.events, 'changeAuthoringState', () => {
            this.queryAllowedActions();
        });
        this.listenToTarget(target);
        this.queryAllowedActions();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.target !== this.props.target) {
            this.listenToTarget(this.props.target);
            this.queryAllowedActions();
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.listenToTarget(undefined);
        this.queryDebouncer.dispose();
        this.queryCancellation.abort();
    }
    queryAllowedActions() {
        this.queryDebouncer.call(() => {
            this.queryCancellation.abort();
            this.queryCancellation = new async_1.Cancellation();
            this.queryCanDelete(this.props.target);
            this.queryCanEdit(this.props.target);
        });
    }
    queryCanDelete(link) {
        const { metadataApi, editor, view } = this.props;
        if (!metadataApi) {
            this.setState({ canDelete: false });
            return;
        }
        if (isSourceOrTargetDeleted(editor.authoringState, link)) {
            this.setState({ canDelete: false });
        }
        else {
            this.setState({ canDelete: undefined });
            const source = view.model.getElement(link.sourceId);
            const target = view.model.getElement(link.targetId);
            const signal = this.queryCancellation.signal;
            metadataApi.canDeleteLink(link.data, source.data, target.data, signal).then(canDelete => {
                if (signal.aborted) {
                    return;
                }
                if (this.props.target.id === link.id) {
                    this.setState({ canDelete });
                }
            });
        }
    }
    queryCanEdit(link) {
        const { metadataApi, editor, view } = this.props;
        if (!metadataApi) {
            this.setState({ canEdit: false });
            return;
        }
        if (isDeletedLink(editor.authoringState, link)) {
            this.setState({ canEdit: false });
        }
        else {
            this.setState({ canEdit: undefined });
            const source = view.model.getElement(link.sourceId);
            const target = view.model.getElement(link.targetId);
            const signal = this.queryCancellation.signal;
            metadataApi.canEditLink(link.data, source.data, target.data, signal).then(canEdit => {
                if (signal.aborted) {
                    return;
                }
                if (this.props.target.id === link.id) {
                    this.setState({ canEdit });
                }
            });
        }
    }
    listenToTarget(link) {
        const { view } = this.props;
        this.targetListener.stopListening();
        if (link) {
            const source = view.model.getElement(link.sourceId);
            const target = view.model.getElement(link.targetId);
            const listenToElement = (element) => {
                this.targetListener.listen(element.events, 'changePosition', this.updateAll);
                this.targetListener.listen(element.events, 'changeSize', this.updateAll);
            };
            listenToElement(source);
            listenToElement(target);
            this.targetListener.listen(link.events, 'changeVertices', this.updateAll);
            this.targetListener.listen(link.events, 'changeLabelBounds', this.updateAll);
        }
    }
    paperToScrollablePaneCoords(point) {
        return this.props.paperArea.paperToScrollablePaneCoords(point.x, point.y);
    }
    computePolyline() {
        const { view, target } = this.props;
        const sourceElement = view.model.getElement(target.sourceId);
        const targetElement = view.model.getElement(target.targetId);
        if (!(sourceElement && targetElement)) {
            return undefined;
        }
        const route = view.getRouting(target.id);
        const verticesDefinedByUser = target.vertices || [];
        const vertices = route ? route.vertices : verticesDefinedByUser;
        return geometry_1.computePolyline(sourceElement, targetElement, vertices);
    }
    calculateDegree(source, target) {
        const x = target.x - source.x;
        const y = target.y - source.y;
        const r = Math.sqrt(x * x + y * y);
        const unit = { x: x / r, y: y / r };
        return Math.atan2(unit.y, unit.x) * (180 / Math.PI);
    }
    renderSourceButton(polyline) {
        const { editor, target } = this.props;
        const point = geometry_1.getPointAlongPolyline(polyline, 0);
        const { x, y } = this.paperToScrollablePaneCoords(point);
        const style = { top: y - BUTTON_SIZE / 2, left: x - BUTTON_SIZE / 2 };
        return (React.createElement("button", { className: `${CLASS_NAME}__button`, style: style, disabled: isDeletedLink(editor.authoringState, target), onMouseDown: this.onSourceMove },
            React.createElement("svg", { width: BUTTON_SIZE, height: BUTTON_SIZE },
                React.createElement("g", { transform: `scale(${BUTTON_SIZE})` },
                    React.createElement("circle", { r: 0.5, cx: 0.5, cy: 0.5, fill: '#198AD3' })))));
    }
    getButtonPosition(polyline, index) {
        const polylineLength = geometry_1.computePolylineLength(polyline);
        const point = geometry_1.getPointAlongPolyline(polyline, polylineLength - (BUTTON_SIZE + BUTTON_MARGIN) * index);
        const { x, y } = this.paperToScrollablePaneCoords(point);
        return { top: y - BUTTON_SIZE / 2, left: x - BUTTON_SIZE / 2 };
    }
    renderTargetButton(polyline) {
        const { editor, target } = this.props;
        const style = this.getButtonPosition(polyline, 0);
        const { length } = polyline;
        const degree = this.calculateDegree(polyline[length - 1], polyline[length - 2]);
        return (React.createElement("button", { className: `${CLASS_NAME}__button`, style: style, disabled: isDeletedLink(editor.authoringState, target), onMouseDown: this.onTargetMove },
            React.createElement("svg", { width: BUTTON_SIZE, height: BUTTON_SIZE, style: { transform: `rotate(${degree}deg)` } },
                React.createElement("g", { transform: `scale(${BUTTON_SIZE})` },
                    React.createElement("polygon", { points: '0,0.5 1,1 1,0', fill: '#198AD3' })))));
    }
    renderEditButton(polyline) {
        const { canEdit } = this.state;
        const style = this.getButtonPosition(polyline, 1);
        if (canEdit === undefined) {
            return (React.createElement("div", { className: `${CLASS_NAME}__spinner`, style: style },
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 })));
        }
        const title = canEdit ? 'Edit link' : 'Editing is unavailable for the selected link';
        return (React.createElement("button", { className: `${CLASS_NAME}__button ${CLASS_NAME}__edit`, style: style, title: title, onClick: this.props.onEdit, disabled: !canEdit }));
    }
    renderDeleteButton(polyline) {
        const { canDelete } = this.state;
        const style = this.getButtonPosition(polyline, 2);
        if (canDelete === undefined) {
            return (React.createElement("div", { className: `${CLASS_NAME}__spinner`, style: style },
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 })));
        }
        const title = canDelete ? 'Delete link' : 'Deletion is unavailable for the selected link';
        return (React.createElement("button", { className: `${CLASS_NAME}__button ${CLASS_NAME}__delete`, style: style, title: title, onClick: this.props.onDelete, disabled: !canDelete }));
    }
    // Link editing implementation could be rethought in the future.
    renderEditLabelButton() {
        const { view, target, paperArea, onEditLabel } = this.props;
        const linkType = view.model.getLinkType(target.typeId);
        const template = view.createLinkTemplate(linkType);
        if (!template.setLinkLabel || !target.labelBounds) {
            return null;
        }
        const { x, y, width, height } = target.labelBounds;
        const { x: left, y: top } = paperArea.paperToScrollablePaneCoords(x + width, y + height / 2);
        const size = { width: 15, height: 17 };
        const style = { width: size.width, height: size.height, top: top - size.height / 2, left };
        return React.createElement("button", { className: `${CLASS_NAME}__edit-label-button`, style: style, onClick: () => onEditLabel(), title: 'Edit Link Label' });
    }
    render() {
        const { editor, target, metadataApi } = this.props;
        const polyline = this.computePolyline();
        if (!polyline) {
            return null;
        }
        const isAuthoringMode = Boolean(metadataApi);
        const deleteOrRevertButton = (isDeletedByItself(editor.authoringState, target) ||
            isSourceOrTargetDeleted(editor.authoringState, target) ? null : this.renderDeleteButton(polyline));
        return (React.createElement("div", { className: `${CLASS_NAME}` },
            isAuthoringMode ? this.renderTargetButton(polyline) : null,
            isAuthoringMode ? this.renderSourceButton(polyline) : null,
            !isAuthoringMode || isDeletedLink(editor.authoringState, target)
                ? null : this.renderEditButton(polyline),
            isAuthoringMode ? deleteOrRevertButton : null,
            this.renderEditLabelButton()));
    }
}
exports.HaloLink = HaloLink;
function isDeletedLink(state, link) {
    return isDeletedByItself(state, link) || isSourceOrTargetDeleted(state, link);
}
function isDeletedByItself(state, link) {
    const event = state.index.links.get(link.data);
    return event && event.type === authoringState_1.AuthoringKind.DeleteLink;
}
function isSourceOrTargetDeleted(state, link) {
    const sourceEvent = state.index.elements.get(link.data.sourceId);
    const targetEvent = state.index.elements.get(link.data.targetId);
    return ((sourceEvent && sourceEvent.type === authoringState_1.AuthoringKind.DeleteElement) ||
        (targetEvent && targetEvent.type === authoringState_1.AuthoringKind.DeleteElement));
}


/***/ }),
/* 132 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkStateWidget = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const geometry_1 = __webpack_require__(57);
const paper_1 = __webpack_require__(52);
const view_1 = __webpack_require__(66);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const spinner_1 = __webpack_require__(90);
const authoringState_1 = __webpack_require__(89);
const CLASS_NAME = `ontodia-authoring-state`;
const LINK_LABEL_MARGIN = 5;
class LinkStateWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.listener = new events_1.EventObserver();
        this.delayedUpdate = new async_1.Debouncer();
        this.scheduleUpdate = () => {
            this.delayedUpdate.call(this.performUpdate);
        };
        this.performUpdate = () => {
            this.forceUpdate();
        };
    }
    componentDidMount() {
        this.listenEvents();
    }
    componentDidUpdate(prevProps) {
        const sameEventSources = (this.props.view === prevProps.view);
        if (!sameEventSources) {
            this.listener.stopListening();
            this.listenEvents();
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
    }
    listenEvents() {
        const { editor, view } = this.props;
        this.listener.listen(editor.model.events, 'elementEvent', ({ data }) => {
            if (data.changeSize || data.changePosition) {
                this.scheduleUpdate();
            }
        });
        this.listener.listen(editor.model.events, 'linkEvent', ({ data }) => {
            if (data.changeVertices || data.changeLabelBounds) {
                this.scheduleUpdate();
            }
        });
        this.listener.listen(editor.model.events, 'changeCells', this.scheduleUpdate);
        this.listener.listen(editor.events, 'changeAuthoringState', this.scheduleUpdate);
        this.listener.listen(editor.events, 'changeTemporaryState', this.scheduleUpdate);
        this.listener.listen(editor.events, 'changeValidationState', this.scheduleUpdate);
        this.listener.listen(view.events, 'syncUpdate', ({ layer }) => {
            if (layer === view_1.RenderingLayer.Editor) {
                this.delayedUpdate.runSynchronously();
            }
        });
    }
    calculateLinkPath(link) {
        const polyline = this.calculatePolyline(link);
        return 'M' + polyline.map(({ x, y }) => `${x},${y}`).join(' L');
    }
    calculatePolyline(link) {
        const { editor, view } = this.props;
        const source = editor.model.getElement(link.sourceId);
        const target = editor.model.getElement(link.targetId);
        const route = view.getRouting(link.id);
        const verticesDefinedByUser = link.vertices || [];
        const vertices = route ? route.vertices : verticesDefinedByUser;
        return geometry_1.computePolyline(source, target, vertices);
    }
    renderLinkStateLabels() {
        const { editor } = this.props;
        return editor.model.links.map(link => {
            let renderedState = null;
            const state = editor.authoringState.index.links.get(link.data);
            if (state) {
                const onCancel = () => editor.discardChange(state);
                let statusText;
                let title;
                if (state.type === authoringState_1.AuthoringKind.ChangeLink && !state.before) {
                    statusText = 'New';
                    title = 'Revert creation of the link';
                }
                else if (state.type === authoringState_1.AuthoringKind.ChangeLink && state.before) {
                    statusText = 'Change';
                    title = 'Revert all changes in properties of the link';
                }
                else if (state.type === authoringState_1.AuthoringKind.DeleteLink) {
                    statusText = 'Delete';
                    title = 'Revert deletion of the link';
                }
                if (statusText && title) {
                    renderedState = (React.createElement("span", null,
                        React.createElement("span", { className: `${CLASS_NAME}__state-label` }, statusText),
                        "[",
                        React.createElement("span", { className: `${CLASS_NAME}__state-cancel`, onClick: onCancel, title: title }, "cancel"),
                        "]"));
                }
            }
            const renderedErrors = this.renderLinkErrors(link.data);
            if (renderedState || renderedErrors) {
                const labelPosition = this.getLinkStateLabelPosition(link);
                if (!labelPosition) {
                    return null;
                }
                const style = { left: labelPosition.x, top: labelPosition.y };
                return React.createElement("div", { className: `${CLASS_NAME}__state-indicator`, key: link.id, style: style },
                    React.createElement("div", { className: `${CLASS_NAME}__state-indicator-container` },
                        React.createElement("div", { className: `${CLASS_NAME}__state-indicator-body` },
                            renderedState,
                            renderedErrors)));
            }
            else {
                return null;
            }
        });
    }
    renderLinkStateHighlighting() {
        const { editor } = this.props;
        return editor.model.links.map(link => {
            if (editor.temporaryState.links.has(link.data)) {
                const path = this.calculateLinkPath(link);
                return (React.createElement("path", { key: link.id, d: path, fill: 'none', stroke: 'grey', strokeWidth: 5, strokeOpacity: 0.5, strokeDasharray: '8 8' }));
            }
            const state = editor.authoringState.index.links.get(link.data);
            const isDeletedLink = authoringState_1.AuthoringState.isDeletedLink(editor.authoringState, link.data);
            if (state || isDeletedLink) {
                const path = this.calculateLinkPath(link);
                let color;
                if (isDeletedLink) {
                    color = 'red';
                }
                else if (state && state.type === authoringState_1.AuthoringKind.ChangeLink) {
                    color = state.before ? 'blue' : 'green';
                }
                return (React.createElement("path", { key: link.id, d: path, fill: 'none', stroke: color, strokeWidth: 5, strokeOpacity: 0.5 }));
            }
            return null;
        });
    }
    getLinkStateLabelPosition(link) {
        if (link.labelBounds) {
            const { x, y } = link.labelBounds;
            return { x, y: y - LINK_LABEL_MARGIN / 2 };
        }
        else {
            const polyline = this.calculatePolyline(link);
            const polylineLength = geometry_1.computePolylineLength(polyline);
            return geometry_1.getPointAlongPolyline(polyline, polylineLength / 2);
        }
    }
    renderLinkErrors(linkModel) {
        const { editor } = this.props;
        const { validationState } = editor;
        const validation = validationState.links.get(linkModel);
        if (!validation) {
            return null;
        }
        const title = validation.errors.map(error => error.message).join('\n');
        return this.renderErrorIcon(title, validation);
    }
    renderErrorIcon(title, validation) {
        return React.createElement("div", { className: `${CLASS_NAME}__item-error`, title: title },
            validation.loading
                ? React.createElement(spinner_1.HtmlSpinner, { width: 15, height: 17 })
                : React.createElement("div", { className: `${CLASS_NAME}__item-error-icon` }),
            (!validation.loading && validation.errors.length > 0)
                ? validation.errors.length : undefined);
    }
    render() {
        const { editor, paperTransform } = this.props;
        const { scale, originX, originY } = paperTransform;
        if (!editor.inAuthoringMode) {
            return null;
        }
        const htmlTransformStyle = {
            position: 'absolute', left: 0, top: 0,
            transform: `scale(${scale},${scale})translate(${originX}px,${originY}px)`,
        };
        return React.createElement("div", { className: `${CLASS_NAME}` },
            React.createElement(paper_1.TransformedSvgCanvas, { paperTransform: paperTransform, style: { overflow: 'visible', pointerEvents: 'none' } }, this.renderLinkStateHighlighting()),
            React.createElement("div", { className: `${CLASS_NAME}__validation-layer`, style: htmlTransformStyle }, this.renderLinkStateLabels()));
    }
}
exports.LinkStateWidget = LinkStateWidget;


/***/ }),
/* 133 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ElementDecorator = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const spinner_1 = __webpack_require__(90);
const authoringState_1 = __webpack_require__(89);
const CLASS_NAME = `ontodia-authoring-state`;
class ElementDecorator extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.delayedUpdate = new async_1.Debouncer();
        const { model, editor } = props;
        this.state = {
            state: editor.authoringState.index.elements.get(model.iri),
            validation: editor.validationState.elements.get(model.iri),
            isTemporary: editor.temporaryState.elements.has(model.iri),
        };
    }
    componentDidMount() {
        const { model, editor } = this.props;
        this.listener.listen(model.events, 'changeSize', () => this.forceUpdate());
        this.listener.listen(editor.events, 'changeAuthoringState', () => this.setState({ state: editor.authoringState.index.elements.get(model.iri) }));
        this.listener.listen(editor.events, 'changeValidationState', () => this.setState({ validation: editor.validationState.elements.get(model.iri) }));
        this.listener.listen(editor.events, 'changeTemporaryState', () => this.setState({ isTemporary: editor.temporaryState.elements.has(model.iri) }));
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.delayedUpdate.dispose();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (this.state.state !== nextState.state ||
            this.state.validation !== nextState.validation ||
            this.state.isTemporary !== nextState.isTemporary ||
            this.props.position !== nextProps.position);
    }
    renderElementOutlines() {
        const { model } = this.props;
        const { state, isTemporary } = this.state;
        const { width, height } = model.size;
        if (isTemporary) {
            return [
                React.createElement("rect", { key: `${model.id}-opacity`, x: 0, y: 0, width: width, height: height, fill: 'rgba(255, 255, 255, 0.5)' }),
                React.createElement("rect", { key: `${model.id}-stripes`, x: 0, y: 0, width: width, height: height, fill: 'url(#stripe-pattern)' })
            ];
        }
        if (state && state.type === authoringState_1.AuthoringKind.DeleteElement) {
            const right = width;
            const bottom = height;
            return (React.createElement("g", { key: model.id },
                React.createElement("rect", { x: 0, y: 0, width: width, height: height, fill: 'white', fillOpacity: 0.5 }),
                React.createElement("line", { x1: 0, y1: 0, x2: right, y2: bottom, stroke: 'red' }),
                React.createElement("line", { x1: right, y1: 0, x2: 0, y2: bottom, stroke: 'red' })));
        }
        return null;
    }
    renderErrorIcon(title, validation) {
        return React.createElement("div", { className: `${CLASS_NAME}__item-error`, title: title },
            validation.loading
                ? React.createElement(spinner_1.HtmlSpinner, { width: 15, height: 17 })
                : React.createElement("div", { className: `${CLASS_NAME}__item-error-icon` }),
            (!validation.loading && validation.errors.length > 0)
                ? validation.errors.length : undefined);
    }
    renderElementErrors() {
        const { view } = this.props;
        const { validation } = this.state;
        if (!validation) {
            return null;
        }
        const title = validation.errors.map(error => {
            if (error.propertyType) {
                const { id, label } = view.model.createProperty(error.propertyType);
                const source = view.formatLabel(label, id);
                return `${source}: ${error.message}`;
            }
            else {
                return error.message;
            }
        }).join('\n');
        return this.renderErrorIcon(title, validation);
    }
    renderElementState() {
        const { model, editor } = this.props;
        const { state } = this.state;
        if (state) {
            const onCancel = () => editor.discardChange(state);
            let renderedState;
            let statusText;
            let title;
            if (state.type === authoringState_1.AuthoringKind.ChangeElement && !state.before) {
                statusText = 'New';
                title = 'Revert creation of the element';
            }
            else if (state.type === authoringState_1.AuthoringKind.ChangeElement && state.before) {
                statusText = 'Change';
                title = 'Revert all changes in properties of the element';
            }
            else if (state.type === authoringState_1.AuthoringKind.DeleteElement) {
                statusText = 'Delete';
                title = 'Revert deletion of the element';
            }
            if (statusText && title) {
                renderedState = (React.createElement("span", null,
                    React.createElement("span", { className: `${CLASS_NAME}__state-label` }, statusText),
                    "[",
                    React.createElement("span", { className: `${CLASS_NAME}__state-cancel`, onClick: onCancel, title: title }, "cancel"),
                    "]"));
            }
            const renderedErrors = this.renderElementErrors();
            if (renderedState || renderedErrors) {
                return (React.createElement("div", { className: `${CLASS_NAME}__state-indicator`, key: model.id, style: { left: 0, top: 0 } },
                    React.createElement("div", { className: `${CLASS_NAME}__state-indicator-container` },
                        React.createElement("div", { className: `${CLASS_NAME}__state-indicator-body` },
                            renderedState,
                            renderedErrors))));
            }
        }
        return null;
    }
    render() {
        const { position, size } = this.props.model;
        const transform = `translate(${position.x}px,${position.y}px)`;
        const outlines = this.renderElementOutlines();
        const state = this.renderElementState();
        if (!outlines && !state) {
            return null;
        }
        return (React.createElement("div", { style: { position: 'absolute', transform } },
            outlines ? (React.createElement("svg", { width: size.width, height: size.height, style: { position: 'absolute', pointerEvents: 'none', overflow: 'visible' } },
                React.createElement("defs", null,
                    React.createElement("pattern", { id: 'stripe-pattern', patternUnits: 'userSpaceOnUse', width: 13, height: 13, patternTransform: 'rotate(45)' },
                        React.createElement("line", { x1: 0, y: 0, x2: 0, y2: 13, stroke: '#ddd', strokeWidth: 10, strokeOpacity: 0.2 }))),
                this.renderElementOutlines())) : null,
            state));
    }
}
exports.ElementDecorator = ElementDecorator;


/***/ }),
/* 134 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EditLayer = exports.EditLayerMode = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const schema_1 = __webpack_require__(54);
const linkLayer_1 = __webpack_require__(82);
const elements_1 = __webpack_require__(53);
const geometry_1 = __webpack_require__(57);
const paper_1 = __webpack_require__(52);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const spinner_1 = __webpack_require__(90);
var EditLayerMode;
(function (EditLayerMode) {
    EditLayerMode[EditLayerMode["establishLink"] = 0] = "establishLink";
    EditLayerMode[EditLayerMode["moveLinkSource"] = 1] = "moveLinkSource";
    EditLayerMode[EditLayerMode["moveLinkTarget"] = 2] = "moveLinkTarget";
})(EditLayerMode = exports.EditLayerMode || (exports.EditLayerMode = {}));
class EditLayer extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.cancellation = new async_1.Cancellation();
        this.beginCreatingLink = (params) => {
            const { model } = this.props.view;
            const { sourceId, point } = params;
            const temporaryElement = this.createTemporaryElement(point);
            const temporaryLink = model.addLink(new elements_1.Link({
                typeId: schema_1.PLACEHOLDER_LINK_TYPE,
                sourceId,
                targetId: temporaryElement.id,
            }));
            const fatLinkType = model.createLinkType(temporaryLink.typeId);
            fatLinkType.setVisibility({ visible: true, showLabel: false });
            this.temporaryElement = temporaryElement;
            this.temporaryLink = temporaryLink;
        };
        this.onMouseMove = (e) => {
            const { targetElement } = this.state;
            e.preventDefault();
            e.stopPropagation();
            const point = this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
            this.temporaryElement.setPosition(point);
            const newTargetElement = this.findElementFormPoint(point);
            if (newTargetElement && (!targetElement || newTargetElement.iri !== targetElement.iri)) {
                this.canDropOnElement(newTargetElement);
            }
            this.setState({ targetElement: newTargetElement });
        };
        this.onMouseUp = (e) => {
            const { editor, mode } = this.props;
            const { targetElement, canDropOnElement, canDropOnCanvas } = this.state;
            const batch = editor.model.history.startBatch();
            editor.model.removeElement(this.temporaryElement.id);
            batch.discard();
            if (targetElement || (mode === EditLayerMode.moveLinkSource || mode === EditLayerMode.moveLinkTarget)) {
                this.endChangingLink({ link: this.temporaryLink, targetElement, canDrop: canDropOnElement }).then(link => {
                    if (link) {
                        editor.setSelection([link]);
                        editor.showEditLinkForm(link);
                    }
                });
            }
            else if (canDropOnCanvas) {
                const point = this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
                const source = editor.model.getElement(this.temporaryLink.sourceId);
                this.createNewElement(source.data).then(target => {
                    target.setPosition(point);
                    this.endChangingLink({
                        link: this.temporaryLink, targetElement: target, canDrop: canDropOnCanvas,
                    }).then(link => {
                        editor.setSelection([target]);
                        editor.showEditElementTypeForm({ link, source, target });
                    });
                });
            }
            editor.finishEditing();
        };
        this.createNewElement = (source) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { editor, metadataApi } = this.props;
            if (!metadataApi) {
                return;
            }
            const elementTypes = yield metadataApi.typesOfElementsDraggedFrom(source, this.cancellation.signal);
            const classId = elementTypes.length === 1 ? elementTypes[0] : schema_1.PLACEHOLDER_ELEMENT_TYPE;
            const type = this.props.editor.model.createClass(classId);
            const typeName = this.props.view.formatLabel(type.label, type.id);
            const labelText = classId === schema_1.PLACEHOLDER_ELEMENT_TYPE ? 'New Entity' : `New ${typeName}`;
            const types = [classId];
            const entityIri = yield metadataApi.generateNewElementIri(types, async_1.Cancellation.NEVER_SIGNAL);
            const elementModel = {
                id: entityIri,
                types,
                label: { values: [{ text: labelText, lang: '' }] },
                properties: {},
            };
            return editor.createNewEntity({ elementModel, temporary: true });
        });
        this.state = {};
    }
    componentDidMount() {
        const { mode, target, point } = this.props;
        if (mode === EditLayerMode.establishLink) {
            this.beginCreatingLink({ sourceId: target.id, point });
        }
        else if (mode === EditLayerMode.moveLinkSource || mode === EditLayerMode.moveLinkTarget) {
            this.beginMovingLink({ link: target, point });
        }
        else {
            throw new Error('Unknown edit mode');
        }
        this.forceUpdate();
        this.canDropOnCanvas();
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.cancellation.abort();
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    }
    beginMovingLink(params) {
        const { editor, mode } = this.props;
        const { link, point } = params;
        this.oldLink = link;
        editor.model.removeLink(link.id);
        const { id, typeId, sourceId, targetId, data, vertices } = link;
        const temporaryElement = this.createTemporaryElement(point);
        let temporaryLink;
        if (mode === EditLayerMode.moveLinkSource) {
            temporaryLink = editor.model.addLink(new elements_1.Link({
                id, typeId, sourceId: temporaryElement.id, targetId, data, vertices,
            }));
        }
        else if (mode === EditLayerMode.moveLinkTarget) {
            temporaryLink = editor.model.addLink(new elements_1.Link({
                id, typeId, sourceId, targetId: temporaryElement.id, data, vertices,
            }));
        }
        else {
            throw new Error('Unknown edit mode');
        }
        this.temporaryElement = temporaryElement;
        this.temporaryLink = temporaryLink;
    }
    createTemporaryElement(point) {
        const temporaryElement = this.props.view.model.createTemporaryElement();
        temporaryElement.setPosition(point);
        return temporaryElement;
    }
    canDropOnCanvas() {
        const { mode, editor, metadataApi } = this.props;
        if (!metadataApi || mode !== EditLayerMode.establishLink) {
            this.setState({ canDropOnCanvas: false });
            return;
        }
        this.setState({ canDropOnCanvas: undefined });
        const source = editor.model.getElement(this.temporaryLink.sourceId).data;
        metadataApi.canDropOnCanvas(source, this.cancellation.signal).then(canDropOnCanvas => {
            if (!this.cancellation.signal.aborted) {
                this.setState({ canDropOnCanvas });
            }
        });
    }
    canDropOnElement(targetElement) {
        const { mode, editor, metadataApi } = this.props;
        if (!metadataApi) {
            this.setState({ canDropOnElement: false });
            return;
        }
        this.setState({ canDropOnElement: undefined });
        let source;
        let target;
        if (mode === EditLayerMode.establishLink || mode === EditLayerMode.moveLinkTarget) {
            source = editor.model.getElement(this.temporaryLink.sourceId).data;
            target = targetElement.data;
        }
        else if (mode === EditLayerMode.moveLinkSource) {
            source = targetElement.data;
            target = editor.model.getElement(this.temporaryLink.targetId).data;
        }
        metadataApi.canDropOnElement(source, target, this.cancellation.signal).then(canDropOnElement => {
            if (!this.cancellation.signal.aborted) {
                this.setState({ canDropOnElement });
            }
        });
    }
    endChangingLink(params) {
        const { editor, mode } = this.props;
        const { link, targetElement, canDrop } = params;
        let originalLink;
        editor.model.removeLink(link.id);
        if (this.oldLink) {
            originalLink = editor.model.addLink(this.oldLink);
        }
        if (mode === EditLayerMode.establishLink) {
            const sourceElement = editor.model.getElement(link.sourceId);
            if (canDrop && targetElement) {
                return this.createNewLink(sourceElement, targetElement);
            }
        }
        else if (mode === EditLayerMode.moveLinkSource) {
            if (canDrop && targetElement) {
                return Promise.resolve(editor.moveLinkSource({ link, newSource: targetElement }));
            }
        }
        else if (mode === EditLayerMode.moveLinkTarget) {
            if (canDrop && targetElement) {
                return Promise.resolve(editor.moveLinkTarget({ link, newTarget: targetElement }));
            }
        }
        else {
            throw new Error('Unknown edit mode');
        }
        return Promise.resolve(originalLink);
    }
    createNewLink(source, target) {
        const { editor, metadataApi } = this.props;
        if (!metadataApi) {
            return Promise.resolve(undefined);
        }
        return metadataApi.possibleLinkTypes(source.data, target.data, this.cancellation.signal).then(linkTypes => {
            const placeholder = { linkTypeIri: schema_1.PLACEHOLDER_LINK_TYPE, direction: elements_1.LinkDirection.out };
            const { linkTypeIri: typeId, direction } = linkTypes.length === 1 ? linkTypes[0] : placeholder;
            const data = {
                linkTypeId: typeId,
                sourceId: source.iri,
                targetId: target.iri,
            };
            let [sourceId, targetId] = [source.id, target.id];
            // switches source and target if the direction equals 'in'
            if (direction === elements_1.LinkDirection.in) {
                data.sourceId = target.iri;
                data.targetId = source.iri;
                [sourceId, targetId] = [targetId, sourceId];
            }
            const link = new elements_1.Link({ typeId, sourceId, targetId, data });
            const existingLink = editor.model.findLink(link.typeId, link.sourceId, link.targetId);
            return existingLink || editor.createNewLink({ link, temporary: true });
        });
    }
    findElementFormPoint(point) {
        const { elements } = this.props.view.model;
        for (let i = elements.length - 1; i >= 0; i--) {
            const element = elements[i];
            const { x, y, width, height } = geometry_1.boundsOf(element);
            if (element.temporary) {
                continue;
            }
            if (point.x >= x && point.x <= x + width && point.y >= y && point.y <= y + height) {
                return element;
            }
        }
        return undefined;
    }
    renderHighlight() {
        const { targetElement, canDropOnElement } = this.state;
        if (!targetElement) {
            return null;
        }
        const { x, y, width, height } = geometry_1.boundsOf(targetElement);
        if (canDropOnElement === undefined) {
            return (React.createElement("g", { transform: `translate(${x},${y})` },
                React.createElement("rect", { width: width, height: height, fill: 'white', fillOpacity: 0.5 }),
                React.createElement(spinner_1.Spinner, { size: 30, position: { x: width / 2, y: height / 2 } })));
        }
        const stroke = canDropOnElement ? '#5cb85c' : '#c9302c';
        return (React.createElement("rect", { x: x, y: y, width: width, height: height, fill: 'transparent', stroke: stroke, strokeWidth: 3 }));
    }
    renderCanDropIndicator() {
        const { targetElement, canDropOnCanvas } = this.state;
        if (targetElement) {
            return null;
        }
        const { x, y } = this.temporaryElement.position;
        let indicator;
        if (canDropOnCanvas === undefined) {
            indicator = React.createElement(spinner_1.Spinner, { size: 1.2, position: { x: 0.5, y: -0.5 } });
        }
        else if (canDropOnCanvas) {
            indicator = React.createElement("path", { d: 'M0.5,0 L0.5,-1 M0,-0.5 L1,-0.5', strokeWidth: 0.2, stroke: '#5cb85c' });
        }
        else {
            indicator = (React.createElement("g", null,
                React.createElement("circle", { cx: '0.5', cy: '-0.5', r: '0.5', fill: 'none', strokeWidth: 0.2, stroke: '#c9302c' }),
                React.createElement("path", { d: 'M0.5,0 L0.5,-1', strokeWidth: 0.2, stroke: '#c9302c', transform: 'rotate(-45 0.5 -0.5)' })));
        }
        return (React.createElement("g", { transform: `translate(${x} ${y})scale(40)` },
            React.createElement("rect", { x: -0.5, y: -0.5, width: 1, height: 1, fill: 'rgba(0, 0, 0, 0.1)', rx: 0.25, ry: 0.25 }),
            React.createElement("g", { transform: `translate(${0.5}, -${0.5})scale(${0.25})` }, indicator)));
    }
    render() {
        const { view, paperTransform } = this.props;
        if (!this.temporaryLink) {
            return null;
        }
        return (React.createElement(paper_1.TransformedSvgCanvas, { paperTransform: paperTransform, style: { overflow: 'visible' } },
            React.createElement(linkLayer_1.LinkMarkers, { view: view }),
            this.renderHighlight(),
            this.renderCanDropIndicator(),
            React.createElement(linkLayer_1.LinkLayer, { view: view, links: [this.temporaryLink] })));
    }
}
exports.EditLayer = EditLayer;


/***/ }),
/* 135 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateElements = exports.changedElementsToValidate = exports.ValidationState = void 0;
const tslib_1 = __webpack_require__(1);
const model_1 = __webpack_require__(48);
const collections_1 = __webpack_require__(56);
const authoringState_1 = __webpack_require__(89);
var ValidationState;
(function (ValidationState) {
    ValidationState.empty = createMutable();
    ValidationState.emptyElement = { loading: false, errors: [] };
    ValidationState.emptyLink = { loading: false, errors: [] };
    function createMutable() {
        return {
            elements: new Map(),
            links: new collections_1.HashMap(model_1.hashLink, model_1.sameLink),
        };
    }
    ValidationState.createMutable = createMutable;
    function setElementErrors(state, target, errors) {
        const elements = collections_1.cloneMap(state.elements);
        if (errors.length > 0) {
            elements.set(target, { loading: false, errors });
        }
        else {
            elements.delete(target);
        }
        return Object.assign(Object.assign({}, state), { elements });
    }
    ValidationState.setElementErrors = setElementErrors;
    function setLinkErrors(state, target, errors) {
        const links = state.links.clone();
        if (errors.length > 0) {
            links.set(target, { loading: false, errors });
        }
        else {
            links.delete(target);
        }
        return Object.assign(Object.assign({}, state), { links });
    }
    ValidationState.setLinkErrors = setLinkErrors;
})(ValidationState = exports.ValidationState || (exports.ValidationState = {}));
function changedElementsToValidate(previousAuthoring, editor) {
    const currentAuthoring = editor.authoringState;
    const links = new collections_1.HashMap(model_1.hashLink, model_1.sameLink);
    previousAuthoring.index.links.forEach((e, model) => links.set(model, true));
    currentAuthoring.index.links.forEach((e, model) => links.set(model, true));
    const toValidate = new Set();
    links.forEach((value, linkModel) => {
        const current = currentAuthoring.index.links.get(linkModel);
        const previous = previousAuthoring.index.links.get(linkModel);
        if (current !== previous) {
            toValidate.add(linkModel.sourceId);
        }
    });
    for (const element of editor.model.elements) {
        const current = currentAuthoring.index.elements.get(element.iri);
        const previous = previousAuthoring.index.elements.get(element.iri);
        if (current !== previous) {
            toValidate.add(element.iri);
            // when we remove element incoming link are removed as well so we should update their sources
            if ((current || previous).type === authoringState_1.AuthoringKind.DeleteElement) {
                for (const link of element.links) {
                    if (link.data.sourceId !== element.iri) {
                        toValidate.add(link.data.sourceId);
                    }
                }
            }
        }
    }
    return toValidate;
}
exports.changedElementsToValidate = changedElementsToValidate;
function validateElements(targets, validationApi, editor, cancellation) {
    const previousState = editor.validationState;
    const newState = ValidationState.createMutable();
    for (const element of editor.model.elements) {
        if (newState.elements.has(element.iri)) {
            continue;
        }
        const outboundLinks = element.links.reduce((acc, link) => {
            if (link.sourceId === element.id) {
                acc.push(link.data);
            }
            return acc;
        }, []);
        if (targets.has(element.iri)) {
            const event = {
                target: element.data,
                outboundLinks,
                state: editor.authoringState,
                model: editor.model,
                cancellation,
            };
            const result = validationApi.validate(event);
            const loadingElement = { loading: true, errors: [] };
            const loadingLink = { loading: true, errors: [] };
            newState.elements.set(element.iri, loadingElement);
            outboundLinks.forEach(link => newState.links.set(link, loadingLink));
            processValidationResult(result, loadingElement, loadingLink, event, editor);
        }
        else {
            // use previous state for element and outbound links
            newState.elements.set(element.iri, previousState.elements.get(element.iri));
            for (const link of outboundLinks) {
                newState.links.set(link, previousState.links.get(link));
            }
        }
    }
    editor.setValidationState(newState);
}
exports.validateElements = validateElements;
function processValidationResult(result, previousElement, previousLink, e, editor) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let allErrors;
        try {
            allErrors = yield result;
        }
        catch (err) {
            // tslint:disable-next-line:no-console
            console.error(`Failed to validate element`, e.target, err);
            allErrors = [{ type: 'element', target: e.target.id, message: `Failed to validate element` }];
        }
        const elementErrors = [];
        const linkErrors = new collections_1.HashMap(model_1.hashLink, model_1.sameLink);
        e.outboundLinks.forEach(link => linkErrors.set(link, []));
        for (const error of allErrors) {
            if (error.type === 'element' && error.target === e.target.id) {
                elementErrors.push(error);
            }
            else if (error.type === 'link' && linkErrors.has(error.target)) {
                linkErrors.get(error.target).push(error);
            }
        }
        let state = editor.validationState;
        if (state.elements.get(e.target.id) === previousElement) {
            state = ValidationState.setElementErrors(state, e.target.id, elementErrors);
        }
        linkErrors.forEach((errors, link) => {
            if (state.links.get(link) === previousLink) {
                state = ValidationState.setLinkErrors(state, link, errors);
            }
        });
        editor.setValidationState(state);
    });
}


/***/ }),
/* 136 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DefaultToolbar = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const CLASS_NAME = 'ontodia-toolbar';
class DefaultToolbar extends React.Component {
    constructor() {
        super(...arguments);
        this.onChangeLanguage = (event) => {
            const value = event.currentTarget.value;
            this.props.onChangeLanguage(value);
        };
        this.onExportSVG = () => {
            this.props.onExportSVG();
        };
        this.onExportPNG = () => {
            this.props.onExportPNG();
        };
    }
    renderSaveDiagramButton() {
        if (!this.props.onSaveDiagram) {
            return null;
        }
        return (React.createElement("button", { type: 'button', className: 'saveDiagramButton ontodia-btn ontodia-btn-primary', disabled: this.props.canSaveDiagram === false, onClick: this.props.onSaveDiagram },
            React.createElement("span", { className: 'fa fa-floppy-o', "aria-hidden": 'true' }),
            " Save diagram"));
    }
    renderPersistAuthoredChangesButton() {
        if (!this.props.onPersistChanges) {
            return null;
        }
        return (React.createElement("button", { type: 'button', className: 'saveDiagramButton ontodia-btn ontodia-btn-success', disabled: this.props.canPersistChanges === false, onClick: this.props.onPersistChanges },
            React.createElement("span", { className: 'fa fa-floppy-o', "aria-hidden": 'true' }),
            " Save data"));
    }
    renderLanguages() {
        const { selectedLanguage, languages } = this.props;
        if (languages.length <= 1) {
            return null;
        }
        return (React.createElement("span", { className: `ontodia-btn-group ${CLASS_NAME}__language-selector` },
            React.createElement("label", { className: 'ontodia-label' },
                React.createElement("span", null, "Data Language - ")),
            React.createElement("select", { value: selectedLanguage, onChange: this.onChangeLanguage }, languages.map(({ code, label }) => React.createElement("option", { key: code, value: code }, label)))));
    }
    render() {
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: 'ontodia-btn-group ontodia-btn-group-sm' },
                this.renderSaveDiagramButton(),
                this.renderPersistAuthoredChangesButton(),
                this.props.onClearAll ? (React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Clear All', onClick: this.props.onClearAll },
                    React.createElement("span", { className: 'fa fa-trash', "aria-hidden": 'true' }),
                    "\u00A0Clear All")) : null,
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Force layout', onClick: this.props.onForceLayout },
                    React.createElement("span", { className: 'fa fa-sitemap', "aria-hidden": 'true' }),
                    " Layout"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Zoom In', onClick: this.props.onZoomIn },
                    React.createElement("span", { className: 'fa fa-search-plus', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Zoom Out', onClick: this.props.onZoomOut },
                    React.createElement("span", { className: 'fa fa-search-minus', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Fit to Screen', onClick: this.props.onZoomToFit },
                    React.createElement("span", { className: 'fa fa-arrows-alt', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Export diagram as PNG', onClick: this.onExportPNG },
                    React.createElement("span", { className: 'fa fa-picture-o', "aria-hidden": 'true' }),
                    " PNG"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Export diagram as SVG', onClick: this.onExportSVG },
                    React.createElement("span", { className: 'fa fa-picture-o', "aria-hidden": 'true' }),
                    " SVG"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Print diagram', onClick: this.props.onPrint },
                    React.createElement("span", { className: 'fa fa-print', "aria-hidden": 'true' })),
                this.renderLanguages())));
    }
}
exports.DefaultToolbar = DefaultToolbar;


/***/ }),
/* 137 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderTo = exports.Workspace = void 0;
const tslib_1 = __webpack_require__(1);
const react_1 = __webpack_require__(46);
const ReactDOM = tslib_1.__importStar(__webpack_require__(59));
const saveAs = tslib_1.__importStar(__webpack_require__(138));
const commands_1 = __webpack_require__(64);
const history_1 = __webpack_require__(65);
const view_1 = __webpack_require__(66);
const asyncModel_1 = __webpack_require__(114);
const editorController_1 = __webpack_require__(116);
const events_1 = __webpack_require__(55);
const toSvg_1 = __webpack_require__(84);
const navigator_1 = __webpack_require__(139);
const toolbar_1 = __webpack_require__(136);
const workspaceMarkup_1 = __webpack_require__(140);
const workspaceContext_1 = __webpack_require__(88);
const layout_1 = __webpack_require__(109);
const react_redux_1 = __webpack_require__(153);
const Actions = tslib_1.__importStar(__webpack_require__(197));
const ONTODIA_WEBSITE = 'http://arca.diag.uniroma1.it/'; //ARCA_WEBSITE
const ONTODIA_LOGO_SVG = __webpack_require__(199);
class Workspace extends react_1.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this._watermarkSvg = ONTODIA_LOGO_SVG;
        this._watermarkUrl = ONTODIA_WEBSITE;
        this.zoomToFit = () => {
            this.markup.paperArea.zoomToFit();
        };
        this.zoomToFitRect = (bbox) => {
            this.markup.paperArea.zoomToFitRect(bbox);
        };
        this.clearAll = () => {
            this.editor.removeItems([...this.model.elements]);
        };
        this.forceLayout = () => {
            const batch = this.model.history.startBatch('Force layout');
            batch.history.registerToUndo(commands_1.RestoreGeometry.capture(this.model));
            layout_1.applyLayout(this.model, layout_1.forceLayout({ model: this.model }));
            for (const link of this.model.links) {
                link.setVertices([]);
            }
            batch.store();
        };
        this.exportSvg = (fileName) => {
            this.markup.paperArea.exportSVG().then(svg => {
                fileName = fileName || 'diagram.svg';
                const xmlEncodingHeader = '<?xml version="1.0" encoding="UTF-8"?>';
                const blob = new Blob([xmlEncodingHeader + svg], { type: 'image/svg+xml' });
                saveAs(blob, fileName);
            });
        };
        this.exportPng = (fileName) => {
            fileName = fileName || 'diagram.png';
            this.markup.paperArea.exportPNG({ backgroundColor: 'white' }).then(dataUri => {
                const blob = toSvg_1.dataURLToBlob(dataUri);
                saveAs(blob, fileName);
            });
        };
        this.undo = () => {
            this.model.history.undo();
        };
        this.redo = () => {
            this.model.history.redo();
        };
        this.zoomBy = (value) => {
            this.markup.paperArea.zoomBy(value);
        };
        this.zoomIn = () => {
            this.markup.paperArea.zoomIn();
        };
        this.zoomOut = () => {
            this.markup.paperArea.zoomOut();
        };
        this.print = () => {
            this.markup.paperArea.exportSVG().then(svg => {
                const printWindow = window.open('', undefined, 'width=1280,height=720');
                printWindow.document.write(svg);
                printWindow.document.close();
                printWindow.print();
            });
        };
        this.changeLanguage = (language) => {
            const { onLanguageChange } = this.props;
            // if language is in controlled mode we'll just forward the change
            if (onLanguageChange) {
                onLanguageChange(language);
            }
            else {
                this.view.setLanguage(language);
                // since we have toolbar dependent on language, we're forcing update here
                this.forceUpdate();
            }
        };
        this.centerTo = (paperPosition) => {
            this.markup.paperArea.centerTo(paperPosition);
        };
        const { hideHalo, history, viewOptions = {}, metadataApi, validationApi, propertyEditor, elementTemplateResolver, linkTemplateResolver, typeStyleResolver, selectLabelLanguage, } = this.props;
        const { linkRouter, onIriClick, disableDefaultHalo, suggestProperties, groupBy, } = viewOptions;
        this.model = new asyncModel_1.AsyncModel(history || new history_1.NonRememberingHistory(), groupBy || []);
        this.view = new view_1.DiagramView(this.model, {
            elementTemplateResolver,
            linkTemplateResolver,
            typeStyleResolver,
            selectLabelLanguage,
            linkRouter,
            onIriClick,
        });
        this.editor = new editorController_1.EditorController({
            model: this.model,
            view: this.view,
            disableHalo: hideHalo || disableDefaultHalo,
            suggestProperties,
            validationApi,
            propertyEditor,
        });
        this.editor.setMetadataApi(metadataApi);
        this.view.setLanguage(this.props.language);
        this.state = { criteria: {} };
    }
    _getPaperArea() {
        return this.markup ? this.markup.paperArea : undefined;
    }
    _setWatermark(watermarkSvg, watermarkUrl) {
        this._watermarkSvg = watermarkSvg;
        this._watermarkUrl = watermarkUrl;
        this.forceUpdate();
    }
    render() {
        const { hidePanels, hideToolbar, metadataApi, hideScrollBars, onWorkspaceEvent, _elementsSearchPanel, } = this.props;
        return react_1.createElement(workspaceMarkup_1.WorkspaceMarkup, {
            ref: markup => { this.markup = markup; },
            hidePanels,
            hideToolbar,
            hideScrollBars,
            model: this.model,
            view: this.view,
            editor: this.editor,
            metadataApi,
            leftPanelInitiallyOpen: this.props.leftPanelInitiallyOpen,
            rightPanelInitiallyOpen: this.props.rightPanelInitiallyOpen,
            searchCriteria: this.props.criteria,
            onSearchCriteriaChanged: this.props.onSearchCriteriaChanged,
            searchResults: this.props.searchResults,
            onSearchResultsChanged: this.props.onSearchResultsChanged,
            zoomOptions: this.props.zoomOptions,
            onZoom: this.props.onZoom,
            isLeftPanelOpen: this.props.leftPanelInitiallyOpen,
            isRightPanelOpen: this.props.rightPanelInitiallyOpen,
            toolbar: react_1.createElement(ToolbarWrapper, { workspace: this }),
            onWorkspaceEvent: onWorkspaceEvent,
            watermarkSvg: this.props.watermarkSvg,
            watermarkUrl: this.props.watermarkUrl,
            elementsSearchPanel: _elementsSearchPanel,
        });
    }
    componentDidMount() {
        const { onWorkspaceEvent } = this.props;
        this.editor._initializePaperComponents(this.markup.paperArea);
        this.updateNavigator(!this.props.hideNavigator);
        this.listener.listen(this.model.events, 'loadingSuccess', () => {
            this.view.performSyncUpdate();
            this.markup.paperArea.centerContent();
        });
        this.listener.listen(this.model.events, 'elementEvent', ({ key, data }) => {
            if (!data.requestedAddToFilter) {
                return;
            }
            const { source, linkType, direction } = data.requestedAddToFilter;
            this.props.onSearchCriteriaChanged({
                refElement: source,
                refElementLink: linkType,
                linkDirection: direction,
            });
            if (onWorkspaceEvent) {
                onWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.searchUpdateCriteria);
            }
        });
        this.listener.listen(this.markup.paperArea.events, 'pointerUp', e => {
            if (this.props.onPointerUp) {
                this.props.onPointerUp(e);
            }
        });
        this.listener.listen(this.markup.paperArea.events, 'pointerMove', e => {
            if (this.props.onPointerMove) {
                this.props.onPointerMove(e);
            }
        });
        this.listener.listen(this.markup.paperArea.events, 'pointerDown', e => {
            if (this.props.onPointerDown) {
                this.props.onPointerDown(e);
            }
        });
        if (onWorkspaceEvent) {
            this.listener.listen(this.editor.events, 'changeSelection', () => onWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.editorChangeSelection));
            this.listener.listen(this.editor.events, 'toggleDialog', () => onWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.editorToggleDialog));
            this.listener.listen(this.editor.events, 'addElements', () => onWorkspaceEvent(workspaceContext_1.WorkspaceEventKey.editorAddElements));
        }
    }
    componentWillReceiveProps(nextProps) {
        const controlledLanguage = Boolean(nextProps.onLanguageChange);
        if (controlledLanguage && nextProps.language !== this.view.getLanguage()) {
            this.view.setLanguage(nextProps.language);
        }
        if (nextProps.metadataApi !== this.editor.metadataApi) {
            this.editor.setMetadataApi(nextProps.metadataApi);
        }
        if (nextProps.hideNavigator !== this.props.hideNavigator) {
            this.updateNavigator(!nextProps.hideNavigator);
        }
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.view.dispose();
    }
    updateNavigator(showNavigator) {
        if (showNavigator) {
            const widget = react_1.createElement(navigator_1.Navigator, { view: this.view, expanded: !this.props.collapseNavigator });
            this.view.setPaperWidget({ key: 'navigator', widget, attachment: view_1.WidgetAttachment.Viewport });
        }
        else {
            this.view.setPaperWidget({ key: 'navigator', widget: undefined, attachment: view_1.WidgetAttachment.Viewport });
        }
    }
    getModel() { return this.model; }
    getDiagram() { return this.view; }
    getEditor() { return this.editor; }
    preventTextSelectionUntilMouseUp() { this.markup.preventTextSelection(); }
    showWaitIndicatorWhile(operation) {
        this.markup.paperArea.centerTo();
        this.editor.setSpinner({});
        if (operation) {
            operation.then(() => {
                this.editor.setSpinner(undefined);
            }).catch(error => {
                // tslint:disable-next-line:no-console
                console.error(error);
                this.editor.setSpinner({ statusText: 'Unknown error occured', errorOccured: true });
            });
        }
    }
}
exports.Workspace = Workspace;
Workspace.defaultProps = {
    hideTutorial: true,
    collapseNavigator: false,
    leftPanelInitiallyOpen: true,
    rightPanelInitiallyOpen: false,
    languages: [
        { code: 'en', label: 'English' },
        { code: 'ru', label: 'Russian' },
    ],
    language: 'en',
};
class ToolbarWrapper extends react_1.Component {
    constructor() {
        super(...arguments);
        this.listener = new events_1.EventObserver();
    }
    render() {
        const { workspace } = this.props;
        const view = workspace.getDiagram();
        const editor = workspace.getEditor();
        const { languages, onSaveDiagram, onPersistChanges, hidePanels, toolbar } = workspace.props;
        const canPersistChanges = onPersistChanges ? editor.authoringState.events.length > 0 : undefined;
        const canSaveDiagram = !canPersistChanges;
        const defaultToolbarProps = {
            onZoomIn: workspace.zoomIn,
            onZoomOut: workspace.zoomOut,
            onZoomToFit: workspace.zoomToFit,
            onPrint: workspace.print,
            onExportSVG: workspace.exportSvg,
            onExportPNG: workspace.exportPng,
            canSaveDiagram,
            onSaveDiagram: onSaveDiagram ? () => onSaveDiagram(workspace) : undefined,
            canPersistChanges,
            onPersistChanges: onPersistChanges ? () => onPersistChanges(workspace) : undefined,
            onForceLayout: () => {
                workspace.forceLayout();
                workspace.getDiagram().performSyncUpdate();
                workspace.zoomToFit();
            },
            onClearAll: workspace.clearAll,
            languages,
            selectedLanguage: view.getLanguage(),
            onChangeLanguage: workspace.changeLanguage,
            hidePanels,
        };
        if (toolbar) {
            const toolbarProps = Object.assign(Object.assign({}, defaultToolbarProps), toolbar.props);
            return react_1.cloneElement(toolbar, toolbarProps);
        }
        else {
            return react_1.createElement(toolbar_1.DefaultToolbar, defaultToolbarProps);
        }
    }
    componentDidMount() {
        const { workspace } = this.props;
        const editor = workspace.getEditor();
        this.listener.listen(editor.events, 'changeAuthoringState', () => {
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        this.listener.stopListening();
    }
}
function renderTo(workspace, container, props) {
    ReactDOM.render(react_1.createElement(workspace, props), container);
}
exports.renderTo = renderTo;
//redux container
const mapStateToProps = (state) => ({
    watermarkSvg: state.watermarkSvg,
    watermarkUrl: state.watermarkUrl,
    criteria: state.criteria,
    searchResults: state.searchResults,
});
const mapDispatchToProps = (dispatch) => ({
    onSearchCriteriaChanged: (criteria) => {
        dispatch(Actions.onSearchCriteriaChanged(criteria));
    },
    onSearchResultsChanged: (searchResults) => {
        dispatch(Actions.onSearchResultsChanged(searchResults));
    },
});
const ConnectedWorkspace = react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Workspace);
exports["default"] = ConnectedWorkspace;


/***/ }),
/* 138 */
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__138__;

/***/ }),
/* 139 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Navigator = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const d3_color_1 = __webpack_require__(60);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const paper_1 = __webpack_require__(52);
const CLASS_NAME = 'ontodia-navigator';
const MIN_SCALE = 0.25;
class Navigator extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.delayedRedraw = new async_1.Debouncer();
        this.listener = new events_1.EventObserver();
        this.scheduleRedraw = () => {
            if (this.state.expanded) {
                this.delayedRedraw.call(this.draw);
            }
        };
        this.draw = () => {
            const { paperTransform: pt, width, height } = this.props;
            this.calculateTransform();
            const ctx = this.canvas.getContext('2d');
            ctx.fillStyle = '#EEEEEE';
            ctx.clearRect(0, 0, width, height);
            ctx.fillRect(0, 0, width, height);
            const paneStart = paper_1.paneTopLeft(pt);
            const paneSize = paper_1.totalPaneSize(pt);
            const paneEnd = {
                x: paneStart.x + paneSize.x,
                y: paneStart.y + paneSize.y,
            };
            const start = canvasFromPaneCoords(paneStart, pt, this.transform);
            const end = canvasFromPaneCoords(paneEnd, pt, this.transform);
            ctx.fillStyle = 'white';
            ctx.fillRect(start.x, start.y, end.x - start.x, end.y - start.y);
            ctx.save();
            this.drawElements(ctx);
            this.drawViewport(ctx);
            ctx.restore();
        };
        this.onDragViewport = (e) => {
            e.preventDefault();
            if (this.isDraggingViewport) {
                const canvas = this.canvasFromPageCoords(e.pageX, e.pageY);
                const paper = paperFromCanvasCoords(canvas, this.props.paperTransform, this.transform);
                this.props.paperArea.centerTo(paper);
            }
        };
        this.onMouseUp = () => {
            this.stopDraggingViewport();
        };
        this.onWheel = (e) => {
            e.preventDefault();
            const delta = Math.max(-1, Math.min(1, e.deltaY || e.deltaX));
            this.props.paperArea.zoomBy(-delta * 0.1);
        };
        this.onToggleClick = () => {
            this.setState((state) => ({ expanded: !state.expanded }), this.scheduleRedraw);
        };
        this.state = { expanded: this.props.expanded };
    }
    componentDidMount() {
        const { view, paperArea } = this.props;
        this.listener.listen(view.events, 'changeHighlight', this.scheduleRedraw);
        this.listener.listen(view.model.events, 'changeCells', this.scheduleRedraw);
        this.listener.listen(view.model.events, 'elementEvent', this.scheduleRedraw);
        this.listener.listen(paperArea.events, 'pointerMove', this.scheduleRedraw);
        this.listener.listen(paperArea.events, 'scroll', this.scheduleRedraw);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextState !== this.state;
    }
    componentWillUnmount() {
        this.delayedRedraw.dispose();
        this.listener.stopListening();
        this.stopDraggingViewport();
    }
    drawElements(ctx) {
        const { view, paperTransform: pt } = this.props;
        view.model.elements.forEach(element => {
            const { position, size } = element;
            ctx.fillStyle = this.chooseElementColor(element);
            const { x: x1, y: y1 } = canvasFromPaperCoords(position, pt, this.transform);
            const { x: x2, y: y2 } = canvasFromPaperCoords({
                x: position.x + size.width,
                y: position.y + size.height,
            }, pt, this.transform);
            ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
        });
    }
    chooseElementColor(element) {
        const { view } = this.props;
        const isBlurred = view.highlighter && !view.highlighter(element);
        if (isBlurred) {
            return 'lightgray';
        }
        const { color: { h, c, l } } = view.getTypeStyle(element.data.types);
        return d3_color_1.hcl(h, c, l).toString();
    }
    drawViewport(ctx) {
        const { paperArea, paperTransform: pt, width, height } = this.props;
        ctx.strokeStyle = '#337ab7';
        ctx.lineWidth = 2;
        const { clientWidth, clientHeight } = paperArea.getAreaMetrics();
        const viewportStart = paperArea.clientToScrollablePaneCoords(0, 0);
        const viewportEnd = paperArea.clientToScrollablePaneCoords(clientWidth, clientHeight);
        const { x: x1, y: y1 } = canvasFromPaneCoords(viewportStart, pt, this.transform);
        const { x: x2, y: y2 } = canvasFromPaneCoords(viewportEnd, pt, this.transform);
        // draw visible viewport rectangle
        ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
        // draw "out of area" viewport borders
        ctx.beginPath();
        if (x1 < 0) {
            ctx.moveTo(0, y1);
            ctx.lineTo(0, y2);
        }
        if (y1 < 0) {
            ctx.moveTo(x1, 0);
            ctx.lineTo(x2, 0);
        }
        if (x2 > width) {
            ctx.moveTo(width, y1);
            ctx.lineTo(width, y2);
        }
        if (y2 > height) {
            ctx.moveTo(x1, height);
            ctx.lineTo(x2, height);
        }
        ctx.lineWidth = 4;
        ctx.strokeStyle = '#a0d2ff';
        ctx.setLineDash([5, 5]);
        ctx.stroke();
    }
    calculateTransform() {
        const { paperArea, paperTransform: pt, width, height, scalePadding } = this.props;
        const box = paperArea.getContentFittingBox();
        const displayPadding = {
            x: Math.max(box.width, width / MIN_SCALE) * scalePadding,
            y: Math.max(box.height, height / MIN_SCALE) * scalePadding,
        };
        const displayStart = paper_1.paneFromPaperCoords({
            x: box.x - displayPadding.x,
            y: box.y - displayPadding.y,
        }, pt);
        const displayEnd = paper_1.paneFromPaperCoords({
            x: box.x + box.width + displayPadding.x,
            y: box.y + box.height + displayPadding.y,
        }, pt);
        const displaySize = {
            x: displayEnd.x - displayStart.x,
            y: displayEnd.y - displayStart.y,
        };
        const scale = Math.min(width / displaySize.x, height / displaySize.y);
        const canvasOffset = {
            x: (width - displaySize.x * scale) / 2,
            y: (height - displaySize.y * scale) / 2,
        };
        this.transform = { scale, canvasOffset, paneOffset: displayStart };
    }
    canvasFromPageCoords(pageX, pageY) {
        const { top, left } = this.canvas.getBoundingClientRect();
        return {
            x: pageX - left - window.pageXOffset,
            y: pageY - top - window.pageYOffset,
        };
    }
    render() {
        const { width, height } = this.props;
        const { expanded } = this.state;
        return (React.createElement("div", { className: `${CLASS_NAME} ${CLASS_NAME}--${expanded ? 'expanded' : 'collapsed'}`, style: expanded ? { width, height } : undefined },
            React.createElement("canvas", { ref: canvas => this.canvas = canvas, width: width, height: height, onMouseDown: e => {
                    this.startDragginViewport();
                    this.onDragViewport(e);
                }, onWheel: this.onWheel }),
            React.createElement("button", { className: `${CLASS_NAME}__toggle`, title: expanded ? 'Collapse navigator' : 'Expand navigator', onClick: this.onToggleClick },
                React.createElement("div", { className: `${CLASS_NAME}__toggle-icon` }))));
    }
    startDragginViewport() {
        if (!this.isDraggingViewport) {
            this.isDraggingViewport = true;
            document.addEventListener('mousemove', this.onDragViewport);
            document.addEventListener('mouseup', this.onMouseUp);
        }
    }
    stopDraggingViewport() {
        if (this.isDraggingViewport) {
            this.isDraggingViewport = false;
            document.removeEventListener('mousemove', this.onDragViewport);
            document.removeEventListener('mouseup', this.onMouseUp);
        }
    }
}
exports.Navigator = Navigator;
Navigator.defaultProps = {
    width: 300,
    height: 160,
    scalePadding: 0.2,
    expanded: true,
};
function canvasFromPaneCoords(pane, pt, nt) {
    return {
        x: nt.canvasOffset.x + (pane.x - nt.paneOffset.x) * nt.scale,
        y: nt.canvasOffset.y + (pane.y - nt.paneOffset.y) * nt.scale,
    };
}
function canvasFromPaperCoords(paper, pt, nt) {
    const pane = paper_1.paneFromPaperCoords(paper, pt);
    return canvasFromPaneCoords(pane, pt, nt);
}
function paperFromCanvasCoords(canvas, pt, nt) {
    const pane = {
        x: nt.paneOffset.x + (canvas.x - nt.canvasOffset.x) / nt.scale,
        y: nt.paneOffset.y + (canvas.y - nt.canvasOffset.y) / nt.scale,
    };
    return paper_1.paperFromPaneCoords(pane, pt);
}


/***/ }),
/* 140 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkspaceMarkup = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const paperArea_1 = __webpack_require__(83);
const classTree_1 = __webpack_require__(141);
const instancesSearch_1 = __webpack_require__(126);
const linksToolbox_1 = __webpack_require__(149);
const workspaceContext_1 = __webpack_require__(88);
const async_1 = __webpack_require__(61);
const layout_1 = __webpack_require__(150);
class WorkspaceMarkup extends React.Component {
    constructor() {
        super(...arguments);
        this.untilMouseUpClasses = [];
        this.cancellation = new async_1.Cancellation();
        this.triggerWorkspaceEvent = (key) => {
            const { onWorkspaceEvent } = this.props;
            if (onWorkspaceEvent) {
                onWorkspaceEvent(key);
            }
        };
        this.renderToolbar = () => {
            const { hideToolbar, toolbar } = this.props;
            if (hideToolbar) {
                return null;
            }
            return React.createElement("div", { className: 'ontodia__header' }, toolbar);
        };
        this.onCreateInstance = (classId, position) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { editor, view, model, metadataApi } = this.props;
            yield forceNonReactExecutionContext();
            const batch = model.history.startBatch();
            const type = editor.model.getClass(classId);
            const typeName = view.formatLabel(type.label, type.id);
            const types = [classId];
            const signal = this.cancellation.signal;
            const newEntityIri = yield metadataApi.generateNewElementIri(types, signal);
            if (signal.aborted) {
                return;
            }
            const elementModel = {
                id: newEntityIri,
                types,
                label: { values: [{ text: `New ${typeName}`, lang: '' }] },
                properties: {},
            };
            const element = editor.createNewEntity({ elementModel });
            view.performSyncUpdate();
            const targetPosition = position || getViewportCenterInPaperCoords(this.paperArea);
            centerElementToPosition(element, targetPosition);
            batch.store();
            editor.setSelection([element]);
            editor.showEditEntityForm(element);
        });
        this.onDocumentMouseUp = () => {
            for (const className of this.untilMouseUpClasses) {
                this.element.classList.remove(className);
            }
            this.untilMouseUpClasses = [];
        };
        this.onDropOnPaper = (e, paperPosition) => {
            e.preventDefault();
            const event = { dragEvent: e, paperPosition };
            if (this.props.view._tryHandleDropOnPaper(event)) {
                return;
            }
            const iris = tryParseDefaultDragAndDropData(e);
            if (iris.length > 0) {
                this.props.editor.onDragDrop(iris, paperPosition);
            }
        };
    }
    getChildContext() {
        const { editor } = this.props;
        const ontodiaWorkspace = { editor, triggerWorkspaceEvent: this.triggerWorkspaceEvent };
        return { ontodiaWorkspace };
    }
    getLeftPanelLayout() {
        const { view, editor, model, searchCriteria, onSearchCriteriaChanged, searchResults, onSearchResultsChanged } = this.props;
        const classTree = (React.createElement(classTree_1.ClassTree, { view: view, editor: editor, onClassSelected: classId => {
                const elementType = model.createClass(classId);
                onSearchCriteriaChanged({ elementType });
            }, onCreateInstance: this.onCreateInstance }));
        const instancesSearch = (React.createElement(instancesSearch_1.InstancesSearch, { view: view, model: model, criteria: searchCriteria || {}, onCriteriaChanged: onSearchCriteriaChanged, searchResults: searchResults || {}, onResultsChanged: onSearchResultsChanged }));
        return {
            type: layout_1.WorkspaceLayoutType.Column,
            children: [
                {
                    id: 'instances',
                    type: layout_1.WorkspaceLayoutType.Component,
                    content: instancesSearch,
                    heading: 'Search',
                }
            ],
            defaultSize: 275,
            defaultCollapsed: !this.props.isLeftPanelOpen,
        };
    }
    getRightPanelLayout() {
        const { view, editor, elementsSearchPanel } = this.props;
        const rightPanel = {
            type: layout_1.WorkspaceLayoutType.Column,
            children: [{
                    id: 'connections',
                    type: layout_1.WorkspaceLayoutType.Component,
                    content: React.createElement(linksToolbox_1.LinkTypesToolbox, { view: view, editor: editor }),
                    heading: 'Connections',
                }],
            defaultSize: 275,
            defaultCollapsed: !this.props.isRightPanelOpen,
        };
        if (elementsSearchPanel) {
            rightPanel.children = [
                ...rightPanel.children,
                {
                    id: 'search',
                    type: layout_1.WorkspaceLayoutType.Component,
                    content: React.cloneElement(elementsSearchPanel, { view, editor }),
                    heading: 'Search in diagram',
                }
            ];
        }
        return rightPanel;
    }
    render() {
        const paper = {
            id: 'paper',
            type: layout_1.WorkspaceLayoutType.Component,
            content: (React.createElement("div", { className: 'ontodia__main-panel', style: { flex: '1 1 0px', width: '100%' } },
                React.createElement(paperArea_1.PaperArea, { ref: el => this.paperArea = el, view: this.props.view, zoomOptions: this.props.zoomOptions, hideScrollBars: this.props.hideScrollBars, watermarkSvg: this.props.watermarkSvg, watermarkUrl: this.props.watermarkUrl, onDragDrop: this.onDropOnPaper, onZoom: this.props.onZoom }))),
        };
        const workspaceLayout = this.props.hidePanels ? paper : {
            type: layout_1.WorkspaceLayoutType.Row,
            children: [
                this.getLeftPanelLayout(),
                paper,
                this.getRightPanelLayout(),
            ]
        };
        return (React.createElement("div", { ref: e => this.element = e, className: 'ontodia' },
            this.renderToolbar(),
            React.createElement("div", { className: 'ontodia__workspace' },
                React.createElement(layout_1.WorkspaceLayout, { layout: workspaceLayout, _onStartResize: direction => this.untilMouseUp({
                        preventTextSelection: true,
                        verticalResizing: direction === 'vertical',
                        horizontalResizing: direction === 'horizontal',
                    }) }))));
    }
    componentDidMount() {
        document.addEventListener('mouseup', this.onDocumentMouseUp);
    }
    componentWillUnmount() {
        document.removeEventListener('mouseup', this.onDocumentMouseUp);
        this.cancellation.abort();
    }
    preventTextSelection() {
        this.untilMouseUp({ preventTextSelection: true });
    }
    untilMouseUp(params) {
        this.untilMouseUpClasses = [];
        if (params.preventTextSelection) {
            this.untilMouseUpClasses.push('ontodia--unselectable');
        }
        if (params.horizontalResizing) {
            this.untilMouseUpClasses.push('ontodia--horizontal-resizing');
        }
        if (params.verticalResizing) {
            this.untilMouseUpClasses.push('ontodia--vertical-resizing');
        }
        for (const className of this.untilMouseUpClasses) {
            this.element.classList.add(className);
        }
    }
}
exports.WorkspaceMarkup = WorkspaceMarkup;
WorkspaceMarkup.childContextTypes = workspaceContext_1.WorkspaceContextTypes;
function forceNonReactExecutionContext() {
    // force non-React executing context to resolve forceUpdate() synchronously
    return Promise.resolve();
}
function getViewportCenterInPaperCoords(paperArea) {
    const viewport = paperArea.getAreaMetrics();
    return paperArea.clientToPaperCoords(viewport.clientWidth / 2, viewport.clientHeight / 2);
}
function centerElementToPosition(element, center) {
    const position = {
        x: center.x - element.size.width / 2,
        y: center.y - element.size.height / 2,
    };
    element.setPosition(position);
}
function tryParseDefaultDragAndDropData(e) {
    const tryGetIri = (type, decode = false) => {
        try {
            const iriString = e.dataTransfer.getData(type);
            if (!iriString) {
                return undefined;
            }
            let iris;
            try {
                iris = JSON.parse(iriString);
            }
            catch (e) {
                iris = [(decode ? decodeURI(iriString) : iriString)];
            }
            return iris.length === 0 ? undefined : iris;
        }
        catch (e) {
            return undefined;
        }
    };
    return tryGetIri('application/x-ontodia-elements')
        || tryGetIri('text/uri-list', true)
        || tryGetIri('text') // IE11, Edge
        || [];
}


/***/ }),
/* 141 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var classTree_1 = __webpack_require__(142);
Object.defineProperty(exports, "ClassTree", ({ enumerable: true, get: function () { return classTree_1.ClassTree; } }));


/***/ }),
/* 142 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClassTree = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const elements_1 = __webpack_require__(53);
const async_1 = __webpack_require__(61);
const collections_1 = __webpack_require__(56);
const events_1 = __webpack_require__(55);
const spinner_1 = __webpack_require__(90);
const progressBar_1 = __webpack_require__(120);
const treeModel_1 = __webpack_require__(143);
const leaf_1 = __webpack_require__(144);
const CLASS_NAME = 'ontodia-class-tree';
const MIN_TERM_LENGTH = 3;
class ClassTree extends React.Component {
    constructor(props) {
        super(props);
        this.listener = new events_1.EventObserver();
        this.delayedClassUpdate = new async_1.Debouncer();
        this.delayedSearch = new async_1.Debouncer(200 /* ms */);
        this.loadClassesOperation = new async_1.Cancellation();
        this.refreshOperation = new async_1.Cancellation();
        this.onSearchTextChange = (e) => {
            const requestedSearchText = e.currentTarget.value;
            this.setState({ requestedSearchText });
            this.delayedSearch.call(this.performSearch);
        };
        this.performSearch = () => {
            const { requestedSearchText } = this.state;
            const requested = normalizeSearchText(requestedSearchText);
            if (requested === this.state.appliedSearchText) {
                return;
            }
            const appliedSearchText = requested.length < MIN_TERM_LENGTH ? undefined : requested;
            this.setState((state) => applyFilters(Object.assign(Object.assign({}, state), { appliedSearchText })));
        };
        this.onShowOnlyCreatableChange = (e) => {
            this.setState((state) => applyFilters(Object.assign(Object.assign({}, state), { showOnlyConstructible: !state.showOnlyConstructible })));
        };
        this.onSelectNode = (node) => {
            const { onClassSelected } = this.props;
            this.setState({ selectedNode: node });
            onClassSelected(node.model.id);
        };
        this.onCreateInstance = (node) => {
            const { onCreateInstance } = this.props;
            onCreateInstance(node.model.id);
        };
        this.onDragCreate = (node) => {
            const { view, onCreateInstance } = this.props;
            view.setHandlerForNextDropOnPaper(e => {
                onCreateInstance(node.model.id, e.paperPosition);
            });
        };
        this.refreshClassTree = () => {
            const cancellation = new async_1.Cancellation();
            const { editor } = this.props;
            this.refreshOperation.abort();
            this.refreshOperation = cancellation;
            this.setState((state, props) => {
                if (!this.classTree) {
                    return { refreshingState: progressBar_1.ProgressState.none };
                }
                let refreshingState = progressBar_1.ProgressState.none;
                if (editor.inAuthoringMode) {
                    const newIris = getNewClassIris(state.constructibleClasses, this.classTree);
                    if (newIris.size > 0) {
                        refreshingState = progressBar_1.ProgressState.loading;
                        this.queryCreatableTypes(newIris, cancellation.signal);
                    }
                }
                const roots = createRoots(this.classTree, props.view);
                return applyFilters(Object.assign(Object.assign({}, state), { roots: sortTree(roots), refreshingState }));
            });
        };
        this.state = {
            refreshingState: progressBar_1.ProgressState.none,
            roots: [],
            filteredRoots: [],
            requestedSearchText: '',
            appliedSearchText: '',
            constructibleClasses: new Map(),
            showOnlyConstructible: false,
        };
    }
    render() {
        const { view, editor } = this.props;
        const { refreshingState, requestedSearchText, appliedSearchText, filteredRoots, selectedNode, constructibleClasses, showOnlyConstructible } = this.state;
        const normalizedSearchText = normalizeSearchText(requestedSearchText);
        // highlight search term only if actual tree is already filtered by current or previous term:
        //  - this immediately highlights typed characters thus making it look more responsive,
        //  - prevents expanding non-filtered tree (which can be too large) just to highlight the term
        const searchText = appliedSearchText ? normalizedSearchText : undefined;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: `${CLASS_NAME}__filter` },
                React.createElement("div", { className: `${CLASS_NAME}__filter-group` },
                    React.createElement("input", { type: 'text', className: 'search-input ontodia-form-control', placeholder: 'Search for...', value: this.state.requestedSearchText, onChange: this.onSearchTextChange }),
                    editor.inAuthoringMode ? (React.createElement("label", { className: `${CLASS_NAME}__only-creatable` },
                        React.createElement("input", { type: 'checkbox', checked: showOnlyConstructible, onChange: this.onShowOnlyCreatableChange }),
                        " Show only constructible")) : null)),
            React.createElement(progressBar_1.ProgressBar, { state: refreshingState }),
            this.classTree ? (React.createElement(leaf_1.Forest, { className: `${CLASS_NAME}__tree ontodia-scrollable`, view: view, nodes: filteredRoots, searchText: searchText, selectedNode: selectedNode, onSelect: this.onSelectNode, creatableClasses: constructibleClasses, onClickCreate: this.onCreateInstance, onDragCreate: this.onDragCreate })) : (React.createElement("div", { className: `${CLASS_NAME}__spinner` },
                React.createElement(spinner_1.HtmlSpinner, { width: 30, height: 30 })))));
    }
    componentDidMount() {
        const { view, editor } = this.props;
        this.listener.listen(view.events, 'changeLanguage', () => this.refreshClassTree());
        this.listener.listen(editor.model.events, 'loadingStart', () => {
            this.initClassTree();
        });
        this.listener.listen(editor.model.events, 'classEvent', ({ data }) => {
            if (data.changeLabel || data.changeCount) {
                this.delayedClassUpdate.call(this.refreshClassTree);
            }
        });
        this.initClassTree();
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.delayedClassUpdate.dispose();
        this.delayedSearch.dispose();
        this.loadClassesOperation.abort();
        this.refreshOperation.abort();
    }
    initClassTree() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.dataProvider !== this.props.editor.model.dataProvider) {
                this.dataProvider = this.props.editor.model.dataProvider;
                this.classTree = undefined;
                const cancellation = new async_1.Cancellation();
                this.loadClassesOperation.abort();
                this.loadClassesOperation = cancellation;
                const classes = yield this.dataProvider.classTree();
                if (cancellation.signal.aborted) {
                    return;
                }
                this.setClassTree(classes);
            }
            this.refreshClassTree();
        });
    }
    setClassTree(roots) {
        const diagramModel = this.props.editor.model;
        const visiting = new Set();
        const reduceNonCycle = (acc, model) => {
            if (!visiting.has(model.id)) {
                visiting.add(model.id);
                const children = model.children.reduce(reduceNonCycle, []);
                acc.push(Object.assign(Object.assign({}, model), { children }));
                visiting.delete(model.id);
            }
            return acc;
        };
        this.classTree = roots.reduce(reduceNonCycle, []);
        const addClass = (model) => {
            const existing = diagramModel.getClass(model.id);
            if (!existing) {
                const { id, label, count, children } = model;
                const richClass = new elements_1.FatClassModel({ id, label: label.values, count });
                diagramModel.addClass(richClass);
                children.forEach(addClass);
            }
        };
        this.classTree.forEach(addClass);
        this.refreshClassTree();
    }
    queryCreatableTypes(typeIris, ct) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.props.editor.metadataApi.filterConstructibleTypes(typeIris, ct);
                if (ct.aborted) {
                    return;
                }
                this.setState((state) => {
                    const constructibleClasses = collections_1.cloneMap(state.constructibleClasses);
                    typeIris.forEach(type => {
                        constructibleClasses.set(type, result.has(type));
                    });
                    return applyFilters(Object.assign(Object.assign({}, state), { constructibleClasses, refreshingState: progressBar_1.ProgressState.completed }));
                });
            }
            catch (err) {
                // tslint:disable-next-line:no-console
                console.error(err);
                if (ct.aborted) {
                    return;
                }
                this.setState((state) => applyFilters(Object.assign(Object.assign({}, state), { refreshingState: progressBar_1.ProgressState.error })));
            }
        });
    }
}
exports.ClassTree = ClassTree;
function createRoots(classTree, view) {
    const mapClass = (model) => {
        const richClass = view.model.createClass(model.id);
        return {
            model: richClass,
            label: view.formatLabel(richClass.label, richClass.id),
            derived: model.children.map(mapClass),
        };
    };
    return classTree.map(mapClass);
}
function getNewClassIris(existingClasses, classTree) {
    const classIris = new Set();
    const visitClass = (model) => {
        if (!existingClasses.has(model.id)) {
            classIris.add(model.id);
        }
        model.children.forEach(visitClass);
    };
    classTree.forEach(visitClass);
    return classIris;
}
function normalizeSearchText(text) {
    return text.trim().toLowerCase();
}
function sortTree(roots) {
    function mapNodes(nodes) {
        if (nodes.length === 0) {
            return nodes;
        }
        const mapped = nodes.map(mapNode);
        mapped.sort(compareByLabel);
        return mapped;
    }
    function mapNode(node) {
        return treeModel_1.TreeNode.setDerived(node, mapNodes(node.derived));
    }
    function compareByLabel(left, right) {
        return left.label.localeCompare(right.label);
    }
    return mapNodes(roots);
}
function applyFilters(state) {
    let filteredRoots = state.roots;
    if (state.appliedSearchText) {
        filteredRoots = filterByKeyword(filteredRoots, state.appliedSearchText);
    }
    if (state.showOnlyConstructible) {
        filteredRoots = filterOnlyCreatable(filteredRoots, state.constructibleClasses);
    }
    return Object.assign(Object.assign({}, state), { filteredRoots });
}
function filterByKeyword(roots, searchText) {
    if (roots.length === 0) {
        return roots;
    }
    function collectByKeyword(acc, node) {
        const derived = node.derived.reduce(collectByKeyword, []);
        // keep parent if children is included or label contains keyword
        if (derived.length > 0 || node.label.toLowerCase().indexOf(searchText) >= 0) {
            acc.push(treeModel_1.TreeNode.setDerived(node, derived));
        }
        return acc;
    }
    return roots.reduce(collectByKeyword, []);
}
function filterOnlyCreatable(roots, creatableClasses) {
    function collectOnlyCreatable(acc, node) {
        const derived = node.derived.reduce(collectOnlyCreatable, []);
        if (derived.length > 0 || creatableClasses.get(node.model.id)) {
            acc.push(treeModel_1.TreeNode.setDerived(node, derived));
        }
        return acc;
    }
    return roots.reduce(collectOnlyCreatable, []);
}


/***/ }),
/* 143 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TreeNode = void 0;
exports.TreeNode = {
    setDerived: (node, derived) => (Object.assign(Object.assign({}, node), { derived })),
};


/***/ }),
/* 144 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Forest = exports.Leaf = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const listElementView_1 = __webpack_require__(121);
const EXPAND_ICON = __webpack_require__(145);
const COLLAPSE_ICON = __webpack_require__(146);
const DEFAULT_LEAF_ICON = __webpack_require__(147);
const DEFAULT_PARENT_ICON = __webpack_require__(148);
const LEAF_CLASS = 'ontodia-class-leaf';
class Leaf extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = (e) => {
            e.preventDefault();
            const { node, onSelect } = this.props;
            onSelect(node);
        };
        this.toggle = () => {
            this.setState((state) => ({ expanded: !state.expanded }));
        };
        this.onClickCreate = () => {
            this.props.onClickCreate(this.props.node);
        };
        this.onDragCreate = (e) => {
            // sets the drag data to support drag-n-drop in Firefox
            // see https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations for more details
            // IE supports only 'text' and 'URL' formats, see https://msdn.microsoft.com/en-us/ie/ms536744(v=vs.94)
            e.dataTransfer.setData('text', '');
            this.props.onDragCreate(this.props.node);
        };
        this.state = {
            expanded: Boolean(this.props.searchText),
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.searchText !== nextProps.searchText) {
            this.setState({
                expanded: Boolean(nextProps.searchText),
            });
        }
    }
    render() {
        const _a = this.props, { node } = _a, otherProps = tslib_1.__rest(_a, ["node"]);
        const { view, selectedNode, searchText, creatableClasses } = otherProps;
        const { expanded } = this.state;
        let toggleIcon;
        if (node.derived.length > 0) {
            toggleIcon = expanded ? COLLAPSE_ICON : EXPAND_ICON;
        }
        let { icon } = view.getTypeStyle([node.model.id]);
        if (!icon) {
            icon = node.derived.length === 0 ? DEFAULT_LEAF_ICON : DEFAULT_PARENT_ICON;
        }
        let bodyClass = `${LEAF_CLASS}__body`;
        if (selectedNode && selectedNode.model === node.model) {
            bodyClass += ` ${LEAF_CLASS}__body--selected`;
        }
        const label = listElementView_1.highlightSubstring(node.label, searchText, { className: `${LEAF_CLASS}__highlighted-term` });
        return (React.createElement("div", { className: LEAF_CLASS, role: 'tree-item' },
            React.createElement("div", { className: `${LEAF_CLASS}__row` },
                React.createElement("div", { className: `${LEAF_CLASS}__toggle`, onClick: this.toggle, role: 'button' }, toggleIcon ? React.createElement("img", { className: `${LEAF_CLASS}__toggle-icon`, src: toggleIcon }) : null),
                React.createElement("a", { className: bodyClass, href: node.model.id, onClick: this.onClick },
                    React.createElement("div", { className: `${LEAF_CLASS}__icon-container` },
                        React.createElement("img", { className: `${LEAF_CLASS}__icon`, src: icon })),
                    React.createElement("span", { className: `${LEAF_CLASS}__label` }, label),
                    node.model.count ? (React.createElement("span", { className: `${LEAF_CLASS}__count ontodia-badge` }, node.model.count)) : null),
                creatableClasses.get(node.model.id) ? (React.createElement("div", { className: `${LEAF_CLASS}__create ontodia-btn-group ontodia-btn-group-xs` },
                    React.createElement("button", { className: 'ontodia-btn ontodia-btn-default', title: 'Click or drag to create new entity of this type', draggable: true, onClick: this.onClickCreate, onDragStart: this.onDragCreate }, "+"))) : null),
            expanded && node.derived.length > 0 ? (React.createElement(Forest, Object.assign({ className: `${LEAF_CLASS}__children`, nodes: node.derived }, otherProps))) : null));
    }
}
exports.Leaf = Leaf;
class Forest extends React.Component {
    render() {
        const _a = this.props, { nodes, className } = _a, otherProps = tslib_1.__rest(_a, ["nodes", "className"]);
        return (React.createElement("div", { className: className, role: 'tree' }, nodes.map(node => (React.createElement(Leaf, Object.assign({ key: `node-${node.model.id}`, node: node }, otherProps))))));
    }
}
exports.Forest = Forest;


/***/ }),
/* 145 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Ym94PSIwIDAgMTI4IDEyOCI+DQogIDxlbGxpcHNlIHN0cm9rZT0iIzAwMCIgcnk9IjYwIiByeD0iNjAiIGN5PSI2NCIgY3g9IjY0IiBzdHJva2Utd2lkdGg9IjUiIGZpbGw9Im5vbmUiLz4NCiAgPGxpbmUgeTI9IjYzLjQzNzUiIHgyPSIxMDQuNSIgeTE9IjYzLjQzNzUiIHgxPSIyMi41IiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZT0iIzAwMCIgZmlsbD0ibm9uZSIvPg0KICA8bGluZSB5Mj0iMTAyLjQ0NDM0OSIgeDI9IjYzLjUiIHkxPSIyOS40Mzc1IiB4MT0iNjMuNSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2U9IiMwMDAiIGZpbGw9Im5vbmUiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 146 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Ym94PSIwIDAgMTI4IDEyOCI+DQogIDxlbGxpcHNlIHN0cm9rZT0iIzAwMCIgcnk9IjYwIiByeD0iNjAiIGN5PSI2NCIgY3g9IjY0IiBzdHJva2Utd2lkdGg9IjUiIGZpbGw9Im5vbmUiLz4NCiAgPGxpbmUgeTI9IjYzLjQzNzUiIHgyPSIxMDQuNSIgeTE9IjYzLjQzNzUiIHgxPSIyMi41IiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZT0iIzAwMCIgZmlsbD0ibm9uZSIvPg0KPC9zdmc+DQo="

/***/ }),
/* 147 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnDQogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIg0KICAgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiDQogICB3aWR0aD0iMTI4Ig0KICAgaGVpZ2h0PSIxMjgiDQogICB2aWV3Ym94PSIwIDAgMTI4IDEyOCINCiAgIHZlcnNpb249IjEuMSINCiAgIGlkPSJzdmc0NTA3Ig0KICAgc29kaXBvZGk6ZG9jbmFtZT0idHJlZS1sZWFmLnN2ZyINCiAgIGlua3NjYXBlOnZlcnNpb249IjAuOTIuMSByMTUzNzEiPg0KICA8ZGVmcw0KICAgICBpZD0iZGVmczQ1MTEiIC8+DQogIDxzb2RpcG9kaTpuYW1lZHZpZXcNCiAgICAgcGFnZWNvbG9yPSIjZmZmZmZmIg0KICAgICBib3JkZXJjb2xvcj0iIzY2NjY2NiINCiAgICAgYm9yZGVyb3BhY2l0eT0iMSINCiAgICAgb2JqZWN0dG9sZXJhbmNlPSIxMCINCiAgICAgZ3JpZHRvbGVyYW5jZT0iMTAiDQogICAgIGd1aWRldG9sZXJhbmNlPSIxMCINCiAgICAgaW5rc2NhcGU6cGFnZW9wYWNpdHk9IjAiDQogICAgIGlua3NjYXBlOnBhZ2VzaGFkb3c9IjIiDQogICAgIGlua3NjYXBlOndpbmRvdy13aWR0aD0iMTkyMCINCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iMTAxNyINCiAgICAgaWQ9Im5hbWVkdmlldzQ1MDkiDQogICAgIHNob3dncmlkPSJmYWxzZSINCiAgICAgaW5rc2NhcGU6em9vbT0iMC45MDUwOTY2OCINCiAgICAgaW5rc2NhcGU6Y3g9Ii0yNzIuNjg0NyINCiAgICAgaW5rc2NhcGU6Y3k9Ii01Ljg1OTY0ODciDQogICAgIGlua3NjYXBlOndpbmRvdy14PSItOCINCiAgICAgaW5rc2NhcGU6d2luZG93LXk9Ii04Ig0KICAgICBpbmtzY2FwZTp3aW5kb3ctbWF4aW1pemVkPSIxIg0KICAgICBpbmtzY2FwZTpjdXJyZW50LWxheWVyPSJzdmc0NTA3IiAvPg0KICA8Zw0KICAgICBpZD0iZzQ1MDUiPg0KICAgIDxjaXJjbGUNCiAgICAgICBpZD0ic3ZnXzEiDQogICAgICAgY3k9IjY0Ig0KICAgICAgIGN4PSI2NCINCiAgICAgICBzdHJva2Utb3BhY2l0eT0ibnVsbCINCiAgICAgICBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMTU3M2IwO3N0cm9rZS13aWR0aDo1Ig0KICAgICAgIHI9IjYwIiAvPg0KICAgIDxjaXJjbGUNCiAgICAgICBpZD0ic3ZnXzMiDQogICAgICAgY3k9IjY0Ig0KICAgICAgIGN4PSI2NCINCiAgICAgICBzdHJva2Utb3BhY2l0eT0ibnVsbCINCiAgICAgICBzdHlsZT0iZmlsbDojMTU3M2IwO3N0cm9rZTojMTU3M2IwO3N0cm9rZS13aWR0aDo1LjcxMDI2MzI1Ig0KICAgICAgIHI9IjM3IiAvPg0KICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 148 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnDQogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIg0KICAgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIg0KICAgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiDQogICB3aWR0aD0iMTI4Ig0KICAgaGVpZ2h0PSIxMjgiDQogICB2aWV3Ym94PSIwIDAgMTI4IDEyOCINCiAgIHZlcnNpb249IjEuMSINCiAgIGlkPSJzdmc1MDg4Ig0KICAgc29kaXBvZGk6ZG9jbmFtZT0idHJlZS1sZWFmLWZvbGRlci5zdmciDQogICBpbmtzY2FwZTp2ZXJzaW9uPSIwLjkyLjEgcjE1MzcxIj4NCiAgPGRlZnMNCiAgICAgaWQ9ImRlZnM1MDkyIiAvPg0KICA8c29kaXBvZGk6bmFtZWR2aWV3DQogICAgIHBhZ2Vjb2xvcj0iI2ZmZmZmZiINCiAgICAgYm9yZGVyY29sb3I9IiM2NjY2NjYiDQogICAgIGJvcmRlcm9wYWNpdHk9IjEiDQogICAgIG9iamVjdHRvbGVyYW5jZT0iMTAiDQogICAgIGdyaWR0b2xlcmFuY2U9IjEwIg0KICAgICBndWlkZXRvbGVyYW5jZT0iMTAiDQogICAgIGlua3NjYXBlOnBhZ2VvcGFjaXR5PSIwIg0KICAgICBpbmtzY2FwZTpwYWdlc2hhZG93PSIyIg0KICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjE5MjAiDQogICAgIGlua3NjYXBlOndpbmRvdy1oZWlnaHQ9IjEwMTciDQogICAgIGlkPSJuYW1lZHZpZXc1MDkwIg0KICAgICBzaG93Z3JpZD0iZmFsc2UiDQogICAgIGlua3NjYXBlOnpvb209IjIuNjA3NDU2MyINCiAgICAgaW5rc2NhcGU6Y3g9IjEyOC43NDYxNCINCiAgICAgaW5rc2NhcGU6Y3k9IjMwLjkwNTQ3MiINCiAgICAgaW5rc2NhcGU6d2luZG93LXg9Ii04Ig0KICAgICBpbmtzY2FwZTp3aW5kb3cteT0iLTgiDQogICAgIGlua3NjYXBlOndpbmRvdy1tYXhpbWl6ZWQ9IjEiDQogICAgIGlua3NjYXBlOmN1cnJlbnQtbGF5ZXI9InN2ZzUwODgiIC8+DQogIDxnDQogICAgIGlkPSJnNTA4NiI+DQogICAgPGNpcmNsZQ0KICAgICAgIGlkPSJzdmdfMSINCiAgICAgICBjeT0iNjQiDQogICAgICAgY3g9IjY0Ig0KICAgICAgIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMxNTczYjA7c3Ryb2tlLXdpZHRoOjUiDQogICAgICAgcj0iNjAiIC8+DQogICAgPGNpcmNsZQ0KICAgICAgIGlkPSJzdmdfMyINCiAgICAgICBjeT0iNjQiDQogICAgICAgY3g9IjY0Ig0KICAgICAgIHN0cm9rZS1vcGFjaXR5PSJudWxsIg0KICAgICAgIHN0eWxlPSJmaWxsOiMxNTczYjA7c3Ryb2tlOiMxNTczYjA7c3Ryb2tlLXdpZHRoOjUiDQogICAgICAgcj0iMzciIC8+DQogICAgPHBhdGgNCiAgICAgICBpZD0ic3ZnXzUiDQogICAgICAgZD0ibSAxMjcuMjI1OCw4Ni41NDY2NDMgYyAtMC4wMTA1LC01Ljk3MTA2NSAtNC43MjMxNCwtMTAuODA5MDM0IC0xMC41NDAwOSwtMTAuODE3MTQ3IHYgLTAuMDAyNyBIIDg0LjM4MDE1MiBjIC0xLjMzMTAyLC00LjM4NjM1MyAtNS4zMDAzNTcsLTcuNTkzNjM3IC0xMC4wMjg3NzEsLTcuNjAxNzUgaCAtNy41Nzc1ODcgYyAtNS44MTk1ODYsMC4wMDU0IC0xMC41MzQ4MjIsNC44NDYwODIgLTEwLjU0NTM2NSwxMC44MTcxNDcgdiAzOC4zNjg0MTcgYyAwLjAxMDU0LDUuOTY1NjUgNC43MjU3NzgsMTAuODAzNjIgMTAuNTQ1MzY1LDEwLjgxNDQ0IGggNDkuOTE0NTU2IGMgNS44MTE2NywtMC4wMTA4IDEwLjUyOTU1LC00Ljg0ODc5IDEwLjU0MDA5LC0xMC44MTQ0NCBWIDg2LjU0NjY0MyBaIg0KICAgICAgIGlua3NjYXBlOmNvbm5lY3Rvci1jdXJ2YXR1cmU9IjAiDQogICAgICAgc3R5bGU9ImZpbGw6IzBmNTM3NiINCiAgICAgICBzb2RpcG9kaTpub2RldHlwZXM9ImNjY2NjY2NjY2NjY2MiIC8+DQogIDwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 149 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkTypesToolbox = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const commands_1 = __webpack_require__(64);
const elements_1 = __webpack_require__(53);
const async_1 = __webpack_require__(61);
const events_1 = __webpack_require__(55);
const listElementView_1 = __webpack_require__(121);
const progressBar_1 = __webpack_require__(120);
class LinkInToolBox extends React.Component {
    constructor() {
        super(...arguments);
        this.onPressFilter = () => {
            if (this.props.onPressFilter) {
                this.props.onPressFilter(this.props.link);
            }
        };
        this.changeState = (state) => {
            const history = this.props.view.model.history;
            changeLinkTypeState(history, state, [this.props.link]);
        };
        this.isChecked = (stateName) => {
            let curState;
            if (!this.props.link.visible) {
                curState = 'invisible';
            }
            else if (!this.props.link.showLabel) {
                curState = 'withoutLabels';
            }
            else {
                curState = 'allVisible';
            }
            return stateName === curState;
        };
        this.getText = () => {
            const { link: linkType, view, filterKey } = this.props;
            const fullText = view.formatLabel(linkType.label, linkType.id);
            return listElementView_1.highlightSubstring(fullText, filterKey);
        };
    }
    render() {
        const newIcon = (this.props.link.isNew ? React.createElement("span", { className: 'linkInToolBox__new-tag' }, "new") : '');
        const countIcon = (this.props.count > 0 ? React.createElement("span", { className: 'ontodia-badge' }, this.props.count) : '');
        const badgeContainer = (newIcon || countIcon ? React.createElement("div", null,
            newIcon,
            countIcon) : '');
        return (React.createElement("li", { "data-linktypeid": this.props.link.id, className: 'ontodia-list-group-item linkInToolBox clearfix' },
            React.createElement("span", { className: 'ontodia-btn-group ontodia-btn-group-xs', "data-toggle": 'buttons' },
                React.createElement("label", { className: 'ontodia-btn ontodia-btn-default' + (this.isChecked('invisible') ? ' active' : ''), id: 'invisible', title: 'Hide links and labels', onClick: () => this.changeState('invisible') },
                    React.createElement("span", { className: 'fa fa-times', "aria-hidden": 'true' })),
                React.createElement("label", { className: 'ontodia-btn ontodia-btn-default' + (this.isChecked('withoutLabels') ? ' active' : ''), id: 'withoutLabels', title: 'Show links without labels', onClick: () => this.changeState('withoutLabels') },
                    React.createElement("span", { className: 'fa fa-arrows-h', "aria-hidden": 'true' })),
                React.createElement("label", { className: 'ontodia-btn ontodia-btn-default' + (this.isChecked('allVisible') ? ' active' : ''), id: 'allVisible', title: 'Show links with labels', onClick: () => this.changeState('allVisible') },
                    React.createElement("span", { className: 'fa fa-text-width', "aria-hidden": 'true' }))),
            React.createElement("div", { className: 'link-title' }, this.getText()),
            badgeContainer,
            React.createElement("div", { className: 'linkInToolBox__filter-button', onClick: this.onPressFilter })));
    }
}
class LinkTypesToolboxView extends React.Component {
    constructor(props) {
        super(props);
        this.compareLinks = (a, b) => {
            const { view } = this.props;
            const aText = view.formatLabel(a.label, a.id);
            const bText = view.formatLabel(b.label, b.id);
            return aText.localeCompare(bText);
        };
        this.onChangeInput = (e) => {
            this.setState({ filterKey: e.currentTarget.value });
        };
        this.onDropFilter = () => {
            this.setState({ filterKey: '' });
        };
        this.getLinks = () => {
            const { view, links = [] } = this.props;
            return links.filter(linkType => {
                const text = view.formatLabel(linkType.label, linkType.id).toLowerCase();
                return !this.state.filterKey || text.indexOf(this.state.filterKey.toLowerCase()) >= 0;
            })
                .sort(this.compareLinks);
        };
        this.getViews = (links) => {
            const countMap = this.props.countMap || {};
            const views = [];
            for (const link of links) {
                views.push(React.createElement(LinkInToolBox, { key: link.id, view: this.props.view, link: link, onPressFilter: this.props.filterCallback, count: countMap[link.id] || 0, filterKey: this.state.filterKey }));
            }
            return views;
        };
        this.state = { filterKey: '' };
    }
    render() {
        const className = 'link-types-toolbox';
        const { view, dataState, selectedElement } = this.props;
        const history = view.model.history;
        const links = this.getLinks();
        const views = this.getViews(links);
        let connectedTo = null;
        if (selectedElement) {
            const selectedElementLabel = view.formatLabel(selectedElement.data.label.values, selectedElement.iri);
            connectedTo = (React.createElement("h4", { className: 'links-heading', style: { display: 'block' } },
                "Connected to",
                '\u00A0',
                React.createElement("span", null, selectedElement.iri)));
        }
        let dropButton = null;
        if (this.state.filterKey) {
            dropButton = React.createElement("button", { type: 'button', className: `${className}__clearSearch`, onClick: this.onDropFilter },
                React.createElement("span", { className: 'fa fa-times', "aria-hidden": 'true' }));
        }
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: `${className}__heading` },
                React.createElement("div", { className: `${className}__searching-box` },
                    React.createElement("input", { className: 'search-input ontodia-form-control', type: 'text', value: this.state.filterKey, onChange: this.onChangeInput, placeholder: 'Search for...' }),
                    dropButton),
                React.createElement("div", { className: `${className}__switch-all` },
                    React.createElement("div", { className: 'ontodia-btn-group ontodia-btn-group-xs' },
                        React.createElement("label", { className: 'ontodia-btn ontodia-btn-default', title: 'Hide links and labels', onClick: () => changeLinkTypeState(history, 'invisible', links) },
                            React.createElement("span", { className: 'fa fa-times', "aria-hidden": 'true' })),
                        React.createElement("label", { className: 'ontodia-btn ontodia-btn-default', title: 'Show links without labels', onClick: () => changeLinkTypeState(history, 'withoutLabels', links) },
                            React.createElement("span", { className: 'fa fa-arrows-h', "aria-hidden": 'true' })),
                        React.createElement("label", { className: 'ontodia-btn ontodia-btn-default', title: 'Show links with labels', onClick: () => changeLinkTypeState(history, 'allVisible', links) },
                            React.createElement("span", { className: 'fa fa-text-width', "aria-hidden": 'true' }))),
                    React.createElement("span", null, "\u00A0Switch all"))),
            React.createElement(progressBar_1.ProgressBar, { state: dataState }),
            React.createElement("div", { className: `${className}__rest` },
                connectedTo,
                React.createElement("div", { className: 'ontodia-scrollable' },
                    React.createElement("ul", { className: 'ontodia-list-group connected-links' }, views)))));
    }
}
class LinkTypesToolbox extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.listener = new events_1.EventObserver();
        this.linkListener = new events_1.EventObserver();
        this.debounceSelection = new async_1.Debouncer(50 /* ms */);
        this.updateOnCurrentSelection = () => {
            const { editor } = this.props;
            const single = editor.selection.length === 1 ? editor.selection[0] : null;
            if (single !== this.state.selectedElement && single instanceof elements_1.Element) {
                this.requestLinksOf(single);
            }
        };
        this.onLinkChanged = () => {
            this.forceUpdate();
        };
        this.onAddToFilter = (linkType) => {
            const { selectedElement } = this.state;
            selectedElement.addToFilter(linkType);
        };
        const { view, editor } = this.props;
        this.listener.listen(view.events, 'changeLanguage', () => this.updateOnCurrentSelection());
        this.listener.listen(editor.model.events, 'loadingSuccess', () => this.updateOnCurrentSelection());
        this.listener.listen(editor.events, 'changeSelection', () => {
            this.debounceSelection.call(this.updateOnCurrentSelection);
        });
        this.state = { dataState: progressBar_1.ProgressState.none };
    }
    componentDidMount() {
        this.updateOnCurrentSelection();
    }
    componentWillUnmount() {
        this.listener.stopListening();
        this.linkListener.stopListening();
        this.debounceSelection.dispose();
    }
    requestLinksOf(selectedElement) {
        if (selectedElement) {
            const request = { elementId: selectedElement.iri };
            this.currentRequest = request;
            this.setState({ dataState: progressBar_1.ProgressState.loading, selectedElement });
            this.props.editor.model.dataProvider.linkTypesOf(request).then(linkTypes => {
                if (this.currentRequest !== request) {
                    return;
                }
                const { linksOfElement, countMap } = this.computeStateFromRequestResult(linkTypes);
                this.subscribeOnLinksEvents(linksOfElement);
                this.setState({ dataState: progressBar_1.ProgressState.completed, linksOfElement, countMap });
            }).catch(error => {
                if (this.currentRequest !== request) {
                    return;
                }
                // tslint:disable-next-line:no-console
                console.error(error);
                this.setState({ dataState: progressBar_1.ProgressState.error, linksOfElement: undefined, countMap: {} });
            });
        }
        else {
            this.currentRequest = null;
            this.setState({
                dataState: progressBar_1.ProgressState.completed,
                selectedElement,
                linksOfElement: undefined,
                countMap: {},
            });
        }
    }
    computeStateFromRequestResult(linkTypes) {
        const linksOfElement = [];
        const countMap = {};
        const model = this.props.editor.model;
        for (const linkType of linkTypes) {
            const type = model.createLinkType(linkType.id);
            linksOfElement.push(type);
            countMap[linkType.id] = linkType.inCount + linkType.outCount;
        }
        return { linksOfElement, countMap };
    }
    subscribeOnLinksEvents(linksOfElement) {
        this.linkListener.stopListening();
        const listener = this.linkListener;
        for (const link of linksOfElement) {
            listener.listen(link.events, 'changeLabel', this.onLinkChanged);
            listener.listen(link.events, 'changeVisibility', this.onLinkChanged);
        }
    }
    render() {
        const { view } = this.props;
        const { selectedElement, dataState, linksOfElement, countMap } = this.state;
        return React.createElement(LinkTypesToolboxView, { view: view, dataState: dataState, links: linksOfElement, countMap: countMap, filterCallback: this.onAddToFilter, selectedElement: selectedElement });
    }
}
exports.LinkTypesToolbox = LinkTypesToolbox;
function changeLinkTypeState(history, state, links) {
    const batch = history.startBatch();
    const { visible, showLabel } = (state === 'invisible' ? { visible: false, showLabel: false } :
        state === 'withoutLabels' ? { visible: true, showLabel: false } :
            state === 'allVisible' ? { visible: true, showLabel: true } :
                undefined);
    for (const linkType of links) {
        history.execute(commands_1.changeLinkTypeVisibility({ linkType, visible, showLabel }));
    }
    batch.store();
}


/***/ }),
/* 150 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WorkspaceLayout = exports.WorkspaceLayoutType = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const accordion_1 = __webpack_require__(151);
const accordionItem_1 = __webpack_require__(152);
const DEFAULT_HORIZONTAL_COLLAPSED_SIZE = 28;
var WorkspaceLayoutType;
(function (WorkspaceLayoutType) {
    WorkspaceLayoutType["Row"] = "row";
    WorkspaceLayoutType["Column"] = "column";
    WorkspaceLayoutType["Component"] = "component";
})(WorkspaceLayoutType = exports.WorkspaceLayoutType || (exports.WorkspaceLayoutType = {}));
class WorkspaceLayout extends React.Component {
    renderAccordion({ children, direction, animationDuration }) {
        const { _onStartResize, _onResize } = this.props;
        const items = children.map((child, index) => {
            let dockSide;
            if (direction === 'horizontal' && !child.undocked) {
                if (index === 0) {
                    dockSide = accordionItem_1.DockSide.Left;
                }
                else if (index === children.length - 1) {
                    dockSide = accordionItem_1.DockSide.Right;
                }
            }
            let collapsedSize = child.collapsedSize;
            if (collapsedSize === undefined && direction === 'horizontal') {
                collapsedSize = DEFAULT_HORIZONTAL_COLLAPSED_SIZE;
            }
            return (React.createElement(accordionItem_1.AccordionItem, { key: child.type === WorkspaceLayoutType.Component ? child.id : index, heading: child.type === WorkspaceLayoutType.Component ? child.heading : undefined, dockSide: dockSide, defaultSize: child.defaultSize, defaultCollapsed: child.defaultCollapsed, collapsedSize: collapsedSize, minSize: child.minSize }, this.renderLayout(child)));
        });
        return (React.createElement(accordion_1.Accordion, { direction: direction, onStartResize: _onStartResize, onResize: _onResize, animationDuration: animationDuration }, items));
    }
    renderLayout(layout) {
        if (layout.type === WorkspaceLayoutType.Row) {
            return this.renderAccordion({
                children: layout.children,
                direction: 'horizontal',
                animationDuration: layout.animationDuration,
            });
        }
        if (layout.type === WorkspaceLayoutType.Column) {
            return this.renderAccordion({
                children: layout.children,
                direction: 'vertical',
                animationDuration: layout.animationDuration,
            });
        }
        if (layout.type === WorkspaceLayoutType.Component) {
            return React.Children.only(layout.content);
        }
        return null;
    }
    render() {
        const { layout } = this.props;
        return this.renderLayout(layout);
    }
}
exports.WorkspaceLayout = WorkspaceLayout;


/***/ }),
/* 151 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Accordion = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const CLASS_NAME = 'ontodia-accordion';
class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.items = [];
        this.isScrollable = false;
        this.updateSizes = () => {
            const { children } = this.props;
            const defaultProps = new Map();
            React.Children.forEach(children, (child, index) => {
                if (typeof child !== 'object') {
                    return;
                }
                const { defaultSize, defaultCollapsed, collapsedSize, minSize } = child.props;
                // enables the scrollbar in the accordion if at least one item has min size
                if (minSize !== undefined) {
                    this.isScrollable = true;
                }
                defaultProps.set(index, { defaultSize, defaultCollapsed, collapsedSize, minSize });
            });
            this.defaultProps = defaultProps;
            this.setState(({ collapsed }) => {
                const totalSize = this.clientSize(this.element.parentElement);
                let leftSize = totalSize;
                let leftChildCount = React.Children.count(children);
                const newCollapsed = [];
                this.defaultProps.forEach(({ defaultSize, defaultCollapsed = false }, index) => {
                    // preserves items collapsed by user
                    let itemCollapsed = collapsed[index] === undefined
                        ? defaultCollapsed
                        : collapsed[index];
                    // if no expanded items, expands the last one
                    const isLastItem = index === this.defaultProps.size - 1;
                    const noExpandedItems = newCollapsed.findIndex(c => !c) < 0;
                    if (isLastItem && noExpandedItems) {
                        itemCollapsed = false;
                    }
                    const size = itemCollapsed ? this.sizeWhenCollapsed(index) : defaultSize;
                    if (size) {
                        leftSize = leftSize - size;
                        leftChildCount = leftChildCount - 1;
                    }
                    newCollapsed.push(itemCollapsed);
                });
                const newSizes = [];
                const newPercents = [];
                this.defaultProps.forEach(({ defaultSize, minSize }, index) => {
                    let size = leftSize / leftChildCount;
                    const collapsedSize = this.sizeWhenCollapsed(index);
                    if (newCollapsed[index]) {
                        size = collapsedSize;
                    }
                    else if (defaultSize !== undefined) {
                        size = defaultSize;
                    }
                    else if (size < minSize) {
                        size = collapsedSize + minSize;
                    }
                    if (size < collapsedSize) {
                        size = collapsedSize;
                        newCollapsed[index] = true;
                    }
                    const percent = `${100 * size / totalSize}%`;
                    newSizes.push(size);
                    newPercents.push(percent);
                });
                return {
                    sizes: newSizes,
                    percents: newPercents,
                    collapsed: newCollapsed,
                };
            });
        };
        this.onBeginDragHandle = (itemIndex) => {
            this.originTotalSize = this.clientSize(this.element);
            this.originSizes = this.computeEffectiveItemSizes();
            this.originCollapsed = [...this.state.collapsed];
            this.setState({ resizing: true }, () => {
                const { direction, onStartResize } = this.props;
                if (onStartResize) {
                    onStartResize(direction);
                }
            });
        };
        this.onEndDragHandle = () => {
            this.setState({ resizing: false });
        };
        this.sizeWhenCollapsed = (index) => {
            const item = this.items[index];
            const { collapsedSize } = this.defaultProps.get(index);
            if (collapsedSize !== undefined) {
                return collapsedSize;
            }
            const headerSize = item.header ? this.clientSize(item.header) : 0;
            return headerSize + (this.offsetSize(item.element) - this.clientSize(item.element));
        };
        this.onDragHandle = (itemIndex, dx, dy) => {
            const sizes = [...this.originSizes];
            const collapsed = [...this.originCollapsed];
            new SizeDistributor(sizes, collapsed, this.originTotalSize, this.sizeWhenCollapsed).distribute(itemIndex + 1, this.isVertical ? dy : dx);
            const percents = sizes.map(size => `${100 * size / this.originTotalSize}%`);
            this.setState({ sizes, percents, collapsed });
        };
        const childCount = React.Children.count(this.props.children);
        this.state = {
            collapsed: [],
            resizing: false,
            percents: React.Children.map(this.props.children, () => `${100 / childCount}%`),
        };
    }
    componentDidMount() {
        this.updateSizes();
    }
    componentDidUpdate(prevProps, prevState) {
        const { direction, children, onResize, animationDuration } = this.props;
        if (React.Children.count(children) !== React.Children.count(prevProps.children)) {
            this.updateSizes();
        }
        const { sizes, resizing } = this.state;
        if (sizes !== prevState.sizes && onResize) {
            if (resizing) {
                onResize(direction);
            }
            else {
                // triggers the callback after finishing CSS animation
                setTimeout(() => onResize(direction), animationDuration);
            }
        }
    }
    get isVertical() {
        return this.props.direction === 'vertical';
    }
    clientSize(element) {
        const { clientWidth, clientHeight } = element;
        return this.isVertical ? clientHeight : clientWidth;
    }
    offsetSize(element) {
        const { offsetWidth, offsetHeight } = element;
        return this.isVertical ? offsetHeight : offsetWidth;
    }
    render() {
        const { direction } = this.props;
        const { resizing } = this.state;
        const resizingClassName = resizing ? `${CLASS_NAME}--resizing` : '';
        const scrollableClassName = this.isScrollable ? `${CLASS_NAME}--scrollable` : '';
        return (React.createElement("div", { className: `${CLASS_NAME} ${CLASS_NAME}--${direction} ${resizingClassName} ${scrollableClassName}`, ref: element => this.element = element }, this.renderItems()));
    }
    renderItems() {
        const { sizes, percents, collapsed } = this.state;
        const { children, direction } = this.props;
        return React.Children.map(children, (child, index) => {
            if (typeof child !== 'object') {
                throw new Error('Accordion should have only AccordionItem elements as children');
            }
            const lastChild = index === React.Children.count(children) - 1;
            const size = collapsed[index] ? sizes[index] : percents[index];
            const additionalProps = {
                ref: element => this.items[index] = element,
                collapsed: collapsed[index],
                size,
                direction,
                onChangeCollapsed: itemCollapsed => this.onItemChangeCollapsed({ itemIndex: index, itemCollapsed }),
                onBeginDragHandle: lastChild ? undefined : () => this.onBeginDragHandle(index),
                onDragHandle: lastChild ? undefined : (dx, dy) => this.onDragHandle(index, dx, dy),
                onEndDragHandle: this.onEndDragHandle,
            };
            return React.cloneElement(child, additionalProps);
        });
    }
    computeEffectiveItemSizes() {
        const sizes = [];
        this.items.forEach((item, index) => {
            if (!item) {
                return;
            }
            if (this.state.collapsed[index]) {
                const collapsedSize = this.sizeWhenCollapsed(index);
                sizes.push(collapsedSize);
            }
            else {
                sizes.push(this.offsetSize(item.element));
            }
        });
        return sizes;
    }
    onItemChangeCollapsed({ itemIndex, itemCollapsed }) {
        const totalSize = this.clientSize(this.element);
        const sizes = this.computeEffectiveItemSizes();
        if (sizes.length === 1) {
            return;
        }
        const collapsed = [...this.state.collapsed];
        const effectiveSize = sizes[itemIndex];
        const collapsedSize = this.sizeWhenCollapsed(itemIndex);
        const distributor = new SizeDistributor(sizes, collapsed, totalSize, this.sizeWhenCollapsed);
        if (itemCollapsed) {
            const splitShift = Math.max(effectiveSize - collapsedSize, 0);
            sizes[itemIndex] = collapsedSize;
            if (itemIndex === sizes.length - 1) {
                distributor.expand(splitShift, itemIndex - 1);
            }
            else {
                distributor.expand(splitShift, itemIndex + 1);
            }
        }
        else {
            const { defaultSize, minSize } = this.defaultProps.get(itemIndex);
            const shift = (defaultSize || (totalSize / sizes.length)) - collapsedSize;
            let freeSize = 0;
            if (itemIndex === sizes.length - 1) {
                freeSize = distributor.collapseForward({ shift, from: itemIndex - 1, to: itemIndex });
            }
            else {
                freeSize = distributor.collapseForward({ shift, from: itemIndex + 1, to: sizes.length });
            }
            freeSize = Math.max(freeSize, distributor.leftoverSize());
            if (freeSize < shift) {
                freeSize += distributor.collapseForward({ shift: shift - freeSize, from: 0, to: itemIndex });
            }
            if (freeSize < minSize) {
                freeSize = minSize;
            }
            sizes[itemIndex] = Math.round(collapsedSize + freeSize);
        }
        collapsed[itemIndex] = itemCollapsed;
        const percents = sizes.map(size => `${100 * size / totalSize}%`);
        this.setState({ sizes, percents, collapsed });
    }
}
exports.Accordion = Accordion;
Accordion.defaultProps = {
    direction: 'vertical',
    animationDuration: 300,
};
class SizeDistributor {
    constructor(sizes, collapsed, totalSize, sizeWhenCollapsed) {
        this.sizes = sizes;
        this.collapsed = collapsed;
        this.totalSize = totalSize;
        this.sizeWhenCollapsed = sizeWhenCollapsed;
    }
    distribute(splitIndex, splitShift) {
        if (splitShift > 0) {
            let freeSize = this.collapseForward({ shift: splitShift, from: splitIndex, to: this.sizes.length });
            freeSize = Math.max(freeSize, this.leftoverSize());
            this.expand(freeSize, splitIndex - 1);
        }
        else {
            let freeSize = this.collapseBackward({ shift: -splitShift, from: 0, to: splitIndex });
            freeSize = Math.max(freeSize, this.leftoverSize());
            this.expand(freeSize, splitIndex);
        }
    }
    collapseForward({ shift, from, to }) {
        if (shift <= 0) {
            return 0;
        }
        let shiftLeft = shift;
        for (let i = from; i < to; i++) {
            shiftLeft = this.collapse(shiftLeft, i);
        }
        return shift - shiftLeft;
    }
    collapseBackward({ shift, from, to }) {
        if (shift <= 0) {
            return 0;
        }
        let shiftLeft = shift;
        for (let i = to - 1; i >= from; i--) {
            shiftLeft = this.collapse(shiftLeft, i);
        }
        return shift - shiftLeft;
    }
    collapse(shift, index) {
        if (this.collapsed[index]) {
            return shift;
        }
        const size = this.sizes[index];
        const collapsedSize = this.sizeWhenCollapsed(index);
        const newSize = Math.round(Math.max(size - shift, collapsedSize));
        this.sizes[index] = newSize;
        this.collapsed[index] = newSize <= collapsedSize;
        return shift - (size - newSize);
    }
    expand(shift, index) {
        if (shift <= 0) {
            return 0;
        }
        const oldSize = this.sizes[index];
        const newSize = Math.round(oldSize + shift);
        this.sizes[index] = newSize;
        this.collapsed[index] = newSize <= this.sizeWhenCollapsed(index);
        return newSize - oldSize;
    }
    leftoverSize() {
        const sizeSum = this.sizes.reduce((sum, size) => sum + size, 0);
        return Math.max(this.totalSize - sizeSum, 0);
    }
}


/***/ }),
/* 152 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AccordionItem = exports.DockSide = void 0;
const tslib_1 = __webpack_require__(1);
const React = tslib_1.__importStar(__webpack_require__(46));
const draggableHandle_1 = __webpack_require__(118);
var DockSide;
(function (DockSide) {
    DockSide[DockSide["Left"] = 1] = "Left";
    DockSide[DockSide["Right"] = 2] = "Right";
})(DockSide = exports.DockSide || (exports.DockSide = {}));
const CLASS_NAME = 'ontodia-accordion-item';
class AccordionItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resizing: false,
        };
    }
    get element() { return this._element; }
    get header() { return this._header; }
    get isVertical() {
        return this.props.direction === 'vertical';
    }
    renderToggleButton() {
        const { collapsed, dockSide, onChangeCollapsed } = this.props;
        if (!dockSide) {
            return null;
        }
        const side = dockSide === DockSide.Left ? 'left' : 'right';
        return React.createElement("div", { className: `${CLASS_NAME}__handle-btn ${CLASS_NAME}__handle-btn-${side}`, onClick: () => onChangeCollapsed(!collapsed) });
    }
    render() {
        const { heading, bodyClassName, children, bodyRef, collapsed, size, direction, onBeginDragHandle, onDragHandle, onEndDragHandle, dockSide, } = this.props;
        const { resizing } = this.state;
        const shouldRenderHandle = onBeginDragHandle && onDragHandle && onEndDragHandle;
        const style = this.isVertical ? { height: size } : { width: size };
        // unmount child component when the accordion item is collapsed and has dockSide
        const isMounted = !(collapsed && dockSide);
        return React.createElement("div", { className: `${CLASS_NAME} ${CLASS_NAME}--${collapsed ? 'collapsed' : 'expanded'} ${CLASS_NAME}--${direction}
                ${resizing ? `${CLASS_NAME}--resizing` : ''}`, ref: element => this._element = element, style: style },
            React.createElement("div", { className: `${CLASS_NAME}__inner` },
                heading ? React.createElement("div", { className: `${CLASS_NAME}__header`, ref: header => this._header = header, onClick: () => this.props.onChangeCollapsed(!collapsed) }, heading) : null,
                React.createElement("div", { className: `${CLASS_NAME}__body` }, children && isMounted ? children :
                    React.createElement("div", { ref: bodyRef, className: `${bodyClassName || ''}` }))),
            shouldRenderHandle ? (React.createElement(draggableHandle_1.DraggableHandle, { className: `${CLASS_NAME}__handle ${CLASS_NAME}__handle-${direction}`, onBeginDragHandle: e => {
                    this.setState({ resizing: true });
                    onBeginDragHandle();
                }, onDragHandle: (e, x, y) => onDragHandle(x, y), onEndDragHandle: e => {
                    this.setState({ resizing: false });
                    onEndDragHandle();
                } })) : null,
            this.renderToggleButton());
    }
}
exports.AccordionItem = AccordionItem;
AccordionItem.defaultProps = {
    direction: 'vertical',
};


/***/ }),
/* 153 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Provider: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.Provider),
/* harmony export */   ReactReduxContext: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.ReactReduxContext),
/* harmony export */   batch: () => (/* reexport safe */ _utils_reactBatchedUpdates__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates),
/* harmony export */   connect: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.connect),
/* harmony export */   connectAdvanced: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.connectAdvanced),
/* harmony export */   createDispatchHook: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.createDispatchHook),
/* harmony export */   createSelectorHook: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.createSelectorHook),
/* harmony export */   createStoreHook: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.createStoreHook),
/* harmony export */   shallowEqual: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.shallowEqual),
/* harmony export */   useDispatch: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.useDispatch),
/* harmony export */   useSelector: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.useSelector),
/* harmony export */   useStore: () => (/* reexport safe */ _exports__WEBPACK_IMPORTED_MODULE_0__.useStore)
/* harmony export */ });
/* harmony import */ var _exports__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(154);
/* harmony import */ var _utils_reactBatchedUpdates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(196);
/* harmony import */ var _utils_batch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(168);


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

(0,_utils_batch__WEBPACK_IMPORTED_MODULE_2__.setBatch)(_utils_reactBatchedUpdates__WEBPACK_IMPORTED_MODULE_1__.unstable_batchedUpdates);


/***/ }),
/* 154 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Provider: () => (/* reexport safe */ _components_Provider__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   ReactReduxContext: () => (/* reexport safe */ _components_Context__WEBPACK_IMPORTED_MODULE_2__.ReactReduxContext),
/* harmony export */   connect: () => (/* reexport safe */ _connect_connect__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   connectAdvanced: () => (/* reexport safe */ _components_connectAdvanced__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   createDispatchHook: () => (/* reexport safe */ _hooks_useDispatch__WEBPACK_IMPORTED_MODULE_4__.createDispatchHook),
/* harmony export */   createSelectorHook: () => (/* reexport safe */ _hooks_useSelector__WEBPACK_IMPORTED_MODULE_5__.createSelectorHook),
/* harmony export */   createStoreHook: () => (/* reexport safe */ _hooks_useStore__WEBPACK_IMPORTED_MODULE_6__.createStoreHook),
/* harmony export */   shallowEqual: () => (/* reexport safe */ _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   useDispatch: () => (/* reexport safe */ _hooks_useDispatch__WEBPACK_IMPORTED_MODULE_4__.useDispatch),
/* harmony export */   useSelector: () => (/* reexport safe */ _hooks_useSelector__WEBPACK_IMPORTED_MODULE_5__.useSelector),
/* harmony export */   useStore: () => (/* reexport safe */ _hooks_useStore__WEBPACK_IMPORTED_MODULE_6__.useStore)
/* harmony export */ });
/* harmony import */ var _components_Provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(155);
/* harmony import */ var _components_connectAdvanced__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(170);
/* harmony import */ var _components_Context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(166);
/* harmony import */ var _connect_connect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(180);
/* harmony import */ var _hooks_useDispatch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(192);
/* harmony import */ var _hooks_useSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(195);
/* harmony import */ var _hooks_useStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(193);
/* harmony import */ var _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(181);










/***/ }),
/* 155 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(156);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);
/* harmony import */ var _utils_Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(167);
/* harmony import */ var _utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var subscription = (0,_utils_Subscription__WEBPACK_IMPORTED_MODULE_2__.createSubscription)(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return store.getState();
  }, [store]);
  (0,_utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__.useIsomorphicLayoutEffect)(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || _Context__WEBPACK_IMPORTED_MODULE_1__.ReactReduxContext;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
      subscribe: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func).isRequired,
      dispatch: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func).isRequired,
      getState: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func).isRequired
    }),
    context: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any)
  };
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Provider);

/***/ }),
/* 156 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(157);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(160)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(165)();
}


/***/ }),
/* 157 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(158);
} else {
  module.exports = __webpack_require__(159);
}


/***/ }),
/* 158 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 159 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 160 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(157);
var assign = __webpack_require__(161);

var ReactPropTypesSecret = __webpack_require__(162);
var has = __webpack_require__(163);
var checkPropTypes = __webpack_require__(164);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 161 */
/***/ ((module) => {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 162 */
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 163 */
/***/ ((module) => {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 164 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(162);
  var loggedTypeFailures = {};
  var has = __webpack_require__(163);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 165 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(162);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 166 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ReactReduxContext: () => (/* binding */ ReactReduxContext),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ReactReduxContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReactReduxContext);

/***/ }),
/* 167 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createSubscription: () => (/* binding */ createSubscription)
/* harmony export */ });
/* harmony import */ var _batch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(168);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = (0,_batch__WEBPACK_IMPORTED_MODULE_0__.getBatch)();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

/***/ }),
/* 168 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getBatch: () => (/* binding */ getBatch),
/* harmony export */   setBatch: () => (/* binding */ setBatch)
/* harmony export */ });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 169 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useIsomorphicLayoutEffect: () => (/* binding */ useIsomorphicLayoutEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

/***/ }),
/* 170 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ connectAdvanced)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(171);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(172);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(173);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(177);
/* harmony import */ var _utils_Subscription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(167);
/* harmony import */ var _utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(169);
/* harmony import */ var _Context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(166);


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  (0,_utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_6__.useIsomorphicLayoutEffect)(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? _Context__WEBPACK_IMPORTED_MODULE_7__.ReactReduxContext : _ref2$context,
      connectOptions = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref2, _excluded);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !(0,react_is__WEBPACK_IMPORTED_MODULE_4__.isValidElementType)(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react__WEBPACK_IMPORTED_MODULE_3__.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__["default"])(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is__WEBPACK_IMPORTED_MODULE_4__.isContextConsumer)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = (0,_utils_Subscription__WEBPACK_IMPORTED_MODULE_5__.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_3__.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
      var lastWrapperProps = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
      var renderIsScheduled = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(WrappedComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react__WEBPACK_IMPORTED_MODULE_3___default().memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react__WEBPACK_IMPORTED_MODULE_3___default().forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(Connect, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 171 */
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _extends)
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 172 */
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ _objectWithoutPropertiesLoose)
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 173 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var reactIs = __webpack_require__(174);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 174 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(175);
} else {
  module.exports = __webpack_require__(176);
}


/***/ }),
/* 175 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 176 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 177 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(178);
} else {
  module.exports = __webpack_require__(179);
}


/***/ }),
/* 178 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 179 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 180 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createConnect: () => (/* binding */ createConnect),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(171);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(172);
/* harmony import */ var _components_connectAdvanced__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(170);
/* harmony import */ var _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(181);
/* harmony import */ var _mapDispatchToProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(182);
/* harmony import */ var _mapStateToProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(188);
/* harmony import */ var _mergeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(189);
/* harmony import */ var _selectorFactory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(190);


var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? _components_connectAdvanced__WEBPACK_IMPORTED_MODULE_2__["default"] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps__WEBPACK_IMPORTED_MODULE_5__["default"] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps__WEBPACK_IMPORTED_MODULE_4__["default"] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps__WEBPACK_IMPORTED_MODULE_6__["default"] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory__WEBPACK_IMPORTED_MODULE_7__["default"] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_3__["default"] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_3__["default"] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _utils_shallowEqual__WEBPACK_IMPORTED_MODULE_3__["default"] : _ref3$areMergedPropsE,
        extraOptions = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/createConnect());

/***/ }),
/* 181 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ shallowEqual)
/* harmony export */ });
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 182 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   whenMapDispatchToPropsIsFunction: () => (/* binding */ whenMapDispatchToPropsIsFunction),
/* harmony export */   whenMapDispatchToPropsIsMissing: () => (/* binding */ whenMapDispatchToPropsIsMissing),
/* harmony export */   whenMapDispatchToPropsIsObject: () => (/* binding */ whenMapDispatchToPropsIsObject)
/* harmony export */ });
/* harmony import */ var _utils_bindActionCreators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(183);
/* harmony import */ var _wrapMapToProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? (0,_wrapMapToProps__WEBPACK_IMPORTED_MODULE_1__.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? (0,_wrapMapToProps__WEBPACK_IMPORTED_MODULE_1__.wrapMapToPropsConstant)(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0,_wrapMapToProps__WEBPACK_IMPORTED_MODULE_1__.wrapMapToPropsConstant)(function (dispatch) {
    return (0,_utils_bindActionCreators__WEBPACK_IMPORTED_MODULE_0__["default"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 183 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bindActionCreators)
/* harmony export */ });
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/***/ }),
/* 184 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getDependsOnOwnProps: () => (/* binding */ getDependsOnOwnProps),
/* harmony export */   wrapMapToPropsConstant: () => (/* binding */ wrapMapToPropsConstant),
/* harmony export */   wrapMapToPropsFunc: () => (/* binding */ wrapMapToPropsFunc)
/* harmony export */ });
/* harmony import */ var _utils_verifyPlainObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(185);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') (0,_utils_verifyPlainObject__WEBPACK_IMPORTED_MODULE_0__["default"])(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 185 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ verifyPlainObject)
/* harmony export */ });
/* harmony import */ var _isPlainObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
/* harmony import */ var _warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);


function verifyPlainObject(value, displayName, methodName) {
  if (!(0,_isPlainObject__WEBPACK_IMPORTED_MODULE_0__["default"])(value)) {
    (0,_warning__WEBPACK_IMPORTED_MODULE_1__["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 186 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isPlainObject)
/* harmony export */ });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 187 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ warning)
/* harmony export */ });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 188 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   whenMapStateToPropsIsFunction: () => (/* binding */ whenMapStateToPropsIsFunction),
/* harmony export */   whenMapStateToPropsIsMissing: () => (/* binding */ whenMapStateToPropsIsMissing)
/* harmony export */ });
/* harmony import */ var _wrapMapToProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(184);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? (0,_wrapMapToProps__WEBPACK_IMPORTED_MODULE_0__.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? (0,_wrapMapToProps__WEBPACK_IMPORTED_MODULE_0__.wrapMapToPropsConstant)(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 189 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   defaultMergeProps: () => (/* binding */ defaultMergeProps),
/* harmony export */   whenMergePropsIsFunction: () => (/* binding */ whenMergePropsIsFunction),
/* harmony export */   whenMergePropsIsOmitted: () => (/* binding */ whenMergePropsIsOmitted),
/* harmony export */   wrapMergePropsFunc: () => (/* binding */ wrapMergePropsFunc)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(171);
/* harmony import */ var _utils_verifyPlainObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(185);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') (0,_utils_verifyPlainObject__WEBPACK_IMPORTED_MODULE_1__["default"])(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 190 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ finalPropsSelectorFactory),
/* harmony export */   impureFinalPropsSelectorFactory: () => (/* binding */ impureFinalPropsSelectorFactory),
/* harmony export */   pureFinalPropsSelectorFactory: () => (/* binding */ pureFinalPropsSelectorFactory)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(172);
/* harmony import */ var _verifySubselectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(191);

var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref2, _excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    (0,_verifySubselectors__WEBPACK_IMPORTED_MODULE_1__["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 191 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ verifySubselectors)
/* harmony export */ });
/* harmony import */ var _utils_warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(187);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      (0,_utils_warning__WEBPACK_IMPORTED_MODULE_0__["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 192 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createDispatchHook: () => (/* binding */ createDispatchHook),
/* harmony export */   useDispatch: () => (/* binding */ useDispatch)
/* harmony export */ });
/* harmony import */ var _components_Context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(166);
/* harmony import */ var _useStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = _components_Context__WEBPACK_IMPORTED_MODULE_0__.ReactReduxContext;
  }

  var useStore = context === _components_Context__WEBPACK_IMPORTED_MODULE_0__.ReactReduxContext ? _useStore__WEBPACK_IMPORTED_MODULE_1__.useStore : (0,_useStore__WEBPACK_IMPORTED_MODULE_1__.createStoreHook)(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

/***/ }),
/* 193 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createStoreHook: () => (/* binding */ createStoreHook),
/* harmony export */   useStore: () => (/* binding */ useStore)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);
/* harmony import */ var _useReduxContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(194);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = _components_Context__WEBPACK_IMPORTED_MODULE_1__.ReactReduxContext;
  }

  var useReduxContext = context === _components_Context__WEBPACK_IMPORTED_MODULE_1__.ReactReduxContext ? _useReduxContext__WEBPACK_IMPORTED_MODULE_2__.useReduxContext : function () {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/***/ }),
/* 194 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useReduxContext: () => (/* binding */ useReduxContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_Context__WEBPACK_IMPORTED_MODULE_1__.ReactReduxContext);

  if (process.env.NODE_ENV !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 195 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createSelectorHook: () => (/* binding */ createSelectorHook),
/* harmony export */   useSelector: () => (/* binding */ useSelector)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _useReduxContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(194);
/* harmony import */ var _utils_Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(167);
/* harmony import */ var _utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);
/* harmony import */ var _components_Context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(166);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return (0,_utils_Subscription__WEBPACK_IMPORTED_MODULE_2__.createSubscription)(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var latestSelector = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var latestStoreState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var latestSelectedState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  (0,_utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__.useIsomorphicLayoutEffect)(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  (0,_utils_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_3__.useIsomorphicLayoutEffect)(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = _components_Context__WEBPACK_IMPORTED_MODULE_4__.ReactReduxContext;
  }

  var useReduxContext = context === _components_Context__WEBPACK_IMPORTED_MODULE_4__.ReactReduxContext ? _useReduxContext__WEBPACK_IMPORTED_MODULE_1__.useReduxContext : function () {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

/***/ }),
/* 196 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   unstable_batchedUpdates: () => (/* reexport safe */ react_dom__WEBPACK_IMPORTED_MODULE_0__.unstable_batchedUpdates)
/* harmony export */ });
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable import/no-unresolved */


/***/ }),
/* 197 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSearchResultsChanged = exports.onSearchCriteriaChanged = void 0;
const tslib_1 = __webpack_require__(1);
const ActionTypes = tslib_1.__importStar(__webpack_require__(198));
function onSearchCriteriaChanged(criteria) {
    return {
        type: ActionTypes.UPDATE_CRITERIA,
        criteria,
    };
}
exports.onSearchCriteriaChanged = onSearchCriteriaChanged;
function onSearchResultsChanged(searchResults) {
    return {
        type: ActionTypes.UPDATE_SEARCH_RESULTS,
        searchResults,
    };
}
exports.onSearchResultsChanged = onSearchResultsChanged;


/***/ }),
/* 198 */
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UPDATE_SEARCH_RESULTS = exports.UPDATE_CRITERIA = void 0;
exports.UPDATE_CRITERIA = 'UPDATE_CRITERIA';
exports.UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';


/***/ }),
/* 199 */
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjAvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvVFIvMjAwMS9SRUMtU1ZHLTIwMDEwOTA0L0RURC9zdmcxMC5kdGQiIFsNCgk8IUVOVElUWSBuc19leHRlbmQgImh0dHA6Ly9ucy5hZG9iZS5jb20vRXh0ZW5zaWJpbGl0eS8xLjAvIj4NCgk8IUVOVElUWSBuc19haSAiaHR0cDovL25zLmFkb2JlLmNvbS9BZG9iZUlsbHVzdHJhdG9yLzEwLjAvIj4NCgk8IUVOVElUWSBuc19ncmFwaHMgImh0dHA6Ly9ucy5hZG9iZS5jb20vR3JhcGhzLzEuMC8iPg0KCTwhRU5USVRZIG5zX3ZhcnMgImh0dHA6Ly9ucy5hZG9iZS5jb20vVmFyaWFibGVzLzEuMC8iPg0KCTwhRU5USVRZIG5zX2ltcmVwICJodHRwOi8vbnMuYWRvYmUuY29tL0ltYWdlUmVwbGFjZW1lbnQvMS4wLyI+DQoJPCFFTlRJVFkgbnNfc2Z3ICJodHRwOi8vbnMuYWRvYmUuY29tL1NhdmVGb3JXZWIvMS4wLyI+DQoJPCFFTlRJVFkgbnNfY3VzdG9tICJodHRwOi8vbnMuYWRvYmUuY29tL0dlbmVyaWNDdXN0b21OYW1lc3BhY2UvMS4wLyI+DQoJPCFFTlRJVFkgbnNfYWRvYmVfeHBhdGggImh0dHA6Ly9ucy5hZG9iZS5jb20vWFBhdGgvMS4wLyI+DQpdPg0KPHN2ZyB2ZXJzaW9uPSIxLjAiDQoJIGlkPSJMaXZlbGxvXzEiIHhtbG5zOng9IiZuc19leHRlbmQ7IiB4bWxuczppPSImbnNfYWk7IiB4bWxuczpncmFwaD0iJm5zX2dyYXBoczsiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQoJIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjYyIDEzOSINCgkgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjYyIDEzOSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8bWV0YWRhdGE+DQoJPHNmdyAgeG1sbnM9IiZuc19zZnc7Ij4NCgkJPHNsaWNlcz48L3NsaWNlcz4NCgkJPHNsaWNlU291cmNlQm91bmRzICBib3R0b21MZWZ0T3JpZ2luPSJ0cnVlIiBoZWlnaHQ9IjEzNS43OSIgd2lkdGg9IjI1OS45OTkiIHg9IjEiIHk9IjAuNzEiPjwvc2xpY2VTb3VyY2VCb3VuZHM+DQoJCTxvcHRpbWl6YXRpb25TZXR0aW5ncz48L29wdGltaXphdGlvblNldHRpbmdzPg0KCTwvc2Z3Pg0KPC9tZXRhZGF0YT4NCjxzd2l0Y2g+DQoJPGZvcmVpZ25PYmplY3QgcmVxdWlyZWRFeHRlbnNpb25zPSImbnNfYWk7IiB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIj4NCgkJPGk6cGdmUmVmICB4bGluazpocmVmPSIjYWRvYmVfaWxsdXN0cmF0b3JfcGdmIj4NCgkJPC9pOnBnZlJlZj4NCgk8L2ZvcmVpZ25PYmplY3Q+DQoJPGcgaTpleHRyYW5lb3VzPSJzZWxmIj4NCgkJPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCwyNy43NSkiPg0KCQkJPGcgaWQ9Imc4NjciPg0KCQkJCTxnIHRyYW5zZm9ybT0ibWF0cml4KDEuMDU4MzMsMCwwLDEuMDU4MzMsMTIwLjc0OTcyLC01LjczNzI2NjEpIj4NCgkJCQkJPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM1NEI5NDgiIGQ9Ik0xMzIuNTIsNjIuMzVjMCwyNi4wOTItMjEuMTUyLDQ3LjI0NC00Ny4yNDQsNDcuMjQ0bDAsMA0KCQkJCQkJYy0yNi4wOTIsMC00Ny4yNDQtMjEuMTUyLTQ3LjI0NC00Ny4yNDRoMGMwLTI2LjA5MiwyMS4xNTItNDcuMjQ0LDQ3LjI0NC00Ny4yNDR2MEMxMTEuMzY4LDE1LjEwNiwxMzIuNTIsMzYuMjU4LDEzMi41Miw2Mi4zNQ0KCQkJCQkJTDEzMi41Miw2Mi4zNXoiLz4NCgkJCQk8L2c+DQoJCQkJPGcgdHJhbnNmb3JtPSJtYXRyaXgoMC45MjAxNTkzOSwwLDAsMS4wODA1MDg5LDM4LjM2NjgyMywtNy41Nzc4MjY4KSI+DQoJCQkJCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNTRCOTQ4IiBkPSJNMTMuODk5LDE2LjY2NGgxNzMuNTQ0djkyLjIyMUgxMy44OTlWMTYuNjY0eiIvPg0KCQkJCTwvZz4NCgkJCQk8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLjA1ODMzLDAsMCwxLjA1ODMzLDAuNzQ5OTk4NzksLTUuNzM3MjY2MSkiPg0KCQkJCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzU0Qjk0OCIgZD0iTTk0LjcyNSw2Mi4zNWMwLDI2LjA5Mi0yMS4xNTIsNDcuMjQ0LTQ3LjI0NCw0Ny4yNDRsMCwwDQoJCQkJCQljLTI2LjA5MiwwLTQ3LjI0NC0yMS4xNTItNDcuMjQ0LTQ3LjI0NGgwYzAtMjYuMDkyLDIxLjE1Mi00Ny4yNDQsNDcuMjQ0LTQ3LjI0NHYwQzczLjU3MywxNS4xMDYsOTQuNzI1LDM2LjI1OCw5NC43MjUsNjIuMzUNCgkJCQkJCUw5NC43MjUsNjIuMzV6Ii8+DQoJCQkJPC9nPg0KCQkJCTxjaXJjbGUgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM1NEI5NDgiIGN4PSI1MSIgY3k9IjYwLjI1IiByPSI0NSIvPg0KCQkJPC9nPg0KCQk8L2c+DQoJCTxnPg0KCQkJPGc+DQoJCQkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgc3Ryb2tlPSIjNzFCRjRBIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0zNy44OTYsOTkuMDMyTDM0LjE5MiwxMTQuM0gyMC44MTENCgkJCQkJYzAsMCwxNy4yNzctNjAuNjY0LDE3LjI3OC02MC42NjRoMTcuMzM5TDcyLjg5NSwxMTQuM0g1OC44NzhMNTUuMTYsOTkuMDMySDM3Ljg5NnogTTUyLjc4Miw4OS42MDUNCgkJCQkJQzUwLDc3Ljk5NCw0Ny43NzIsNjkuNTA5LDQ2LjU5OSw2My43MTZoLTAuMzE3Yy0wLjkwOSw1LjU4NC0zLjI3MywxNC43LTYuMDIxLDI1Ljg4OUg1Mi43ODJ6Ii8+DQoJCQkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgc3Ryb2tlPSIjNzFCRjRBIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik05My4xODcsODguNDMzVjExNC4zSDc5LjkwMlY1My42MzZoMjIuODQ3DQoJCQkJCWMxMy41NiwwLDIxLjI0OSw1Ljc0OSwyMS4yNDksMTYuNTczYzAsOC43NzItNS43NzgsMTIuNTYtOS42NzMsMTMuODE0YzUuNzc4LDIuMTk5LDguNTEzLDYuMTg5LDguNTEzLDE1LjE0OXYyLjQyDQoJCQkJCWMwLDYuODk1LDAuNDAyLDkuNDY5LDEuMDA2LDEyLjcwN2gtMTIuOTIzYy0xLjA5LTIuNzc5LTEuMjg0LTcuNTgxLTEuMjg0LTEyLjgwN3YtMi4yMWMwLTguMTA4LTIuMjktMTAuODUxLTEwLjcyMy0xMC44NTENCgkJCQkJSDkzLjE4N3ogTTkzLjE4Nyw3OS42MzdoNi4yNjdjOC4wNjcsMCwxMS4yMjEtMi44MjIsMTEuMjIxLTguOTU0YzAtNS4yMjUtMy4wNy04LjI1MS05LjkwNi04LjI1MWgtNy41ODFWNzkuNjM3eiIvPg0KCQkJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIHN0cm9rZT0iIzcxQkY0QSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTc3Ljc2Niw5Ni42NGMtMC4zMzEsMy4wNjYtMS43NiwxOC43MDQtMjIuNDYzLDE4LjcwNA0KCQkJCQljLTIxLjIxMywwLTIzLjY0OS0xNS4xNTUtMjMuNjQ5LTMxLjQ1N2MwLTE5LjY0NCw3LjA4NS0zMS4yMTYsMjQuNDQ4LTMxLjIxNmMxOS43ODQsMCwyMS4zMiwxMy43OTcsMjEuNjI1LDE4LjY1aC0xMy4yMTUNCgkJCQkJYy0wLjIwNy0yLjA2My0wLjM4NC05LjQzOC04LjYxNy05LjQzOGMtOC4zODksMC0xMC40MzEsOC4zNDYtMTAuNDMxLDIyLjIzYzAsMTEuNDM5LDEuNDAyLDIyLjE3NiwxMC4wNiwyMi4xNzYNCgkJCQkJYzcuOTYxLDAsOC42MDEtNy4zMjYsOC45MzEtOS42NDlIMTc3Ljc2NnoiLz4NCgkJCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiM3MUJGNEEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE5OC4wMjIsOTkuMDMybC0zLjcwNSwxNS4yNjloLTEzLjM4MmwxNy4yNzgtNjAuNjY0aDE3LjM0DQoJCQkJCWwxNy40NjcsNjAuNjY0aC0xNC4wMThsLTMuNzE3LTE1LjI2OUgxOTguMDIyeiBNMjEyLjkwOCw4OS42MDVjLTIuNzgzLTExLjYxMS01LjAxLTIwLjA5Ni02LjE4NC0yNS44ODloLTAuMzE3DQoJCQkJCWMtMC45MDksNS41ODQtMy4yNzIsMTQuNy02LjAyMSwyNS44ODlIMjEyLjkwOHoiLz4NCgkJCTwvZz4NCgkJPC9nPg0KCQk8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLjY5Nzc0OTUsMCwwLDEuNTUyMjI4LC01OS4xNTE5MTksMC4xNDk5OTk3NykiPg0KCQkJPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiMyMzFGMjAiIHN0cm9rZT0iIzIzMUYyMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNNzYuMjI1LDguMzc0DQoJCQkJYzAuMzIyLTAuNDU5LDAuNjMyLTAuNzk0LDAuOTMtMS4wMDNjMC4zMDYtMC4yMDksMC42NjUtMC4zMTQsMS4wNzUtMC4zMTRjMC45NDMsMCwxLjYxMSwwLjQxOSwyLjAwNiwxLjI1Nw0KCQkJCXMwLjU5MiwyLjIwMywwLjU5Miw0LjA5N2MwLDIuMTM1LTAuMjA5LDMuNTkzLTAuNjI4LDQuMzc0Yy0wLjQxMSwwLjc3My0xLjA1OSwxLjE2LTEuOTQ2LDEuMTZjLTAuMzg3LDAtMC43MTMtMC4wODUtMC45NzktMC4yNTQNCgkJCQljLTAuMjY2LTAuMTc3LTAuNi0wLjUzNi0xLjAwMy0xLjA3NWgtMC4wNDh2NS44MzdoLTEuOTgyVjcuMjEzaDEuOTMzdjEuMTZINzYuMjI1eiBNNzcuNDEsMTYuMjQNCgkJCQljMC40NzUsMCwwLjgxNC0wLjI3NCwxLjAxNS0wLjgyMmMwLjIwMS0wLjU1NiwwLjMwMi0xLjQ1NCwwLjMwMi0yLjY5NWMwLTEuNDQyLTAuMDkzLTIuNDY1LTAuMjc4LTMuMDY5DQoJCQkJYy0wLjE4NS0wLjYxMi0wLjUzMi0wLjkxOC0xLjAzOS0wLjkxOGMtMC40NjcsMC0wLjc4NSwwLjI1NC0wLjk1NSwwLjc2MWMtMC4xNjksMC40OTktMC4yNTQsMS4zNTMtMC4yNTQsMi41NjINCgkJCQljMCwxLjQ5OCwwLjA2NCwyLjU3LDAuMTkzLDMuMjE0Qzc2LjUzMSwxNS45MTgsNzYuODcsMTYuMjQsNzcuNDEsMTYuMjR6Ii8+DQoJCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzIzMUYyMCIgc3Ryb2tlPSIjMjMxRjIwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik04Ni4zNzYsNy4wMzINCgkJCQljMS4wMDcsMCwxLjgxNywwLjM4MywyLjQyOSwxLjE0OHMwLjkxOCwyLjI0OCwwLjkxOCw0LjQ0N2MwLDIuMDYyLTAuMzIyLDMuNDYtMC45NjcsNC4xOTNjLTAuNjM2LDAuNzMzLTEuNDIyLDEuMS0yLjM1NiwxLjENCgkJCQljLTEuMTY4LDAtMi4wMzQtMC40MzktMi41OTgtMS4zMTdjLTAuNTY0LTAuODc4LTAuODQ2LTIuMjI4LTAuODQ2LTQuMDQ4YzAtMi4yMzIsMC4zMjItMy43MSwwLjk2Ny00LjQzNQ0KCQkJCXMxLjQ0Ni0xLjA4OCwyLjQwNS0xLjA4OEw4Ni4zNzYsNy4wMzJ6IE04Ny42MjEsMTMuMTIzYzAtMS43OTctMC4wODUtMi45ODktMC4yNTQtMy41NzdjLTAuMTY5LTAuNTg4LTAuNTA4LTAuODgyLTEuMDE1LTAuODgyDQoJCQkJYy0wLjQ4MywwLTAuODE0LDAuMjMtMC45OTEsMC42ODljLTAuMTc3LDAuNDU5LTAuMjY2LDEuMjM3LTAuMjY2LDIuMzMyYzAsMi4xMzUsMC4wOTcsMy40NCwwLjI5LDMuOTE1DQoJCQkJYzAuMjAxLDAuNDc1LDAuNTMyLDAuNzEzLDAuOTkxLDAuNzEzYzAuNDkxLDAsMC44MjItMC4yMzgsMC45OTEtMC43MTNDODcuNTM2LDE1LjExNyw4Ny42MjEsMTQuMjkxLDg3LjYyMSwxMy4xMjN6Ii8+DQoJCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzIzMUYyMCIgc3Ryb2tlPSIjMjMxRjIwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xMDEuODIsNy4yMTMNCgkJCQlsLTIuNTk4LDEwLjU2MmgtMS4zOWwtMS4zMDUtNi40NjVoLTAuMDQ4bC0xLjMxNyw2LjQ2NWgtMS4zMDVMOTEuMjM0LDcuMjEzaDEuODI1bDEuNDg2LDcuMDQ1aDAuMDQ4bDEuNDE0LTcuMDQ1aDEuMDE1DQoJCQkJbDEuNDg2LDcuMDY5aDAuMDQ4bDEuNDAyLTcuMDY5SDEwMS44MnoiLz4NCgkJCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMjMxRjIwIiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEwOS42NzQsMTIuODQ1DQoJCQkJaC00LjQ0N2MwLDEuMTQ0LDAuMDc3LDIuMDEsMC4yMywyLjU5OGMwLjE2MSwwLjU4LDAuNTM2LDAuODcsMS4xMjQsMC44N2MwLjQ1MSwwLDAuNzU3LTAuMTY5LDAuOTE4LTAuNTA4DQoJCQkJYzAuMTYxLTAuMzM4LDAuMjQ2LTAuODcsMC4yNTQtMS41OTVoMS44MDFjLTAuMDU2LDIuNDczLTEuMTA0LDMuNzEtMy4xNDIsMy43MWMtMi4xOTEsMC0zLjI4Ny0xLjczMi0zLjI4Ny01LjE5Ng0KCQkJCWMwLTMuNzc4LDEuMTM2LTUuNjY3LDMuNDA4LTUuNjY3YzAuODYyLDAsMS41OTksMC4zMjYsMi4yMTEsMC45NzljMC42MiwwLjY1MywwLjkzLDIuMDAyLDAuOTMsNC4wNDhWMTIuODQ1eiBNMTA3LjY4LDExLjMxDQoJCQkJYzAtMS4wNDctMC4wODUtMS43OTctMC4yNTQtMi4yNDhjLTAuMTY5LTAuNDU5LTAuNDc1LTAuNjg5LTAuOTE4LTAuNjg5Yy0wLjUyNCwwLTAuODcsMC4yNDItMS4wMzksMC43MjUNCgkJCQljLTAuMTYxLDAuNDc1LTAuMjQyLDEuMjEyLTAuMjQyLDIuMjExSDEwNy42OHoiLz4NCgkJCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMjMxRjIwIiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTExNi43NjgsOC43NzINCgkJCQljLTAuOTEsMC4wMjQtMS41NTksMC4xOTctMS45NDYsMC41MmMtMC4zODcsMC4zMjItMC41OCwxLjAzOS0wLjU4LDIuMTUxdjYuMzMyaC0yLjAwNlY3LjIxNGgyLjAwNnYxLjU1OWgwLjA0OA0KCQkJCWMwLjU4LTEuMTQ0LDEuMzYxLTEuNzE2LDIuMzQ0LTEuNzE2bDAuMTMzLDAuMDI0TDExNi43NjgsOC43NzJ6Ii8+DQoJCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzIzMUYyMCIgc3Ryb2tlPSIjMjMxRjIwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xMjQuODUyLDEyLjg0NQ0KCQkJCWgtNC40NDdjMCwxLjE0NCwwLjA3NywyLjAxLDAuMjMsMi41OThjMC4xNjEsMC41OCwwLjUzNiwwLjg3LDEuMTI0LDAuODdjMC40NTEsMCwwLjc1Ny0wLjE2OSwwLjkxOC0wLjUwOA0KCQkJCWMwLjE2MS0wLjMzOCwwLjI0Ni0wLjg3LDAuMjU0LTEuNTk1aDEuODAxYy0wLjA1NiwyLjQ3My0xLjEwNCwzLjcxLTMuMTQyLDMuNzFjLTIuMTkxLDAtMy4yODctMS43MzItMy4yODctNS4xOTYNCgkJCQljMC0zLjc3OCwxLjEzNi01LjY2NywzLjQwOC01LjY2N2MwLjg2MiwwLDEuNTk5LDAuMzI2LDIuMjExLDAuOTc5YzAuNjIsMC42NTMsMC45MywyLjAwMiwwLjkzLDQuMDQ4VjEyLjg0NXogTTEyMi44NTgsMTEuMzENCgkJCQljMC0xLjA0Ny0wLjA4NS0xLjc5Ny0wLjI1NC0yLjI0OGMtMC4xNjktMC40NTktMC40NzUtMC42ODktMC45MTgtMC42ODljLTAuNTI0LDAtMC44NywwLjI0Mi0xLjAzOSwwLjcyNQ0KCQkJCWMtMC4xNjEsMC40NzUtMC4yNDIsMS4yMTItMC4yNDIsMi4yMTFIMTIyLjg1OHoiLz4NCgkJCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMjMxRjIwIiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEzMS45NDUsMS44MzZoMS45Nw0KCQkJCXYxNS45MzloLTEuOTQ2di0xLjQxNGgtMC4wNDhjLTAuNDc1LDEuMDM5LTEuMTUyLDEuNTU5LTIuMDMsMS41NTljLTAuNTE2LDAtMC45OTEtMC4xNzMtMS40MjYtMC41Mg0KCQkJCWMtMC40MjctMC4zNDYtMC43MjUtMC44My0wLjg5NC0xLjQ1Yy0wLjE2OS0wLjYyLTAuMjU0LTEuNjU2LTAuMjU0LTMuMTA2YzAtMS42NTEsMC4wNzItMi44MzIsMC4yMTgtMy41NDENCgkJCQljMC4xNDUtMC43MTcsMC40MjMtMS4yNzMsMC44MzQtMS42NjhjMC40MTEtMC40MDMsMC45MzUtMC42MDQsMS41NzEtMC42MDRjMC44MywwLDEuNDgyLDAuNDcxLDEuOTU4LDEuNDE0aDAuMDQ4TDEzMS45NDUsMS44MzZ6DQoJCQkJIE0xMzEuOTY5LDEyLjMyNWMwLTEuMzA1LTAuMDg1LTIuMjI4LTAuMjU0LTIuNzY3Yy0wLjE2MS0wLjU0OC0wLjQ5MS0wLjgyMi0wLjk5MS0wLjgyMmMtMC40OTksMC0wLjg0MiwwLjI4Ni0xLjAyNywwLjg1OA0KCQkJCWMtMC4xODUsMC41NzItMC4yNzgsMS41MTktMC4yNzgsMi44NGMwLDEuMzcsMC4wODUsMi4zNDgsMC4yNTQsMi45MzZjMC4xNzcsMC41OCwwLjUxMiwwLjg3LDEuMDAzLDAuODcNCgkJCQljMC40ODMsMCwwLjgxOC0wLjMwMiwxLjAwMy0wLjkwNkMxMzEuODczLDE0LjcyMiwxMzEuOTY5LDEzLjcxOSwxMzEuOTY5LDEyLjMyNXoiLz4NCgkJCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjMjMxRjIwIiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE0MS4wMiwxLjgzNmgxLjk4Mg0KCQkJCXY2Ljc3OWgwLjA0OGMwLjM3MS0xLjA1NSwxLjA1NS0xLjU4MywyLjA1NC0xLjU4M2MwLjc0MSwwLDEuMzQ5LDAuMzQ2LDEuODI1LDEuMDM5YzAuNDgzLDAuNjkzLDAuNzI1LDIuMDMsMC43MjUsNC4wMTINCgkJCQljMCwyLjQxNy0wLjIxMywzLjk5Mi0wLjY0LDQuNzI1Yy0wLjQyNywwLjcyNS0xLjA4OCwxLjA4OC0xLjk4MiwxLjA4OGMtMC44NTQsMC0xLjUyMy0wLjUyOC0yLjAwNi0xLjU4M2gtMC4wNDh2MS40NjJoLTEuOTU4DQoJCQkJTDE0MS4wMiwxLjgzNnogTTE0NS41NTIsMTIuODY5YzAtMS40OTgtMC4wODktMi41NjYtMC4yNjYtMy4yMDJjLTAuMTY5LTAuNjM2LTAuNTItMC45NTUtMS4wNTEtMC45NTUNCgkJCQljLTAuNDUxLDAtMC43NzMsMC4yNTgtMC45NjcsMC43NzNjLTAuMTkzLDAuNTE2LTAuMjksMS4zNDEtMC4yOSwyLjQ3N2MwLDEuNTM5LDAuMDg5LDIuNjM0LDAuMjY2LDMuMjg3DQoJCQkJYzAuMTg1LDAuNjQ0LDAuNTMyLDAuOTY3LDEuMDM5LDAuOTY3YzAuNDU5LDAsMC43ODUtMC4yNjIsMC45NzktMC43ODVDMTQ1LjQ1NSwxNC44OTksMTQ1LjU1MiwxNC4wNDUsMTQ1LjU1MiwxMi44Njl6Ii8+DQoJCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzIzMUYyMCIgc3Ryb2tlPSIjMjMxRjIwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xNTYuNzA2LDcuMjEzDQoJCQkJbC00LjkzLDE1LjIzOGgtMS43MjhsMS43MjgtNS42MTlsLTIuODY0LTkuNjE5aDEuOTdsMS43NCw3LjI3NWgwLjA0OGwyLjE1MS03LjI3NUwxNTYuNzA2LDcuMjEzeiIvPg0KCQk8L2c+DQoJPC9nPg0KPC9zd2l0Y2g+DQo8aTpwZ2YgIGlkPSJhZG9iZV9pbGx1c3RyYXRvcl9wZ2YiPg0KCTwhW0NEQVRBWw0KCWVKemN2V2RiSzBrT0tQeCtudWZoUDloRUd4dTdjeUE3a25PR0E4YWhBWU1URG1mbTdJZjcyMStwT3VkMllIYnZuZGxsb0x0YVZWS3ANCmxFcXFXb3FmWDYzbEd0MmFzc1ptcU5qY1gwdExoYjVTSFhiNzZ6SHlPSGJRYW8wR3d6NCtTbHdtWTdTWW9iQlY3a0NxYUMxdmxmNmcNCjJlMnN4eGdBb2I0dDQvZUpVa3VKWlpLeFJCSWZYVGVITFFVZWRqdkRicU5aWFd0MTM3dVp3ZS8zcE5FbndDaFdoOUNHcHJJc25XVW8NCldvN1I5RHJQeEhJbnBGRzE4N3M2R0RUL2cwMEVWbUx4WWI0NzZqU2FuZmQ4OTUvMUdBWC9NZ0lkbzFrUjMrMDNMNVdCdlVGR3huOUUNClZtQW9pcWVoS1pVUktWbWdaRmJrS1hna01RQ0F0T0lvU2FZNGltRUJtcERCbHpSSENSSXYwUWk2MksyUDJrcG5lTjd2MXBYQm9OQnQNCmRmdUQ5VmpoVDdVVE82bSt3NXRxN0VGcHRicC94L0t0YXYzTCtrMFpTQUJ0Yy9CWHMxUG9kdXBLYjdnRy8yMG9uWUhTeUhkYkRXdnINClUwVnBLSTFJMytRTytFcTUyVktBK3UzcUVNWk5KaU4zUURPVi9LalphcHlPMmpVRkpvWm4xZWRzaFl6N1pnQURockhqNytTNVdEbG8NCnc2TXJaVGdFd2tHM1pFNHY5L0pXYkZWcVU3SEUwNlh5M2dRTzZUNG5kYWo5YnE5ZDdYOE45QmxoWUN4eWhqTC9vYldXMTBxNzE0STUNCko1TkRzM1NHandsU1JxRE5sb0xQWXgwQW9FcytYbU1rT1NOem5DVHhETS9LOE4wYXcwZ1o0QVJSRWlTQloxZ3V4dk4wUm9aNWxrV0INCkZ4Zyt4Z3BpaHBZWWhxRTRYcElsWG9OcHpxM3l1Nm44dlI0NzdYWVVqYnk1L3ZCS1pVQ09veWoxcC9icWN0UlMramVkSnM2VGlwK3MNCjB2ZWsyMUJhK2pNQ290eXF2ZzkwQXRMbVQ2M0ZkYlgvcmd5QmQ3dXQwWkNzTE1ub0JlYnd1UHBINlZzNk9lc3BuZXZ1TFJucUdzOW0NCkJBdWhPVmdwVW9ZeEtVZkhwSXhrL1VlT3NTd0RWSllGQVdhS2pFV1FZalFqRzhPampaLzZJTEJIN0U4ZkNWbHQ1OEF5Wi8zbWU3T3oNCnZrWURzRFVXeUEzd2pYODAzdHJyTnhzbWE0bE1URkova0E0eWtqWk1XbVlvR1FjUjdZbmFneWpRc0Q0NUpzb1RqWGd3RmNPaDB0R3ANCkNVdWxjR0poZkNwemNvYklsVHFOUXJlTlhERWdVZ2RZdmdPckFZU1k5dGI4Zzd3REVLUGUzRjlQYzMreGN2WjcxQjBxQTRBSThsQVcNCnN1Lzk2bThGS0N4bFM2TitGL2lic3JTb1ZRZEs5ZzI0cHRsUm56WnE2ak1RSnMzZW9BbmRaeHZWOTNlbHIvMEgzbWZyelQ2dzdGdEwNCitTZmJVL3JEais1b1VPMDBzbGYxYXIvYnliN0QyaWV3VzhyYk1IdFdBcTdsVmRqNEFPQ1IzMkhtUG9aR2w2U3Avb2Y2cWphQ3A4T3MNCjBtbFVCeDlacFUzK013U3hvbVJCUFRRVVhQRUFiT0RvVlAyNHEyUWJYVkFBSUw1ak5DOW5IeHBOcFE4WUQyTFpRYTlhQjNJSVhMWSsNCjZ2ZVZUdjBQL0NGa2EvM3VsOUtwVlVFa0FRdG45ZmJaZXJmM1I0UFpiN3dwSUE2YkhmaGNaTEpBLzJhOTJ1cDBoOW1QUDcwUHBaUHQNCkU4a0VIemF5N1dvZGh3VmtoVW5LOWtDbndaZWpRWGI0ZDNjd0FxSTF1LzNzOEtPdktNWmYxZnBvcUdUYm94Z3RzVm55ckZHSCtTZlENCjZrcWoyV3BWQVJLSUJ1TUxHRkM3T3FpUFdtUkVrb1F2djBmVlBueUR2MzVVVzI5cUg5ckRBYXc2SnBzai9BQ2djbXFQT2N0czVsVDYNCjVnenNjNGhBTmxmS0ZyUWhaRXZrODJ5SmZBeFFTcGJQUzhaM0IycXJBN1dMQTB1YkE2Tk5hZmlSUFNVZEFwZ3o5WU16OVlNenl3ZG4NCjZwak9qTy9hbzlhdzJXdjl5WjROV3NnVE56cENOK3JITjVhUGI0eXZIdFNYMXgvZFBuQ0xBaHFyQTZ3MnlGYlZqcXM2UGxYTDExVzENCjY2b0JwRXJJVVZXeWRaMGNpdnE1b2tKWHpJOEJsR0o4MTFSYk5kVldUVXNYVGFPTkF1VG9xQjEyMWVaZGZVeGR5d2RkcllueFhhUDUNCnU0a1BWR0tNMUU5SGFrOGoyM2hHeGpkLzFOZERRb3cvK3VPNXY2NUxxc1RsRHl2WEExQktGbDNFVm9pZ0tYWHFYVFJ2MW1PVkFPTWcNCjJIQjR5Z1o5bXcyQ3EycUk2OGM1TWlLUWcvcDRWT3Z4K2s5UDE1eGt0QlVZL2puTTJaQXN3OU1lZVNkVnpsc2plTG5YNzQ1NkI1MjMNCjd0eGZDZFgyUE1hRnBMNk1rYmRnVE83MXEyK3d6TWs3K1BPZ29WUk5teWRUYmZhU0lVQ3Z2cFJoL2NNUHJQcDJJc0MzU2gyc1liQU8NCkdyR3oyaWY4QVZBdVVTTFZ1N0ZtR3l3cWRjUkdzeWd3aThvYjlLOE5GajdHWDlaZzJBZWQzMkFjZ0VpTE5ab3FxZUdsMmpnSzJQTlcNCnRWUHRHOGpyVUxXWHplRncxSzhDNUU2MURlTW5EYW9kWlhnZkJUUW8xTDVpRHBqOHFmODMwdEJBTHZhQVJNM2ZycWtQYldCNUZhbXINCjZ2QUR6SFBRYUFNWEVkNUc2Tk0wNGZreFFGTWJSWUZacUlLZWhqWGYrMmpXWS9uK2FQQVJ1KzUyV3hiNFlEdDEwRE9JMWJXbXdIZTINCmFiU0NJQkFRUUNUTy90T3VkVnZOUVJ1QVhEWEo3d2JRYzlBNHpYcEx1Zm9EQ2pFYWo2QmgxTytjZFZReWVhR2lOalFRNnFsZjRFejENCmgrcDNZNDMvMysvUitDcW90M085TnlUaEFLalkvYittUDdBQWtVRGV2Um45Tkpwdktyc3JWamJVdnYyZjdrL2ptQmdZT2lCVGZlUkYNCllKdXJ2NnNnNzQrYnRaRFZqYVIvYTRMcTY4ZXVSczBoRVdtb0dXTDFicnZYSFlDN2I2NDB2ZVdWQ1pKSDNXalZmbXRyRWZTaTZtYVENCnNhZ2F4VUJjSmZBSlNIRXduV0puZmVndEdmWXlGaWloc3ZCekJIclIvVHFiakdXMEFhR2pZeHZPRDZEbUowR2hnZDhJOFIxNHFBejUNCkg3cmxGQld6L0R2NzhjdnFPNHdHRFArQVZ3UEczRkduKzNlSC9CVmJSMXc2M1E2TVEyU1NzZXhwdGEzRTB0QUdoSElQUkxEZWlJcUINCmIwbGxCRmxpS0pHQy8vTXlMN0hncWdvaXh3bXNMSWtzVDNFQ2gwOVlTYUI0QnB4MG1oWWxBY05Xck15eGdzeHdIQy95UER5Z1daSGgNCk9aa0NUNTRTSmZ5SVptaGVrQVJHNUhoS2xzZ0RTd09XanQxWGNSQzBScWY3UC9qWElmejJDYy8raHRISFRtSlB6MVNzTVFjdkw5V20NCjkyQXZacytyUUkvWXh0eGZzU3pZSFBpTEgvcHlLUHFXTU1QUEQwaWtXZXVBY3NSVU1CcGxDN2lXUjUwRzJIMG94ZkM3d2dlQWpxbE4NCjFNZEpNcmFzMWdiQTBMSHNiWFBRckxWVW9CNUFyb2JWK3RlMFFNWWZTYjQ2YU5adHcwQ2ZlaHdRREhuVk91dHJueUxVWXJPT1FhbHENCi8wOXNIV2paSFY0cWRmQjh3ZW9sYzB3YWFpU05qVFdYbERxWFpBSmpNSlVKQzZ3a0F0K0lrYzdWZVVhRHhoTkxZcXVOUmFkZ2pBZzgNCkV5RXFJL05xSUVuaU9ZWmxwS2dJV2hBelFmcmpGWXdrZW1HZ2hxSWhHQXdLSjNpRzVFSndKclZVQVNmSk5JZ2JpWkk0a1JZa2xZZ3kNCngxQTB6MUV5SjhpQ0d2dGpHWmtEOFNad0lzVkxFc2JzUklmQW9qS014TEM4MFc1eWlXRk9oakhncElackhyUk5MSEV6VUVxL2xjNVoNCm96SHBIUDB3SXlMT3pNOHdIb2FSL2xIcUpQZ2NMbFVaVm1URHRSeFBzUklyOHJCb09KbWhTWFE1QXhxUDRrQ3pjVHdIS3BBRW56TWMNCnpMT3B5V2dTN2lXVHJ6MUV0ckN3QkR3VmZscHRBSUpjQkFSNUdVWXFnbnJHclNLQ0MyaGVXUUR0VERNd1VFbDl4cm13Z1E5WTJWVFYNCitFUmZBaXFyL3d2NDhSSHdvOEZHb1RsWWQ3UW95dm9xaHZVb01ad3NBMGFzT29FOGEvc0gwYkV2WXlRTUdpUUcxdXkvZ0tBUWppQW4NCnNwTEUwUUxQU0NKRm83MEVFMG5CcHpUTFNXQ0xvVWtGcGhwUHN6UWppelJOODZyWTR1M1RSV2JVeHNTSXNJT3JmeDVoTWNLTWdrMEoNCmExS1FZVG9aVWRabWxHVUJHMDRDWTVUVDVESm5FOElFUWQ0bXFoRkJ3ZnFQK0M4Z0tJVWp5QW9jR05LQUJrTlJvclltUllsbWNKWEMNCkRFcGtsbFY3MjhLUVpFUEpxbVZRTW1XNGZ3R2xjR3M1dzlFd0ZReHdFc3V6REVlclRNcUE3OERRSWs5elBCR1lyTXd5NEJpSW9paUkNCnNvcTI0RUxJTG5Yd085YmlMY0RMbjBkWW9pSWdETUlKMkpPUmdBdDVuQnJBQUQwZm1nZDJsSEhITWtQeHZNQnlyRXp4TUhxUlZSZWwNCmkwTkZtNE1rcTNTeUV1RG4wYVVqb011eklGcEVUa0tkUVZnUnpDVDRXeVllSVZHU0dYUVdjWmViWW1CK1JWN0YxMm81c2FoRUJKc3gNCmhhdFdzbXBOOEJsL0h1RUkzaThyQ0JLRGMwQ0JxcFJFbkdCS0FHNEc4U09Ednl2ejZ2QXlRZ1M5S2RzZDNwL0hMNHJkSThKNFdWbUcNCmtYT3lxSm85TkFmckVnd0Y4UGQ1VHVWWDF1NitFL1JzUWdqUjQyeHE4MS9BTDRMWnc5RVNyRVZaRmxDVDBJSW1ZMkV0eWd5SUpBNzUNCldaMC9CL041MlhXc2JKdmxmd0hCQ0hZUEdLdXl5SUdNa1lDenlJckU1QU9XNGtGL2dIQWl3UmdCYlNPWU94cE1JUjZ6RFR6bHErVEUNCmw2ZHRwc09QNHdzQ05BTERrblFvZ1FkNXcvQzZ0eVpRdEFnQ2xwTmtYcFJZSDBOZDVHeUdPY291MjRPZnQvTTRJWUpHd1Z3dVNoUVkNCldKWEFuYXFKSTFJWWJJUFpvTUNRMFNhUWQ3dWpMcnVPKzVmTkhyQmxvcWhNVUlkZzFZSHVsOVhjRjh3RVFxT0JBVnVXb2xDNkNPQjMNCmdld1JaWUVIYTBFelpHVm53TkROdzd4RFR2MGN3ay93dkRwcURaOG5DU0ZpVjhpUG9FaEExb0wyQkR5Sm9TZlRNbEFDVU9JNEVpTVYNCndOYVZjY3A1WUcyeXVnRTFqaGZCekFKVUJkckFMRGNXbnJRL25pUjhYT28wTE1IajhDajBlYldsRERIM0FIcy9yODBhTzJzU0g2SGsNCi9YOXdCcXlaZmVkMStIL2VIS3N4b3ZGQzVjY0EwRGE1Ym9Lb1RTYU16Tk9VK2xMZEMwVlEvNS8rSElBNW4vcjFvQTFhendRc1ZvZkENClZVdVZyUDRBZVEvL3RNUnJ5SVA3aytQVGJrUHhlYjBSUy96VGJuV2d3VnAxT093M2E2T2hNaUNCR0dpYzYvZXIveXFZR2ZWaWFWZi8NCmFMWWFmYVdqdFdKaTJRTWdsZkVhZnd6LzlCVHRkV0s1TTZnTTN2N2VnUFY5TmNSRUhudlQzOVhXeUdpTEx3WStEVHNnSExSMjJtQUcNCjlqLy9MWUw3azRJT0prVUVBZ3hhelRwMm1yM3BOT3Z3TXBRUTZmOExXSURoWlpKcVRkTThSb09sV1BaU3FiWUNxUEIzc3pIOGlNUUcNCldzc29WUGh4TkdtV3o0aVlUQTVLbWVYRHNmeFFNTDh4RXBwNjAvOEpQTjNaOVdHWS9oTnRTZi9QNE9lc0ZRakQ3MDhrL1A3OGorQm4NCjdIMzQ0bFByRG9mZDlySHlObFF6dlNPaDUvNW9MT0g4NDFMMXFqdnExeFZTSnpKckFmdS9nR08zTjJ5Mm0vOGg5VFY2WnZ1NGFQN28NCkhMejkvZitZV2lPV3plOXFmL0MvYjlyODEwa0ZYcTBTaFVxdGJ2MUxhVVFpazk3MGYwS21KbXBOVW41R1IwRVNlQVpXNkNuQkpnS2kNCjF1Yi9yOW03Z0Z1eldtc3BrVmJHLzZOQ1lmMTNkTEdBYmY4M0dCN3hySThHb1BML0I4VGZqN0xvK3FDSzBTaU1Ec0E2ak02cC84YTYNCmdRSDlyNDNuZjROQWJXVlliY0NNemM0RWtxY2UwMEpEaXl0RldnZVcxdXJubEZaYUc5Ti9zWUM1dXQycllLbG12dnZQL1lQdXgyZ0QNCnhqcmRYRitwcW1tUVhuckNLVDBrU3FCaUVzM1FHVnB6N3M2N3pjNlFvSmtnQmJBMkUxL3ZxTmdjOUZyVlB5ZlYvcGMrNXV2cTcyNEwNCmEwd0d5bnVuRzZQZDAySFJhNFlqZVo2N05FQTdTNG90NDdsVVd0ZmRTM1VvNnRqT3U0TW1Za0plMDdva0V6RFFIL2t6eHVrbUhReHkNCi9XR3RXKzAzcnBTV1VoOGFSb2RIQ3kzZWVlckZWM29iUW5udHJhaVJMbmNBbERiQ2pxU3NOSFpjN2J5UHF1OUs3THpid3lSMmxhSnENCjliMWw2cjl5QitWUnE2Vi9ySlhwdzF2dEM1WXl5R3JXeldCMWJxV2d0RnBZNXF5and3YzFMSURqTkRRbjNMdGh1ZFh0OXMvZTNnYUsNCjNwVDNiVXM4eFY2MTNoenF4QkI0bnRYbzRkWDQwaUE4bG5IVEFTM3o1cUtEeWFlNWdLWjdmY1ZZNGY1alZmR3lEWmJGWFhrZndLUzUNCk9kelFwcGJ4Y3J3aytvMlh0TFVOV05KRkFjWFF2Ty8wSVo2bGY0YW1LSW40M1NVR25Xd2ZVajRqdzNwNFkxRzRSWWF6K1ZXOTJ0SVINCmxtaVpqa2tjaDd1cjRSOE9xOFk2MVFrbStjNGFDa1JZSWlDV2h0Vk8zYVJ3RUozSzFicVN3eEx1ME5hRU9zN20vZz09DQoJXV0+DQoJPCFbQ0RBVEFbDQoJTEVTYXUvbWQ5NkVvYVc2eWtCL2hTVE1MK3dTeEdtbHJaUjh6RW12c2dJQWl5T1lHc0h3TEh5QjlsTk5SKzBqUmg4dXhuczFQbFgrRw0KSU5yd3hBS2pLZVBmRW9IYndESSt3NzIyQnBCOXlicVBOWmJkenI0MVFKb3dkWVpEUmFJcUJCVnBidzBpSXJEMW5TWEdUT2tpSDdlYQ0KWW0vcXFRSktQOVlkRFVrNStJRGtzZzhpdGg0Q1FUeWEwakZkOWNlYWd5NGVuQkdyWVVZdkRNeWp0V0FCWE8wTW03RnFxMWtkZUxCWQ0KN2tER1dqT2lnMkoxUExJQ2xtcmZGS29NeDBqK1RSbExVNS9CZm5YQUpRZmNZdTlxMVZXMEVieGJPTkpsaVJnOUFWSURROEpvendhOQ0KcmlFRnRCNEFxSzczUkoyeEdyMW14am53ZG5XZzJ5aXNvUE5XcjlyUU1VUjFmUkRMalliZDJHVVZ6eFl3MVdRb25Xcm1jclFRU283MQ0KcWoyWW9rR3pQV29SS1JhVlFCWjRqS1hkc0YvdERIcFY5U2lGZDFnTHNjRVlnN1JTbmZadDZLUTRtZS96dmpKUStyK1YyRFd3TDZtMw0KcTlhYUxWT3NrVU43REpDNkJGQ1A5YkdhR3hSbEdqL1cxZEVuQkYvN1RRcW9ZN1ZxeXlLOEUwOG5TcU5aamZWeFlZeitnOFdGejI2Yg0KMHN1YUtodnd5ZmlITWF2aGFjb1hwTUdKTXZnd3BwMU1WY3c4cGNXd3FteWZuSTJHUFdEOGtJK28yQnBQVWFGYURnelVLdjVCOVAxdA0KdGRNY2ZBQmFWcVVYcUE1SUZUZXBOeUN6Z2pyVHBteEZPWnF5TllGZGQzdlczc2RTMlNhVVBOa2dzQUVTUk5wbWlBRGs2RUE5S1NQSw0KdkxZL0pjdVN6TEF4aWFYNUtDQlIrWk5ob3JFYnllaXhPRUlIbllieXo1VlM3M1owQVlJcFJEcHFOR2JRUkIySFNhK0pCMUp1OWdkaA0KM3hEZUN1QVV2KzhNTXMyQXdReFkwL0NYQWNUTlhxSklHN3dnU2x4MDlrS1ludHhGK3lqMG5pNFN1NytWZmcrVFRGekt5dkZGdmRYcw0Ka2FMaWx2SlBEQSt3NlJwQkwzZE0wL2tnY1FuaXJ6K29ldm5UeE1BeTdUaVVjcWF0NVlKa0RFOTBqbGQyUHFDZEQxeU9NazA1bi9ETw0KQjRMekFlZDY0QUlyT1Ird3JvNWRvNmZkbzNYMVJMdEd4N2dnczY0QjA2N2hNRzVDdVBwaVhLVGhYRTlvVjErTXUzZlhDQmtYcHF5Yg0KWU83SmRJL1oxWVp6UTNaUmpOVXB2MkhqdlA1d1lETGRoc2s3R3c2UG9QUlByOXNmWXVDUWZHejV5QkhkQllpeG01dURZc3kzeFY0Zg0KendzaTZsNE4wc1N1aHQxZWpBakVtSFV3V1d1MW5XTkp1S3J4TEtpQ1I0QUdqM284ZzVNTzhCS054U055U29YTnFJSTNlS3FmeFp1aA0KTEIvZFYzVTdlYzN5UWZHNjZORldQMFhQWWZMQ0c1SlBaL1dYekZlbGRrMXBxR2FKOThDT3UzV3JOV3JGNlB6OVRiZDJ6Ry9BZXFvMw0KQjdZUGpMNjBRNEVjYjQ2aGR6MzJkZUJDek9YaWR3eVNXR1FuUTVuMjNIbnpINlVGbjcyUnMzZnNMVjNRUHJwLzd6Y2JIdmI0VmZXMw0KY3FJZWFhWG9vOU1sc0dnbjBkV29ObEIzMUQxbWhaeG1nRktXSEhEbUhya2M2M1JOdFJCcmRyU2pKSnBEeFVFbllyV1d6cTlpWjBGSw0KaEltQlkxSkE3VkhRdE1lbFRYdllYVU4wWXRBbnpLRlBhQ0xnWTBaYjdHZlNUYUROYlBNSmNOZ0JneEpOQjBlRnJISmtWajBrS1phMw0KMmZpMG82MkxIT0dqVndjVU5IektOZnd6elNtLzluYksxYUc0MjdqbVJtOXpaUXNGaElrWjNkN0ttdnRjMmQ1Nyt5dWpkRkE4T3VOQQ0KMW1iMWZpTXpCRXZNeXA3ZXNPcjliaThFMEtEZWE5WC9PR2JDM2FqZU1Tek1oTnNHY1hkTU5ncmZtaTBMK1ZYbnlRa2FWMHFyMnN0OA0KaE9FQ1JER29FbVVJbjkzYUVNK21EWU03TU1xbWZZalU2bWZBem9kaERqSCtNQWhvQ2wxbUNPTldCN1htc0YwTm8vMGJMS0NQYnY4Lw0KSWIyM3U0WTg0MzBnOWJRTmpWQnE5OThES1kzZEdiS3JoaWZjQmtMczlmb1pXNnFpZnpOcjRpYWVhTmJzTlArakhoVlVqVFg2SUw3Nw0KSVhNS01EcTI1ZXhQL3E2RjhTU096c2cwK0lhTVRGTTBMM2dORUdFMzhXamNqSnJURmtRZ2JFc2lNZUVZZDYzN0lrelFnR3Rha2xvZw0KYWcxbDBIenZWRU9ubVV5S3JXOWYzdThCenMzT1cxZm5McG5Qc0F4VzBiQU1oOFg4Z2JUcWg4NjdaWG5yYVF6ZTlNZXhrSk9GWWRnWg0KUEtNMFZMQmhzS3BXN1FmT2dpazJFT3pRRUlVaTQ3Y2d1MzIwS0IwazloNkJlZ1pwMzlvMlJDcmhIRm80T0FJbGhsYnBIWWFmaFd3aA0KQXhrTVd5cmJnZkZxMCs4dVRMRmxROTNoMUQ0d05MS2xpaWVnSzVnbk5NNkJSaFpWSEdWNHZRWkt2ZFlZNCtzWnU3U1VMemNPY0IvSw0KNE1YUWhoOVJ4T2tZbkIyNll1d3phbTJPUzVNUmVWNWtSUmJ6emYyV3BsWE1lbEVNMjJnVUMrSndhS1dxOE9oVHByWTNwd0VGcnlUSg0Kb2toaFJUZk4rbzA0WEgrWUlzY3VHb0phV3BaT2h1RjlhUTJrUU52dGIvdU9qMXMydERONnhLYzcvREJXZ1ZmVHQ4NHcwMmoxK205ZA0KMDM0MVRWVnJ5MzZqUDdCVDJkUDhhbHYxZjhnOEVKRFZUcWNiTkxtazBkdW9VemQ3ZFZOSGJhVFowNE1nMVVSYTJvM1dhRUY3SzVCLw0KZWxiUjZLVXJvY1ZnMU1OWkdQejlBYjVVb0dFTGpidTl4aWlzeFNESW1pQXQ2dDNnRnJqL1ZyVzdXbDZUQ0MxMUU1STRDU0ZOd1N3TQ0KN2xZRFp0bE9aQ21mcHYyK2MxT0NiSDU0TlgxM05mV1VEWU5NUjNtdldsS0xQT1hNSUZOcm92T2pzOFJONWlvVHUxTnE0REJXTVZqeg0KSzNGMWQzYitLeG43ellTb0VGeDdWb3VPOWU2dXBmeFdXaUVMY3dDT2ZhRGNnd1VKTWd5WkxKUUlkYnp4b2hQb1hzQ2dhSVJYdGMyUw0KaHlnYVpBWWYxUWFlRGgwTURrdzZYSk9XRmVtNWVIdnEwclUwRTcwY0I1anltcWNqN2lQNjZ1MC9Yd0V0VmNsbkVWWmV5eGpBb1IzaA0KM3RseVdrcXFBK1hGa1dGcTAyYkRSOURLdHZhZXZHd0RQeG9veFc0OWozOWFzbGExalZLTStPVDBMMk1ZQXZDTTBtRDR3U3RNTTBuUQ0KQUltRlpsYlZGVi95ZGsxYlFZc0VtL1ZoSWZVSFNwZWNMeHFrd0FoTVBJc1VNMGVpMjhENmpyUDFNNyt4REw2YVBYQkRPMEY4WjBXdA0KNmdqczJXZm1zRnZEWTErdDgySU5WS2xob1pCSWxVOFF5Ujc4c2UwdnExRWlJMXhkN1RTMERlZkFMV2IxSzNKU09zYkM4U3V5L2U3Ng0KeXQ2WE9xcXhPMU0vaTlLYkVRbnRWSHQzSHlDVlQ3cS9ZWm9yQStXZFhLTVIxZzZFNFlkL0kwd1VzNm5Td09odHJ0VnlaR2h1ZUN3YQ0KUzIyK28vQWJFVmNyd2hGWi9TVWVJQW92ckk5d01lYXVDZ2NIRWw5VWtMY0o1TlEyL3lxbWRtNXJXU3FiT2xsTDdYd01XZnlONFRZdg0KMWxuanhZWHhHM214d2U1Y0QvUEZOM252YTMvaGNxdGFmS01ldG8yM1RHcnJVdmlJci9TdWUvRzFRL2tCdW9tbm1mSnBQTEZXVGNiVA0KbGNaK1BGWFBITWZYY2t6YmVIYUF6dzdqYTlMYVdUejF1TktQcHo4K0wrT3BwOU5GS3J2MWtJQnhubmUzNWIzcUU3djgrbnhDSFpadg0KVTNTdDkxbG1sMFlIMlZSaGJmVVN1dUVHN09JRndZSGJPWHZkcHZaZkQzY1FReW0xTGF3dUZKVitmbFJLblJ6ZkZZOE80bGY2MitKWA0KSmp2ZzkrWFg2NzJ0MGwxZXVkek5EdDQzMTUvUFQrVGlZM0huWTJPSGxqTDVaSHY1cXZCODBDcENONlduMTFTVlhzMkpIVDVlU0Y1bw0KdlU1Q29HOUVrNUJqQ1lud2hIUzZpaWYyQjJsQ3RFcmpJY01leS9IVTlsYjNpNjR1eHN2MFhxR1JwOTRxOFVKcSs2c3YwUHU3bTRmVQ0KZnZXK09PRklrQVhJWUpMOVBoZFAzNzRjNEJSSU9LS3JlUEwxVGNKbkpSd0pIMDgydjFyeDVERGZ4QmxKRWpKcnZYTHBTL3d0RHpUNQ0KbFNNazNaYjNGei9KYjJRbW9CdHF2NklVQnZIbmxTS3pzajFmZExTQ0taRDJtSjJGL1JmNGM2OUZOWllmaWpvaXg0TitmMk53Mi8vVg0Ka282b0xIZVZzTTR3QXBYMmx1N1ozWXRFQXJ0cExOTmtXczVNU3ZlZkM2dTdRRWhwbE5yZWl5OXpBMlp3WXZiS2RTK3ZPbjY5dnZTZg0KS3g5WGpsNE5iS1M5clZmK2U3VkhlZmI2SWp5ZSsvVzZ2OUNxWlIrOWU5Mk1QdzBXYmgvT3NSdFBkQysyVnJiWEMwK0hYcjJtTnVyYw0KcGsrdndzTEM3ZU1wNytpVmRFTTY1aDRlcVhKZU9QUHNkYjc4S1MxMjJJMXpyMTZwOGx0OTM3ZlhaWVo3S0tuQ3hnTmQ3cUZCN2UzMQ0KSDd4eExYL2ZNSVhyR3M0cjEzWE42MHA3WGV2MWZHV0Y5S3AybzAwdDI3L05mcEJlZ1ROckpmdlVQdldmaTdmbjJHdlN6VkRjTXpmTQ0KM0t4NTk5cmJQNFJ1SEIyYnZRcW4xTWFDWDYvMS9vdEUzM3YzZWxwYVhmZ1dSaWRtcnlqVGpJNEhDNzE4MmEvWC9SMm1Rejk2OThvbA0KSDFJYnJadFR6MTdueTFXOFhjelJzWFZxank3eVByMEtDMHU4eE8vNDlQcFFvY3JkNjJ1elY4VEcwdkhlNHRieXNmSng0OW5yM29WMA0KNjR2cjhsbzhvODFyNmRkWDJiWjQ1dkhZbHNIS2JucUFIYSs2ME4ydnRQVWxLL2FjdlI0Zm5ENXJ2VDZzSlJ5NGlud204MmoyaXB4bQ0KUmZjeFR4MjNMMFR2WGcvbVI5THhRMTN5N1BXc3Blejc5Z3JkSEdXK2UybHZkTG1uRkhWMS9EM3k3dldJZlRrdWwzZmlucjFlSHpRUA0KekY2SjlyUjFmSFVpWEwvNjlWcWticWtYMmJ2WDQ3V0Y2MFpsZGNPclZ4UTJ0eTliQTE5MGJ4TktwZWZYNndsMXQ3YVQ5K20xbExyYg0KbGZvRjBpdDA0MFQzTVgzOTR0dnI1L3oxY2Q2bjExOEM5Vng5VFhuMWlwdzJmM3JUL0ZwZk9rMTdFdm5sNWI3aTIydFgyVW04Ky9WNg0KUXIyV2pvdWtWOEpwemxWN1E4L2ZEeThPdkhydDkwL1hGclJlYTJ6U3NYaFM4bXFKVlh1dHpnLzN6RjZoRzFRKzYvMFJXNkN3NDdTcg0KMTdPdHhQZEw2WDRYZXQzcU96WFBldmNocmZYNkphODZlbDE2ZTVwL0k3MUNOMHorZ1Q2d3k0cExxblQ2dEllOXJybmw0dW1hcm5rSw0KUXllRlM2WFBqTnJyVHFLVU5udEZDUTEyM2NkS0k2VkpLSFp4dlhCa2w0dEtha3M2ZmNKZXMrNWVoYVg1cllmOWZlajFNTzdvTmM3aw0Keno1SXIyUnUxaTh5RG5RL3UxdWxMN1hYblp2alk3dDZCekovZm5TSnZnTWo5THhnZmNzTTIzRm12Vk56dkRXVk5ETmFqck9OZHMvNw0KY3k0SmkyZWJWL3plOW9FalRwbytiMVdUbzdSNVZsSWJ1RFQxNHhaMXZNc3k1SzFiM2ovdVVNZVhPNXpmMnh4MTNEZ1N5RnZveHFOQg0KZ1RxSjMwbCtuNWVvcy9yQnBkL2JDblZWK0JvNjNsb3NtNmMwZFhXN0VQZjUvQ2xEWGUrZUpQemU4dFJOL0R2ai9YWXpqamRQOWtkeA0KVVd2Z2xscjcxTzFOZkV0OWExOXgrUGFRdW4xZjIvRjdlMHpkTGNvNWcyanVCcWZVblZBcStIMStUajB1aU05K2J6K3A1L3ZIVmNkYg0KQzlGK2lkVHo1MXZhNS9OZk12VnlzOEg2dmQybEtrSkY5bmxid2R0YzZjenFFZS9Ub0pxZzVWZm14T2R0YllIT0w3K1UvZDVlMFVjWA0KODRmK1JLdDM2ZE12cHVuemVTTkpQM3dlTFh1LzVWODYxeHVidzBkZm9qR0Q4L2hLOHBEWVdnbndkQkw3dHRVOXlNVXorN3ZiNmx1bg0KRkdTR3JmZ21kL2pwL1paTC9rSmhzOG04WC9nMWVFNXRiclF2TFcvUkx6YWQ0dTFlb25HZHluY0hwNm9rMjk3cUxWbWN0OUl2SmErTA0KVG9mL1JrUml2NzlETCsxbWh5dUY4dldPK0ZCOExEOWNGeDlMbXhsNFJwVUwrVXk5VU1obmoxTHcyVlZQZDhDWFdqZ2NWdTNRMHZVQw0KdTZLYTZvZHQxUis2NmJXZVRDR2FQWkU2SytCbjNvK0lQd1NpOW0zVGNHd1hzczJ0V2hLVzRud0puS0gxYzV2bzdzOHpLMXZuYTdveg0KZEhaaXR3V3dZNzFYL21OMWFUUGU5ZTZWZTdqMzczVyszTWc2ZWtXMVpuUk1sYS96Rno2OWd0RjgxanlwK3ZYNkd0RHIzcHBzdHdVYQ0KeThzTFpxLzl3WHBxWVBUSzJucVY5cm43aitNTnZkZTlsbzNDOHdscnI5elZJblJqZHR3ZnZkSVozMTRKei9uMENoNG4rQlcvdkh2bA0KSHA1VU44cmFzWTNJYmNhM1YrSmErUGFLZmtYRDdCV3hzWFdzK1BjcW5WN2MrL2VLUm9vdmhhRWJ0Rk1xZnVoZXVLWjJZVDJ0OVU5Kw0KMDloOVBiZ2RFVFphMDQxSUlMbGZ4OUhhSmMvVmRrWThqVGtXN1BFazJ5SXVqOENkWDNrcWFLdWdlcGtuaHFFcVp3PT0NCgldXT4NCgk8IVtDREFUQVsNCglkT0thYTMrWFR0L1FhZVBIa3o0M21xR2h4Wk42dGdCZXFvTXdMaTJSeU8zejVTNE9FQzM5cTEycmpNTCtEL21sSmZJRHAvVE80YTFwDQpQWndaSXlxaWQxa21yV3dSUXd4TjdkMmN3NS9MUzlxUDZuM1JkQUcwdUplK2dxSHhVNUV1UFEvMnRKaU5ock5sME51bEplMUgrcVNyDQpFa2oxQ0J3UlM4QUIrTEJnbzZHVjlQbnNoMUpjUW9hRy93Sm43bEFId2NNeW12aU1LVjFLcXo4MGt0S1dvS2JGeFZVSlA0cEFlUEpEDQp3NUM0N3A0WW5zZE5ERlh0NlVMUytIRnA5WkU4NWhEczc1T3dPYXlNaUJ1bERWOTFtUnp4VXBXMWpKbWVkQTVKZEZCRmNpTTFKcjM4DQpPV0lqN1FCbEJsT0MyTjZiNS9jZWVzSDhaVEtYeHREKy9FVzkwZk1QRWFnZlRIcGlDd0QxdzdnMThncmFvTHhJcjg5Tk9MM3NVaWpUDQpkVW1oaDNUUDFvT0JQNERIYnNhWWtSSWlzbWVCWVF6YUpvV1N5NDVJdjJONVBxU0h2aVBTUmdLaW52elF5RWRDdFI3a0svMjZkUzVQDQpxeHozWHA2cVorU0IzQTU5ZEJ3Qk9YVnVQSGN5RUxtMWhXRGsxQi9LZVdaNXU1ZmM3SG1UZWUrOGpjYXRqMzR5OFZwVzhmTG0rWmNTDQpwUXkrN29KUkl0aTRwOHpCUVVSbkdJTmd2ZGw5NzJqWlljamJPQTFtcTVpZEJXMHEvb29ic1ZHR04xbU5nd3lHVmgwZ1QyaTFnUzgwDQpYMUJXSlcxZmdIVFB0UUJyekhjRXJMMVduOTBqZ0JHVk1XSjFFRENobGRFS0dJRW5hVU04Slh4NG8xcG1ua2Q1c2szRmFzRjduMW5GDQpIOXJ3MWVpM20wRUFRN3M4dElGSzV4TmtUS3JqWVJsYnluZHMxRnNoOCtTRDV0bUZsM1ZtenJCR05QdTBjTit1YWZtUytzRktMMWdLDQoyZFFhNEhVLzhOTlVudGFrM1pRMFozalBJV0xWNVduWFZKRW51YkZIVnhkWDlpTVlWUmFUZy9iYUxFWjZ5ZkV3ZW0zVkVzRmpJZzQ3DQpESXZKUDhxSDNzTXl6RHcvVzg4K3BvVWc3V25PWUFSbEFpVDlXZ3kwTmhiQ1BBTHJOSWJZZW1QTUlaRnAxY3JOYktCUnlxZHk2d1ZLDQpuWnV4b2RrVlRQakFyS0xUQmUxdDVmdCtka1FMTWZqR1FmTnRQZkU0TzZJNXBOdllSTk1pWVhyTVpyajk3ZkJ1bWZ6OWk2ODhjbHJPDQpwdG1zaVU3N2VOLzM3Y28veU5iMTF0bjd1THV6SHl6VHJOYTNwd0VCS0gzTnoycDU3dU1lek5FNDduVFNaemJmTVpqQ0xtNGNIVTlGDQpvSERQVU0zbENDWlFKUk01M2hDQWphK0VHR09xS3A1ZWpUa1MzZkVJSGt5WVBBZ2RDZG5DdTY4d1U1UEZWd0NRa2FnTTdmQWYxNys5DQpkZFp3ZXhDZy9yeWNSN0kxcXJ0UkpEeE8yTWpJaGNOaG1YRndHTkhuQWNpRGFpbDZEN2J3aDkyeWVSNTA0dU5JRXIrRjhubmdzRVVjDQpUbUhvc0d4akdpNUVGUVdPZEI3WDJqdVlqU2hRRmNIblFYUlJFSXpoTUxYaWhTRmlNemJodzZ3SEorZHlYVk1SMkpsM0oxRWMwcXY1DQp6L0lNTUJ4OE1CYXJNMXFBMU1kMUI0OW83OWUzTDBkb1Fjam85QXBjN0Y3MElsRE12RTRidmNaYzdEWjYyVmQ2UmxkcnRzWGVQclF2DQpkaDgzTGpRV3hTNnV6ODlIQ3FZRUJoM2Fod0d1b0R1UWE4MkVkTE1iclVZVXdnSUc0WUZjb3FUWDZaVXBJeXJ0UTNibjl2ckVGemtpDQpiRUpqSWV5aS9FMU5Fd2pScE1BaGRIUGJuUm9scDVhMVJtNkQ0M3EycVRvYzJRVjg1Q0NSVGQ4Z2Jmanh3aVUrc1oxRFIyd25nS0VYDQp2RU1TZGpON1ovMTg2REN6MloyYnBiaUQva1ltWktDbDdaNkgzdEZZTVRhdkpISjFSSFJ3Mk5CcEpmdnB4U09pRjNYdEdSUVJqV0FsDQo5NDdzZW5IQ2RiTnpzNVdjaHQxVmh1NGRPUlZpeERDMmxkM1hMK0oyUldoQnljUW1Da3BMM0lTaXdNcHBSeTROT0lFb0FNSTROQitPDQpTVTlVOWxGK1BtWXVFc2l1K1VMMEV1bEd0M1E5bE44S2RMMndZdG5VaGQ4SzhDelJEc2Zhc3ZyOHd3LzNWeFB1YmxqeDJqdHZXM2VqDQpvbWpBZ1BBV1FqT2l0TUhySmtLVUZxQUZyOEpvRWhvWER6MXRHQjluTHBsd1FQSFpLUXdIdERyV2NMeDMyQW1nMUV6d3NsbzJVd0ZhDQppekFjTFFFbVdCY1NhSmtwMUtwQk5OMGlUaWJkYnVmOTlkVGJFeFpoQTlBY250bkU2Z2NIWnRzMWlyaFQ2RXZOeGpJVFpTZExqM0k0DQovSGd2NlFhdURaOTBTRGQ0dGg3QnZGc2dHeXNoNXNYOXpkVFNqY3dOR0p4ajJmZEIwZzFBZVVnM0xjbGkzRDBvZ0RhV2RQTXhvRENnDQp6VTR0QlhCZmYzVVdVc0NkVU9IUGFhR0Fvb2lUWUNocVB2UkdGRWtTUHB5c3IrOVBIUFp1YWt2bkpWY2t6R1BTVWtGN1N0b09KUDdJDQptb2FMUGNxaHFqeDl5YUJUdE9yTUdZTm5VU1lqVWtaWEFkNGQrRzVrUjdUWTdtOU5pV3RvejRuM2hBRmF1TVExWTUxaFF2YzJha0tGDQpsOFF4cGNEZVF5L1k2WTVnWnBPWnN5ZE0rUXViVUVDK2hyOHZGSWYyTkFCTm0xV2hRakhjN3VDTi9GQkFVWE9hak13VTMvVklvRTBXDQo1RGFWb3pWQXZBSzZlQy9sMUkvVitlTUlQaytJNzYwNmhmZDNzN0QrZi9ublFaaW1lbVQ5Q05BQ3JYOHY1ZWdYdVVWb0Uxci8xbm1sDQo1L21acUxYcS9NbHMxQm9BbWw0YnFjVVhKMU1uSjVIaCtFZjJiTmwyNFlCb1gvMFlyQnk5aEEwOXZ6YStmZ3hRanVzSmt0M3QxSS9yDQppVEdkREo5RXd3S001R2xveEFWQ1VyUE0xQTVmZWJTZThIZFpDVFhKOG5TdVRMOHRQUEFsSmpTQ1BmWUlDTFN4MTdudndNZ2lEdzQvDQpCRWxlTzlHRTRObTA3K0lHdWt3d29iZFI3RSt2YlZpclUzZ2ZHUFAyejlqekc1T0ZMZXl4enZCMTV1WEdNZm43aHpXSG1uSWtZMFNLDQpRL3U2Y1E5QmFzcWFHb2N5elNNN3prbUMvUDJITTRJOTFpS3p4MnplQ3BrUTV5bHFOaGFDNG9QbVpxenRINFFXd3N0akJGT1kvTVA4DQo4amgyaHpQUjBjclFEeVF3RnhXYXo3S3ZEYnd5ZlMzZFdEa2pOUCtTak1rL211eGNaUHJjT0NKRzF1WHhnWWYxbEN1ZVhLM05BNm5iDQoyejc3Mkd2ZFZpdkZoY2FvVkpZWGQxL0sxOXZuSlZMTEI5M01wcHd2RlZqTE4yY3BXcHFxbk0rYW9lV3U1WnV6SG1Nd1RUbGZjQzNmDQpuRm02T0YwNW42VlhqMW8rYTZMeVZPVjh3YlY4YzliU3hXbksrWUpyK2V3RzFCVGxmTUcxZkhQVzBzVnB5dm1DYS9ubTdLV0xrNWZ6DQpCZGZ5YVdwdCtuSys0Rm8rd3RDektPY0xydVhUc0Jtdm5NK2VBQjFRZ0dmRUQ0d3R2RENEejc4TzdEdkNtS0lFaUdGWVlibmlKOTFnDQp5MTFMU3lnNmR3RW1Ucng5S3RvTlkyYWFBUEg1eWxqNTZ3RTdoVTlGZTBCcUFsTHA5VzJ1TWg5M0twdk5LUXVxQnd4TStmUGNLUXlBDQpGcGJsNVlPaHEySWxRaEZmWkF4ZGdhNHBDRjhKTGx4VngyVEpUd3NZVmxpZ0syQk1QWWNOUFc3OTNoaGk1d1VQTnBzNjRBakRQeHNHDQo1NWRvamtlRUZKUFNOQnQ4TmdPSzREZDFlQXVRKzdYZ1FNNDduU2UwN0c3Yy9CS3Z1QUNXM1kwZGFYYWpWTXhFZEtQQ3l1Nmk1NWY0DQppMDZnalVlS3lVUmVDbUhvcUlWaVVSSzh0bXRNMTJGV2tBanpYRWdoWmpUNVZXTkdvY0dVeUhXdjFmbktmUGhrZUJhOXVpUjBPYmlpDQpjcXhBRzRZdG1hQUFzUzJpNGhOb3M4Y2EwUWhPMnlNcWUwaVlraU5sWklvYU9YOVZaeTJQaTFTUEpnM0RiSXh4YWdwZlJtTVZ2QVRVDQpGTm9NTXEvNkc4em9zc1M0L0d2a0ZOOGlIS2VaSFpaNXZ4ZVVlWDkyYVVTa1ErWndUcXNwRE11OGoxNVQ2Sm1VUG1ldHlCK2pwdEFSDQo5UXpqQ0RYSndoOWFTSVZQMUlHcG52U3QveGI4MkdpR0gyTXdEalQvdlk5SmlCWlMvek1tMGRocG9Obmp4ZXBobWJZa0tyVUVLNlI4DQpKNUtadSs4TUZYc1VMWm5MUGxycFhvRGM4QUZBNWliTUh5VHJuQTZWMWUvN1h2NmdWODV0Qkg5d3VCTlNmR0xhMVNZQTY1NDBnYkU4DQpQZ3diZ08wQjVYR09pOFBGTmFiYmp5eGhKWHMrczJRMWJ2ZGRHeXNCanBwdjJaL251blZJZ1ZDS1JBNUUrRWJWd3dyMlhQck94NTVCDQpsRGdIU3U0c1Zic0RGbFJDa0NqMm5aVzZ6NFAzb1JmVjV5eVZYbllMMDRlaFFabU9GZUJJV3MzQmtGcTlFQUhrWDVibFNrNmEyRTc3DQpQUEJkKythYU42UkFLS2tpcjF1dkZDY0xwMzBlakJjTENxaGdzKzhDQVIrNGZNK0lmQkJlbzJjYjA1eHh5S25uc01hSzNnU01pU1JaDQp6SWFyZ3FJM2M4YUpZOUdHTlY3MHh1bEcyZVBHVzBObjlBYkxvcWFKM2xnNHJYMDRkZlNHWFZ4UExIcDVlalpoRTlHck9Cdy9ldU1mDQpGMmdmVGgyOUFlUzRSRURLU1BSNnVJalJtN21nYzZCSVBkeTAwUnNzaG1NdFFjaEo4NUlPSTBSdnRIVVRXaXZvSDcySlZCMWtXRFpJDQpvTEVLaEFJVEw3SU9RM3BPci9RS0tZMk5aRWdmK2VaY3pJMVRJYmwrRVRLUnZwNkRPNk9MM2JrUkl4U3pSamoyN01qTTB2WE5JSTZFDQpYRElxbDVKNG1qZWpIa1ZNaGdnclk4TmtDSHVzYzhJU3YzQ0pxL3FlSVNWK1VTcGFBMWV3V29nWkVLZUxrblppSVpCZjJOVEIwSDRyDQoyWkVPQ0FKenhia2hDOC84T2NLYU9CYStkVEZ4Wlo3RFc5T0w4MlpkbVJlY2RqMnp5cnhRVHB0TlpaNGFIWFFWNTQwUEtMZ3liNHhrDQoyR2txODZ3MnRLVTRiOWFWZVc2bk1HcGk1RmlWZVVHcFZyb1JPb1BLdkRucmhVNGU2M0ZHbFhsYTVyMnpPRy9XbFhrK2N6UHJ5cndRDQpiODF2WDJqdnRqdUx3bjlVZVNINTY1RlRMd0VVSGRIcWpKQjZDZENZV1VnQm9QbFZoRTB2VDlQQW1uQjVNd3NiZzBCeDVTRlBzRmxNDQpBTmxkN05EaGVNWnNDS0NwandBZ1VMVEZhTldlbGwyZXNWS3NmUTg0OXN5OGo1UmlEVmI2OXFwelBaWitGWUpwcU9VT1JsaVBEMU1kDQpkbXZFT3Q5V3dzNTRpWjRLdmZMdFhFRVJaSnB2S3ZUS2QrUUMxd0JUdmVDVkxURTJ1OTNPNktoakFpanNMSndvTGk0Qk5PWjY5RlpyDQp0ek5aajdlK3l0RWFzNGxvK0JOb3RiRU9oa3c1WWphT2xBbkEwSld3aE0vR2RydXQzZGpyb0M1OXoyZU9Tc083bVJiSjNzMjBTUFp1DQpSa1d5djc1blVDUkx6Ni9OcGtnV0FNMm1TQllCVFY4a2kxQm1VaVNMWlhUaEIxMDdjd2Q5eThoZ29RUWNCUnNwZjhtZXpvT3l3cjBlDQpLLzJwdzJDYXNMSFU1VTJkSytSVmxHZFRhMUZ5aGV4b1J2WHVMWFBqNitEUG9DalBzankxdXJ3ZktjcWIzUGNjcXlqUFAzZy8wNkk4DQpMY2tpcEZ4ejZxSzhPWEl5N0V1d2Jvbm93ZFVHdmpKS05XNHRjaUZhOVpVOTV5TDg5UHM1NC9ZNGowbDJIcHc4OFpGd0d0RytQYmVRDQp4ZzQ4NDhDR25uYmZKSmJOZy9NSTVmQ2RpVG5mVW5rc3A0dXdCeFIwOGpBSzlpelJnWE4rdGJqaFZkZU9NVG5PTTdlemhUWHRPampkDQoxYlRtOCtRTUVvOE9yYmUvSnk0WFJiejkvU29PWmhSV0Z1UEY2NVg0NnRFR0hVOFhMKy93NHZVcnZIajlPcjU2blJQd3QzTnNXb2l2DQpIVlY0S252L0pXckthYXY3WlIyMEhwK3lYNkduVm9SWmZVOWIyZDE1bHJKUzJsWUFOMWhaN0Zxdm1MV1gzU1ZxaTVkZnZzVitYUEpYDQpVTm5keTVwdnIrUW1jcDllaFFWU216WG5YK3ozRWxSMkYrZjllOFdieUkxZVdZOTdDdjBMNERianp3SFh5bDNzWGxwNmRWeWhoN2R6DQp6L2tXKy9FZnE3dDNxejIvVXJTSG9MSzdkOHJSNjV6OW5zTG5mZjlpdjZXdjdHM05yOWRxUUs5NzFMcmQ2blRXTnI0Zkx2ajJHdisxDQpJTno0VVRnZFdPdzNYejVZZGt3dHJ0czEwai81VFM4S0hEVWl0VHRiVUJ3WnhINU41OCsyNGhGQTlrZVZMK3RwNDRpMWFhS2E4VFI5DQpFY1BuNllSRHh3YkZuTVB6ZTkzRzdmbHkyNW1mNzR6RFRsUmNOS2ZlNmRYempWTjVCMWo4Ny9UYTlUeUwyaitqeTcrNEtQU0tHdmYrDQptV2QwY0xycjlleGpHamtUL0dkMXZaN1g5RVVOMjUydnpFOVRuR2tKRUQ4VncyOWJzZVVPQnR6dDVyeFdMMExZYm95YjlYd3huQXUvDQpDeS9zb3BVb0dNNTVuUVkzY1ZWc3BEdFdvaEkrNVBxSk1kWU45WGJNL1lwRUttdWMxUDlXUHRNcG5GbGhuNWYzTVc3TUprSmhuNWVYDQo0QjIybTZxd3o2dXF6OWVHbnJ5d3p5dUtxQVdJWjFuWTUxWFZSOWJOYkF2N3ZOakgyRnViWFdHZmY3aDdwb1Y5WGc9PQ0KCV1dPg0KCTwhW0NEQVRBWw0KCTZTa1dDVDJyd3I3UVRNalpGUFo1N2ZQNDdPSk9VOWhubjFlMXFpOWdZMlhTd2o2ZlhkeFpGL1lGVkt6TXNyQXY2aGxkVXhiMldmTDkNCmphbys3KzNWcVFyN3ZKU1RHb0dhYVdHZjE1aXNXOTh6S3V6enF1cHpaSFROb3JEUGF3Nk5kVE83d2o0dlVQcG04UXdMKzd5cStyd3ENClZxWXM3SnVZYU9NVjlvVVJiVWFGZlY1VmZlTVNMVUpobjFkVjM1eFBwZGNVaFgxZU51bWNzK3A3K3NJK0w5bGpVZEt6S3V6ejJteFINCmZjK1pGdmJaQVN5SHVyZ1RGdlo1emJYL3hzckVoWDNXV2RKM1pvTDB6WVNGZlQ2K3B5OUZKaXpzczVERHNESG4vQXZLSmkzczgwSnANCnpuSnlrcCs5aXNPYTBrZFU4d1hXQjY3eW9VUXgxTzRJS2xUVEIvRjVRSHhFcXhzMWVmVlZxTnh3bUJ5enVNVXZ6T1NZMFMxKzJ4NVgNCitIbWFITkZJRlhvSHNJVlYxU0NrLzJWNW9hWDYwZmdBV1VBSnU3TjNOZHIwZmZpclgrOEUvNkFyOThMdTZ2VWNrenRsQkljVlpXRkgNCkdwUHVoVVlWTmdHa0VzWVFOcjR1RTdzb2YyWHRMdE9oMDJWeUp6WTVZMlkrdnFmai9yOEppK2ZNTUxOdm5rMUVlejNpNVg4NnB3VlANCndkU1gvNmxSanJENy95TFc5TTNpaVBDcEx2K3oyR2tCOS85Rkw1WHl1Znh2M0NEa2hKZi9lUWNobmZmL2pWa3Y1Yjc4Yjg1MTRMblgNCi9YOFRaSkNBbXJCY1k2L1hlUGdtNVFZVXo4MnV4cU4zTkpzenljbmNyRjlNWFUxMEZKemZZU1pjaHRiMGVXVTRqcHZkalJNLzlTMUINClI3Nlp4cTRFbU5Ccisvd3pReUtYeDVFYiswSVM2S0lscVNGMXhHZ003WHZmbUczL0pKbHd1OU5ZRkdqVGZEWnZiYXdOSTR6cVI2NHYNCkMwcUpoNkZ5d2JIMGNWS3RpRWN3bTFRcmNqYkI5SndHTkkrU1pSV2xFSE1HT3lrRWlzMlU5V0tCaUlERzBZSCtpV01JYUtLbDZJSUMNCmZxNTkzWXhkYVcrRjVuOUlZcFRMNjUzVnZwOUt3bFh0KzZtRTcwWkZMMEQ3VkNMZGoreGg5M2tra1FPMDFVaUN6YUxNZktsNTFTSFUNCmpEQTNWbWN6YUhNS3JEaDN5dmF0ZXB4djhMNW5wR0Jod1pXUE1tRmh6TTFNTDNlOG1kM2xqamVPRW9wSnBjQnRkeXpqM3NlTkluZlINClRXTmptRkNDMDBmSEFUU0RZd3hVUUpQZDhHMzNieEJRUURiU2VHbXhzRkE4U2lpbTJTd0dtOHk5SHVHWlJ3bkZKTUg3Q2U3OTg4eE0NCnNWNzlOK0Y2dElDYTRWM2ZZZmYrUlRUVnA3MzNUemZWZmEvK0c3UDB4K2ZldjNGZDNBbnYvZk5RYS9hci82YkJ5eFd6R2UreVBpZTANCjhIdi9IQUhpd0dyZmllNzlpM3g4Kzk2djc2bnJ5NUFGd09vTE9Ya2plclV2UGUvcFdob01QVjYxTHowLzN2M3kzc0VVcExrU29lNGoNCnRCQlRMNzAzUFlKSkFVVUtmb1ZrZEJGQTAxWDdFaWlxOXB5KzJ2Y3U4R3k3WGFJOXg2bStkMlh0UkxwRjBHYlpPR3VwM0ZrN1dFWjINCkU2elJQTU5nWG5rMmdIM0FlaHl6a09xZTdGWDVxelh2V3FxZ2FybWFmN1JQNDdUSURqNUErNGlRaytqMDduMldKMEQ3aXJBOEl4UlMNCjNSTVhmMGErWjZVZjdPZTdmRThmSmJXZXlBUmtUSVphak03d0F3d3JzSlpxWEl1eHBtN2NPcnVCeDdNNGZnNEw1UnFXaytEdHU3Z1QNCjFOMFdNdjZwZktaUW1IT2NlUjlRbVRiTnFWcHVvczNzTXN6YXdOeks5ZDJOaW1yWkZESmlCRDA2Ri9FQ3dmdEs5SXRTZlhlanlEMTkNCk03c01FOFlVZU1wSTVMcGJjeGx2OHljZHp3NjFTVGdlOVB2TUVHdWp0SUxCUS9rQlN3MnY4Y2R1UEZYUEhHS0pZWUhVR1diWVkzblINCm1MNWxCOUcwMzJ3MWN2MEJ2ZFEzZXlVTWJiK2FicDVabDcwcjh6Ym5sMzByOC9xajE0eC9QU0IyczhtOE8yL2lTNWxYMDNuY09taFUNCnF6MEdWU0YrMGc3L3hsR0krSFo2NWR2ck1uMVlxZnYxMnZDdGtZTnVCdEpwL3NxQ3JyMUdickR3b2ZoVjVrbjcyOStMYlFOWFIyVmUNCjBsSVBPR2ZjSG1jaDhoYmoyeXRWbHFsVG4xNkZoY1hMTnZQaTFTdDBnK2dHbEQvT2x3ZWNmNjk3NmRkYjMxNVhsSVQ0WVFsME9Vc0MNCk0wRzlIcS80OXRvZjNHekh2WHFGYnRSQ3hOM250V3ZiMUNxeTNqLzVUWnVNWk9HeDBZN1M3bVhVN3RpRWpVOVRZZUg3cFhSL0ZncVMNCi85QzRUMU9jV0tMeksrY3dSeTFKRm9tMkt3SlRIdlg5ZFphaCtTSmtaMm9PdThlTzBsTnhKdGN1Rk5FWkt6czJ2Y0t5a1FKdTViT1oNCnc1N1h1a1VkVnRTRVQvZGVtVTBSd09TVmc4OFFpbW9FRngxQjREbVBpMmtpeDUyZWlxRTN3RmdTTG9OSk5VN2lWbGg1M0txdkF6WmUNCmVaeGZKdWljNHd6aVNGdzFaZzZZZjlZUVloaWFDQisxQUJCczh1QjFFNzBBTUNSZFRyUFRvZzNMLzRpZWNkZk5objhhclRZY2R4NnUNCjNRSDNPTnhUdlFodEZwNUdLZmljM2FpUjI0ZjBjSnBZbUoxb3BWKzN3U2syVVRmQlM3UFpKbnBZVzVoQlBLMDBpME1vc1I1Ulg4WnoNCmZnZWJSU3RKakJvRTFVS3F2aVdKSVVlUVJxdEhqRjYzRnViVmxBSnp3S0xGMCt5cEtMUjdjNmpHZkFkakhWbllWTXN6OUtScjdIeVUNCnlZaFFwVitkUDdISUxYYzZ6NWdIZFFHOUFnNysxNE01YzJyaGY3UUl6SmZVYzk2cjQ0eEoraGdwYytxeE9hRjFkbURTK2VpQVNBVnQNCmxnM0p4bDZ3U1RkR1FaczBjcWlUdVdrcXZXb2hSekdZNFRWVmRQclgyZmtmeFJEQlZMY1pVSzRvNmJoMWlaWTVkT3hLZXA0dkVMbTINCk5QVFdIOWNjK21ZTmZVbjkwRktoeUJ6UmQ5a0NVMEh6TGFHZE0rNWJHd2ZhMkl3ZlJMVFFhcUt4aURhcjgxRUFtdThPNkVSRUM2aU0NCmMxVXgyemVMSnl4SmpHbzJXdXR2SmloSnRDOVAvM3JFT1kvalA4WW9TYlFQd3I4ZWNjNXhuL1NZSllsUjZ4RjFSZURySS9uQkdPK2kNClFhKzl0VEZLRW4zRW5xc2UwY3RoSDZNa01WelYrR1UvakZXUzZFTlNWejJpdzRBYXR5UXhrbnZvM0Y2MW96Ulc1VkpJUGFLL0ozMTINCjQ0M1hSSmNWV3FYQUQxNVdhSFdqWExXTnM3dXNNQ3o4TUtQTENrMUZFQzQvcHJpczBDblRmdWl5UWkya091bkZnRkV2S3pUQ2RqOTcNCldTSGhOQnpXejE1V2FNMjgvOEhMQ3IzRER6Z3N4ZlBhVVdKWHE4TUpPOVhLZXR1aGtRWTM3WVdIT3F0NjMzWTRicmFkNzRXSGs1eHENCk5jR0ZoNzdJemVKVUsvUEN3Nmx5b0tKZmVCaGNBRGczZzFPdHlJV0hNempWS3NxRmg5SHFQYWUrOE5Ba2tGZlF3NHVoSjdyd2NEdncNCnRrT0w0ekhkaFlkakZwUk5ldUdoa3kzc3R4MjZFbUFtdmZBd0dMbTV3UHM5eDdqd01QaTJ3NEJZNTNnWEhnYWpwSnJxTTdqd01EUVoNCmRqWVhIZ1pmQ3FiSnRPa3ZQQXhleG9hcDdpeUJHdmZDdzJETjU3VFRKcjd3MEpiKzVMcnQwTk8vbWVUQ3crQzhMRXZhOVhRWEhrWW8NCkpabkZoWWZCdHgwYSttYmFDdy9IdktkdzBnc1A3VkNjdHgyNkE4UVRYbmpvbjY2bWRUT2JDdytEOTJNMG1UYjloWWVCMVRGcXJ2cXMNCnF0WDhienUwZWdSVFhYZ1l2TTlEYklGWlhIZ1luT0x0RzdrZDk4SkR2MkkwNjFiRWxDVVhBQzFFak5pa1FFakpoUkowNGVFWVVtQ2ENCkN3OE5kdk84N2RBVnM1bjB3c05nS0hPKzl4Uk9YM0podWUxd3VsS1NHMThQM2JIYkhDMjFOOEtGaDhFNXRIUEcrUUxHZXB6c3dzUGcNCmswZE14MlBLQ3crTndpL1BpdTA1YTlGUzlCSW85NFdIRVdUYUxDNDhETDd0Y0hwVFhidndjQWJsMkZFdVBJemk0czdnd2tNZGlyZkgNCjdWSnI0MTU0R0hwRllZQ3dtZURDdzZCQ2oxL2ZtdTg1L1lXSG5reG0zSFk0blV5N2kycjhXUGM5cDdyd01OajRzV1EvVEhmaG9VbHcNCnI5TGdjYU9EdmhjZWpsK0xPOUdGaDU1UURGRWNYTEV5eG9XSGsyZDBlVng0T0dtcC9weFdJVG4xaFllMjllaTY3VkR0WmdZWEh1cFYNCmRkNjNIV295YmZvTEQ0T1RxRlRqZGdZWEhnWjc5enJSWmxaNDVYM2I0Uml4VGp2Um5CY2VUdTU3am5YaG9aODhWRzg3bkZXS1lpSDQNCnRzTTV4OUg2RTE5NEdIemJvV1p5VEgvaFlYQ1JycmVTbnVEQ3crRGJEc1BzdE9oRnVvRzNIVnFEa0ZOZGVEaUpaVFBCaFllK3MwazINCmdPeGIzMEhRUWk0OGpKVFhPZjJGaDhHNmdvUlVuZXBDR2JwdE4zam1yeXMwTmVGS0l6SEN3YnBsUTczZHJHZWRFV0Y0RmlEdmcvUDkNCjdVV1VhaW1KaGF0NmpwQVhUTkI1d1JRQXRuM2FWTWRLQkZLZllOUmhWZWM3Qlkya0FNcVJuRlJSQ3YzKzltVnpOenZjUE16UjB0MFYNCnM3STlYeVJOc0twclAzVjlYdTNIbDM2bGx1TVlOWXF2dk94L3hETmJuN25VeHZhM25OcmN1SHhJWFRlL3VsU3A5Sm1sU3A5cjYxVDUNCjZDS0hpcURjYlI1VGV4ZnlHblY4Y0ZxaGp0dHY3OVJaUy9tZ3JrNVltYm8rYU41U040T1BOK3FXR3JhbzI1ZXRFWFczZHB1Z0h0TTMNClNlcTVObjlHdmJ6Y3YxR1ZTM1pJdmJMM0s5VHJTZUtpMysrWHN2M0JyKzVHZjBSM2JxR2IvcWdpSlFZcjRqTGFDWmREckRaZFdXczINCjlzLzJUK1czM2R2bngvZjQ2dkxTL2ZtaXROSEtMNTFmN1IwdWYzd3R6Yy9MMmRQRVFxdStkTURKeTJlMXovdmk1cXBlbEJnZnBYdmMNCjZTdVpGbElDQjkzRWMrWHI2eVZxVVduQTQvT3VwempSNW9hVXZBNEdXT0I2SEYvTFAzQ1dDeksxR3hiWDh3NTZFV0loMGZZdTFqbWcNCnlPaWJldDE4U2ZiN3Ayc3BFMTBYcmx6eVByWEpydXhTNWZ4Um5pcS8xUStwdmJQVDltRGhSYWhoTVcxYzYzRDd1NVRha2s2ZnFHeTUNCkVwOVRLeVF2cU5LdFdDSDNIMUxaTXlYdE1NTHN5OGgybGVGcm9tMUdhUzNJbWRySXRBWFUrdC9sZUxMWjJvNm5tZkp4UEZWZnU0aW4NCkhoUEYrR0pST3NPcTRFTnk3V2g4TGNlZXg5ZXlLNmY0NGhISmQ0OFhqNWJpNlpQNy9manE5d0pnWGYyV05DWXZqMUNtTXlsTlFpL1MNCnF3VjZvOUNzWm1sRXNySzdjUnp2azZrcWw1Z1RDWDY3NnRIcDkvZHQrTzMybXdRQ3FPelhmSVo4eXk3SzdTRkZKVEpaOGlmS3lvVDINCjI2ZXlDbC9zaytRa2NydnAyOHAzQ3Ara3REL1hFMnY0NTVyMjV6R253UURKTUN6VnY3NWxLc3NmVUxsMjkzaVFPN3E3ZXdiSk1KUzENCmNXNkxTZk1GUVFDNjBkOXRwU3p2cW91RkxmMUZZYzE4d2VRZmIzYjBGd2RaOHdWWVorODUvY1VaYmJ4NGdlbGJhcEc1MmR0YU5SOWINCnliZFhTRnRlV0xyZU84Z0F6ZE9yb09WK3BRRFFRcEo1SG55TzRNVWxEYi9WS0hibkpnNS9udStxa0tFYmhGRWhoaVE4THFmeG8xVXcNCnhwVThFVEVvSVNXUXNzY1NpS2t6bU4venN5ekdwdE5FSzhPZk56VDVRcDJnN1BrVG16MjUrbUxoMjJ1Zy84TG1BcjVOcVRaMHBrMWwNCkg0NU4ycnpxM2J6QzdBdVBhOFZzZFhONS9iMnpjbFBlTEhHZkZrbXF5dG05K3d1cm42czd1N3BlUHBaVnE1TUkwMW1CMUlVdGdaYzgNCmxDNWtDWTg2THUrdUtOZkZnNFoyalNmZ2RVL3JiSHpOcElycHBWRTVzWDl3d0NSYmxRV055UjZxbklGNjFjcGt0Yk0xcEZJYTZDcDINCjRNK2JySDdJS2Z4eFQ5RzE0NE1rL1BaRXE3Wnh0dmJDYk1zSERNeFhyY3JxdnpVNEFrT2IzNjlMQW5LTjZIYjQ4ejZyZmZ2MVJPbS8NCnZkQldGcWlCZWozZTFrYjAxV0NOb2RhWWx6aGJLVmVTVDBmTTY4bjNrb2JOVjFzZ3dvYk5TNnkwb2J3azN3b2ZRdmtzMzVJV0pFdUENClI1VUNvSkxKVGlHdWFmT0hHam5VWTMxVWRuaWZNWHF0YS93eWZLSG9QWG8zQWI5VmFmMjNCbU8yQSsxOUNSZ09Qems5MW1rZEVUKzgNCkxhOG10emZFMjdYNWsvTHJ5WkpNVkM2N1hCbUkxT0ZlaW9mNWVoWlNwZHY3L2R6UlBiVVFvdHMxaytONDNaRmtZUTlxa1J1YlY1LzMNCmxsQmdYcXZDRVFUbU9ValgwazA4L2QzYlJ5RUtNblcwVGk1cEJySDcwWHhTYjIrR0Y3ZjRySWdITHlCRGU1MjRvTTNnMW9NcUEyRVoNCjVSSmtGV29PSFVoU3JVbjFHMlhmUXg4SXppSGxFaG40c3pMVVdYVi9CVk53U1R3TjVDaVJta24xaWxlTEVIM29aaEQ0Q3JPeUczOG0NCmZJQm1acG9jUWdUZTZ1WkJ0bmsvektnQnNXWjZQVVdNYTVCdXBVTkhsRmozQ05pZDI5TWpCelBnaXh2b1J1eTdoQT09DQoJXV0+DQoJPCFbQ0RBVEFbDQoJTGxrVUlHejFRUitsaVNSSHF4T3hPY3FtdHNYYi9jTHJWNjVCaEsxRlFoOVRGRjg3d3RqR0VXMHVTbm92L3kzQVZMMmZ3WXZUVlFQRA0KcEZvUnJ6SWppRmoxR2Q0R3B3cFdJazdCcS92TXQrWTdXRnhPNzYrVmFZUmhCYjYvYzRuaTcyTFZFUXhYZlE1VEEyOXY5VXpyR1BQSQ0KdHZaTUk5QzBBUFhnUGJzYzM5eERkM2FUcmo4K2JkTHBRbU9IcnIwL2JXa1pUVnNQbklxU2ZZc1dkZWFHbC9JM05MOFFUNTQrSXFjaA0KeDVIelB2Sm9CcHlxZnlZM1Q5ZFJ4eDhnWjE3R1V4Znp5L2oyQ2xsN0czODBWUDRHUXlnZFQ4ZGZWOURhdUhYeXEzSytsY0loNmxWNA0KU1dEWjhyZGhtR3l3TzlmRDNWTDF0ZlMxMi9uT3Z1N2VybHcrNUs0M1BoUEZneWZoTUhjMVNzenZidTZVTTRiViswM2dFdnMzKzdIVQ0KVGRzOWwyWGRqVEk3OXUyMTBDd3Y5NkhEKysvZDduNy9vVnhKN3kva3p0NDNqM1BYUlc2eCtIWXh1Q1JHK0NEK3ZGS2tHa3VkWXIrLw0KOWJpZ2V3Uk1zWDYyNCtnOVl0Y1h4YmZsM3NJNld5aldBUFY2eFJmaE9YTEVoQVBuVGg5QVhuRk9DMWU3MzUxWlVZK3UwSTZwT09tZw0Kemw1VGgwZ2xGeVdLR2hRNytiUHozZWR5a2VkZlNkZlFUVFJ5azY1L3lSTjJqUXpOMUN1cnV4dS9QaXJGek9WcnYvQzIxYW1OUlhnMg0KMTQ4WGc2bitBNXkyZlZOWkxibjNiNGh3eERBdUNzekR0bmJlU0xtU0lvTFlWSkxDd3ZyeDVlNTZTV25tdnhLSmk5TCtlWlBlL2M1bA0KYzhXRGRuTlFMcmJvdkxZb3VXTFRkSlV5M0g0Tzg5T21tdTZJQkNmWU9HaStzMzZCT21nK3RUMWFqanV3bnhCMTZHWXM3Q2RrTjhSbQ0KSE96OVVkL1oyRjYyT2w2b1Z0MzVBaDVpMVZPbXJxNHNiS0laY0l3eTlSaTEvUkg2WEgyVXBGZnhkSElYeE81cVBoMWZrOVplVkxkcw0KclhQeFM1UFFGTGJmVWEwQ3F6S1plTms3R0Y4UFAveUF4TGxWZG0rUHRnN0tsZUUxdXJpbFYrSHNJL0t5bjF6WWhPTTh0WnhUaVJhRw0KY3pEQ3lHN25NSy9TU0RNZzN3Zk9CSGpEeFozSlRKc2hwTzJiMjhXaXVlWlEzMHl4N0tLdU9kUTMwMHI1Q0dvZHVobGZzNCt2MWpVcA0KTUhOVFpneTFObzBwNDZDMXRrMFVtZHpqSUd4aE54TG9VcVY4Zm1YcW1mYkZXbGRybmt0c1NrNnpXSEVvMHdJTnVYQVIweVBCTHpQTQ0KN05pZkpaK2hmNVBQVUV6cEx2OXdta3YzcU4xYy9lSzBYTnhKOFllNWRIZDlwZmhZSGo3bjlvWFgwOTIzNjk1R3FmOWNPK05idFpmRg0KNHFoNmZyYWI3UThYODYrbnpGVlpYdUMzeS9MaVphUHdmTGl3dnpGNjMwN25NMXovbGxuWldkMHpzMVJmbDFva04wRS9LeTI3aUdzLw0KUXh4RlczeGtZVkJLTlI4L2N0ZTNkLzBOUmU1L0FmN3hEL0Y3Ly9LNFZLMnVaRXFQamZrUFFucHpFbEN0TFhXZkMyZzJNRXorZ1Q2dw0KSVI2MTY4VkZNQysrZitFOEFQMExMNzhjQmdiR2JMeHRqTUdwZGlUY0JMM2VNY1ZNWnZNT3BQc3p2YnR4K0hVWjJiSWh2ZG90aXpHTQ0KS2ozS01ZMUpHVUc2ejVtSE5VNm4yOXhHbFpYZ3FnMDlNYzJqWWowVHRUYWVBZVhVckxQb1g2TTZNdlJNaklyZ3JvMUExOWlHOUZqQw0KOWdjY2R1aGZQTGM0YjkrTDdXUFZqWm9COVlOSmI5RTN6aUU4elRCV0VPQ3c3Mit2RjU0TzlSVzNkZWtrUEc2SWtoT05IYkxIdXVtNA0KOHk2dVA1K2ZZR2dJbEltd0N6ODI4NkE0Rms3Sm41dWJhOE5OMENoN3g2Q0lybzUzczhPZG85dytmNU1COVhON0JYOVM1ZlhsYm5HOQ0KdU5BUXFKL1JONU9JQXRYazBNWHY3SHphOGZUTnRGMzNDb1g4MTBvSG5jSmlSbHdaUk5XMlJOWCt5L29tdXFxYkk0ZWNodUVjQVdFUQ0KTnIxRjM4Q05rUzh3ODhBTjdteDMxcVFXV1hpRTA3eENDT05POThiUll2RlhjVzl2Nnd0RURQdnRRSjFZblVIVFBhVmxwUzB5VmQrTQ0KcFhJbjRYUjFicVlPbTRWMXJXYmJSVjluRXk2eU9XdE40Yy9GQ2UweWJRcE9DMGJZelduQjYyeENyS0dic2RiWmhJdk16V25CNjJ5cw0KUllhYlBRK09nMlk4TmduVHhVdEdUYWhJUFNaMjQ2a1dWOFp0d0VQOGN3WHpLNTR4NUhlSzJ5NGJHQTQ4aXlkZjN5UXQ1NkxTWU5YRA0KMmpGWWlHNlVQVjQ0ZmJEUXc5b2pVbUMyZ1hvdmt3ZjF6WXdqR21NR1V5SnZ6bmp0RVRpWTRWLzBwR2NjMGZCQ0hlTnBnZUhEMlRoWg0KS0FVbUMxK08xYjlmNUhiaUxRTzNyVDFKUEcwU3hvZXVkV3grYnZZOVhOeGdUK01uSTdkZUxwNVhQQTJXVm1KL3duaGFwOWN2WCs5dw0KOThSbEtjdnpJekdDTCtPMTNOWDBVZDhWdjVJb05PTlB5YWlMWGRWM0pIZHdzeW5ja1J3QzR0QnBpY3BqcmpoNlJSa1dQc1JuSmFLYw0KKzlZNURmOW8zejFkTDErUnZCZ3R0WFZzNWI5enVmb3JkMzN6K1JMVmpTSy9sU3R4K0cwanJjYVRTT1JVclNJWmsrZHlSSzE5dFZiTA0KdVZiMU04SmlJNzhCb0ZSNUVOOTYxdk9YcXQvWllBdGJUYnYreWRtM2IwaisyT3ludE95SEg1NTlNdlZtbHVwUHpUNlplbVNCbjUxOQ0KTXZWazNmem83SSs5VXpqWjdKT3BoMjUrZVBiSjFLdjUwRDg1KzJUcW94bTN3Yk92R2Y3RG5aUVphTE9XSktpcHZiYUNDS3kvMW9tbQ0KN2Z4b09DUnRERVgzcko5OXlhdEc5aGhKVmVVZEhvWTFSZEY1MFlwYU9MQjFWV3JvUm5QZGxqOU9kT3ZtMFoycFc1bkNkWTB6eDBtZQ0KTFh3TG94T1MycXZDZUYxeXdoalZ6cjh0anRMeUkzTm93WUU4aTI4OXRBMnYvY1oyOFJKWjh3OXFEQm14VVdIdzNiSVRCbnZ3Wk1LNA0KVW1Ib3FacThtaXlvWmhHV0t5dE1zcDBYTVowK1FlKzl2RlBJREVudFdmVWJwWUQyK0dzK2hRblR2SlliZW5mWGNIbFFpUFhvZFoxTw0KR1Rmc3JPN2VyVllKYjZqWFUyRjJPM21SVE93OHRleFpRNDNsZEVKYnhCdnRTK00rcG1mTDZ0NW8zWnppVU9jZEZ6V1pVMHJtNFQ3ZQ0KelpiVTBvaCsvdUhKV0o3b0VTUnFpNWUvNk9vOHR3Y2pvak0yaHNwMGRhS040bVl0UXB3YlBDM3I2eXQ1ank4V3pPRllXYkRHZEkxQQ0KMStoMWw3WFFZV2t6L3FyVGdjdWFkTURoZkpsMFVDK3lWSWxRSEZ3WlJQaGxKY0xvNll3UVFaVUNaRVFXT3FRajBJSGR2VWdrTkNKVQ0KZDg1c1JGZ2ZHSlVhcE5lNHptbmF0SVRUWVljK0hHaExJSjg4TW9pdy81eVovN3p4WlFaYmFBZ0ZFYVh4c25qMnBkR0JHZEZXT3RUUA0KVHZ5WVlVVVZ0dXF3bWZjTGs1dTBET0pJTUN3Y2FZTVJBWURtMzJqSDFrd0d3M0xPaHQreU1PWW1hR1ZvMXhWUE1Rak5Ua3RQQTBNdA0KL3d4YzM0aE5JQ0lvZ0RMVERJSmRsTCt5aHVpY2pMV2k4aVpoQVI5WlpXWFAwSFh1c2NnVEptOGlOcFBCc1BMbWhNSW1ZV1ZQSzR5bw0KTTVLdzhpWUFJRVR6Z21GRnhBbkQ1RTMvR2RsWi8rcm9BRmFYVkNsZ2cyRmh6MGxZSytIRm14clJJc01nN0JsR1RmY0NzVmsySm50Uw0KKzhXcm1uR2JZc2ZlVjlKa1FhcDhuVGNRdGw5RGlPMGljbG9BWHNteHBLQkdOQmNNSDA2THl1NUprOU1JbDVpY0ZuM3RKOGVYZ2k1Tw0KUzFvNWJTSkVURTR6MlYzZDhZaU9pQituaFF6Q3ltbkpDSUl3dmxMOGRhSEJZQVl2OWtHcytrcEJoNUlPSU1hcXlaN2pEMEpUMHF0ag0KQ1VLdlFWaDUwODBXcHBJT21KRlZCM3RHRUdJT0FGTW9hZUtVS1o4S0dxYjdhWHRWOEFmdXFUemlYc29qN3FCZ2REQ2VQa3VtaVplTg0KaFU4TnZYQjFQNlBWOEtDVDRWMWNNNmpHazY5S05iN1N1K3JhQzdtYyswRVdUak5DSFpxYnl1cFZYWWR0cmFxclhFbXFoVi9WK1VNaQ0KMkZKNms5TWtnYUxXbGU4ZHoyZm92VUo1bDY2OU5FcjROcTNIQmVpOTNucldjRjNOeXVJODhOZFczMW83Yk5UenVqQzA3bVNweUNGaw0KSnYrUUt0bDMySGVZbk1BVTIwZlh5THhyR0JKSTBHdExPOWNwTEVYVFVIbzR5MWhDQWpkYjY0WGN6ZkpHWjNlRHVsMGtBUU5pVXZPdA0KV21PNStGaCt1RTdKWElwY3MxUGFXbVNKZlc5R2RkVTFnb2M5R0tjMExYdWMxNVJua3Z2bFRTTVFrT2VINTR2SzN2Tmo3Vk1yWXJ6Lw0KV2lCelNGZ0FpL1BTbGZwamZIbnJqSWt2MzFmWDBTOGRlbGVVVmtaSnVyNzRXVWh0cDY4cE5yZkpNdG5tQXN3RG5zeGdxUzNOUDYyKw0KcUlXVnlmb0RyaHV0dHJKMlQxRktqUk5zaDUrZ0oydDErc2xodDV6cGl0R3JoYWRIaFBhb0gxbmdjVFd6R1g3b0VZYlNRd0lrREhYKw0KUUNoTjZraU42U2EwUWViQldrRjBlNjJIQmJVZjJhWFJZSWRKTG40ZXdEU25PU2J4L3JKREhaNGZZS0JMcmUwa2RkMGdjVEoya0Jjaw0KWm1Qci81YlFmTTM5b3NoUVdYNDlsVDNsTDNlQW9ZKzMxWFc3ZmY1S0hQYjZrN0JuekRrNXdtT2VlZDJVUzlUaDNsYUs4QmVkTHB4dA0Kd3p3SVJTM3o2WkhkdCt6N1ByY3JoK2FwQ2xxNERIblpLSW5WaUpaM2ZDbCtydXh2ZS9WS3ArbWJUZXB3ZUlhQnVSck1QbjlKMXVNOQ0KSVlkMnBlWExMbyt4d0M0WkV5bVl4SDFQZTUwZjliWStLQUl6M0J6Z3dTVWltM3Zkd1I3S1pTUzN3QzQxMkRKMVdIc2hjYWRIY3VvNg0KZGNURVM4d3JLKyt4T3pmck1wTnNzL3ZVVVhIMUZMOVlwMnZIRFhJcGFycFFwZGhsZHVjTXhpYktXTFg0U3RZam1WWG05ZTdvV0ovVg0KSkEvZHdBRHoyZTQydTd4Wk9zazJ0MjhLMU9GZ3lOSHAyNVVTU0plYmJlMG9NSjVPR0xXbGFrWCt3aW1kYmFacGljaDdVQng3V1lNWQ0KcTNSNjVTUHBPbTlENCsrZTN3dTlDRWV0ZU5SaW5mcGhBejkzMHNDY1dpU3JIamJ3Y3ljTnpLbmwyTTlXSEg3Z3BBR3RteGN0VVAxVA0KSncwUWswTS9iT0RuVGhwUU9VMDdiT0RuVGhxWU13OEJPcFovN3FRQmdvMSsyTURQblRSQTVrWS9iT0RuVGhvZzNlaUhEZnpjU1FPbQ0KRkZoNUt2emNTUU1FRy8yd2dhbE9Hc0RvcEgydmFFVVRYamxwUlUySlgwanFkdDE1VjZQcS9aY3E0c2hKWXFyVWFzNmZMeHRTYTZETA0KbVl3YWdkS1dHOCtwVGltc2c5MHVVYVkwNk5kdDFVNERWYW9IdVgvQlI3ZVVhdHppSVdwNEYwaUduQVJKNzcxazhBNk8vYXpQK2RqNw0KbElmSmhTK09FcVNiNGZZM25hWTZyN28wUGxyVnl2Z0xTejF0ME51N1JDZ2t0RE1kUUlnWjVmc1pTNFY5dWxlZ2lvZWJYY3B4Y01xYw0KZmhHYVZzRy90VXFRUk1NM1pUV0xYMGd3OW5TTjNLNmxXc0x3cDNtTWdBTHlxekVna3N3RWJoNmNNbWVlQXpYNFAwQkNpUktvbU1RSQ0KVklhbVk5bkxVVXZwbi9XYjc4MU9ETXp0amJtL3Nya0RtcjdwTkxybHZxSmNLLzhNaTkzNnFLMTBockgxV0RaM1ZUZzRrUGlpVXU4Mg0KbEpocW4vT3ZvaUUrMWpSa05EWm4vUndJMVlRdHZzbDdYL3NMbDF2VjRodjFzTzFNTjB1eSsxdWtqaDh0V3JBbU45VWExZlJIOHdNVA0KeXpKNElzVVZWcUVXNDJ2VUNVTk9tUEE2Z005aXFUOEs3Y2ZOdGRkeVY3eGpxWWI1bHV6L0VDOTllNnVXUy9kT0QzZVA1TUcydEw5NQ0KbHlsM0g3bmJVdi9YSTBWTStmSldicXV1YmRDY0tUZXA3WWRuQmt6SVN6eWtuczh5ci9IOU16UVViajNPb013VG9hbDdHNDZURTR3VQ0Ka1pXTngrUE9kdjcxcEgrYzIyYy9MbUE0bThXVXpMZlB5S0ZhOENOL1hKWVh2czVKQmtoS0Z1UkhHSmh5WDF4b2pFb2t2VU12SGlETw0KalcxMzg0N0VOaE1XN2l5OXJHOXF3dTFNNldpY0RXWXRVOWx2cEVucHNMcUFud2NmUkhKbXlESUE5cHJQNkttcHVvNVlXQ0hIUlpMbA0KUy80MGw2OTJJZ2RaSi96dW12cm44MEFoQzJpRlhkemNmTldPNm5qWmZUZVduR1djeEFhMEwwZkxDaXNzMVl3WGFldUxHOXJ3Zisxcg0KOG4zcnpYaEIyYnRaV3p6NDBOK2RKalgvODNpK2FqeExXYy9tZU1uVWpSZHIxaGU5ZFVwYnA1cXZTNUdkZEhwZklDZi80Qk4xWnc0TQ0KMGlVRCtFVktiVlhyMGJqcUw5YU1kYk9vcGdYQk16VWhnNjRMQlFiL3BGVEJVTjgvSTM5cVFNRWFwK2YwUTJ5eUQrV1VZWDZvNTVFdw0KU1dIZG9NMTF4cHBMMXJwYUtxWGw1SXZ1elJvTStwcG9xNmQ0a2FOa2JaZDM2R2Q4R2dmUVhXZW5BZWtCanpKaURnPT0NCgldXT4NCgk8IVtDREFUQVsNCglhaHBBZG1Hd21iclo2QXZiTjl4cFRueHVKRFF2K2ZFcXJoc1dUNlkrZkRXWmpFbU9HbDg2Nm5jV2ZtR0srMXRhdHRpZHl1ZE04ZkdBDQpWaGRBc1g3R2E3KzFiaGp0dDlIVGkrcWlsWkxWaXZZYjg0N0s4MDdkeVdVcWo3dVlsZkNZSVY0dlUya2RVN3A5emxSR2x4cncxK1M5DQp3WE9QVmpQcGRhUHhhYnpnRE1WWHMyRHplaGN2R0RMMU10L0t2Sy9tenV0dng4V2pnL2lWb1dTQ0lnMk91Nzd5NENVZktIcXZ6MWwxDQp4Uzh6TjV6cWNpeHZQUEhhYjhWcWs3UlRpZmJNYWsxdjJ6bm5pTTRLMTgvbFltdStucnU4L3JWU3FxM3QzcUVkdVltQ1JiZkJoajFCDQp0Ulg5VG80ejhoSk5Yd3Q5SW5mY3dKb3d0eTBzWFMyVjVjWDVheUljUVpMMnp2T3ZSK0pOY1ZUZDJBY2hlbktZVDdiNjU3dlpRWHU3DQorRmhvUDJHWnlrN3E2aHJlZmQrQ3ZGMHQ1dmFGZU0zTUJQR3lnY1kzZ0JDYnNXMmc4UTJnT2Q4N1FnSnNvUEVOSURJMzQ5cEE0eHRBDQpKT1ZoWEJzb3lrR1lWbUZqdmZSRzV5V253TElGVG5ldGFTTWVLUi96aGR5OGtmSng2NHh4cXpDU1ZoanBac2tCSTFWWTNDbFpNbHdTDQo4Z1ByeUhDWm45L2UyZFBUVzdxcmpwSlZUQXVhTDVlWFRCaVVNczluSFREdTc4OXpCb3htd3JiUzlscXE5VUQ0b1BScll3MUZBUTJlDQpaVEdOczJTYzAwb2VJMmRteUdPWW13cHFubDhEM1JQRXVJMkYrdDY1QU5FM2JWWU1sTFNVRnUzY3pTM0dUS3JBTElabm44eVNWTWNyDQpzd1N0enNqSkpRL3B6dmhKRmJieUxzZFc2OWpiSENrTEVaNzZiRTBuQWtuNE1kSWZQNUtGeDhhTFRvZk1tbzBPWWo4MHcyWjEwVUtFDQpuY0ozMTVwWm9pN1BhVEtOekkydmlYZnZzNm53REp1Z05LT2ttYXFFTEtEbUJua3dWQ0NNcEdVeXdnR29HVWxPR0t0andmQUFrSElzDQpDOVVUSEd0bEpOUGpEMkxPZnRjQjNnTTJKU0laci9XdEVpMHlJdGtKQjJGUkJFbHFXdGFpZlFGWUU5UURZYVNUd2VzOGVKR3I1bUI2DQpkUm9ZQ0dBR3dpYWQ5b0VSbFMzUzZvRVBvVEJzZzNEQ3lFU1lVdHptQ0VqSlMwL0tXZ1lBU2pjNXBvQkJSNkVFTHBBNWN1cXNKd3hHDQpoeUVzbU90c01MOTNWTEMxeTY2YTdSWTc3TWE1MXE3Y1pweWNsZzFobEZDOHNpRUNTQ2RhSUl5MUtkazltN0Z5Mm1SclB4dUZTMEl5DQpZTFBVdElqUVZrNmJFQkVtNmlBc25PWWNCeHRPelgxdTY2U1FVZ0gwdDNuV0JvQ3g4QlVxNlVtSXdVVEl4YlVNUW8wT09zY3hMV3N4DQpHUWRiK0NqcG9CbGhvcGc4RGdubVZOSU1GWUU5dlFaQnpva0ZsM1VYdkM5K0srMjRCZ0JyRks1MzFoOUxmZkJHd1lrKzNTOVUzdzgvDQpTWDZBZFFPUUwyUlVMd3d0UmtkSkNwMzZFbGN3dVB1aXU2SW5IWE9EanJqQzJ2YmdhMnI3dkpWUkV3TFVlSko2bGpCR3dQU3poRFcvDQpISnh0L1RkYVRkZlVRcnE4cUNZK0Fab0hQWUtTR3F6TTN6OFI0NVlNVmZ1eW5EVjJqeW1yczd2eVlXemlIaVd0TCtTaEVlZzdza1lSDQowOGNwSTRwNFJOU2E1ZDJMYU1SaWpySjJuOW9NbFRyT0MwWUpmV29Oa2U3ZEpJd1E2YWthOHNLNVVkKzljMFlrOERSRHRxWEFFZDlWDQo0MVI0YURDdTFsTmFEVE9hNXdXYndHdnZLU1R1aFhiU2NYMVJYTmZjb3ZSSlY4OUZvT3RyVzdnb0xySmErSExuQUNsM1FXc2ZYZHdRDQp1S3hsWjNTLzBsZlA0bWVTYXh5dXRPczE2dzdpenU2R0dXV0NiaHloTDcrNGwrc0NGcDhNRzJjb2pjQXpVb1VpZzd3NDNuSW43VWp2DQp1YXZSWXJQMDJEakhoWGROR3hHZFYrWjU5TEk3Wnh3Sy9mRENHdnVubkRWVXVTTWFMSE9uNVg4VUx3b29DdTZ5T3ZmZkFmRGFNMXFNDQpkN1FlbXJvanVWRmQvSTNWUWtQa0QwNkZVZHBvQy9Ebm93YXlVaWV6LzJpRXNSOHA0emZhR3Fka1hwcEduSksxdmloK0xacXBRbCtmDQp2STdOb3pCSmdOajg0UXdRUDJkczY0WmRUcDRoYVovaHg4TWQrblRQdFBFYlkyMTM4czdoTTg1ak9CZmwxOXVIUWpFbEpjdmwwc210DQpwSHNFSUU3YVBLWFUxZ1d5SldJRVl4OVJzSm03WVZNZGY2NTI0MzBDK2d5UFA1L1RUem4zT0FGOWhzZWZrLzBibnhQUVozajh1V3B5DQplSitBSHZYNGM5d2t4U01kY0IrMFV1bzBySHVnOEhnSkhsMHB3MUdQTk9FcmVlVzkyVG11L2xGQVBkQXg5VjhLL3NXZm9oeWpHU25HDQo4RHo4d2VQVDQ5cmNYNG5qNW0rbDFlckc2R1RzdUlOZjVkQ2JyV1J6L1dHeFdSODJ1NTFxLzA4TVQrMnY0QmF0VW0zRkV0WCs4S0NSDQpKRnV1bGV6OXlmRXBic0NTSmxubk55R3ZOMktKZjlxdERqUllxdzZIL1dadE5GUUdPdVJjdjE5MXQ2dC9ORnVOdnRMUldqR3g3RUZuDQphTDdHSDhNL1BVVjduZmdZRG52cjJlemZmLytkK1p2TmRQdnZXWWFpcU96Zzkzc3lscjJDTGp2djlvOS9WMXNqNDJ0OE1WajNiOXlwDQp0dlcyMmhDMTF1blpZRWNIWXhjQmc2dmJ2Y3IxUjNOUWFpbklOSkh3Y0gxanpQVE5RVEcySHRPWnBnSk1BODJCT2FrSzhBdTgxR0hnDQpqN20vcUZnT2Y5ei9UWDVWNXY0YWVmOENGaUNWRVNTWjVsaGFvaVJPcEFVSitUWWp5eHhEMFR4SHlad2dDNFNYTXl3amN6UXRDcHhJDQo4WkxFd0JPUjRUbVpvbVdCRWlXQUFFOFlpV0Y1b3gwZHU2OWlOL2c5dEkvZC84Ry9EdUczVDNqMmQ0eW1ZaWV4cDJjcTFwaURwcUM5DQpNU0ZCaHI0cFNhWTRpbUZqUEowQnBxRjVTdVFabHBHNFdOdWpFY05tV0ltWFJWNmdLRmFTT1hnZ1pRU2FGV1NaQmp3NExrYWd3SGNBDQpSeEFBSFlZbUlIaGFFbmlaRlJoWGd3SjBFOWJtR0JhdFJMcG1PWVlXZ0hTQ3F3MnRqbFZnUkpZVldGNDJ4a294dE1oeHZMdUJDMk1ZDQppdEZJNG1pWUQ4bmQ2Tmlqa1loRTRPQTFML01pSzhQZzlORlNFczNMbkFUMEozQW9qZ0VNUkVid29JdXpoU2RoOUVZVWRBODB4OUVZDQpVOEJLTk0xU3RMdVJheHBkNHczbmhrSVVsb0hSdlBsSlZvN3hFcTJpdHZoeE9WNTlWSHZLdGJueXRSVjI0d3ZSVzFpN3hMUHpRYUpkDQpCZkh3ejY4RURKK1hXRFpOd2IvNjd6UURpNDJUUlNhOXhtZEVGaVpDb0g4bExTSmwySzkyQm0vZGZ0c3VTM0tHOE1QdTdPOHNUL1ErDQpjWlZUNUIvekYrT1ZQZ1phaXNFZ2t1UTdkU2lXY2VRYTNacHlWdnRVNnNNVGdvOVRMcWxxVVJjRnVPYkpYNDI1djRSWUlobTd2eU9hDQo4TDhqcUZRWkJQeEQ4N3dvc0F6SHNqUUZTNVNpTWhMRDhLQytHT0RidHJvQ0FJNU1DNEpJaTVUb2JITHMxU1JEaXlKd0tTdElQQ05JDQpwSkc3cTBpTlhKMjlCZkVqTlNHSHkvcDhMRlVpa0FUc2dYQ2llRFh5d05pcnc0ak5QTHJzekp3eU5QQjVwOXVKMFNMTnFpVHlwVDRyDQpUeWtOZ01PUnYyVlcxZ1dDQk1wRmt0TWdYMWxCQUM1T3I0a1pYaFFsUmwyU2dqUkx3YUIzN3kwWWNDaHlUQjhKSGNPUmFJSUJ4aU9PDQpJeGZDSk1GL3dWSlJ4UUd5Rk9nWFFFaG1aRUh3VU5CdGowWXVrMFJWYnBRZ003UU1XUEF1UzRFbkVDUkpBZzZuS0JpUWgwa1Myb1lvDQpYdXhacEJsYUFwT0NkcHNrQkFhTUZUUTN1Rm8wV2tNT204VGR3a3Z4YXEwa2pxTllqcE1ZM2xQenVsdTUxYncyWXBoVjREVGdOWmZSDQo0Y2Jid3l6eGIyUXhTL1JwWUVHU0FNTjROSEpOcGR1TUN1V0lRaFMyQ1RKTFdHbldaZ2tyL29CWlFnd0NvTGtvL3hmdEVtMFFjb3dNDQpRUk0vczdkSy9vc2lTT05zVWVZNCtCcE1YRmtnVklDdldlaVNFMUFFaVh3R1ZTT3dsc2hMdENTN0c4bTh5cEV5SmZBY3g0Sk1JcDlJDQpFaGgxTWl3azBkMUNZMXBHcGloWVdXRHExOEV1Y0RaaWhBek53ZVJUQUFjbFhNdzFGRElTQnRjL3hWS0FSOHlGa2F0RkhTMTdoRXZEDQpVNGxpQUFrUE1CbFZ0c2lvN3psSmRBL0YxY0lMSTFjakYyRmNRM0VSTjN5TzZrSHJYZkJhbmZRMDY1MzNpeGxwa1lSM1NSQ0Rnd2lHDQpBZWpiaWFmekZFR21FS25RcWc0VnNHL1NqSmdSK1JrTERZZXNzQW9OeHhQU3V5bzA4TzhaQ3cxU1JvR2hRMFFjekUyc3BzQ3FDb1JFDQovcXkybFlOT1EvbEhlM0ExN1BiL0dBK0F2UGh0cmpOc1Zsdk42Z0NIcFpabitFNklKeDhaSTNhSk5KdWp0V294dEdTSm9jQWVBR1VsDQpnNVFGY2dsZ0dRZ3NNRGpMVThETytJU1Z3S2hBNVFieVN4SlF3Z0duZzFwbHdJWVFNZGlab1ZtYjBNTW5ETTBMc094RURpeEhpVHl3DQpTMFZWQmw3K2x3ZVI4eGJFSXNoc3RGREFpT05oRUdBc01FUlNzTUE1SVBoQjNyUkpJNGtDalE4R0JRdkRrNkNSa09FRk1OcWhFUS8vDQp4RVE2dzdJc0kvQTh5REllaGtRREY0SkNBYWtHbWdRY0hXd2hzVExMTUJJWUtpeE5reGFnWDZCYjhIZFltcGdZSXBOaGVSbTFJQWcwDQpRWlJJSXhFTUlyQ2paQW5sTUpPUkJWR2tnREtTQ0VRZ0RTUlprRGdKeGthREdCUFpqQ0RBK0FXS1pVV09kVGVvRThVQ1ErVjRXV0NBDQpZcHpzQVVXQXNWSFFFNEFDbmFpQ1lUaUJHRXlDQUV3cEFuNGlCV01IZlFBdW9FZ0lCMklScERqRHlaTFdFWXllbzJFa1BBMUNsbUdnDQpFWmNST0VCWUFoZVA0a21FQ0l4WUdnZ0N4SVcyMElMSmdLWUIvRmtZRzhWNHRLRGxETTRWOG9nTXZaS08zSTJFREFOdGVCRnRRSFc4DQpJb09tTDRibEtBeHgwVnlHQWxzUm8zUWl6Q3ZCaUpKWk1PNUZpZ1ZYRmxvd0dWR0dyOURHZzBka2hvUU1pOG9kU0FmV0FZMWc2QXdRDQpVbVFwbkJXS3FHQ2tCOWdOTWlXaFNxTkpjRTBBSlFLV0E2Z2ZuQ0lSUnNDekRQQXhDNGFocXdWaXhHWlE1YkVDTFJPdWQwTmhNaHdzDQpJZ1pvaGFFeWdZd0VwZ2xHTElGdlNScFFITWZCQXhaV0VDT1RCaXlHMUdCMHFEQUpQamg2bUhMa1hSYm1oRFFDQmdMZUJyWUQ2eDRaDQpGK2FPQjBNZTBBS25rSkNGQVo4SExCd2FVQVNNd1RiaXdQMlhhSUVGRGtIaXcrQjVHUlFyakJoK0lSMlJoUVlyaXNObHlyUHVSc2RlDQpqU2lPaUhVTU84SnFsckNSSUFDdmduMG9TQ0pZSXNRcmlOSUlHQmhRQkxkQUZCQVJyVHRZbXZDUUVjRDZreUkzY2tpSTR5aGlCQnJWDQpmR1U4RnlEajZWaVJDQVpHUkRZRTdvVzVrd2oxZ1A0TStPc1NrVUJ0bFdWQU5zZ01UK09hcGQyTlVEandhTllDd1dHMkpYVVJDQUp3DQpDY09DRlN4Z0N4QUJ3RFFnY2tDOGlhU0ZETEpJQkgrT0FSbEw1cElEYVFjY3dXS1FXOEtRTncyR09xdzBFTUljY0JOSU95N0RnMHVHDQpza0tRb1NtMEVJR00wQWVNQml4TnpxdUZuRUdQRFJjR3k1SWw0R3JDb0pnRlUxRVFZR1dESTR3REFURVBWQWVWd2trOGtSNncybWtlDQovb0xXTXJZQUx4VUlJb0lrQUVqUWdzMUlBb2FWWVdLQXp3ZytzQ0JwVmZMeHdOY1NFVk1TT0FWZytnSG5VNFJ3TkxvSVBEekVkVS9tDQpGekFCNFFmZHdKaGo3aG5TV29oQVY3Q3NpVmtLYXdrNEM5eFptY0dRRitNQkJsWTVvZ2RvY1l3c2FVT1JlUUhzYmdHd2tyRUZFbGxHDQpyWUlSQU5JQ0JBNFlmeUF4TVpDbXJqWnc5WUVMYU9CYkNrVU11dVFzVENCb0xVRkVJQXd0d1d5SnFGaFVxUXRpZ1FJYW9oeVRQUnFnDQoyb1YvY1NGd0JCZG5DNWhoSUJEYTZMUkVOQjY2VENKSVFZcmlCWmtuSXBubUdCZ0REOEtSSm5JRGZnT1BpUUUyWWlpWnNCSE4wUktvDQpmb0hSNUMyRmpBWGtBQTRVYVkwZm9RMzBDa1NWT2FKWXdTREg0SlJJY3hUdURHbGNMOEo2QktMd0hsUGpYQmYxb01YSkJpek9WWDlEDQpldEp0Q0t2bEJpdGZBaXRCQnNjRk4yWmdkUk1SQlF1VVJkWE5FemRSa2pNTXVqQTgya2ZRMUd3QzFnY044bG1tTUpvSWFoajFwUzdtDQpnQkt3a21CbEErMWlNc2g4R3RrTEdCTWtMMDhNSEJENElOVVoxUG8wOFJJWkVCNENCZVlOZmlTb3JBbnFDRllYajV3SDdpaXNFbGhuDQp3TmlpQk10V1hZNWtyV0lVQVFiazBRSldQWU5iRUNBOEtJeGxZVWZ1UnVCNWNSSndEVnBRWU5UZ1VCaGNScUNYMGNJak15cWhUUVQyDQptSVJNQUJpQktZWnhHUkIzWUcyb3loenNMZVExOE41SmZBa0l3K0ZxaHE1Z2xUS2E4Z09GaEp0cG9KU2tHTkFXT0E9PQ0KCV1dPg0KCTwhW0NEQVRBWw0KCW53YzdBY3crK0VGYVVNaEZNcWdFRUJBeG1CK1FWeklhZGVDbGFnYUJyUVZnSlBFWjBLaGdqcUg5Uk13MkZ4Z09ZNjhjamhqc1kwbHQNCklkSklPUllXTVhqY0VsQUZoQllIcXdXd2xSbFZnWUpZUnNGQWNZUnlFcE9CdVNHc3pUTThwY3AzRG1Od29La0YwQWdTNEFkMkpJZy8NCkVJYVVvTnBKTUpuUVFnSUhHaVNEUndzWlpRbU1Bd1FoTHhESjdHNEVFeTNod01BQTV5VVlQb3lFUVJaRFU1L0NEU2FVZENpbEFRd3UNCk9ScnhZUmtKUkFmd0tVTWtxb0FXSnZ3S3E1aFgzWGlnQ2dnTUZueHRqamVNWnFBeWVBeXc1c0VValFGbGdVbkFQb0VwQXAzTnVwZ2YNCjF3OE5kaXJJS2pTVU9GZURRdWdhQzFUZG5udURWdFVOTENSUUdEK1FZTWd3WmlDb2xPR0lQeUZnTklYVDFyQ2pFYWc2Qm53ZUdET1kNCjVXRE5RUXNnRHNjQWo0akF5ektSNkRBM1lFQUIxNkhoaWJ3cS92KzFuVTJ2SHNkeGhmY0IvQis0MGM0bVpucTZlN3JYZ3JNaVlDLzgNCkJ3aUZVQUlFVWlBSnlkL1A4MVRONWNjN3pmZlNVbUpBZ0VYV25lbVBxbFBuVk5WY2tiOUlibkNWSHVISkJmajdnVVo2NFhncklUMHQNCllJRFp5Y1luWncwNUJMRFAvZ1lMTUo2NGg4eEE0M3ZjR3JmTXhZRWR4cFZIWlpzWWh5ZlNXdmxrVVVoWWVIQzhxS1BpV045KzhxZncNCmpNVmp1dXBCQ0c4blc4ekhjTzBBTkpCRXVIcXZKSTNUNXRBNVE0QklPc3BFMXVGazQ3akNpdnlCaENRSkFmVXR6a1FQT3EzcGtadDgNCkRHbGJGT0NZaHB3ZVI0VzRxQ1R4R3R4dVlVSEtNWHRzNXJHalh5OTZNQ0xab1ZvbktRWjZlY1I2YTlUK3lDbVFpS1JFSUFMMzFhMWQNCngxSkFFR08zS0NWcnhHYVhSbkdmdTFubyt6ZzVZTGZoSHB0RnBneHlDQk5vUjVoajVjbWQwSFhGMmNieG5tSEJhNUV4b1JyemlyaFINCkVJdFlJeTkrc29BVGRUc1g2UXVIU1JlSTk3RGE0akUzYjdrdDVkSGhWaHU2dWEzbkVyMEJZbGg5dDRnUDNNZEwzZTM2blhObDhSQkINClQvUDNzaWY0YXY3ZWwyMitiOHJmQkwxblpjTm1GMWJnSlhkbEVTMG1rQlVkeHZIZzNTT1RDNUczSXpiTk55Vm1RTFpPaktwaER1NUMNCkliTTBxcWhicENMUDJYcGtlSXp3SHhsZEpJdkxpR3d0eWUwRTB2a1ZJK0tEUTNmNFpiN293ZnZySUlPMnZWRG8wSzZ5TkpyTmZFdmENCndBeWVQWmZpYXVKazVEYzBVK2tBenRMR2ZnNFpDaGRBaHZobk9zZ3BDTUFsZDJzUmwxRUZzYUVOTlNvYVN4c2N1Skx2SndIVWJQc3MNCjMwYXVoa3JqZnBYTmZjMW9vRlU0cGdQdjYyMmt6OEoxK1ljM2pvOUd1enFLSEk3L2w3VVJzdDRrRDRqc05kUGc0bld2ZXRPekZMWC8NCjNzN1RKeVlhMVN3bzl5WWV0TmpLUUJVVzlIQUozUnZ1REZHQXliWEJJaTBlM0kzZUxZMFFoZ2NKSFhZeHo1azZVUEcvb1ltaXFvRWYNCjRXdWthc0IweTcvbkZBNEQzNG1sZ0IyQWlrTzJRNU1LTmVRS2lRWFk2Y2tPcllvUWNOSzBrUmcvN2R5eUdXRG9qbjdHQmdJQ3RFSFQNCm4vWmNGeUFhdFNwZ0NxOXJsMmZlSGdOSEEvWjNTMnZISlU1Ty9RKytiTlpOWWRaSXdsVU5VMUxnSExDNEN1OFoyeWo1SXZNYUIwSTgNCjhhS1plNjc2TjhDNGwzd01ISi9VWUEzeUtIRnVvQ2hxYkdEVFV2akNGby9JYWhIK2hzZ3NGa3czZTY1NWJwM25PbTRSTzczYnZFdWINCjA2eEdkajdQSTVpMUo3VkxzeUpuaFM1Z3gvRGkxdUpLaysxYUZ0dkFnemhkTHhnRDVFVGMwSU9GbThZellPNW1pYU1ad3ZmSHNFZHUNClp4U2x6N0ZkcDZ2Q0JJa3NCYTBzSHFzTWQ1TkhXUlBLRnN5RXlqYXIxUGR5YVhnTHArckFHdHA4V1hRTnZzYUpPZFZTSFdWWlBFVzYNCk93cjBCTVM4eUM1NTNGazRmTHNtamVya2E0VEV0a1dWdVVNeVRxK0NJTXNhY3RTbUNUbzBjeEN3K0NrcHRQVU9qaTlYOTJVMHN6U3kNCkFDSWl3cXF0TERhT0RjRUlSTEdhZk05cm1QQVVsSmJONjg5NWMvZzhEQnlZTUJ2TmorbktZUUFIaEFKejdrWTRJMHMwOFZqN2piMUoNCldKMGdPS0xYTHkwR2ZoU1kwS01zamNCVlBTQkxFM2tQaUlwZDhXSlRPSGZMYzBrSXNKdUJBMTUzTVNQbldaSk5yVnRMaFZOQ2RaS00NClJnbXdvR3pyNkRVMzBIWFBHdlJuZkxJWWtvRHRjcE10RkUwRlErbzhWMDh4K1JLUk1GN2NLRXRSbGRodkdPeFJCTVBIU1U0QXpzWlANCnhFcUNIc0RiT0ptZWhaV0FXYndCV2had0hNY0FvMlhMZGw0QzhSNmhXcEZYNjFCR1ErYnF5dUxoaXI3L2xudDg2aWZQMmw5UDJOdXkNClYvck43TzBRSlBEMDB4Sm95MHNvNEFXTUd3Qm82WG9IeXAvMDBwRzdDSU1VdUZIdXkzQjlBeFFISllIL0twaXlVRWVhVWxsdUFBNzMNCmNxaGVTZWdXWVBOb1JBQzRMNTRITG1XU3dXaEhaUE9tczc5RTY0eit6WWoyTm84aEdVaVBJVkpXUC9LaWVEM0F4YXFrSjNjTFo3M3MNCkRBRFFXeFJEN2paSjZpSm55bElEK3c5YkNFSlFGMkhhTnhxOTBCVkxMekNyTkxvdDZadU1IaTdpeFFpL1BGeERVSWFsRVdIVXA1VksNCi9uQzdJRzRiRGdsd0JQSTg3cFA3VTFCQUdTOHVHdmhzUWZTd2tYTU1TOGNXY2s0RDUyN3gvU2ZmZ2VNUjQrMHlhdk5nRnpEelBWblENCnF3NzJOQ2FXN1lKL2p0QTFQYVFWV3hiUTZtTk42R3IyQ1UrVU1DcHZZZlJ1YWZSSTZMQ0FDS2k2OXhJbG1odWx3NkpucWN0TzZMNm0NCmROVThEWmxSZ203bFdMQzZhbGUyOG5PaVpWdXh1a3JNT2xzS2FlclplVnV3dXFvMmhwdVJxQy9KZW5zTWpsREJ2R21scExjRnE2c1cNCkRnSHhSakRVK2hWV2h4RUhJeUxYR1lYYkc2dkRBc2JXVkMyanRSV3IwMEtlWWgxdDduUE42cmh0S05IdVJEMjcydGUwRGlOU0NMeW4NCjIrL3JDMTdYN01WM3dRMmVWUFlGSWVOOG9Vd2IwckRQT3RlMHJuS2FFYzNFK2FncldsZkpreUFwRG1PbnBDOW8zZDNpUnV0dUpqZGENClZ5WFZsWmlIQ2tSajgwYkkyQTZPWWFPbDUvR3ZlQjNPTUIxaUlKdENHaFl0ZWM4dDZ0dTRNQ1NrTEloZEEwVnRWaGVMeUFxSkZiSGoNCmd0Ui8vS3RqQm0xQjdHNVJmU04yZDRzN3NYc1ZHNTZDMDdOMlNSSTdYSllNQ0dKMjIwZkhtdGpkalI2SkhSYkZrcTFGNkhvbHp5K0oNCm5UZGpOM1BnNW52MGdCZkVEaU8xZFlHMzJ5QmJFRHNzVU41MUl5L3ZZM3hHMno1U012MmtPbFJ0S2I2WE5iRVRuUWdtZnVTMGNMaDYNCkRBaUh6TEFnZEdiZWZHUjJBcVdkek1HTlpVMWx3ZXhxRkZ0TEQ2RGMrb0xaWFpoTldoM2dVVjh3dTd2Rmd0bTllcEZQSFdYWklIdWQNCjJTMEw3djk4WDIzdllDMG9OQnBzL3JCa2R1UjRuN1BFbm1kNFlSLzIxdllZNmR6VTNZOUc3MVpHSzA3azZ5Wk9CWFJLK2I3VjZIaUwNCktIVmE1RlFYZmpUQ20wa2xKS1hadjJvRW9GcHh4Ky8yTE9NTk12SnBLNmhiTmVsY3VSTXowQjJ3ZFFYREhScG5pNW5sZ0prTGl4L3kNCkV6WExNQ1F3OW5Hc2NrSkRhQXpudmtnSlowMnRqNU1QU2NQdS9BNUxBRUVuTkptMzFWSHZpdzFVNHBSTGhSL3MxNFFWNmNtU3lRQjUNClI5UkUya2trUy9MaWYwa1E3SVNkanMxTVdSWVcxWHdNTHpsQ29qbitNTVhUMDdtSUpIQVlXZm9yN1F4ZUZ6bVhkY2t0SFQwNDRqR2INCmpjZTJLV3FPcTJKdGQrTkEzM2tsbDBVQjFPRXg3UTZoMTR1K2ZFeHhQSURVQ0JCbnQ4dWwyQkRVU2Jjejhmd3FRMGljY2tma2ZRRnUNCktDcFNRU0RKaHpXR0NVdTZYbVQ5ZExESk5xOEpsc1pxZDRLMDJlYjBjSlVEM0dTdldjSWgvd3h5Um96SXh0RU5xMGUyMlRpRVBVc1ANCk1ZOWtCNmJ1K1I3d2dHVWN0bGJLTlFUbnJhSmtJVTVIZkJsNW5NV1pEank0M1p0MXVoenNGNWljbXgyY20wRjQzS1BqM2g0QzNIVTcNCldvMlRLRmxISVVDaDlhVG9xZFFsT2s0RTF4NHp6MXZpdGZWMWJ0bktZOEpvQWtSeFhGamRjRGQ2OXkwbzhoUUNuN1VtOW84b1JkSkQNCkZKRGtvMUEydzhuOTVKT0R5ajdDemNoeUZFeU9NeGxTaXR4dzB5VWljYVNHNVBZdFJTakxXMWc0aTFGczU3YVp6ZjFnak5DTjgveDQNCkl2dDBFbU8zRTVHVnNoRXRCVm1TTFNLT1hsNDlwR0l0dW5ZUDh5M2VIbjRFVjdiZWRvME5QbzdKNkFicUtSc00remdXWXpLQlRhMDcNCkNBUEphOWVZVExWK0E1VXJXMXF3VTVpeXJiS3M4dkFXdVhlRXdRdDRzUk95SEp0NHlaVDh4SXd2ZjRQSGQyY25jQ3ZjaHV5ZmViQnYNCmVqQWVjQ29LMDBKR2dSZ0p1SUNST3dISk1SVXU1ZVZyM3k4ZmcwaXFKU2Z4WEV5c0JIMkpGeUdhYXhMOXVhSDVEeEE5YWdYdXh6a0UNCm9MNEVDM0V3YTlxUUJPeGdML2tlb2RXRUROODc3L0RtMzdNeGczTkVzK0Z4VkNhdXg4NGhtTUdtMnQwaWprMDlWTlVzZU5pNWZJd3YNCkxtQkZ3UXRHQXEzVmF5dStSMG1IckU0VER2QWhWaWJJb251TVIxWTRYL3pOaGpBWVZGOXF1Y3AxUVBpc0NwUjdjSnhLQzVObnpkTG4NCnErSHpySE80N0FDK1NsRCtlTGNsK2NuWXJpRmRNbHlRMXhVL0djYmJabWVNYTY5ZjRTYzNvMGRhZVJuaHIzNTh0VzFaeWxzWk9XK0gNClB4cEJkYWFRMlNVK3pvK2U5bEdjZEluTzdvbEV2R3JZWDREenNNcmlsVUJmOXZuWk9FYk9XdWhlWTVBRWhyTUNHN2x3a1NWc0tqdDUNCnFwNTZHYlkrUkp4aUg5TmhuOG5oRVk2T1o4L0lpcVF6eUJEUU5HV200VjF6ZjJzSnduemJqMnRDcFRqZFJPSThJclFkSWtMMzl4Z2MNCmljMkltaHp2WVduTEJIMjMrRkpPL1pEditkSUd0c0FKSDg3S1p1WFZsUmpwZm1rU1ozSjEyZy9WTEw0ZSsrRkg0M2NTbkdNbStZRWQNCk9VcW9Ic2dDM3RDM2NlM2RlYnVyN2RLZDRvVjRFVnBFSVNmYm5JcGwzNFRKTlliRUhhTVZ4aEV4Tmh6cmhrOXhhcFpyN3haeFFjME8NCjNXWkNJZEh2cThjUTNtQ1RnOGVIQS9uQjZHWVVoRFpIeU9JWEZ3QWRIQkx5cFg0MmZ0RHpLNlRjRUg4MkhHZkZzcDcxYnZSdWFiUm8NCldHY3dBUUhONVl4blJrOGk3bGt1ZjcyZndkR1N3UVNqTXZKNnhsc1VWNU14VGpoU0J2U2prWkpxaXdaOWM5dzJic2hQMWFCSk01dEcNCjBLRUczSU9NR1hGT3BHMStwa3FDbkdjT0NrVVR1bHJrYXNtbU1TcGw4eGRVN0J1Z25QbnppUEZPOE44WE84U0QvM0U0SkxPWnFSem8NCjFvbTNHc055enVqRUhLdERILzF1OEVNaVJneXZkcFBtdVhxSWlTQW1jVkhDVy9sVUpDZDFjRGt0TExZUlgzaVNQM3F5RGdLNkY4NWoNCjJBRDU0WUl2UEIvRXdyVGtKQkNZNUpEdk9CMFZ2dnpFaVhoK3R1VWtrQU4zR1ZGalplRDNmSDVyd3VHZS9YaDV6NWRHOWdabmNSNlgNCkE3YVU0MHFPK0d3UU1HMVprQ09jL0RSRk9ybm5ocXFmR0NCZXlwbTVmcmNXTHo2TUJDZVJGb2dsdW5EU21yTTFMaFFKNGhEcmlLY2cNCkUweDFUbkNrRE96MlMyRUgvUDhXOTJPVjdlQmF5N2hpN0F1TDJGQm5ROVVKMnRPUExsYVBzWjQ3eEhkM2RNMk1qeWJDV1ZEb1lWRWQNCkxCNzJ3a2RPTmtYTkJSQ3pWUG5pY1d6dzdFNHYxWEkxOWtGQk12VTVvbmwrRHhBN2pHTW9vYmE1dG5nSW9XZnAvUGQxa3Y1UUl3bjYNCitUYUdWQkZCSkpWeUg5d3c1dWVRVGpWaWhEMUpsaGJmTSt5VHhPckVpZmdaR201cDlQZ2swMFJSVi9kaWl5bU5vaDkzN1BCQW91U3oNCnVaelBHeTlUYmRvUmJyakM2UDByUmhPaFJWZ1RyVWNJTFROYlI0czdFdUhYUFg2OHZtM3ljR2MxdGl1anJJeFkwM1NTcHR2NFhML3UNCjljTjhocysvdDJmeTljOHgvL0RYMTkwUElXYTd2cjl1clpReS92d1hSRFNrQ3g3dzUrM3RIcDlCbjljWDBQKzNYMVRtMjVkZlZPWlMNCjNyd3NwZmlYZXk2aS9UOThVdm5PL3hLa3YzTHRyei85Vy96Q3RiLzRxeksvKy92N0h6Lzg0NWYzLy9HZi9nYTJIMzk5Lzk4ZjNyei8NCjZhZWZmM3YvMjRmLzRxL2UvUGpMaDE5LysvbVhEMjkrL2ZlZi84Yy84WWMrL3NCMzMvMzFiLy82cDMvNVgzU0xDalE9DQoJXV0+DQo8L2k6cGdmPg0KPC9zdmc+DQo="

/***/ }),
/* 200 */
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(1);
var defaultLinkStyles_1 = __webpack_require__(78);
Object.defineProperty(exports, "LINK_SHOW_IRI", ({ enumerable: true, get: function () { return defaultLinkStyles_1.LINK_SHOW_IRI; } }));
var schema_1 = __webpack_require__(54);
Object.defineProperty(exports, "TemplateProperties", ({ enumerable: true, get: function () { return schema_1.TemplateProperties; } }));
tslib_1.__exportStar(__webpack_require__(52), exports);
tslib_1.__exportStar(__webpack_require__(83), exports);
tslib_1.__exportStar(__webpack_require__(61), exports);
tslib_1.__exportStar(__webpack_require__(56), exports);
tslib_1.__exportStar(__webpack_require__(63), exports);
tslib_1.__exportStar(__webpack_require__(90), exports);
tslib_1.__exportStar(__webpack_require__(121), exports);
var workspaceContext_1 = __webpack_require__(88);
Object.defineProperty(exports, "WorkspaceContextTypes", ({ enumerable: true, get: function () { return workspaceContext_1.WorkspaceContextTypes; } }));
var layout_1 = __webpack_require__(109);
Object.defineProperty(exports, "groupForceLayout", ({ enumerable: true, get: function () { return layout_1.groupForceLayout; } }));
Object.defineProperty(exports, "groupRemoveOverlaps", ({ enumerable: true, get: function () { return layout_1.groupRemoveOverlaps; } }));
Object.defineProperty(exports, "padded", ({ enumerable: true, get: function () { return layout_1.padded; } }));
Object.defineProperty(exports, "biasFreePadded", ({ enumerable: true, get: function () { return layout_1.biasFreePadded; } }));
Object.defineProperty(exports, "getContentFittingBoxForLayout", ({ enumerable: true, get: function () { return layout_1.getContentFittingBoxForLayout; } }));


/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=ontodia.js.map